(function () {
    'use strict';

    angular
        .module('app', [
            'ui.router', // @uirouter/angularjs, formerly angular-ui-router
            'ui.select', // ui-select
            'app.vmis',
            'mm.foundation', // angular-foundation-6, foundation-sites
            'templates',
            'ngCookies', // angular-cookies
            'ngSanitize', // angular-sanitize
            'ngIdle' // ng-idle
        ]);

    angular
        .module('app')
        .run(['$rootScope', '$state', '$location', '$window', '$interval', '$cookies', '$modalStack', 'Idle', 'authentication',
            function ($rootScope, $state, $location, $window, $interval, $cookies, $modalStack, Idle, authentication) {
                $rootScope.$on('$viewContentLoaded', function () {
                    $(document).foundation();
                });

                $rootScope.$on('$stateChangeStart', function (event, toState, toParams) {
                    // Dismiss all modals
                    $modalStack.dismissAll('', [1]);

                    // If user is logged in
                    if (authentication.isLoggedIn()) {
                        // Restart watching for idleness
                        if (Idle.idling()) {
                            Idle.watch();
                            $cookies.remove('logged-out-reason');
                        }

                        // TODO: Rework routing and remove.
                        if (toState.name === 'vmis.inviteAccepted') return;

                        authentication.getUserProfile().then(function (response) {
                            if (angular.isDefined(response.aosUser.communityAffiliationId)) {
                                authentication.getCommunityInfo({ communityAffiliationId: response.aosUser.communityAffiliationId }).then(function (comm) {
                                    // If not, force them to the profile page
                                    if ((!authentication.isAosProfileValid(response.aosUser)) || comm.communityAffiliations.isArchived || !response.aosUser.vmisUser ||
                                        (response.aosUser.vmisUser && !authentication.isVmisProfileValid(response.aosUser.vmisUser.volunteerProfile)) ||
                                        (response.aosUser.vmisUser && response.aosUser.vmisUser.adminProfile &&
                                            !authentication.isAdminProfileValid(response.aosUser.vmisUser.adminProfile))) {
                                        $state.go('vmis.profile');
                                    }
                                    else if (toState.redirectTo) {
                                        event.preventDefault();
                                        $state.go(toState.redirectTo, toParams);
                                    }
                                }).catch(function (error) {
                                    console.log(error);
                                });
                            }
                            else {
                                // If not, force them to the profile page
                                if (!authentication.isAosProfileValid(response.aosUser) ||
                                    (response.aosUser.vmisUser && !authentication.isVmisProfileValid(response.aosUser.vmisUser.volunteerProfile)) ||
                                    (response.aosUser.vmisUser.adminProfile && !authentication.isAdminProfileValid(response.aosUser.vmisUser.adminProfile))) {
                                    $state.go('vmis.profile');
                                }
                                else if (toState.redirectTo) {
                                    event.preventDefault();
                                    $state.go(toState.redirectTo, toParams);
                                }
                            }
                        }).catch(function (error) {
                            console.log(error);
                        });

                    }
                });
                $rootScope.$on('$stateChangeSuccess', function(event, currentRoute, previousRoute) {
                    // Change page title based on route info
                    var pageTitle = currentRoute.title;
                    if (pageTitle) {
                        $window.document.title = "VMIS - " + pageTitle;
                    }
                });
            }
        ])
        // Used for ui-select, from: http://angular-ui.github.io/ui-select/demo-basic.html
        .filter('propsFilter', function () {
            return function (items, props) {
                var out = [];

                if (angular.isArray(items)) {
                    var keys = Object.keys(props);

                    items.forEach(function (item) {
                        var itemMatches = false;

                        for (var i = 0; i < keys.length; i++) {
                            var prop = keys[i];
                            // This error on People > Volunteer: "TypeError: Cannot read property 'prop' of null"
                            // ...is resolved by checking if objects exist before accessing them.
                            var text = props ? props[prop].toLowerCase() : null;
                            if (item ? (item[prop].toString().toLowerCase().indexOf(text) !== -1) : false) {
                                itemMatches = true;
                                break;
                            }
                        }

                        if (itemMatches) {
                            out.push(item);
                        }
                    });
                } else {
                    // Let the output be the input untouched
                    out = items;
                }

                return out;
            };
        })
        /**
         * Uploaded attachment filter function for ensuring URLs work properly.
         * @returns function that parses strings for good URLs
         */
        .filter('uploadedFileFilter', function () {
            return function (link) {
                var http = "http://";
                var https = "https://";

                // Does not work in Internet Explorer 11
                //if (link.startsWith(http) || link.startsWith(https))
                if (link.indexOf(http) === 0 || link.indexOf(https) === 0) {
                    return link;
                }
                else {
                    return http + link;
                }
            };
        })
        .config(['uiSelectConfig', function (uiSelectConfig) {
            uiSelectConfig.theme = 'bootstrap';
        }])
        .config(['IdleProvider', 'TitleProvider', function (IdleProvider, TitleProvider) {
            IdleProvider.autoResume('notIdle');
            TitleProvider.enabled(false);
        }])

        // Configure Idle service (https://github.com/HackedByChinese/ng-idle) and begin watching for idleness if user is already authenticated.
        .run(['Idle', 'Keepalive', 'authentication', 'config', function (Idle, Keepalive, authentication, config) {
            config.get().then(function (configData) {
                // Seconds to wait until a user is considered idle.
                Idle.setIdle(configData.idleConfig.idle);
                // Seconds to wait after a user is idle to perfom some action (e.g. log out the user).
                Idle.setTimeout(configData.idleConfig.timeout);
                // Interval to send a keep alive signal to the backend.
                Keepalive.setInterval(configData.idleConfig.keepAlive);
            }).then(function () {
                if (authentication.isLoggedIn()) {
                    Idle.watch();
                }
            });
        }])
        .config(['$locationProvider', function ($locationProvider) {
            $locationProvider.html5Mode(true);
        }]);

    angular
        .module('app.auth', [
            'angularMoment', // angular-moment, requires moment
            'mm.foundation' // angular-foundation-6, requires foundation-sites
        ]);

    angular
        .module('templates', []);
})();
/**
 * Created by tlester3 on 4/16/16.
 */
(function () {
    'use strict';

    angular
        .module('app')
        .config(config);

    config.$inject = ['$urlRouterProvider'];

    function config($urlRouterProvider) {
        $urlRouterProvider
            .otherwise('/');
    }
})();
/**
 * Created by tlester3 on 4/17/16.
 */
(function () {
    'use strict';

    angular
        .module('app.auth')
        .factory('authentication', authentication);

    authentication.$inject = ['$http', '$cookies', '$q', '$log', '$window', '$location', '_', 'moment', 'config'];

    function authentication($http, $cookies, $q, $log, $window, $location, _, moment, config) {
        var host = $window.location.protocol + "//" + $window.location.host;

        return {
            destroyToken: destroyToken,
            isLoggedIn: isLoggedIn,

            setRedirect: setRedirect,
            getRedirect: getRedirect,
            clearRedirect: clearRedirect,

            isUserInVMIS: isUserInVMIS,
            logIn: logIn,
            getLastLoginDate: getLastLoginDate,
            logOut: logOut,
            logOutOfAppOnly: logOutOfAppOnly,
            keepAlive: keepAlive,
            isAosProfileValid: isAosProfileValid,
            isCommunityArchived: isCommunityArchived,
            isVmisProfileValid: isVmisProfileValid,
            isAdminProfileValid: isAdminProfileValid,

            findByUsername: findByUsername,
            sendMigrationEmailByUsername: sendMigrationEmailByUsername,
            findUsernameByKey: findUsernameByKey,
            completeUserMigration: completeUserMigration,

            getUiData: getUiData,
            createStateList: createStateList,
            setUserProfile: setUserProfile,
            getUserProfile: getUserProfile,
            getNonUserEmail: getNonUserEmail,
            setNonUser: setNonUser,
            setNonUserToUser: setNonUserToUser,

            getOpportunities: getOpportunities,
            getOpportunitiesAdmin: getOpportunitiesAdmin,
            getOpportunityDetails: getOpportunityDetails,
            applyForOpportunity: applyForOpportunity,
            setVolunteerForOpportunity: setVolunteerForOpportunity,

            getOpportunitiesAppliedFor: getOpportunitiesAppliedFor,
            getApplicationsAdmin: getApplicationsAdmin,
            getVolunteerHoursForOpportunity: getVolunteerHoursForOpportunity,
            getHoursVol: getHoursVol,
            getHoursAdmin: getHoursAdmin,
            setVolunteerHoursForOpportunity: setVolunteerHoursForOpportunity,
            getHoursDetails: getHoursDetails,
            deleteHours: deleteHours,

            getUserRoles: getUserRoles,
            modifyUserRoles: modifyUserRoles,

            getOpportunityVolunteers: getOpportunityVolunteers,
            getApplicationDetails: getApplicationDetails,
            getCommunityApplicationDetails: getCommunityApplicationDetails,

            deleteApplication: deleteApplication,

            manageVolunteerHours: manageVolunteerHours,
            setOpportunity: setOpportunity,
            geocodeOpportunity: geocodeOpportunity,
            deleteOpportunity: deleteOpportunity,
            setOpportunityStatusForUser: setOpportunityStatusForUser,
            finishOpportunityStatusForUser: finishOpportunityStatusForUser,

            sendInvite: sendInvite,
            acceptInvite: acceptInvite,
            getInvites: getInvites,
            getInviteStatus: getInviteStatus,
            updateInvite: updateInvite,
            deleteInvite: deleteInvite,

            getNotifications: getNotifications,
            setNotificationRead: setNotificationRead,
            deleteNotifications: deleteNotifications,
            getUserNotificationEmailSettings: getUserNotificationEmailSettings,
            setUserNotificationEmailSettings: setUserNotificationEmailSettings,

            getVolunteersAdmin: getVolunteersAdmin,
            getManagersAdmin: getManagersAdmin,
            getAllUsers: getAllUsers,
            getCommunities: getCommunities,
            getCommunityInfo: getCommunityInfo,
            getCommunitiesIntermediateNodes: getCommunitiesIntermediateNodes,
            getOrganizations: getOrganizations,
            getOrganizationsAdmin: getOrganizationsAdmin,
            setOrganizationInfo: setOrganizationInfo,
            deleteOrganization: deleteOrganization,
            getStandardOrganizations: getStandardOrganizations,
            getStandardPositionsAdmin: getStandardPositionsAdmin,
            getOrganizationGroups: getOrganizationGroups,
            manageOrganizationGroup: manageOrganizationGroup,
            getOpocsForOpportunity: getOpocsForOpportunity,

            sendEmailToList: sendEmailToList,
            getTroubledOrganizationsForCommunity: getTroubledOrganizationsForCommunity,

            uploadHoursDocument: uploadHoursDocument,
            deleteHoursDocument: deleteHoursDocument,
            uploadVolunteerDocument: uploadVolunteerDocument,
            deleteVolunteerDocument: deleteVolunteerDocument,
            uploadMassEmailAttachment: uploadMassEmailAttachment,

            getVolunteerServiceRecord: getVolunteerServiceRecord,
            getVolunteerNotes: getVolunteerNotes,
            manageVolunteerNotes: manageVolunteerNotes,
            getVolunteerBackgroundChecks: getVolunteerBackgroundChecks,
            manageVolunteerBackgroundChecks: manageVolunteerBackgroundChecks,
            getVolunteerDocuments: getVolunteerDocuments,
            getVolunteerAwards: getVolunteerAwards,
            setVolunteerAwards: setVolunteerAwards,
            deleteVolunteerAwards: deleteVolunteerAwards,
            getVolunteerTrainings: getVolunteerTrainings,
            setVolunteerTrainings: setVolunteerTrainings,
            deleteVolunteerTrainings: deleteVolunteerTrainings,
            getVolunteerOrientations: getVolunteerOrientations,
            setVolunteerOrientations: setVolunteerOrientations,
            deleteVolunteerOrientations: deleteVolunteerOrientations,

            getAvccsForCommunity: getAvccsForCommunity,
            getDA4713: getDA4713,
            getDA4162: getDA4162,
            mergeVMISdata: mergeVMISdata,
            getMasterUserIdFromEmail: getMasterUserIdFromEmail,
            getUsernameFromMasterUserId: getUsernameFromMasterUserId,

            checkVmisApiHealth: checkVmisApiHealth,
            checkCoreApiHealth: checkCoreApiHealth
        };

        function saveToken(token, expiration) {
            $cookies.put('cas-ticket', token, {
                expires: expiration
            });
        }

        function getToken() {
            return $cookies.get('cas-ticket');
        }

        function destroyToken() {
            $cookies.remove('cas-ticket');
        }

        function setRedirect(state, params) {
            $cookies.putObject('redirect', { state: state, params: params });
        }

        function getRedirect() {
            return $cookies.getObject('redirect');
        }

        function clearRedirect() {
            $cookies.remove('redirect');
        }

        function isLoggedIn() {
            return !!getToken();
        }

        function isUserInVMIS(params) {
            var data = {
                email: params.email
            };

            return config.get().then(function (configData) {
                return $http.post(configData.apiServer + '/public_api/is_user_in_VMIS', data);
            }).then(httpSuccess).catch(httpFailure);
        }

        function logIn(ticket, service) {
            if (service === null || service === undefined) {
                service = encodeURIComponent(host + ($location.path() === '/' ? '' : $location.path()));
            }

            var data = {
                ticket: ticket,
                service: service
            };

            return config.get().then(function (configData) {
                return $http.post(configData.coreServer + '/login/sign_in_with_ticket', data);
            }).then(httpSuccess).then(onSuccess).catch(httpFailure);

            function onSuccess(response) {
                saveToken(response.access_token, moment().add(response.expires_in, 'minutes').toDate());
                return response;
            }
        }

        function getLastLoginDate() {
            return config.get().then(function (configData) {
                var service = encodeURIComponent($window.location.protocol + "//" + $window.location.host);
                return $http.post(configData.coreServer + '/authorized_api/users/get_last_login', {authorization: getToken(), service: service});
            }).then(httpSuccess).catch(httpFailure);
        }

        function logOutOfAppOnly () {
            return config.get().then(function (configData) {
                var service = encodeURIComponent($window.location.protocol + "//" + $window.location.host);
                return $http.post(configData.coreServer + '/authorized_api/users/sign_out', {authorization: getToken(), service: service});
            }).then(httpSuccess).catch(httpFailure);
        }

        function logOut() {
            var casServer = "";
            return config.get().then(function (configData) {
                casServer = configData.casServer; // Store value while config data is in-scope
                return $http.post(configData.coreServer + '/authorized_api/users/sign_out', { authorization: getToken() });
            }).then(httpSuccess).then(function (response) {
                destroyToken();
                // See loggedOut.routes.js
                window.location.href = casServer + 'logout?service=' +
                    encodeURI($window.location.protocol + "//" + $window.location.host + "/logged-out");
            }).catch(httpFailure);
        }

        function keepAlive() {
            return config.get().then(function (configData) {
                return $http.post(configData.apiServer + '/authorized_api/keep_alive', { authorization: getToken() });
            }).then(httpSuccess).then(function (response) {
                saveToken(getToken(), new Date(response.expiresOnDate));
                return response;
            }).catch(httpFailure).catch(function (error) {
                destroyToken();
                return $q.reject(error);
            });
        }

        function findByUsername(username) {
            return config.get().then(function (configData) {
                return $http.get(configData.coreServer + '/public_api/migrate/' + username);
            }).then(httpSuccess).catch(httpFailure);
        }

        function findUsernameByKey(key) {
            return config.get().then(function (configData) {
                return $http.get(configData.coreServer + '/public_api/migrate/userwithhash/' + key);
            }).then(httpSuccess).catch(httpFailure);
        }

        function sendMigrationEmailByUsername(username) {
            return config.get().then(function (configData) {
                return $http.post(configData.coreServer + '/public_api/migrate/' + username);
            }).then(httpSuccess).catch(httpFailure);
        }

        function completeUserMigration(key, username, email, password) {
            var params = {
                hash: key,
                password: password,
                newEmail: email
            };
            return config.get().then(function (configData) {
                return $http.put(configData.coreServer + '/public_api/migrate/claim/' + username, params);
            }).then(httpSuccess).catch(httpFailure);
        }

        function isAosProfileValid(aosProfile) {
            if (!isLoggedIn()) return false;

            // List of required AFWP Profile fields
            var isProfileValid = aosProfile.firstName &&
                aosProfile.lastName &&
                aosProfile.dateOfBirth &&
                aosProfile.communityAffiliationId &&
                aosProfile.branchOfService &&
                aosProfile.armyComponent &&
                aosProfile.dispositions.length > 0;

            //check dispositions
            if (_.indexOf(aosProfile.dispositions, 'Service Member') >= 0) isProfileValid = isProfileValid && aosProfile.payGrade;
            if (_.indexOf(aosProfile.dispositions, 'Family Member') >= 0) isProfileValid = isProfileValid && aosProfile.sponsorPayGrade;
            if (_.indexOf(aosProfile.dispositions, 'DoD Civilian') >= 0) isProfileValid = isProfileValid && aosProfile.civilianPayGrade;

            //check minor
            if (moment().diff(new Date(aosProfile.dateOfBirth), 'years') < 18) {
                if (!aosProfile.isMarried) {
                    isProfileValid = isProfileValid &&
                        aosProfile.parentGuardianFirstName &&
                        aosProfile.parentGuardianLastName &&
                        aosProfile.parentGuardianPhone &&
                        aosProfile.parentGuardianEmail &&
                        aosProfile.parentGuardianCountry &&
                        aosProfile.parentGuardianAddress1 &&
                        aosProfile.parentGuardianCity &&
                        aosProfile.parentGuardianZipCode;

                    if (aosProfile.parentGuardianCountry === 'United States') isProfileValid = isProfileValid && aosProfile.parentGuardianUsState;
                }
            }

            return !!isProfileValid;
        }

        function isCommunityArchived(communityAffiliationId) {
            return getCommunityInfo({ communityAffiliationId: communityAffiliationId })
                .then(function (comm) {
                    return comm.communityAffiliations.isArchived;
                });
        }

        // Assuming aosUser.vmisUser.volunteerProfile as input
        function isVmisProfileValid(vmisProfile) {
            if (!vmisProfile) return false;

            // List of required Volunteer Profile fields
            var isProfileValid =
                vmisProfile.preferredContactMethodId &&
                vmisProfile.volunteerEmail &&
                vmisProfile.primaryPhone;

            return !!isProfileValid;
        }

        function isAdminProfileValid(adminProfile) {
            if (!adminProfile) return false;

            // List of required Administrator Profile fields
            var isProfileValid = adminProfile.workEmail &&
                adminProfile.commercialWorkPhone &&
                adminProfile.country &&
                adminProfile.address1 &&
                adminProfile.city &&
                adminProfile.zipCode;
            if (adminProfile.country === 'United States') isProfileValid = isProfileValid && adminProfile.usState;

            return !!isProfileValid;
        }

        function getUiData(elements) {
            var data = {
                elements: elements
            };

            return config.get().then(function (configData) {
                return $http.post(configData.apiServer + '/public_api/get_ui_data', data);
            }).then(httpSuccess).catch(httpFailure);
        }

        function createStateList(states,abbreviations) {
            var resultArray = [];

            for (var i = 0; i < states.length ; i++) {
                resultArray.push(states[i] + " ("+abbreviations[i]+")");
            }

            return resultArray;
        }

        function getUserProfile(optional) {
            //if (!isLoggedIn())
            //    return $q.reject("Logged out");

            var data = {
                authorization: getToken()
            };

            data.masterUserId = optional?optional.masterUserId?optional.masterUserId:undefined:undefined;

            return config.get().then(function (configData) {
                return $http.post(configData.apiServer + '/authorized_api/get_user_profile', data);
            }).then(httpSuccess).catch(httpFailure);
        }

        function setUserProfile(profile, id) {
            var profileCopy = angular.copy(profile, {});
            var data = {
                authorization: getToken(),
                aosUser: profileCopy
            };

            if (angular.isNumber(id)) {
                data.masterUserId = angular.copy(id);
            }

            return config.get().then(function (configData) {
                return $http.post(configData.apiServer + '/authorized_api/set_user_profile', data);
            }).then(httpSuccess).catch(httpFailure);
        }

        function getNonUserEmail(nonUserMasterId) {
            var data = {
                authorization: getToken(),
                masterUserId: nonUserMasterId
            };
            return config.get().then(function (configData) {
                return $http.post(configData.apiServer + '/authorized_api/get_nonuser_email', data);
            }).then(httpSuccess).catch(httpFailure);
        }

        function setNonUser(profile) {
            var data = {
                authorization: getToken(),
                email: profile.email,
                aosUser: profile.aosUser
            };

            return config.get().then(function (configData) {
                return $http.post(configData.apiServer + '/authorized_api/set_non_user', data);
            }).then(httpSuccess).catch(httpFailure);
        }

        function setNonUserToUser(params) {
            var data = {
                authorization: getToken(),
                masterUserId: params.masterUserId,
                email: params.email
            };

            return config.get().then(function (configData) {
                return $http.post(configData.apiServer + '/authorized_api/set_non_user_to_user', data);
            }).then(httpSuccess).catch(httpFailure);
        }

        function getOpportunities(params) {
            var data = params;

            var url = '/public_api';
            if (isLoggedIn()) {
                url = '/authorized_api';
                data.authorization = getToken();
            }

            return config.get().then(function (configData) {
                return $http.post(configData.apiServer + url + '/get_opportunities', data);
            }).then(httpSuccess).catch(httpFailure);
        }

        function getOpportunitiesAdmin(params) {
            var data = angular.copy(params);
            data.authorization = getToken();

            return config.get().then(function (configData) {
                return $http.post(configData.apiServer + '/authorized_api/get_opportunities_admin', data);
            }).then(httpSuccess).catch(httpFailure);
        }

        function getOpportunityDetails(params) {
            var data = params;
            var url = '/public_api';

            if (isLoggedIn()) {
                url = '/authorized_api';
                data.authorization = getToken();
            }

            return config.get().then(function (configData) {
                return $http.post(configData.apiServer + url + '/get_opportunity_details', data);
            }).then(httpSuccess).catch(httpFailure);
        }

        function applyForOpportunity(params) {
            var data = params;
            data.authorization = getToken();

            return config.get().then(function (configData) {
                return $http.post(configData.apiServer + '/authorized_api/apply_for_opportunity', data);
            }).then(httpSuccess).catch(httpFailure);
        }

        function setVolunteerForOpportunity(params) {
            var data = angular.copy(params, {});
            data.authorization = getToken();

            return config.get().then(function (configData) {
                return $http.post(configData.apiServer + '/authorized_api/set_volunteer_for_opportunity', data);
            }).then(httpSuccess).catch(httpFailure);
        }

        function getOpportunitiesAppliedFor(params) {
            var data = angular.copy(params, {});
            data.authorization = getToken();

            return config.get().then(function (configData) {
                return $http.post(configData.apiServer + '/authorized_api/get_opportunities_applied_for', data);
            }).then(httpSuccess).catch(httpFailure);
        }

        function getApplicationsAdmin(params) {
            var data = angular.copy(params, {});
            data.authorization = getToken();

            return config.get().then(function (configData) {
                return $http.post(configData.apiServer + '/authorized_api/get_applications_admin', data);
            }).then(httpSuccess).catch(httpFailure);
        }

        function getVolunteerHoursForOpportunity(params) {
            var data = params;
            data.authorization = getToken();

            return config.get().then(function (configData) {
                return $http.post(configData.apiServer + '/authorized_api/get_volunteer_hours_for_opportunity', data);
            }).then(httpSuccess).catch(httpFailure);
        }

        function getDA4713(params) {
            var data = angular.copy(params);
            data.authorization = getToken();

            return config.get().then(function (configData) {
                return $http.post(configData.apiServer + '/authorized_api/get_DA4713_form', data, { responseType: 'arraybuffer' });
            }).then(httpSuccess).then(function (response) {
                var file = new Blob([response], { type: 'application/pdf' });
                saveAs(file, moment().format('YYYYMMDD_HHmmss') + '_DA4713.pdf');
            }).catch(httpFailure);
        }

        function getDA4162(params) {
            var data = angular.copy(params);
            data.authorization = getToken();

            return config.get().then(function (configData) {
                return $http.post(configData.apiServer + '/authorized_api/get_DA4162_form', data, { responseType: 'arraybuffer' });
            }).then(httpSuccess).then(function (response) {
                var file = new Blob([response], { type: 'application/pdf' });
                saveAs(file, moment().format('YYYYMMDD_HHmmss') + '_DA4162.pdf');
            }).catch(httpFailure);
        }

        function getHoursVol(params) {
            var data = angular.copy(params);
            data.authorization = getToken();

            return config.get().then(function (configData) {
                return $http.post(configData.apiServer + '/authorized_api/get_hours_vol', data);
            }).then(httpSuccess).catch(httpFailure);
        }

        function getHoursAdmin(params) {
            var data = angular.copy(params);
            data.authorization = getToken();

            return config.get().then(function (configData) {
                return $http.post(configData.apiServer + '/authorized_api/get_hours_admin', data);
            }).then(httpSuccess).catch(httpFailure);
        }

        function setVolunteerHoursForOpportunity(params) {
            var data = params;
            data.authorization = getToken();
            return config.get().then(function (configData) {
                return $http.post(configData.apiServer + '/authorized_api/set_volunteer_hours_for_opportunity', data);
            }).then(httpSuccess).catch(httpFailure);
        }

        function getUserRoles() {
            var data = {
                authorization: getToken()
            };

            return config.get().then(function (configData) {
                return $http.post(configData.apiServer + '/authorized_api/get_user_roles', data);
            }).then(httpSuccess).catch(httpFailure);
        }

        function modifyUserRoles(params) {
            var data = params;
            data.authorization = getToken();
            return config.get().then(function (configData) {
                return $http.post(configData.apiServer + '/authorized_api/modify_user_roles', data);
            }).then(httpSuccess).catch(httpFailure);
        }

        function getOpportunityVolunteers(opportunityId, status) {
            var data = {
                authorization: getToken(),
                volunteerOpportunityId: opportunityId
            };

            if (status) data.volunteerApplicationStatus = status;

            return config.get().then(function (configData) {
                return $http.post(configData.apiServer + '/authorized_api/get_opportunity_volunteers', data);
            }).then(httpSuccess).catch(httpFailure);
        }

        function manageVolunteerHours(params) {
            var data = {
                authorization: getToken(),
                volunteerHoursStatus: params.volunteerHoursStatus,
                hoursIds: params.hoursIds
            };

            // Fill in optional parameters
            if ('reviewerNotes' in params)
                data.reviewerNotes = params.reviewerNotes;
            if ('hours' in params)
                data.hours = params.hours;

            return config.get().then(function (configData) {
                return $http.post(configData.apiServer + '/authorized_api/manage_volunteer_hours', data);
            }).then(httpSuccess).catch(httpFailure);
        }

        function setOpportunity(opportunity) {
            var data = opportunity;
            data.authorization = getToken();

            return config.get().then(function (configData) {
                return $http.post(configData.apiServer + '/authorized_api/set_opportunity', data);
            }).then(httpSuccess).catch(httpFailure);
        }

        function geocodeOpportunity(volunteerOpportunityId) {
            var data = { volunteerOpportunityId: volunteerOpportunityId, authorization: getToken() };
            return config.get().then(function (configData) {
                return $http.post(configData.apiServer + '/authorized_api/geocode_opportunity', data);
            }).then(httpSuccess).catch(httpFailure);
        }

        function deleteOpportunity(params) {
            var data = angular.copy(params, {});
            data.authorization = getToken();

            return config.get().then(function (configData) {
                return $http.post(configData.apiServer + '/authorized_api/delete_opportunity', data);
            }).then(httpSuccess).catch(httpFailure);
        }

        function setOpportunityStatusForUser(params) {
            var data = angular.copy(params, {});
            data.authorization = getToken();
            return config.get().then(function (configData) {
                return $http.post(configData.apiServer + '/authorized_api/set_opportunity_status_for_user', data);
            }).then(httpSuccess).catch(httpFailure);
        }

        function finishOpportunityStatusForUser(params) {
            var data = angular.copy(params);
            data.authorization = getToken();
            return config.get().then(function (configData) {
                return $http.post(configData.apiServer + '/authorized_api/finish_opportunity_status_for_user', data);
            }).then(httpSuccess).catch(httpFailure);
        }

        function sendInvite(params) {
            var data = angular.copy(params, {});
            data.authorization = getToken();
            return config.get().then(function (configData) {
                return $http.post(configData.apiServer + '/authorized_api/send_invite', data);
            }).then(httpSuccess).catch(httpFailure);
        }

        function acceptInvite(params) {
            var data = {
                authorization: getToken(),
                hash: params.hash
            };

            return config.get().then(function (configData) {
                return $http.post(configData.apiServer + '/authorized_api/accept_invite', data);
            }).then(httpSuccess).catch(httpFailure);
        }

        function getInvites(params) {
            var data = angular.copy(params, {});
            data.authorization = getToken();

            return config.get().then(function (configData) {
                return $http.post(configData.apiServer + '/authorized_api/get_invites', data);
            }).then(httpSuccess).catch(httpFailure);
        }

        function getInviteStatus(hash) {
            var data = {
                hash: hash
            };

            return config.get().then(function (configData) {
                return $http.post(configData.apiServer + '/public_api/get_invite_status', data);
            }).then(httpSuccess).catch(httpFailure);
        }

        function updateInvite(params) {
            var data = angular.copy(params, {});
            data.authorization = getToken();

            return config.get().then(function (configData) {
                return $http.post(configData.apiServer + '/authorized_api/update_invite', data);
            }).then(httpSuccess).catch(httpFailure);
        }

        function deleteInvite(hash) {
            var data = {
                authorization: getToken(),
                hash: hash
            };

            return config.get().then(function (configData) {
                return $http.post(configData.apiServer + '/authorized_api/delete_invite', data);
            }).then(httpSuccess).catch(httpFailure);
        }

        function getNotifications(startingRowIndex, numberOfRows) {
            var data = {
                authorization: getToken(),
                startingRowIndex: startingRowIndex,
                numberOfRows: numberOfRows
            };

            return config.get().then(function (configData) {
                return $http.post(configData.apiServer + '/authorized_api/get_notifications', data);
            }).then(httpSuccess).catch(httpFailure);
        }

        function setNotificationRead(notificationIds) {
            var data = {
                authorization: getToken(),
                notificationIds: notificationIds
            };

            return config.get().then(function (configData) {
                return $http.post(configData.apiServer + '/authorized_api/set_notification_read', data);
            }).then(httpSuccess).catch(httpFailure);
        }

        function getApplicationDetails(params) {
            var data = {
                authorization: getToken(),
                volunteerApplicationId: params.volunteerApplicationId
            };

            return config.get().then(function (configData) {
                return $http.post(configData.apiServer + '/authorized_api/get_application_details', data);
            }).then(httpSuccess).catch(httpFailure);
        }

        function getCommunityApplicationDetails(params) {
            var data = {
                authorization: getToken(),
                communityVolunteerOrganizationApplicationId: params.communityVolunteerOrganizationApplicationId
            };

            return config.get().then(function (configData) {
                return $http.post(configData.apiServer + '/authorized_api/get_application_details', data);
            }).then(httpSuccess).catch(httpFailure);
        }

        function deleteApplication(params) {
            var data = angular.copy(params, {});
            data.authorization = getToken();

            return config.get().then(function (configData) {
                return $http.post(configData.apiServer + '/authorized_api/delete_application', data);
            }).then(httpSuccess).catch(httpFailure);
        }

        function getHoursDetails(id) {
            var data = {
                authorization: getToken(),
                hoursId: id
            };

            return config.get().then(function (configData) {
                return $http.post(configData.apiServer + '/authorized_api/get_hours_details', data);
            }).then(httpSuccess).catch(httpFailure);
        }

        function deleteHours(params) {
            var data = angular.copy(params);
            data.authorization = getToken();

            return config.get().then(function (configData) {
                return $http.post(configData.apiServer + '/authorized_api/delete_hours', data);
            }).then(httpSuccess).catch(httpFailure);
        }

        function deleteNotifications(notificationIds) {
            var data = {
                authorization: getToken(),
                notificationIds: notificationIds
            };

            return config.get().then(function (configData) {
                return $http.post(configData.apiServer + '/authorized_api/delete_notification', data);
            }).then(httpSuccess).catch(httpFailure);
        }

        function getUserNotificationEmailSettings(params) {
            var data = angular.copy(params, {});
            data.authorization = getToken();

            return config.get().then(function (configData) {
                return $http.post(configData.apiServer + '/authorized_api/get_user_notification_email_settings', data);
            }).then(httpSuccess).catch(httpFailure);
        }

        function setUserNotificationEmailSettings(params) {
            var data = angular.copy(params);
            data.authorization = getToken();

            return config.get().then(function (configData) {
                return $http.post(configData.apiServer + '/authorized_api/set_user_notification_email_settings', data);
            }).then(httpSuccess).catch(httpFailure);
        }

        function getVolunteersAdmin(params) {
            var data = angular.copy(params, {});
            data.authorization = getToken();

            return config.get().then(function (configData) {
                return $http.post(configData.apiServer + '/authorized_api/get_volunteers_admin', data);
            }).then(httpSuccess).catch(httpFailure);
        }

        function getManagersAdmin(params) {
            var data = angular.copy(params, {});
            data.authorization = getToken();

            return config.get().then(function (configData) {
                return $http.post(configData.apiServer + '/authorized_api/get_managers_admin', data);
            }).then(httpSuccess).catch(httpFailure);
        }

        function getAllUsers(params) {
            var data = angular.copy(params, {});
            data.authorization = getToken();

            return config.get().then(function (configData) {
                return $http.post(configData.apiServer + '/authorized_api/get_all_users', data);
            }).then(httpSuccess).catch(httpFailure);
        }

        function getCommunities(params) {
            var data = angular.copy(params);

            return config.get().then(function (configData) {
                return $http.post(configData.apiServer + '/public_api/get_communities', data);
            }).then(httpSuccess).catch(httpFailure);
        }

        function getCommunityInfo(params) {
            var data = angular.copy(params);

            return config.get().then(function (configData) {
                return $http.post(configData.apiServer + '/public_api/get_community_info', data);
            }).then(httpSuccess).catch(httpFailure);
        }

        function getCommunitiesIntermediateNodes(params) {
            var data = angular.copy(params);

            return config.get().then(function (configData) {
                return $http.post(configData.apiServer + '/public_api/get_communities_intermediate_nodes', data);
            }).then(httpSuccess).catch(httpFailure);
        }

        function getOrganizations(params) {
            var data = angular.copy(params) || {};
            data.authorization = getToken();

            if (typeof params !== 'undefined') {
                if ('isActive' in params)
                    data.isActive = params.isActive;
            }

            return config.get().then(function (configData) {
                return $http.post(configData.apiServer + '/public_api/get_organizations_for_community', data);
            }).then(httpSuccess).catch(httpFailure);
        }

        function getOrganizationsAdmin(params) {
            var data = angular.copy(params);
            data.authorization = getToken();

            return config.get().then(function (configData) {
                return $http.post(configData.apiServer + '/authorized_api/get_organizations_admin', data);
            }).then(httpSuccess).catch(httpFailure);
        }

        function setOrganizationInfo(params) {
            params.authorization = getToken();

            return config.get().then(function (configData) {
                return $http.post(configData.apiServer + '/authorized_api/set_organization_info', params);
            }).then(httpSuccess).catch(httpFailure);
        }

        function deleteOrganization(params) {
            params.authorization = getToken();

            return config.get().then(function (configData) {
                return $http.post(configData.apiServer + '/authorized_api/delete_organization', params);
            }).then(httpSuccess).catch(httpFailure);
        }

        function getStandardOrganizations(params) {
            var data = angular.copy(params, {});
            data.authorization = getToken();

            return config.get().then(function (configData) {
                return $http.post(configData.apiServer + '/authorized_api/get_standard_organizations', data);
            }).then(httpSuccess).catch(httpFailure);
        }

        function getStandardPositionsAdmin(params) {
            var data = angular.copy(params, {});
            data.authorization = getToken();

            return config.get().then(function (configData) {
                return $http.post(configData.apiServer + '/authorized_api/get_standard_positions_admin', data);
            }).then(httpSuccess).catch(httpFailure);
        }

        function getOrganizationGroups(params) {
            var data = angular.copy(params, {});
            data.authorization = getToken();

            return config.get().then(function (configData) {
                return $http.post(configData.apiServer + '/authorized_api/get_organization_groups', data);
            }).then(httpSuccess).catch(httpFailure);
        }

        function manageOrganizationGroup(params) {
            var data = angular.copy(params, {});
            data.authorization = getToken();

            return config.get().then(function (configData) {
                return $http.post(configData.apiServer + '/authorized_api/manage_organization_group', data);
            }).then(httpSuccess).catch(httpFailure);
        }

        function getOpocsForOpportunity(params) {
            var data = angular.copy(params);
            data.authorization = getToken();

            return config.get().then(function (configData) {
                return $http.post(configData.apiServer + '/public_api/get_opocs_for_opportunity', data);
            }).then(httpSuccess).catch(httpFailure);
        }

        function sendEmailToList(params) {
            var data = angular.copy(params);
            data.authorization = getToken();

            return config.get().then(function (configData) {
                return $http.post(configData.apiServer + '/authorized_api/send_email_to_list', data);
            }).then(httpSuccess).catch(httpFailure);
        }

        function getTroubledOrganizationsForCommunity(params) {
            var data = angular.copy(params, {});
            data.authorization = getToken();

            return config.get().then(function (configData) {
                return $http.post(configData.apiServer + '/authorized_api/get_troubled_organizations_for_community', data);
            }).then(httpSuccess).catch(httpFailure);
        }

        // Uploading documents requires different method
        // (multi-part form-data request)
        function uploadHoursDocument(params) {
            var fd = new FormData();
            fd.append('theFile', params.theFile);
            fd.append('fileSuffix', params.fileSuffix);
            // TODO: Use "documentName" to allow user to specify what document is, not just the filename
            fd.append('documentName', params.documentName);
            fd.append('volunteerHoursId', params.volunteerHoursId);
            fd.append('authorization', getToken());

            return config.get().then(function (configData) {
                return $http.post(configData.apiServer + '/authorized_api/hours_document', fd, {
                    transformRequest: angular.identity,
                    headers: { 'Content-Type': undefined }
                });
            }).then(httpSuccess).catch(httpFailure);
        }

        function deleteHoursDocument(params) {
            params.authorization = getToken();

            return config.get().then(function (configData) {
                return $http.post(configData.apiServer + '/authorized_api/delete_documents_for_hours', params);
            }).then(httpSuccess).catch(httpFailure);
        }

        // Uploading documents requires different method
        // (multi-part form-data request)
        function uploadVolunteerDocument(params) {
            var fd = new FormData();
            fd.append('theFile', params.theFile);
            fd.append('fileSuffix', params.fileSuffix);
            // TODO: Use "documentName" to allow user to specify what document is, not just the filename
            fd.append('documentName', params.documentName);
            fd.append('masterUserId', params.masterUserId);
            fd.append('documentDescription', params.documentDescription);
            fd.append('authorization', getToken());

            // Award, Training, Orientation-specific fields for their document upload
            if (params.volunteerAwardId) {
                fd.append('volunteerAwardId', params.volunteerAwardId);
            } else if (params.volunteerTrainingId) {
                fd.append('volunteerTrainingId', params.volunteerTrainingId);
            } else if (params.volunteerOrientationId) {
                fd.append('volunteerOrientationId', params.volunteerOrientationId);
            }

            return config.get().then(function (configData) {
                return $http.post(configData.apiServer + '/authorized_api/volunteer_document', fd, {
                    transformRequest: angular.identity,
                    headers: { 'Content-Type': undefined }
                });
            }).then(httpSuccess).catch(httpFailure);
        }

        function deleteVolunteerDocument(params) {
            params.authorization = getToken();

            return config.get().then(function (configData) {
                return $http.post(configData.apiServer + '/authorized_api/delete_documents_for_user', params);
            }).then(httpSuccess).catch(httpFailure);
        }

        // Uploading documents requires different method
        // (multi-part form-data request)
        function uploadMassEmailAttachment(params) {
            var fd = new FormData();
            fd.append('theFile', params.theFile);
            fd.append('fileSuffix', params.fileSuffix);
            fd.append('sentEmailUUID', params.sentEmailUUID);
            fd.append('documentName', params.documentName);
            fd.append('authorization', getToken());

            return config.get().then(function (configData) {
                return $http.post(configData.apiServer + '/authorized_api/upload_attachment', fd, {
                    transformRequest: angular.identity,
                    headers: { 'Content-Type': undefined }
                });
            }).then(httpSuccess).catch(httpFailure);
        }

        function getVolunteerServiceRecord(params) {
            var data = angular.copy(params, {});
            data.authorization = getToken();

            return config.get().then(function (configData) {
                return $http.post(configData.apiServer + '/authorized_api/get_volunteer_service_record', data);
            }).then(httpSuccess).catch(httpFailure);
        }

        function getVolunteerNotes(params) {
            var data = angular.copy(params, {});
            data.authorization = getToken();

            return config.get().then(function (configData) {
                return $http.post(configData.apiServer + '/authorized_api/get_volunteer_notes', data);
            }).then(httpSuccess).catch(httpFailure);
        }

        function manageVolunteerNotes(params) {
            var data = angular.copy(params, {});
            data.authorization = getToken();

            return config.get().then(function (configData) {
                return $http.post(configData.apiServer + '/authorized_api/manage_volunteer_notes', data);
            }).then(httpSuccess).catch(httpFailure);
        }

        function getVolunteerBackgroundChecks(params) {
            var data = angular.copy(params, {});
            data.authorization = getToken();

            return config.get().then(function (configData) {
                return $http.post(configData.apiServer + '/authorized_api/get_volunteer_background_checks', data);
            }).then(httpSuccess).catch(httpFailure);
        }

        function manageVolunteerBackgroundChecks(params) {
            var data = angular.copy(params, {});
            data.authorization = getToken();

            return config.get().then(function (configData) {
                return $http.post(configData.apiServer + '/authorized_api/manage_volunteer_background_checks', data);
            }).then(httpSuccess).catch(httpFailure);
        }

        function getVolunteerDocuments(params) {
            var data = angular.copy(params, {});
            data.authorization = getToken();

            return config.get().then(function (configData) {
                return $http.post(configData.apiServer + '/authorized_api/get_volunteer_documents', data);
            }).then(httpSuccess).catch(httpFailure);
        }

        function getVolunteerAwards(params) {
            var data = angular.copy(params, {});
            data.authorization = getToken();

            return config.get().then(function (configData) {
                return $http.post(configData.apiServer + '/authorized_api/get_volunteer_awards', data);
            }).then(httpSuccess).catch(httpFailure);
        }

        function setVolunteerAwards(params) {
            var data = angular.copy(params, {});
            data.authorization = getToken();

            return config.get().then(function (configData) {
                return $http.post(configData.apiServer + '/authorized_api/set_volunteer_awards', data);
            }).then(httpSuccess).catch(httpFailure);
        }

        function deleteVolunteerAwards(params) {
            var data = angular.copy(params, {});
            data.authorization = getToken();

            return config.get().then(function (configData) {
                return $http.post(configData.apiServer + '/authorized_api/delete_volunteer_awards', data);
            }).then(httpSuccess).catch(httpFailure);
        }

        function getVolunteerTrainings(params) {
            var data = angular.copy(params, {});
            data.authorization = getToken();

            return config.get().then(function (configData) {
                return $http.post(configData.apiServer + '/authorized_api/get_volunteer_trainings', data);
            }).then(httpSuccess).catch(httpFailure);
        }

        function setVolunteerTrainings(params) {
            var data = angular.copy(params, {});
            data.authorization = getToken();

            return config.get().then(function (configData) {
                return $http.post(configData.apiServer + '/authorized_api/set_volunteer_trainings', data);
            }).then(httpSuccess).catch(httpFailure);
        }

        function deleteVolunteerTrainings(params) {
            var data = angular.copy(params, {});
            data.authorization = getToken();

            return config.get().then(function (configData) {
                return $http.post(configData.apiServer + '/authorized_api/delete_volunteer_trainings', data);
            }).then(httpSuccess).catch(httpFailure);
        }

        function getVolunteerOrientations(params) {
            var data = angular.copy(params, {});
            data.authorization = getToken();

            return config.get().then(function (configData) {
                return $http.post(configData.apiServer + '/authorized_api/get_volunteer_orientations', data);
            }).then(httpSuccess).catch(httpFailure);
        }

        function setVolunteerOrientations(params) {
            var data = angular.copy(params, {});
            data.authorization = getToken();

            return config.get().then(function (configData) {
                return $http.post(configData.apiServer + '/authorized_api/set_volunteer_orientations', data);
            }).then(httpSuccess).catch(httpFailure);
        }

        function deleteVolunteerOrientations(params) {
            var data = angular.copy(params, {});
            data.authorization = getToken();

            return config.get().then(function (configData) {
                return $http.post(configData.apiServer + '/authorized_api/delete_volunteer_orientations', data);
            }).then(httpSuccess).catch(httpFailure);
        }

        function getAvccsForCommunity(params) {
            var data = angular.copy(params);
            return config.get().then(function (configData) {
                return $http.post(configData.apiServer + '/public_api/get_avccs_for_community', data);
            }).then(httpSuccess).catch(httpFailure);
        }

        function mergeVMISdata(params) {
            var data = angular.copy(params);
            data.authorization = getToken();
            return config.get().then(function (configData) {
                return $http.post(configData.apiServer + '/authorized_api/merge_VMIS_data', data);
            }).then(httpSuccess).catch(httpFailure);
        }

        function getMasterUserIdFromEmail(params) {
            var data = angular.copy(params);
            data.authorization = getToken();
            return config.get().then(function (configData) {
                return $http.post(configData.apiServer + '/authorized_api/get_masterUserId_from_email', data);
            }).then(httpSuccess).catch(httpFailure);
        }

        function getUsernameFromMasterUserId(params) {
            var data = angular.copy(params);
            data.authorization = getToken();
            return config.get().then(function (configData) {
                return $http.post(configData.coreServer + '/authorized_api/users/get_username_from_masterUserId', data);
            }).then(httpSuccess).catch(httpFailure);
        }

        /**
         * Gets information from VMIS API health check.
         * @param params Any of acceptable parameters to check aspects of API health (unacceptable ones are ignored) (optional)
         * @returns {*} Returns a promise of the data from the API.
         */
        function checkVmisApiHealth(params) {
            return config.get().then(function (configData) {
                return checkHealth(configData.apiServer, params);
            });
        }

        /**
         * Gets information from Core API health check.
         * @param params Any of acceptable parameters to check aspects of API health (unacceptable ones are ignored) (optional)
         * @returns {*} Returns a promise of the data from the API.
         */
        function checkCoreApiHealth(params) {
            return config.get().then(function (configData) {
                return checkHealth(configData.coreServer, params);
            });
        }

        function checkHealth(api, params) {
            if (params !== undefined && !Array.isArray(params)) {
                console.warn("Attempted to pass non-array into API health check!");
                return;
            }
            var paramsStr = "";

            // "params" is optional
            if (params) {
                paramsStr += "?test=";
                params.forEach(function (param) {
                    paramsStr += param.toString() + ",";
                });
            }

            return $http.get(api + '/check_health' + paramsStr).then(httpSuccess).catch(httpFailure);
        }

        function httpSuccess(response) {
            if (response.status === 200) {
                var data = response.data;
                if (data &&
                    (data.success === true ||
                        (data instanceof ArrayBuffer && data.byteLength !== undefined))) {
                    return response.data;
                }
            }
            return $q.reject(response);
        }

        function httpFailure(error) {
            if (error.status === 200) {
                $log.error(error.config.method, error.config.url, error.data.error);
                return $q.reject(error.data.error);
            }
            var errorText = 'Error: ' + error.status + ', ' + error.statusText;
            $log.error(error.config.method, error.config.url, errorText);
            return $q.reject(errorText);
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.auth')
        .factory('config', config);

    config.$inject = ['$http'];

    function config($http) {
        var $config;

        return { get: get };

        function get() {
            if (!$config) {
                $config = $http.get('/config.json').then(function (response) {
                    if (typeof response.data !== 'object') {
                        response.status = 404;
                        response.statusText = 'Not Found';
                        throw response;
                    }
                    return response.data;
                });
            }
            return $config;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.lite', []);

    angular
        .module('app.lite')
        .factory('lite', lite);

    lite.$inject = ['$cookies', 'config'];

    function lite($cookies, config) {

        return {
            isLiteMode: isLiteMode,
            setLiteMode: setLiteMode,
            getNumRows: getNumRows,
        };

        function isLiteMode() {
            var cookieData = $cookies.get('vmis-lite');
            // result will be undefined if it hasn't been explicitly set yet
            return !!cookieData ? JSON.parse(cookieData) : false;
        }

        function setLiteMode(isLiteMode) {
            $cookies.put('vmis-lite', isLiteMode);
        }

        // Input is default number of rows for a single object type and the reduction factor
        function getNumRows(defaultNumRows, liteModeReductionFactor) {
            if (!isLiteMode()) return defaultNumRows;

            var reducedValue = Math.ceil(
                defaultNumRows / (liteModeReductionFactor > 0 ? liteModeReductionFactor : 1));

            return reducedValue > 0 ? reducedValue : 1;
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.auth')
        .factory('loadStatus', loadStatus);

    loadStatus.$inject = ['config', 'lite'];

    // TODO: This service is not used to its fullest extent
    // It could be expanded to handle a number of situations that are currently
    // addressed repeatedly in an individual manner throughout the app.
    // Reset, for example, could be modified to handle the many other
    // reset-like behaviors, and then applied everywhere.
    // Additionally, this service holds the defaultNumRows value from the config,
    // so it could serve as the reference point for that to cut down on config.get()s.
    function loadStatus(config, lite) {
        return {
            init: init,
            setup: setup,
            reset: reset
        };

        function init() {
            return {
                currentIndex: 0,
                numResultsNotLoaded: 0,
                nextResultLoadNum: null,
                defaultNumRows: 0,
                maxLoadAll: 0
            };
        }

        // One loadStatus per object type
        function setup(loadStatusObj, type) {
            return config.get().then(function (configData) {
                loadStatusObj.defaultNumRows = lite.getNumRows(
                    configData.defaultNumRows[type], configData.liteModeReductionFactor);
                loadStatusObj.nextResultLoadNum = loadStatusObj.defaultNumRows;
                loadStatusObj.maxLoadAll = configData.defaultNumRows.maxLoadAll;
            }).catch(function (error) {
                console.error(error);
            });
        }

        function reset(loadStatusObj) {
            loadStatusObj.currentIndex = 0;
            loadStatusObj.numResultsNotLoaded = 0;
            loadStatusObj.nextResultLoadNum = loadStatusObj.defaultNumRows;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app')
        .factory('_', lodash);

    lodash.$inject = ['$window'];

    function lodash($window) {
        return $window._;
    }
})();
(function () {
    'use strict';

    angular
        .module('app.auth')
        .factory('records', records);

    records.$inject = ['authentication'];

    function records(authentication) {

        var myMasterUserId = null;

        activate();

        return {
            getMyMasterUserId: getMyMasterUserId
        };

        function activate() {
            return authentication.getUserProfile()
                .then(function (response) {
                    if (response.masterUserId) {
                        myMasterUserId = response.masterUserId;
                    }
                });
        }

        /**
         * Returns user's own masterUserId, if it's obtained on controller load using this service, above.
         * Otherwise null.
         * @returns myMasterUserId user's own masterUserId, unless null
         */
        function getMyMasterUserId() {
            return myMasterUserId;
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app')
        .factory('redirect', redirect);

    redirect.$inject = ['$window', '$location'];

    function redirect($window) {
        return {
            returnTo: returnTo
        };

        function returnTo(returnTo) {
            var url = $window.decodeURIComponent(returnTo);
            if (url.indexOf('?') == -1) {
                url = url.concat('?');
            } else {
                url = url.concat('&');
            }
            url = url.concat('logged-in');
            $window.location.href = url;
        }
    }
})();

/**
 * Created by scuzzort3 on 6/8/16.
 */
(function () {
    'use strict';

    angular
        .module('app.auth')
        .factory('usersServices', users);

    users.$inject = [
        '$q',
        'moment',
        'authentication'
    ];

    function users($q,
                   moment,
                   authentication) {

        return {
            isBasicAdminUserDataComplete: isBasicAdminUserDataComplete,
            currentUserFirstName: currentUserFirstName,
            getTotalHoursForUserForMonth: getTotalHoursForUserForMonth
        };

        function currentUserFirstName() {
            return authentication.getUserProfile()
                .then(function (user) {
                    return user.aosUser.firstName;
                })
                .catch(function (error) {
                    return $q.reject(error);
                });
        }

        function getTotalHoursForUserForMonth(date) {
            var startDate = moment(date).startOf('month').format();
            var endDate = moment(date).endOf('month').format();

            var paramsSubmitted = {
                startDate: startDate,
                endDate: endDate
            };


            return authentication.getHoursVol(paramsSubmitted).then(function (response) {
                var submittedSum = 0;
                var certifiedSum = 0;
                var rejectedSum = 0;

                angular.forEach(response.hours, function (timeInHours) {
                    switch (timeInHours.volunteerHoursStatus) {
                        case "Submitted":
                            submittedSum += timeInHours.hours;
                            break;
                        case "Certified":
                            certifiedSum += timeInHours.hours;
                            break;
                        case "Rejected":
                            rejectedSum += timeInHours.hours;
                            break;
                    }
                });

                return {
                    submittedHours: submittedSum,
                    certifiedHours: certifiedSum,
                    rejectedHours: rejectedSum
                };
            }).catch(function (error) {
                return $q.reject(error);
            });
        }

        // Check if user profile has AOS user object, VMIS user object, admin profile, and responsibilities
        function isBasicAdminUserDataComplete(userProfile) {
            return !(
                userProfile.aosUser === undefined ||
                userProfile.aosUser === null ||
                userProfile.aosUser.vmisUser === undefined ||
                userProfile.aosUser.vmisUser === null ||
                userProfile.aosUser.vmisUser.adminProfile === undefined ||
                userProfile.aosUser.vmisUser.adminProfile === null ||
                userProfile.aosUser.vmisUser.adminProfile.responsibilities === undefined ||
                userProfile.aosUser.vmisUser.adminProfile.responsibilities === null
            );
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.auth')
        .factory('utilsServices', utils);

    utils.$inject = ['$q', '_', 'authentication'];

    function utils($q, _, authentication) {
        return {
            combineCommunityResponsibilities: combineCommunityResponsibilities,
            combineStandardOrganizationResponsibilities: combineStandardOrganizationResponsibilities,
            combineResponsibilities: combineResponsibilities,
            parseErrorString: parseErrorString,
            displayError: displayError
        };

        /**
         * Combines the community responsibilities of an admin.
         * @param profile The admin's profile
         * @param roles The roles to require
         * @returns {*} Returns a promise of an array of communities or null if admin does not have any
         * responsibilities. Communities are returned in the following format:
         *     {
         *         id, // Community ID
         *         name, // Community name
         *         organizations: [{
         *             id, // Organization ID
         *             name // Organization name
         *         }, ...]
         *     }
         */
        function combineCommunityResponsibilities(profile, roles) {
            var responsibilities = getResponsibilities(profile);
            if (!responsibilities) return null;

            var communities = [];

            // Coordinator
            if (shouldInclude(responsibilities, roles, 'avcc', 'AVC Coordinator')) {
                communities = getUniques(communities, mapCommunities(responsibilities.avcc));
            }

            // Coordinator Assistant
            if (shouldInclude(responsibilities, roles, 'avccAssistant', 'AVC Coordinator Assistant')) {
                communities = getUniques(communities, mapCommunities(responsibilities.avccAssistant));
            }

            // OPOC
            if (shouldInclude(responsibilities, roles, 'opoc', 'AVC OPOC')) {
                communities = getUniques(communities, mapCommunities(responsibilities.opoc));
            }

            return $q.when(communities);

            function mapCommunities(communities) {
                return _.map(communities, function (community) {
                    return {
                        id: community.communityAffiliationId,
                        name: community.communityAffiliationName,
                        organizations: community.organizations ? _.map(community.organizations, function (organization) {
                                return {
                                    id: organization.volunteerOrganizationId,
                                    name: organization.volunteerOrganizationName
                                };
                            }) : null
                    };
                });
            }
        }

        /**
         * Combines the standard organization responsibilities of an admin.
         * @param profile The admin's profile
         * @param roles The roles to require
         * @returns {*} Returns a promise of an array of standard organizations or null if admin does not have any
         * responsibilities. Standard organizations are returned in the following format:
         *     {
         *         id, // Standard organization ID
         *         name // Standard organization name
         *     }
         */
        function combineStandardOrganizationResponsibilities(profile, roles) {
            return authentication.getStandardOrganizations({
                getAll: true
            }).then(function(response) {
                return _.map(response.standardOrganizations, function(standardOrganization) {
                    return {
                        id: standardOrganization.volunteerOrganizationTemplateId,
                        name: standardOrganization.volunteerOrganizationTemplateName
                    };
                });
            });
        }

        /**
         * Combines all the responsibilities of an admin.
         * @param profile The admin's profile
         * @param roles The roles to require
         * @returns {*} Returns a promise of a map of the admin's responsibilities or null if admin does not have any
         * responsibilities.
         */
        function combineResponsibilities(profile, roles) {
            if (!getResponsibilities(profile)) return null;

            return $q.all({
                standardOrganizations: combineStandardOrganizationResponsibilities(profile, roles),
                communities: combineCommunityResponsibilities(profile, roles)
            });
        }

        function getResponsibilities(profile) {
            return _.has(profile, 'aosUser.vmisUser.adminProfile.responsibilities') ? profile.aosUser.vmisUser.adminProfile.responsibilities : null;
        }

        function shouldInclude(responsibilities, roles, responsibilityRole, requiredRole) {
            return _.has(responsibilities, responsibilityRole) && (!roles || _.includes(roles, requiredRole));
        }

        function getUniques(array1, array2) {
            return array1 ? _.unionBy(array1, array2, 'id') : array2;
        }

        function parseErrorString(error) {
            var errorStr = "";
            if (error.error)
                errorStr = error.error;
            else
                errorStr = error;
            return errorStr;
        }

        /**
         * Displays error string in vm.formError and sets vm.isLoading flag to false.
         * Ignores multiple common strings that shouldn't be displayed.
         * Note: there are multiple ways we use formError, and this doesn't work for all of them.
         * @param error The error string
         * @param vm The object to place the string in (formError) and set loading flag to false in
         */
        function displayError(error, vm) {
            if (_.isUndefined(error)) return;
            var errorStr = parseErrorString(error);

            vm.loading = false;

            if (errorStr === 'cancel' || errorStr === 'backdrop click' || errorStr === 'ok')
                return;
            if (errorStr)
                vm.formError = errorStr;
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app')
        .directive('convertToNumber', ConvertToNumber);

    ConvertToNumber.$inject = [];

    function ConvertToNumber() {
        return {
            require: 'ngModel',
            link: function (scope, element, attrs, ngModel) {
                ngModel.$parsers.push(function (val) {
                    return parseInt(val, 10);
                });
                ngModel.$formatters.push(function (val) {
                    if (angular.isNumber(val) && isFinite(val)) {
                        return val.toString();
                    }
                });
            }
        };
    }
})();
(function () {
    'use strict';

    angular
        .module('app')
        .directive('confirmDataError', ConfirmDataError);

    ConfirmDataError.$inject = [];

    function ConfirmDataError() {
        return {
            require: 'ngModel',
            link: link
        };

        function link(scope, elm, attrs, ctrl) {
            scope.$watch(attrs.confirmDataError, function (error) {
                elm[0].setCustomValidity(error);
                ctrl.$setValidity('confirmDataError', error ? false : true);
            });
        }
    }
})();

/**
 * Created by scuzzort3 on 7/13/16.
 */
(function () {
    'use strict';

    angular
        .module('app.hoursEntryFormatter', []);

    angular
        .module('app.hoursEntryFormatter')
        .directive('hoursEntryFormatter', hoursEntryFormatter);

    hoursEntryFormatter.$inject = [];

    function hoursEntryFormatter() {
        return {
            restrict: 'A',
            scope: {},
            require: 'ngModel',
            link: function (scope, element, attrs, ngModel) {
                var min = attrs.min || 0;
                var max = attrs.max || 24;
                var pattern = new RegExp(attrs.pattern);
                ngModel.$parsers.push(function (val) {
                    if (val.match(pattern) !== null) {
                        if (parseFloat(val, 10) < min) {
                            val = min.toString();
                        } else if (parseFloat(val, 10) > max) {
                            val = max.toString();
                        }
                    }

                    ngModel.$setViewValue(val);
                    ngModel.$render();

                    return parseFloat(val, 10);
                });
                ngModel.$formatters.push(function (val) {
                    if(!angular.isNumber(val)){
                        return '';
                    }

                    return val.toFixed(2);
                });
            }
        };
    }
})();
/*
 http://foundation-datepicker.peterbeno.com/example.html
 */
(function () {
    'use strict';

    angular
        .module('app')
        .directive('vmisDatepicker', VmisDatepicker);

    VmisDatepicker.$inject = ['$timeout'];

    function VmisDatepicker($timeout) {
        return {
            restrict: 'A',
            require: 'ngModel',
            scope: {
                format: '@?',
                startDate: '<?',
                endDate: '<?',
                leftArrow: '@?',
                rightArrow: '@?'
            },
            link: link
        };

        function link(scope, element, attributes, controller) {
            var target = attributes.target ? '#' + attributes.target : element;
            var format = scope.format || moment.ISO_8601;
            var datepicker;


            $timeout(function () {
                datepicker = $(target).fdatepicker({
                    initialDate: new Date(),
                    leftArrow: scope.leftArrow || defaultArrow('left'),
                    rightArrow: scope.rightArrow || defaultArrow('right'),
                    onRender: onRender
                }).on('changeDate', onChangeDate).on('show', onShow).data('datepicker');
            }, 100);

            controller.$validators.dateValidator = function (modelValue, viewValue) {
                if (modelValue) {
                    var startDate = dateExist('startDate');
                    if (startDate && moment(modelValue).isBefore(startDate, 'day')) return false;
                    var endDate = dateExist('endDate');
                    if (endDate && moment(modelValue).isAfter(endDate, 'day')) return false;
                }
                return viewValue ? moment(viewValue, format, true).isValid() : true;
            };

            controller.$formatters.unshift(function (modelValue) {
                if (!format || !modelValue) return "";
                var retVal = moment(new Date(modelValue));
                return scope.format ? retVal.format(scope.format) : retVal;
            });

            controller.$parsers.unshift(function (viewValue) {
                var date = moment(viewValue, format);
                return (date && date.isValid() && date.year() > 1900 ) ? date.toDate() : "";
            });

            scope.$on('$destroy', function () {
                datepicker.remove();
            });

            function defaultArrow(direction) {
                return '<icon>' +
                    '<svg class="icon icon-fa-chevron-' + direction + '">' +
                    '<use xlink:href="#icon-fa-chevron-' + direction + '"></use>' +
                    '</svg>' +
                    '</icon>';
            }

            function onRender(utcDate) {
                var localDate = moment(utcDate).add(utcDate.getTimezoneOffset(), 'minutes');
                var startDate = dateExist('startDate');
                var endDate = dateExist('endDate');
                var renderStart = startDate ? moment(localDate).isSameOrAfter(startDate, 'day') : true;
                var renderEnd = endDate ? moment(localDate).isSameOrBefore(endDate, 'day') : true;
                return renderStart && renderEnd ? '' : 'disabled';
            }

            function onChangeDate(event) {
                var date = moment(event.date).add(event.date.getTimezoneOffset(), 'minutes').startOf('day').toDate();
                scope.$apply(function () {
                    controller.$setViewValue(date, 'programmatic');
                    controller.$modelValue = date;
                });
            }

            function onShow() {
                if (!controller.$modelValue) return;
                var date = moment(controller.$modelValue).startOf('day').toDate();
                datepicker.update(date);
            }

            function dateExist(date) {
                if (angular.isDefined(attributes[date])) {
                    if (scope[date] === undefined) return attributes[date] ? false : new Date();
                    if (scope[date] === null) return false;
                    return scope[date];
                }
                return false;
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app')
        .directive('vmisDropdown', vmisDropdown);

    vmisDropdown.$inject = [];

    function vmisDropdown() {
        return {
            restrict: 'E',
            transclude: {
                'toggle': 'vmisDropdownToggle',
                'pane': 'vmisDropdownPane'
            },
            templateUrl: 'app/common/directives/dropdown/dropdown.view.html',
            controller: 'DropdownController',
            controllerAs: 'vm',
            scope: {
                active: '=?isOpen'
            },
            bindToController: true
        };
    }
})();
(function () {
    'use strict';

    angular
        .module('app')
        .controller('DropdownController', DropdownController);

    DropdownController.$inject = ['$element', '$scope', '$transclude'];

    function DropdownController($element, $scope, $transclude) {
        var vm = this;
        var body = angular.element(document.querySelector('body'));

        vm.$onDestroy = onDestroy;
        vm.toggle = toggle;

        $transclude(function (clone) {
            var el = angular.element($element[0].querySelector('vmis-dropdown>span'));
            el.append(clone);
        }, $element.parent(), 'toggle');

        $transclude(function (clone, scope) {
            scope.$close = close;
            var el = angular.element($element[0].querySelector('vmis-dropdown>div'));
            el.append(clone);
        }, $element.parent(), 'pane');

        function onDestroy() {
            body.off('click', onClick);
        }

        function onClick(event) {
            var elementContents = Array.prototype.slice.apply($element[0].querySelectorAll('*'));

            if (elementContents.length <= 0) {
                return;
            }

            var isOuterElement = elementContents.every(function (node) {
                return node !== event.target;
            });

            if (isOuterElement || !vm.active) {
                close();
                $scope.$apply();
            }
        }

        function close() {
            vm.active = false;
            body.off('click', onClick);
        }

        function open() {
            vm.active = true;
            body.on('click', onClick);
        }

        function toggle() {
            if (vm.active) {
                close();
            } else {
                open();
            }
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app')
        .directive('modal', modal);

    modal.$inject = [];

    function modal() {
        return {
            restrict: 'E',
            transclude: {
                body: '?modalBody',
                footer: '?modalFooter'
            },
            templateUrl: 'app/common/directives/modal/modal.template.html',
            controller: function() {},
            controllerAs: 'vm',
            bindToController: true,
            scope: {
                close: '<?',
                modalTitle: '@?'
            }
        };
    }
})();
(function () {
    'use strict';

    angular
        .module('app')
        .directive('loadingIcon', LoadingIcon);

    LoadingIcon.$inject = [];

    function LoadingIcon() {
        return {
            restrict: 'E',
            templateUrl: 'app/common/directives/loadingIcon/loadingIcon.template.html',
            controller: function () {},
            controllerAs: 'loadingIcon',
            scope: {
                show: '=',
                // TODO: Make size parameter so these two cannot conflict if both used
                little: '=?',
                littlest: '=?',
                pushDown: '=?'
            },
            bindToController: true
        };
    }
})();

(function () {
    'use strict';

    angular
        .module('app')
        .directive('uploadDocumentList', UploadDocumentList);

    UploadDocumentList.$inject = [];

    function UploadDocumentList() {
        return {
            restrict: 'E',
            templateUrl: 'app/common/directives/uploadDocumentList/uploadDocumentList.template.html',
            controller: function () {},
            controllerAs: 'uploadDocumentList',
            scope: {
                uploadedDocuments: '=',
                selectedDocuments: '=',
                onDeleteUploadedDoc: '=',
                onDeleteSelectedDoc: '=',
                showUploadInstructions: '=',
                showDelete: '=',
                disableDelete: '='
            },
            bindToController: true
        };
    }
})();
(function () {
    'use strict';
    
    angular
        .module('app.vmisCalendar', [
            'angularMoment'
        ]);
})();
(function () {
    'use strict';

    angular
        .module('app.vmisCalendar')
        .directive('vmisCalendar', calendar);

    calendar.$inject = ['moment'];

    function calendar(moment) {
        return {
            restrict: 'E',
            templateUrl: 'common/directives/vmisCalendar/vmisCalendar.view.html',
            scope: {
                date: '=?', // Date object, date string, or moment
                hideDayOfWeek: '=?',
                hideDays: '=?',
                view: '=?' //'month'(default), 'week'
            },
            link: link
        };

        function link(scope, element, attrs) {

            element.on('$destroy', destroy);

            activate();

            function activate() {
                if(typeof attrs.date === 'undefined') {
                    scope.date = moment();
                } else {
                    scope.date = moment(attrs.date);
                    if(!scope.date.isValid()) {
                        return;
                    }
                }

                if(typeof attrs.hideDayOfWeek === 'undefined') {
                    scope.showDayOfWeek = true;
                }
                if(typeof attrs.hideDays === 'undefined') {
                    scope.showDays = true;
                }
                if(typeof attrs.view === 'undefined') {
                    attrs.view = 'month';
                }

                if(scope.showDays) {
                    switch(attrs.view) {
                        case 'month':
                            scope.weeks = buildMonth(scope.date);
                            break;
                        case 'week':
                            scope.weeks = [buildWeek(scope.date)];
                            break;
                        default:
                            return;
                    }
                }
            }

            function destroy() {

            }
        }

        function buildMonth(startDate) {
            var date = startDate.clone().startOf('month').weekday(0);
            var weeks = [];

            for (var i = 0; i < 6; i++) {
                weeks.push(buildWeek(date));
                date.add(1, 'w');
            }

            return weeks;
        }

        function buildWeek(startDate) {
            var date = startDate.clone().startOf('week');
            var days = [];

            for (var i = 0; i < 7; i++) {
                days.push({
                    date: date.clone(),
                    data: {}
                });
                date.add(1, 'd');
            }

            return days;
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.vmisHoursEntry', [
            'app.vmisCalendar',
            'app.hoursEntryFormatter'
        ]);
})();
(function () {
    'use strict';

    angular
        .module('app.vmisHoursEntry')
        .directive('vmisHoursEntry', hoursEntry);

    hoursEntry.$inject = [];

    function hoursEntry() {
        return {
            restrict: 'E',
            templateUrl: 'app/common/directives/vmisHoursEntry/vmisHoursEntry.view.html',
            controller: 'HoursEntryController',
            controllerAs: 'vmWidget',
            bindToController: true,
            scope: {
                date: '=?',
                setHourCallback: '=?' // function callback;
            }
        };
    }
})();
(function () {
    'use strict';

    angular
        .module('app.vmisHoursEntry')
        .controller('HoursEntryController', HoursEntryController);

    HoursEntryController.$inject = ['$scope', '$q', '$timeout', 'moment', 'authentication', '$modal', '_'];

    function HoursEntryController($scope, $q, $timeout, moment, authentication, $modal, _) {
        var vm = this;

        vm.dateRange = {
            start: new Date().getDate() < 15 ? moment().subtract(1, 'months').startOf('month').toDate() : moment().startOf('month').toDate(),
            end: new Date()
        };
        vm.tooltipIsOpen = false;
        vm.autoSubmitTimeOut = null;

        vm.autoSubmitHours = autoSubmitHours;
        vm.onHourBlur = setHour;

        $scope.$watch('vmWidget.date', dateListener, true);

        function getOpportunities() {
            return authentication
                .getOpportunitiesAppliedFor({
                    startingRowIndex: 0,
                    numberOfRows: 100,
                    volunteerApplicationStatus: 'Approved',
                    volunteerServiceStatus: 'Active',
                    volunteerPositionStatus: ['Open, searchable','Open, not searchable']
                })
                .then(function (response) {
                    return response.opportunities.map(function (position) {
                        return {
                            id: position.opportunityId,
                            title: position.title
                        };
                    });
                });
        }

        function getAllHours(opportunities) {
            return $q.all(opportunities.map(getHours));
        }

        function getHours(opportunity) {
            var request = {
                volunteerOpportunityId: opportunity.id,
                // Just send date, as timezones would cause an extra Sunday to be included
                startDate: moment(vm.date).startOf('week').format('YYYY-MM-DD'),
                endDate: moment(vm.date).endOf('week').format('YYYY-MM-DD')
            };

            return authentication.getHoursVol(request)
                .then(function (response) {
                    return _.map(_.filter(response.hours, 'dayOfService'), function (activity) {
                        return {
                            date: moment(activity.dayOfService),
                            hours: activity.hours,
                            status: activity.volunteerHoursStatus,
                            reviewerNote: activity.reviewerNotes,
                            userNote: activity.userNotes
                        };
                    });
                });
        }

        /**
         * This function creates a timeout that, when expired, submits the hours being entered in
         * the Log Hours card. It should be set on the "keyup" event.
         * Adapted from emailValidator.directive.js in Account Management.
         */
        function autoSubmitHours(position, activity) {
            //cancel the last timeout
            clearTimeout(vm.autoSubmitTimeOut);

            // wait for user to stop typing before processing validity
            vm.autoSubmitTimeOut = setTimeout(function(){
                setHour(position, activity);
            }, 1500);
        }

        function setHour(position, activity) {
            if (angular.isUndefined(activity.hours) || activity.hours === null) {
                return;
            }
            var hours = activity.hours || 0;
            var request = {
                volunteerOpportunityId: position.id,
                hours: {
                    dateEntered: moment().toISOString(),
                    dayOfService: moment(activity.date).startOf('day').toISOString(),
                    hours: hours
                }
            };

            authentication
                .setVolunteerHoursForOpportunity(request)
                .then(function (response) {
                    vm.tooltipIsOpen = true;
                    if (typeof vm.setHourCallback === 'function') {
                        vm.setHourCallback();
                    }
                    $timeout(function () {
                        vm.tooltipIsOpen = false;
                    }, 2000);
                    return response;
                })
                .then(displayHours)
                .catch(function (error) {
                    var templateUrl = "app/common/directives/vmisHoursEntry/error.html";
                    var options = {
                        controller: 'HoursErrorController',
                        controllerAs: 'modal',
                        templateUrl: templateUrl,
                        size: 'tiny',
                        backdrop: 'static',
                        keyboard: false,
                        resolve: {
                            error: function () {
                                return error;
                            }
                        }
                    };
                    $modal.open(options);
                });
        }

        function dateListener() {
            displayHours();
        }

        function displayHours() {
            vm.weekday = moment(vm.date).weekday();
            var deferred = $q.defer();
            var promise = deferred.promise;

            promise
                .then(getOpportunities)
                .then(function (positions) {
                    vm.positions = positions;
                    return positions;
                })
                .then(getAllHours)
                .then(function (result) {

                    for (var i = 0; i < vm.positions.length; i++) {
                        var position = vm.positions[i];
                        position.activities = [];
                        // TODO: could be more robust by checking if full date matches, not just weekday
                        for (var d = 0; d < 7; d++) {
                            var foundIndex = -1;
                            for (var j = 0; j < result[i].length; j++) {
                                foundIndex = result[i][j].date.weekday() === d ? j : foundIndex;
                            }
                            var activity = {
                                hours: null,
                                date: moment(vm.date).weekday(d).toDate()
                            };
                            // Element IDs must be unique
                            activity.id = "hours-" +
                                position.title.split(" ").join("") +
                                "-" +
                                activity.date.toDateString().split(" ").join("");

                            if (foundIndex > -1) {
                                activity.hours = result[i][foundIndex].hours ? result[i][foundIndex].hours : null;
                                activity.status = result[i][foundIndex].status;
                            }

                            position.activities.push(activity);
                        }
                    }

                    return result;
                })
                .catch(function (error) {
                    var templateUrl = "app/common/directives/vmisHoursEntry/error.html";
                    var options = {
                        controller: 'HoursErrorController',
                        controllerAs: 'modal',
                        templateUrl: templateUrl,
                        size: 'tiny',
                        backdrop: 'static',
                        keyboard: false,
                        resolve: {
                            error: function () {
                                return error;
                            }
                        }
                    };
                    $modal.open(options);
                });

            deferred.resolve();
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.vmisHoursEntry')
        .controller('HoursErrorController', HoursErrorController);

    HoursErrorController.$inject = ['error'];

    function HoursErrorController(error) {
        var vm = this;
        vm.error = error;
    }
})();
(function () {
    'use strict';

    angular
        .module('app')
        .directive('vmisHoursStatus', VmisHoursStatus);

    VmisHoursStatus.$inject = [];

    function VmisHoursStatus() {
        return {
            restrict: 'E',
            templateUrl: 'app/common/directives/vmisHoursStatus/vmisHoursStatus.template.html',
            controller: function () {},
            controllerAs: 'vm',
            scope: {
                status: '<'
            },
            bindToController: true
        };
    }
})();
(function () {
    'use strict';

    angular
        .module('app')
        .directive('icon', Icon);

    Icon.$inject = [];

    function Icon() {
        return {
            restrict: 'E',
            templateUrl: 'app/common/directives/icon/icon.template.html',
            controller: function () {},
            controllerAs: 'icon',
            bindToController: true,
            scope: {
                name: '@',
                spin: '=?'
            }
        };
    }
})();
(function () {
    'use strict';

    angular
        .module('app')
        .directive('loadMore', loadMore);

    loadMore.$inject = [];

    function loadMore() {
        return {
            restrict: 'E',
            templateUrl: 'app/common/directives/loadMore/loadMore.template.html',
            controller: function() {},
            controllerAs: 'vm',
            bindToController: true,
            scope: {
                isLoading: '<',
                loadStatus: '<',
                onLoadMore: '&',
                onLoadAll: '&'
            }
        };
    }
})();
(function () {
    'use strict';

    angular
        .module('app')
        .directive('retrievedResults', retrievedResults);

    retrievedResults.$inject = [];

    function retrievedResults() {
        return {
            restrict: 'E',
            templateUrl: 'app/common/directives/retrievedResults/retrievedResults.template.html',
            controller: function() {},
            controllerAs: 'vm',
            bindToController: true,
            scope: {
                isLoading: '<',
                loadStatus: '<'
            }
        };
    }
})();
(function () {
    'use strict';

    angular
        .module('app')
        .directive('massAction', MassAction);

    MassAction.$inject = [];

    function MassAction() {
        return {
            restrict: 'E',
            templateUrl: 'app/common/directives/massAction/massAction.template.html',
            controller: function () {},
            controllerAs: 'vm',
            scope: {
                massActions: '=',
                selectedMassAction: '=',
                numSelected: '=',
                disabled: '='
            },
            bindToController: true
        };
    }
})();

(function () {
    'use strict';

    angular
        .module('app')
        .directive('textAreaWithCount', textAreaWithCount);

    textAreaWithCount.$inject = [];

    function textAreaWithCount() {
        return {
            restrict: 'E',
            templateUrl: 'app/common/directives/textAreaWithCount/textAreaWithCount.template.html',
            controller: function() {},
            controllerAs: 'vm',
            bindToController: true,
            scope: {
                defaultShownText: '@',
                maxGivenLength: '@',
                isRequired: '<',
                isDisabled: '<',
                isReadOnly: '@',
                numberRows: '@',
                modelName: '=',
                isHidden: '<'
            }
        };
    }
    
})();
(function () {
    'use strict';

    angular
        .module('app')
        .directive('liveChat', LiveChat);

    LiveChat.$inject = [];

    function LiveChat() {
        return {
            restrict: 'E',
            link: link
        };

        function link() {
            // Requires JQuery
            var script = document.createElement('script');
            script.type = 'text/javascript';
            script.async = "async";
            script.defer = "defer";
            script['data-cfasync'] = "false";
            script.src = "https://mylivechat.com/chatinline.aspx?hccid=44878937";
            document.body.appendChild(script);
        }
    }
})();
/**
 * Created by scuzzort3 on 8/10/17.
 */
(function () {
    'use strict';

    angular
        .module('app.learnAboutThisPage', [
        ]);
})();
/**
 * Created by scuzzort3 on 8/10/17.
 */
(function () {
    'use strict';

    angular
        .module('app.learnAboutThisPage')
        .directive('learnAboutThisPage', learnAboutThisPage);

    learnAboutThisPage.$inject = [];

    function learnAboutThisPage() {
        return {
            restrict: 'E',
            templateUrl: 'app/common/directives/learnAboutThisPage/learnAboutThisPage.view.html',
            controller: 'LearnAboutThisPageController',
            controllerAs: 'vmWidget',
            scope: {
                learnTitle: '@',
                textBody: '@'
            }
        };
    }
})();
(function () {
    'use strict';

    angular
        .module('app.learnAboutThisPage')
        .controller('LearnAboutThisPageController', LearnAboutThisPageController);

    LearnAboutThisPageController.$inject = ['$scope', '$modal'];

    function LearnAboutThisPageController($scope, $modal) {
        var vmWidget = this;

        vmWidget.learnTitle = $scope.learnTitle;
        vmWidget.textBody = $scope.textBody;

        vmWidget.openModal = openModal;

        function openModal() {
            var modalInstance = $modal.open({
                templateUrl: 'app/common/directives/learnAboutThisPage/learnAboutModal.template.html',
                controller: 'LearnAboutModalController',
                controllerAs: 'vmWidgetModal',
                backdrop: 'static',
                keyboard: false
            });
            modalInstance.learnTitle = vmWidget.learnTitle;
            modalInstance.textBody = vmWidget.textBody;
            // modalInstance.result
            // To Do: add error catching

        }
    }
})();
/**
 * Created by scuzzort3 on 8/10/17.
 */
(function () {
    'use strict';

    angular
        .module('app.learnAboutThisPage')
        .controller('LearnAboutModalController', LearnAboutModalController);

    LearnAboutModalController.$inject = ['$modalInstance'];

    function LearnAboutModalController($modalInstance) {
        var vmWidgetModal = this;
        vmWidgetModal.learnTitle = $modalInstance.learnTitle;
        vmWidgetModal.textBodyParagraphs = $modalInstance.textBody.split('\n');
    }
})();
(function () {
    'use strict';

    angular
        .module('app')
        .directive('passwordValidator', PasswordValidator);

    PasswordValidator.$inject = ['config'];

    // Provide validators for each aspect of a password:
    // Min 15 characters
    // 2 uppercase letters
    // 2 lowercase letters
    // 2 numbers
    // 2 special characters
    // 0 spaces

    // Example: https://docs.angularjs.org/guide/forms - "Custom Validation"
    function PasswordValidator(config) {
        return {
            restrict: 'A',
            require: 'ngModel',
            link: function (scope, elm, attrs, ctrl) {
                return config.get().then(function (configData) {
                    var lengthRegex = RegExp(configData.passwordRequirements.requirementChecks.lengthRegex);
                    var upperRegex = RegExp(configData.passwordRequirements.requirementChecks.upperRegex);
                    var lowerRegex = RegExp(configData.passwordRequirements.requirementChecks.lowerRegex);
                    var numRegex = RegExp(configData.passwordRequirements.requirementChecks.numRegex);
                    var specialRegex = RegExp(configData.passwordRequirements.requirementChecks.specialRegex);
                    var spaceRegex = RegExp(configData.passwordRequirements.requirementChecks.spaceRegex);

                    ctrl.$validators.passwordLength = function(modelValue, viewValue) {
                        return lengthRegex.test(modelValue);
                    };
                    ctrl.$validators.passwordUpper = function(modelValue, viewValue) {
                        return upperRegex.test(modelValue);
                    };
                    ctrl.$validators.passwordLower = function(modelValue, viewValue) {
                        return lowerRegex.test(modelValue);
                    };
                    ctrl.$validators.passwordNum = function(modelValue, viewValue) {
                        return numRegex.test(modelValue);
                    };
                    ctrl.$validators.passwordSpecial = function(modelValue, viewValue) {
                        return specialRegex.test(modelValue);
                    };
                    ctrl.$validators.passwordSpace = function(modelValue, viewValue) {
                        // When empty, it technically doesn't have spaces but we want to
                        // keep the UI element red.
                        if (ctrl.$isEmpty(modelValue)) return false;

                        return spaceRegex.test(modelValue);
                    };
                });
            }
        };
    }
})();
(function () {
    'use strict';

    angular
        .module('app.vmis', [
            'angularMoment', // angular-moment, requires moment
            'chart.js', // angular-chart.js, requires chart.js

            'vmis.activityCalendar',
            'app.auth',

            'vmis.administrator',
            'vmis.volunteer',

            'app.hoursEntryFormatter',
            'app.learnAboutThisPage',
            'app.lite'
        ]);
})();
(function () {
    'use strict';

    angular
        .module('app.vmis')
        .config(config);

    config.$inject = ['$stateProvider', '$urlRouterProvider'];

    function config($stateProvider, $urlRouterProvider) {
        $urlRouterProvider
            // Check if a service ticket is present in the current url's search parameters.
            .when(/\\*/, ticketHandler)
            // Determine where to reroute the user when they navigate to '/'.
            .when('/', defaultPathRedirect);

        $stateProvider
            .state('print', {
                url: "/print",
                abstract: true,
                template: '<div class="print-page" ui-view></div>'
            })
            .state('vmis', {
                templateUrl: 'app/components/vmis.view.html',
                controller: 'VmisController',
                controllerAs: 'vm'
            })
            .state('print.position', {
                url: '/position/{id:int}',
                templateUrl: 'app/components/vmisPrint.view.html',
                controller: 'VmisPrintController',
                controllerAs: 'vm'
            })
            .state('about', {
                url: '/about',
                templateUrl: 'app/components/vmis.view.html',
                controller: 'VmisController',
                controllerAs: 'vm',
                title: 'About'
            });

        ticketHandler.$inject = ['$cookies', '$state', '$modal', 'authentication', '$location', '$window', 'Idle', 'config'];

        function ticketHandler($cookies, $state, $modal, authentication, $location, $window, Idle, config) {
            var searchParms = $location.search();

            // Check if a service ticket is present in the current url's search parameters. If not, continue handling route as normal.
            if (angular.isDefined(searchParms.ticket)) {
                var ticket = searchParms.ticket;
                return config.get().then(function (configData) {
                    return authentication.logIn(ticket).then(function (response) {
                        Idle.watch();
                        $cookies.remove('logged-out-reason');

                        var options = {
                            controllerAs: 'vm',
                            backdrop: 'static',
                            keyboard: false
                        };

                        // This is handled in Account Management?
                        // Check if the user logged in with a one-time password or a password that is soon to expire. If so, display a modal with the appropriate warning.
                        // if (response.isOneTimeUsePassword) {
                        //     options.templateUrl = 'app/components/accountSettings/editPassword.view.html';
                        //     options.controller = 'EditPasswordController';
                        //     options.resolve = {
                        //         isDismissible: function () {
                        //             return false;
                        //         }
                        //     };
                        //     options.id = 1;
                        //     $modal.open(options);
                        // } else

                        // If password is near expiration, alert user. If using Common Access Card (CAC), don't bother.
                        // Days to expire field should also not be null if using the modal. (Previously this was the only way to determine CAC use.)
                        if (!response.cac_in_use && (response.daysToExpire !== null) && (response.daysToExpire < configData.passwordExpirationWarningDays)) {
                            options.templateUrl = 'app/components/logIn/passwordExpirationModal/passwordExpirationModal.view.html';
                            options.controller = 'PasswordExpirationModalController';
                            options.resolve = {
                                daysRemaining: function () {
                                    return response.daysToExpire;
                                }
                            };
                            options.size = 'tiny';
                            $modal.open(options);
                        }

                        // Reroute the user to a previously defined path, the state that represents the '/' path, or remove the service ticket from url's search parameters.
                        if (authentication.getRedirect()) {
                            var redirect = authentication.getRedirect();
                            authentication.clearRedirect();
                            $state.go(redirect.state, redirect.params);
                        } else if ($location.path() === '/') {
                            $state.go('vmis.dashboard', null, { reload: true });
                        } else {
                            $location.search('ticket', null);
                        }
                    }).catch(function (err) {
                        console.error(err);
                        // Reroute the user to the logged out page and display the appropriate error.
                        $cookies.put('logged-out-reason', configData.loggedOutReasons.ticketError);
                        $state.go('vmis.loggedOut', null, { reload: true });
                    });
                });
            }
            return false;
        }

        defaultPathRedirect.$inject = ['$cookies', '$state', 'authentication', 'config'];

        function defaultPathRedirect($cookies, $state, authentication, config) {
            var isVolunteer, isOpoc, isAvcc, isProgramManager, isAfwpAdmin;

            return config.get().then(function (configData) {
                if (configData.siteUnderConstruction) {
                    // If the site is under construction, redirect the user to '/underConstruction'.
                    $state.go('underConstruction', null, { reload: true });
                }
                else if (authentication.isLoggedIn()) {
                    // Check the current user's profile and determine where to reroute the user depending on their role(s).
                    return authentication.getUserRoles()
                        .then(function (response) {
                            if (response.vmisUserRoles !== null) {
                                for (var i = 0; i < response.vmisUserRoles.length; i++) {
                                    switch (response.vmisUserRoles[i]) {
                                        case 'AVC Volunteer':
                                            isVolunteer = true;
                                            break;
                                        case 'AVC OPOC':
                                            isOpoc = true;
                                            break;
                                        case 'AVC Coordinator':
                                            isAvcc = true;
                                            break;
                                        case 'AVC Program Manager':
                                            isProgramManager = true;
                                            break;
                                        case 'AFWP Administrator':
                                            isAfwpAdmin = true;
                                            break;
                                    }
                                }

                                if (isProgramManager || isAvcc || isOpoc || isVolunteer || isAfwpAdmin) {
                                    $state.go('vmis.dashboard', null, { reload: true });
                                } else {
                                    $state.go('vmis.volunteer.opportunities', null, { reload: true });
                                }
                            }
                        })
                        .catch(function (error) {
                            // Remove the current user's cookies and redirect them to the landing page.
                            console.log(error);
                            authentication.destroyToken();
                            $state.go('landing', null, { reload: true });
                        });
                }
                else {
                    // Redirect unauthenticated users to landing page.
                    $state.go('landing', null, { reload: true });
                }
            });
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.vmis')
        .controller('VmisController', VmisController);

    VmisController.$inject = ['$cookies', '$scope', '$state', '$modal', '$window', 'Idle', 'authentication', 'moment', 'config', 'loadStatus', 'lite'];

    function VmisController($cookies, $scope, $state, $modal, $window, Idle, authentication, moment,
                            config, loadStatus, lite) {
        var vm = this;

        vm.toggleLiteMode = toggleLiteMode;
        vm.vmisLiteText = lite.isLiteMode() ? "Switch to standard VMIS" : "Try VMIS Lite";

        vm.websiteFamilyList = null;
        vm.reportsUrl = null;
        vm.faqUrl = null;
        vm.contactHelpDeskUrl = "https://contact.armyfamilywebportal.com";

        vm.footerMessage = null;
        vm.showMyLiveChat = null;

        vm.showMenu = false;
        vm.colors = [{ name: "Red", id: 1 }, { name: "Green", id: 2 }, { name: "Blue", id: 3 }];

        vm.navClosed = false;

        vm.isLoggedIn = null;
        vm.lastLoginDate = null;

        vm.isRole = {
            volunteer: false,
            opoc: false,
            coorAssistant: false,
            coordinator: false,
            regionManager: false,
            programManager: false,
            afwpAdmin: false
        };

        vm.loadStatus = loadStatus.init();

        $scope.notificationObject = {
            notifications: 0,
            unreadNotifications: 0,
            totalUnreadNotifications: 0,
            setNotifications: function (inNotifications, unreadCount) {
                $scope.notificationObject.notifications = inNotifications;
                if (unreadCount !== null && unreadCount !== undefined)
                    $scope.notificationObject.updateUnreadNotificationsCount(unreadCount);
                else
                    $scope.notificationObject.updateUnreadNotificationsCount(
                        $scope.notificationObject.notifications.reduce(function (count, notif) {
                            if (!notif.read)
                                count++;
                            return count;
                        }, 0)
                    );
            },
            updateUnreadNotificationsCount: function (numUnread) {
                $scope.notificationObject.totalUnreadNotifications = numUnread;
                if (numUnread > 99)
                    $scope.notificationObject.unreadNotifications = "99+";
                else
                    $scope.notificationObject.unreadNotifications = numUnread;
            }
        };

        vm.logIn = logIn;
        vm.onClickLogOut = onClickLogOut;
        vm.onClickViewProfile = onClickViewProfile;
        vm.onClickViewAccountSettings = onClickViewAccountSettings;
        vm.goHome = goHome;
        vm.hasAdditionalRole = hasAdditionalRole;
        vm.redirectToDashboard = redirectToDashboard;
        vm.openAboutModal = openAboutModal;
        vm.toggleNav = toggleNav;

        $scope.$on('IdleStart', function () {
            // the user appears to have gone idle
            return $modal.open({
                templateUrl: 'app/components/idle/idle.view.html',
                controller: 'IdleController',
                controllerAs: 'vm',
                size: 'tiny',
                closeOnClick: false,
                backdrop: 'static',
                keyboard: false
            }).result.then(function () {
                Idle.watch();
                $cookies.remove('logged-out-reason');
            });
        });

        $scope.$on('IdleTimeout', function () {
            // the user has timed out (meaning idleDuration + timeout has passed without any activity)
            // this is where you'd log them
            config.get().then(function (configData) {
                $cookies.put('logged-out-reason', configData.loggedOutReasons.idle);
                logOutOfAppOnly();
                $state.go('vmis.loggedOut', null, { reload: true });
            });
        });

        $scope.$on('Keepalive', function () {
            // do something to keep the user's session alive
            authentication.keepAlive().catch(function (err) {
                console.error(err);
                return config.get().then(function (configData) {
                    $cookies.put('logged-out-reason', configData.loggedOutReasons.ticketError);
                    logOut();
                });
            });
        });

        $scope.$on('profile:update', function () {
            // Update the name and side nav options
            getProfile();
        });

        // Close the drop down menu if the user clicks outside of it
        window.onclick = function (event) {
            if (!$(event.target).hasClass("header-icon-menu")) {
                vm.showMenu = false;
                $scope.$apply();
            }
        };

        activate();

        function activate() {
            config.get().then(function (configData) {
                vm.websiteFamilyList = configData.afwpWebsiteFamilyList;
                vm.reportsUrl = configData.reportsUrl;
                vm.faqUrl = configData.faqUrl;
                vm.footerMessage = configData.footerMessage || "";
                vm.showMyLiveChat = !configData.isUatWebsite;

                let options = vm.websiteFamilyList
                    .filter(e => e.name === 'AFWP Resource Center')
                    .map(e => e.url);

                // If not logged in, do not ping API without ticket/token and cause an error
                if (configData.siteUnderConstruction) {
                    $state.go('underConstruction', null);
                }
                // If "/about", open About modal on blank page that can't be closed.
                else if ($state.current.name === 'about') {
                    openAboutModal(true);
                }
                else if (authentication.isLoggedIn() && $state.current.name !== 'vmis.loggedOut') {
                    loadStatus.setup(vm.loadStatus, "notifications")
                        .then(function () {
                            getProfile().then(loadNotifications).catch(function (error) {
                                console.log(error);
                                authentication.destroyToken();
                                vm.isLoggedIn = false;
                            });
                        });
                    getLastLoginDate().catch(function (error) {
                        console.log(error);
                    });
                }
                else {
                    vm.isLoggedIn = false;

                    if ($state.current.name !== 'vmis.logIn' &&
                        $state.current.name !== 'vmis.register' &&
                        $state.current.name !== 'vmis.claimUser' &&
                        $state.current.name !== 'vmis.migrateUser' &&
                        $state.current.name !== 'vmis.volunteer.avccLocator' &&
                        $state.current.name !== 'vmis.loggedOut') {
                        $state.go('vmis.volunteer.opportunities', null);
                    }
                }
            });
        }

        function getLastLoginDate() {
            return authentication.getLastLoginDate()
                .then(function (response) {
                    if (response.lastLoginDate == null){
                        vm.lastLoginDate = null;
                    } else {
                        vm.lastLoginDate = moment(response.lastLoginDate).local().format('MM-DD-YYYY, h:mm A');
                    }
                }).catch(function (err) {
                    throw(err);
                })
        }

        function getProfile() {
            return authentication.getUserProfile().then(function (response) {
                vm.isLoggedIn = true;
                vm.firstName = response.aosUser.firstName;

                //need to concat name display otherwise name scrolls across the top of the time
                if (angular.isDefined(vm.firstName) && vm.firstName !== null) {
                    if (vm.firstName.length > 30) {
                        vm.firstName = vm.firstName.substring(0, 30);
                        vm.firstName = vm.firstName + "...";
                    }
                }

                var vmisRoles = response.roles.vmisUserRoles;
                if (vmisRoles !== null) {
                    // Clear roles for if refreshing from updated profile
                    vm.isRole = {
                        volunteer: false,
                        opoc: false,
                        coorAssistant: false,
                        coordinator: false,
                        regionManager: false,
                        programManager: false,
                        afwpAdmin: false
                    };

                    for (var i = 0; i < vmisRoles.length; i++) {
                        switch (vmisRoles[i]) {
                            case 'AVC Volunteer':
                                vm.isRole.volunteer = true;
                                break;
                            case 'AVC OPOC':
                                vm.isRole.opoc = true;
                                break;
                            case 'AVC Coordinator Assistant':
                                vm.isRole.coorAssistant = true;
                                break;
                            case 'AVC Coordinator':
                                vm.isRole.coordinator = true;
                                break;
                            case 'AVC Region Manager':
                                vm.isRole.regionManager = true;
                                break;
                            case 'AVC Program Manager':
                                vm.isRole.programManager = true;
                                break;
                            case 'AFWP Administrator':
                                vm.isRole.afwpAdmin = true;
                                break;
                        }
                    }
                    if ($state.is('vmis')) {
                        if (hasAdditionalRole() || vm.isRole.volunteer) {
                            $state.go('.dashboard', null, { reload: true });
                        } else {
                            $state.go('.volunteer.opportunities');
                        }
                    }
                }
            });
        }

        function loadNotifications() {
            return authentication.getNotifications(0, vm.loadStatus.defaultNumRows)
                .then(function (response) {
                    // TODO: Update vm.loadStatus
                    $scope.notificationObject.setNotifications(response.notifications, response.unread);
                    return $scope.notificationObject.notifications;
                });
        }

        function onClickLogOut() {
            vm.isDropdownOpen = false;
            logOut();
        }

        function logOutOfAppOnly() {
            Idle.unwatch();
            authentication.logOutOfAppOnly().catch(function (err) {
                console.error(err);
                return config.get().then(function (configData) {
                    $cookies.put('logged-out-reason', configData.loggedOutReasons.idle);
                });
            });
        }

        function logOut() {
            Idle.unwatch();
            authentication.logOut().catch(function (err) {
                console.error(err);
                return config.get().then(function (configData) {
                    $cookies.put('logged-out-reason', configData.loggedOutReasons.ticketError);
                });
            });
        }

        function onClickViewProfile() {
            vm.isDropdownOpen = false;
            $state.go('vmis.profile');
        }

        function onClickViewAccountSettings() {
            vm.isDropdownOpen = false;
            // Open link in new tab
            config.get().then(function (configData) {
                $window.open(configData.accountSettingsUrl + "log-in", '_blank');
            });
        }

        function goHome() {
            if (vm.isLoggedIn) $state.go('vmis.dashboard');
        }

        function logIn() {
            $state.go('vmis.logIn');
        }

        function hasAdditionalRole() {
            return (vm.isRole.opoc || vm.isRole.coorAssistant ||
                vm.isRole.coordinator || vm.isRole.regionManager ||
                vm.isRole.programManager || vm.isRole.afwpAdmin);
        }

        function redirectToDashboard() {
            $state.go('vmis.dashboard', null);
        }

        function toggleLiteMode() {
            lite.setLiteMode(!lite.isLiteMode());
            $state.reload();
        }

        function openAboutModal(stayOpen) {
            var options = {
                templateUrl: "app/components/about/about.modal.view.html",
                controller: 'AboutModalController',
                controllerAs: 'aboutModal',
                backdrop: 'static',
                keyboard: false,
                resolve: {
                    // Tell modal to hide close buttons
                    stayOpen: function () {
                        return stayOpen;
                    }
                }
            };
            
            return $modal.open(options)
                .result.catch(function (error) {
                    if (error === 'cancel' || error === 'ok' || error === 'backdrop click')
                        return;
                    if (error)
                        console.error(error);
                });
        }

        /**
         * This function is accessible by a round blue button when the side nav is closed
         * and the last side nav entry when it is open.
         * The side nav entry only shows when on medium or small screens, and the side nav
         * always starts open. So this functionality isn't accessible on large screens.
         * (This can be changed! Just remove "hide-for-large" for that entry in vmis.view.html.) */
        function toggleNav() {
            vm.navClosed = !vm.navClosed;
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.vmis')
        .controller('VmisPrintController', VmisPrintController);

    VmisPrintController.$inject = ['$q', '$stateParams', 'opportunitiesService', 'authentication'];

    function VmisPrintController($q, $stateParams, opportunitiesService, authentication) {
        var vm = this;

        vm.opportunityId = $stateParams.id;
        activate();

        function activate() {
            getOpportunityDetails();
        }

        function getOpportunityDetails() {
            return $q.all({
                    details: opportunitiesService.getOpportunityDetails(vm.opportunityId),
                    opocs: authentication.getOpocsForOpportunity({volunteerOpportunityId: vm.opportunityId})
                })
                .then(function (results) {
                    vm.details = results.details;
                    vm.details.isBackgroundCheckRequired = vm.details.isBackgroundCheckRequired ? 'Yes' : 'No';
                    vm.details.supervisionConditionFlag = vm.details.supervisionConditionFlag ? 'Yes' : 'No';

                    vm.opocs = results.opocs.opocs;
                    vm.isVolunteerSubmitted = vm.details.volunteerOrganization === 'Volunteer Submitted';
                });

        }
    }
})();
/**
 * Created by kmorgan41 on 12/12/16.
 */
(function () {
    'use strict';

    angular
        .module('app')
        .controller('userController', userController);

    userController.$inject = ['authentication', '$scope'];

    function userController(authentication, $scope) {

        $scope.dropdownContents = [];

        $scope.loggedIn = authentication.isLoggedIn();

        if($scope.loggedIn) {
            authentication.getUserProfile()
                .then(function (response) {
                    $scope.firstName = response.aosUser.firstName;

                    $scope.userName = {
                        name: 'Username',
                        //value: 'some very very very long name'
                        value: $scope.firstName
                    };

                    $scope.logout = {
                        name: 'Logout',
                        value: 'Log Out'
                    };
                    $scope.dropdownContents.push($scope.userName, $scope.logout);
                    //console.log($scope.dropdownContents);

                    $scope.selectedItem = $scope.userName;

                    $scope.$watch("selectedItem", function (value) {
                        if ($scope.selectedItem.name == "Logout") {
                            //$scope.logout();
                            //console.log('log out');
                        }
                    });
                });
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.vmis')
        .controller('AboutModalController', AboutModalController);

    AboutModalController.$inject = ['$modalInstance', '$q', 'authentication', 'config', 'stayOpen'];

    function AboutModalController($modalInstance, $q, authentication, config, stayOpen) {
        var vm = this;
        vm.title = "About VMIS";

        vm.isLoading = true;

        vm.stayOpen = stayOpen;

        vm.vmisUi = {
            display: false,
            version: "-",
            date: "-",
            url: "",
            numericalVersion: "-"
        };
        vm.vmisApi = {
            version: "-",
            online: false
        };
        vm.coreApi = {
            version: "-",
            online: false
        };

        var promises = [];

        promises.push(config.get().then(function (configData) {
            vm.vmisUi = configData.build;
            vm.vmisUi.numericalVersion = APP_VERSION; // From app/common/version.js
        }));

        // Get VMIS and Core API versions through check_health

        promises.push(authentication.checkVmisApiHealth().then(function (healthData) {
            vm.vmisApi.version = healthData.apiVersion;
            vm.vmisApi.online = healthData.success;
        }));

        promises.push(authentication.checkCoreApiHealth().then(function (healthData) {
            vm.coreApi.version = healthData.apiVersion;
            vm.coreApi.online = healthData.success;
        }));

        $q.all(promises).catch(function (error) {
            console.error(error);
        }).finally(function () {
            vm.isLoading = false;
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('vmis.administrator', [
            'ui.router',
            'angularMoment',

            'administrator.hours'
        ]);
})();
(function () {
    'use strict';

    angular
        .module('vmis.administrator')
        .config(routes);

    routes.$inject = ['$stateProvider'];

    function routes($stateProvider) {
        $stateProvider
            .state('vmis.administrator', {
                url: '/administrator',
                abstract: true,
                template: '<div ui-view></div>'
            })
            .state('vmis.administrator.organizations', {
                url: '/organizations',
                templateUrl: 'app/components/administrator/organizations/organizations.view.html',
                controller: 'OrganizationsController',
                controllerAs: 'vm',
                title: 'Organizations'
            })
            .state('vmis.administrator.invitations', {
                url: '/invitations',
                templateUrl: 'app/components/administrator/invitations/invitations.view.html',
                controller: 'InvitationsController',
                controllerAs: 'vm',
                resolve: {
                    title: function () {
                        return 'Invitations';
                    }
                },
                title: "Invitations"
            })
            .state('vmis.administrator.positions', {
                url: '/positions',
                templateUrl: 'app/components/administrator/positions/positions.view.html',
                controller: 'PositionsController',
                controllerAs: 'vm',
                title: 'Positions'
            })
            .state('vmis.administrator.applications', {
                url: '/applications',
                templateUrl: 'app/components/administrator/applications/applications.view.html',
                controller: 'ApplicationsController',
                controllerAs: 'vm',
                title: 'Applications'
            })
            .state('vmis.administrator.applications.details', {
                url: '/details?applicationId&communityVolunteerOrganizationApplicationId',
                templateUrl: 'app/components/administrator/applications/applicationDetails.view.html',
                controller: 'ApplicationDetailsController',
                controllerAs: 'vm',
                params: {
                    nextState: {
                        name: '',
                        params: {},
                        options: {}
                    }
                }
            });
    }
})();
(function () {
    'use strict';

    angular
        .module('vmis.administrator')
        .controller('ApplicationsController', ApplicationsController);

    ApplicationsController.$inject = ['$modal', '$scope', '$q', '$timeout', '_', 'authentication', 'utilsServices', 'loadStatus'];

    function ApplicationsController($modal, $scope, $q, $timeout, _, authentication, utilsServices, loadStatus) {
        var vm = this;

        vm.isLoading = true;
        vm.applications = [];
        vm.alerts = [];

        vm.sortReverse = true;
        vm.sortColumn = 'submittedDate';
        vm.statusTypes = [
            {
                status: "All",
                value: ""
            },
            {
                status: "Submitted",
                value: "Submitted"
            },
            {
                status: "Approved",
                value: "Approved"
            },
            {
                status: "Declined",
                value: "Declined"
            }
        ];

        vm.positionTitles = [
            {
                title: "All",
                value: ""
            }
        ];

        var uniqueTitles = []; // Track unique positions for filtering

        vm.filter = {
            selectedCommunity: {},
            selectedOrganization: {},
            volunteerOpportunity: vm.positionTitles[0].value,
            communityVolunteeringApplication: vm.positionTitles[0].commId,
            volunteerApplicationStatus: vm.statusTypes[1].value,
            firstName: null,
            lastName: null
        };

        vm.communities = [];

        vm.loadStatus = loadStatus.init();

        vm.getApplications = getApplications;
        vm.onClickApplication = onClickApplication;
        vm.onClickSearch = onClickSearch;
        vm.onLoadMore = onLoadMore;
        vm.onLoadAll = onLoadAll;
        vm.disableOrgDropDown = disableOrgDropDown;
        vm.onSelectCommunity = onSelectCommunity;
        vm.onSelectOrganization = onSelectOrganization;
        $scope.$on('applications:alert', alertHandler);
        vm.onCloseAlert = onCloseAlert;


        activate();

        function activate() {
            loadStatus.setup(vm.loadStatus, "applications")
                .then(function () {
                    getCommunities(); // Calls getApplications()
                });
        }

        function getApplications(index, num) {
            vm.isLoading = true;

            var params = {
                startingRowIndex: index,
                numberOfRows: num,
                volunteerApplicationStatus: vm.filter.volunteerApplicationStatus ? vm.filter.volunteerApplicationStatus : undefined,
                volunteerOpportunityId: vm.filter.volunteerOpportunity ? (vm.filter.volunteerOpportunity.opportunityId ? vm.filter.volunteerOpportunity.opportunityId : undefined) : undefined,
                communityVolunteerOrganizationApplicationId: vm.filter.volunteerOpportunity ? (vm.filter.volunteerOpportunity.commId ? vm.filter.volunteerOpportunity.commId : undefined) : undefined,
                communityAffiliationId: (vm.filter.selectedCommunity.id !== -1) ? vm.filter.selectedCommunity.id : undefined,
                volunteerOrganizationId: (vm.filter.selectedOrganization.id !== -1) ? vm.filter.selectedOrganization.id : undefined,
                firstName: vm.filter.firstName ? vm.filter.firstName : undefined,
                lastName: vm.filter.lastName ? vm.filter.lastName : undefined
            };

            return authentication.getApplicationsAdmin(params)
                .then(function (response) {
                    return getApplicationsSuccess(response, index, num);
                }).catch(function (error) {
                    getApplicationsError(error);
                });

            function getApplicationsSuccess(response, index, num) {
                // Create "masterUserFullName" field for filtering
                function processApplications(applications) {
                    applications.forEach(function (application) {
                        if (angular.isUndefined(application.submittedDate)) {
                            application.submittedDate = application.createdDate;
                        }
                        //application.masterUserFullName = application.firstName + " " + application.lastName;

                        // Get unique titles for drop down
                        if (uniqueTitles.indexOf(application.volunteerOpportunity) === -1) {
                            uniqueTitles.push(application.volunteerOpportunity);
                            vm.positionTitles.push({
                                title: application.volunteerOpportunity,
                                value: { opportunityId: application.volunteerOrganizationOpportunityId, commId: application.communityVolunteerOrganizationApplicationId }

                            });
                        }
                    });
                }

                if (index === 0) {
                    vm.loadStatus.currentIndex = 0;
                    vm.applications = [];
                }

                // Either set current index to max if all users loaded or increment by rows loaded
                vm.loadStatus.currentIndex = (vm.loadStatus.currentIndex + num > response.count) ? response.count : (vm.loadStatus.currentIndex + num);
                // Track total number of users not loaded for "Load All" button
                vm.loadStatus.numResultsNotLoaded = response.count - vm.loadStatus.currentIndex;
                // Set text for "Load More" button
                vm.loadStatus.nextResultLoadNum = (response.count === vm.loadStatus.currentIndex) ? 0 :
                    (vm.loadStatus.numResultsNotLoaded > num) ? num : vm.loadStatus.numResultsNotLoaded;

                // Only operate on new applications
                response.applications.forEach(function (application) {
                    if (angular.isDefined(application.volunteerOrganizationOpportunityId)) {
                        application.volunteerOrganization = application.orgActive ?
                            application.volunteerOrganization : application.volunteerOrganization + " (inactive)";
                    }
                });

                vm.applications = vm.applications.concat(response.applications);
                processApplications(vm.applications); // TODO: Should only operate on new applications?

                $timeout(function () {
                    vm.isLoading = false;
                }, 100);

                return vm.applications;
            }

            function getApplicationsError(error) {
                if (angular.isDefined(error)) {
                    var errorStr = error.error ? error.error : error;
                    displayError(errorStr);
                }
                else
                    displayError("Failed to load list! Please try again");

                $timeout(function () {
                    vm.isLoading = false;
                }, 100);
            }
        }

        function getCommunities() {
            return authentication.getUserProfile().then(function (response) {
                return utilsServices.combineCommunityResponsibilities(response, ['AVC OPOC', 'AVC Coordinator']);
            }).then(function (communities) {
                if (_.isArray(communities) && communities.length !== 1) {
                    communities.unshift({
                        name: "All",
                        organizations: []
                    });
                }
                _.forEach(communities, function (community) {
                    if (_.isArray(community.organizations) && community.organizations.length !== 1) {
                        community.organizations.unshift({
                            name: 'All'
                        });
                    }
                });
                vm.communities = communities;
                vm.filter.selectedCommunity = vm.communities[0];

                return onSelectCommunity();
            }).catch(displayError);
        }

        function onClickApplication(application) {
            var options = {
                templateUrl: 'app/components/administrator/applications/applicationDetails.view.html',
                controller: 'ApplicationDetailsController',
                controllerAs: 'vm',
                backdrop: 'static',
                keyboard: false,
                resolve: {
                    params: function () {
                        if (application.volunteerApplicationId) {
                            return {
                                title: 'Application Details',
                                volunteerApplicationId: application.volunteerApplicationId,
                                status: application.volunteerApplications
                            };
                        }
                        else {
                            return {
                                title: 'Application Details',
                                communityVolunteerOrganizationApplicationId: application.communityVolunteerOrganizationApplicationId,
                                status: application.volunteerApplications
                            };
                        }
                    }
                }
            };

            $modal.open(options).result.then(function (result) {
                if (angular.isDefined(result) && result.error !== "") {
                    displayError(result.error);
                }
                vm.loadStatus.currentIndex = 0;
                getApplications(vm.loadStatus.currentIndex, vm.loadStatus.defaultNumRows);
            });
        }

        function disableOrgDropDown() {
            return vm.isLoading || (vm.filter.selectedCommunity.id === -1);
        }

        function onSelectCommunity() {
            // Should only occur if program manager or AVCC/Assistant,
            // since loading all orgs on People page takes too long for PM
            // and AVCC/Assistant responsibilities are on community level.
            var promise = vm.filter.selectedCommunity.organizations === null ? fillCommOrgs() : $q.when();
            return promise.then(function () {
                vm.loadStatus.currentIndex = 0;
                vm.filter.selectedOrganization = vm.filter.selectedCommunity.organizations[0];
                return getApplications(vm.loadStatus.currentIndex, vm.loadStatus.defaultNumRows);
            });
        }

        function fillCommOrgs() {
            return authentication.getOrganizations({
                communityAffiliationId: vm.filter.selectedCommunity.id,
                getAll: true
            }).then(function (response) {
                var organizations = _.map(response.organizations, function (organization) {
                    return {
                        id: organization.volunteerOrganizationId,
                        name: organization.organizationName
                    };
                });
                if (_.isArray(organizations) && organizations.length !== 1) {
                    organizations.unshift({
                        name: "All"
                    });
                }
                vm.filter.selectedCommunity.organizations = organizations;
            }).catch(function (error) {
                $scope.$emit('people:alert', error);
                vm.isLoading = false;
            });
        }

        function onSelectOrganization() {
            vm.loadStatus.currentIndex = 0;
            return getApplications(vm.loadStatus.currentIndex, vm.loadStatus.defaultNumRows);
        }

        function onClickSearch() {
            return getApplications(0, vm.loadStatus.defaultNumRows);
        }

        function alertHandler(event, message) {
            event.stopPropagation();

            displayError(message);
        }

        function onCloseAlert(index) {
            vm.alerts.splice(index, 1);
        }

        function displayAlert(type, message) {
            vm.alerts.push({
                type: type,
                message: message
            });
        }

        function displayError(error) {
            if (error === 'cancel' || error === 'backdrop click')
                return;
            if (error)
                displayAlert('alert', error);
        }

        function onLoadMore() {
            getApplications(vm.loadStatus.currentIndex, vm.loadStatus.nextResultLoadNum);
        }

        function onLoadAll() {
            getApplications(vm.loadStatus.currentIndex, vm.loadStatus.numResultsNotLoaded);
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('vmis.administrator')
        .controller('ApproveConfirmationController', ApproveConfirmationController);

    ApproveConfirmationController.$inject = ['$modalInstance', 'firstName', 'lastName', 'positionTitle'];

    function ApproveConfirmationController($modalInstance, firstName, lastName, positionTitle) {
        var vm = this;

        vm.firstName = firstName;
        vm.lastName = lastName;
        vm.positionTitle = positionTitle;

        vm.onApprove = onApprove;
        vm.onCancel = onCancel;

        activate();

        function activate() {
        }

        function onApprove() {
            $modalInstance.close();
        }

        function onCancel() {
            $modalInstance.dismiss();
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('vmis.administrator')
        .controller('RejectConfirmationController', RejectConfirmationController);

    RejectConfirmationController.$inject = ['firstName', 'lastName', 'positionTitle'];

    function RejectConfirmationController(firstName, lastName, positionTitle) {
        var vm = this;

        vm.firstName = firstName;
        vm.lastName = lastName;
        vm.positionTitle = positionTitle;
    }
})();
(function () {
    'use strict';

    angular
        .module('vmis.administrator')
        .controller('DeleteConfirmationController', DeleteConfirmationController);

    DeleteConfirmationController.$inject = ['$modalInstance', 'firstName', 'lastName', 'positionTitle'];

    function DeleteConfirmationController($modalInstance, firstName, lastName, positionTitle) {
        var vm = this;

        vm.firstName = firstName;
        vm.lastName = lastName;
        vm.positionTitle = positionTitle;

        vm.onDelete = onDelete;
        vm.onCancel = onCancel;

        activate();

        function activate() {
        }

        function onDelete() {
            $modalInstance.close();
        }

        function onCancel() {
            $modalInstance.dismiss();
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('vmis.administrator')
        .controller('ApplicationDetailsController', ApplicationDetailsController);

    ApplicationDetailsController.$inject = ['params', '$q', '$modal', '$modalInstance', 'authentication'];

    function ApplicationDetailsController(params, $q, $modal, $modalInstance, authentication) {
        var vm = this;
        vm.isLoading = true;
        vm.title = params.title;
        vm.canReject = false;
        vm.canDelete = false;
        vm.applicationId = params.volunteerApplicationId;
        vm.isOrgActive = true;

        vm.onSetStatus = onSetStatus;

        activate();

        function activate() {
            getApplicationDetails(params);
        }

        function finishedLoading(){
            vm.isLoading = false;
        }

        function getApplicationDetails(params) {
            if (!angular.isUndefined(params.volunteerApplicationId)) {
                return authentication.getApplicationDetails(params)
                    .then(function (response) {
                        vm.application = response.application;
                        return $q.all({
                            positionDetails: getPositionDetails(vm.application.volunteerOrganizationOpportunityId),
                            userProfile: getProfile(vm.application.masterUserId),
                            opportunityHours: getHoursAdmin(vm.application.volunteerOrganizationOpportunityId),
                            applicationHours: getHoursUserAdmin(vm.application.volunteerOrganizationOpportunityId, vm.application.masterUserId),
                        });
                    })
                    .then(function (result) {
                        vm.position = result.positionDetails;
                        vm.isOrgActive = vm.position.organization.isActive ? true:false;
                        vm.position.isBackgroundCheckRequired = vm.position.isBackgroundCheckRequired ? 'Yes' : 'No';
                        vm.position.volunteerOrganization = vm.position.organization.isActive ? vm.position.organization.volunteerOrganizationFullName : vm.position.organization.volunteerOrganizationFullName+ " (inactive)";
                        vm.profile = result.userProfile;

                        if (result.opportunityHours.count <= 0) {
                            vm.canReject = true;
                        }

                        vm.canDelete = true;
                        for (var i = 0; i < result.applicationHours.hours.length; i++) {
                            if(result.applicationHours.hours[i].applicationId === params.applicationId){
                                vm.canDelete = false;
                                break;
                            }
                        }
                        // result.applicationHours.hours.forEach(function(hour){
                        //     if(hour.applicationId === params.applicationId){
                        //         vm.canDelete = false;
                        //     }
                        // });

                        vm.showRank = vm.profile.aosUser.dispositions.some(function (disposition) {
                            return disposition === 'Service Member';
                        });
                        vm.showCivilianRank = vm.profile.aosUser.dispositions.some(function (disposition) {
                            return disposition === 'DoD Civilian';
                        });
                        vm.isVolunteerSubmitted = vm.position.volunteerOrganization === 'Volunteer Submitted';
                        vm.position.supervisionConditionFlag = vm.position.supervisionConditionFlag ? 'Yes' : 'No';
                        finishedLoading();
                    });

            }
            else {
                return authentication.getCommunityApplicationDetails(params)
                    .then(function (response) {
                        vm.application = response.application;
                        vm.position = response.application;
                        vm.position.volunteerOrganization = vm.position.commArchived ? 'Volunteer Submitted (inactive)' : 'Volunteer Submitted';
                        vm.isOrgActive = vm.position.commArchived ? false:true;
                        vm.position.isBackgroundCheckRequired = vm.position.isBackgroundCheckRequired ? 'Yes' : 'No';

                        return $q.all({
                            userProfile: getProfile(vm.application.masterUserId),
                            opportunityHours: getHoursAdmin(params.volunteerOrganizationOpportunityId)
                        });
                    })
                    .then(function (result) {
                        vm.profile = result.userProfile;
                        if (result.opportunityHours.count <= 0) {
                            vm.canReject = true;
                        }
                        vm.showRank = vm.profile.aosUser.dispositions.some(function (disposition) {
                            return disposition === 'Service Member';
                        });
                        vm.showCivilianRank = vm.profile.aosUser.dispositions.some(function (disposition) {
                            return disposition === 'DoD Civilian';
                        });
                        vm.isVolunteerSubmitted = true;
                        vm.position.supervisionConditionFlag = vm.position.supervisionConditionFlag ? 'Yes' : 'No';
                        finishedLoading();
                    });
            }
        }

        function getPositionDetails(positionId) {
            return authentication.getOpportunityDetails({
                volunteerOpportunityId: positionId
            })
                .then(function (response) {
                    return response;
                });
        }

        function getProfile(userId) {
            return authentication.getUserProfile({
                masterUserId: userId
            })
                .then(function (response) {
                    return response;
                });
        }

        function getHoursAdmin(opportunityId) {
            var startDate = new Date(0);
            var endDate = new Date();
            return authentication.getHoursAdmin({
                startDate: startDate,
                endDate: endDate,
                volunteerOpportunityId: opportunityId,
                startingRowIndex: 0,
                numberOfRows: 1
            })
                .then(function (response) {
                    return response;
                });
        }

        function getHoursUserAdmin(opportunityId,masterUserId) {
            var startDate = new Date(0);
            var endDate = new Date();
            return authentication.getHoursAdmin({
                volunteerOpportunityId: opportunityId,
                masterUserId: masterUserId
            })
                .then(function (response) {
                    return response;
                });
        }

        function onSetStatus(status) {
            var templateUrl, controller;
            switch (status) {
                case 'Approved':
                    templateUrl = 'app/components/administrator/applications/approveConfirmation.template.html';
                    controller = 'ApproveConfirmationController';
                    break;
                case 'Declined':
                    templateUrl = 'app/components/administrator/applications/rejectConfirmation.template.html';
                    controller = 'RejectConfirmationController';
                    break;
                case 'Delete':
                    templateUrl = 'app/components/administrator/applications/deleteConfirmation.template.html';
                    controller = 'DeleteConfirmationController';
                    break;
                default:
                    return;
            }
            var modalSize = 'notTiny';
            if (controller === 'ApproveConfirmationController') {
                modalSize = 'tiny';
            }

            var modalInstance = $modal.open({
                templateUrl: templateUrl,
                controller: controller,
                controllerAs: 'vm',
                backdrop: 'static',
                keyboard: false,
                resolve: {
                    firstName: function () {
                        return vm.profile.aosUser.firstName;
                    },
                    lastName: function () {
                        return vm.profile.aosUser.lastName;
                    },
                    positionTitle: function () {
                        return vm.position.title;
                    }
                },
                size: modalSize
            });

            modalInstance.result
                .then(function (reason) {
                    var params;
                    if(status == 'Delete'){
                        params = {
                          role: "admin",
                        };
                        if (vm.application.volunteerOrganizationOpportunityId) {
                            params.volunteerApplicationId = vm.applicationId;
                        } else if (vm.position.communityVolunteerOrganizationApplicationId) {
                            params.communityVolunteerOrganizationApplicationId = vm.position.communityVolunteerOrganizationApplicationId;
                        }
                        return authentication.deleteApplication(params)
                            .then($modalInstance.close);
                    }
                    else {
                        params = {
                            userId: vm.profile.masterUserId,
                            volunteerApplicationStatus: status
                        };

                        if (vm.application.volunteerOrganizationOpportunityId) {
                            params.opportunityId = vm.application.volunteerOrganizationOpportunityId;
                            params.volunteerApplicationId = vm.applicationId;
                        } else if (vm.position.communityVolunteerOrganizationApplicationId) {
                            params.communityVolunteerOrganizationApplicationId = vm.position.communityVolunteerOrganizationApplicationId;
                        }

                        if (angular.isDefined(reason)) {
                            params.statusReason = reason;
                        }

                        return authentication.setOpportunityStatusForUser(params)
                                .then($modalInstance.close);
                    }
                }, function () {
                })
                .catch(function(error){
                    $modalInstance.close({
                        error: error
                    });
                });
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('vmis.administrator')
        .controller('NameFilterController', NameFilterController);

    NameFilterController.$inject = ['$modalInstance', 'params'];

    function NameFilterController($modalInstance, params) {
        var vm = this;

        vm.isLoading = true;

        vm.filter = {};
        vm.filter.firstName = params.firstName || null;
        vm.filter.lastName = params.lastName || null;

        vm.onFilter = onFilter;

        activate();

        function activate() {
            vm.isLoading = false;
        }

        function onFilter() {
            vm.isLoading = true;
            var outputFilter = angular.copy(vm.filter);
            close('success', "Filter successfully created!", outputFilter);
        }

        function close(action, msg, filter) {
            $modalInstance.close({
                action: action,
                message: msg,
                filter: filter || null
            });
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('administrator.hours', [
            'ui.router',
            'angularMoment',
            
            'app.auth'
        ]);
})();
(function () {
    'use strict';

    angular
        .module('administrator.hours')
        .config(routes);

    routes.$inject = ['$stateProvider'];

    function routes($stateProvider) {
        $stateProvider
            .state('vmis.administrator.hours', {
                url: '/hours',
                templateUrl: 'app/components/administrator/hours/hours.view.html',
                controller: 'HoursController',
                controllerAs: 'vm',
                title: 'Hours'
            });
    }
})();
(function () {
    'use strict';

    angular
        .module('administrator.hours')
        .controller('HoursController', HoursController);

    HoursController.$inject = ['$q', '$modal', '$scope', 'moment', 'authentication', 'utilsServices', 'loadStatus', '_'];

    function HoursController($q, $modal, $scope, moment, authentication, utilsServices, loadStatus, _) {
        var vm = this;

        vm.isLoading = true;

        vm.formError = "";

        vm.statusTypes = [
            'All',
            'Submitted',
            'Certified',
            'Rejected',
            'Deleted'
        ];
        vm.activities = [];
        vm.loadStatus = loadStatus.init();

        vm.communities = [];
        vm.currentDate = new Date();
        vm.filter = {
            endDate: moment().toDate(),
            startDate: moment().date() < 15 ?
                moment().subtract(1, 'months').startOf('month').toDate() :
                moment().startOf('month').toDate(),
            status: 'Submitted',
            firstName: "",
            lastName: "",
            selectedCommunity: null,
            selectedOrganization: null
        };
        vm.sortReverse = true;
        vm.sortColumn = 'date';

        vm.disableOrgDropDown = disableOrgDropDown;
        vm.onSelectCommunity = onSelectCommunity;
        vm.onSelectOrganization = onSelectOrganization;
        vm.onActivityClick = onActivityClick;
        vm.onStatusChange = onStatusChange;
        vm.onChangeDates = onChangeDates;
        vm.onCheckAll = onCheckAll;
        vm.onCheckActivity = onCheckActivity;
        vm.onClickBatch = onClickBatch;
        vm.onLoadMore = onLoadMore;
        vm.onLoadAll = onLoadAll;
        vm.onClickSearch = onClickSearch;

        activate();

        function activate() {
            loadStatus.setup(vm.loadStatus, "hours")
                .then(function () {
                    getCommunities(); // Calls getActivities()
                });
        }

        function getCommunities() {
            return authentication.getUserProfile().then(function (response) {
                // Set up communities and organizations that the
                // active user is responsible for for the drop downs
                return utilsServices.combineCommunityResponsibilities(response);
            }).then(function (communities) {
                if (_.isArray(communities) && communities.length !== 1) {
                    communities.unshift({
                        name: 'All',
                        organizations: []
                    });
                }
                _.forEach(communities, function (community) {
                    if (_.isArray(community.organizations) && community.organizations.length !== 1) {
                        community.organizations.unshift({
                            name: 'All'
                        });
                    }
                });
                vm.communities = communities;
                // Use lack of ID as cue for this entry
                vm.filter.selectedCommunity = vm.communities[0];
                return onSelectCommunity();
            }).catch(displayError);
        }

        function getActivities(index, num) {
            vm.isLoading = true;

            var params = {
                startingRowIndex: index,
                numberOfRows: num,
                // If input box has invalid date format and a drop down is changed,
                // the date here will be undefined
                startDate: vm.filter.startDate ? new Date(vm.filter.startDate).toISOString() : undefined,
                endDate: vm.filter.endDate ? new Date(vm.filter.endDate).toISOString() : undefined,
                volunteerHoursStatus: vm.filter.status !== "All" ? vm.filter.status : undefined,
                communityAffiliationId: vm.filter.selectedCommunity.id || undefined,
                volunteerOrganizationId: vm.filter.selectedOrganization.id || undefined,
                firstName: vm.filter.firstName || undefined,
                lastName: vm.filter.lastName || undefined
            };

            return authentication.getHoursAdmin(params)
                .then(function (response) {
                    getActivitiesSuccess(response, index, num);
                }).catch(displayError).finally(function (err) {
                    vm.isLoading = false;
                    getActivitiesError(err);
                });
        }

        function onClickSearch () {
            vm.loadStatus.currentIndex = 0;
            getActivities(vm.loadStatus.currentIndex, vm.loadStatus.defaultNumRows);
        }

        function fillCommOrgs() {
            return authentication.getOrganizations({
                communityAffiliationId: vm.filter.selectedCommunity.id,
                getAll: true
            }).then(function (response) {
                var organizations = _.map(response.organizations, function (organization) {
                    return {
                        id: organization.volunteerOrganizationId,
                        name: organization.organizationName
                    };
                });
                if (_.isArray(organizations) && organizations.length !== 1) {
                    organizations.unshift({
                        name: "All"
                    });
                }
                vm.filter.selectedCommunity.organizations = organizations;
            }).catch(function (error) {
                $scope.$emit('people:alert', error);
                vm.isLoading = false;
            });
        }

        function disableOrgDropDown() {
            return vm.isLoading || !angular.isDefined(vm.filter.selectedCommunity.id);
        }

        function onSelectCommunity() {
            var promise = vm.filter.selectedCommunity.organizations === null ? fillCommOrgs() : $q.when();
            return promise
                .then(function () {
                    vm.loadStatus.currentIndex = 0;
                    vm.filter.selectedOrganization = vm.filter.selectedCommunity.organizations[0];
                    return getActivities(vm.loadStatus.currentIndex, vm.loadStatus.defaultNumRows);
                });
        }

        function onSelectOrganization() {
            vm.loadStatus.currentIndex = 0;
            // This function is called on community change, which is unnecessary
            if (!vm.isLoading)
                getActivities(vm.loadStatus.currentIndex, vm.loadStatus.defaultNumRows);
        }

        function onActivityClick(activity) {
            var modalInstance = $modal.open({
                templateUrl: 'app/components/administrator/hours/manageActivity.view.html',
                controller: 'ManageActivityController',
                controllerAs: 'vm',
                backdrop: 'static',
                keyboard: false,
                resolve: {
                    activity: function () {
                        return angular.copy(activity);
                    },
                    rejectOnly: function () {
                        return false;
                    }
                }
            });

            modalInstance.result
                .then(function () {
                    vm.loadStatus.currentIndex = 0;
                    return getActivities(vm.loadStatus.currentIndex, vm.loadStatus.defaultNumRows);
                }).catch(displayError);
        }

        function onStatusChange() {
            vm.loadStatus.currentIndex = 0;
            getActivities(vm.loadStatus.currentIndex, vm.loadStatus.defaultNumRows);
        }

        function onChangeDates(startDate, endDate) {
            if (angular.isDefined(startDate) && angular.isDefined(endDate)) {
                vm.loadStatus.currentIndex = 0;
                getActivities(vm.loadStatus.currentIndex, vm.loadStatus.defaultNumRows);
            }
        }

        function onCheckAll() {
            vm.activities.forEach(function (activity) {
                activity.isChecked = activity.status !== 'Deleted' ? vm.checkAll : false;
            });
            vm.activityChecked = vm.checkAll;
        }

        function onCheckActivity() {
            vm.activityChecked = vm.activities.some(function (activity) {
                return activity.isChecked;
            });

            var activities = _.filter(vm.activities, function (activity) {
                return activity.status !== 'Deleted';
            });
            vm.checkAll = activities.length ? _.every(activities, function (activity) {
                return activity.isChecked;
            }) : false;
        }

        function onClickBatch(status) {
            $modal.open({
                templateUrl: 'app/components/administrator/hours/batchConfirmation.view.html',
                controller: 'BatchConfirmationController',
                controllerAs: 'vm',
                backdrop: 'static',
                keyboard: false,
                resolve: {
                    status: function () {
                        return status;
                    }
                }
            }).result
                .then(function (reviewerNote) {
                    switch (status) {
                        case 'Certify':
                            status = 'Certified';
                            break;
                        case 'Reject':
                            status = 'Rejected';
                            break;
                    }
                    var params = {
                        volunteerHoursStatus: status,
                        hoursIds: vm.activities.filter(function (activity) {
                            return activity.isChecked;
                        }).map(function (activity) {
                            return activity.id;
                        }),
                        reviewerNotes: reviewerNote || ''
                    };

                    return authentication.manageVolunteerHours(params);
                })
                .then(function () {
                    vm.loadStatus.currentIndex = 0;
                    return getActivities(vm.loadStatus.currentIndex, vm.loadStatus.defaultNumRows);
                }).catch(function (error) {
                    displayError(error);
                });
        }

        function displayError(error) {
            if (_.isUndefined(error)) return;
            var errorStr = utilsServices.parseErrorString(error);

            vm.isLoading = false;

            if (errorStr === 'cancel' || errorStr === 'backdrop click' || errorStr === 'ok')
                return;
            if (errorStr)
                vm.formError = errorStr;
        }

        function getActivitiesSuccess(response, index, num) {
            if (index === 0) {
                vm.loadStatus.currentIndex = 0;
                vm.activities = [];
            }
            // Either set current index to max if all users loaded or increment by rows loaded
            vm.loadStatus.currentIndex = (vm.loadStatus.currentIndex + num > response.count) ? response.count : (vm.loadStatus.currentIndex + num);
            // Track total number of users not loaded for "Load All" button
            vm.loadStatus.numResultsNotLoaded = response.count - vm.loadStatus.currentIndex;
            // Set text for "Load More" button
            vm.loadStatus.nextResultLoadNum = (response.count === vm.loadStatus.currentIndex) ? 0 :
                (vm.loadStatus.numResultsNotLoaded > num) ? num : vm.loadStatus.numResultsNotLoaded;

            vm.activities = vm.activities.concat(_.map(response.hours, function (activity) {
                return {
                    id: activity.volunteerHoursId,
                    position: {
                        id: null,
                        title: activity.volunteerOpportunity
                    },
                    organization: activity.orgActive ? activity.volunteerOrganization : activity.volunteerOrganization + " (inactive)",
                    community: activity.communityAffiliation,
                    volunteer: {
                        firstName: activity.firstName,
                        lastName: activity.lastName
                    },
                    documents: activity.documents,
                    hours: activity.hours,
                    status: activity.volunteerHoursStatus,
                    type: activity.dayOfService ? 'Daily' : 'Period',
                    date: activity.dayOfService || activity.periodOfService,
                    volunteerNote: activity.userNotes || '',
                    reviewerNote: activity.reviewerNotes || ''
                };
            }));

            onCheckActivity();
            vm.sortReverse = true;
            vm.sortColumn = 'date';
        }

        function getActivitiesError(error) {
            if (angular.isDefined(error)) {
                var errorStr = error.error ? error.error : error;
                $scope.$emit('hours:alert', errorStr);
            }
            else
                $scope.$emit('hours:alert', "Failed to load list! Please try again.");

            vm.isLoading = false;
        }

        function onLoadMore() {
            getActivities(vm.loadStatus.currentIndex, vm.loadStatus.nextResultLoadNum);
            vm.checkAll = false;
        }

        function onLoadAll() {
            getActivities(vm.loadStatus.currentIndex, vm.loadStatus.numResultsNotLoaded);
            vm.checkAll = false;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('administrator.hours')
        .controller('ManageActivityController', ManageActivityController);

    ManageActivityController.$inject = ['$modalInstance', '$modal', '$timeout', 'authentication', 'utilsServices', 'moment', 'activity', 'rejectOnly', 'config'];

    // This modal is used by different pages that supply slightly different "activity" parameters.
    // These are the fields provided in one page that aren't in others:
    //   Hours:                     dateSubmitted, volunteer.email
    //   Service Log (Admin Mode):  position.$$hashKey

    function ManageActivityController($modalInstance, $modal, $timeout, authentication, utilsServices, moment, activity, rejectOnly, config) {
        var vm = this;

        vm.isLoading = true;
        vm.isDocumentUploading = false;

        vm.rejectOnly = rejectOnly;
        vm.activity = activity;

        vm.allowedFileTypesForUpload = null;
        vm.maxFileSizeInMegabytes = null;
        vm.formError = "";

        // This modal is used for both daily and period hours
        vm.isDaily = activity.type === 'Daily';

        // Flag for determining if creating new activity or editing existing one
        vm.isNew = !angular.isNumber(vm.activity.id);

        vm.isDeleted = vm.activity.status === 'Deleted';

        if (vm.rejectOnly)
            vm.title = "Reject ";
        else
            if (vm.isNew)
                vm.title = "Create ";
            else
                vm.title = "Manage ";

        if (vm.isDaily)
            vm.title += "Daily Hours - " + moment(vm.activity.date).format("MMMM DD, YYYY");
        else
            vm.title += "Period Hours - " + moment(vm.activity.date).format("MMMM YYYY");

        if (vm.rejectOnly) {
            vm.activity.position = {
                title: vm.activity.position
            };
        }

        // Only matters if activity is not new
        vm.submitterText = "";
        if (!vm.isNew) {
            if (vm.activity.createdByMasterUserId === vm.activity.volunteer.masterUserId)
                vm.submitterText += "Volunteer";
            else
                vm.submitterText += "Administrator";
        }

        if (vm.isNew) {
            vm.activity.hours = 0;
            vm.activity.reviewerNote = "";
            vm.activity.documents = [];
            vm.uploadedDocuments = [];
        }
        else {
            vm.uploadedDocuments = vm.activity.documents.length > 0 ? vm.activity.documents : [];
        }

        vm.originalHours = vm.activity.hours;
        vm.hoursEdited = false;

        vm.maxDocumentsUploaded = vm.uploadedDocuments.length === 3;
        vm.selectedDocuments = [];

        vm.onChangeHours = onChangeHours;
        vm.onClickCertify = onClickCertify;
        vm.onClickReject = onClickReject;
        vm.onClickDelete = onClickDelete;
        vm.onSelectDoc = onSelectDoc;
        vm.onDeleteUploadedDoc = onDeleteUploadedDoc;
        vm.onDeleteSelectedDoc = onDeleteSelectedDoc;

        activate();

        function activate() {
            config.get().then(function (configData) {
                vm.allowedFileTypesForUpload = configData.allowedFileTypesForUpload;
                vm.maxFileSizeInMegabytes = configData.maxFileSizeInMegabytes;
            });
            loadDropdowns();
        }

        function displayError(error) {
            if (_.isUndefined(error)) return;
            var errorStr = utilsServices.parseErrorString(error);

            vm.isLoading = false;

            if (errorStr === 'cancel' || errorStr === 'backdrop click' || errorStr === 'ok')
                return;
            if (errorStr)
                vm.formError = errorStr;
        }

        function loadDropdowns() {
            if (vm.isDaily)
                vm.maxHours = 24;
            else
                vm.maxHours = (moment(vm.activity.date).daysInMonth() * 8);

            vm.hrLabel = [];
            for (var i = 0; i <= vm.maxHours; i++)
                vm.hrLabel.push(i);

            vm.numHours = Math.floor(vm.activity.hours) || 0;
            vm.numMinutes = (vm.activity.hours - Math.floor(vm.activity.hours)) * 60 || 0;

            if (vm.numHours === 0)
                vm.minLabel = [15, 30, 45];
            else if (vm.numHours === 24)
                vm.minLabel = [0];
            else
                vm.minLabel = [0, 15, 30, 45];

            vm.isLoading = false;
        }

        function onChangeHours() {
            // If selected min hours in dropdown,
            // remove 0 and set minutes to something
            // because 0 hours, 0 minutes is not allowed
            if (vm.numHours === 0) {
                vm.minLabel = [15, 30, 45];
                if (vm.numMinutes === 0)
                    vm.numMinutes = vm.minLabel[0];
            }
            else if (vm.numHours === 24) {
                vm.minLabel = [0];
                if (vm.numMinutes !== 0)
                    vm.numMinutes = vm.minLabel[0];
            }
            // If left previous state,
            // fill back in that dropdown
            else if (vm.minLabel.length < 4) {
                vm.minLabel = [0, 15, 30, 45];
            }

            vm.activity.hours = (vm.numHours + (vm.numMinutes / 60));

            vm.hoursEdited = (vm.activity.hours !== vm.originalHours);
        }

        function onClickCertify() {
            vm.isLoading = true;
            if (vm.isNew)
                createActivity();
            else
                updateActivity('Certified');
        }

        function onClickReject() {
            vm.isLoading = true;
            if (!vm.isNew)
                updateActivity('Rejected');
            // Cannot reject new activity as admin
        }

        function onClickDelete() {
            $modal.open({
                templateUrl: 'app/components/volunteer/activityCalendar/deleteHours.view.html',
                controller: 'DeleteHoursController',
                controllerAs: 'vm',
                size: 'tiny',
                backdrop: 'static',
                keyboard: false,
                resolve: {
                    activity: function () {
                        var deleteActivity = angular.copy(vm.activity);
                        if (vm.hoursEdited)
                            deleteActivity.hours = vm.originalHours;
                        return deleteActivity;
                    },
                    adminEditing: function () {
                        return true;
                    }
                }
            }).result.then($modalInstance.close);
        }

        function createActivity() {
            var activityDate = moment(vm.activity.date).format("YYYY-MM-DD");
            var params = {
                volunteerOpportunityId: vm.activity.position.id,
                hours: {
                    dateEntered: new Date().toISOString(),
                    hours: vm.activity.hours,
                    userNotes: vm.activity.volunteerNote,
                    dayOfService: vm.isDaily ? activityDate : undefined,
                    periodOfService: vm.isDaily ? undefined : activityDate
                },
                setHoursAsOPOC: true,
                volunteerMasterUserId: vm.activity.volunteer.masterUserId
            };

            return authentication.setVolunteerHoursForOpportunity(params)
                .then(function (response) {
                    // If document to upload, do so!
                    if (vm.newUpload) {
                        vm.isDocumentUploading = true;

                        // If new
                        if (response.volunteerHoursId)
                            uploadDocuments(response.volunteerHoursId);
                        // If existing
                        else {
                            uploadDocuments(response.updatedHours[0].volunteerHoursId);
                        }
                    }
                    else {
                        response.action = 'add';
                        $modalInstance.close(response);
                    }
                })
                .catch($modalInstance.dismiss);
        }

        function updateActivity(status) {
            var params = {
                volunteerHoursStatus: status,
                hoursIds: [vm.activity.id],
                reviewerNotes: vm.activity.reviewerNote
            };

            // If hours were edited, include that
            if (vm.hoursEdited)
                params.hours = vm.activity.hours;

            return authentication.manageVolunteerHours(params)
                .then(function (response) {
                    // If document to upload, do so!
                    if (vm.newUpload) {
                        vm.isDocumentUploading = true;

                        // If new
                        if (response.volunteerHoursId)
                            uploadDocuments(response.volunteerHoursId);
                        // If existing
                        else {
                            uploadDocuments(response.updatedHours[0].volunteerHoursId);
                        }
                    }
                    else {
                        response.action = 'edit';
                        $modalInstance.close(response);
                    }
                })
                .catch($modalInstance.dismiss);
        }

        // Occurs after user submits, so close when completed
        function uploadDocuments(hoursId) {
            var numUploadsDone = 0;
            angular.forEach(vm.selectedDocuments, function (document) {
                var uploadDocumentParams = {
                    theFile: document,
                    fileSuffix: document.name.split(".").pop(),
                    documentName: document.name, // TODO: Allow user to title the upload
                    volunteerHoursId: hoursId
                };

                // TODO: Ideally would like to not create function in a loop,
                // but no known way to pass in "document" and the response
                authentication.uploadHoursDocument(uploadDocumentParams)
                    .then(function (response) {
                        uploadHoursSuccess(response, document);
                    })
                    .catch(function (error) {
                        uploadHoursFailure(error, document);
                    });
            });

            function uploadHoursSuccess(response, document) {
                document.uploaded = true; // Show check mark

                if (++numUploadsDone === vm.selectedDocuments.length) {
                    // Delay slightly to show final check mark
                    $timeout(function () {
                        $modalInstance.close("Document successfully uploaded!");
                    }, 1000);
                }
            }

            function uploadHoursFailure(error, document) {
                var errorStr = error.message ? error.message : error;

                if (++numUploadsDone === vm.selectedDocuments.length) {
                    $timeout(function () {
                        $modalInstance.dismiss("Document upload failed: " + errorStr);
                    }, 1000);
                }
            }
        }

        function onDeleteUploadedDoc(document) {
            var deleteDocumentParams = {
                hoursDocumentId: document.hoursDocumentId
            };

            return authentication.deleteHoursDocument(deleteDocumentParams)
                .then(function () {
                    vm.uploadedDocuments.splice(vm.uploadedDocuments.indexOf(document), 1);
                    updateMaxDocumentsUploaded();
                })
                .catch(function (error) {
                    var errorStr = error.error ? error.error : error;
                    $modalInstance.dismiss(errorStr);
                });
        }

        function onDeleteSelectedDoc(document) {
            vm.selectedDocuments.splice(vm.selectedDocuments.indexOf(document), 1);
            updateMaxDocumentsUploaded();
        }

        // This function ensures that only 3 total documents are uploaded or selected to be uploaded at once
        function onSelectDoc(documents, errDocuments) {
            if (errDocuments.length > 0) {
                vm.formError = "Wrong file type or file size is larger than " + vm.maxFileSizeInMegabytes + ".";
                displayError(vm.formError);
                $('#activityModal')[0].scrollIntoView();
                updateNewUpload();
                return;
            } else {
                vm.formError = "";
            }

            var numDocuments = documents.length + vm.selectedDocuments.length + vm.uploadedDocuments.length;
            if (documents.length === 0) {
                // Update flag for whether new documents to upload were selected
                updateNewUpload();
                return;
            }
            else if (numDocuments > 3) {
                updateNewUpload();
                return;
            }
            else if (numDocuments === 3) {
                vm.maxDocumentsUploaded = true;
            }

            vm.selectedDocuments = vm.selectedDocuments.concat(documents);
            //vm.errDocuments = errDocuments && errDocuments[0];

            updateNewUpload();
        }

        function updateMaxDocumentsUploaded() {
            vm.maxDocumentsUploaded = ((vm.selectedDocuments.length + vm.uploadedDocuments.length) === 3);
        }

        function updateNewUpload() {
            vm.newUpload = (vm.selectedDocuments.length > 0);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('administrator.hours')
        .controller('BatchConfirmationController', BatchConfirmationController);

    BatchConfirmationController.$inject = ['status'];

    function BatchConfirmationController(status) {
        var vm = this;

        vm.status = status;
    }
})();
(function () {
    'use strict';

    angular
        .module('vmis.administrator')
        .controller('InvitationsController', InvitationsController);

    InvitationsController.$inject = ['$modal', '$scope', 'authentication', 'loadStatus', 'title'];

    function InvitationsController($modal, $scope, authentication, loadStatus, title) {
        var vm = this;

        vm.isLoading = true;

        vm.sortReverse = true;
        vm.sortColumn = 'invitationDate';
        vm.title = title;
        vm.status = [
            'All',
            'Sent',
            'Accepted',
            'Expired'
        ];
        vm.invites = [];
        vm.alerts = [];
        vm.currentStatus = vm.status[1];
        vm.loadStatus = loadStatus.init();

        var completeRoleObjectList = [
            {
                shortName: "Vol",
                name: "Volunteer",
                vmisUserRolesName: "AVC Volunteer"
            },
            {
                shortName: "OPOC",
                name: "OPOC",
                responsibilitiesName: "opoc",
                vmisUserRolesName: "AVC OPOC"
            },
            {
                shortName: "AVCCAssistant",
                name: "AVCC Assistant",
                responsibilitiesName: "avccAssistant",
                vmisUserRolesName: "AVC Coordinator Assistant"
            },
            {
                shortName: "AVCC",
                name: "AVCC",
                responsibilitiesName: "avcc",
                vmisUserRolesName: "AVC Coordinator"
            },
            {
                shortName: "RM",
                name: "Region Manager",
                responsibilitiesName: "rm",
                secondResponsibilitiesName: "rmManaged",
                vmisUserRolesName: "AVC Region Manager"
            },
            {
                shortName: "PM",
                name: "Program Manager",
                vmisUserRolesName: "AVC Program Manager"
            }
        ];

        vm.getInvites = getInvites;
        vm.sendInvite = sendInvite;
        vm.onLoadMore = onLoadMore;
        vm.onLoadAll = onLoadAll;
        vm.onCloseAlert = onCloseAlert;

        activate();

        function activate() {
            vm.role = "AVC OPOC";

            loadStatus.setup(vm.loadStatus, "invitations")
                .then(function () {
                    getInvites(vm.loadStatus.currentIndex, vm.loadStatus.defaultNumRows);
                });

            // From people.routes.js, for future handling of different
            // invitation options for different user responsibilities
            /*
            vm.roles = [];

            return authentication.getUserProfile()
                .then(function (response) {
                    // Note: this detects what roles the ACTIVE USER has.
                    // Different roles are invitable based on that.
                    for (var i = 0; i < response.roles.vmisUserRoles.length; i++) {
                        // Depending on the active user role, save data about their responsibilities
                        // to display in drop downs and populate the drop down for the types of roles
                        // they can invite.
                        switch (response.roles.vmisUserRoles[i]) {
                            case "AVC Program Manager":
                                addRoleAvoidDuplicates(getRoleObjectByVmisUserRolesName("AVC Program Manager"));
                                addRoleAvoidDuplicates(getRoleObjectByVmisUserRolesName("AVC Region Manager"));
                                addRoleAvoidDuplicates(getRoleObjectByVmisUserRolesName("AVC Coordinator"));
                                addRoleAvoidDuplicates(getRoleObjectByVmisUserRolesName("AVC Coordinator Assistant"));
                                addRoleAvoidDuplicates(getRoleObjectByVmisUserRolesName("AVC OPOC"));
                                break;
                            case "AVC Region Manager":
                                addRoleAvoidDuplicates(getRoleObjectByVmisUserRolesName("AVC Coordinator"));
                                break;
                            case "AVC Coordinator":
                                addRoleAvoidDuplicates(getRoleObjectByVmisUserRolesName("AVC Coordinator Assistant"));
                                addRoleAvoidDuplicates(getRoleObjectByVmisUserRolesName("AVC OPOC"));
                                break;
                            case "AVC Coordinator Assistant":
                                addRoleAvoidDuplicates(getRoleObjectByVmisUserRolesName("AVC OPOC"));
                                break;
                            case "AVC OPOC":
                                addRoleAvoidDuplicates(getRoleObjectByVmisUserRolesName("AVC OPOC"));
                                break;
                            default:
                                break;
                        }
                    }
                }
                .catch(function (error) {
                    if (error) {
                        var errorStr = error.error ? error.error : error;
                        displayError(errorStr);
                    }
                }));

            // Return the role object that matches the "vmisUserRolesName" string
            // Searches complete list because used for setup
            function getRoleObjectByVmisUserRolesName(vmisUserRolesName) {
                return completeRoleObjectList.filter(function (element) {
                    return (element.vmisUserRolesName === vmisUserRolesName);
                })[0];
            }

            function addRoleAvoidDuplicates(role) {
                // If current role cannot be found in list, add it
                if (!getRoleObject(role.name)) {
                    vm.roles.push(role);
                }
            }

            // Return the role object in the current list that matches the "name" string
            function getRoleObject(name) {
                return vm.roles.filter(function (element) {
                    return (element.name === name);
                })[0];
            }
            */
        }

        function getInvites(index, num) {
            vm.isLoading = true;
            var params = {
                startingRowIndex: index,
                numberOfRows: num,
                invitationStatus: vm.currentStatus !== vm.status[0] ? vm.currentStatus : undefined
            };
            if (vm.role) {
                params.aosRoles = [vm.role];
            }

            authentication.getInvites(params)
                .then(function (response) {
                    return getInvitesSuccess(response, index, num);
                }).catch(function (err) {
                    getInvitesError(err);
                });
        }

        function sendInvite(invite) {
            var options = {
                templateUrl: 'app/components/administrator/invitations/sendInvite.view.html',
                controller: 'SendInviteController',
                controllerAs: 'vm',
                backdrop: 'static',
                keyboard: false,
                resolve: {
                    roles: function () {
                        return vm.roles ? vm.roles : null;
                    },
                    selectedRole: function () {
                        return vm.role;
                    },
                    title: function () {
                        var role;
                        switch (vm.role) {
                            case "AVC OPOC":
                                role = "OPOC";
                                break;
                            case "AVC Coordinator":
                                role = "AVCC";
                                break;
                            case "AVC Region Manager":
                                role = "Region Manager";
                                break;
                            default:
                                role = "";
                                break;
                        }

                        return angular.isDefined(invite) ? 'Edit ' + role + ' Invitation' : 'Invite New ' + role;
                    },
                    invite: function () {
                        return angular.isDefined(invite) ? invite : null;
                    }
                }
            };

            $modal.open(options).result.then(function () {
                vm.loadStatus.currentIndex = 0;
                return getInvites(vm.loadStatus.currentIndex, vm.loadStatus.defaultNumRows);
            }).catch(function (error) {
                // If modal is left by pressing "Escape", error is undefined.
                if (error) {
                    var errorStr = error.error ? error.error : error;
                    if (errorStr === 'ok' || errorStr === 'cancel' || errorStr === 'backdrop click')
                        return;

                    displayError(errorStr);
                }
            });
        }

        function getInvitesSuccess(response, index, num) {
            if (index === 0) {
                vm.loadStatus.currentIndex = 0;
                vm.invites = [];
            }

            // Either set current index to max if all users loaded or increment by rows loaded
            vm.loadStatus.currentIndex = (vm.loadStatus.currentIndex + num > response.count) ? response.count : (vm.loadStatus.currentIndex + num);
            // Track total number of users not loaded for "Load All" button
            vm.loadStatus.numResultsNotLoaded = response.count - vm.loadStatus.currentIndex;
            // Set text for "Load More" button
            vm.loadStatus.nextResultLoadNum = (response.count === vm.loadStatus.currentIndex) ? 0 :
                (vm.loadStatus.numResultsNotLoaded > num) ? num : vm.loadStatus.numResultsNotLoaded;

            vm.invites = vm.invites.concat(response.invitations);
            vm.isLoading = false;
        }

        function getInvitesError(error) {
            if (angular.isDefined(error)) {
                var errorStr = error.error ? error.error : error;
                $scope.$emit('invites:alert', errorStr);
            }
            else
                $scope.$emit('invites:alert', "Failed to load list! Please try again.");

            vm.isLoading = false;
        }

        function onLoadMore() {
            getInvites(vm.loadStatus.currentIndex, vm.loadStatus.nextResultLoadNum);
        }

        function onLoadAll() {
            getInvites(vm.loadStatus.currentIndex, vm.loadStatus.numResultsNotLoaded);
        }

        function displayAlert(type, message) {
            vm.alerts.push({
                type: type,
                message: message
            });
        }

        function onCloseAlert(index) {
            vm.alerts.splice(index, 1);
        }

        function displayError(error) {
            if (error === 'cancel' || error === 'ok' || error === 'backdrop click')
                return;
            if (error)
                displayAlert('alert', error);
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('vmis.administrator')
        .controller('SendInviteController', SendInviteController);

    SendInviteController.$inject = ['$modal', '$modalInstance', '$q', '_', 'authentication', 'roles', 'selectedRole', 'title', 'invite'];

    function SendInviteController($modal, $modalInstance, $q, _, authentication, roles, selectedRole, title, invite) {
        var vm = this;
        var hash = '';
        var responsibilities = null;

        vm.isLoading = true;
        //vm.roles = roles; // TODO: Future expansion of invitations
        vm.role = selectedRole;
        vm.title = title;
        vm.isEditing = invite !== null;

        vm.communities = [];
        vm.selectedCommunity = null;
        vm.invitedResponsibilities = [];

        vm.errorText = "";


        vm.requestReadReceipt = false;
        vm.bcc = false;

        vm.onChangeRole = onChangeRole;
        vm.onChangeCommunity = onChangeCommunity;
        vm.onSubmit = onSubmit;
        vm.onClickDelete = onClickDelete;

        activate();

        function activate() {
            getResponsibilities();
        }

        function getResponsibilities() {
            return authentication.getUserProfile()
                .then(function (response) {
                    responsibilities = response.aosUser.vmisUser.adminProfile.responsibilities;
                    getOpocData();
                }).catch(function (err) {
                    setError(err);
                    vm.isLoading = false;
                });
        }

        function getOrgsForCommunity(comm) {
            var params = {
                communityAffiliationId: comm.communityAffiliationId,
                getAll: true
            };

            return authentication.getOrganizations(params)
                .then(function (response) {
                    comm.organizations = response.organizations;
                    comm.organizations.forEach(function (org) {
                        org.communityAffiliationId = comm.communityAffiliationId;
                        org.communityAffiliationName = comm.communityAffiliationName;
                    });
                }).catch(function (err) {
                    setError(err);
                    vm.isLoading = false;
                });
        }

        function getOpocData() {
            vm.communities = responsibilities.avcc;
            vm.selectedCommunity = vm.communities[0];

            // Create empty org list to populate when community selected
            vm.communities.forEach(function (comm) {
                comm.organizations = null;
            });

            getOrgsForCommunity(vm.selectedCommunity)
                .then(function () {
                    // If editing existing invitation with data and responsibility IDs, load that.
                    if (vm.isEditing)
                        getInvite(invite);
                    else
                        vm.isLoading = false;
                });
        }

        function getInvite(invite) {
            hash = invite.hash;

            vm.role = invite.aosRoles[0];
            vm.email = invite.emailAddress;
            vm.firstName = invite.firstName;
            vm.lastName = invite.lastName;
            vm.requestReadReceipt = Boolean(invite.requestReadReceipt);
            vm.bcc = Boolean(vm.bccEmailAddress = invite.bccEmailAddress);

            var additionalInfo = angular.fromJson(invite.additionalInfo);
            switch (vm.role) {
                /*
                case 'AVC Coordinator':
                    items = additionalInfo.communityAffiliationIds;
                    return selectCoordinator();
                case 'AVC Region Manager':
                    items = additionalInfo.communityAffiliationIds;
                    return selectRegionManager();
                */
                case 'AVC OPOC':
                    var promiseArray = [];
                    // Get all communities to be able to sort existing orgs
                    vm.communities.forEach(function (comm) {
                        if (comm.organizations === null)
                            promiseArray.push(getOrgsForCommunity(comm));
                    });

                    $q.all(promiseArray)
                        .then(function () {
                            // Assumed to be running after data is populated
                            additionalInfo.volunteerOrganizationIds.forEach(function (orgId) {
                                var foundOrg = false;
                                for (var i = 0; i < vm.communities.length; i++) {
                                    if (foundOrg)
                                        break;

                                    for (var j = 0; j < vm.communities[i].organizations.length; j++) {
                                        if (orgId === vm.communities[i].organizations[j].volunteerOrganizationId) {
                                            vm.invitedResponsibilities.push(vm.communities[i].organizations[j]);
                                            foundOrg = true;
                                            break;
                                        }
                                    }
                                }

                                if (!foundOrg) {
                                    setError("Error: could not find match for organization ID " + orgId);
                                }
                            });

                            vm.isLoading = false;
                        });


                    break;
            }
        }

        /*
        function selectCoordinator() {
            vm.isLoading = true;
            var elements = [
                'communityaffiliation'
            ];
            return authentication.getUiData(elements).then(function (response) {
                items = response.communityaffiliation.map(function (community) {
                    return {
                        name: community,
                        set: vm.items.indexOf(community) !== -1
                    };
                });
                vm.isLoading = false;
            });
        }

        function selectRegionManager() {
            vm.isLoading = true;
            return selectCoordinator().then(function () {
                vm.isLoading = false;
            });
        }

        function selectOrganizationProgramManager() {
            vm.isLoading = true;
            var params = {};

            return authentication.getStandardOrganizations(params).then(function (response) {
                items = response.standardOrganizations.map(function (standardOrganization) {
                    return {
                        name: standardOrganization.volunteerOrganizationTemplateName,
                        set: vm.items.indexOf(standardOrganization.volunteerOrganizationTemplateName) !== -1
                    };
                });
                vm.isLoading = false;
            });
        }
        */

        function onChangeRole() {
            vm.invitedResponsibilities = [];
            switch (vm.role) {
                /*
                case 'AVC Coordinator':
                    return selectCoordinator();
                case 'AVC Region Manager':
                    return selectRegionManager();
                */
                case 'AVC OPOC':
                    return selectOpoc();
            }
        }

        function onChangeCommunity() {
            if (vm.selectedCommunity.organizations === null)
                getOrgsForCommunity(vm.selectedCommunity);
        }

        function onSubmit() {
            vm.isLoading = true;
            var params = {
                email: vm.email,
                firstName: vm.firstName,
                lastName: vm.lastName,
                requestReadReceipt: vm.requestReadReceipt,
                bccEmailAddress: vm.bcc ? vm.bccEmailAddress : '',
                additionalInfo: {}
            };
            switch (vm.role) {
                /*
                case 'AVC Coordinator':
                case 'AVC Region Manager':
                    params.additionalInfo.communityAffiliationIds = _.map(vm.items, getItemId);
                    break;
                */
                case 'AVC OPOC':
                    params.additionalInfo.volunteerOrganizationIds = _.map(vm.invitedResponsibilities, function (resp) {
                        return resp.volunteerOrganizationId;
                    });
                    params.additionalInfo.communityAffiliationIds = _.uniqBy(_.map(vm.invitedResponsibilities, function (resp) {
                        return resp.communityAffiliationId;
                    }));
                    break;
            }

            var apiCall = authentication.sendInvite;

            if (invite !== null) {
                params.invitationId = invite.invitationId;
                apiCall = authentication.updateInvite;
            } else {
                params.aosRoles = [vm.role];
            }

            return apiCall(params)
                .then(function () {
                    $modalInstance.close();
                })
                .catch(function (error) {
                    params = {
                        error: error,
                        success: false
                    };
                    return $modalInstance.dismiss(params);
                });


            function getItemId(item) {
                return item.id;
            }
        }

        function onClickDelete() {
            var options = {
                templateUrl: 'app/components/administrator/invitations/deleteInvite.view.html',
                controller: 'DeleteInviteController',
                controllerAs: 'vm',
                size: 'tiny',
                backdrop: 'static',
                keyboard: false,
                resolve: {
                    fullName: function () {
                        return vm.firstName + " " + vm.lastName;
                    },
                    email: function () {
                        return vm.email;
                    },
                    role: function () {
                        return vm.role;
                    }
                }
            };

            $modal.open(options)
                .result
                .then(deleteInvite);
        }

        function deleteInvite() {
            vm.isLoading = true;
            return authentication.deleteInvite(hash)
                .then(function () {
                    $modalInstance.close();
                });
        }

        function setError(error) {
            var errorStr = error.error ? error.error : error;
            if (errorStr === 'ok' || errorStr === 'cancel' || errorStr === 'backdrop click')
                return;
            vm.errorText = errorStr;
        }

        function clearError() {
            vm.errorText = "";
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('vmis.administrator')
        .controller('DeleteInviteController', DeleteInviteController);

    DeleteInviteController.$inject = ['$modalInstance', 'fullName', 'email', 'role'];

    function DeleteInviteController($modalInstance, fullName, email, role) {
        var vm = this;
        vm.title = "Delete Invitation";

        vm.fullName = fullName;
        vm.email = email;
        vm.role = role;

        vm.title = "Confirm Delete Invitation - " + vm.fullName;

        vm.onAccept = onAccept;

        function onAccept() {
            $modalInstance.close();
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('vmis.administrator')
        .config(config);

    config.$inject = ['$stateProvider', '$urlRouterProvider'];

    function config($stateProvider, $urlRouterProvider) {
        $urlRouterProvider
            .when('/accept-invite', ['$window', '$location', '$state', 'authentication', function ($window, $location, $state, authentication) {
                var parameters = $location.search();
                if (!parameters.hasOwnProperty('key')) {
                    return false;
                }

                var regexp = /^[\da-z]{8}(-[\da-z]{4}){4}[\da-z]{8}$/;
                if (!regexp.test(parameters.key)) {
                    return false;
                }

                if (authentication.isLoggedIn()) {
                    return authentication.acceptInvite({hash: parameters.key}).then(function () {
                        $state.go('vmis.inviteAccepted');
                    }, function() {
                        $state.go('vmis.inviteNotFound');
                    });
                } else {
                    authentication.setRedirect('vmis.acceptInvite', {hash: parameters.key});
                    $state.go('vmis.logIn');
                    return true;
                }
            }]);

        $stateProvider.state('vmis.acceptInvite', {
            url: '/accept-invite?hash',
            templateUrl: 'app/components/administrator/invitations/acceptInvite.view.html',
            controller: 'AcceptInviteController',
            controllerAs: 'vm',
            title: 'Accept Invitation'
        }).state('vmis.inviteAccepted', {
            url: '/invite-accepted',
            templateUrl: 'app/components/administrator/invitations/inviteAccepted.view.html',
            title: 'Invitation Accepted'
        }).state('vmis.inviteNotFound', {
            url: '/invite-not-found',
            templateUrl: 'app/components/administrator/invitations/inviteNotFound.view.html',
            title: 'Invitation Not Found'
        });
    }
})();
(function () {
    'use strict';

    angular
        .module('vmis.administrator')
        .controller('AcceptInviteController', AcceptInviteController);

    AcceptInviteController.$inject = ['$state', '$stateParams', 'authentication'];

    function AcceptInviteController($state, $stateParams, authentication) {
        var vm = this;

        vm.onSubmit = onSubmit;

        activate();

        function activate() {
            getInvite();
        }

        function getInvite() {
            return authentication.getInviteStatus($stateParams.hash)
                .then(function (response) {
                    vm.role = response.aosRoles[0];
                    vm.firstName = response.firstName;
                    vm.lastName = response.lastName;
                    var additionalInfo = JSON.parse(response.additionalInfo);
                    vm.communities = additionalInfo.communityAffiliations;
                    vm.standardOrganizations = additionalInfo.volunteerOrganizationTemplates;
                    vm.organizations = additionalInfo.volunteerOrganizations;
                    vm.community = response.community;
                    switch (response.invitationStatusId) {
                        case 'Expired':
                            vm.expired = true;
                            break;
                        case 'Accepted':
                            vm.accepted = true;
                            break;
                    }
                    vm.showInvite = !(vm.expired || vm.accepted);
                })
                .catch(displayError);
        }

        function onSubmit() {
            return authentication.acceptInvite({
                hash: $stateParams.hash
            }).then(function () {
                $state.go('vmis.inviteAccepted');
            }).catch(displayError);
        }

        function displayError(error) {
            vm.formError = error;
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('vmis.administrator')
        .controller('MergeAccountsController', MergeAccountsController);

    MergeAccountsController.$inject = ['authentication', '$scope', '$modal'];

    function MergeAccountsController(authentication, $scope, $modal) {
        var vm = this;
        
        vm.isLoading = false;
        
        vm.selectedUsernames = [];
        vm.selectedEmails = [];
        vm.selectedNonUsers = [];

        vm.alerts = [];

        vm.mergeToUser = "";
        vm.selectedUsernameList = "";
        vm.selectedEmailList = "";
        vm.selectedNonUserList = "";
        
        vm.onClickUsername = onClickUsername;
        vm.onClickEmail = onClickEmail;
        vm.onClickNonUser = onClickNonUser;

        vm.onClickMergeStats = onClickMergeStats;
        vm.onClickMerge = onClickMerge;
        vm.onClearData = onClearData;

        $scope.$on('mergeAccounts:alert', alertHandler);
        vm.onCloseAlert = onCloseAlert;
        
        activate();

        function activate() {

        }

        function onClearData(items) {
            if(items === "all") {
                vm.mergeToUser = "";
                vm.selectedUsernameList = "";
                vm.selectedEmailList = "";

                vm.selectedUsernames = [];
                vm.selectedEmails = [];

                vm.selectedNonUserList = "";
                vm.selectedNonUsers = [];
            }
            
            if(items === "email"){
                vm.selectedEmailList = "";
                vm.selectedEmails = [];
            }
            
            if(items === "username"){
                vm.selectedUsernameList = "";
                vm.selectedUsernames = [];
            }

            if(items === "nonuser"){
                vm.selectedNonUserList = "";
                vm.selectedNonUsers = [];
            }
        }
        
        function onClickUsername() {
            $modal.open({
                templateUrl: 'app/components/administrator/mergeAccounts/addEmailUsername.view.html',
                controller: 'AddEmailUsernameController',
                controllerAs: 'vm',
                backdrop: 'static',
                keyboard: false,
                resolve: {
                    title: function () {
                        return "Add Username";
                    }
                },
                size: 'tiny'
            }).result.then(function (result) {
                if(vm.selectedUsernames.some(function(element){
                        return element === result.item;
                    })){
                    displayError("This username already exists in this Merge From Email Addresses");
                }
                else {
                    vm.selectedUsernames.push(result.item);
                    if (vm.selectedUsernameList !== "") {
                        vm.selectedUsernameList = vm.selectedUsernameList + ", " + result.item;
                    }
                    else {
                        vm.selectedUsernameList = result.item;
                    }
                }
            });
        }

        function onClickEmail() {
            $modal.open({
                templateUrl: 'app/components/administrator/mergeAccounts/addEmailUsername.view.html',
                controller: 'AddEmailUsernameController',
                controllerAs: 'vm',
                backdrop: 'static',
                keyboard: false,
                resolve: {
                    title: function () {
                        return "Add Email";
                    }
                }
            }).result.then(function (result) {
                if(vm.selectedEmails.some(function(element){
                        return element === result.item;
                    })){
                    displayError("This email already exists in this Merge From Email Addresses");
                }
                else {
                    if(result.item === vm.mergeToUser){
                        displayError("You cannot add the Merge To Email Address to the Merge From Email Address list");
                    }
                    else {
                        vm.selectedEmails.push(result.item);
                        if (vm.selectedEmailList !== "") {
                            vm.selectedEmailList = vm.selectedEmailList + ", " + result.item;
                        }
                        else {
                            vm.selectedEmailList = result.item;
                        }
                    }
                }
            });
        }

        function onClickNonUser() {
            $modal.open({
                templateUrl: 'app/components/administrator/mergeAccounts/addEmailUsername.view.html',
                controller: 'AddEmailUsernameController',
                controllerAs: 'vm',
                backdrop: 'static',
                keyboard: false,
                resolve: {
                    title: function () {
                        return "Add Non-User";
                    }
                }
            }).result.then(function (result) {
                if(vm.selectedNonUsers.some(function(element){
                    return element === result.item;
                })){
                    displayError("This non-user already exists in this Merge From Non-Users");
                }
                else {
                    if(result.item === vm.mergeToUser){
                        displayError("You cannot add the Merge To Email Address to the Merge From Non-Users list");
                    }
                    else {
                        vm.selectedNonUsers.push(result.item);
                        if (vm.selectedNonUserList !== "") {
                            vm.selectedNonUserList = vm.selectedNonUserList + ", " + result.item;
                        }
                        else {
                            vm.selectedNonUserList = result.item;
                        }
                    }
                }
            });
        }

        function onClickMergeStats() {
            vm.isLoading = true;
            authentication.getMasterUserIdFromEmail({email: vm.mergeToUser})
                .then(function(user){
                    if(user.success){
                        return user.masterUserId;
                    }
                })
                .then(function(masterUserId){
                    var params = {getMergeStatsOnly: true};
                    params.masterUserId = masterUserId;

                    if(vm.selectedEmails.length !== 0){
                        params.emails = vm.selectedEmails;
                    }
                    if(vm.selectedUsernames.length !== 0){
                        params.usernames = vm.selectedUsernames;
                    }
                    if(vm.selectedNonUsers.length !== 0){
                        params.nonUsers = vm.selectedNonUsers;
                    }
                    return authentication.mergeVMISdata(params);
                })
                .then(function(results){
                    if(angular.isDefined(results)) {
                        $modal.open({
                            templateUrl: 'app/components/administrator/mergeAccounts/mergeCompleted.view.html',
                            controller: 'MergeCompletedController',
                            controllerAs: 'vm',
                            backdrop: 'static',
                            keyboard: false,
                            resolve: {
                                title: function () {
                                    return "Merge Information";
                                },
                                results: function () {
                                    return results;
                                }
                            }
                        });
                    }
                })
                .catch(function(error){
                    if(error === "email not found") {
                        displayError("This user does not exist in the system");
                    }
                    else {
                        displayError(error);
                    }
                })
                .finally(function(){
                    vm.isLoading = false;
                });
        }

        function onClickMerge() {
            $modal.open({
                templateUrl: 'app/components/administrator/mergeAccounts/confirmMerge.view.html',
                controller: 'ConfirmMergeController',
                controllerAs: 'vm',
                backdrop: 'static',
                keyboard: false,
                resolve: {
                    toEmail:  function () {return vm.mergeToUser;},
                    fromEmails: function () {return vm.selectedEmails;},
                    fromUsernames: function () {return vm.selectedUsernames;},
                    fromNonUsers: function () {return vm.selectedNonUsers;}
                }
            }).result.then(function (error) {
                if(angular.isDefined(error)){
                    displayError(error.error);
                }
                else {
                    onClearData("all");
                }
            });
        }

        function alertHandler(event, message) {
            event.stopPropagation();

            displayError(message);
        }

        function onCloseAlert(index) {
            vm.alerts.splice(index, 1);
        }

        function displayAlert(type, message) {
            vm.alerts.push({
                type: type,
                message: message
            });
        }

        function displayError(error) {
            if (error === 'cancel' || error === 'backdrop click')
                return;
            if (error)
                displayAlert('alert', error);
        }
    }
})();
    
(function () {
    'use strict';

    angular
        .module('vmis.administrator')
        .config(routes);

    routes.$inject = ['$stateProvider'];

    function routes($stateProvider) {
        $stateProvider
            .state('vmis.administrator.mergeAccounts', {
                url: '/merge-accounts',
                controller: 'MergeAccountsController',
                controllerAs: 'vm',
                templateUrl: 'app/components/administrator/mergeAccounts/mergeAccounts.view.html',
                title: 'Merge Accounts'
            });
    }
})();
/**
 * Created by nbhadsavle3 on 11/3/2017.
 */

(function () {
    'use strict';

    angular
        .module('vmis.administrator')
        .controller('AddEmailUsernameController', AddEmailUsernameController);

    AddEmailUsernameController.$inject = ['$modalInstance', 'title'];

    function AddEmailUsernameController($modalInstance, title) {
        var vm = this;
        
        vm.title = title;

        vm.onCancel = onCancel;
        vm.onConfirm = onConfirm;

        activate();

        function activate() {
        }

        function onConfirm() {
            $modalInstance.close({item: vm.item});
        }

        function onCancel() {
            $modalInstance.dismiss('cancel');
        }
    }
})();
/**
 * Created by nbhadsavle3 on 11/3/2017.
 */

(function () {
    'use strict';

    angular
        .module('vmis.administrator')
        .controller('MergeCompletedController', MergeCompletedController);

    MergeCompletedController.$inject = ['$modalInstance', 'title', 'results', '$modal'];

    function MergeCompletedController($modalInstance, title, results, $modal) {
        var vm = this;
        
        vm.title = title;
        vm.hoursLost = 0;
        vm.applicationsLost = 0;
        vm.applicationsUpdated = 0;
        
        vm.applications = 0;
        vm.awards = 0;
        vm.backgroundChecks = 0;
        vm.hours = 0;
        vm.notes = 0;
        vm.orientations = 0;
        vm.trainings = 0;
        vm.documents = 0;

        vm.onCancel = onCancel;
        vm.onConfirm = onConfirm;
        vm.onClickHoursApps = onClickHoursApps;

        if(angular.isDefined(results.discardedHours)){
            vm.hoursLost = results.discardedHours.length;
        }

        if(angular.isDefined(results.discardedApplications)){
            vm.applicationsLost = results.discardedApplications.length;
        }

        if(angular.isDefined(results.updatedApplications)){
            vm.applicationsUpdated = results.updatedApplications.length;
        }

        if(angular.isDefined(results.totalApplications)){
            vm.applications = results.totalApplications.length;
        }

        if(angular.isDefined(results.totalHours)){
            vm.hours = results.totalHours.length;
        }

        if(angular.isDefined(results.mergedData)){
            vm.applications = results.mergedData.applications.length;
            vm.awards = results.mergedData.awards.length;
            vm.backgroundChecks = results.mergedData.backgroundChecks.length;
            vm.hours = results.mergedData.hours.length;
            vm.notes = results.mergedData.notes.length;
            vm.orientations = results.mergedData.orientations.length;
            vm.trainings = results.mergedData.trainings.length;
            vm.documents = results.mergedData.documents.length;
        }

        activate();

        function activate() {
        }

        function onClickHoursApps (type,dataSet) {
            var res;
            switch(dataSet){
                case "appLost":
                    res = results.discardedApplications;
                    break;
                case "hoursLost":
                    res = results.discardedHours;
                    break;
                case "totalApps":
                    res = results.totalApplications;
                    break;
                case "totalHours":
                    res = results.totalHours;
                    break;
                case "appUpdated":
                    res = results.updatedApplications;
                    break;
                default:
                    $modalInstance.close();
                    break;
            }

            if(type === "hours") {
                $modal.open({
                    templateUrl: 'app/components/administrator/mergeAccounts/hoursAppsDetails.view.html',
                    controller: 'HoursAppsDetailsController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    keyboard: false,
                    resolve: {
                        title: function () {
                            return "Hours Details";
                        },
                        data: function () {
                            return res;
                        }
                    }
                }).result.then(function () {
                });
            }

            else if(type === "apps"){
                $modal.open({
                    templateUrl: 'app/components/administrator/mergeAccounts/hoursAppsDetails.view.html',
                    controller: 'HoursAppsDetailsController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    keyboard: false,
                    resolve: {
                        title: function () {
                            return "Applications Details";
                        },
                        data: function () {
                            return res;
                        }
                    }
                }).result.then(function () {
                });
            }
        }

        function onConfirm() {
            $modalInstance.close();
        }

        function onCancel() {
            $modalInstance.dismiss('cancel');
        }
    }
})();
/**
 * Created by nbhadsavle3 on 11/3/2017.
 */

(function () {
    'use strict';

    angular
        .module('vmis.administrator')
        .controller('ConfirmMergeController', ConfirmMergeController);

    ConfirmMergeController.$inject = ['$modalInstance', 'authentication','toEmail','fromEmails','fromUsernames', 'fromNonUsers', '$modal'];

    function ConfirmMergeController($modalInstance, authentication, toEmail, fromEmails, fromUsernames, fromNonUsers, $modal) {
        var vm = this;
        
        vm.isLoading = false;
        vm.toEmail = toEmail;
        vm.fromEmails = fromEmails;
        vm.fromUsernames = fromUsernames;
        vm.fromNonUsers = fromNonUsers;

        vm.onCancel = onCancel;
        vm.onConfirm = onConfirm;

        activate();

        function activate() {
        }

        function onConfirm() {
            vm.isLoading = true;
            authentication.getMasterUserIdFromEmail({email: toEmail})
                .then(function(user){
                    if(user.success){
                        return user.masterUserId;
                    }
                })
                .then(function(masterUserId){
                    if(angular.isDefined(masterUserId)) {
                        var params = {};
                        params.masterUserId = masterUserId;

                        if (fromEmails.length !== 0) {
                            params.emails = fromEmails;
                        }
                        if (fromUsernames.length !== 0) {
                            params.usernames = fromUsernames;
                        }
                        if(fromNonUsers.length !== 0){
                            params.nonUsers = fromNonUsers;
                        }

                        return authentication.mergeVMISdata(params);
                    }
                })
                .then(function(results){
                    vm.isLoading = false;
                    if(angular.isDefined(results)) {
                        $modal.open({
                            templateUrl: 'app/components/administrator/mergeAccounts/mergeCompleted.view.html',
                            controller: 'MergeCompletedController',
                            controllerAs: 'vm',
                            backdrop : 'static',
                            keyboard: false,
                            resolve: {
                                title: function () {
                                    return "Merge Results";
                                },
                                results: function () {
                                    return results;
                                }
                            }
                        }).result.then(function () {
                            $modalInstance.close();
                        });
                    }
                })
                .catch(function(error){
                    if(error === "email not found") {
                        return $modalInstance.close({error: "This user does not exist in the system"});
                    }
                    else {
                        return $modalInstance.close({error: error});
                    }
                })
                .finally(function(){
                    vm.isLoading = false;
                });
        }

        function onCancel() {
            $modalInstance.dismiss('cancel');
        }
    }
})();
/**
 * Created by nbhadsavle3 on 11/3/2017.
 */

(function () {
    'use strict';

    angular
        .module('vmis.administrator')
        .controller('HoursAppsDetailsController', HoursAppsDetailsController);

    HoursAppsDetailsController.$inject = ['$modalInstance', 'title', 'data'];

    function HoursAppsDetailsController($modalInstance, title, data) {
        var vm = this;
        
        vm.title = title;
        vm.applications = [];
        vm.hours = [];

        if(title === "Applications Details") {
            vm.applications = data;
        }

        if(title === "Hours Details") {
            vm.hours = data;
        }


        vm.onCancel = onCancel;
        vm.onConfirm = onConfirm;

        activate();

        function activate() {
        }
        
        function onConfirm() {
            $modalInstance.close();
        }

        function onCancel() {
            $modalInstance.dismiss('cancel');
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('vmis.administrator')
        .config(routes);

    routes.$inject = ['$stateProvider'];

    function routes($stateProvider) {
        $stateProvider
            .state('vmis.administrator.organizationGroups', {
                url: '/organization-groups',
                templateUrl: 'app/components/administrator/organizationGroups/organizationGroups.view.html',
                controller: 'OrganizationGroupsController',
                controllerAs: 'vm',
                title: 'Organization Groups'
            });
    }
})();
(function () {
    'use strict';

    angular
        .module('vmis.administrator')
        .controller('OrganizationGroupsController', OrganizationGroupsController);

    OrganizationGroupsController.$inject = ['_', '$modal', 'authentication', 'loadStatus'];

    function OrganizationGroupsController(_, $modal, authentication, loadStatus) {
        var vm = this;

        vm.defaultCategoryName = "None";
        vm.sortColumn = 'name';
        vm.loadStatus = loadStatus.init();

        vm.onClickOrganizationGroup = onClickOrganizationGroup;
        vm.onLoadAll = onLoadAll;
        vm.onLoadMore = onLoadMore;

        activate();

        function activate() {
            loadStatus.setup(vm.loadStatus, "organizationGroups")
                .then(function () {
                    getOrganizationGroups(vm.loadStatus.currentIndex, vm.loadStatus.defaultNumRows);
                });
        }

        function getOrganizationGroups(index, num) {
            vm.isLoading = true;

            return authentication.getOrganizationGroups({
                startingRowIndex: index,
                numberOfRows: num
            }).then(function (response) {
                if (index === 0) {
                    vm.loadStatus.currentIndex = 0;
                    vm.organizationGroups = [];
                }

                // Either set current index to max if all users loaded or increment by rows loaded
                vm.loadStatus.currentIndex = (vm.loadStatus.currentIndex + num > response.count) ? response.count : (vm.loadStatus.currentIndex + num);
                // Track total number of users not loaded for "Load All" button
                vm.loadStatus.numResultsNotLoaded = response.count - vm.loadStatus.currentIndex;
                // Set text for "Load More" button
                vm.loadStatus.nextResultLoadNum = (response.count === vm.loadStatus.currentIndex) ? 0 :
                    (vm.loadStatus.numResultsNotLoaded > num) ? num : vm.loadStatus.numResultsNotLoaded;

                vm.organizationGroups = _.concat(vm.organizationGroups, _.map(response.organizationGroups, function (organizationGroup) {
                    return {
                        id: organizationGroup.volunteerOrganizationGroupId,
                        name: organizationGroup.volunteerOrganizationGroupName
                    };
                })
                );
                vm.formError = '';
            }).catch(function (error) {
                if (angular.isDefined(error)) {
                    vm.formError = error.error ? error.error : error;
                }
                else
                    vm.formError = 'Failed to load list! Please try again.';
            }).finally(function () {
                vm.isLoading = false;
            });
        }

        function onClickOrganizationGroup(organizationGroup) {
            $modal.open({
                templateUrl: 'app/components/administrator/organizationGroups/organizationGroupDetails.view.html',
                controller: 'OrganizationGroupDetailsController',
                controllerAs: 'vm',
                backdrop: 'static',
                keyboard: false,
                resolve: {
                    title: function () {
                        return organizationGroup ? 'Organization Group Details' : 'Add New Organization Group';
                    },
                    organizationGroup: function () {
                        return organizationGroup ? _.clone(organizationGroup) : {};
                    }
                }
            }).result.then(function () {
                vm.loadStatus.currentIndex = 0;
                return getOrganizationGroups(vm.loadStatus.currentIndex, vm.loadStatus.defaultNumRows);
            });
        }

        function onLoadMore() {
            getOrganizationGroups(vm.loadStatus.currentIndex, vm.loadStatus.nextResultLoadNum);
        }

        function onLoadAll() {
            getOrganizationGroups(vm.loadStatus.currentIndex, vm.loadStatus.numResultsNotLoaded);
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('vmis.administrator')
        .controller('OrganizationGroupDetailsController', OrganizationGroupDetailsController);

    OrganizationGroupDetailsController.$inject = ['$modalInstance', '$modal', 'authentication', 'title', 'organizationGroup', 'config'];

    function OrganizationGroupDetailsController($modalInstance, $modal, authentication, title, organizationGroup, config) {
        var vm = this;
        var originalOrganizationGroupName = organizationGroup.name;

        vm.title = title;
        vm.organizationGroup = organizationGroup;

        vm.isProductionWebsite = null;
        vm.bannerMessage = null;

        vm.onSave = onSave;
        vm.onClickDelete = onClickDelete;

        activate();

        function activate() {
            config.get().then(function (configData) {
                vm.isProductionWebsite = configData.isProductionWebsite;
                vm.bannerMessage = configData.bannerMessage;
            });
        }

        function onSave() {
            vm.isLoading = true;
            return authentication.manageOrganizationGroup({
                volunteerOrganizationGroupId: organizationGroup.id || undefined,
                volunteerOrganizationGroupName: organizationGroup.name
            }).then(function () {
                $modalInstance.close();
            }).catch(function (error) {
                vm.formError = error;
            }).finally(function () {
                vm.isLoading = false;
            });
        }

        function onClickDelete() {
            $modal.open({
                templateUrl: 'app/components/administrator/organizationGroups/organizationGroupDelete.view.html',
                controller: 'OrganizationGroupDeleteController',
                controllerAs: 'vm',
                size: 'tiny',
                backdrop: 'static',
                keyboard: false,
                resolve: {
                    organizationGroupName: function () {
                        return originalOrganizationGroupName;
                    }
                }
            }).result.then(function () {
                vm.isLoading = true;
                return authentication.manageOrganizationGroup({
                    volunteerOrganizationGroupId: organizationGroup.id || undefined,
                    isDelete: true
                }).then(function () {
                    $modalInstance.close();
                });
            }, function () {
                //dismiss
            }).catch(function (error) {
                vm.formError = error;
            }).finally(function () {
                vm.isLoading = false;
            });
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('vmis.administrator')
        .controller('OrganizationGroupDeleteController', OrganizationGroupDeleteController);

    OrganizationGroupDeleteController.$inject = ['organizationGroupName'];

    function OrganizationGroupDeleteController(organizationGroupName) {
        var vm = this;

        vm.organizationGroupName = organizationGroupName;
    }
})();
(function () {
    'use strict';

    angular
        .module('vmis.administrator')
        .controller('OrganizationsController', OrganizationsController);

    OrganizationsController.$inject = ['$q', '$modal', '$scope', 'authentication', 'loadStatus', '_'];

    function OrganizationsController($q, $modal, $scope, authentication, loadStatus, _) {
        var vm = this;

        vm.isLoading = true;
        vm.alerts = [];
        vm.organizations = [];
        vm.commArchived = false;
        vm.sortColumn = "name";
        vm.sortReverse = false;
        vm.dropDowns = {};
        vm.volunteerSubmitted = "Volunteer Submitted";

        vm.statuses = [
            {
                name: "All",
                value: -1
            },
            {
                name: "Active",
                value: 1
            },
            {
                name: "Inactive",
                value: 0
            }
        ];
        vm.status = vm.statuses[1].value; // Default to "Active"

        vm.loadStatus = loadStatus.init();

        vm.onClickAddNewOrganization = onClickAddNewOrganization;
        vm.onClickEditOrganization = onClickEditOrganization;
        vm.onChangeStatus = onChangeStatus;
        vm.onChangeCommunity = onChangeCommunity;
        vm.onChangeType = onChangeType;
        vm.onCloseAlert = onCloseAlert;
        vm.onLoadMore = onLoadMore;
        vm.onLoadAll = onLoadAll;

        activate();

        function activate() {
            loadStatus.setup(vm.loadStatus, "organizations")
                .then(function () {
                    getDropdownData();
                    return $q.all({
                        communities: getCommunities(),
                        organizations: getOrganizations(vm.loadStatus.currentIndex,
                            vm.loadStatus.defaultNumRows, null, vm.status)
                    });
                })
                .then(function (responses) {
                    vm.communities = responses.communities;
                    if (vm.communities.length !== 1) {
                        vm.communities.unshift({
                            id: -1,
                            name: "All"
                        });
                    }
                    vm.selectedCommunityId = vm.communities[0].id;
                }).catch(displayError).finally(function () {
                    vm.isLoading = false;
                });
        }

        function getCommunities() {
            return authentication.getUserProfile().then(function (response) {
                var responsibilities = response.aosUser.vmisUser.adminProfile.responsibilities;
                var communities = [];

                if (responsibilities.avcc) {
                    communities = _.concat(communities, _.map(responsibilities.avcc, function (community) {
                        return {
                            id: community.communityAffiliationId,
                            name: community.communityAffiliationName
                        };
                    }));
                }
                return _.sortBy(communities, ['name']);
            });
        }

        function getDropdownData() {
            var elements = [
                'volunteerorganizationtype'
            ];
            return authentication.getUiData(elements)
                .then(function (response) {
                    vm.dropDowns.types = _.concat({
                        name: 'All'
                    }, _.map(response.volunteerorganizationtype, function (type) {
                        return {
                            name: type,
                            value: type
                        };
                    }));
                    vm.organizationType = vm.dropDowns.types[0];
                });
        }

        function getOrganizations(index, num, communityId, status) {
            vm.isLoading = true;
            return authentication.getOrganizationsAdmin({
                startingRowIndex: index,
                numberOfRows: num,
                volunteerOrganizationType: vm.organizationType ? vm.organizationType.value : undefined,
                communityAffiliationId: (((communityId !== null) && (communityId >= 0)) ? communityId : undefined),
                isActive: (_.isFinite(status) && (status >= 0)) ? status : undefined
            }).then(function (response) {
                return getOrganizationsSuccess(response, index, num);
            }).catch(function (err) {
                getOrganizationsError(err);
            });

            function getOrganizationsSuccess(response, index, num) {
                if (index === 0) {
                    vm.loadStatus.currentIndex = 0;
                    vm.organizations = [];
                }

                if (response.organizations.organizations) {
                    response = response.organizations;
                }

                // Either set current index to max if all users loaded or increment by rows loaded
                vm.loadStatus.currentIndex = (vm.loadStatus.currentIndex + num > response.count) ? response.count : (vm.loadStatus.currentIndex + num);
                // Track total number of users not loaded for "Load All" button
                vm.loadStatus.numResultsNotLoaded = response.count - vm.loadStatus.currentIndex;
                // Set text for "Load More" button
                vm.loadStatus.nextResultLoadNum = (response.count === vm.loadStatus.currentIndex) ? 0 :
                    (vm.loadStatus.numResultsNotLoaded > num) ? num : vm.loadStatus.numResultsNotLoaded;

                var organization = _.map(response.organizations, function (organization) {
                    return {
                        id: organization.volunteerOrganizationId,
                        group: {
                            id: organization.volunteerOrganizationGroupId,
                            name: organization.volunteerOrganizationGroup
                        },
                        type: organization.volunteerOrganizationType,
                        name: organization.volunteerOrganizationFullName,
                        description: organization.volunteerOrganizationDescription || '',
                        status: organization.isActive,
                        community: {
                            id: organization.communityAffiliationId,
                            name: organization.commArchived ? organization.communityAffiliation + " (inactive)" : organization.communityAffiliation
                        },
                        commArchived: organization.commArchived ? true : false,
                        standardOrganization: {
                            id: organization.volunteerOrganizationTemplateId,
                            name: organization.volunteerOrganizationTemplate
                        }
                    };
                });
                vm.organizations = vm.organizations.concat(organization);
                vm.isLoading = false;
                return response;
            }

            function getOrganizationsError(error) {
                if (angular.isDefined(error)) {
                    var errorStr = error.error ? error.error : error;
                    $scope.$emit('organizations:alert', errorStr);
                }
                else
                    $scope.$emit('organizations:alert', "Failed to load list! Please try again.");

                vm.isLoading = false;
            }
        }

        function onClickAddNewOrganization() {
            openModal('Add New Organization', { status: 1 });
        }

        function onClickEditOrganization(organization) {
            openModal('Edit Organization', organization);
        }

        function openModal(title, organization) {
            var modalInstance = $modal.open({
                templateUrl: 'app/components/administrator/organizations/editOrganizationForm.template.html',
                controller: 'EditOrganizationsController',
                controllerAs: 'vm',
                backdrop: 'static',
                keyboard: false,
                resolve: {
                    params: function () {
                        return {
                            organization: organization,
                            title: title,
                            communities: vm.communities,
                            commArchived: vm.commArchived
                        };
                    }
                }
            });

            // Process result from edit modal
            modalInstance.result.then(function () {
                vm.loadStatus.currentIndex = 0;
                vm.isLoading = true;
                return getOrganizations(vm.loadStatus.currentIndex, vm.loadStatus.defaultNumRows, vm.selectedCommunityId, vm.status);
            }).catch(displayError).finally(function (err) {
                getOrganizationsError(err);
            });
        }

        function onChangeStatus(status) {
            changeFilters(vm.selectedCommunityId, status);
        }

        function onChangeCommunity(communityId) {
            changeFilters(communityId, vm.status);
        }

        function onChangeType() {
            changeFilters(vm.selectedCommunityId, vm.status);
        }

        function changeFilters(communityId, status) {
            vm.loadStatus.currentIndex = 0;
            vm.isLoading = true;
            return getOrganizations(vm.loadStatus.currentIndex, vm.loadStatus.defaultNumRows, communityId, status)
                .catch(displayError).finally(function () {
                    vm.isLoading = false;
                });
        }

        function onCloseAlert(index) {
            vm.alerts.splice(index, 1);
        }

        function displayAlert(type, message) {
            vm.alerts.push({
                type: type,
                message: message
            });
        }

        function displayError(error) {
            vm.isLoading = false;
            if (error === 'cancel' || error === 'backdrop click') {
                return;
            }
            if (error) {
                displayAlert('alert', error);
            }
        }

        function onLoadMore() {
            getOrganizations(vm.loadStatus.currentIndex, vm.loadStatus.nextResultLoadNum, vm.selectedCommunityId, vm.status);
        }

        function onLoadAll() {
            getOrganizations(vm.loadStatus.currentIndex, vm.loadStatus.numResultsNotLoaded, vm.selectedCommunityId, vm.status);
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('vmis.administrator')
        .controller('EditOrganizationsController', EditOrganizationsController);

    EditOrganizationsController.$inject = ['$q', '$modalInstance', '$modal', '_', 'params', 'authentication', 'loadStatus', 'config'];

    function EditOrganizationsController($q, $modalInstance, $modal, _, params, authentication, loadStatus, config) {
        var vm = this;

        vm.isLoading = true;
        vm.isProductionWebsite = null;
        vm.bannerMessage = null;
        vm.organization = angular.copy(params.organization);
        vm.title = params.title;
        vm.commArchived = params.organization.commArchived;
        vm.isDerivedFromStandardOrganization = (angular.isDefined(params.organization.standardOrganization) && params.organization.standardOrganization.name !== "NONE");
        vm.dropDowns = {
            communities: params.communities,
            statuses: [
                {
                    name: "Active",
                    value: 1
                },
                {
                    name: "Inactive",
                    value: 0
                }
            ]
        };

        // If only one community possible, go ahead and select that one
        if (vm.dropDowns.communities.length === 1)
            vm.organization.communityId = vm.dropDowns.communities[0].id;

        vm.loadStatus = loadStatus.init();

        vm.onChangeStandardOrganization = onChangeStandardOrganization;
        vm.onSubmit = onSubmit;
        vm.isDeletable = isDeletable;
        vm.onClickDelete = onClickDelete;

        activate();

        function activate() {
            var promises = [getDropDownData(), getOrganizationGroups()];
            if (vm.organization.id) {
                promises.push(isDeletable(vm.organization.id).then(function (isDeletable) {
                    vm.showDelete = isDeletable;
                }));
                promises = $q.all(promises);
            } else {
                promises = $q.all(promises).then(getStandardOrganizations);
            }
            promises.catch(displayFormError).finally(function () {
                vm.isLoading = false;
            });
            config.get().then(function (configData) {
                vm.isProductionWebsite = configData.isProductionWebsite;
                vm.bannerMessage = configData.bannerMessage;
            });
        }

        function onSubmit() {
            var apiParams = {
                volunteerOrganizationId: vm.organization.id || undefined,
                volunteerOrganizationFullName: vm.organization.name === params.organization.name ? undefined : vm.organization.name,
                communityAffiliationId: vm.organization.communityId,
                volunteerOrganizationDescription: vm.organization.description,
                isActive: vm.organization.status,
                volunteerOrganizationGroup: vm.organization.group.name,
                volunteerOrganizationType: vm.organization.id ? undefined : vm.organization.type
            };

            if (_.has(vm.standardOrganization, 'id')) {
                _.assign(apiParams, {
                    volunteerOrganizationTemplateId: vm.organization.id ? undefined : vm.standardOrganization.id,
                    deriveFromStandardOrganization: true
                });
            }

            if (params.organization.status === 1 && vm.organization.status === 0) {
                var modalInstance = $modal.open({
                    templateUrl: 'app/components/administrator/organizations/confirmOrganizationInactive.template.html',
                    controller: 'ConfirmOrganizationInactiveController',
                    controllerAs: 'vm',
                    size: 'tiny',
                    backdrop: 'static',
                    keyboard: false,
                    resolve: {
                        organization: function () {
                            return vm.organization;
                        },
                        community: function () {
                            return null;
                        },
                        title: function () {
                            return "Inactivate Organization";
                        }
                    }
                });
                // Close edit window if confirm delete modal returned
                modalInstance.result.then(function () {
                    return authentication.setOrganizationInfo(apiParams).then($modalInstance.close).catch(displayFormError);
                }).then($modalInstance.close).catch(displayFormError);
            }

            else {
                return authentication.setOrganizationInfo(apiParams).then($modalInstance.close).catch(displayFormError);
            }
        }

        function isDeletable(id) {
            return authentication.getOpportunitiesAdmin({
                startingRowIndex: 0,
                numberOfRows: 1,
                volunteerOrganizationId: id
            }).then(function (response) {
                return response.count === 0;
            });
        }

        function onClickDelete() {
            var modalInstance = $modal.open({
                templateUrl: 'app/components/administrator/organizations/confirmOrganizationDelete.template.html',
                controller: 'ConfirmOrganizationDeleteController',
                controllerAs: 'vm',
                size: 'tiny',
                backdrop: 'static',
                keyboard: false,
                resolve: {
                    organization: function () {
                        return vm.organization;
                    }
                }
            });

            // Close edit window if confirm delete modal returned
            modalInstance.result.then(function () {
                return authentication.deleteOrganization({
                    volunteerOrganizationId: vm.organization.id
                });
            }).then($modalInstance.close).catch(displayFormError);
        }

        function getDropDownData() {
            var elements = [
                'volunteerorganizationtype'
            ];
            return authentication.getUiData(elements)
                .then(function (response) {
                    vm.dropDowns.types = response.volunteerorganizationtype;
                    vm.organization.type = params.organization.type || vm.dropDowns.types[0];
                });
        }

        function getOrganizationGroups() {
            // Get number of org groups to load initially
            return loadStatus.setup(vm.loadStatus, "organizationGroups").then(function () {
                // Get those org groups
                return authentication.getOrganizationGroups({
                    startingRowIndex: 0,
                    numberOfRows: vm.loadStatus.defaultNumRows
                }).then(function (response) {
                    var organizationGroups = response.organizationGroups;

                    // Update load status object
                    vm.loadStatus.currentIndex = response.organizationGroups.length < response.count ?
                        vm.loadStatus.defaultNumRows : response.organizationGroups.length;
                    vm.loadStatus.numResultsNotLoaded = response.count - vm.loadStatus.currentIndex;
                    vm.loadStatus.nextResultLoadNum = vm.loadStatus.numResultsNotLoaded;

                    // If more org groups, get them
                    if (vm.loadStatus.nextResultLoadNum > 0) {
                        return authentication.getOrganizationGroups({
                            startingRowIndex: vm.loadStatus.currentIndex,
                            numberOfRows: vm.loadStatus.nextResultLoadNum
                        }).then(function (response) {
                            return organizationGroups.concat(response.organizationGroups);
                        });
                    }
                    return organizationGroups;
                }).then(function (organizationGroups) {
                    vm.dropDowns.groups = _.map(organizationGroups, function (organizationGroup) {
                        return {
                            id: organizationGroup.volunteerOrganizationGroupId,
                            name: organizationGroup.volunteerOrganizationGroupName
                        };
                    });
                    vm.organization.group = vm.organization.group || vm.dropDowns.groups[0];
                });
            });
        }

        function getStandardOrganizations() {
            return authentication.getStandardOrganizations({
                getAll: true,
                isActive: true
            }).then(function (response) {
                var standardOrganizations = response.standardOrganizations;
                return standardOrganizations;
            }).then(function (standardOrganizations) {
                vm.dropDowns.standardOrganizations = _.map(standardOrganizations, function (standardOrganization) {
                    return {
                        id: standardOrganization.volunteerOrganizationTemplateId,
                        name: standardOrganization.volunteerOrganizationTemplateName,
                        description: standardOrganization.volunteerOrganizationDescription,
                        group: {
                            id: standardOrganization.volunteerOrganizationGroupId,
                            name: standardOrganization.volunteerOrganizationGroup
                        },
                        type: standardOrganization.volunteerOrganizationType
                    };
                });
                vm.dropDowns.standardOrganizations.unshift({
                    name: 'None',
                    fullName: '',
                    description: '',
                    group: vm.dropDowns.groups[0],
                    type: vm.dropDowns.types[0]
                });
                vm.standardOrganization = vm.dropDowns.standardOrganizations[0];
            });
        }

        function onChangeStandardOrganization() {
            _.assign(vm.organization, {
                type: vm.standardOrganization.type,
                group: vm.standardOrganization.group,
                name: vm.standardOrganization.name,
                description: vm.standardOrganization.description
            });
        }

        function displayFormError(error) {
            if (error === 'cancel' || error === 'ok' || error === 'backdrop click')
                return;
            if (error)
                vm.formError = error;
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('vmis.administrator')
        .controller('ConfirmOrganizationDeleteController', ConfirmOrganizationDeleteController);

    ConfirmOrganizationDeleteController.$inject = ['$modalInstance', 'organization'];

    function ConfirmOrganizationDeleteController($modalInstance, organization) {
        var vm = this;
        vm.title = "Delete Organization";

        vm.name = organization.name;

        vm.onAccept = onAccept;

        function onAccept() {
            $modalInstance.close();
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('vmis.administrator')
        .controller('ConfirmOrganizationInactiveController', ConfirmOrganizationInactiveController);

    ConfirmOrganizationInactiveController.$inject = ['$modalInstance', 'title', 'organization', 'community'];

    function ConfirmOrganizationInactiveController($modalInstance,title, organization, community) {
        var vm = this;
        vm.title = title;

        if(organization !== null) {
            vm.name = organization.name;
        }

        if(community !== null) {
            vm.name = community;
        }

        vm.onAccept = onAccept;

        function onAccept() {
            $modalInstance.close();
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('vmis.administrator')
        .controller('PositionsController', PositionsController);

    PositionsController.$inject = ['_', '$modal', '$q', '$scope', '$timeout', 'authentication', 'utilsServices', 'loadStatus'];

    function PositionsController(_, $modal, $q, $scope, $timeout, authentication, utilsServices, loadStatus) {
        var vm = this;

        vm.isLoading = true;
        vm.sortReverse = true;
        vm.sortColumn = 'postedDate';
        vm.loadStatus = loadStatus.init();

        vm.positions = [];
        vm.responsibilities = [];
        vm.title = '';

        vm.onClickSearch = onClickSearch;
        vm.onPositionClick = onPositionClick;
        vm.onStatusChange = onStatusChange;
        vm.onLoadMore = onLoadMore;
        vm.onLoadAll = onLoadAll;

        vm.disableOrgDropDown = disableOrgDropDown;

        vm.respOrgs = [];
        vm.organizations = [];
        vm.communities = [];
        vm.filterName = undefined;
        vm.selectedOrganization = {};
        vm.selectedCommunity = {};
        vm.avccCommunities = [];
        vm.statuses = [];

        vm.onCommunityChange = onCommunityChange;
        vm.onOrganizationChange = onOrganizationChange;

        activate();

        function activate() {
            loadStatus.setup(vm.loadStatus, "positions")
                .then(function () {
                    authentication.getUiData(['volunteerpositionstatus']).then(function (response) {
                        vm.statuses = response.volunteerpositionstatus;
                        vm.statuses.unshift("All");
                        vm.status = vm.statuses[0];
                    });
                    getCommunities();
                });
        }

        function onPositionClick(positionId) {
            $modal.open({
                templateUrl: 'app/components/administrator/positions/positionDetails.view.html',
                controller: 'PositionDetailsController',
                controllerAs: 'vm',
                backdrop: 'static',
                keyboard: false,
                resolve: {
                    isClonedPosition: function () {
                        return false;
                    },
                    positionId: function () {
                        return positionId;
                    },
                    title: function () {
                        return positionId ? 'Position Details' : 'Add New Position';
                    }
                }
            }).result.then(function (result) {
                if (result.clonePosition === true) {
                    setTimeout(
                        function () {
                            var cloneModal = $modal.open({
                                templateUrl: 'app/components/administrator/positions/positionDetails.view.html',
                                controller: 'PositionDetailsController',
                                controllerAs: 'vm',
                                backdrop: 'static',
                                keyboard: false,
                                resolve: {
                                    isClonedPosition: function () {
                                        return true;
                                    },
                                    positionId: function () {
                                        return positionId;
                                    },
                                    title: function () {
                                        return 'Update Fields for Cloned Position';
                                    }
                                }
                            });

                            cloneModal.result.then(function () {
                                getPositions(0, 200, vm.status);
                            }, function () {
                                getPositions(0, 200, vm.status);
                            });
                        },
                        250
                    );
                }
                else {
                    getPositions(0, 200, vm.status);
                }
            });
            // modalInstance.result
            //To Do: Add in error checking
        }

        function onStatusChange() {
            vm.loadStatus.currentIndex = 0;
            getPositions(vm.loadStatus.currentIndex, vm.loadStatus.defaultNumRows);
        }

        function onCommunityChange() {
            var promise = vm.selectedCommunity.organizations === null ? fillCommOrgs() : $q.when();
            return promise.then(function () {
                vm.loadStatus.currentIndex = 0;
                vm.selectedOrganization = vm.selectedCommunity.organizations[0];
                return getPositions(vm.loadStatus.currentIndex, vm.loadStatus.defaultNumRows);
            });

            function fillCommOrgs() {
                return authentication.getOrganizations({
                    communityAffiliationId: vm.selectedCommunity.id,
                    getAll: true
                }).then(function (response) {
                    var organizations = _.map(response.organizations, function (organization) {
                        return {
                            id: organization.volunteerOrganizationId,
                            name: organization.organizationName
                        };
                    });
                    if (_.isArray(organizations) && organizations.length !== 1) {
                        organizations.unshift({
                            name: "All"
                        });
                    }
                    vm.selectedCommunity.organizations = organizations;
                }).catch(function (error) {
                    $scope.$emit('people:alert', error);
                    vm.isLoading = false;
                });
            }
        }

        function onOrganizationChange() {
            vm.isLoading = true;
            vm.loadStatus.currentIndex = 0;

            if (!angular.isDefined(vm.selectedOrganization.id))
                vm.sortColumn = 'organization.name';
            else
                vm.sortColumn = 'title';

            vm.sortReverse = false;

            return getPositions(vm.loadStatus.currentIndex, vm.loadStatus.defaultNumRows);
        }

        function onClickSearch() {
            return getPositions(0, vm.loadStatus.defaultNumRows);
        }

        function getPositions(index, num) {
            vm.isLoading = true;
            return authentication.getOpportunitiesAdmin({
                startingRowIndex: index,
                numberOfRows: num,
                volunteerPositionStatus: (vm.status !== "All") ? vm.status : undefined,
                communityAffiliationId: vm.selectedCommunity.id || undefined,
                volunteerOrganizationId: vm.selectedOrganization.id || undefined,
                title: vm.filterName ? vm.filterName : undefined
            }).then(function (response) {
                getPositionsSuccess(response, index, num);
            }).catch(function (err) {
                getPositionsError(err);
            }).finally(function () {
                $timeout(function () {
                    vm.isLoading = false;
                }, 100);
            });
        }

        function getPositionsSuccess(response, index, num) {
            if (index === 0) {
                vm.loadStatus.currentIndex = 0;
                vm.positions = [];
            }

            // Either set current index to max if all users loaded or increment by rows loaded
            vm.loadStatus.currentIndex = (vm.loadStatus.currentIndex + num > response.count) ? response.count : (vm.loadStatus.currentIndex + num);
            // Track total number of users not loaded for "Load All" button
            vm.loadStatus.numResultsNotLoaded = response.count - vm.loadStatus.currentIndex;
            // Set text for "Load More" button
            vm.loadStatus.nextResultLoadNum = (response.count === vm.loadStatus.currentIndex) ? 0 :
                (vm.loadStatus.numResultsNotLoaded > num) ? num : vm.loadStatus.numResultsNotLoaded;

            var position = _.map(response.opportunities, function (position) {
                return {
                    id: position.volunteerOrganizationOpportunityId,
                    title: position.title,
                    organization: {
                        id: position.volunteerOrganizationId,
                        name: position.orgActive ? position.volunteerOrganization : position.volunteerOrganization + " (inactive)"
                    },
                    postedDate: new Date(position.postedDate),
                    closedDate: position.closedDate ? new Date(position.closedDate) : null,
                    status: position.volunteerPositionStatus,
                    totalApplicants: position.applicationCount
                };
            });



            vm.positions = vm.positions.concat(position);
            vm.isLoading = false;
        }

        function getPositionsError(error) {
            if (angular.isDefined(error)) {
                var errorStr = error.error ? error.error : error;
                $scope.$emit('hours:alert', errorStr);
            }
            else
                $scope.$emit('hours:alert', "Failed to load list! Please try again.");

            vm.isLoading = false;
        }

        function onLoadMore() {
            getPositions(vm.loadStatus.currentIndex, vm.loadStatus.nextResultLoadNum);
        }

        function onLoadAll() {
            getPositions(vm.loadStatus.currentIndex, vm.loadStatus.numResultsNotLoaded);
        }

        function getCommunities() {
            return authentication.getUserProfile().then(function (response) {
                return utilsServices.combineCommunityResponsibilities(response, ['AVC OPOC', 'AVC Coordinator']);
            }).then(function (communities) {
                // Use lack of ID as cue for this entry
                if (_.isArray(communities) && communities.length !== 1) {
                    vm.communities.unshift({
                        name: "All",
                        organizations: []
                    });
                }
                _.forEach(communities, function (community) {
                    if (_.isArray(community.organizations) && community.organizations.length !== 1) {
                        community.organizations.unshift({
                            name: 'All'
                        });
                    }
                });
                vm.communities = communities;
                vm.selectedCommunity = vm.communities[0];
                return onCommunityChange();
            });
        }

        function disableOrgDropDown() {
            return vm.isLoading || !angular.isDefined(vm.selectedCommunity.id);
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('vmis.administrator')
        .controller('PositionDetailsController', PositionDetailsController);

    PositionDetailsController.$inject = ['_', '$q', '$state', '$window', 'isClonedPosition', 'positionId', 'title', '$modal', '$modalInstance', 'authentication', 'moment', 'config'];

    function PositionDetailsController(_, $q, $state, $window, isClonedPosition, positionId, title, $modal, $modalInstance, authentication, moment, config) {
        var vm = this;

        var positionTypes = [
            [], // AVC
            ['None'], // Private Organization
            ['None'] // Non-AVC
        ];
        var organizationTypes = [];

        vm.isProductionWebsite = null;
        vm.bannerMessage = null;

        vm.isClone = isClonedPosition;
        vm.isLoading = true;
        vm.isOrgActive = true;
        vm.title = title;
        vm._ = _;
        vm.dropDowns = {
            booleanOptions: [{
                label: 'No',
                value: false
            }, {
                label: 'Yes',
                value: true
            }]
        };
        vm.position = {
            id: positionId,
            supervisors: _.map(new Array(2), function () {
                return {
                    name: '',
                    email: '',
                    phone: ''
                };
            })
        };

        vm.onDelete = onDelete;
        vm.onSave = onSave;
        vm.onChangeCountry = onChangeCountry;
        vm.onChangeCommunity = onChangeCommunity;
        vm.onChangeOrganization = onChangeOrganization;
        vm.onClickClone = onClickClone;
        vm.onPrint = onPrint;
        vm.disableOrgDropDown = disableOrgDropDown;
        vm.startDate = moment().add(1,'day').toDate();

        activate();

        function activate() {
            // initializeNewPosition() can call onChangeCommunity(), which requires drop down data
            getDropDownData().then(function () {
                var positionPromise = null;
                if (vm.isClone === false) {
                    positionPromise = positionId ? getDetails(positionId) : initializeNewPosition();

                    $q.all([
                        positionPromise
                    ]).then(function () {
                        if (vm.position.organization) {
                            vm.dropDowns.positionTypes = positionTypes[vm.position.organization.type.id];
                        }

                        if (vm.position.address) {
                            onChangeCountry(vm.position.address.country);
                        }

                        vm.isLoading = false;
                    })
                        .catch(displayError);
                }
                // this means we're cloning an existing
                else {
                    positionPromise = initializeNewPosition().then(function () {
                        return getDetails(positionId);
                    });

                    $q.all([
                        positionPromise
                    ]).then(function () {

                        if (vm.position.organization) {
                            vm.dropDowns.positionTypes = positionTypes[vm.position.organization.type.id];
                        }

                        if (vm.position.address) {
                            onChangeCountry(vm.position.address.country);
                        }

                        // fill in community, organization
                        vm.position.community = _.find(vm.dropDowns.communities, function (communityElem) {
                            return communityElem.name === vm.position.organization.community.name;
                        });
                        var theOrganization = vm.position.organization;
                        onChangeCommunity(vm.position.community).then(function () {
                            vm.position.organization = _.find(vm.position.community.organizations, function (orgElem) {
                                return theOrganization.name === orgElem.name;
                            });
                        });

                        // always make cloned status "Open, searchable"
                        vm.position.status = "Open, searchable";

                        vm.position.id = null;
                        positionId = null;
                        vm.position.title = null;
                        vm.position.closedDate = null;
                        vm.isLoading = false;
                        vm.position.hasApplications = false;
                        vm.isLoading = false;

                        vm.ignoreInvalid = false;
                    })
                        .catch(displayError);
                }
            });

            config.get().then(function (configData) {
                vm.isProductionWebsite = configData.isProductionWebsite;
                vm.bannerMessage = configData.bannerMessage;
            });
        }

        function getDetails(positionId) {
            var params = {
                volunteerOpportunityId: positionId
            };

            return authentication.getOpportunityDetails(params)
                .then(function (response) {
                    vm.isOrgActive = response.organization.isActive ? true : false;
                    vm.position = {
                        id: response.volunteerOrganizationOpportunityId,
                        organization: {
                            name: response.organization.isActive ? response.organization.volunteerOrganizationFullName : response.organization.volunteerOrganizationFullName + " (inactive)",
                            type: {
                                name: response.organization.volunteerOrganizationType,
                                id: response.organization.volunteerOrganizationTypeId - 1
                            },
                            community: {
                                name: response.organization.communityAffiliation.communityAffiliationName
                            }
                        },
                        title: response.title,
                        closedDate: response.closedDate ? moment(response.closedDate, 'YYYY-MM-DD').toDate() : '',
                        keywords: response.keywords || '',
                        positionType: response.volunteerPositionType,
                        opportunityType: response.volunteerOpportunityType,
                        status: response.volunteerPositionStatus,
                        backgroundCheckRequired: !!response.isBackgroundCheckRequired,
                        supervisionRequired: !!response.supervisionConditionFlag,
                        summary: response.summary || '',
                        duties: response.duties,
                        qualifications: response.qualifications,
                        training: response.training,
                        orientation: response.orientation,
                        timeRequired: response.timeRequired,
                        evaluation: response.evaluation || '',
                        benefits: response.benefits || '',
                        address: {
                            country: response.country,
                            line1: response.address1,
                            line2: response.address2 || '',
                            city: response.city,
                            state: response.usState,
                            zipCode: response.zipCode
                        },
                        supervisors: [{
                            name: response.firstLineSupervisorName || '',
                            email: response.firstLineSupervisorEmail || '',
                            phone: response.firstLineSupervisorPhone || ''
                        }, {
                            name: response.secondLineSupervisorName || '',
                            email: response.secondLineSupervisorEmail || '',
                            phone: response.secondLineSupervisorPhone || ''
                        }],
                        hasApplications: response.volunteerApplications.length > 0
                    };

                    // give the user a one time shot at submitting invalid values if the title
                    // is empty
                    vm.ignoreInvalid = vm.position.title.length === 0;
                    vm.isVolunteerSubmitted = response.volunteerOrganization === 'Volunteer Submitted';
                });
        }

        function initializeNewPosition() {
            var communities = [];
            return authentication.getUserProfile().then(function (response) {
                var adminProfile = response.aosUser.vmisUser.adminProfile;

                //get Coordinator communities
                if (adminProfile.responsibilities.avcc) {
                    communities = _.map(adminProfile.responsibilities.avcc, function (community) {
                        return {
                            id: community.communityAffiliationId,
                            name: community.communityAffiliationName
                        };
                    });
                }

                //get OPOC organizations
                if (adminProfile.responsibilities.opoc) {
                    _.forEach(adminProfile.responsibilities.opoc, function (community) {
                        if (_.some(communities, { id: community.communityAffiliationId }) === false) {
                            communities.push({
                                id: community.communityAffiliationId,
                                name: community.communityAffiliationName,
                                opocOrganizations: _.map(community.organizations, function (organization) {
                                    return {
                                        id: organization.volunteerOrganizationId
                                    };
                                })
                            });
                        }
                    });
                }

                vm.dropDowns.communities = _.sortBy(communities, ['name']);

                // If only one community, go ahead and select it
                if (vm.dropDowns.communities.length === 1) {
                    vm.position.community = vm.dropDowns.communities[0];
                    onChangeCommunity(vm.position.community);
                }
            });
        }

        function onSave() {
            if (vm.position.id) {
                $modal.open({
                    templateUrl: 'app/components/administrator/positions/confirmation.template.html',
                    controller: 'ConfirmationController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    keyboard: false,
                    resolve: {
                        title: function () {
                            return 'Confirm Changes';
                        },
                        body: function () {
                            return 'Are you sure you want to save changes to ' + vm.position.title + '?';
                        }
                    },
                    size: 'tiny'
                }).result.then(onConfirm);
            } else {
                onConfirm();
            }
        }

        function onConfirm() {
            vm.isLoading = true;
            // Note: title, position type, background check required, and supervision required are prevented from
            // being changed in the UI (both disabled inputs and below) if there are applications for the position.

            if(angular.isDefined(vm.position.address.state) && vm.position.address.state !== null){
               var testString = vm.position.address.state.substring(vm.position.address.state.length-5);

               if(testString.substring(0,2) === ' (' && testString.substring(testString.length-1) === ')'){
                   vm.position.address.state = vm.position.address.state.substring(0,vm.position.address.state.length-5);
               }
            }

            var params = {
                volunteerOrganizationOpportunityId: vm.position.id ? vm.position.id : undefined,
                volunteerOrganizationId: vm.position.id ? undefined : vm.position.organization.id,
                title: (vm.position.hasApplications && !vm.ignoreInvalid) ? undefined : vm.position.title,
                closedDate: vm.position.closedDate ? moment(vm.position.closedDate).format('YYYY-MM-DD[T00:00:00Z]') : null,
                keywords: vm.position.keywords,
                volunteerPositionType: vm.position.hasApplications ? undefined : vm.position.positionType,
                volunteerOpportunityType: vm.position.opportunityType,
                volunteerPositionStatus: vm.isOrgActive ? vm.position.status : "Closed",
                isBackgroundCheckRequired: vm.position.hasApplications ? undefined : vm.position.backgroundCheckRequired,
                supervisionConditionFlag: vm.position.hasApplications ? undefined : vm.position.supervisionRequired,
                summary: vm.position.summary,
                duties: vm.position.duties,
                qualifications: vm.position.qualifications,
                training: vm.position.training,
                orientation: vm.position.orientation,
                timeRequired: vm.position.timeRequired,
                evaluation: vm.position.evaluation,
                benefits: vm.position.benefits,
                country: vm.position.address.country,
                address1: vm.position.address.line1,
                address2: vm.position.address.line2,
                city: vm.position.address.city,
                usState: vm.position.address.state,
                zipCode: vm.position.address.zipCode,
                firstLineSupervisorName: vm.position.supervisors[0].name,
                firstLineSupervisorEmail: vm.position.supervisors[0].email,
                firstLineSupervisorPhone: vm.position.supervisors[0].phone,
                secondLineSupervisorName: vm.position.supervisors[1].name,
                secondLineSupervisorEmail: vm.position.supervisors[1].email,
                secondLineSupervisorPhone: vm.position.supervisors[1].phone
            };

            return authentication
                .setOpportunity(params).then(function(res) {
                        if (res && res.success === true && res.volunteerOrganizationOpportunityId) {
                            return authentication
                                .geocodeOpportunity(res.volunteerOrganizationOpportunityId)
                                .catch(function(err) {
                                    //TBD: Add this alert back in when VMIS On the Go is fully rolled-out
                                    //alert("Current Address could not be geolocated. This means that it may not appear in VMIS On the Go. If you would like this position to appear in VMIS on the Go, please check and update the address.");
                                    console.error('Geocode error: ', err);
                                })
                                .finally($modalInstance.close);
                        }
                    }
                )
                .catch(displayError);
        }

        function getDropDownData() {
            var elements = [
                'usstate',
                'stateabbrev',
                'country',
                'volunteerpositiontype',
                'volunteeropportunitytype',
                'volunteerpositionstatus',
                'volunteerorganizationtype'
            ];

            return authentication.getUiData(elements).then(function (response) {
                vm.dropDowns.states = authentication.createStateList(response.usstate,response.stateabbrev);
                vm.dropDowns.countries = response.country;
                positionTypes[0] = response.volunteerpositiontype;
                positionTypes[0].pop();
                vm.dropDowns.opportunityTypes = response.volunteeropportunitytype;
                vm.dropDowns.statuses = response.volunteerpositionstatus;
                organizationTypes = response.volunteerorganizationtype;
            });
        }

        function onDelete() {
            $modal.open({
                templateUrl: 'app/components/administrator/positions/confirmation.template.html',
                controller: 'ConfirmationController',
                controllerAs: 'vm',
                backdrop: 'static',
                keyboard: false,
                resolve: {
                    title: function () {
                        return 'Confirm to Delete Position';
                    },
                    body: function () {
                        return 'Are you sure you want to delete ' + vm.position.title + '?';
                    }
                }
            }).result.then(function () {
                authentication.deleteOpportunity({
                    opportunityId: vm.position.id
                }).then($modalInstance.close)
                    .catch(displayError);
            });
        }

        function displayError(error) {
            vm.formError = error;
            vm.isLoading = false;
        }

        function onChangeCommunity(community) {
            vm.position.organization = undefined;

            vm.isLoading = true;
            return authentication.getOrganizations({
                communityAffiliationId: community.id,
                getAll: true
            }).then(function (response) {
                var organizations = _.sortBy(_.map(_.filter(response.organizations, function (organization) {
                    return organization.organizationName !== 'Volunteer Submitted';
                }), function (organization) {
                    return {
                        id: organization.volunteerOrganizationId,
                        name: organization.organizationName,
                        type: {
                            name: organization.volunteerOrganizationType,
                            id: _.indexOf(organizationTypes, organization.volunteerOrganizationType)
                        }
                    };
                }), ['name']);

                community.organizations = _.isUndefined(community.opocOrganizations) ? organizations : _.intersectionBy(organizations, community.opocOrganizations, 'id');
                vm.isLoading = false;
            });
        }

        function onChangeOrganization(organization) {
            if (_.isEqual(vm.dropDowns.positionTypes, positionTypes[organization.type.id]) === false) {
                vm.dropDowns.positionTypes = positionTypes[organization.type.id];
                vm.position.positionTypeId = undefined;
            }

            vm.isOrgActive = true;

            if (organization.name.length > 11) {
                var suffix = organization.name.substring(organization.name.length - 11);
                if (suffix === " (inactive)") {
                    vm.isOrgActive = false;
                }
            }

            if (!vm.isOrgActive) {
                vm.position.status = "Closed";
            }

        }

        function onChangeCountry(country) {
            vm.isStateRequired = country === 'United States';
            if (!vm.isStateRequired) {
                vm.position.address.state = undefined;
            }
        }

        function onClickClone() {
            $modalInstance.close({ clonePosition: true });
        }

        function onPrint() {
            var printHref = $state.href("print.position", { id: vm.position.id }, { absolute: true });
            $window.open(printHref.replace("#", "print.html#"), "Print");
        }

        function disableOrgDropDown() {
            return vm.isLoading || (!angular.isDefined(vm.position.community) || vm.position.community === null);
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('vmis.administrator')
        .controller('ConfirmationController', ConfirmationController);

    ConfirmationController.$inject = ['$modalInstance', 'title', 'body'];

    function ConfirmationController($modalInstance, title, body) {
        var vm = this;

        vm.body = body;
        vm.title = title;

        vm.onCancel = onCancel;
        vm.onConfirm = onConfirm;

        activate();

        function activate() {
        }

        function onConfirm() {
            $modalInstance.close();
        }

        function onCancel() {
            $modalInstance.dismiss('cancel');
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('vmis.administrator')
        .controller('PeopleController', PeopleController);

    PeopleController.$inject = ['$stateParams', '$scope', '$location', '$state', 'params'];

    function PeopleController($stateParams, $scope, $location, $state, params) {
        var vm = this;

        vm.isLoading = true;

        vm.alerts = [];

        vm.roleObjectList = params.roleObjectList;
        //vm.responsibilities = params.responsibilities;

        // Set initial drop down selection
        vm.selectedRoleObject = vm.roleObjectList[vm.roleObjectList.length - 1];
        // If state parameter, attempt to use it as initial role
        var initRoleStr = $stateParams.role;
        if (initRoleStr) {
            var initRole = vm.roleObjectList.filter(function (role) {
                return role.shortName.toLowerCase() === initRoleStr.toLowerCase();
            })[0];
            if (initRole)
                vm.selectedRoleObject = initRole;
        }

        $scope.$on('people:role', selectRoleHandler);
        $scope.$on('people:success', successHandler);
        $scope.$on('people:alert', alertHandler);

        vm.onSelectRole = onSelectRole;
        vm.onCloseAlert = onCloseAlert;

        activate();

        function activate() {
            vm.isLoading = false;
        }

        function onSelectRole(newRole) {
            vm.selectedRoleObject = vm.roleObjectList.filter(function (role) {
                return role.name === newRole.name;
            })[0];

            $location.search({}); // Remove filtering parameters when switching roles
            $location.path($location.path().substring(0, $location.path().lastIndexOf('/') + 1) +
                vm.selectedRoleObject.shortName.toLowerCase());
        }

        function selectRoleHandler(event, role) {
            event.stopPropagation();

            onSelectRole(role);
        }

        function successHandler(event, message) {
            event.stopPropagation();

            displayAlert('success', message);
        }

        function alertHandler(event, message) {
            event.stopPropagation();

            displayError(message);
        }

        function onCloseAlert(index) {
            vm.alerts.splice(index, 1);
        }

        function displayAlert(type, message) {
            vm.alerts.push({
                type: type,
                message: message
            });
        }

        function displayError(error) {
            if (error === 'cancel' || error === 'backdrop click')
                return;
            if (error)
                displayAlert('alert', error);
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('vmis.administrator')
        .config(routes);

    routes.$inject = ['$stateProvider'];

    function routes($stateProvider) {
        $stateProvider
            .state('vmis.administrator.people', {
                url: '/people/{role}',
                title: 'People',
                views: {
                    "@vmis.administrator": {
                        templateUrl: 'app/components/administrator/people/people.view.html',
                        controller: 'PeopleController',
                        controllerAs: 'vm'
                    },
                    "volunteers@vmis.administrator.people": {
                        templateUrl: 'app/components/administrator/people/volunteers/volunteers.view.html',
                        controller: 'VolunteersController',
                        controllerAs: 'vm'
                    },
                    "opocs@vmis.administrator.people": {
                        templateUrl: 'app/components/administrator/people/opocs/opocs.view.html',
                        controller: 'OPOCsController',
                        controllerAs: 'vm'
                    },
                    "coordinatorAssistants@vmis.administrator.people": {
                        templateUrl: 'app/components/administrator/people/coordinatorAssistants/coordinatorAssistants.view.html',
                        controller: 'CoordinatorAssistantsController',
                        controllerAs: 'vm'
                    },
                    "coordinators@vmis.administrator.people": {
                        templateUrl: 'app/components/administrator/people/coordinators/coordinators.view.html',
                        controller: 'CoordinatorsController',
                        controllerAs: 'vm'
                    },
                    "regionManagers@vmis.administrator.people": {
                        templateUrl: 'app/components/administrator/people/regionManagers/regionManagers.view.html',
                        controller: 'RegionManagersController',
                        controllerAs: 'vm'
                    },
                    "programManagers@vmis.administrator.people": {
                        templateUrl: 'app/components/administrator/people/programManagers/programManagers.view.html',
                        controller: 'ProgramManagersController',
                        controllerAs: 'vm'
                    },
                    "global@vmis.administrator.people": {
                        templateUrl: 'app/components/administrator/people/global/global.view.html',
                        controller: 'GlobalUserSearchController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    params: ['authentication', function (authentication) {
                        var params = {
                            roleObjectList: [],
                            responsibilities: {},
                            isProgramManager: false,
                            masterUserId: -1
                        };

                        // Used for creating isPMAndNotAVCC
                        var isAVCC = false;

                        var completeRoleObjectList = [
                            {
                                shortName: "Vol",
                                name: "Volunteer",
                                vmisUserRolesName: "AVC Volunteer"
                            },
                            {
                                shortName: "OPOC",
                                name: "OPOC",
                                responsibilitiesName: "opoc",
                                vmisUserRolesName: "AVC OPOC"
                            },
                            {
                                shortName: "AVCCAssistant",
                                name: "AVCC Assistant",
                                responsibilitiesName: "avccAssistant",
                                vmisUserRolesName: "AVC Coordinator Assistant"
                            },
                            {
                                shortName: "AVCC",
                                name: "AVCC",
                                responsibilitiesName: "avcc",
                                vmisUserRolesName: "AVC Coordinator"
                            },
                            {
                                shortName: "RM",
                                name: "Region Manager",
                                responsibilitiesName: "rm",
                                secondResponsibilitiesName: "rmManaged",
                                vmisUserRolesName: "AVC Region Manager"
                            },
                            {
                                shortName: "PM",
                                name: "Program Manager",
                                vmisUserRolesName: "AVC Program Manager"
                            },
                            {
                                shortName: "global",
                                name: "Global Lookup",
                                vmisUserRolesName: "Global User Lookup"
                            }
                        ];

                        return authentication.getUserProfile()
                            .then(function (response) {
                                params.masterUserId = response.masterUserId;
                                params.responsibilities = response.aosUser.vmisUser.adminProfile ?
                                    response.aosUser.vmisUser.adminProfile.responsibilities : null;

                                // Note: this detects what roles the ACTIVE USER has.
                                // Different roles are modifiable based on that.
                                for (var i = 0; i < response.roles.vmisUserRoles.length; i++) {
                                    // Depending on the active user role, save data about their responsibilities
                                    // to display in drop downs and populate the drop down for the types of roles
                                    // they can modify.
                                    switch (response.roles.vmisUserRoles[i]) {
                                        case "AVC Program Manager":
                                            addRoleAvoidDuplicates(getRoleObjectByVmisUserRolesName("Global User Lookup"));
                                            addRoleAvoidDuplicates(getRoleObjectByVmisUserRolesName("AVC Program Manager"));
                                            addRoleAvoidDuplicates(getRoleObjectByVmisUserRolesName("AVC Region Manager"));
                                            addRoleAvoidDuplicates(getRoleObjectByVmisUserRolesName("AVC Coordinator"));
                                            params.isProgramManager = true;
                                            break;
                                        case "AVC Region Manager":
                                            addRoleAvoidDuplicates(getRoleObjectByVmisUserRolesName("AVC Coordinator"));
                                            break;
                                        case "AVC Coordinator":
                                            addRoleAvoidDuplicates(getRoleObjectByVmisUserRolesName("AVC Volunteer"));
                                            addRoleAvoidDuplicates(getRoleObjectByVmisUserRolesName("AVC Coordinator Assistant"));
                                            addRoleAvoidDuplicates(getRoleObjectByVmisUserRolesName("AVC OPOC"));
                                            isAVCC = true;
                                            break;
                                        case "AVC Coordinator Assistant":
                                            addRoleAvoidDuplicates(getRoleObjectByVmisUserRolesName("AVC Volunteer"));
                                            break;
                                        case "AVC OPOC":
                                            addRoleAvoidDuplicates(getRoleObjectByVmisUserRolesName("AVC Volunteer"));
                                            break;
                                        default:
                                            break;
                                    }
                                }

                                params.isPMAndNotAVCC = params.isProgramManager && !isAVCC;

                                return params;
                            })
                            .catch(function (error) {
                                console.log(error); // TODO: Improve
                                return params;
                            });

                        // Return the role object that matches the "vmisUserRolesName" string
                        // Searches complete list because used for setup
                        function getRoleObjectByVmisUserRolesName(vmisUserRolesName) {
                            return completeRoleObjectList.filter(function (element) {
                                return (element.vmisUserRolesName === vmisUserRolesName);
                            })[0];
                        }

                        function addRoleAvoidDuplicates(role) {
                            // If current role cannot be found in list, add it
                            if (!getRoleObject(role.name)) {
                                params.roleObjectList.push(role);
                            }
                        }

                        // Return the role object in the current list that matches the "name" string
                        function getRoleObject(name) {
                            return params.roleObjectList.filter(function (element) {
                                return (element.name === name);
                            })[0];
                        }
                    }]
                }
            });
    }
})();

(function () {
    'use strict';

    angular
        .module('vmis.administrator')
        .controller('VolunteersController', VolunteersController);

    VolunteersController.$inject = ['$q', '$modal', '$state', '$window', '$scope', '$location', '$timeout', 'authentication', 'loadStatus', 'params', 'moment', '_'];

    function VolunteersController($q, $modal, $state, $window, $scope, $location, $timeout, authentication, loadStatus, params, moment, _) {
        var vm = this;

        vm.isLoading = true;
        vm.roleObjectList = angular.copy(params.roleObjectList);
        vm.responsibilities = angular.copy(params.responsibilities);
        vm.includeFloatingUsers = false;
        vm.isFloatingUsersEnabled = false;

        vm.excludeNonAppliedVolunteers = true;

        // Ideally should compare with roles object in profile, but only passed in responsibilities.
        var isOPOC = angular.isDefined(vm.responsibilities.opoc);
        var isAVCCAssistant = angular.isDefined(vm.responsibilities.avccAssistant);
        vm.isAVCC = angular.isDefined(vm.responsibilities.avcc);
        // If viewing volunteers and not AVCC/Assistant, only show users related to organizations responsible for
        var isOnlyOPOC = isOPOC && !isAVCCAssistant && !vm.isAVCC;
        vm.isOnlyAVCCAssistant = !isOPOC && isAVCCAssistant && !vm.isAVCC;

        vm.selectedRoleObject = vm.roleObjectList.filter(function (role) {
            return role.name === "Volunteer";
        })[0];
        vm.numUsersSelected = 0;
        vm.searchFilter = {
            fullName: $location.search().name || ''
        };
        vm.isExporting = false;

        vm.filter = {
            selectedCommunity: _.parseInt($location.search().community) || undefined,
            selectedOrganizations: $location.search().organization || undefined,
            lastName: $location.search().lastName || '',
            firstName: $location.search().firstName || '',
            isActive: $location.search().isActive ? $location.search().isActive !== 'false' : undefined,
            startDate: isNaN(new Date($location.search().startDate)) ? undefined : new Date($location.search().startDate),
            endDate: isNaN(new Date($location.search().endDate)) ? undefined : new Date($location.search().endDate),
            floatingUsers: $location.search().floatingUsers || '',
            volunteerEmail: $location.search().volunteerEmail || undefined,
            excludeNonAppliedVolunteers: $location.search().excludeNonAppliedVolunteers || '',
            startingRowIndex: _.parseInt($location.search().startingRowIndex) || undefined,
            numberOfRows: _.parseInt($location.search().numberOfRows) || undefined
        };

        if(!vm.filter.startingRowIndex || !vm.filter.numberOfRows){
            vm.filter.startingRowIndex=undefined;
            vm.filter.numberOfRows=undefined;
        }

        vm.isCustomPaging = angular.isDefined(vm.filter.startingRowIndex) && angular.isDefined(vm.filter.numberOfRows) && vm.filter.startingRowIndex !== null && vm.filter.numberOfRows !== null;

        if(vm.filter.selectedOrganizations !== undefined){
            if(Array.isArray(vm.filter.selectedOrganizations)){
                vm.filter.selectedOrganizations.forEach(function(value,index){
                    vm.filter.selectedOrganizations[index] = _.parseInt(value);
                });
            }
            else {
                vm.filter.selectedOrganizations = [_.parseInt(vm.filter.selectedOrganizations)];
            }
        }

        if(!vm.isCustomPaging) {
            vm.loadStatus = loadStatus.init();
        }
        else {
            vm.totalResults = 0;
        }

        vm.sortColumn = 'aosUser.lastName';
        vm.sortReverse = false;

        vm.usersWithRole = [];

        vm.onSelectRole = onSelectRole;
        vm.onClickFilterUsers = onClickFilterUsers;
        vm.onClickSearch = onClickSearch;
        vm.onClickAddNewNonUser = onClickAddNewNonUser;
        vm.onCheckAll = onCheckAll;
        vm.onCheckUser = onCheckUser;
        vm.onClickEditVol = onClickEditVol;
        vm.onLoadMore = onLoadMore;
        vm.onLoadAll = onLoadAll;
        vm.massActionDisabled = massActionDisabled;
        vm.onCheckIncludeFloatingUsers = onCheckIncludeFloatingUsers;
        vm.onCheckExcludeNonAppliedVolunteers = onCheckExcludeAppliedVolunteers;

        activate();

        function activate() {
            determineStateOfFloatingUserCheckBox();
            determineStateOfExcludeNonAppliedVolunteers ();

            vm.massActions = [
                {
                    name: "Export",
                    action: onExport
                },
                {
                    name: "Mass Email",
                    action: onMassEmail
                }
            ];

            if(!vm.isCustomPaging) {
                loadStatus.setup(vm.loadStatus, "users")
                    .then(function () {
                        fillCommunities();
                    });
            }

            else {
                fillCommunities();
            }
        }

        function determineStateOfFloatingUserCheckBox() {
            // if we're only an opoc, then you will always see floating volunteers
            // because you're filtering on organization, not community
            if (isOnlyOPOC) {
                vm.includeFloatingUsers = true;
                vm.isFloatingUsersEnabled = false;
            }
            else {
                if (vm.filter.selectedOrganizations !== null && vm.filter.selectedOrganizations !== undefined) {
                    vm.includeFloatingUsers = true;
                    vm.isFloatingUsersEnabled = false;
                }
                else {
                    vm.isFloatingUsersEnabled = true;
                    vm.includeFloatingUsers = vm.filter.floatingUsers === 'true';
                }
            }
        }

        function onCheckIncludeFloatingUsers() {
            if (vm.includeFloatingUsers === true) {
                vm.filter.floatingUsers = 'true';
            }
            else {
                vm.filter.floatingUsers = '';
            }


            $location.search('floatingUsers', vm.filter.floatingUsers || null);


            if(!vm.isCustomPaging) {
                vm.loadStatus.currentIndex = 0;
                getUsers(vm.loadStatus.currentIndex, vm.loadStatus.defaultNumRows);
            }
            else {
                getUsers(vm.filter.startingRowIndex, vm.filter.numberOfRows);
            }
        }

        function determineStateOfExcludeNonAppliedVolunteers () {
            vm.excludeNonAppliedVolunteers = vm.filter.excludeNonAppliedVolunteers !== 'false';

            if(!(vm.filter.excludeNonAppliedVolunteers === 'false' || vm.filter.excludeNonAppliedVolunteers === 'true')){
                vm.filter.excludeNonAppliedVolunteers = '';
                $location.search('excludeNonAppliedVolunteers', null);
            }
        }

        function onCheckExcludeAppliedVolunteers() {
            if(vm.excludeNonAppliedVolunteers){
                vm.filter.excludeNonAppliedVolunteers = 'true';
            }

            else {
                vm.filter.excludeNonAppliedVolunteers = 'false';
            }

            $location.search('excludeNonAppliedVolunteers', vm.filter.excludeNonAppliedVolunteers || null);


            if(!vm.isCustomPaging) {
                vm.loadStatus.currentIndex = 0;
                loadStatus.setup(vm.loadStatus, "users")
                    .then(function () {
                        getUsers(vm.loadStatus.currentIndex, vm.loadStatus.defaultNumRows);
                    });
            }
            else {
                getUsers(vm.filter.startingRowIndex, vm.filter.numberOfRows);
            }
        }

        function communityAlreadyExistsInArray(array,community){
            var isFound = false;
            array.forEach(function(item){
                if(item.communityAffiliationId === community.communityAffiliationId){
                    isFound = true;
                }
            });
            return isFound;
        }

        function fillCommunities() {
            vm.communities = [];
            var promiseArray = [];
            if (!isOnlyOPOC) {
                if (vm.isAVCC) {
                    vm.communities = vm.responsibilities.avcc;
                    // If AVCC, communities specified but need organizations arrays
                    vm.communities.forEach(function (comm) {
                        // Empty array is required for filter modal to add orgs when needed
                        comm.organizations = [];
                    });
                    if (isOPOC) {
                        vm.responsibilities.opoc.forEach(function (comm) {
                            comm.organizations.forEach(function (org) {
                                org.organizationName = org.volunteerOrganizationName;
                            });
                            if(!communityAlreadyExistsInArray(vm.communities,comm)){
                                vm.communities.push(comm);
                            }
                        });
                    }
                }
                else if (isAVCCAssistant) {
                    vm.communities = vm.responsibilities.avccAssistant;
                    // If AVCC Assistant, communities specified but need organizations arrays
                    vm.communities.forEach(function (comm) {
                        // Empty array is required for filter modal to add orgs when needed
                        comm.organizations = [];
                    });
                    if (isOPOC) {
                        vm.responsibilities.opoc.forEach(function (comm) {
                            comm.organizations.forEach(function (org) {
                                org.organizationName = org.volunteerOrganizationName;
                            });
                            if(!communityAlreadyExistsInArray(vm.communities,comm)){
                                vm.communities.push(comm);
                            }
                        });
                    }
                }
            }
            else {
                vm.includeFloatingUsers = true;
                vm.isFloatingUsersEnabled = false;

                vm.communities = vm.responsibilities.opoc;

                // Not calling fillResponsibilities, so initialize "All" entry
                vm.communities.forEach(function (comm) {
                    // Responsibilities object uses different field name than getOrganizations API call
                    comm.organizations.forEach(function (org) {
                        org.organizationName = org.volunteerOrganizationName;
                    });
                    comm.organizations.unshift({
                        volunteerOrganizationId: -1,
                        organizationName: "All"
                    });
                });
            }

            return $q.all(promiseArray).then(function () {
                vm.communities.unshift({
                    communityAffiliationId: -1,
                    communityAffiliationName: "All",
                    organizations: [{
                        volunteerOrganizationId: -1,
                        organizationName: "All"
                    }]
                });
                vm.isLoading = false;
            }).catch(function (error) {
                $scope.$emit('people:alert', error);
                vm.isLoading = false;
            });
        }

        function getUsers(index, num) {
            vm.isLoading = true;

            var allCommunities = !vm.filter.selectedCommunity;
            var allOrganizations = !vm.filter.selectedOrganizations;

            updateCheckAllAndExport();

            var paramsGetUsers = {
                isRegUser: true,
                isNonUser: true,
                startingRowIndex: index,
                numberOfRows: num,
                isActive: vm.filter.isActive,
                firstName: vm.filter.firstName ? vm.filter.firstName : undefined,
                lastName: vm.filter.lastName ? vm.filter.lastName : undefined,
                startDate: vm.filter.startDate ? moment(vm.filter.startDate).startOf('day').toISOString() : undefined,
                endDate: vm.filter.endDate ? moment(vm.filter.endDate).endOf('day').toISOString() : undefined,
                includeFloatingVolunteers: vm.includeFloatingUsers,
                volunteerEmail: vm.filter.volunteerEmail ? vm.filter.volunteerEmail : undefined,
                excludeVolunteersWithoutApplications: vm.excludeNonAppliedVolunteers
            };

            if (!allCommunities) {
                paramsGetUsers.communityAffiliationIds = [vm.filter.selectedCommunity];
            }

            // If specific organization filter is selected, include in parameters
            if (!allOrganizations) {
                paramsGetUsers.volunteerOrganizationIds = vm.filter.selectedOrganizations;
                paramsGetUsers.communityAffiliationIds = undefined;
            }

            // Make call for these communities and/or organizations with parameters
            authentication.getVolunteersAdmin(paramsGetUsers)
                .then(function (response) {
                    getUsersSuccess(response, index, num);
                })
                .catch(function (error) {
                    getUsersError(error);
                });

            function getUsersSuccess(response, index, num) {
                if (index === 0 && !vm.isCustomPaging) {
                    vm.usersWithRole = [];
                    vm.loadStatus.currentIndex = 0;
                }

                if(vm.isCustomPaging){
                    vm.usersWithRole=[];
                    vm.totalResults = response.count;
                }

                for (var i = 0; i < response.users.length; i++) {
                    // If current user is AVCC, any variables set here are ignored in view.
                    if (isOPOC) {
                        if (isAVCCAssistant) {
                            // If the current user is OPOC + AVCC Assistant and the target user is non-user,
                            // first check if the user has any activity. If not, they are an inactive non-user,
                            // which is a special case with fewer drop downs. It is also known then that the user
                            // is visible through the OPOC role. If the non-user has activity,
                            // check for a match between the target user's activity and the OPOC responsibilities.
                            // If no match, the user is visible through the AVCC Assistant role; otherwise,
                            // the OPOC role. These situations will have different drop down options.
                            if (response.users[i].isNonUser) {
                                response.users[i].isInactiveNonUser =
                                    (response.users[i].activePositionOrganizations.length === 0);

                                response.users[i].fromAvccAssistPurview = response.users[i].isInactiveNonUser ?
                                    false : !isUserInNormalOPOCPurview(response.users[i]);
                            }
                            // If the current user is OPOC + AVCC Assistant and the target user is normal,
                            // check for a match between the target user's activity and the OPOC responsibilities.
                            // If no match, the user is visible through the AVCC Assistant role; otherwise,
                            // the OPOC role. These situations will have different drop down options.
                            else
                                response.users[i].fromAvccAssistPurview = !isUserInNormalOPOCPurview(response.users[i]);
                        }
                        // If current user is OPOC and target user is non-user, check for a match between
                        // the target user's activity and the OPOC responsibilities. If no match,
                        // the target user is a special case with fewer drop down options.
                        else if (response.users[i].isNonUser) {
                            response.users[i].isInactiveNonUser = !isUserInNormalOPOCPurview(response.users[i]);
                        }
                    }

                    response.users[i].latestHoursActivityDate = response.users[i].latestHoursActivityDate || "";

                    // Create unique ID for user checkbox
                    // TODO: for volunteer lists especially this may not be unique enough (add email?)
                    response.users[i].checkboxId = "check-" + response.users[i].aosUser.lastName + response.users[i].aosUser.firstName;

                    // Add user to full list
                    vm.usersWithRole.push(response.users[i]);
                }

                updateCheckAllAndExport();

                if(!vm.isCustomPaging) {
                    // Either set current index to max if all users loaded or increment by rows loaded
                    vm.loadStatus.currentIndex = (vm.loadStatus.currentIndex + num > response.count) ?
                        response.count : (vm.loadStatus.currentIndex + num);
                    // Track total number of users not loaded for "Load All" button
                    vm.loadStatus.numResultsNotLoaded = response.count - vm.loadStatus.currentIndex;
                    // Set text for "Load More" button
                    vm.loadStatus.nextResultLoadNum = (response.count === vm.loadStatus.currentIndex) ? 0 :
                        (vm.loadStatus.numResultsNotLoaded > num) ? num : vm.loadStatus.numResultsNotLoaded;
                }

                $timeout(function () {
                    vm.isLoading = false;
                }, 100);

                function isUserInNormalOPOCPurview(user) {
                    // For each active position the user is in
                    for (var p = 0; p < user.activePositionOrganizations.length; p++) {
                        // For each community OPOC has responsibilities in
                        for (var c = 0; c < vm.responsibilities.opoc.length; c++) {
                            // For each organization in responsible community
                            for (var o = 0; o < vm.responsibilities.opoc[c].organizations.length; o++) {
                                // Check if non-user's activity matches responsibility
                                if (user.activePositionOrganizations[p] ===
                                    vm.responsibilities.opoc[c].organizations[o].volunteerOrganizationId)
                                    return true;
                            }
                        }
                    }
                    return false;
                }
            }

            function getUsersError(error) {
                if (angular.isDefined(error)) {
                    var errorStr = error.error ? error.error : error;
                    $scope.$emit('people:alert', errorStr);
                }
                else
                    $scope.$emit('people:alert', "Failed to load list! Please try again.");

                $timeout(function () {
                    vm.isLoading = false;
                }, 100);
            }
        }

        function onSelectRole() {
            $scope.$emit('people:role', vm.selectedRoleObject);
        }

        function onClickFilterUsers() {
            var modalInstance = $modal.open({
                templateUrl: 'app/components/administrator/people/actionDirectives/orgCommFilter.view.html',
                controller: 'OrgCommFilterController',
                controllerAs: 'vm',
                backdrop: 'static',
                keyboard: false,
                resolve: {
                    params: function () {
                        return {
                            communities: vm.communities,
                            selectedCommunity: vm.filter.selectedCommunity,
                            selectedOrganizations: vm.filter.selectedOrganizations,
                            isActive: vm.filter.isActive,
                            startDate: vm.filter.startDate || null,
                            endDate: vm.filter.endDate || null,
                            role: "Volunteer",
                            volunteerEmail: vm.filter.volunteerEmail || null,
                            startingRowIndex: vm.filter.startingRowIndex || null,
                            numberOfRows: vm.filter.numberOfRows || null
                        };
                    }
                }
            });

            modalInstance.result
                .then(function (result) {
                    vm.isLoading = true;

                    switch (result.action) {
                        case 'success':
                            // Apply results from filter modal
                            vm.filter.selectedCommunity = result.filter.selectedCommunity.communityAffiliationId !== -1 ?
                                result.filter.selectedCommunity.communityAffiliationId : null;
                            if(result.filter.selectedOrganizations.length === 0){
                                vm.filter.selectedOrganizations = null;
                            }
                            else {
                                vm.filter.selectedOrganizations = [];
                                result.filter.selectedOrganizations.forEach(function(selectedOrg){
                                   vm.org = selectedOrg.volunteerOrganizationId !== -1 ? vm.filter.selectedOrganizations.push(selectedOrg.volunteerOrganizationId):null;
                                });
                            }

                            vm.filter.isActive = result.filter.isActive.value;
                            vm.filter.startDate = result.filter.startDate;
                            vm.filter.endDate = result.filter.endDate;
                            vm.filter.volunteerEmail = result.filter.volunteerEmail;
                            vm.filter.startingRowIndex = result.filter.startingRowIndex;
                            vm.filter.numberOfRows = result.filter.numberOfRows;

                            $location.search({
                                community: vm.filter.selectedCommunity,
                                organization: vm.filter.selectedOrganizations,
                                isActive: vm.filter.isActive,
                                firstName: vm.filter.firstName || null,
                                lastName: vm.filter.lastName || null,
                                startDate: vm.filter.startDate || null,
                                endDate: vm.filter.endDate || null,
                                name: vm.searchFilter.fullName || null,
                                floatingUsers: vm.filter.floatingUsers || null,
                                volunteerEmail: vm.filter.volunteerEmail || null,
                                excludeNonAppliedVolunteers: vm.filter.excludeNonAppliedVolunteers || null,
                                startingRowIndex: vm.filter.startingRowIndex || null,
                                numberOfRows: vm.filter.numberOfRows || null
                            });

                            vm.isCustomPaging = angular.isDefined(vm.filter.startingRowIndex) && angular.isDefined(vm.filter.numberOfRows) && vm.filter.startingRowIndex !== null && vm.filter.numberOfRows !== null;

                            determineStateOfFloatingUserCheckBox();
                            determineStateOfExcludeNonAppliedVolunteers ();

                            if(!vm.isCustomPaging) {
                                if(!vm.loadStatus) {
                                    vm.loadStatus = loadStatus.init();
                                }

                                return getUsers(0, vm.loadStatus.defaultNumRows);
                            }

                            else {
                                return getUsers(vm.filter.startingRowIndex, vm.filter.numberOfRows);
                            }
                        break;
                        case 'error':
                            vm.isLoading = false;
                            return $scope.$emit('people:alert', result.message);
                        default:
                            vm.isLoading = false;
                            return $scope.$emit('people:alert', "Failed to create new filter!");
                    }
                })
                .catch(function (error) {
                    $scope.$emit('people:alert', error);
                    vm.isLoading = false;
                });
        }

        function onClickSearch() {
            $location.search({
                community: vm.filter.selectedCommunity,
                organization: vm.filter.selectedOrganizations,
                isActive: vm.filter.isActive,
                firstName: vm.filter.firstName || null,
                lastName: vm.filter.lastName || null,
                startDate: vm.filter.startDate || null,
                endDate: vm.filter.endDate || null,
                volunteerEmail: vm.filter.volunteerEmail || null,
                startingRowIndex: vm.filter.startingRowIndex || null,
                numberOfRows: vm.filter.numberOfRows || null
            });
            if(!vm.isCustomPaging) {
                getUsers(0, vm.loadStatus.defaultNumRows);
            }
            else {
                return getUsers(vm.filter.startingRowIndex, vm.filter.numberOfRows);
            }
            return updateCheckAllAndExport();
        }

        function onClickAddNewNonUser() {
            var modalInstance = $modal.open({
                templateUrl: 'app/components/administrator/people/volunteers/addNonUser.view.html',
                controller: 'AddNonUserController',
                controllerAs: 'vm',
                backdrop: 'static',
                keyboard: false
            });

            modalInstance.result
                .then(function (result) {
                    vm.isLoading = true;

                    switch (result.action) {
                        case 'success':
                            return $state.go('vmis.profileNonUser', { "email": result.email });
                        // These states do not seem to occur
                        case 'error':
                            vm.isLoading = false;

                            return $scope.$emit('people:alert', result.message);
                        default:
                            vm.isLoading = false;

                            return $scope.$emit('people:alert', "Failed to create new non-user!");
                    }
                })
                .catch(function (error) {
                    $scope.$emit('people:alert', error);
                    vm.isLoading = false;
                });
        }

        function onCheckAll() {
            // Check users in either complete or filtered list
            for (var i = 0; i < vm.usersWithRole.length; i++)
                vm.usersWithRole[i].isChecked = vm.checkAll;

            updateCheckAllAndExport();
        }

        function onCheckUser() {
            updateCheckAllAndExport();
        }

        function updateCheckAllAndExport() {
            vm.numUsersSelected = 0;
            for (var i = 0; i < vm.usersWithRole.length; i++) {
                if (vm.usersWithRole[i].isChecked)
                    vm.numUsersSelected++;
            }

            // If list empty, uncheck
            if (vm.usersWithRole.length === 0) {
                vm.checkAll = false;
            }
            // Otherwise look for a checked user
            else {
                vm.checkAll = vm.usersWithRole.every(function (user) {
                    return user.isChecked;
                });
            }
        }

        function onClickEditVol(vol, action) {
            var paramId = {
                id: vol.masterUserId
            };
            switch (action) {
                case "Profile":
                    // Open new page in new tab
                    $window.open($state.href('vmis.profileEdit', paramId), '_blank');
                    break;
                case "Service Log":
                    $window.open($state.href('vmis.volunteer.serviceLogEdit', paramId), '_blank');
                    break;
                case "Records":
                    $window.open($state.href('vmis.volunteer.recordsEdit', paramId), '_blank');
                    break;
                case "Service History":
                    $window.open($state.href('vmis.volunteer.serviceHistoryEdit', paramId), '_blank');
                    break;
                case "Convert to Normal User":
                    convertToNormalUser(vol);
                    break;
                default:
                    console.log(page);
                    break;
            }
        }

        function convertToNormalUser(vol) {
            // Confirm conversion with modal
            return authentication.getNonUserEmail(vol.masterUserId).then(function (response) {
                var options = {
                    templateUrl: 'app/components/administrator/people/volunteers/confirmConvert.view.html',
                    controller: 'ConfirmConvertController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    keyboard: false,
                    resolve: {
                        modalParams: function () {
                            return {
                                firstName: vol.aosUser.firstName,
                                lastName: vol.aosUser.lastName,
                                email: response.email,
                                masterUserId: vol.masterUserId
                            };
                        }
                    }
                };

                return $modal.open(options).result;
            }).then(function () {
                var msg = "Invitation email sent to " + vol.aosUser.firstName + " " + vol.aosUser.lastName + "!";
                $scope.$emit('people:success', msg);
                return getUsers(0, vm.loadStatus.defaultNumRows);
            }).catch(function (error) {
                $scope.$emit('people:alert', error);
            });
        }

        function onMassEmail() {
            var emails = vm.usersWithRole.filter(function (user) {
                return user.isChecked && (user.aosUser !== null);
            }).map(function (user) {
                return (
                    (user.aosUser.vmisUser) ?
                        user.aosUser.vmisUser.volunteerProfile.volunteerEmail :
                        (user.email) ? user.email : null
                );
            });

            if (emails.length === 0)
                return;

            emails = Array.from(new Set(emails));
            // From: https://stackoverflow.com/a/281335/1634403
            emails = emails.filter(Boolean);

            var modalInstance = $modal.open({
                templateUrl: 'app/components/administrator/people/actionDirectives/massEmail.view.html',
                controller: 'MassEmailController',
                controllerAs: 'vm',
                backdrop: 'static',
                keyboard: false,
                resolve: {
                    params: function () {
                        return {
                            emails: emails
                        };
                    }
                }
            });

            // Process result from modal
            modalInstance.result
                .then(function (result) {
                    switch (result.action) {
                        case 'success':
                            var message = "";
                            if (emails.length !== 1)
                                message = "Mass email \"" + result.message + "\" successfully sent to " + emails.length + " users!";
                            else
                                message = "Mass email \"" + result.message + "\" successfully sent to 1 user!";

                            return $scope.$emit('people:success', message);
                        case 'error':
                            return $scope.$emit('people:alert', result.message);
                        default:
                            return $scope.$emit('people:alert', "Mass email failed to send!");
                    }
                })
                .catch(function (error) {
                    $scope.$emit('people:alert', error);
                });
        }

        // Export currently-checked users to spreadsheet format for download
        function onExport() {
            vm.isExporting = true;

            var exportingUsersHeader = [
                "First Name",
                "Last Name",
                "Last Login Date",
                "Most Recent Hours",
                "Email",
                "Background Check\r\n"
            ].toString();

            var exportingUsers = [exportingUsersHeader];
            exportingUsers = exportingUsers.concat(vm.usersWithRole.filter(function (user) {
                return user.isChecked;
            }).map(function (checkedUser) {
                var email = (checkedUser.aosUser.vmisUser !== null) ?
                    checkedUser.aosUser.vmisUser.volunteerProfile.volunteerEmail : "";

                return [
                    checkedUser.aosUser.firstName,
                    checkedUser.aosUser.lastName,
                    checkedUser.lastSignedIn,
                    checkedUser.latestHoursActivityDate,
                    email,
                    checkedUser.aosUser.backgroundCheckStatus
                ].toString() + "\r\n";
            }));

            var blob = new Blob(exportingUsers, { type: "text/plain;charset=utf-8" });
            saveAs(blob, (moment().format('YYYYMMDD_HHmmss') + "_Report.csv"));

            vm.isExporting = false;
        }

        function onLoadMore() {
            if(!vm.isCustomPaging) {
                getUsers(vm.loadStatus.currentIndex, vm.loadStatus.nextResultLoadNum);
                vm.checkAll = false;
            }
        }

        function onLoadAll() {
            if(!vm.isCustomPaging) {
                getUsers(vm.loadStatus.currentIndex, vm.loadStatus.numResultsNotLoaded);
                vm.checkAll = false;
            }
        }

        function massActionDisabled() {
            return vm.numUsersSelected === 0 || vm.isExporting || vm.isLoading;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('vmis.administrator')
        .controller('ConfirmConvertController', ConfirmConvertController);

    ConfirmConvertController.$inject = ['$modalInstance', 'authentication', 'modalParams'];

    function ConfirmConvertController($modalInstance, authentication, modalParams) {
        var vm = this;

        vm.formError = '';
        vm.isLoading = false;
        vm.fullName = modalParams.firstName + " " + modalParams.lastName;
        vm.email = modalParams.email;

        vm.onOk = onOk;

        function onOk() {
            vm.isLoading = true;
            var params = {
                masterUserId: modalParams.masterUserId,
                email: vm.email
            };

            return authentication.setNonUserToUser(params).then(function () {
                return $modalInstance.close();
            }).catch(function (error) {
                vm.formError = error;
            }).finally(function() {
                vm.isLoading = false;
            });
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('vmis.administrator')
        .controller('AddNonUserController', AddNonUserController);

    AddNonUserController.$inject = ['$modalInstance', 'authentication'];

    function AddNonUserController($modalInstance, authentication) {
        var vm = this;

        vm.isLoading = false;

        vm.onSubmit = onSubmit;

        function onSubmit() {
            vm.isLoading = true;

            vm.formError = "";

            var params = {
                email: vm.email
            };

            authentication.getVolunteersAdmin(params)
                .then(function (response) {
                    if (response.users.length === 0)
                        $modalInstance.close({
                            action: "success",
                            email: vm.email
                        });
                    else
                        vm.formError = "The entered email address already has an account.";

                    vm.isLoading = false;
                })
                .catch(function (error) {
                    vm.formError = error;
                    vm.isLoading = false;
                });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('vmis.administrator')
        .controller('OPOCsController', OPOCsController);

    OPOCsController.$inject = ['$q', '$modal', '$scope', '$location', '_', 'authentication', 'loadStatus', 'params', 'moment', '$timeout', '$window', '$state'];

    function OPOCsController($q, $modal, $scope, $location, _, authentication, loadStatus, params, moment, $timeout, $window, $state) {
        var vm = this;

        vm.isLoading = true;
        vm.roleObjectList = angular.copy(params.roleObjectList);
        vm.responsibilities = angular.copy(params.responsibilities);

        var isProgramManager = params.isProgramManager;
        // If user is PM but not AVCC, cannot add roles
        vm.isPMAndNotAVCC = params.isPMAndNotAVCC;

        vm.selectedRoleObject = vm.roleObjectList.filter(function (role) {
            return role.name === "OPOC";
        })[0];
        vm.numUsersSelected = 0;
        vm.isExporting = false;
        vm.sortColumn = 'aosUser.lastName';
        vm.sortReverse = false;

        vm.filter = {
            selectedCommunity: _.parseInt($location.search().community) || undefined,
            selectedOrganizations: $location.search().organization || undefined,
            lastName: $location.search().lastName || '',
            firstName: $location.search().firstName || '',
            startDate: isNaN(new Date($location.search().startDate)) ? undefined : new Date($location.search().startDate),
            endDate: isNaN(new Date($location.search().endDate)) ? undefined : new Date($location.search().endDate),
            workEmail: $location.search().workEmail || ''
        };

        if(vm.filter.selectedOrganizations !== undefined){
            if(Array.isArray(vm.filter.selectedOrganizations)){
                vm.filter.selectedOrganizations.forEach(function(value,index){
                    vm.filter.selectedOrganizations[index] = _.parseInt(value);
                });
            }
            else {
                vm.filter.selectedOrganizations = [_.parseInt(vm.filter.selectedOrganizations)];
            }
        }

        vm.loadStatus = loadStatus.init();

        vm.usersWithRole = [];

        vm.onSelectRole = onSelectRole;
        vm.onClickFilterUsers = onClickFilterUsers;
        vm.onClickSearch = onClickSearch;
        vm.onClickAddNewOPOC = onClickAddNewOPOC;
        vm.onClickEditOPOC = onClickEditOPOC;
        vm.onClickOpenOPOC = onClickOpenOPOC;
        vm.onCheckAll = onCheckAll;
        vm.onCheckUser = onCheckUser;
        vm.onMassEmail = onMassEmail;
        vm.onExport = onExport;
        vm.onLoadMore = onLoadMore;
        vm.onLoadAll = onLoadAll;
        vm.massActionDisabled = massActionDisabled;

        activate();

        function activate() {
            vm.massActions = [
                {
                    name: "Export",
                    action: onExport
                },
                {
                    name: "Mass Email",
                    action: onMassEmail
                }
            ];

            loadStatus.setup(vm.loadStatus, "users")
                .then(function () {
                    fillCommunities(); // Calls getUsers
                });
        }

        function fillCommunities() {
            vm.communities = [];
            var promiseArray = [];
            vm.communities = vm.responsibilities.avcc;

            // If AVCC, communities specified but need organizations arrays
            vm.communities.forEach(function (comm) {
                // Empty array is required for filter modal to add orgs when needed
                comm.organizations = [];
            });

            return $q.all(promiseArray).then(function () {
                vm.communities.unshift({
                    communityAffiliationId: -1,
                    communityAffiliationName: "All",
                    organizations: [{
                        volunteerOrganizationId: -1,
                        organizationName: "All"
                    }]
                });
                return getUsers(vm.loadStatus.currentIndex, vm.loadStatus.defaultNumRows);
            }).catch(function (error) {
                $scope.$emit('people:alert', error);
                vm.isLoading = false;
            });
        }

        function getUsers(index, num) {
            vm.isLoading = true;
            var allCommunities = !vm.filter.selectedCommunity;
            var allOrganizations = !vm.filter.selectedOrganizations;

            var paramsGetUsers = {
                vmisRole: "AVC OPOC",
                startingRowIndex: index,
                numberOfRows: num,
                firstName: vm.filter.firstName ? vm.filter.firstName : undefined,
                lastName: vm.filter.lastName ? vm.filter.lastName : undefined,
                startDate: vm.filter.startDate ? moment(vm.filter.startDate).startOf('day').toISOString() : undefined,
                endDate: vm.filter.endDate ? moment(vm.filter.endDate).endOf('day').toISOString() : undefined,
                workEmail: vm.filter.workEmail ? vm.filter.workEmail : undefined
            };

            if (!allCommunities) {
                paramsGetUsers.communityAffiliationIds = [vm.filter.selectedCommunity];
            }

            // If specific organization filter is selected, include in parameters
            if (!allOrganizations) {
                paramsGetUsers.volunteerOrganizationIds = vm.filter.selectedOrganizations;
                paramsGetUsers.communityAffiliationIds = undefined;
            }

            authentication.getManagersAdmin(paramsGetUsers)
                .then(function (response) {
                    getUsersSuccess(response, index, num);
                })
                .catch(function (error) {
                    getUsersError(error);
                });

            function getUsersSuccess(response, index, num) {
                if (index === 0) {
                    vm.usersWithRole = [];
                    vm.loadStatus.currentIndex = 0;
                }

                for (var i = 0; i < response.users.length; i++) {
                    // Create unique ID for user checkbox
                    response.users[i].checkboxId = "check-" + response.users[i].aosUser.lastName + response.users[i].aosUser.firstName;
                    // Add user to full list
                    vm.usersWithRole.push(response.users[i]);
                }

                updateCheckAllAndExport();

                // Either set current index to max if all users loaded or increment by rows loaded
                vm.loadStatus.currentIndex = (vm.loadStatus.currentIndex + num > response.count) ? response.count : (vm.loadStatus.currentIndex + num);
                // Track total number of users not loaded for "Load All" button
                vm.loadStatus.numResultsNotLoaded = response.count - vm.loadStatus.currentIndex;
                // Set text for "Load More" button
                vm.loadStatus.nextResultLoadNum = (response.count === vm.loadStatus.currentIndex) ? 0 :
                    (vm.loadStatus.numResultsNotLoaded > num) ? num : vm.loadStatus.numResultsNotLoaded;

                $timeout(function () {
                    vm.isLoading = false;
                }, 100);
            }

            function getUsersError(error) {
                if (angular.isDefined(error)) {
                    var errorStr = error.error ? error.error : error;
                    $scope.$emit('people:alert', errorStr);
                }
                else
                    $scope.$emit('people:alert', "Failed to load list! Please try again.");

                $timeout(function () {
                    vm.isLoading = false;
                }, 100);
            }
        }

        function onSelectRole() {
            $scope.$emit('people:role', vm.selectedRoleObject);
        }

        function onClickFilterUsers() {
            var modalInstance = $modal.open({
                templateUrl: 'app/components/administrator/people/actionDirectives/orgCommFilter.view.html',
                controller: 'OrgCommFilterController',
                controllerAs: 'vm',
                backdrop: 'static',
                keyboard: false,
                resolve: {
                    params: function () {
                        return {
                            communities: angular.copy(vm.communities),
                            selectedCommunity: vm.filter.selectedCommunity,
                            selectedOrganizations: vm.filter.selectedOrganizations,
                            startDate: vm.filter.startDate || null,
                            endDate: vm.filter.endDate || null,
                            workEmail: vm.filter.workEmail || null,
                            role: "AVC OPOC"
                        };
                    }
                }
            });

            modalInstance.result.then(function (result) {
                vm.isLoading = true;
                switch (result.action) {
                    case 'success':
                        // Apply results from filter modal
                        vm.filter.selectedCommunity = result.filter.selectedCommunity.communityAffiliationId !== -1 ? result.filter.selectedCommunity.communityAffiliationId : null;
                        if(result.filter.selectedOrganizations.length === 0){
                            vm.filter.selectedOrganizations = null;
                        }
                        else {
                            vm.filter.selectedOrganizations = [];
                            result.filter.selectedOrganizations.forEach(function(selectedOrg){
                                // If not "All", save
                                if (selectedOrg.volunteerOrganizationId !== -1) {
                                    vm.filter.selectedOrganizations.push(selectedOrg.volunteerOrganizationId);
                                }
                            });
                            // If working list is empty, set org filter back to empty
                            vm.filter.selectedOrganizations = vm.filter.selectedOrganizations.length === 0 ? null : vm.filter.selectedOrganizations;
                        }
                        vm.filter.startDate = result.filter.startDate;
                        vm.filter.endDate = result.filter.endDate;
                        vm.filter.workEmail = result.filter.workEmail;

                        $location.search({
                            community: vm.filter.selectedCommunity,
                            organization: vm.filter.selectedOrganizations,
                            startDate: vm.filter.startDate || null,
                            endDate: vm.filter.endDate || null,
                            firstName: vm.filter.firstName || null,
                            lastName: vm.filter.lastName || null,
                            workEmail: vm.filter.workEmail || null
                        });

                        return getUsers(0, vm.loadStatus.defaultNumRows);
                    case 'error':
                        vm.isLoading = false;
                        return $scope.$emit('people:alert', result.message);
                    default:
                        vm.isLoading = false;
                        return $scope.$emit('people:alert', "Failed to create new filter!");
                }
            }).catch(function (error) {
                $scope.$emit('people:alert', error);
                vm.isLoading = false;
            });
        }

        function onClickSearch() {
            $location.search({
                community: vm.filter.selectedCommunity,
                organization: vm.filter.selectedOrganizations,
                startDate: vm.filter.startDate || null,
                endDate: vm.filter.endDate || null,
                firstName: vm.filter.firstName || null,
                lastName: vm.filter.lastName || null,
                workEmail: vm.filter.workEmail || null
            });
            getUsers(0, vm.loadStatus.defaultNumRows);
            return updateCheckAllAndExport();
        }

        function onClickAddNewOPOC() {
            openOpocModal();
        }

        function onClickEditOPOC(opoc) {
            openOpocModal(opoc);
        }

        function onClickOpenOPOC(opoc) {
            var paramId = {
                id: opoc.masterUserId
            };
            $window.open($state.href('vmis.profileEdit', paramId), '_blank');
        }

        function openOpocModal(opoc) {
            var modalResponsibilities = angular.copy(vm.communities.filter(function (comm) {
                return comm.communityAffiliationId !== -1;
            }).map(function (comm) {
                var retComm = comm;
                retComm.organizations = retComm.organizations.filter(function (org) {
                    return org.volunteerOrganizationId !== -1;
                });
                return retComm;
            }));

            var modalInstance = $modal.open({
                templateUrl: 'app/components/administrator/people/opocs/editOpoc.view.html',
                controller: 'EditOpocController',
                controllerAs: 'vm',
                backdrop: 'static',
                keyboard: false,
                resolve: {
                    params: function () {
                        return {
                            activeUserResponsibilities: modalResponsibilities,
                            opoc: angular.copy(opoc) || null,
                            // If user has certain higher roles, they can remove OPOC role entirely
                            canRemove: isProgramManager,
                            // If user is PM but not AVCC, cannot edit roles
                            canEdit: !vm.isPMAndNotAVCC
                        };
                    }
                }
            });

            // Process result from edit modal
            modalInstance.result
                .then(function (result) {
                    processModalResult(result, opoc, modalResponsibilities);
                })
                .catch(function (error) {
                    $scope.$emit('people:alert', error);
                });
        }

        function processModalResult(result, opoc, modalResponsibilities) {
            vm.isLoading = true;
            var promiseArray = [];
            switch (result.action) {
                case 'edit':
                    result.responsibilities.forEach(function (comm) {
                        promiseArray.push(authentication.modifyUserRoles({
                            masterUserId: result.masterUserId,
                            aosUserRoles: ["AVC OPOC"],
                            communityAffiliationIds: [comm.communityAffiliationId],
                            volunteerOrganizationIds: comm.organizations.map(function (org) {
                                return org.volunteerOrganizationId;
                            }),
                            isAddingOrRemovingResponsibilities: true
                        }));
                    });

                    // Check if an entire community's worth of organizations was removed.
                    if (angular.isDefined(opoc)) {
                        var removedCommunityArray = [];

                        // Filter list to just communities not in new responsibilities list
                        var missingResponsibilities = opoc.aosUser.vmisUser.adminProfile.responsibilities.opoc
                            .filter(function (origResp) {
                                // Return true and keep community if not found in new list by ID
                                return undefined === _.find(result.responsibilities, function (resp) {
                                    return resp.communityAffiliationId === origResp.communityAffiliationId;
                                });
                            });

                        // For each missing community with responsibilities, check if missing because
                        // active user doesn't have purview or if because being entirely removed.
                        missingResponsibilities.forEach(function (missingResp) {
                            for (var i = 0; i < modalResponsibilities.length; i++) {
                                // If in active user responsibilities, take action
                                if (modalResponsibilities[i].communityAffiliationId === missingResp.communityAffiliationId) {
                                    removedCommunityArray.push(missingResp.communityAffiliationId);
                                    break;
                                }
                            }
                        });

                        // API needs the last OPOC community deletion to be done after all others are resolved
                        if (removedCommunityArray.length === 1) {
                            promiseArray.push(authentication.modifyUserRoles({
                                masterUserId: result.masterUserId,
                                aosUserRoles: ["AVC OPOC"],
                                communityAffiliationIds: [removedCommunityArray[0]],
                                volunteerOrganizationIds: [],
                                isAddingOrRemovingResponsibilities: true
                            }));
                        }
                        else if (removedCommunityArray.length > 1) {
                            for (var i = 0; i < removedCommunityArray.length - 1; i++) {
                                promiseArray.push(authentication.modifyUserRoles({
                                    masterUserId: result.masterUserId,
                                    aosUserRoles: ["AVC OPOC"],
                                    communityAffiliationIds: [removedCommunityArray[i]],
                                    volunteerOrganizationIds: [],
                                    isAddingOrRemovingResponsibilities: true
                                }));
                            }
                            return $q.all(promiseArray).then(function () {
                                return authentication.modifyUserRoles({
                                    masterUserId: result.masterUserId,
                                    aosUserRoles: ["AVC OPOC"],
                                    communityAffiliationIds: [removedCommunityArray[removedCommunityArray.length - 1]],
                                    volunteerOrganizationIds: [],
                                    isAddingOrRemovingResponsibilities: true
                                });
                            }).then(function () {
                                $scope.$emit('profile:update');
                                getUsers(0, vm.loadStatus.defaultNumRows);
                            }).catch(function (error) {
                                $scope.$emit('people:alert', error);
                                vm.isLoading = false;
                            });
                        }
                    }
                    break;
                case 'save':
                    if (result.responsibilities.length === 0) {
                        promiseArray.push(authentication.modifyUserRoles({
                            masterUserId: result.masterUserId,
                            aosUserRoles: ["AVC OPOC"],
                            isAdding: true
                        }));
                    }
                    else {
                        var firstComm = result.responsibilities.pop();
                        promiseArray.push(authentication.modifyUserRoles({
                            masterUserId: result.masterUserId,
                            aosUserRoles: ["AVC OPOC"],
                            communityAffiliationIds: [firstComm.communityAffiliationId],
                            volunteerOrganizationIds: firstComm.organizations.map(function (org) {
                                return org.volunteerOrganizationId;
                            }),
                            isAdding: true
                        }));
                    }

                    if (result.responsibilities.length > 0) {
                        return $q.all(promiseArray)
                            .then(function () {
                                result.action = 'edit';
                                return processModalResult(result, opoc, modalResponsibilities);
                            })
                            .catch(function (error) {
                                $scope.$emit('people:alert', error);
                                vm.isLoading = false;
                            });
                    }
                    break;
                case 'remove':
                    promiseArray.push(authentication.modifyUserRoles({
                        masterUserId: result.masterUserId,
                        aosUserRoles: ["AVC OPOC"],
                        isDeleting: true
                    }));
                    break;
                default:
                    break;
            }

            return $q.all(promiseArray).then(function () {
                $scope.$emit('profile:update');
                return getUsers(0, vm.loadStatus.defaultNumRows);
            }).catch(function (error) {
                $scope.$emit('people:alert', error);
                vm.isLoading = false;
            });
        }

        function onCheckAll() {
            // Check users in either complete or filtered list
            for (var i = 0; i < vm.usersWithRole.length; i++)
                vm.usersWithRole[i].isChecked = vm.checkAll;

            updateCheckAllAndExport();
        }

        function onCheckUser() {
            updateCheckAllAndExport();
        }

        function updateCheckAllAndExport() {
            vm.numUsersSelected = 0;
            for (var i = 0; i < vm.usersWithRole.length; i++) {
                if (vm.usersWithRole[i].isChecked)
                    vm.numUsersSelected++;
            }

            // If list empty, uncheck
            if (vm.usersWithRole.length === 0) {
                vm.checkAll = false;
            }
            // Otherwise look for a checked user
            else {
                vm.checkAll = vm.usersWithRole.every(function (user) {
                    return user.isChecked;
                });
            }
        }

        function onMassEmail() {
            var emails = vm.usersWithRole.filter(function (user) {
                return user.isChecked;
            }).map(function (user) {
                return (
                    (user.aosUser.vmisUser.adminProfile.workEmail) ?
                        user.aosUser.vmisUser.adminProfile.workEmail :
                        (user.masterUserEmail) ? user.masterUserEmail : null
                );
            });

            if (emails.length === 0)
                return;

            emails = Array.from(new Set(emails));
            emails = emails.filter(Boolean);

            var modalInstance = $modal.open({
                templateUrl: 'app/components/administrator/people/actionDirectives/massEmail.view.html',
                controller: 'MassEmailController',
                controllerAs: 'vm',
                backdrop: 'static',
                keyboard: false,
                resolve: {
                    params: function () {
                        return {
                            emails: emails
                        };
                    }
                }
            });

            // Process result from modal
            modalInstance.result
                .then(function (result) {
                    switch (result.action) {
                        case 'success':
                            var message = "";
                            if (emails.length !== 1)
                                message = "Mass email \"" + result.message + "\" successfully sent to " + emails.length + " users!";
                            else
                                message = "Mass email \"" + result.message + "\" successfully sent to 1 user!";

                            return $scope.$emit('people:success', message);
                        case 'error':
                            return $scope.$emit('people:alert', result.message);
                        default:
                            return $scope.$emit('people:alert', "Mass email failed to send!");
                    }
                })
                .catch(function (error) {
                    $scope.$emit('people:alert', error);
                });
        }

        // Export currently-checked users to spreadsheet format for download
        function onExport() {
            vm.isExporting = true;

            var exportingUsersHeader = [
                "First Name",
                "Last Name",
                "Last Login Date",
                "Responsibilities",
                "Email\r\n"
            ].toString();

            var exportingUsers = [exportingUsersHeader];
            exportingUsers = exportingUsers.concat(vm.usersWithRole.filter(function (user) {
                return user.isChecked;
            }).map(function (checkedUser) {
                var responsibilitiesStr = "\"";
                if (angular.isDefined(checkedUser.aosUser.vmisUser.adminProfile.responsibilities.opoc)) {
                    checkedUser.aosUser.vmisUser.adminProfile.responsibilities.opoc.forEach(function (comm) {
                        responsibilitiesStr += comm.communityAffiliationName + ": ";
                        comm.organizations.forEach(function (org) {
                            responsibilitiesStr += org.volunteerOrganizationName + "; ";
                        });
                        responsibilitiesStr = responsibilitiesStr.slice(0, -2);
                        responsibilitiesStr += ". ";
                    });
                    responsibilitiesStr = responsibilitiesStr.slice(0, -1);
                    responsibilitiesStr += "\"";
                }

                var email = (checkedUser.aosUser.vmisUser.adminProfile.workEmail !== null) ?
                    checkedUser.aosUser.vmisUser.adminProfile.workEmail : "";

                return [
                    checkedUser.aosUser.firstName,
                    checkedUser.aosUser.lastName,
                    checkedUser.lastSignedIn,
                    responsibilitiesStr,
                    email
                ].toString() + "\r\n";
            }));

            var blob = new Blob(exportingUsers, { type: "text/plain;charset=utf-8" });
            saveAs(blob, (moment().format('YYYYMMDD_HHmmss') + "_Report.csv"));

            vm.isExporting = false;
        }

        function onLoadMore() {
            getUsers(vm.loadStatus.currentIndex, vm.loadStatus.nextResultLoadNum);
            vm.checkAll = false;
        }

        function onLoadAll() {
            getUsers(vm.loadStatus.currentIndex, vm.loadStatus.numResultsNotLoaded);
            vm.checkAll = false;
        }

        function massActionDisabled() {
            return vm.numUsersSelected === 0 || vm.isExporting || vm.isLoading;
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('vmis.administrator')
        .controller('EditOpocController', EditOpocController);

    EditOpocController.$inject = ['$modalInstance', '$modal', '$q', 'params', 'authentication', 'usersServices'];

    function EditOpocController($modalInstance, $modal, $q, params, authentication, usersServices) {
        var vm = this;

        vm.isLoading = true;

        vm.opoc = params.opoc || {};
        vm.isNewOPOC = params.opoc === null;
        vm.canRemove = !vm.isNewOPOC && params.canRemove;
        vm.canEdit = params.canEdit;

        if (vm.isNewOPOC)
            vm.title = "Add New OPOC";
        else
            vm.title = "Edit OPOC - " + vm.opoc.aosUser.firstName + " " + vm.opoc.aosUser.lastName;

        vm.errorText = "";

        vm.communities = params.activeUserResponsibilities;
        vm.selectedCommunity = vm.communities[0];
        vm.opocResponsibilities = [];
        vm.initFillCommsCount = 0;
        var originalResponsibilities = [];

        vm.onCommunityChange = onCommunityChange;
        vm.onSelectOrg = onSelectOrg;
        vm.onClickRemove = onClickRemove;
        vm.onSubmit = onSubmit;

        activate();

        function activate() {
            if (!vm.isNewOPOC && vm.opoc.aosUser.vmisUser.adminProfile.responsibilities.opoc) {
                var promiseArray = [];

                // Get all communities' orgs before building flat responsibilities list
                // Implemented similarly to manageActivity.controller.js:233
                vm.opoc.aosUser.vmisUser.adminProfile.responsibilities.opoc.forEach(function (respComm) {
                    var fillComm = findCommInFullList(respComm);

                    // If target user has responsibilities outside of active user's purview,
                    // do not attempt to fill drop down for those responsibilities.
                    if (fillComm) {
                        promiseArray.push(authentication.getOrganizations({
                            communityAffiliationId: respComm.communityAffiliationId,
                            getAll: true
                        })
                            .then(function (response) {
                                // Populate this particular vm.communities entry with its organizations
                                fillComm.organizations = [];
                                // This fills the object for future uses of the modal
                                response.organizations.forEach(function (org) {
                                    fillComm.organizations.push(org);
                                });
                            })
                            .catch(function (error) {
                                setError(error);
                            }));
                    }
                });

                $q.all(promiseArray)
                    .then(function () {
                        fillTargetUserResponsibilities();
                    })
                    .catch(function (error) {
                        setError(error);
                    });
            }
            else {
                vm.selectedCommunity = vm.communities[0];
                onCommunityChange();
            }
        }

        function onCommunityChange() {
            return getCommOrgs();
        }

        function onSelectOrg(item, model) {
            addCommDataToOrg(vm.opocResponsibilities.length - 1, vm.selectedCommunity);
        }

        function onClickRemove() {
            vm.isLoading = true;

            var modalInstance = $modal.open({
                templateUrl: 'app/components/administrator/people/actionDirectives/confirmRoleRemove.view.html',
                controller: 'ConfirmRoleRemoveController',
                controllerAs: 'vm',
                backdrop: 'static',
                keyboard: false,
                resolve: {
                    params: function () {
                        return {
                            userInfo: vm.opoc,
                            role: "Organization Point Of Contact"
                        };
                    }
                }
            });

            modalInstance.result
                .then(function () {
                    close('remove', vm.opoc.masterUserId, originalResponsibilities);
                    vm.isLoading = false;
                })
                .catch(function (error) {
                    if (angular.isDefined(error))
                        setError(error);
                    vm.isLoading = false;
                });
        }

        function onSubmit() {
            var promiseArray = [];
            vm.isLoading = true;
            if (!vm.opoc.masterUserId) {
                promiseArray.push(authentication.getMasterUserIdFromEmail({
                    email: vm.opoc.masterUserEmail
                })
                    .then(function (response) {
                        if (response.success === true) {
                            clearError();
                            vm.opoc.masterUserId = response.masterUserId;
                            authentication.getUserProfile({masterUserId: vm.opoc.masterUserId})
                                .then(function (userProfile) {
                                    var isUserOPOC = userProfile.roles.vmisUserRoles.filter(function (role) {
                                        return role === "AVC OPOC";
                                    }).length === 1;

                                    if (vm.isNewOPOC && isUserOPOC) {
                                        if (!usersServices.isBasicAdminUserDataComplete(userProfile))
                                        {
                                            setError("This user cannot be added due to incomplete data");
                                            vm.isLoading = false;
                                            return;
                                        }

                                        var isUserInOPOCCommunity = userProfile.aosUser.vmisUser.adminProfile.responsibilities.opoc.filter(function (opocResp) {
                                            return opocResp.communityAffiliationId === vm.selectedCommunity.communityAffiliationId;
                                        }).length === 1;

                                        if (isUserInOPOCCommunity) {
                                            setError("The account associated with the email address is already an OPOC. You must find and edit that user's roles in the table.");
                                            vm.isLoading = false;
                                            return;
                                        } else {
                                            close('edit', vm.opoc.masterUserId, vm.opocResponsibilities);
                                            return;
                                        }
                                    }

                                    if (vm.isNewOPOC)
                                        close('save', vm.opoc.masterUserId, vm.opocResponsibilities);
                                    else
                                        close('edit', vm.opoc.masterUserId, vm.opocResponsibilities);
                                })
                                .catch(function (error) {
                                    setError(error);
                                    vm.isLoading = false;
                                });
                        }
                    })
                    .catch(function (error) {
                        setError(error);
                        vm.isLoading = false;
                    }));
            }

            else {
                promiseArray.push(authentication.getUserProfile({masterUserId: vm.opoc.masterUserId})
                    .then(function (userProfile) {
                        var isUserOPOC = userProfile.roles.vmisUserRoles.filter(function (role) {
                            return role === "AVC OPOC";
                        }).length === 1;

                        if (vm.isNewOPOC && isUserOPOC) {
                            if (!usersServices.isBasicAdminUserDataComplete(userProfile))
                            {
                                setError("This user cannot be added due to incomplete data");
                                vm.isLoading = false;
                                return;
                            }

                            var isUserInOPOCCommunity = userProfile.aosUser.vmisUser.adminProfile.responsibilities.opoc.filter(function (opocResp) {
                                return opocResp.communityAffiliationId === vm.selectedCommunity.communityAffiliationId;
                            }).length === 1;

                            if (isUserInOPOCCommunity) {
                                setError("The account associated with the email address is already an OPOC. You must find and edit that user's roles in the table.");
                                vm.isLoading = false;
                                return;
                            } else {
                                close('edit', vm.opoc.masterUserId, vm.opocResponsibilities);
                                return;
                            }
                        }

                        if (vm.isNewOPOC)
                            close('save', vm.opoc.masterUserId, vm.opocResponsibilities);
                        else
                            close('edit', vm.opoc.masterUserId, vm.opocResponsibilities);
                    })
                    .catch(function (error) {
                        setError(error);
                        vm.isLoading = false;
                    }));
            }

            $q.all(promiseArray).catch(function (error) {
                    setError(error);
                });
        }

        function isInActiveUserResponsibilities(resp) {
            for (var i = 0; i < vm.communities.length; i++) {
                if (resp.communityAffiliationId === vm.communities[i].communityAffiliationId)
                    return true;
            }

            return false;
        }

        // Called once all communities have organizations loaded
        function fillTargetUserResponsibilities() {
            // If existing role with responsibilities, fill ui-select
            vm.opoc.aosUser.vmisUser.adminProfile.responsibilities.opoc.forEach(function (respComm) {
                // Find community to process
                var curComm = findCommInFullList(respComm);

                // If target user's responsibility is outside of active user's purview, just add
                // info without connecting it to the existing lists (that do not exist for it, anyway).
                if (curComm) {
                    // Add each responsible organization by finding its entry in the full list
                    respComm.organizations.forEach(function (respOrg) {
                        vm.opocResponsibilities.push(_.find(curComm.organizations, function (org) {
                            return org.volunteerOrganizationId === respOrg.volunteerOrganizationId;
                        }));
                        // Add parent community for display purposes
                        addCommDataToOrg(vm.opocResponsibilities.length - 1, curComm);
                    });
                }
                else {
                    respComm.organizations.forEach(function (respOrg) {
                        respOrg.organizationName = respOrg.volunteerOrganizationName;
                        respOrg.readOnly = true;
                        vm.opocResponsibilities.push(respOrg);
                        addCommDataToOrg(vm.opocResponsibilities.length - 1, respComm);
                    });
                }
            });
            originalResponsibilities = angular.copy(vm.opocResponsibilities);

            vm.selectedCommunity = vm.communities[0];
            onCommunityChange();
        }

        function findCommInFullList(inComm) {
            // Accept both community object with ID and ID itself
            if (inComm.communityAffiliationId)
                inComm = inComm.communityAffiliationId;

            return _.find(vm.communities, function (comm) {
                return inComm === comm.communityAffiliationId;
            });
        }

        function addCommDataToOrg(index, curComm) {
            if (!vm.opocResponsibilities[index].communityAffiliationId) {
                vm.opocResponsibilities[index].communityAffiliationName = curComm.communityAffiliationName;
                vm.opocResponsibilities[index].communityAffiliationId = curComm.communityAffiliationId;
            }
        }

        function getCommOrgs() {
            vm.isLoading = true;
            var comm = vm.selectedCommunity;
            if (comm.organizations.length === 0) {
                return authentication.getOrganizations({
                    communityAffiliationId: comm.communityAffiliationId,
                    getAll: true
                })
                    .then(function (response) {
                        comm.organizations = [];
                        // This fills the object for future uses of the modal
                        response.organizations.forEach(function (org) {
                            comm.organizations.push(org);
                        });
                    })
                    .catch(function (error) {
                        setError(error);
                    })
                    .finally(function () {
                        vm.isLoading = false;
                    });
            }
            else {
                vm.isLoading = false;
                return $q.when();
            }
        }

        function setError(error) {
            var errorStr = error.error ? error.error : (error.message ? error.message : error);
            if (errorStr === 'cancel' || errorStr === 'backdrop click')
                return;
            vm.errorText = errorStr;
        }

        function clearError() {
            vm.errorText = "";
        }

        function close(action, masterUserId, responsibilities) {
            $modalInstance.close({
                action: action,
                masterUserId: masterUserId,
                responsibilities: reformatResponsibilities(responsibilities)
            });
        }

        function reformatResponsibilities(resp) {
            var outResp = [];
            resp.forEach(function (org) {
                // Check if community for org exists
                var outComm = _.find(outResp, function (comm) {
                    return org.communityAffiliationId === comm.communityAffiliationId;
                });

                // If new community
                if (!outComm) {
                    var newComm = findCommInFullList(org.communityAffiliationId);
                    // If not found, responsibility is outside of active user's purview
                    // and will not be included in API call.
                    if (newComm) {
                        newComm.organizations = [org];
                        outResp.push(newComm);
                    }
                }
                else {
                    outComm.organizations.push(org);
                }
            });

            return outResp;
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('vmis.administrator')
        .controller('CoordinatorAssistantsController', CoordinatorAssistantsController);

    CoordinatorAssistantsController.$inject = ['$q', '$modal', '$scope', '$location', 'authentication', 'loadStatus', 'params', 'moment', '_', '$timeout', '$window', '$state'];

    function CoordinatorAssistantsController($q, $modal, $scope, $location, authentication, loadStatus, params, moment, _, $timeout, $window, $state) {
        var vm = this;

        vm.isLoading = true;
        vm.roleObjectList = angular.copy(params.roleObjectList);
        vm.responsibilities = angular.copy(params.responsibilities);

        var isProgramManager = params.isProgramManager;
        // If user is PM but not AVCC, cannot add roles
        vm.isPMAndNotAVCC = params.isPMAndNotAVCC;

        vm.selectedRoleObject = vm.roleObjectList.filter(function (role) {
            return role.name === "AVCC Assistant";
        })[0];
        vm.numUsersSelected = 0;
        vm.isExporting = false;
        vm.sortColumn = 'aosUser.lastName';
        vm.sortReverse = false;

        vm.filter = {
            selectedCommunities: $location.search().community || undefined,
            lastName: $location.search().lastName || '',
            firstName: $location.search().firstName || '',
            startDate: isNaN(new Date($location.search().startDate)) ? undefined : new Date($location.search().startDate),
            endDate: isNaN(new Date($location.search().endDate)) ? undefined : new Date($location.search().endDate),
            workEmail: $location.search().workEmail || ''
        };

        if(vm.filter.selectedCommunities !== undefined){
            if(Array.isArray(vm.filter.selectedCommunities)){
                vm.filter.selectedCommunities.forEach(function(value,index){
                    vm.filter.selectedCommunities[index] = _.parseInt(value);
                });
            }
            else {
                vm.filter.selectedCommunities = [_.parseInt(vm.filter.selectedCommunities)];
            }
        }

        vm.loadStatus = loadStatus.init();

        vm.usersWithRole = [];

        vm.onSelectRole = onSelectRole;
        vm.onClickFilterUsers = onClickFilterUsers;
        vm.onClickSearch = onClickSearch;
        vm.onClickAddNewAVCCAssistant = onClickAddNewAVCCAssistant;
        vm.onClickEditAVCCAssistant = onClickEditAVCCAssistant;
        vm.onClickOpenAVCCAssistant = onClickOpenAVCCAssistant;
        vm.onCheckAll = onCheckAll;
        vm.onCheckUser = onCheckUser;
        vm.onMassEmail = onMassEmail;
        vm.onExport = onExport;
        vm.onLoadMore = onLoadMore;
        vm.onLoadAll = onLoadAll;
        vm.massActionDisabled = massActionDisabled;

        activate();

        function activate() {
            vm.massActions = [
                {
                    name: "Export",
                    action: onExport
                },
                {
                    name: "Mass Email",
                    action: onMassEmail
                }
            ];

            loadStatus.setup(vm.loadStatus, "users")
                .then(function () {
                    fillCommunities(); // Calls getUsers
                });
        }

        function fillCommunities() {
            vm.communities = [];
            var promiseArray = [];
            if (isProgramManager) {
                promiseArray.push(authentication.getCommunities({
                    getAll: true
                })
                    .then(function (response) {
                        vm.communities = response.communityAffiliations;
                    })
                    .catch(function (error) {
                        $scope.$emit('people:alert', error);
                        vm.isLoading = false;
                    }));
            }
            else {
                vm.communities = vm.responsibilities.avcc;
            }

            return $q.all(promiseArray).then(function () {
                vm.communities.unshift({
                    communityAffiliationId: -1,
                    communityAffiliationName: "All"
                });
                return getUsers(vm.loadStatus.currentIndex, vm.loadStatus.defaultNumRows);
            }).catch(function (error) {
                $scope.$emit('people:alert', error);
                vm.isLoading = false;
            });
        }

        function getUsers(index, num) {
            vm.isLoading = true;
            var allCommunities = !vm.filter.selectedCommunities;

            var paramsGetUsers = {
                vmisRole: "AVC Coordinator Assistant",
                startingRowIndex: index,
                numberOfRows: num,
                firstName: vm.filter.firstName ? vm.filter.firstName : undefined,
                lastName: vm.filter.lastName ? vm.filter.lastName : undefined,
                startDate: vm.filter.startDate ? moment(vm.filter.startDate).startOf('day').toISOString() : undefined,
                endDate: vm.filter.endDate ? moment(vm.filter.endDate).endOf('day').toISOString() : undefined,
                workEmail: vm.filter.workEmail ? vm.filter.workEmail : undefined
            };

            if (!allCommunities) {
                paramsGetUsers.communityAffiliationIds = vm.filter.selectedCommunities;
            }

            authentication.getManagersAdmin(paramsGetUsers)
                .then(function (response) {
                    getUsersSuccess(response, index, num);
                })
                .catch(function (error) {
                    getUsersError(error);
                });

            function getUsersSuccess(response, index, num) {
                if (index === 0) {
                    vm.usersWithRole = [];
                    vm.loadStatus.currentIndex = 0;
                }

                for (var i = 0; i < response.users.length; i++) {
                    // Create unique ID for user checkbox
                    response.users[i].checkboxId = "check-" + response.users[i].aosUser.lastName + response.users[i].aosUser.firstName;
                    // Add user to full list
                    vm.usersWithRole.push(response.users[i]);
                }

                updateCheckAllAndExport();

                // Either set current index to max if all users loaded or increment by rows loaded
                vm.loadStatus.currentIndex = (vm.loadStatus.currentIndex + num > response.count) ? response.count : (vm.loadStatus.currentIndex + num);
                // Track total number of users not loaded for "Load All" button
                vm.loadStatus.numResultsNotLoaded = response.count - vm.loadStatus.currentIndex;
                // Set text for "Load More" button
                vm.loadStatus.nextResultLoadNum = (response.count === vm.loadStatus.currentIndex) ? 0 :
                    (vm.loadStatus.numResultsNotLoaded > num) ? num : vm.loadStatus.numResultsNotLoaded;

                $timeout(function () {
                    vm.isLoading = false;
                }, 100);
            }

            function getUsersError(error) {
                if (angular.isDefined(error)) {
                    var errorStr = error.error ? error.error : error;
                    $scope.$emit('people:alert', errorStr);
                }
                else
                    $scope.$emit('people:alert', "Failed to load list! Please try again.");

                $timeout(function () {
                    vm.isLoading = false;
                }, 100);
            }
        }

        function onSelectRole() {
            $scope.$emit('people:role', vm.selectedRoleObject);
        }

        function onClickFilterUsers() {
            var modalInstance = $modal.open({
                templateUrl: 'app/components/administrator/people/actionDirectives/commFilter.view.html',
                controller: 'CommFilterController',
                controllerAs: 'vm',
                backdrop: 'static',
                keyboard: false,
                resolve: {
                    params: function () {
                        return {
                            communities: vm.communities,
                            selectedCommunities: vm.filter.selectedCommunities,
                            startDate: vm.filter.startDate || null,
                            endDate: vm.filter.endDate || null,
                            workEmail: vm.filter.workEmail || null
                        };
                    }
                }
            });

            modalInstance.result.then(function (result) {
                vm.isLoading = true;
                switch (result.action) {
                    case 'success':
                        // Apply results from filter modal
                        if(result.filter.selectedCommunities.length === 0){
                            vm.filter.selectedCommunities = null;
                        }
                        else {
                            vm.filter.selectedCommunities = [];
                            result.filter.selectedCommunities.forEach(function(selectedComm){
                                // If not "All", save
                                if (selectedComm.communityAffiliationId !== -1) {
                                    vm.filter.selectedCommunities.push(selectedComm.communityAffiliationId);
                                }
                            });
                            // If working list is empty, set comm filter back to empty
                            vm.filter.selectedCommunities = vm.filter.selectedCommunities.length === 0 ? null : vm.filter.selectedCommunities;
                        }
                        vm.filter.startDate = result.filter.startDate;
                        vm.filter.endDate = result.filter.endDate;
                        vm.filter.workEmail = result.filter.workEmail;

                        $location.search({
                            community: vm.filter.selectedCommunities,
                            startDate: vm.filter.startDate || null,
                            endDate: vm.filter.endDate || null,
                            firstName: vm.filter.firstName || null,
                            lastName: vm.filter.lastName || null,
                            workEmail: vm.filter.workEmail || null
                        });

                        return getUsers(0, vm.loadStatus.defaultNumRows);
                    case 'error':
                        vm.isLoading = false;
                        return $scope.$emit('people:alert', result.message);
                    default:
                        vm.isLoading = false;
                        return $scope.$emit('people:alert', "Failed to create new filter!");
                }
            }).catch(function (error) {
                $scope.$emit('people:alert', error);
                vm.isLoading = false;
            });
        }

        function onClickSearch() {
            $location.search({
                community: vm.filter.selectedCommunities,
                startDate: vm.filter.startDate || null,
                endDate: vm.filter.endDate || null,
                firstName: vm.filter.firstName || null,
                lastName: vm.filter.lastName || null,
                workEmail: vm.filter.workEmail || null
            });
            getUsers(0, vm.loadStatus.defaultNumRows);
            return updateCheckAllAndExport();
        }

        function onClickAddNewAVCCAssistant() {
            openAVCCAssistantModal();
        }

        function onClickEditAVCCAssistant(avccAssistant) {
            openAVCCAssistantModal(avccAssistant);
        }

        function onClickOpenAVCCAssistant(avccAssistant) {
            var paramId = {
                id: avccAssistant.masterUserId
            };
            $window.open($state.href('vmis.profileEdit', paramId), '_blank');
        }

        function openAVCCAssistantModal(avccAssistant) {
            var modalResponsibilities = vm.communities.filter(function (comm) {
                return comm.communityAffiliationId !== -1;
            });

            var modalInstance = $modal.open({
                templateUrl: 'app/components/administrator/people/coordinatorAssistants/editCoordinatorAssistant.view.html',
                controller: 'EditCoordinatorAssistantController',
                controllerAs: 'vm',
                backdrop: 'static',
                keyboard: false,
                resolve: {
                    params: function () {
                        return {
                            activeUserResponsibilities: modalResponsibilities,
                            avccAssistant: angular.copy(avccAssistant) || null,
                            // If user has certain higher roles, they can remove coordinator assistant role entirely
                            canRemove: isProgramManager,
                            // If user is PM but not AVCC, cannot edit roles
                            canEdit: !vm.isPMAndNotAVCC
                        };
                    }
                }
            });

            // Process result from edit modal
            modalInstance.result
                .then(function (result) {
                    processModalResult(result, avccAssistant, modalResponsibilities);
                })
                .catch(function (error) {
                    $scope.$emit('people:alert', error);
                });
        }

        function processModalResult(result, avccAssistant, modalResponsibilities) {
            vm.isLoading = true;
            var promiseArray = [];
            var newResponsibilities = [];
            switch (result.action) {
                case 'edit':
                    // Get subset of old responsibilities that current user could modify
                    var oldRespInPurview = _.intersectionBy(
                        avccAssistant.aosUser.vmisUser.adminProfile.responsibilities.avccAssistant,
                        modalResponsibilities,
                        'communityAffiliationId');

                    // oldRespInPurview holds old responsibilities, result holds new
                    var delResponsibilities = _.differenceBy(
                        oldRespInPurview,
                        result.responsibilities,
                        'communityAffiliationId');
                    newResponsibilities = _.differenceBy(
                        result.responsibilities,
                        oldRespInPurview,
                        'communityAffiliationId');

                    // API does not handle AVCC Assistant "isAddingOrRemovingResponsibilities"
                    // Must do adding and deleting separately
                    // Add first so that entire role doesn't have potential to be removed in process.
                    if (newResponsibilities.length > 0)
                        promiseArray.push(authentication.modifyUserRoles({
                            masterUserId: result.masterUserId,
                            aosUserRoles: ["AVC Coordinator Assistant"],
                            communityAffiliationIds: newResponsibilities.map(function (resp) {
                                return resp.communityAffiliationId;
                            }),
                            isAdding: true
                        }));
                    if (delResponsibilities.length > 0)
                        promiseArray.push(authentication.modifyUserRoles({
                            masterUserId: result.masterUserId,
                            aosUserRoles: ["AVC Coordinator Assistant"],
                            communityAffiliationIds: delResponsibilities.map(function (resp) {
                                return resp.communityAffiliationId;
                            }),
                            isDeleting: true
                        }));
                    break;
                case 'save':
                    newResponsibilities = result.responsibilities.map(function (comm) {
                        return comm.communityAffiliationId;
                    });

                    promiseArray.push(authentication.modifyUserRoles({
                        masterUserId: result.masterUserId,
                        aosUserRoles: ["AVC Coordinator Assistant"],
                        communityAffiliationIds: newResponsibilities,
                        isAdding: true
                    }));
                    break;
                case 'remove':
                    promiseArray.push(authentication.modifyUserRoles({
                        masterUserId: result.masterUserId,
                        aosUserRoles: ["AVC Coordinator Assistant"],
                        isDeleting: true
                    }));
                    break;
                default:
                    break;
            }

            return $q.all(promiseArray).then(function () {
                $scope.$emit('profile:update');
                return getUsers(0, vm.loadStatus.defaultNumRows);
            }).catch(function (error) {
                $scope.$emit('people:alert', error);
                vm.isLoading = false;
            });
        }

        function onCheckAll() {
            // Check users in either complete or filtered list
            for (var i = 0; i < vm.usersWithRole.length; i++)
                vm.usersWithRole[i].isChecked = vm.checkAll;

            updateCheckAllAndExport();
        }

        function onCheckUser() {
            updateCheckAllAndExport();
        }

        function updateCheckAllAndExport() {
            vm.numUsersSelected = 0;
            for (var i = 0; i < vm.usersWithRole.length; i++) {
                if (vm.usersWithRole[i].isChecked)
                    vm.numUsersSelected++;
            }

            // If list empty, uncheck
            if (vm.usersWithRole.length === 0) {
                vm.checkAll = false;
            }
            // Otherwise look for a checked user
            else {
                vm.checkAll = vm.usersWithRole.every(function (user) {
                    return user.isChecked;
                });
            }
        }

        function onMassEmail() {
            var emails = vm.usersWithRole.filter(function (user) {
                return user.isChecked;
            }).map(function (user) {
                return (
                    (user.aosUser.vmisUser.adminProfile.workEmail) ?
                        user.aosUser.vmisUser.adminProfile.workEmail :
                        (user.masterUserEmail) ? user.masterUserEmail : null
                );
            });

            if (emails.length === 0)
                return;

            emails = Array.from(new Set(emails));
            emails = emails.filter(Boolean);

            var modalInstance = $modal.open({
                templateUrl: 'app/components/administrator/people/actionDirectives/massEmail.view.html',
                controller: 'MassEmailController',
                controllerAs: 'vm',
                backdrop: 'static',
                keyboard: false,
                resolve: {
                    params: function () {
                        return {
                            emails: emails
                        };
                    }
                }
            });

            // Process result from modal
            modalInstance.result
                .then(function (result) {
                    switch (result.action) {
                        case 'success':
                            var message = "";
                            if (emails.length !== 1)
                                message = "Mass email \"" + result.message + "\" successfully sent to " + emails.length + " users!";
                            else
                                message = "Mass email \"" + result.message + "\" successfully sent to 1 user!";

                            return $scope.$emit('people:success', message);
                        case 'error':
                            return $scope.$emit('people:alert', result.message);
                        default:
                            return $scope.$emit('people:alert', "Mass email failed to send!");
                    }
                })
                .catch(function (error) {
                    $scope.$emit('people:alert', error);
                });
        }

        // Export currently-checked users to spreadsheet format for download
        function onExport() {
            vm.isExporting = true;

            var exportingUsersHeader = [
                "First Name",
                "Last Name",
                "Last Login Date",
                "Responsibilities",
                "Email\r\n"
            ].toString();

            var exportingUsers = [exportingUsersHeader];
            exportingUsers = exportingUsers.concat(vm.usersWithRole.filter(function (user) {
                return user.isChecked;
            }).map(function (checkedUser) {
                var responsibilitiesStr = "\"";
                if (angular.isDefined(checkedUser.aosUser.vmisUser.adminProfile.responsibilities.avccAssistant)) {
                    checkedUser.aosUser.vmisUser.adminProfile.responsibilities.avccAssistant.forEach(function (comm) {
                        responsibilitiesStr += comm.communityAffiliationName + "; ";
                    });
                    responsibilitiesStr = responsibilitiesStr.slice(0, -2);
                    responsibilitiesStr += "\"";
                }

                var email = (checkedUser.aosUser.vmisUser.adminProfile.workEmail !== null) ?
                    checkedUser.aosUser.vmisUser.adminProfile.workEmail : "";

                return [
                    checkedUser.aosUser.firstName,
                    checkedUser.aosUser.lastName,
                    checkedUser.lastSignedIn,
                    responsibilitiesStr,
                    email
                ].toString() + "\r\n";
            }));

            var blob = new Blob(exportingUsers, { type: "text/plain;charset=utf-8" });
            saveAs(blob, (moment().format('YYYYMMDD_HHmmss') + "_Report.csv"));

            vm.isExporting = false;
        }

        function onLoadMore() {
            getUsers(vm.loadStatus.currentIndex, vm.loadStatus.nextResultLoadNum);
            vm.checkAll = false;
        }

        function onLoadAll() {
            getUsers(vm.loadStatus.currentIndex, vm.loadStatus.numResultsNotLoaded);
            vm.checkAll = false;
        }

        function massActionDisabled() {
            return vm.numUsersSelected === 0 || vm.isExporting || vm.isLoading;
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('vmis.administrator')
        .controller('EditCoordinatorAssistantController', EditCoordinatorAssistantController);

    EditCoordinatorAssistantController.$inject = ['$modalInstance', '$modal', 'params', 'authentication', 'usersServices'];

    function EditCoordinatorAssistantController($modalInstance, $modal, params, authentication, usersServices) {
        var vm = this;

        vm.isLoading = true;

        vm.avccAssistant = params.avccAssistant || {};
        vm.isNewAVCCAssistant = params.avccAssistant === null;
        vm.canRemove = !vm.isNewAVCCAssistant && params.canRemove;
        vm.canEdit = params.canEdit;

        if (vm.isNewAVCCAssistant)
            vm.title = "Add New AVCC Assistant";
        else
            vm.title = "Edit AVCC Assistant - " + vm.avccAssistant.aosUser.firstName + " " + vm.avccAssistant.aosUser.lastName;

        vm.errorText = "";

        vm.communities = params.activeUserResponsibilities;
        vm.avccAssistantResponsibilities = [];
        var originalResponsibilities = [];

        vm.onClickRemove = onClickRemove;
        vm.onSubmit = onSubmit;

        activate();

        function activate() {
            if (!vm.isNewAVCCAssistant && vm.avccAssistant.aosUser.vmisUser.adminProfile.responsibilities.avccAssistant) {
                // If existing role with responsibilities, fill ui-select
                vm.avccAssistant.aosUser.vmisUser.adminProfile.responsibilities.avccAssistant.forEach(function (resp) {
                    // If AVCC Assistant responsibility is under active user's purview
                    if (isInActiveUserResponsibilities(resp)) {
                        vm.avccAssistantResponsibilities.push(_.find(vm.communities, function (comm) {
                            return comm.communityAffiliationId === resp.communityAffiliationId;
                        }));
                    }
                    // If AVCC Assistant responsibility is outside active user's purview
                    else {
                        resp.readOnly = true;
                        vm.avccAssistantResponsibilities.push(resp);
                    }
                });

                originalResponsibilities = angular.copy(vm.avccAssistantResponsibilities);
            }

            vm.isLoading = false;
        }

        function onClickRemove() {
            vm.isLoading = true;

            var modalInstance = $modal.open({
                templateUrl: 'app/components/administrator/people/actionDirectives/confirmRoleRemove.view.html',
                controller: 'ConfirmRoleRemoveController',
                controllerAs: 'vm',
                backdrop: 'static',
                keyboard: false,
                resolve: {
                    params: function () {
                        return {
                            userInfo: vm.avccAssistant,
                            role: "AVC Coordinator Assistant"
                        };
                    }
                }
            });

            modalInstance.result
                .then(function () {
                    close('remove', vm.avccAssistant.masterUserId, originalResponsibilities);
                    vm.isLoading = false;
                })
                .catch(function (error) {
                    if (angular.isDefined(error))
                        setError(error);
                    vm.isLoading = false;
                });
        }

        function onSubmit() {
            vm.isLoading = true;
            var getProfilePromise = Promise.resolve(null);
            if (vm.isNewAVCCAssistant){
                getProfilePromise = authentication.getMasterUserIdFromEmail({email: vm.avccAssistant.masterUserEmail})
                    .then(function(response){
                        if(response.success === true){
                            clearError();
                            vm.avccAssistant.masterUserId = response.masterUserId;
                            return authentication.getUserProfile({masterUserId: response.masterUserId});
                        }
                        else {
                            setError("The entered email address does not match any existing user");
                            vm.isLoading = false;
                        }
                    });
            }
            else {
                getProfilePromise = authentication.getUserProfile({masterUserId: vm.avccAssistant.masterUserId});
            }

            getProfilePromise
                .then(function(userProfile) {
                    var isUserAVCCAssistant = userProfile.roles.vmisUserRoles.filter(function (role) {
                        return role === "AVC Coordinator Assistant";
                    }).length === 1;

                    // If using "Add New" button, make sure not modifying an AVCC Assistant
                    // that the user could edit in the table.
                    if (vm.isNewAVCCAssistant && isUserAVCCAssistant) {
                        if (!usersServices.isBasicAdminUserDataComplete(userProfile))
                        {
                            setError("This user cannot be added due to incomplete data");
                            vm.isLoading = false;
                            return;
                        }

                        var avccAssistResp = userProfile.aosUser.vmisUser.adminProfile.responsibilities.avccAssistant;

                        // TODO: Use new school methods like in editCoordinator.controller.js
                        var isOverlappingResponsibility = false;
                        for (var i = 0; i < avccAssistResp.length; i++) {
                            if (isOverlappingResponsibility) break;
                            for (var j = 0; j < vm.communities.length; j++) {
                                if (avccAssistResp[i].communityAffiliationId ===
                                    vm.communities[j].communityAffiliationId) {
                                    isOverlappingResponsibility = true;
                                    break;
                                }
                            }
                        }

                        if (isOverlappingResponsibility) {
                            setError("The account associated with the email address is already an AVCC Assistant you can edit. You must find and edit that user's roles in the table.");
                            vm.isLoading = false;
                            return;
                        }
                        // If not new role but user not visible in table
                        else {
                            close('edit', vm.avccAssistant.masterUserId, vm.avccAssistantResponsibilities);
                            return;
                        }
                    }

                    // If new role and not already AVCC Assistant
                    if (vm.isNewAVCCAssistant)
                        close('save', vm.avccAssistant.masterUserId, vm.avccAssistantResponsibilities);
                    // If not new role
                    else
                        close('edit', vm.avccAssistant.masterUserId, vm.avccAssistantResponsibilities);
                })
                .catch(function (error) {
                    setError(error);
                    vm.isLoading = false;
                });

        }

        function isInActiveUserResponsibilities(resp) {
            for (var i = 0; i < vm.communities.length; i++) {
                if (resp.communityAffiliationId === vm.communities[i].communityAffiliationId)
                    return true;
            }

            return false;
        }

        function setError(error) {
            var errorStr = error.error ? error.error : error;
            if (errorStr === 'cancel' || errorStr === 'backdrop click')
                return;
            vm.errorText = errorStr;
        }

        function clearError() {
            vm.errorText = "";
        }

        function close(action, masterUserId, responsibilities) {
            $modalInstance.close({
                action: action,
                masterUserId: masterUserId,
                responsibilities: filterResponsibilities(responsibilities)
            });
        }

        // Ensure only new target user responsibilities
        // that the active user can edit are present
        function filterResponsibilities(resp) {
            return resp.filter(function (comm) {
                return isInActiveUserResponsibilities(comm);
            });
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('vmis.administrator')
        .controller('CoordinatorsController', CoordinatorsController);

    CoordinatorsController.$inject = ['$q', '$modal', '$scope', '$location', 'authentication', 'loadStatus', 'params', 'moment', '_', '$timeout', '$window', '$state'];

    function CoordinatorsController($q, $modal, $scope, $location, authentication, loadStatus, params, moment, _, $timeout, $window, $state) {
        var vm = this;

        vm.isLoading = true;
        vm.roleObjectList = angular.copy(params.roleObjectList);
        vm.responsibilities = angular.copy(params.responsibilities);

        var isProgramManager = params.isProgramManager;

        vm.selectedRoleObject = vm.roleObjectList.filter(function (role) {
            return role.name === "AVCC";
        })[0];
        vm.numUsersSelected = 0;
        vm.isExporting = false;

        vm.sortColumn = 'aosUser.lastName';
        vm.sortReverse = false;

        vm.filter = {
            selectedCommunities: $location.search().community|| undefined,
            lastName: $location.search().lastName || '',
            firstName: $location.search().firstName || '',
            startDate: isNaN(new Date($location.search().startDate)) ? undefined : new Date($location.search().startDate),
            endDate: isNaN(new Date($location.search().endDate)) ? undefined : new Date($location.search().endDate),
            workEmail: $location.search().workEmail || ''
        };

        if(vm.filter.selectedCommunities !== undefined){
            if(Array.isArray(vm.filter.selectedCommunities)){
                vm.filter.selectedCommunities.forEach(function(value,index){
                    vm.filter.selectedCommunities[index] = _.parseInt(value);
                });
            }
            else {
                vm.filter.selectedCommunities = [_.parseInt(vm.filter.selectedCommunities)];
            }
        }

        vm.loadStatus = loadStatus.init();

        vm.usersWithRole = [];

        vm.onSelectRole = onSelectRole;
        vm.onClickFilterUsers = onClickFilterUsers;
        vm.onClickSearch = onClickSearch;
        vm.onClickAddNewCoordinator = onClickAddNewCoordinator;
        vm.onClickEditCoordinator = onClickEditCoordinator;
        vm.onClickOpenCoordinator = onClickOpenCoordinator;
        vm.onCheckAll = onCheckAll;
        vm.onCheckUser = onCheckUser;
        vm.onMassEmail = onMassEmail;
        vm.onExport = onExport;
        vm.onLoadMore = onLoadMore;
        vm.onLoadAll = onLoadAll;
        vm.massActionDisabled = massActionDisabled;

        activate();

        function activate() {
            vm.massActions = [
                {
                    name: "Export",
                    action: onExport
                },
                {
                    name: "Mass Email",
                    action: onMassEmail
                }
            ];

            loadStatus.setup(vm.loadStatus, "users")
                .then(function () {
                    fillCommunities(); // Calls getUsers
                });
        }

        function fillCommunities() {
            vm.communities = [];
            var promiseArray = [];
            if (isProgramManager) {
                promiseArray.push(authentication.getCommunities({
                    getAll: true
                })
                    .then(function (response) {
                        vm.communities = response.communityAffiliations;
                    })
                    .catch(function (error) {
                        $scope.$emit('people:alert', error);
                        vm.isLoading = false;
                    }));
            }
            else {
                vm.communities = vm.responsibilities.rmManaged;
            }

            return $q.all(promiseArray).then(function () {
                vm.communities.unshift({
                    communityAffiliationId: -1,
                    communityAffiliationName: "All"
                });
                return getUsers(vm.loadStatus.currentIndex, vm.loadStatus.defaultNumRows);
            }).catch(function (error) {
                $scope.$emit('people:alert', error);
                vm.isLoading = false;
            });
        }

        function getUsers(index, num) {
            vm.isLoading = true;
            var allCommunities = !vm.filter.selectedCommunities;

            var paramsGetUsers = {
                vmisRole: "AVC Coordinator",
                startingRowIndex: index,
                numberOfRows: num,
                firstName: vm.filter.firstName ? vm.filter.firstName : undefined,
                lastName: vm.filter.lastName ? vm.filter.lastName : undefined,
                startDate: vm.filter.startDate ? moment(vm.filter.startDate).startOf('day').toISOString() : undefined,
                endDate: vm.filter.endDate ? moment(vm.filter.endDate).endOf('day').toISOString() : undefined,
                workEmail: vm.filter.workEmail ? vm.filter.workEmail : undefined
            };

            if (!allCommunities) {
                paramsGetUsers.communityAffiliationIds = vm.filter.selectedCommunities;
            }

            authentication.getManagersAdmin(paramsGetUsers)
                .then(function (response) {
                    getUsersSuccess(response, index, num);
                })
                .catch(function (error) {
                    getUsersError(error);
                });

            function getUsersSuccess(response, index, num) {
                if (index === 0) {
                    vm.usersWithRole = [];
                    vm.loadStatus.currentIndex = 0;
                }

                for (var i = 0; i < response.users.length; i++) {
                    // Create unique ID for user checkbox
                    response.users[i].checkboxId = "check-" + response.users[i].aosUser.lastName + response.users[i].aosUser.firstName;
                    // Add user to full list
                    vm.usersWithRole.push(response.users[i]);
                }

                updateCheckAllAndExport();

                // Either set current index to max if all users loaded or increment by rows loaded
                vm.loadStatus.currentIndex = (vm.loadStatus.currentIndex + num > response.count) ? response.count : (vm.loadStatus.currentIndex + num);
                // Track total number of users not loaded for "Load All" button
                vm.loadStatus.numResultsNotLoaded = response.count - vm.loadStatus.currentIndex;
                // Set text for "Load More" button
                vm.loadStatus.nextResultLoadNum = (response.count === vm.loadStatus.currentIndex) ? 0 :
                    (vm.loadStatus.numResultsNotLoaded > num) ? num : vm.loadStatus.numResultsNotLoaded;

                $timeout(function () {
                    vm.isLoading = false;
                }, 100);
            }

            function getUsersError(error) {
                if (angular.isDefined(error)) {
                    var errorStr = error.error ? error.error : error;
                    $scope.$emit('people:alert', errorStr);
                }
                else
                    $scope.$emit('people:alert', "Failed to load list! Please try again.");

                $timeout(function () {
                    vm.isLoading = false;
                }, 100);
            }
        }

        function onSelectRole() {
            $scope.$emit('people:role', vm.selectedRoleObject);
        }

        function onClickFilterUsers() {
            var modalInstance = $modal.open({
                templateUrl: 'app/components/administrator/people/actionDirectives/commFilter.view.html',
                controller: 'CommFilterController',
                controllerAs: 'vm',
                backdrop: 'static',
                keyboard: false,
                resolve: {
                    params: function () {
                        return {
                            communities: vm.communities,
                            selectedCommunities: vm.filter.selectedCommunities,
                            startDate: vm.filter.startDate || null,
                            endDate: vm.filter.endDate || null,
                            workEmail: vm.filter.workEmail || null
                        };
                    }
                }
            });

            modalInstance.result.then(function (result) {
                vm.isLoading = true;
                switch (result.action) {
                    case 'success':
                        // Apply results from filter modal
                        if(result.filter.selectedCommunities.length === 0){
                            vm.filter.selectedCommunities = null;
                        }
                        else {
                            vm.filter.selectedCommunities = [];
                            result.filter.selectedCommunities.forEach(function(selectedComm){
                                // If not "All", save
                                if (selectedComm.communityAffiliationId !== -1) {
                                    vm.filter.selectedCommunities.push(selectedComm.communityAffiliationId);
                                }
                            });
                            // If working list is empty, set comm filter back to empty
                            vm.filter.selectedCommunities = vm.filter.selectedCommunities.length === 0 ? null : vm.filter.selectedCommunities;
                        }

                        vm.filter.startDate = result.filter.startDate;
                        vm.filter.endDate = result.filter.endDate;
                        vm.filter.workEmail = result.filter.workEmail;

                        $location.search({
                            community: vm.filter.selectedCommunities,
                            startDate: vm.filter.startDate || null,
                            endDate: vm.filter.endDate || null,
                            firstName: vm.filter.firstName || null,
                            lastName: vm.filter.lastName || null,
                            workEmail: vm.filter.workEmail || null
                        });

                        return getUsers(0, vm.loadStatus.defaultNumRows);
                    case 'error':
                        vm.isLoading = false;
                        return $scope.$emit('people:alert', result.message);
                    default:
                        vm.isLoading = false;
                        return $scope.$emit('people:alert', "Failed to create new filter!");
                }
            }).catch(function (error) {
                $scope.$emit('people:alert', error);
                vm.isLoading = false;
            });
        }

        function onClickSearch() {
            $location.search({
                community: vm.filter.selectedCommunities,
                startDate: vm.filter.startDate || null,
                endDate: vm.filter.endDate || null,
                firstName: vm.filter.firstName || null,
                lastName: vm.filter.lastName || null,
                workEmail: vm.filter.workEmail || null
            });
            getUsers(0, vm.loadStatus.defaultNumRows);
            return updateCheckAllAndExport();
        }

        function onClickAddNewCoordinator() {
            openCoordinatorModal();
        }

        function onClickEditCoordinator(coordinator) {
            openCoordinatorModal(coordinator);
        }

        function onClickOpenCoordinator(coordinator) {
            var paramId = {
                id: coordinator.masterUserId
            };
            $window.open($state.href('vmis.profileEdit', paramId), '_blank');
        }

        function openCoordinatorModal(coordinator) {
            var modalResponsibilities = vm.communities.filter(function (comm) {
                return comm.communityAffiliationId !== -1;
            });

            var modalInstance = $modal.open({
                templateUrl: 'app/components/administrator/people/coordinators/editCoordinator.view.html',
                controller: 'EditCoordinatorController',
                controllerAs: 'vm',
                backdrop: 'static',
                keyboard: false,
                resolve: {
                    params: function () {
                        return {
                            activeUserResponsibilities: modalResponsibilities,
                            coordinator: angular.copy(coordinator) || null,
                            // If user has certain higher roles, they can remove coordinator role entirely
                            canRemove: isProgramManager
                        };
                    }
                }
            });

            // Process result from edit modal
            modalInstance.result
                .then(function (result) {
                    processModalResult(result, coordinator, modalResponsibilities);
                })
                .catch(function (error) {
                    $scope.$emit('people:alert', error);
                });
        }

        function processModalResult(result, coordinator, modalResponsibilities) {
            vm.isLoading = true;
            var promiseArray = [];
            var newResponsibilities = [];
            switch (result.action) {
                case 'edit':
                    newResponsibilities = result.responsibilities.map(function (comm) {
                        return comm.communityAffiliationId;
                    });

                    promiseArray.push(authentication.modifyUserRoles({
                        masterUserId: result.masterUserId,
                        aosUserRoles: ["AVC Coordinator"],
                        communityAffiliationIds: newResponsibilities,
                        isAddingOrRemovingResponsibilities: true
                    }));
                    break;
                case 'save':
                    newResponsibilities = result.responsibilities.map(function (comm) {
                        return comm.communityAffiliationId;
                    });

                    promiseArray.push(authentication.modifyUserRoles({
                        masterUserId: result.masterUserId,
                        aosUserRoles: ["AVC Coordinator"],
                        communityAffiliationIds: newResponsibilities,
                        isAdding: true
                    }));
                    break;
                case 'remove':
                    promiseArray.push(authentication.modifyUserRoles({
                        masterUserId: result.masterUserId,
                        aosUserRoles: ["AVC Coordinator"],
                        isDeleting: true
                    }));
                    break;
                default:
                    break;
            }

            return $q.all(promiseArray).then(function () {
                $scope.$emit('profile:update');
                return getUsers(0, vm.loadStatus.defaultNumRows);
            }).catch(function (error) {
                $scope.$emit('people:alert', error);
                vm.isLoading = false;
            });
        }

        function onCheckAll() {
            // Check users in either complete or filtered list
            for (var i = 0; i < vm.usersWithRole.length; i++)
                vm.usersWithRole[i].isChecked = vm.checkAll;

            updateCheckAllAndExport();
        }

        function onCheckUser() {
            updateCheckAllAndExport();
        }

        function updateCheckAllAndExport() {
            vm.numUsersSelected = 0;
            for (var i = 0; i < vm.usersWithRole.length; i++) {
                if (vm.usersWithRole[i].isChecked)
                    vm.numUsersSelected++;
            }

            // If list empty, uncheck
            if (vm.usersWithRole.length === 0) {
                vm.checkAll = false;
            }
            // Otherwise look for a checked user
            else {
                vm.checkAll = vm.usersWithRole.every(function (user) {
                    return user.isChecked;
                });
            }
        }

        function onMassEmail() {
            var emails = vm.usersWithRole.filter(function (user) {
                return user.isChecked;
            }).map(function (user) {
                return (
                    (user.aosUser.vmisUser.adminProfile.workEmail) ?
                        user.aosUser.vmisUser.adminProfile.workEmail :
                        (user.masterUserEmail) ? user.masterUserEmail : null
                );
            });

            if (emails.length === 0)
                return;

            emails = Array.from(new Set(emails));
            emails = emails.filter(Boolean);

            var modalInstance = $modal.open({
                templateUrl: 'app/components/administrator/people/actionDirectives/massEmail.view.html',
                controller: 'MassEmailController',
                controllerAs: 'vm',
                backdrop: 'static',
                keyboard: false,
                resolve: {
                    params: function () {
                        return {
                            emails: emails
                        };
                    }
                }
            });

            // Process result from modal
            modalInstance.result
                .then(function (result) {
                    switch (result.action) {
                        case 'success':
                            var message = "";
                            if (emails.length !== 1)
                                message = "Mass email \"" + result.message + "\" successfully sent to " + emails.length + " users!";
                            else
                                message = "Mass email \"" + result.message + "\" successfully sent to 1 user!";

                            return $scope.$emit('people:success', message);
                        case 'error':
                            return $scope.$emit('people:alert', result.message);
                        default:
                            return $scope.$emit('people:alert', "Mass email failed to send!");
                    }
                })
                .catch(function (error) {
                    $scope.$emit('people:alert', error);
                });
        }

        // Export currently-checked users to spreadsheet format for download
        function onExport() {
            vm.isExporting = true;

            var exportingUsersHeader = [
                "First Name",
                "Last Name",
                "Last Login Date",
                "Responsibilities",
                "Email\r\n"
            ].toString();

            var exportingUsers = [exportingUsersHeader];
            exportingUsers = exportingUsers.concat(vm.usersWithRole.filter(function (user) {
                return user.isChecked;
            }).map(function (checkedUser) {
                var responsibilitiesStr = "\"";
                if (angular.isDefined(checkedUser.aosUser.vmisUser.adminProfile.responsibilities.avcc)) {
                    checkedUser.aosUser.vmisUser.adminProfile.responsibilities.avcc.forEach(function (comm) {
                        responsibilitiesStr += comm.communityAffiliationName + "; ";
                    });
                    responsibilitiesStr = responsibilitiesStr.slice(0, -2);
                    responsibilitiesStr += "\"";
                }

                var email = (checkedUser.aosUser.vmisUser.adminProfile.workEmail !== null) ?
                    checkedUser.aosUser.vmisUser.adminProfile.workEmail : "";

                return [
                    checkedUser.aosUser.firstName,
                    checkedUser.aosUser.lastName,
                    checkedUser.lastSignedIn,
                    responsibilitiesStr,
                    email
                ].toString() + "\r\n";
            }));

            var blob = new Blob(exportingUsers, { type: "text/plain;charset=utf-8" });
            saveAs(blob, (moment().format('YYYYMMDD_HHmmss') + "_Report.csv"));

            vm.isExporting = false;
        }

        function onLoadMore() {
            getUsers(vm.loadStatus.currentIndex, vm.loadStatus.nextResultLoadNum);
            vm.checkAll = false;
        }

        function onLoadAll() {
            getUsers(vm.loadStatus.currentIndex, vm.loadStatus.numResultsNotLoaded);
            vm.checkAll = false;
        }

        function massActionDisabled() {
            return vm.numUsersSelected === 0 || vm.isExporting || vm.isLoading;
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('vmis.administrator')
        .controller('EditCoordinatorController', EditCoordinatorController);

    EditCoordinatorController.$inject = ['$modalInstance', '$modal', '$q', 'params', 'authentication', 'usersServices'];

    function EditCoordinatorController($modalInstance, $modal, $q, params, authentication, usersServices) {
        var vm = this;

        vm.isLoading = true;

        vm.coordinator = params.coordinator || {};
        vm.isNewAVCC = params.coordinator === null;
        vm.canRemove = !vm.isNewAVCC && params.canRemove;
        if (vm.isNewAVCC)
            vm.title = "Add New AVCC";
        else
            vm.title = "Edit AVCC - " + vm.coordinator.aosUser.firstName + " " + vm.coordinator.aosUser.lastName;

        vm.errorText = "";

        vm.communities = params.activeUserResponsibilities;
        vm.avccResponsibilities = [];
        var originalResponsibilities = [];

        vm.onClickRemove = onClickRemove;
        vm.onSubmit = onSubmit;

        activate();

        function activate() {
            if (!vm.isNewAVCC && vm.coordinator.aosUser.vmisUser.adminProfile.responsibilities.avcc) {
                // If existing role with responsibilities, fill ui-select
                vm.coordinator.aosUser.vmisUser.adminProfile.responsibilities.avcc.forEach(function (resp) {
                    // If AVCC responsibility is under active user's purview
                    if (isInActiveUserResponsibilities(resp)) {
                        vm.avccResponsibilities.push(_.find(vm.communities, function (comm) {
                            return comm.communityAffiliationId === resp.communityAffiliationId;
                        }));
                    }
                    // If AVCC responsibility is outside active user's purview
                    else {
                        resp.readOnly = true;
                        vm.avccResponsibilities.push(resp);
                    }
                });

                originalResponsibilities = angular.copy(vm.avccResponsibilities);
            }

            vm.isLoading = false;
        }

        function onClickRemove() {
            vm.isLoading = true;

            var modalInstance = $modal.open({
                templateUrl: 'app/components/administrator/people/actionDirectives/confirmRoleRemove.view.html',
                controller: 'ConfirmRoleRemoveController',
                controllerAs: 'vm',
                backdrop: 'static',
                keyboard: false,
                resolve: {
                    params: function () {
                        return {
                            userInfo: vm.coordinator,
                            role: "AVC Coordinator"
                        };
                    }
                }
            });

            modalInstance.result
                .then(function () {
                    close('remove', vm.coordinator.masterUserId, originalResponsibilities);
                    vm.isLoading = false;
                })
                .catch(function (error) {
                    if (angular.isDefined(error))
                        setError(error);
                    vm.isLoading = false;
                });
        }

        function onSubmit() {
            vm.isLoading = true;

            var getProfilePromise = Promise.resolve(null);
            if (vm.isNewAVCC){
                getProfilePromise = authentication.getMasterUserIdFromEmail({email: vm.coordinator.masterUserEmail})
                    .then(function(response){
                        if(response.success === true){
                            clearError();
                            vm.coordinator.masterUserId = response.masterUserId;
                            return authentication.getUserProfile({masterUserId: response.masterUserId});
                        }
                        else {
                            setError("The entered email address does not match any existing user");
                            vm.isLoading = false;
                        }
                    });
            }
            else {
                getProfilePromise = authentication.getUserProfile({masterUserId: vm.coordinator.masterUserId});
            }

            getProfilePromise
                .then(function(userProfile) {
                    var isUserAVCC = userProfile.roles.vmisUserRoles.filter(function (role) {
                        return role === "AVC Coordinator";
                    }).length === 1;
                    var isUserAssistant = userProfile.roles.vmisUserRoles.filter(function (role) {
                        return role === "AVC Coordinator Assistant";
                    }).length === 1;

                    // Ensure that if modal is opened or not, later code is only run afterward
                    var confirmationPromise = $q.resolve();

                    // Check if user is an AVCC Assistant. If so, show confirmation modal,
                    // because assistant must be removed to add AVCC.
                    if (isUserAssistant) {
                        confirmationPromise = $modal.open({
                            templateUrl: 'app/components/administrator/people/actionDirectives/confirmAvccAssistReplace.view.html',
                            controller: 'ConfirmAvccAssistReplaceController',
                            controllerAs: 'vm',
                            backdrop: 'static',
                            keyboard: false,
                            resolve: {
                                params: function () {
                                    return {
                                        userInfo: userProfile,
                                        avccResponsibilities: vm.avccResponsibilities
                                    };
                                }
                            }
                        }).result; // Simply continue along normal path if "Ok"
                    }

                    confirmationPromise.then(function () {
                        if (vm.isNewAVCC && isUserAVCC) {
                            if (!usersServices.isBasicAdminUserDataComplete(userProfile))
                            {
                                setError("This user cannot be added due to incomplete data");
                                vm.isLoading = false;
                                return;
                            }

                            var newResponsibilities = vm.communities.map(function (comm) {
                                return comm.communityAffiliationId;
                            });
                            var oldResponsibilities = userProfile.aosUser.vmisUser.adminProfile.responsibilities.avcc.map(function(comm){
                                return comm.communityAffiliationId;
                            });

                            if(_.intersection(newResponsibilities,oldResponsibilities).length > 0) {
                                setError("The account associated with the email address is already an AVCC. You must find and edit that user's roles in the table.");
                                vm.isLoading = false;
                                return;
                            }
                            else {
                                close('edit', response.masterUserId, vm.avccResponsibilities);
                                return;
                            }
                        }

                        if (vm.isNewAVCC)
                            close('save', vm.coordinator.masterUserId, vm.avccResponsibilities);
                        else
                            close('edit', vm.coordinator.masterUserId, vm.avccResponsibilities);
                    }).catch(function (error) {
                        setError(error);
                        vm.isLoading = false;
                    });
                }).catch(function (error) {
                    setError(error);
                    vm.isLoading = false;
                });
        }

        function isInActiveUserResponsibilities(resp) {
            for (var i = 0; i < vm.communities.length; i++) {
                if (resp.communityAffiliationId === vm.communities[i].communityAffiliationId)
                    return true;
            }

            return false;
        }

        function setError(error) {
            if (error === undefined) return;
            var errorStr = error.error ? error.error : error;
            if (errorStr === 'cancel' || errorStr === 'backdrop click')
                return;
            vm.errorText = errorStr;
        }

        function clearError() {
            vm.errorText = "";
        }

        function close(action, masterUserId, responsibilities) {
            $modalInstance.close({
                action: action,
                masterUserId: masterUserId,
                responsibilities: filterResponsibilities(responsibilities)
            });
        }

        // Ensure only new target user responsibilities
        // that the active user can edit are present
        function filterResponsibilities(resp) {
            return resp.filter(function (comm) {
                return isInActiveUserResponsibilities(comm);
            });
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('vmis.administrator')
        .controller('GlobalUserSearchController', GlobalUserSearchController);

    GlobalUserSearchController.$inject = ['$q', '$modal', '$scope', '$location', 'authentication', 'loadStatus', 'config', 'params', 'moment', '_', '$timeout'];

    function GlobalUserSearchController($q, $modal, $scope, $location, authentication, loadStatus, config, params, moment, _, $timeout) {
        var vm = this;

        vm.isLoading = true;
        vm.isExactNameSearch = true;
        vm.usersWithRole = [];
        vm.roleObjectList = angular.copy(params.roleObjectList);
        vm.responsibilities = angular.copy(params.responsibilities);
        vm.selectedRoleObject = vm.roleObjectList.filter(function (role) {
            return role.name === "Global Lookup";
        })[0];

        vm.filter = {
            lastName: $location.search().lastName || '',
            firstName: $location.search().firstName || '',
            email: $location.search().firstName || ''
        };

        vm.loadStatus = loadStatus.init();

        vm.sortColumn = 'aosUser.lastName';
        vm.sortReverse = false;

        vm.onSelectRole = onSelectRole;
        vm.onToggleExactNameSearch = onToggleExactNameSearch;
        vm.onClickSearch = onClickSearch;
        vm.onLoadMore = onLoadMore;
        vm.onLoadAll = onLoadAll;

        activate();

        function activate() {
            vm.isLoading = false;
        }

        function onSelectRole() {
            $scope.$emit('people:role', vm.selectedRoleObject);
        }

        function onToggleExactNameSearch() {}

        function onClickSearch() {
            $location.search({
                isActive: vm.filter.email || null,
                firstName: vm.filter.firstName || null,
                lastName: vm.filter.lastName || null
            });
            config.get().then(function (configData) {
                getUsers(0, configData.defaultNumRows.users);
            });
        }

        function getUsers(index, num) {
            vm.isLoading = true;

            var paramsGetUsers = {
                startingRowIndex: index,
                numberOfRows: num,
                isExactFirstNameLastName: vm.isExactNameSearch,
                firstName: vm.filter.firstName ? vm.filter.firstName : undefined,
                lastName: vm.filter.lastName ? vm.filter.lastName : undefined,
                email: vm.filter.email ? vm.filter.email : undefined,
            };

            authentication.getAllUsers(paramsGetUsers)
                .then(function (response) {
                    getUsersSuccess(response, index, num);
                })
                .catch(function (error) {
                    getUsersError(error);
                });
            function getUsersSuccess(response, index, num) {
                if (index === 0) {
                    vm.usersWithRole = [];
                    vm.loadStatus.currentIndex = 0;
                }

                vm.usersWithRole = response.users;

                // Either set current index to max if all users loaded or increment by rows loaded
                vm.loadStatus.currentIndex = (vm.loadStatus.currentIndex + num > response.count) ?
                    response.count : (vm.loadStatus.currentIndex + num);
                // Track total number of users not loaded for "Load All" button
                vm.loadStatus.numResultsNotLoaded = response.count - vm.loadStatus.currentIndex;
                // Set text for "Load More" button
                vm.loadStatus.nextResultLoadNum = (response.count === vm.loadStatus.currentIndex) ? 0 :
                    (vm.loadStatus.numResultsNotLoaded > num) ? num : vm.loadStatus.numResultsNotLoaded;

                $timeout(function () {
                    vm.isLoading = false;
                }, 100);
            }

            function getUsersError(error) {
                if (angular.isDefined(error)) {
                    var errorStr = error.error ? error.error : error;
                    $scope.$emit('people:alert', errorStr);
                }
                else
                    $scope.$emit('people:alert', "Failed to load list! Please try again.");

                $timeout(function () {
                    vm.isLoading = false;
                }, 100);
            }

        }

        function onLoadMore() {
            getUsers(vm.loadStatus.currentIndex, vm.loadStatus.nextResultLoadNum);
            vm.checkAll = false;
        }

        function onLoadAll() {
            getUsers(vm.loadStatus.currentIndex, vm.loadStatus.numResultsNotLoaded);
            vm.checkAll = false;
        }


    }
})();
(function () {
    'use strict';

    angular
        .module('vmis.administrator')
        .controller('RegionManagersController', RegionManagersController);

    RegionManagersController.$inject = ['$q', '$modal', '$scope', '$location', 'authentication', 'loadStatus', 'params', 'moment', '_', '$timeout', '$window', '$state'];

    function RegionManagersController($q, $modal, $scope, $location, authentication, loadStatus, params, moment, _, $timeout, $window, $state) {
        var vm = this;

        vm.isLoading = true;
        vm.roleObjectList = angular.copy(params.roleObjectList);

        var isProgramManager = params.isProgramManager; // Should always be true

        vm.selectedRoleObject = vm.roleObjectList.filter(function (role) {
            return role.name === "Region Manager";
        })[0];
        vm.numUsersSelected = 0;
        vm.isExporting = false;

        vm.filter = {
            selectedCommunities: _.parseInt($location.search().community) || undefined,
            lastName: $location.search().lastName || '',
            firstName: $location.search().firstName || '',
            startDate: isNaN(new Date($location.search().startDate)) ? undefined : new Date($location.search().startDate),
            endDate: isNaN(new Date($location.search().endDate)) ? undefined : new Date($location.search().endDate),
            workEmail: $location.search().workEmail || ''
        };

        if(vm.filter.selectedCommunities !== undefined){
            if(Array.isArray(vm.filter.selectedCommunities)){
                vm.filter.selectedCommunities.forEach(function(value,index){
                    vm.filter.selectedCommunities[index] = _.parseInt(value);
                });
            }
            else {
                vm.filter.selectedCommunities = [_.parseInt(vm.filter.selectedCommunities)];
            }
        }

        vm.loadStatus = loadStatus.init();

        vm.sortColumn = 'aosUser.lastName';
        vm.sortReverse = false;

        vm.usersWithRole = [];

        vm.onSelectRole = onSelectRole;
        vm.onClickFilterUsers = onClickFilterUsers;
        vm.onClickSearch = onClickSearch;
        vm.onClickAddNewRegionManager = onClickAddNewRegionManager;
        vm.onClickEditRegionManager = onClickEditRegionManager;
        vm.onClickOpenRegionManager = onClickOpenRegionManager;
        vm.onCheckAll = onCheckAll;
        vm.onCheckUser = onCheckUser;
        vm.onMassEmail = onMassEmail;
        vm.onExport = onExport;
        vm.onLoadMore = onLoadMore;
        vm.onLoadAll = onLoadAll;
        vm.massActionDisabled = massActionDisabled;

        activate();

        function activate() {
            vm.massActions = [
                {
                    name: "Export",
                    action: onExport
                },
                {
                    name: "Mass Email",
                    action: onMassEmail
                }
            ];

            loadStatus.setup(vm.loadStatus, "users")
                .then(function () {
                    fillCommunities(); // Calls getUsers
                });
        }

        function fillCommunities() {
            vm.communities = [];
            authentication.getCommunitiesIntermediateNodes({ getAll: true }).then(function (response) {
                vm.communities = response.communityAffiliations;
                vm.communities.unshift({
                    communityAffiliationId: -1,
                    communityAffiliationName: "All"
                });
                return getUsers(vm.loadStatus.currentIndex, vm.loadStatus.defaultNumRows);
            }).catch(function (error) {
                $scope.$emit('people:alert', error.message);
                vm.isLoading = false;
            });
        }

        function getUsers(index, num) {
            vm.isLoading = true;
            var allCommunities = !vm.filter.selectedCommunities;

            var paramsGetUsers = {
                vmisRole: "AVC Region Manager",
                startingRowIndex: index,
                numberOfRows: num,
                firstName: vm.filter.firstName ? vm.filter.firstName : undefined,
                lastName: vm.filter.lastName ? vm.filter.lastName : undefined,
                startDate: vm.filter.startDate ? moment(vm.filter.startDate).startOf('day').toISOString() : undefined,
                endDate: vm.filter.endDate ? moment(vm.filter.endDate).endOf('day').toISOString() : undefined,
                workEmail: vm.filter.workEmail ? vm.filter.workEmail : undefined
            };

            if (!allCommunities) {
                paramsGetUsers.communityAffiliationIds = vm.filter.selectedCommunities;
            }

            authentication.getManagersAdmin(paramsGetUsers)
                .then(function (response) {
                    getUsersSuccess(response, index, num);
                })
                .catch(function (error) {
                    getUsersError(error);
                });

            function getUsersSuccess(response, index, num) {
                if (index === 0) {
                    vm.usersWithRole = [];
                    vm.loadStatus.currentIndex = 0;
                }

                for (var i = 0; i < response.users.length; i++) {
                    // Create secret field for filtering on first and last name simultaneously
                    response.users[i].fullName =
                        response.users[i].aosUser.firstName + " " + response.users[i].aosUser.lastName;
                    // Create unique ID for user checkbox
                    response.users[i].checkboxId = "check-" + response.users[i].fullName.split(" ").join("");
                    // Add user to full list
                    vm.usersWithRole.push(response.users[i]);
                }

                updateCheckAllAndExport();

                // Either set current index to max if all users loaded or increment by rows loaded
                vm.loadStatus.currentIndex = (vm.loadStatus.currentIndex + num > response.count) ? response.count : (vm.loadStatus.currentIndex + num);
                // Track total number of users not loaded for "Load All" button
                vm.loadStatus.numResultsNotLoaded = response.count - vm.loadStatus.currentIndex;
                // Set text for "Load More" button
                vm.loadStatus.nextResultLoadNum = (response.count === vm.loadStatus.currentIndex) ? 0 :
                    (vm.loadStatus.numResultsNotLoaded > num) ? num : vm.loadStatus.numResultsNotLoaded;

                $timeout(function () {
                    vm.isLoading = false;
                }, 100);
            }

            function getUsersError(error) {
                if (angular.isDefined(error)) {
                    var errorStr = error.error ? error.error : error;
                    $scope.$emit('people:alert', errorStr);
                }
                else
                    $scope.$emit('people:alert', "Failed to load list! Please try again.");

                $timeout(function () {
                    vm.isLoading = false;
                }, 100);
            }
        }

        function onSelectRole() {
            $scope.$emit('people:role', vm.selectedRoleObject);
        }

        function onClickFilterUsers() {
            var modalInstance = $modal.open({
                templateUrl: 'app/components/administrator/people/actionDirectives/commFilter.view.html',
                controller: 'CommFilterController',
                controllerAs: 'vm',
                backdrop: 'static',
                keyboard: false,
                resolve: {
                    params: function () {
                        return {
                            communities: vm.communities,
                            selectedCommunities: vm.filter.selectedCommunities,
                            startDate: vm.filter.startDate || null,
                            endDate: vm.filter.endDate || null,
                            workEmail: vm.filter.workEmail || null
                        };
                    }
                }
            });

            modalInstance.result
                .then(function (result) {
                    vm.isLoading = true;
                    switch (result.action) {
                        case 'success':
                            // Apply results from filter modal
                            if(result.filter.selectedCommunities.length === 0){
                                vm.filter.selectedCommunities = null;
                            }
                            else {
                                vm.filter.selectedCommunities = [];
                                result.filter.selectedCommunities.forEach(function(selectedComm){
                                    // If not "All", save
                                    if (selectedComm.communityAffiliationId !== -1) {
                                        vm.filter.selectedCommunities.push(selectedComm.communityAffiliationId);
                                    }
                                });
                                // If working list is empty, set comm filter back to empty
                                vm.filter.selectedCommunities = vm.filter.selectedCommunities.length === 0 ? null : vm.filter.selectedCommunities;
                            }
                            vm.filter.startDate = result.filter.startDate;
                            vm.filter.endDate = result.filter.endDate;
                            vm.filter.workEmail = result.filter.workEmail;

                            $location.search({
                                community: vm.filter.selectedCommunities,
                                startDate: vm.filter.startDate || null,
                                endDate: vm.filter.endDate || null,
                                firstName: vm.filter.firstName || null,
                                lastName: vm.filter.lastName || null,
                                workEmail: vm.filter.workEmail || null
                            });

                            return getUsers(0, vm.loadStatus.defaultNumRows);
                        case 'error':
                            vm.isLoading = false;
                            return $scope.$emit('people:alert', result.message);
                        default:
                            vm.isLoading = false;
                            return $scope.$emit('people:alert', "Failed to create new filter!");
                    }
                })
                .catch(function (error) {
                    $scope.$emit('people:alert', error);
                    vm.isLoading = false;
                });
        }

        function onClickSearch() {
            $location.search({
                community: vm.filter.selectedCommunities,
                startDate: vm.filter.startDate || null,
                endDate: vm.filter.endDate || null,
                firstName: vm.filter.firstName || null,
                lastName: vm.filter.lastName || null,
                workEmail: vm.filter.workEmail || null
            });
            getUsers(0, vm.loadStatus.defaultNumRows);
            return updateCheckAllAndExport();
        }

        function onClickAddNewRegionManager() {
            openRegionManagerModal();
        }

        function onClickEditRegionManager(regionManager) {
            openRegionManagerModal(regionManager);
        }

        function onClickOpenRegionManager(regionManager) {
            var paramId = {
                id: regionManager.masterUserId
            };
            $window.open($state.href('vmis.profileEdit', paramId), '_blank');
        }

        function openRegionManagerModal(regionManager) {
            var modalResponsibilities = vm.communities.filter(function (comm) {
                return comm.communityAffiliationId !== -1;
            });

            var modalInstance = $modal.open({
                templateUrl: 'app/components/administrator/people/regionManagers/editRegionManager.view.html',
                controller: 'EditRegionManagerController',
                controllerAs: 'vm',
                backdrop: 'static',
                keyboard: false,
                resolve: {
                    params: function () {
                        return {
                            activeUserResponsibilities: modalResponsibilities,
                            regionManager: angular.copy(regionManager) || null,
                            // If user is program manager (should be), they can remove region manager role entirely
                            canRemove: isProgramManager
                        };
                    }
                }
            });

            // Process result from edit modal
            modalInstance.result
                .then(function (result) {
                    processModalResult(result, regionManager, modalResponsibilities);
                })
                .catch(function (error) {
                    $scope.$emit('people:alert', error);
                });
        }

        function processModalResult(result, regionManager, modalResponsibilities) {
            vm.isLoading = true;
            var promiseArray = [];
            var newResponsibilities = [];
            switch (result.action) {
                case 'edit':
                    newResponsibilities = result.responsibilities.map(function (comm) {
                        return comm.communityAffiliationId;
                    });

                    promiseArray.push(authentication.modifyUserRoles({
                        masterUserId: result.masterUserId,
                        aosUserRoles: ["AVC Region Manager"],
                        communityAffiliationIds: newResponsibilities,
                        isAddingOrRemovingResponsibilities: true
                    }));
                    break;
                case 'save':
                    newResponsibilities = result.responsibilities.map(function (comm) {
                        return comm.communityAffiliationId;
                    });

                    promiseArray.push(authentication.modifyUserRoles({
                        masterUserId: result.masterUserId,
                        aosUserRoles: ["AVC Region Manager"],
                        communityAffiliationIds: newResponsibilities,
                        isAdding: true
                    }));
                    break;
                case 'remove':
                    promiseArray.push(authentication.modifyUserRoles({
                        masterUserId: result.masterUserId,
                        aosUserRoles: ["AVC Region Manager"],
                        isDeleting: true
                    }));
                    break;
                default:
                    break;
            }

            return $q.all(promiseArray).then(function () {
                $scope.$emit('profile:update');
                return getUsers(0, vm.loadStatus.defaultNumRows);
            }).catch(function (error) {
                $scope.$emit('people:alert', error);
                vm.isLoading = false;
            });
        }

        function onCheckAll() {
            // Check users in either complete or filtered list
            for (var i = 0; i < vm.usersWithRole.length; i++)
                vm.usersWithRole[i].isChecked = vm.checkAll;

            updateCheckAllAndExport();
        }

        function onCheckUser() {
            updateCheckAllAndExport();
        }

        function updateCheckAllAndExport() {
            vm.numUsersSelected = 0;
            for (var i = 0; i < vm.usersWithRole.length; i++) {
                if (vm.usersWithRole[i].isChecked)
                    vm.numUsersSelected++;
            }

            // If list empty, uncheck
            if (vm.usersWithRole.length === 0) {
                vm.checkAll = false;
            }
            // Otherwise look for a checked user
            else {
                vm.checkAll = vm.usersWithRole.every(function (user) {
                    return user.isChecked;
                });
            }
        }

        function onMassEmail() {
            var emails = vm.usersWithRole.filter(function (user) {
                return user.isChecked;
            }).map(function (user) {
                return (
                    (user.aosUser.vmisUser.adminProfile.workEmail) ?
                        user.aosUser.vmisUser.adminProfile.workEmail :
                        (user.masterUserEmail) ? user.masterUserEmail : null
                );
            });

            if (emails.length === 0)
                return;

            emails = Array.from(new Set(emails));
            emails = emails.filter(Boolean);

            var modalInstance = $modal.open({
                templateUrl: 'app/components/administrator/people/actionDirectives/massEmail.view.html',
                controller: 'MassEmailController',
                controllerAs: 'vm',
                backdrop: 'static',
                keyboard: false,
                resolve: {
                    params: function () {
                        return {
                            emails: emails
                        };
                    }
                }
            });

            // Process result from modal
            modalInstance.result
                .then(function (result) {
                    switch (result.action) {
                        case 'success':
                            var message = "";
                            if (emails.length !== 1)
                                message = "Mass email \"" + result.message + "\" successfully sent to " + emails.length + " users!";
                            else
                                message = "Mass email \"" + result.message + "\" successfully sent to 1 user!";

                            return $scope.$emit('people:success', message);
                        case 'error':
                            return $scope.$emit('people:alert', result.message);
                        default:
                            return $scope.$emit('people:alert', "Mass email failed to send!");
                    }
                })
                .catch(function (error) {
                    $scope.$emit('people:alert', error);
                });
        }

        // Export currently-checked users to spreadsheet format for download
        function onExport() {
            vm.isExporting = true;

            var exportingUsersHeader = [
                "First Name",
                "Last Name",
                "Last Login Date",
                "Responsibilities",
                "Email\r\n"
            ].toString();

            var exportingUsers = [exportingUsersHeader];
            exportingUsers = exportingUsers.concat(vm.usersWithRole.filter(function (user) {
                return user.isChecked;
            }).map(function (checkedUser) {
                var responsibilitiesStr = "\"";
                if (angular.isDefined(checkedUser.aosUser.vmisUser.adminProfile.responsibilities.rm)) {
                    checkedUser.aosUser.vmisUser.adminProfile.responsibilities.rm.forEach(function (comm) {
                        responsibilitiesStr += comm.communityAffiliationName + "; ";
                    });
                    responsibilitiesStr = responsibilitiesStr.slice(0, -2);
                    responsibilitiesStr += "\"";
                }

                var email = (checkedUser.aosUser.vmisUser.adminProfile.workEmail !== null) ?
                    checkedUser.aosUser.vmisUser.adminProfile.workEmail : "";

                return [
                    checkedUser.aosUser.firstName,
                    checkedUser.aosUser.lastName,
                    checkedUser.lastSignedIn,
                    responsibilitiesStr,
                    email
                ].toString() + "\r\n";
            }));

            var blob = new Blob(exportingUsers, { type: "text/plain;charset=utf-8" });
            saveAs(blob, (moment().format('YYYYMMDD_HHmmss') + "_Report.csv"));

            vm.isExporting = false;
        }

        function onLoadMore() {
            getUsers(vm.loadStatus.currentIndex, vm.loadStatus.nextResultLoadNum);
            vm.checkAll = false;
        }

        function onLoadAll() {
            getUsers(vm.loadStatus.currentIndex, vm.loadStatus.numResultsNotLoaded);
            vm.checkAll = false;
        }

        function massActionDisabled() {
            return vm.numUsersSelected === 0 || vm.isExporting || vm.isLoading;
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('vmis.administrator')
        .controller('EditRegionManagerController', EditRegionManagerController);

    EditRegionManagerController.$inject = ['$modalInstance', '$modal', 'params', 'authentication'];

    function EditRegionManagerController($modalInstance, $modal, params, authentication) {
        var vm = this;

        vm.isLoading = true;

        vm.regionManager = params.regionManager || {};
        vm.isNewRegionManager = params.regionManager === null;
        vm.canRemove = !vm.isNewRegionManager && params.canRemove;
        if (vm.isNewRegionManager)
            vm.title = "Add New Region Manager";
        else
            vm.title = "Edit Region Manager - " + vm.regionManager.aosUser.firstName + " " + vm.regionManager.aosUser.lastName;

        vm.errorText = "";

        vm.regions = params.activeUserResponsibilities;
        vm.rmResponsibilities = [];
        var originalResponsibilities = [];

        vm.onClickRemove = onClickRemove;
        vm.onSubmit = onSubmit;

        activate();

        function activate() {
            if (!vm.isNewRegionManager && vm.regionManager.aosUser.vmisUser.adminProfile.responsibilities.rm) {
                // If existing role with responsibilities, fill ui-select
                vm.regionManager.aosUser.vmisUser.adminProfile.responsibilities.rm.forEach(function (resp) {
                    vm.rmResponsibilities.push(_.find(vm.regions, function (region) {
                        return region.communityAffiliationId === resp.communityAffiliationId;
                    }));
                });
                originalResponsibilities = angular.copy(vm.rmResponsibilities);
            }

            vm.isLoading = false;
        }

        function onClickRemove() {
            vm.isLoading = true;

            var modalInstance = $modal.open({
                templateUrl: 'app/components/administrator/people/actionDirectives/confirmRoleRemove.view.html',
                controller: 'ConfirmRoleRemoveController',
                controllerAs: 'vm',
                backdrop: 'static',
                keyboard: false,
                resolve: {
                    params: function () {
                        return {
                            userInfo: vm.regionManager,
                            role: "AVC Region Manager"
                        };
                    }
                }
            });

            modalInstance.result
                .then(function () {
                    close('remove', vm.regionManager.masterUserId, originalResponsibilities);
                    vm.isLoading = false;
                })
                .catch(function (error) {
                    if (angular.isDefined(error))
                        setError(error);
                    vm.isLoading = false;
                });
        }

        function onSubmit() {
            vm.isLoading = true;

            var getProfilePromise = Promise.resolve(null);
            if (vm.isNewRegionManager){
                getProfilePromise = authentication.getMasterUserIdFromEmail({email: vm.regionManager.masterUserEmail})
                    .then(function(response){
                        if(response.success === true){
                            clearError();
                            vm.regionManager.masterUserId = response.masterUserId;
                            return authentication.getUserProfile({masterUserId: response.masterUserId});
                        }
                        else {
                            setError("The entered email address does not match any existing user");
                            vm.isLoading = false;
                        }
                    });
            }
            else {
                getProfilePromise = authentication.getUserProfile({masterUserId: vm.regionManager.masterUserId});
            }

            getProfilePromise
                .then(function(userProfile) {
                    var isUserRM = userProfile.roles.vmisUserRoles.filter(function (role) {
                        return role === "AVC Region Manager";
                    }).length === 1;

                    if (vm.isNewRegionManager && isUserRM) {
                        setError("The account associated with the email address is already an RM. You must find and edit that user's roles in the table.");
                        vm.isLoading = false;
                        return;
                    }

                    if (vm.isNewRegionManager)
                        close('save', vm.regionManager.masterUserId, vm.rmResponsibilities);
                    else
                        close('edit', vm.regionManager.masterUserId, vm.rmResponsibilities);
                })
                .catch(function (error) {
                    setError(error);
                    vm.isLoading = false;
                });
        }

        function setError(error) {
            var errorStr = error.error ? error.error : error;
            if (errorStr === 'cancel' || errorStr === 'backdrop click')
                return;
            vm.errorText = errorStr;
        }

        function clearError() {
            vm.errorText = "";
        }

        function close(action, masterUserId, responsibilities) {
            $modalInstance.close({
                action: action,
                masterUserId: masterUserId,
                responsibilities: responsibilities
            });
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('vmis.administrator')
        .controller('ProgramManagersController', ProgramManagersController);

    ProgramManagersController.$inject = ['$q', '$modal', '$scope', '$location', 'authentication', 'loadStatus', 'params', 'moment', '$timeout', '$window', '$state'];

    function ProgramManagersController($q, $modal, $scope, $location, authentication, loadStatus, params, moment, $timeout, $window, $state) {
        var vm = this;

        vm.isLoading = true;
        vm.roleObjectList = angular.copy(params.roleObjectList);

        var isProgramManager = params.isProgramManager; // Should always be true
        var masterUserId = params.masterUserId;

        vm.selectedRoleObject = vm.roleObjectList.filter(function (role) {
            return role.name === "Program Manager";
        })[0];
        vm.numUsersSelected = 0;
        vm.isExporting = false;
        vm.sortColumn = 'aosUser.lastName';
        vm.sortReverse = false;

        vm.filter = {
            lastName: $location.search().lastName || '',
            firstName: $location.search().firstName || '',
            startDate: isNaN(new Date($location.search().startDate)) ? undefined : new Date($location.search().startDate),
            endDate: isNaN(new Date($location.search().endDate)) ? undefined : new Date($location.search().endDate),
            workEmail: $location.search().workEmail || ''
        };

        vm.loadStatus = loadStatus.init();

        vm.usersWithRole = [];

        vm.onSelectRole = onSelectRole;
        vm.onClickFilterUsers = onClickFilterUsers;
        vm.onClickSearch = onClickSearch;
        vm.onClickAddNewProgramManager = onClickAddNewProgramManager;
        vm.onClickRemoveProgramManager = onClickRemoveProgramManager;
        vm.onClickOpenProgramManager = onClickOpenProgramManager;
        vm.onCheckAll = onCheckAll;
        vm.onCheckUser = onCheckUser;
        vm.onMassEmail = onMassEmail;
        vm.onExport = onExport;
        vm.onLoadMore = onLoadMore;
        vm.onLoadAll = onLoadAll;
        vm.massActionDisabled = massActionDisabled;

        activate();

        function activate() {
            vm.massActions = [
                {
                    name: "Export",
                    action: onExport
                },
                {
                    name: "Mass Email",
                    action: onMassEmail
                }
            ];

            loadStatus.setup(vm.loadStatus, "users")
                .then(function () {
                    getUsers(vm.loadStatus.currentIndex, vm.loadStatus.defaultNumRows);
                });
        }

        function getUsers(index, num) {
            vm.isLoading = true;

            var paramsGetUsers = {
                vmisRole: "AVC Program Manager",
                startingRowIndex: index,
                numberOfRows: num,
                firstName: vm.filter.firstName ? vm.filter.firstName : undefined,
                lastName: vm.filter.lastName ? vm.filter.lastName : undefined,
                startDate: vm.filter.startDate ? moment(vm.filter.startDate).startOf('day').toISOString() : undefined,
                endDate: vm.filter.endDate ? moment(vm.filter.endDate).endOf('day').toISOString() : undefined,
                workEmail: vm.filter.workEmail ? vm.filter.workEmail : undefined
            };

            authentication.getManagersAdmin(paramsGetUsers)
                .then(function (response) {
                    getUsersSuccess(response, index, num);
                })
                .catch(function (error) {
                    getUsersError(error);
                });

            function getUsersSuccess(response, index, num) {
                if (index === 0) {
                    vm.usersWithRole = [];
                    vm.loadStatus.currentIndex = 0;
                }

                for (var i = 0; i < response.users.length; i++) {
                    // Create unique ID for user checkbox
                    response.users[i].checkboxId = "check-" + response.users[i].aosUser.lastName + response.users[i].aosUser.firstName;
                    // Add user to full list
                    vm.usersWithRole.push(response.users[i]);
                }

                updateCheckAllAndExport();

                // Either set current index to max if all users loaded or increment by rows loaded
                vm.loadStatus.currentIndex = (vm.loadStatus.currentIndex + num > response.count) ? response.count : (vm.loadStatus.currentIndex + num);
                // Track total number of users not loaded for "Load All" button
                vm.loadStatus.numResultsNotLoaded = response.count - vm.loadStatus.currentIndex;
                // Set text for "Load More" button
                vm.loadStatus.nextResultLoadNum = (response.count === vm.loadStatus.currentIndex) ? 0 :
                    (vm.loadStatus.numResultsNotLoaded > num) ? num : vm.loadStatus.numResultsNotLoaded;

                $timeout(function () {
                    vm.isLoading = false;
                }, 100);
            }

            function getUsersError(error) {
                if (angular.isDefined(error)) {
                    var errorStr = error.error ? error.error : error;
                    $scope.$emit('people:alert', errorStr);
                }
                else
                    $scope.$emit('people:alert', "Failed to load list! Please try again.");

                $timeout(function () {
                    vm.isLoading = false;
                }, 100);
            }
        }

        function onSelectRole() {
            $scope.$emit('people:role', vm.selectedRoleObject);
        }

        function onClickFilterUsers() {
            var modalInstance = $modal.open({
                templateUrl: 'app/components/administrator/people/actionDirectives/dateFilter.view.html',
                controller: 'DateFilterController',
                controllerAs: 'vm',
                backdrop: 'static',
                keyboard: false,
                resolve: {
                    params: function () {
                        return {
                            startDate: vm.filter.startDate || null,
                            endDate: vm.filter.endDate || null,
                            workEmail: vm.filter.workEmail || null
                        };
                    }
                }
            });

            modalInstance.result
                .then(function (result) {
                    vm.isLoading = true;
                    switch (result.action) {
                        case 'success':
                            // Apply results from filter modal
                            vm.filter.startDate = result.filter.startDate;
                            vm.filter.endDate = result.filter.endDate;
                            vm.filter.workEmail = result.filter.workEmail;

                            $location.search({
                                startDate: vm.filter.startDate || null,
                                endDate: vm.filter.endDate || null,
                                firstName: vm.filter.firstName || null,
                                lastName: vm.filter.lastName || null,
                                workEmail: vm.filter.workEmail || null
                            });

                            return getUsers(0, vm.loadStatus.defaultNumRows);
                        case 'error':
                            vm.isLoading = false;
                            return $scope.$emit('people:alert', result.message);
                        default:
                            vm.isLoading = false;
                            return $scope.$emit('people:alert', "Failed to create new filter!");
                    }
                })
                .catch(function (error) {
                    $scope.$emit('people:alert', error);
                    vm.isLoading = false;
                });
        }

        function onClickSearch() {
            $location.search({
                startDate: vm.filter.startDate || null,
                endDate: vm.filter.endDate || null,
                firstName: vm.filter.firstName || null,
                lastName: vm.filter.lastName || null,
                workEmail: vm.filter.workEmail || null
            });
            getUsers(0, vm.loadStatus.defaultNumRows);
            return updateCheckAllAndExport();
        }

        function onClickAddNewProgramManager() {
            openProgramManagerModal();
        }

        function onClickRemoveProgramManager(programManager) {
            var modalInstance = $modal.open({
                templateUrl: 'app/components/administrator/people/actionDirectives/confirmRoleRemove.view.html',
                controller: 'ConfirmRoleRemoveController',
                controllerAs: 'vm',
                backdrop: 'static',
                keyboard: false,
                resolve: {
                    params: function () {
                        return {
                            userInfo: programManager,
                            role: "AVC Program Manager"
                        };
                    }
                }
            });

            modalInstance.result
                .then(function () {
                    processModalResult({
                        action: 'remove',
                        masterUserId: programManager.masterUserId,
                        responsibilities: {}
                    },
                        programManager);
                })
                .catch(function (error) {
                    if (angular.isDefined(error))
                        $scope.$emit('people:alert', error);
                    vm.isLoading = false;
                });
        }

        function onClickOpenProgramManager(programManager) {
            var paramId = {
                id: programManager.masterUserId
            };
            $window.open($state.href('vmis.profileEdit', paramId), '_blank');
        }

        function openProgramManagerModal(programManager) {
            var modalInstance = $modal.open({
                templateUrl: 'app/components/administrator/people/programManagers/editProgramManager.view.html',
                controller: 'EditProgramManagerController',
                controllerAs: 'vm',
                backdrop: 'static',
                keyboard: false,
                resolve: {
                    params: function () {
                        return {
                            programManager: angular.copy(programManager) || null,
                            canRemove: isProgramManager
                        };
                    }
                }
            });

            // Process result from edit modal
            modalInstance.result
                .then(function (result) {
                    processModalResult(result, programManager);
                })
                .catch(function (error) {
                    $scope.$emit('people:alert', error);
                });
        }

        function processModalResult(result) {
            vm.isLoading = true;
            var promiseArray = [];
            switch (result.action) {
                case 'edit':
                    promiseArray.push(authentication.modifyUserRoles({
                        masterUserId: result.masterUserId,
                        aosUserRoles: ["AVC Program Manager"],
                        isAdding: true
                    }));
                    break;
                case 'save':
                    promiseArray.push(authentication.modifyUserRoles({
                        masterUserId: result.masterUserId,
                        aosUserRoles: ["AVC Program Manager"],
                        isAdding: true
                    }));
                    break;
                case 'remove':
                    if (result.masterUserId === masterUserId) {
                        $scope.$emit('people:alert', "You cannot remove your own program manager role.");
                        break;
                    }

                    promiseArray.push(authentication.modifyUserRoles({
                        masterUserId: result.masterUserId,
                        aosUserRoles: ["AVC Program Manager"],
                        isDeleting: true
                    }));
                    break;
                default:
                    break;
            }

            return $q.all(promiseArray).then(function () {
                $scope.$emit('profile:update');
                return getUsers(0, vm.loadStatus.defaultNumRows);
            }).catch(function (error) {
                $scope.$emit('people:alert', error);
                vm.isLoading = false;
            });
        }

        function onCheckAll() {
            // Check users in either complete or filtered list
            for (var i = 0; i < vm.usersWithRole.length; i++)
                vm.usersWithRole[i].isChecked = vm.checkAll;

            updateCheckAllAndExport();
        }

        function onCheckUser() {
            updateCheckAllAndExport();
        }

        function updateCheckAllAndExport() {
            vm.numUsersSelected = 0;
            for (var i = 0; i < vm.usersWithRole.length; i++) {
                if (vm.usersWithRole[i].isChecked)
                    vm.numUsersSelected++;
            }

            // If list empty, uncheck
            if (vm.usersWithRole.length === 0) {
                vm.checkAll = false;
            }
            // Otherwise look for a checked user
            else {
                vm.checkAll = vm.usersWithRole.every(function (user) {
                    return user.isChecked;
                });
            }
        }

        function onMassEmail() {
            var emails = vm.usersWithRole.filter(function (user) {
                return user.isChecked;
            }).map(function (user) {
                return (
                    (user.aosUser.vmisUser.adminProfile.workEmail) ?
                        user.aosUser.vmisUser.adminProfile.workEmail :
                        (user.masterUserEmail) ? user.masterUserEmail : null
                );
            });

            if (emails.length === 0)
                return;

            emails = Array.from(new Set(emails));
            emails = emails.filter(Boolean);

            var modalInstance = $modal.open({
                templateUrl: 'app/components/administrator/people/actionDirectives/massEmail.view.html',
                controller: 'MassEmailController',
                controllerAs: 'vm',
                backdrop: 'static',
                keyboard: false,
                resolve: {
                    params: function () {
                        return {
                            emails: emails
                        };
                    }
                }
            });

            // Process result from modal
            modalInstance.result
                .then(function (result) {
                    switch (result.action) {
                        case 'success':
                            var message = "";
                            if (emails.length !== 1)
                                message = "Mass email \"" + result.message + "\" successfully sent to " + emails.length + " users!";
                            else
                                message = "Mass email \"" + result.message + "\" successfully sent to 1 user!";

                            return $scope.$emit('people:success', message);
                        case 'error':
                            return $scope.$emit('people:alert', result.message);
                        default:
                            return $scope.$emit('people:alert', "Mass email failed to send!");
                    }
                })
                .catch(function (error) {
                    $scope.$emit('people:alert', error);
                });
        }

        // Export currently-checked users to spreadsheet format for download
        function onExport() {
            vm.isExporting = true;

            var exportingUsersHeader = [
                "First Name",
                "Last Name",
                "Last Login Date",
                "Email\r\n"
            ].toString();

            var exportingUsers = [exportingUsersHeader];
            exportingUsers = exportingUsers.concat(vm.usersWithRole.filter(function (user) {
                return user.isChecked;
            }).map(function (checkedUser) {
                var email = (checkedUser.aosUser.vmisUser.adminProfile.workEmail !== null) ?
                    checkedUser.aosUser.vmisUser.adminProfile.workEmail : "";

                return [
                    checkedUser.aosUser.firstName,
                    checkedUser.aosUser.lastName,
                    checkedUser.lastSignedIn,
                    email
                ].toString() + "\r\n";
            }));

            var blob = new Blob(exportingUsers, { type: "text/plain;charset=utf-8" });
            saveAs(blob, (moment().format('YYYYMMDD_HHmmss') + "_Report.csv"));

            vm.isExporting = false;
        }

        function onLoadMore() {
            getUsers(vm.loadStatus.currentIndex, vm.loadStatus.nextResultLoadNum);
            vm.checkAll = false;
        }

        function onLoadAll() {
            getUsers(vm.loadStatus.currentIndex, vm.loadStatus.numResultsNotLoaded);
            vm.checkAll = false;
        }

        function massActionDisabled() {
            return vm.numUsersSelected === 0 || vm.isExporting || vm.isLoading;
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('vmis.administrator')
        .controller('EditProgramManagerController', EditProgramManagerController);

    EditProgramManagerController.$inject = ['$modalInstance', '$modal', 'params', 'authentication'];

    // Note: not currently used for editing, only adding new PMs
    function EditProgramManagerController($modalInstance, $modal, params, authentication) {
        var vm = this;

        vm.isLoading = true;

        vm.programManager = params.programManager || {};
        vm.isNewProgramManager = params.programManager === null;
        vm.canRemove = !vm.isNewProgramManager && params.canRemove;
        if (vm.isNewProgramManager)
            vm.title = "Add New Program Manager";
        else
            vm.title = "Edit Program Manager - " + vm.programManager.aosUser.firstName + " " + vm.programManager.aosUser.lastName;

        vm.errorText = "";

        vm.onClickRemove = onClickRemove;
        vm.onSubmit = onSubmit;

        activate();

        function activate() {
            vm.isLoading = false;
        }

        function onClickRemove() {
            vm.isLoading = true;

            var modalInstance = $modal.open({
                templateUrl: 'app/components/administrator/people/actionDirectives/confirmRoleRemove.view.html',
                controller: 'ConfirmRoleRemoveController',
                controllerAs: 'vm',
                backdrop: 'static',
                keyboard: false,
                resolve: {
                    params: function () {
                        return {
                            userInfo: vm.programManager,
                            role: "AVC Program Manager"
                        };
                    }
                }
            });

            modalInstance.result
                .then(function () {
                    close('remove', vm.programManager.masterUserId);
                    vm.isLoading = false;
                })
                .catch(function (error) {
                    if (angular.isDefined(error))
                        setError(error);
                    vm.isLoading = false;
                });
        }

        function onSubmit() {
            vm.isLoading = true;
            authentication.getMasterUserIdFromEmail({
                email: vm.programManager.masterUserEmail
            })
                .then(function (response) {
                    if (response.success === true) {
                        clearError();

                        authentication.getUserProfile({masterUserId: response.masterUserId})
                            .then(function(userProfile) {
                                var isUserPM = userProfile.roles.vmisUserRoles.filter(function (role) {
                                    return role === "AVC Program Manager";
                                }).length === 1;

                                if (vm.isNewProgramManager && isUserPM) {
                                    setError("The account associated with the email address is already a PM. You must find and edit that user's roles in the table.");
                                    vm.isLoading = false;
                                    return;
                                }

                                if (vm.isNewProgramManager)
                                    close('save', response.masterUserId);
                                else
                                    close('edit', response.masterUserId);
                            })
                            .catch(function (error) {
                                setError(error);
                                vm.isLoading = false;
                            });
                    }
                })
                .catch(function (error) {
                    setError("The entered email address does not match any existing user.");
                    vm.isLoading = false;
                });
        }

        function setError(error) {
            var errorStr = error.error ? error.error : error;
            if (errorStr === 'cancel' || errorStr === 'backdrop click')
                return;
            vm.errorText = errorStr;
        }

        function clearError() {
            vm.errorText = "";
        }

        function close(action, masterUserId) {
            $modalInstance.close({
                action: action,
                masterUserId: masterUserId,
                responsibilities: {}
            });
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('vmis.administrator')
        .controller('MassEmailController', MassEmailController);

    MassEmailController.$inject = ['$modalInstance', 'authentication', 'utilsServices', 'params', 'config', '$timeout', '$q'];

    function MassEmailController($modalInstance, authentication, utilsServices, params, config, $timeout, $q) {
        var vm = this;

        vm.isLoading = true;
        vm.maxFilesUploaded = false;
        vm.totalSizeOfFilesSoFar = 0;
        vm.maxNumberOfFiles = 3;
        vm.isFileUploading = false;
        vm.newUpload = false;
        vm.selectedFiles = [];
        vm.docsToBeSent = [];
        vm.allowedFileTypesForUpload = null;
        vm.maxFileSizeInMegabytes = null;
        vm.UUID = null;
        vm.formError = "";

        vm.onSend = onSend;
        vm.onSelectFile = onSelectFile;
        vm.onDeleteSelectedDoc = onDeleteSelectedDoc;

        activate();

        function activate() {
            // Filter list to non-null/undefined and no duplicates
            vm.emails = params.emails.filter(function (email) {
                return email != null;
            }).filter(function (email, index) {
                return params.emails.indexOf(email) === index;
            });

            if (vm.emails.length < params.emails.length) {
                console.warn("Note: " + (params.emails.length - vm.emails.length) +
                    " emails were either missing or duplicates.");
            }

            vm.UUID = generateUUID();
            config.get().then(function (configData) {
                vm.allowedFileTypesForUpload = configData.allowedFileTypesForUpload;
                // This is an int, not a string like similar usages
                vm.maxFileSizeInMegabytes = configData.maxAttachmentSizeInMegabytes + "MB";
            });
            vm.isLoading = false;
        }

        function onSend() {
            vm.isLoading = true;
            vm.isFileUploading = true;

            var formattedBody = vm.body.replace(/(?:\r\n|\r|\n)/g, '<br>');

            uploadDocuments(vm.UUID).then(function(result){
                return authentication.sendEmailToList({
                    emails: vm.emails,
                    subject: vm.subject,
                    body: formattedBody,
                    sentEmailUUID: vm.UUID
                })
                    .then(function (response) {
                        close('success', vm.subject);
                    })
                    .catch(function (error) {
                        close('error', error);
                    });
             });
        }

        function onSelectFile(files, errFiles) {

            if (errFiles.length > 0) {
                vm.formError = "Wrong file type or file size is larger than " + vm.maxFileSizeInMegabytes + ".";
                displayError(vm.formError);
                updateMaxDocumentsUploaded();
                return;
            } else {
                vm.formError = "";
            }
            
            var numDocuments = files.length + vm.selectedFiles.length;

            if (files.length === 0) {
                // Update flag for whether new documents to upload were selected
                return;
            }
            else if (numDocuments > vm.maxNumberOfFiles) {
                return;
            }
            else {
                vm.selectedFiles = vm.selectedFiles.concat(files);
                updateMaxDocumentsUploaded();
            }
        }

        function onDeleteSelectedDoc(document) {

            vm.selectedFiles.splice(vm.selectedFiles.indexOf(document), 1);

            updateMaxDocumentsUploaded();
        }

        function updateMaxDocumentsUploaded() {
            vm.maxFilesUploaded = ((vm.selectedFiles.length) === vm.maxNumberOfFiles);
        }

        function uploadDocuments(sentEmailUUID) {
            // This code is derived from the hours documentation
            var numUploadsDone = 0;
            var uploadDocs = [];
            angular.forEach(vm.selectedFiles, function (document) {
                var uploadDocumentParams = {
                    theFile: document,
                    fileSuffix: document.name.split(".").pop(),
                    documentName: document.name,
                    sentEmailUUID: sentEmailUUID
                };

                // TODO: Ideally would like to not create function in a loop,
                // but no known way to pass in "document" and the response
                uploadDocs.push(authentication.uploadMassEmailAttachment(uploadDocumentParams)
                    .then(function (response) {
                        uploadAttachmentSuccess(response, document);
                    })
                    .catch(function (error) {
                        uploadAttachmentFailure(error, document);
                    }));
            });

            return $q.all(uploadDocs)
                .then(function(_){
                    return $q.when();
                });


            function uploadAttachmentSuccess(response, document) {
                document.uploaded = true; // Show check mark
            }

            function uploadAttachmentFailure(error, document) {
                if (++numUploadsDone === vm.selectedFiles.length) {
                    $timeout(function () {
                        throw ("Document upload failed: " + utilsServices.parseErrorString(error));
                    }, 1000);
                }
            }
        }

        function displayError(error) {
            if (_.isUndefined(error)) return;
            var errorStr = utilsServices.parseErrorString(error);

            vm.isLoading = false;

            if (errorStr === 'cancel' || errorStr === 'backdrop click' || errorStr === 'ok')
                return;
            if (errorStr)
                vm.formError = errorStr;
        }

        function generateUUID() {
            var d = new Date().getTime();
            var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
                var r = (d + Math.random()*16)%16 | 0;
                d = Math.floor(d/16);
                return (c=='x' ? r : (r&0x3|0x8)).toString(16);
            });
            return uuid;
        }

        function close(action, msg) {
            $modalInstance.close({
                action: action,
                message: msg
            });
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('vmis.administrator')
        .controller('ConfirmAvccAssistReplaceController', ConfirmAvccAssistReplaceController);

    ConfirmAvccAssistReplaceController.$inject = ['$modalInstance', 'params'];

    function ConfirmAvccAssistReplaceController($modalInstance, params) {
        var vm = this;

        vm.name = params.userInfo.aosUser.firstName + " " + params.userInfo.aosUser.lastName;
        vm.title = "Replace AVCC Assistant - " + vm.name;
        // Convert responsibilities lists to string separated by comma + space
        vm.avccResponsibilities = params.avccResponsibilities.map(function (resp) {
            return resp.communityAffiliationName;
        }).join(", ");
        // Confirm each object exists (it shouldn't be empty, though)
        vm.avccAssistantResponsibilities = (params.userInfo.aosUser.vmisUser.adminProfile ?
            (params.userInfo.aosUser.vmisUser.adminProfile.responsibilities.avccAssistant ?
                params.userInfo.aosUser.vmisUser.adminProfile.responsibilities.avccAssistant : "") : "")
            .map(function (resp) {
                return resp.communityAffiliationName;
            }).join(", ");

        vm.onAccept = onAccept;

        function onAccept() {
            $modalInstance.close();
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('vmis.administrator')
        .controller('ConfirmRoleRemoveController', ConfirmRoleRemoveController);

    ConfirmRoleRemoveController.$inject = ['$modalInstance', 'params'];

    function ConfirmRoleRemoveController($modalInstance, params) {
        var vm = this;

        vm.name = params.userInfo.aosUser.firstName + " " + params.userInfo.aosUser.lastName;
        vm.role = params.role;
        vm.title = "Remove " + vm.role + " - " + vm.name;

        vm.onAccept = onAccept;

        function onAccept() {
            $modalInstance.close();
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('vmis.administrator')
        .controller('OrgCommFilterController', OrgCommFilterController);

    OrgCommFilterController.$inject = ['$modalInstance', 'moment', 'authentication', 'params', '_', 'config'];

    function OrgCommFilterController($modalInstance, moment, authentication, params, _, config) {
        var vm = this;

        vm.isLoading = true;

        vm.filteringVol = params.role === "Volunteer";

        config.get().then(function (configData) {
            vm.defaultNumRows = configData.defaultNumRows.users;
            vm.maxNumRows = configData.defaultNumRows.maxLoadAll;
        });

        vm.defaultStartingIndex = 0;

        vm.filter = {
            communities: [],
            selectedCommunity: {},
            selectedOrganizations: [],
        };

        // Only allow filtering on activity for volunteers
        if (vm.filteringVol) {
            vm.filter.activities = [
                {
                    name: "All",
                    value: undefined
                },
                {
                    name: "At least 1 Active position",
                    value: true
                },
                {
                    name: "No Active positions",
                    value: false
                }];
            vm.filter.isActive = vm.filter.activities[0];
        }

        if (params.communities)
            vm.filter.communities = params.communities;
        
        vm.filter.selectedCommunity = params.selectedCommunity ? vm.filter.communities.filter(function (comm) {
                return comm.communityAffiliationId === params.selectedCommunity;
            })[0] : vm.filter.communities[0];

        if(params.selectedOrganizations)
        {
            params.selectedOrganizations.forEach(function(selectedOrg){
                vm.selectedOrg = vm.filter.selectedCommunity.organizations.filter(function (org){
                    return org.volunteerOrganizationId == selectedOrg;
                });
                vm.resultAddOrg = vm.selectedOrg[0]?vm.filter.selectedOrganizations.push(vm.selectedOrg[0]):null;
            });
        }

        if (vm.filteringVol && (params.isActive !== undefined))
            vm.filter.isActive = vm.filter.activities.filter(function (activity) {
                return activity.value === params.isActive;
            })[0];

        vm.filter.startDate = params.startDate || null;
        vm.filter.endDate = params.endDate || null;
        vm.currentDate = new Date();

        vm.filter.workEmail = params.workEmail || null;
        vm.filter.volunteerEmail = params.volunteerEmail || null;

        vm.filter.startingRowIndex = params.startingRowIndex || null;
        vm.filter.numberOfRows = params.numberOfRows || null;

        vm.organizationText = "Organization";
        vm.searchEmailText = "Work Email";
        if (vm.filteringVol) {
            vm.organizationText += " of Activity";
            vm.searchEmailText = "Volunteer Email";
        }
        else // Only other role for this modal are OPOCs
            vm.organizationText += " of Responsibility";

        vm.disableOrgDropDown = disableOrgDropDown;
        vm.disableCommunity = disableCommunity;
        vm.onSelectCommunity = onSelectCommunity;
        vm.onSelectOrg = onSelectOrg;
        vm.onClear = onClear;
        vm.onFilter = onFilter;

        activate();

        function activate() {
            // Should only occur if program manager or AVCC/Assistant,
            // since loading all orgs on People page takes too long for PM
            // and AVCC/Assistant responsibilities are on community level.
            if (vm.filter.selectedCommunity.organizations.length === 0)
                fillCommOrgs().then(function(_){
                    if(params.selectedOrganizations)
                    {
                        params.selectedOrganizations.forEach(function(selectedOrg){
                            vm.selectedOrg = vm.filter.selectedCommunity.organizations.filter(function (org){
                                if(org.volunteerOrganizationId !== -1) {
                                    return org.volunteerOrganizationId == selectedOrg;
                                }
                            });
                            vm.resultAddOrg = vm.selectedOrg[0]?vm.filter.selectedOrganizations.push(vm.selectedOrg[0]):null;
                        });
                    }
                });
            else
                vm.isLoading = false;
        }

        function fillCommOrgs() {
            // Do nothing with "All" community placeholder
            if (vm.filter.selectedCommunity.communityAffiliationId === -1) {
                vm.isLoading = false;
                return;
            }
            else
                vm.isLoading = true;

            return authentication.getOrganizations({
                // TODO: Label inactives
                communityAffiliationId: vm.filter.selectedCommunity.communityAffiliationId,
                getAll: true
            })
                .then(function (response) {
                    vm.filter.selectedCommunity.organizations = [];
                    response.organizations.forEach(function (org) {
                        vm.filter.selectedCommunity.organizations.push(org);
                    });
                    vm.filter.selectedOrganizations = [];
                    vm.isLoading = false;
                })
                .catch(function (error) {
                    $scope.$emit('people:alert', error);
                    vm.isLoading = false;
                });
        }

        function disableOrgDropDown() {
            return vm.isLoading || (vm.filter.selectedCommunity.communityAffiliationId === -1);
        }

        function disableCommunity () {
            return vm.filter.selectedOrganizations.length > 0;
        }

        function onSelectCommunity() {
            // Should only occur if program manager or AVCC/Assistant,
            // since loading all orgs on People page takes too long for PM
            // and AVCC/Assistant responsibilities are on community level.
            if (vm.filter.selectedCommunity.organizations.length === 0)
                fillCommOrgs();
            else
                vm.filter.selectedOrganizations = [];
        }

        function onSelectOrg(item, model) {

        }

        function onClear() {
            vm.isLoading = true;

            vm.filter.startDate = null;
            vm.filter.endDate = null;

            vm.filter.workEmail = null;
            vm.filter.volunteerEmail = null;

            vm.filter.startingRowIndex = null;
            vm.filter.numberOfRows = null;

            if (vm.filteringVol)
                vm.filter.isActive = vm.filter.activities[0];
            vm.filter.selectedCommunity = vm.filter.communities[0];
            onSelectCommunity(vm.filter.selectedCommunity);

            onFilter();
        }

        function onFilter() {
            vm.isLoading = true;

            if(vm.filter.startingRowIndex && !vm.filter.numberOfRows){
                vm.filter.numberOfRows = vm.defaultNumRows;
            }

            if(!vm.filter.startingRowIndex && vm.filter.numberOfRows){
                vm.filter.startingRowIndex = vm.defaultStartingIndex;
            }

            var outputFilter = angular.copy(vm.filter);

            // If both fields have data, confirm valid before continuing
            if (outputFilter.startDate && outputFilter.endDate && moment(outputFilter.startDate).isAfter(outputFilter.endDate, 'day')) {
                close('error', "Start Date must be before End Date when filtering.");
            }
            close('success', "Filter successfully created!", outputFilter);
        }

        function close(action, msg, filter) {
            $modalInstance.close({
                action: action,
                message: msg,
                filter: filter || null
            });
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('vmis.administrator')
        .controller('CommFilterController', CommFilterController);

    CommFilterController.$inject = ['$modalInstance', 'moment', 'params'];

    function CommFilterController($modalInstance, moment, params) {
        var vm = this;

        vm.isLoading = true;

        vm.filter = {
            communities: [],
            selectedCommunities: []
        };
        if (params.communities)
            vm.filter.communities = params.communities;

        if(params.selectedCommunities){
            params.selectedCommunities.forEach(function(selectedCommunity){
                vm.selectedCommunity = vm.filter.communities.filter(function(comm){
                   return comm.communityAffiliationId === selectedCommunity;
                });

                vm.resultAddComm = vm.selectedCommunity[0]?vm.filter.selectedCommunities.push(vm.selectedCommunity[0]):null;
            });
        }

        vm.filter.startDate = params.startDate || null;
        vm.filter.endDate = params.endDate || null;
        vm.currentDate = new Date();

        vm.filter.workEmail = params.workEmail || null;

        vm.onClear = onClear;
        vm.onFilter = onFilter;
        vm.onSelectCommunity = onSelectCommunity;

        activate();

        function activate() {
            vm.isLoading = false;
        }

        function onClear() {
            vm.isLoading = true;

            vm.filter.workEmail = null;
            vm.filter.startDate = null;
            vm.filter.endDate = null;
            vm.filter.selectedCommunities = [vm.filter.communities[0]];

            onFilter();
        }

        function onFilter() {
            vm.isLoading = true;

            var outputFilter = angular.copy(vm.filter);

            // If both fields have data, confirm valid before continuing
            if (outputFilter.startDate && outputFilter.endDate && moment(outputFilter.startDate).isAfter(outputFilter.endDate, 'day')) {
                close('error', "Start Date must be before End Date when filtering.");
            }
            close('success', "Filter successfully created!", outputFilter);
        }

        function onSelectCommunity($item, $model) {
            // Array containing just "All" item
            var allCommunity = vm.filter.communities.filter(function(comm){
                return comm.communityAffiliationId === -1;
            });
            // Bool whether new list has "All"
            var containsAll = vm.filter.selectedCommunities.filter(function(comm){
                return comm.communityAffiliationId === -1;
            }).length > 0;
            // Set new list to just "All" if contains that
            if (containsAll) {
                vm.filter.selectedCommunities = allCommunity;
            }
        }

        function close(action, msg, filter) {
            $modalInstance.close({
                action: action,
                message: msg,
                filter: filter || null
            });
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('vmis.administrator')
        .controller('DateFilterController', DateFilterController);

    DateFilterController.$inject = ['$modalInstance', 'moment', 'params'];

    function DateFilterController($modalInstance, moment, params) {
        var vm = this;

        vm.isLoading = true;

        vm.filter = {};
        vm.filter.startDate = params.startDate || null;
        vm.filter.endDate = params.endDate || null;
        vm.currentDate = new Date();
        vm.filter.workEmail = params.workEmail || null;

        vm.onClear = onClear;
        vm.onFilter = onFilter;

        activate();

        function activate() {
            vm.isLoading = false;
        }

        function onClear() {
            vm.isLoading = true;

            vm.filter.startDate = null;
            vm.filter.endDate = null;
            vm.filter.workEmail = null;

            onFilter();
        }

        function onFilter() {
            vm.isLoading = true;

            var outputFilter = angular.copy(vm.filter);

            // If both fields have data, confirm valid before continuing
            if (outputFilter.startDate && outputFilter.endDate && moment(outputFilter.startDate).isAfter(outputFilter.endDate, 'day')) {
                close('error', "Start Date must be before End Date when filtering.");
            }
            close('success', "Filter successfully created!", outputFilter);
        }

        function close(action, msg, filter) {
            $modalInstance.close({
                action: action,
                message: msg,
                filter: filter || null
            });
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('vmis.administrator')
        .config(routes);

    routes.$inject = ['$stateProvider'];

    function routes($stateProvider) {
        $stateProvider
            .state('vmis.administrator.standardOrganizations', {
                url: '/standard-organizations',
                templateUrl: 'app/components/administrator/standardOrganizations/standardOrganizations.view.html',
                controller: 'StandardOrganizationsController',
                controllerAs: 'vm',
                title: 'Standard Organizations'
            });
    }
})();
(function () {
    'use strict';

    angular
        .module('vmis.administrator')
        .controller('StandardOrganizationsController', StandardOrganizationsController);

    StandardOrganizationsController.$inject = ['$q', '$modal', '_', 'authentication', 'loadStatus'];

    function StandardOrganizationsController($q, $modal, _, authentication, loadStatus) {
        var vm = this;

        vm.sortColumn = 'name';
        vm.loadStatus = loadStatus.init();
        vm.isLoading = true;

        vm.onChangeFilter = onChangeFilter;
        vm.onClickStandardOrganization = onClickStandardOrganization;
        vm.onLoadAll = onLoadAll;
        vm.onLoadMore = onLoadMore;

        activate();

        function activate() {
            loadStatus.setup(vm.loadStatus, "standardOrganizations")
                .then(function () {
                    getDropDownData().then(function () {
                        return getStandardOrganizations(vm.loadStatus.currentIndex, vm.loadStatus.defaultNumRows);
                    });
                });
        }

        function getDropDownData() {
            return $q.all({
                groups: authentication.getOrganizationGroups().then(function (response) {
                    return _.concat([{ label: 'All' }], _.map(response.organizationGroups, function (group) {
                        return {
                            label: group.volunteerOrganizationGroupName,
                            value: group.volunteerOrganizationGroupId
                        };
                    }));
                }),
                types: authentication.getUiData(['volunteerorganizationtype']).then(function (response) {
                    return _.concat([{ label: 'All' }], _.map(response.volunteerorganizationtype, function (type) {
                        return {
                            label: type,
                            value: type
                        };
                    }));
                }),
                statuses: $q.when([{ label: 'All' }, {
                    label: 'Active',
                    value: 1
                }, {
                    label: 'Inactive',
                    value: 0
                }])
            }).then(function (responses) {
                vm.dropDowns = {
                    groups: responses.groups,
                    types: responses.types,
                    statuses: responses.statuses
                };

                vm.filters = {
                    group: vm.dropDowns.groups[0],
                    type: vm.dropDowns.types[0],
                    status: vm.dropDowns.statuses[0]
                };
            });
        }

        function getStandardOrganizations(index, num) {
            vm.isLoading = true;

            return authentication.getStandardOrganizations({
                startingRowIndex: index,
                numberOfRows: num,
                volunteerOrganizationGroupId: vm.filters.group.value,
                volunteerOrganizationType: vm.filters.type.value,
                isActive: vm.filters.status.value
            }).then(function (response) {
                if (index === 0) {
                    vm.loadStatus.currentIndex = 0;
                    vm.standardOrganizations = [];
                }

                // Either set current index to max if all users loaded or increment by rows loaded
                vm.loadStatus.currentIndex = (vm.loadStatus.currentIndex + num > response.count) ? response.count : (vm.loadStatus.currentIndex + num);
                // Track total number of users not loaded for "Load All" button
                vm.loadStatus.numResultsNotLoaded = response.count - vm.loadStatus.currentIndex;
                // Set text for "Load More" button
                vm.loadStatus.nextResultLoadNum = (response.count === vm.loadStatus.currentIndex) ? 0 :
                    (vm.loadStatus.numResultsNotLoaded > num) ? num : vm.loadStatus.numResultsNotLoaded;

                vm.standardOrganizations = _.concat(vm.standardOrganizations, _.map(response.standardOrganizations, function (standardOrganization) {
                    return {
                        id: standardOrganization.volunteerOrganizationTemplateId,
                        name: standardOrganization.volunteerOrganizationTemplateName,
                        group: {
                            id: standardOrganization.volunteerOrganizationGroupId,
                            name: standardOrganization.volunteerOrganizationGroup
                        },
                        type: standardOrganization.volunteerOrganizationType,
                        status: standardOrganization.isActive,
                        standardPositionCount: standardOrganization.standardPositionCount,
                        description: standardOrganization.volunteerOrganizationDescription
                    };
                })
                );
                vm.formError = '';
            }).catch(function (error) {
                if (angular.isDefined(error)) {
                    vm.formError = error.error ? error.error : error;
                }
                else
                    vm.formError = 'Failed to load list! Please try again.';
            }).finally(function () {
                vm.isLoading = false;
            });
        }

        function onClickStandardOrganization(standardOrganization) {
            $modal.open({
                templateUrl: 'app/components/administrator/standardOrganizations/standardOrganizationDetails.view.html',
                controller: 'StandardOrganizationDetailsController',
                controllerAs: 'vm',
                backdrop: 'static',
                keyboard: false,
                resolve: {
                    title: function () {
                        return standardOrganization ? 'Standard Organization Details' : 'Add New Standard Organization';
                    },
                    standardOrganization: function () {
                        return standardOrganization ? _.clone(standardOrganization) : {};
                    },
                    dropDowns: function () {
                        return _.forEach(_.clone(vm.dropDowns), function (list, key, dropDowns) {
                            dropDowns[key] = _.tail(list);
                        });
                    }
                }
            }).result.then(function () {
                vm.loadStatus.currentIndex = 0;
                return getStandardOrganizations(vm.loadStatus.currentIndex, vm.loadStatus.defaultNumRows);
            });
        }

        function onChangeFilter() {
            vm.loadStatus.currentIndex = 0;
            getStandardOrganizations(vm.loadStatus.currentIndex, vm.loadStatus.defaultNumRows);
        }

        function onLoadMore() {
            getStandardOrganizations(vm.loadStatus.currentIndex, vm.loadStatus.nextResultLoadNum);
        }

        function onLoadAll() {
            getStandardOrganizations(vm.loadStatus.currentIndex, vm.loadStatus.numResultsNotLoaded);
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('vmis.administrator')
        .controller('StandardOrganizationDetailsController', StandardOrganizationDetailsController);

    StandardOrganizationDetailsController.$inject = ['$modalInstance', '$modal', 'authentication', 'title', 'standardOrganization', 'dropDowns', 'config'];

    function StandardOrganizationDetailsController($modalInstance, $modal, authentication, title, standardOrganization, dropDowns, config) {
        var vm = this;
        var originalStandardOrganizationName = standardOrganization.name;

        vm.title = title;
        vm.standardOrganization = standardOrganization;
        vm.dropDowns = dropDowns;

        vm.isProductionWebsite = null;
        vm.bannerMessage = null;

        vm.onSave = onSave;
        vm.onClickDelete = onClickDelete;

        activate();

        function activate() {
            config.get().then(function (configData) {
                vm.isProductionWebsite = configData.isProductionWebsite;
                vm.bannerMessage = configData.bannerMessage;
            });
        }

        function onSave(standardOrganization) {
            vm.isLoading = true;
            return authentication.setOrganizationInfo({
                isCreatingOrUpdatingOrgTemplate: true,
                volunteerOrganizationTemplateId: standardOrganization.id || undefined,
                volunteerOrganizationTemplateName: standardOrganization.name,
                volunteerOrganizationGroupId: standardOrganization.group.id,
                volunteerOrganizationType: standardOrganization.type,
                isActive: standardOrganization.status,
                volunteerOrganizationDescription: standardOrganization.description
            }).then(function () {
                $modalInstance.close();
            }).catch(function (error) {
                vm.formError = error;
            }).finally(function() {
                vm.isLoading = false;
            });
        }

        function onClickDelete() {
            return $modal.open({
                templateUrl: 'app/components/administrator/standardOrganizations/standardOrganizationDelete.view.html',
                controller: 'StandardOrganizationDeleteController',
                controllerAs: 'vm',
                size: 'tiny',
                backdrop: 'static',
                keyboard: false,
                resolve: {
                    standardOrganizationName: function () {
                        return originalStandardOrganizationName;
                    }
                }
            }).result.then(function () {
                vm.isLoading = true;
                return authentication.deleteOrganization({
                    volunteerOrganizationTemplateId: standardOrganization.id
                }).then(function () {
                    $modalInstance.close();
                });
            }, function () {
                //dismiss
            }).catch(function (error) {
                vm.formError = error;
            }).finally(function () {
                vm.isLoading = false;
            });
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('vmis.administrator')
        .controller('StandardOrganizationDeleteController', StandardOrganizationDeleteController);

    StandardOrganizationDeleteController.$inject = ['standardOrganizationName'];

    function StandardOrganizationDeleteController(standardOrganizationName) {
        var vm = this;

        vm.standardOrganizationName = standardOrganizationName;
    }
})();
(function () {
    'use strict';

    angular
        .module('vmis.administrator')
        .config(routes);

    routes.$inject = ['$stateProvider'];

    function routes($stateProvider) {
        $stateProvider
            .state('vmis.administrator.standardPositions', {
                url: '/standard-positions',
                templateUrl: 'app/components/administrator/standardPositions/standardPositions.view.html',
                controller: 'StandardPositionsController',
                controllerAs: 'vm',
                title: 'Standard Positions'
            });
    }
})();
(function () {
    'use strict';

    angular
        .module('vmis.administrator')
        .controller('StandardPositionsController', StandardPositionsController);

    StandardPositionsController.$inject = ['$modal', 'authentication', 'utilsServices', 'loadStatus', '_'];

    function StandardPositionsController($modal, authentication, utilsServices, loadStatus, _) {
        var vm = this;

        vm.sortColumn = 'title';
        vm.loadStatus = loadStatus.init();

        vm.onChangeStandardOrganization = onChangeStandardOrganization;
        vm.onClickStandardPosition = onClickStandardPosition;
        vm.onLoadAll = onLoadAll;
        vm.onLoadMore = onLoadMore;

        activate();

        function activate() {
            loadStatus.setup(vm.loadStatus, "standardPositions")
                .then(function () {
                    getStandardOrganizations();

                    getStandardPositions(vm.loadStatus.currentIndex, vm.loadStatus.defaultNumRows);
                });
        }

        function getStandardOrganizations() {
            return authentication.getUserProfile().then(function (response) {
                return utilsServices.combineStandardOrganizationResponsibilities(response).then(function (standardOrganizations) {
                    standardOrganizations.unshift({
                        id: null,
                        name: 'All'
                    });
                    vm.standardOrganizations = standardOrganizations;
                    vm.standardOrganization = standardOrganizations[0];
                });
            });
        }

        function getStandardPositions(index, num, standardOrganizationId) {
            vm.isLoading = true;

            return authentication.getStandardPositionsAdmin({
                startingRowIndex: index,
                numberOfRows: num,
                volunteerOrganizationTemplateId: standardOrganizationId || undefined
            }).then(function (response) {
                if (index === 0) {
                    vm.loadStatus.currentIndex = 0;
                    vm.standardPositions = [];
                }

                // Either set current index to max if all users loaded or increment by rows loaded
                vm.loadStatus.currentIndex = (vm.loadStatus.currentIndex + num > response.count) ? response.count : (vm.loadStatus.currentIndex + num);
                // Track total number of users not loaded for "Load All" button
                vm.loadStatus.numResultsNotLoaded = response.count - vm.loadStatus.currentIndex;
                // Set text for "Load More" button
                vm.loadStatus.nextResultLoadNum = (response.count === vm.loadStatus.currentIndex) ? 0 :
                    (vm.loadStatus.numResultsNotLoaded > num) ? num : vm.loadStatus.numResultsNotLoaded;

                vm.standardPositions = _.concat(vm.standardPositions, _.map(response.standardPositions, function (standardPosition) {
                    return {
                        id: standardPosition.volunteerOrganizationsOpportunitiesTemplateId,
                        title: standardPosition.title,
                        standardOrganization: {
                            id: standardPosition.volunteerOrganizationTemplateId,
                            name: standardPosition.VolunteerOrganizationTemplate
                        },
                        duties: standardPosition.duties,
                        qualifications: standardPosition.qualifications,
                        training: standardPosition.training
                    };
                })
                );
                vm.formError = '';
            }).catch(function (error) {
                if (angular.isDefined(error)) {
                    vm.formError = error.error ? error.error : error;
                }
                else
                    vm.formError = 'Failed to load list! Please try again.';
            }).finally(function () {
                vm.isLoading = false;
            });
        }

        function onChangeStandardOrganization(standardOrganization) {
            vm.loadStatus.currentIndex = 0;
            return getStandardPositions(vm.loadStatus.currentIndex, vm.loadStatus.defaultNumRows, standardOrganization.id);
        }

        function onClickStandardPosition(standardPosition) {
            $modal.open({
                templateUrl: 'app/components/administrator/standardPositions/standardPositionDetails.view.html',
                controller: 'StandardPositionDetailsController',
                controllerAs: 'vm',
                backdrop: 'static',
                keyboard: false,
                resolve: {
                    title: function () {
                        return standardPosition ? 'Standard Position Details' : 'Add New Standard Position';
                    },
                    standardPosition: function () {
                        return standardPosition ? _.clone(standardPosition) : {};
                    },
                    standardOrganizations: function () {
                        return _.tail(vm.standardOrganizations);
                    }
                }
            }).result.then(function () {
                vm.loadStatus.currentIndex = 0;
                return getStandardPositions(vm.loadStatus.currentIndex, vm.loadStatus.defaultNumRows);
            });
        }

        function onLoadMore() {
            getStandardPositions(vm.loadStatus.currentIndex, vm.loadStatus.nextResultLoadNum, vm.standardOrganization.id);
        }

        function onLoadAll() {
            getStandardPositions(vm.loadStatus.currentIndex, vm.loadStatus.numResultsNotLoaded, vm.standardOrganization.id);
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('vmis.administrator')
        .controller('StandardPositionDetailsController', StandardPositionDetailsController);

    StandardPositionDetailsController.$inject = ['$modalInstance', '$modal', 'authentication', 'title', 'standardPosition', 'standardOrganizations', 'config'];

    function StandardPositionDetailsController($modalInstance, $modal, authentication, title, standardPosition, standardOrganizations, config) {
        var vm = this;
        var originalStandardPositionTitle = standardPosition.title;

        vm.title = title;
        vm.standardPosition = standardPosition;
        vm.standardOrganizations = standardOrganizations;

        vm.isProductionWebsite = null;
        vm.bannerMessage = null;

        vm.onSave = onSave;
        vm.onClickDelete = onClickDelete;

        activate();

        function activate() {
            if (standardOrganizations.length === 1) {
                vm.standardPosition.standardOrganization = standardOrganizations[0];
            }
            config.get().then(function (configData) {
                vm.isProductionWebsite = configData.isProductionWebsite;
                vm.bannerMessage = configData.bannerMessage;
            });
        }

        function onSave() {
            vm.isLoading = true;
            return authentication.setOpportunity({
                createOrUpdateStandardPosition: true,
                volunteerOrganizationTemplateId: vm.standardPosition.standardOrganization.id,
                volunteerOrganizationsOpportunitiesTemplateId: vm.standardPosition.id || undefined,
                volunteerOrganizationsOpportunitiesTemplateName: vm.standardPosition.title,
                title: vm.standardPosition.title,
                duties: vm.standardPosition.duties || '',
                qualifications: vm.standardPosition.qualifications || '',
                training: vm.standardPosition.training || ''
            }).then(function () {
                $modalInstance.close();
            }).catch(function (error) {
                vm.formError = error;
            }).finally(function () {
                vm.isLoading = false;
            });
        }

        function onClickDelete() {
            return $modal.open({
                templateUrl: 'app/components/administrator/standardPositions/standardPositionDelete.view.html',
                controller: 'StandardPositionDeleteController',
                controllerAs: 'vm',
                size: 'tiny',
                backdrop: 'static',
                keyboard: false,
                resolve: {
                    standardPositionName: function () {
                        return originalStandardPositionTitle;
                    }
                }
            }).result.then(function () {
                vm.isLoading = true;
                return authentication.deleteOpportunity({
                    volunteerOrganizationsOpportunitiesTemplateId: standardPosition.id
                }).then(function () {
                    $modalInstance.close();
                });
            }, function () {
                //dismiss
            }).catch(function (error) {
                vm.formError = error;
            }).finally(function () {
                vm.isLoading = false;
            });
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('vmis.administrator')
        .controller('StandardPositionDeleteController', StandardPositionDeleteController);

    StandardPositionDeleteController.$inject = ['standardPositionName'];

    function StandardPositionDeleteController(standardPositionName) {
        var vm = this;

        vm.standardPositionName = standardPositionName;
    }
})();
(function () {
    'use strict';

    angular
        .module('app.vmis')
        .config(routes);

    routes.$inject = ['$stateProvider'];

    function routes($stateProvider) {
        $stateProvider
            .state('vmis.dashboard', {
                url: '/dashboard',
                title: 'Dashboard',
                views: {
                    '@vmis': {
                        templateUrl: 'app/components/dashboard/dashboard.view.html',
                        controller: 'DashboardController',
                        controllerAs: 'vm'
                    },
                    'coordinator@vmis.dashboard': {
                        templateUrl: 'app/components/dashboard/coordinator/coordinatorDashboard.view.html',
                        controller: 'CoordinatorDashboardController',
                        controllerAs: 'vm'
                    },
                    'opocAvccAssistant@vmis.dashboard': {
                        templateUrl: 'app/components/dashboard/opocAvccAssistant/opocAvccAssistantDashboard.view.html',
                        controller: 'OpocAvccAssistantDashboardController',
                        controllerAs: 'vm'
                    },
                    'volunteer@vmis.dashboard': {
                        templateUrl: 'app/components/dashboard/volunteer/volunteerDashboard.view.html',
                        controller: 'VolunteerDashboardController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    isAdmin: ['$stateParams', 'authentication', function ($stateParams, authentication) {
                        return authentication.getUserProfile().then(function (response) {
                            if (response.aosUser && response.aosUser.vmisUser && response.aosUser.vmisUser.adminProfile)
                                return !!response.aosUser.vmisUser.adminProfile;
                            else
                                return false;
                        }).catch(function () {
                            return false;
                        });
                    }]
                }
            });
    }
})();
(function () {
    'use strict';

    angular
        .module('app.vmis')
        .controller('DashboardController', DashboardController);

    DashboardController.$inject = ['$q', '$state', '$modal', '$window', '$scope', 'authentication', 'loadStatus', 'config', 'lite'];

    function DashboardController($q, $state, $modal, $window, $scope, authentication, loadStatus, config, lite) {
        var vm = this;

        vm.alerts = [];

        vm.loadStatus = loadStatus.init();
        vm.notifications = [];
        vm.isLoading = true;

        vm.onNotificationClick = onNotificationClick;
        vm.onDeleteNotificationClick = onDeleteNotificationClick;
        vm.onMarkAllReadClick = onMarkAllReadClick;
        vm.onDeleteAllClick = onDeleteAllClick;
        vm.onLoadMore = onLoadMore;
        vm.onLoadAll = onLoadAll;
        vm.onCloseAlert = onCloseAlert;

        vm.isLiteMode = lite.isLiteMode();

        activate();

        function activate() {
            checkBrowserVersion();

            authentication.getUserRoles()
                .then(function (response) {
                    if (response.vmisUserRoles !== null) {
                        for (var i = 0; i < response.vmisUserRoles.length; i++) {
                            switch (response.vmisUserRoles[i]) {
                                case 'AVC Volunteer':
                                    vm.isVolunteer = true;
                                    break;
                                case 'AVC Coordinator Assistant':
                                    vm.isAvccAssistant = true;
                                    break;
                                case 'AVC OPOC':
                                    vm.isOpoc = true;
                                    break;
                                case 'AVC Coordinator':
                                    vm.isCoordinator = true;
                                    break;
                                case 'AVC Program Manager':
                                    vm.isProgramManager = true;
                                    break;
                            }
                        }
                    }
                })
                .catch(function () {
                    $state.go('vmis', null, { reload: true });
                });

            loadStatus.setup(vm.loadStatus, "notifications")
                .then(function () {
                    loadNotifications(vm.loadStatus.currentIndex, vm.loadStatus.defaultNumRows);
                });
        }

        function loadNotifications(index, num) {
            vm.isLoading = true;
            return authentication.getNotifications(index, num).then(function (response) {
                return getNotificationsSuccess(response, index, num);
            }).catch(function (error) {
                return getNotificationsError(error);
            });
        }

        function onNotificationClick(notification) {
            var data = notification;
            switch (notification.grammar) {
                case 'OPOC_INVITE_SENT':
                    showOPOCInviteDetails(data)
                        .then(function () {
                            return authentication.setNotificationRead([notification.notificationId]);
                        })
                        .then(function () {
                            checkAndSetRead(notification);
                        })
                        .catch(function (error) {
                            // Clicking outside the modal should still set the notification as read
                            if (error === "backdrop click")
                                return authentication.setNotificationRead([notification.notificationId])
                                    .then(function () {
                                        return checkAndSetRead(notification);
                                    })
                                    .catch(function (error) {
                                        $scope.$emit('dashboard:alert', error);
                                    });
                            else
                                $scope.$emit('dashboard:alert', error);
                        });
                    break;
                case 'DAILY_HOURS_SUBMITTED':
                case 'PERIOD_HOURS_SUBMITTED':
                case 'HOURS_STATUS_CHANGED':
                case 'OPPORTUNITY_APPLIED_FOR':
                case 'APPLICATION_STATUS_CHANGED':
                case 'OPOC_INVITE_DELETED':
                case 'OPOC_INVITE_ACCEPTED':
                case 'OPOC_INVITE_UPDATED':
                    showModalDetails(data)
                        .then(function () {
                            return authentication.setNotificationRead([notification.notificationId]);
                        })
                        .then(function () {
                            checkAndSetRead(notification);
                        })
                        .catch(function (error) {
                            // Clicking outside the modal should still set the notification as read
                            if (error === "backdrop click") {
                                return authentication.setNotificationRead([notification.notificationId])
                                    .then(function () {
                                        return checkAndSetRead(notification);
                                    })
                                    .catch(function (error) {
                                        $scope.$emit('dashboard:alert', error);
                                    });
                            }
                            else
                                $scope.$emit('dashboard:alert', error);
                        });
                    break;
                default:
                    showModalDetails(data)
                        .then(function () {
                            return authentication.setNotificationRead([notification.notificationId]);
                        })
                        .then(function () {
                            checkAndSetRead(notification);
                        })
                        .catch(function (error) {
                            // Clicking outside the modal should still set the notification as read
                            if (error === "backdrop click") {
                                return authentication.setNotificationRead([notification.notificationId])
                                    .then(function () {
                                        return checkAndSetRead(notification);
                                    })
                                    .catch(function (error) {
                                        $scope.$emit('dashboard:alert', error);
                                    });
                            }
                            else
                                $scope.$emit('dashboard:alert', error);
                        });
                    break;
            }

            function checkAndSetRead(notification) {
                if (!notification.read) {
                    notification.read = true;
                    updateUnreadNotificationCount("subtract");
                }
            }
        }

        function showModalDetails(data) {
            data.notInvite = true;
            return showDetailsModal('app/components/dashboard/notificationDetails.modal.view.html', data);
        }

        function showOPOCInviteDetails(data) {
            data.size = 'small';
            return showDetailsModal('app/components/dashboard/acceptOPOCInviteDetails.modal.html', data);
        }

        function showDetailsModal(templateUrl, details) {
            var modalSize = 'tiny';
            if (details.size) {
                modalSize = details.size;
            }
            var options = {
                templateUrl: templateUrl,
                controller: 'DetailsModalController',
                controllerAs: 'modal',
                size: modalSize,
                backdrop: 'static',
                keyboard: false,
                resolve: {
                    details: function () {
                        return details;
                    }
                }
            };

            return $modal.open(options).result.then(function () {
            }, function (error) {
                if (error)
                    return $q.reject(error);
            });
        }

        function onDeleteNotificationClick(notification) {
            var isRead = notification.read;
            return authentication.deleteNotifications([notification.notificationId])
                .then(function () {
                    var index = vm.notifications.indexOf(notification);
                    if (index > -1)
                        vm.notifications.splice(index, 1);
                    if (isRead === 0) {
                        updateUnreadNotificationCount("subtract");
                    }

                    // Update loadStatus object so subsequent notifications aren't skipped
                    vm.loadStatus.currentIndex--;

                    if (vm.loadStatus.currentIndex === 0 && vm.loadStatus.numResultsNotLoaded > 0) {
                        loadNotifications(vm.loadStatus.currentIndex, vm.loadStatus.defaultNumRows);
                    }
                });
        }

        function onMarkAllReadClick() {
            if (vm.notifications.length >= 1) {
                var ids = vm.notifications.map(function (notification) {
                    return notification.notificationId;
                });

                return authentication.setNotificationRead(ids)
                    .then(function () {
                        // Update count before marking read so count is accurate
                        updateUnreadNotificationCount("clear");
                        vm.notifications.forEach(function (notification) {
                            notification.read = true;
                        });
                    });
            }
        }

        function onDeleteAllClick() {
            if (vm.notifications.length >= 1) {
                var options = {
                    templateUrl: 'app/components/dashboard/deleteAllNotifications.modal.view.html',
                    size: 'tiny',
                    backdrop: 'static',
                    keyboard: false
                };

                $modal.open(options)
                    .result
                    .then(function () {
                        var ids = vm.notifications.map(function (notification) {
                            return notification.notificationId;
                        });

                        return authentication.deleteNotifications(ids);
                    })
                    .then(function () {
                        // Update count before wiping list so count is accurate
                        updateUnreadNotificationCount("clear");
                        vm.notifications = [];

                        // Reset loadStatus object and get more notifications
                        return loadStatus.reset(vm.loadStatus)
                            .then(function () {
                                loadNotifications(vm.loadStatus.currentIndex, vm.loadStatus.defaultNumRows);
                            });
                    });
            }
        }

        function updateUnreadNotificationCount(updateVal) {
            if (updateVal === "subtract") {
                vm.unreadNotifications--;
            }
            else if (updateVal === "clear") {
                // Can't just set to zero, since not all notifications
                // are necessarily loaded when this action is taken.
                // Instead count unread notifications being deleted
                // and subtract that value from total.
                vm.unreadNotifications -= vm.notifications.reduce(function (count, notif) {
                    if (!notif.read)
                        count++;
                    return count;
                }, 0);
            }
            // If not one of those strings, must be integer
            else {
                vm.unreadNotifications = updateVal;
            }
            $scope.notificationObject.updateUnreadNotificationsCount(vm.unreadNotifications);
        }

        function getNotificationsSuccess(response, index, num) {
            if (index === 0) {
                vm.loadStatus.currentIndex = 0;
                vm.notifications = [];
            }

            // Either set current index to max if all users loaded or increment by rows loaded
            vm.loadStatus.currentIndex = (vm.loadStatus.currentIndex + num > response.count) ? response.count : (vm.loadStatus.currentIndex + num);
            // Track total number of users not loaded for "Load All" button
            vm.loadStatus.numResultsNotLoaded = response.count - vm.loadStatus.currentIndex;
            // Set text for "Load More" button
            vm.loadStatus.nextResultLoadNum = (response.count === vm.loadStatus.currentIndex) ? 0 :
                (vm.loadStatus.numResultsNotLoaded > num) ? num : vm.loadStatus.numResultsNotLoaded;

            vm.notifications = vm.notifications.concat(response.notifications);

            // Alert top bar to new value
            updateUnreadNotificationCount(response.unread);

            vm.isLoading = false;

            return vm.notifications;
        }

        function getNotificationsError(error) {
            if (angular.isDefined(error)) {
                var errorStr = error.error ? error.error : error;
                $scope.$emit('dashboard:alert', errorStr);
            }
            else
                $scope.$emit('dashboard:alert', "Failed to load list! Please try again.");

            vm.isLoading = false;
        }

        function onLoadMore() {
            loadNotifications(vm.loadStatus.currentIndex, vm.loadStatus.nextResultLoadNum);
        }

        function onLoadAll() {
            loadNotifications(vm.loadStatus.currentIndex, vm.loadStatus.numResultsNotLoaded);
        }

        function checkBrowserVersion() {
            var browserVersions = $window.navigator.userAgent;

            config.get().then(function (configData) {
                var edgeIndex = browserVersions.indexOf(configData.minBrowserCompatibility.edge.searchStr);
                if (edgeIndex > -1) {
                    var edgeVersion = parseFloat(
                        browserVersions.substr(edgeIndex + configData.minBrowserCompatibility.edge.searchStr.length));

                    if (edgeVersion < configData.minBrowserCompatibility.edge.version)
                        displayAlert('alert', configData.minBrowserCompatibility.edge.warning);
                }
                var firefoxIndex = browserVersions.indexOf(configData.minBrowserCompatibility.firefox.searchStr);
                if (firefoxIndex > -1) {
                    var firefoxVersion = parseFloat(
                        browserVersions.substr(firefoxIndex + configData.minBrowserCompatibility.firefox.searchStr.length));

                    if (firefoxVersion < configData.minBrowserCompatibility.firefox.version)
                        displayAlert('alert', configData.minBrowserCompatibility.firefox.warning);
                }
            });
        }

        function onCloseAlert(index) {
            vm.alerts.splice(index, 1);
        }

        function displayAlert(type, message) {
            vm.alerts.push({
                type: type,
                message: message
            });
        }

        function displayError(error) {
            if (error === 'cancel' || error === 'backdrop click')
                return;
            if (error)
                displayAlert('alert', error);
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.vmis')
        .controller('DetailsModalController', DetailsModalController);

    DetailsModalController.$inject = ['$state', '$modalInstance', 'details', 'authentication', '_'];

    function DetailsModalController($state, $modalInstance, details, authentication, _) {
        var vm = this;

        vm.notification = details;
        var invitationId = details.data.invitationId;
        var hash;

        vm.AcceptInvite = AcceptInvite;

        activate();

        function activate() {
            if(!angular.isDefined(details.notInvite)) {
                authentication.getInvites({invitationId: invitationId}).then(function (response) {
                    var invite = response.invitations[0];
                    vm.isAccepted = invite.status === 'Accepted';
                    hash = invite.hash;
                    vm.organizations = _.map(invite.responsibilities.volunteerOrganizations, function (organization) {
                        return {
                            id: organization.volunteerOrganizationId,
                            name: organization.volunteerOrganizationFullName
                        };
                    });
                    vm.communities = _.map(invite.responsibilities.communityAffiliations, function (communityAffiliation) {
                        return {
                            id: communityAffiliation.communityAffiliationId,
                            name: communityAffiliation.communityAffiliationName
                        };
                    });
                    return authentication.getCommunityInfo({communityAffiliationId: invite.communityAffiliationId});
                }).then(function (response) {
                    vm.community = {
                        id: response.communityAffiliations.communityAffiliationId,
                        name: response.communityAffiliations.communityAffiliationName
                    };
                }).catch(function (error) {
                    vm.formError = error;
                });
            }
        }

        function AcceptInvite() {
            return authentication.acceptInvite({
                hash: hash
            }).then(function () {
                $modalInstance.close();
                $state.go('vmis.inviteAccepted');
            }).catch(function (error) {
                vm.formError = error;
            });
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.vmis')
        .controller('OpocDetailsController', OpocDetailsController);

    OpocDetailsController.$inject = ['$q', 'authentication', 'opocs'];

    function OpocDetailsController($q, authentication, opocs) {
        var vm = this;

        activate();

        function activate() {
            getProfile();
        }

        function getProfile() {
            var promises = opocs.map(function (opoc) {
                return authentication.getUserProfile({
                    masterUserId: opoc.masterUserId
                });
            });
            return $q.all(promises).then(function (responses) {
                vm.opocs = responses.map(function (response) {
                    var profile = response.aosUser;
                    var adminProfile = response.aosUser.vmisUser.adminProfile;
                    return {
                        name: profile.firstName + ' ' + profile.lastName,
                        phone: adminProfile.commercialWorkPhone,
                        dsnPhone: adminProfile.dsnPhone ? adminProfile.dsnPhone : 'N/A',
                        email: adminProfile.workEmail
                    };
                });
            });
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.vmis')
        .controller('CoordinatorDashboardController', CoordinatorDashboardController);

    CoordinatorDashboardController.$inject = ['$modal', '$scope', '$q', 'authentication', 'utilsServices', 'loadStatus', 'moment'];

    function CoordinatorDashboardController($modal, $scope, $q, authentication, utilsServices, loadStatus, moment) {
        var vm = this;
        var seriesLabels = {
            hours: ['Submitted', 'Certified & Rejected', 'Certified', 'Rejected'],
            applications: ['Submitted', 'Approved & Rejected', 'Approved', 'Rejected']
        };

        vm.sortColumn = 'totalSubmitted';
        vm.sortReverse = true;
        vm.userEnteredDate = false;
        vm.overdueLoading = true;
        vm.chartLoading = true;
        vm.showChartIncompleteDataWarning = false;

        vm.loadStatusHoursApps = loadStatus.init();
        // TODO: chart load status object not used as fully
        vm.loadStatusChart = loadStatus.init();
        vm.troubledOrganizations = [];

        vm.community = null;

        vm.troubledOrganizations = [];
        vm.chartTypes = [
            'Daily Hours',
            'Period Hours',
            'Applications'
        ];
        vm.chartType = vm.chartTypes[0];

        var chart = {};

        vm.defaultStartDate = moment().startOf('day').subtract(30, 'days').toDate();
        vm.defaultEndDate = moment().startOf('day').toDate();

        vm.startDate = vm.defaultStartDate;
        vm.endDate = vm.defaultEndDate;

        vm.currentDate = new Date();
        vm.organization = null;
        vm.overdueThreshold = 15;
        vm.overdueThresholds = [];

        vm.onChangeOverdueThreshold = onChangeOverdueThreshold;
        vm.onChangeChart = onChangeChart;
        vm.onClickViewOpocs = onClickViewOpocs;
        vm.onLoadMore = onLoadMore;
        vm.onLoadAll = onLoadAll;
        vm.onSelectCommunity = onSelectCommunity;
        vm.onChangeDate = onChangeDate;

        activate();

        function activate() {
            chart = {
                data: [[], [], [], []],
                labels: [],
                options: {
                    legend: {
                        display: true,
                        labels: {
                            filter: function (dataset) {
                                return dataset.datasetIndex < 2;
                            }
                        },
                        onClick: function () {
                        }
                    },
                    tooltips: {
                        callbacks: {
                            label: function (tooltipItem, data) {
                                if (tooltipItem.datasetIndex === 1 || tooltipItem.index === 0) return;
                                var type = data.datasets[tooltipItem.datasetIndex].label;
                                var date = data.labels[0];
                                var count = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index - 1];
                                return type + ' since ' + date + ': ' + count;
                            },
                            afterLabel: function (tooltipItem, data) {
                                if (tooltipItem.datasetIndex === 1) return;
                                var type = data.datasets[tooltipItem.datasetIndex].label;
                                var date = data.labels[tooltipItem.index];
                                var count = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
                                if (tooltipItem.index > 0) count -= data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index - 1];
                                return type + ' on ' + date + ': ' + count;
                            }
                        },
                        filter: function (dataset) {
                            return dataset.datasetIndex !== 1;
                        },
                        intersect: false,
                        displayColors: false,
                        position: 'nearest'
                    },
                    scales: {
                        yAxes: [{
                            ticks: {
                                min: 0,
                                suggestedMax: 10
                            }
                        }, {
                            ticks: {
                                max: -100,
                                min: -100
                            },
                            display: false,
                            id: 'no-show'
                        }]
                    }
                },
                series: ['Submitted', '', 'Certified', 'Rejected'],
                colors: ['#337ab7', '#3c763d'],
                datasetOverride: [{
                    lineTension: 0
                }, {
                    lineTension: 0
                }, {
                    yAxisID: 'no-show'
                }, {
                    yAxisID: 'no-show'
                }]
            };

            vm.chart = angular.copy(chart, {});

            for (var i = 1; i <= 30; i++) {
                vm.overdueThresholds.push(i);
            }

            var promises = [loadStatus.setup(vm.loadStatusHoursApps, "avccHoursApplications"),
                loadStatus.setup(vm.loadStatusChart, "coordinatorChart")];

            return $q.all(promises)
                .then(function () {
                    getProfile()
                        .then(getOrganizations)
                        .then(function () {
                            getChartData(vm.organization, vm.chartType, vm.startDate, vm.endDate);
                            getTroubledOrganizations(vm.loadStatusHoursApps.currentIndex, vm.loadStatusHoursApps.defaultNumRows);
                        });
                });
        }

        function getProfile() {
            return authentication.getUserProfile().then(function (response) {
                return utilsServices.combineCommunityResponsibilities(response, 'AVC Coordinator');
            }).then(function (communities) {
                vm.communities = communities;
                vm.community = vm.communities[0];
            });
        }

        function onSelectCommunity() {
            getOrganizations().then(function () {
                return onChangeChart();
            });
        }

        function getOrganizations() {
            return authentication.getOrganizations({
                communityAffiliationId: vm.community ? vm.community.id : undefined,
                getAll: true
            }).then(function (response) {
                vm.organizations = _.map(response.organizations, function (organization) {
                    return {
                        id: organization.volunteerOrganizationId,
                        name: organization.organizationName
                    };
                });
                vm.organizations.unshift({
                    name: "All"
                    //id: -1
                });
                vm.organization = vm.organizations[0];
            });
        }

        function getChartData(organization, type, startDate, endDate) {
            vm.chartLoading = true;
            var promise = authentication.getHoursAdmin;
            var timeUnit = 'days';
            var labelFormat = 'MM/DD/YYYY';
            chart.series = seriesLabels.hours;
            switch (type) {
                case 'Daily Hours':
                    break;
                case 'Period Hours':
                    timeUnit = 'months';
                    labelFormat = 'MMM YYYY';
                    break;
                case 'Applications':
                    chart.series = seriesLabels.applications;
                    promise = authentication.getApplicationsAdmin;
                    break;
                default:
                    return;
            }

            var params = {
                startingRowIndex: 0,
                numberOfRows: vm.loadStatusChart.defaultNumRows,
                communityAffiliationId: vm.community ? vm.community.id : undefined,
                startDate: moment(startDate).format('YYYY-MM-DD[T00:00:00Z]'),
                endDate: moment(endDate).format('YYYY-MM-DD[T00:00:00Z]')
            };
            if (angular.isDefined(organization.id)) {
                // End point only uses org ID if available,
                // so remove extra work for community parameter
                params.communityAffiliationId = undefined;
                params.volunteerOrganizationId = organization.id;
            }
            return promise(params).then(function (response) {
                var items = [];
                switch (type) {
                    case 'Daily Hours':
                        items = items.concat(response.hours.filter(function (h) {
                            return h.dayOfService;
                        }).map(function (h) {
                            return {
                                date: h.dayOfService,
                                status: h.volunteerHoursStatus
                            };
                        }));
                        break;
                    case 'Period Hours':
                        items = items.concat(response.hours.filter(function (h) {
                            return h.periodOfService;
                        }).map(function (h) {
                            return {
                                date: h.periodOfService,
                                status: h.volunteerHoursStatus
                            };
                        }));
                        break;
                    case 'Applications':
                        items = items.concat(response.applications.map(function (a) {
                            return {
                                date: a.createdDate,
                                status: a.volunteerApplicationStatus
                            };
                        }));
                        break;
                }

                items.sort(function (a, b) {
                    return moment(a.date).diff(b.date, timeUnit);
                });

                var currentDay = moment(startDate, 'MM/DD/YYYY');
                chart.data = [[0], [0], [0], [0]];
                items.forEach(function (i) {
                    var diff = moment(i.date).diff(currentDay, timeUnit);

                    chart.data.forEach(function (d) {
                        for (var i = d.length; i <= diff; i++) {
                            d.push(d[d.length - 1]);
                        }
                    });

                    switch (i.status) {
                        case 'Submitted':
                            chart.data[0][diff]++;
                            break;
                        case 'Approved':
                        case 'Certified':
                            chart.data[0][diff]++;
                            chart.data[1][diff]++;
                            chart.data[2][diff]++;
                            break;
                        case 'Rejected':
                            chart.data[0][diff]++;
                            chart.data[1][diff]++;
                            chart.data[3][diff]++;
                            break;
                    }
                });

                chart.labels = [];
                while (moment(endDate, 'MM/DD/YYYY').isSameOrAfter(currentDay, timeUnit)) {
                    chart.labels.push(currentDay.format(labelFormat));
                    currentDay.add(1, timeUnit);
                }

                angular.forEach(chart.data, function (d) {
                    while (d.length < chart.labels.length) {
                        d.push(d[d.length - 1]);
                    }
                });

                vm.chart = angular.copy(chart, {});

                // If there are more data points than the chart has loaded,
                // display text indicating this and direct to Reports.
                vm.showChartIncompleteDataWarning = (response.count > vm.loadStatusChart.defaultNumRows);

                vm.chartLoading = false;
            });
        }

        function getTroubledOrganizations(index, num) {
            vm.overdueLoading = true;
            var params = {
                startingRowIndex: index,
                numberOfRows: num,
                communityAffiliationId: vm.community ? vm.community.id : undefined,
                hoursDaysOverdueThreshold: vm.overdueThreshold,
                applicationsDaysOverdueThreshold: vm.overdueThreshold
            };

            return authentication.getTroubledOrganizationsForCommunity(params)
                .then(function (response) {
                    getTroubledOrganizationsSuccess(response, params.startingRowIndex, params.numberOfRows);
                }).catch(function (err) {
                    getTroubledOrganizationsError(err);
                }).finally(function () {
                    vm.overdueLoading = false;
                });
        }

        function onChangeOverdueThreshold() {
            vm.loadStatusHoursApps.currentIndex = 0;
            getTroubledOrganizations(vm.loadStatusHoursApps.currentIndex, vm.loadStatusHoursApps.defaultNumRows);
        }

        function onChangeDate() {
            vm.userEnteredDate = true;
            onChangeChart();
        }

        function onChangeChart() {
            if (!vm.userEnteredDate) {
                if (vm.chartType === 'Period Hours') {
                    var currentMonth = moment().month();
                    var currentYear = moment().year();
                    // Set the date range to the previous FY
                    vm.startDate = moment().set({
                        'year': currentMonth >= 9 ? currentYear : currentYear - 1,
                        'month': 9,
                        'date': 1
                    }).startOf('day').toDate();
                    vm.endDate = moment().set({
                        'year': currentYear,
                        'month': currentMonth,
                        'date': moment().date()
                    }).startOf('day').toDate();
                }
                else {
                    vm.startDate = vm.defaultStartDate;
                    vm.endDate = vm.defaultEndDate;
                }
            }

            if (angular.isDefined(vm.startDate) && angular.isDefined(vm.endDate)) {
                return getChartData(vm.organization, vm.chartType, vm.startDate, vm.endDate);
            }
        }

        function onClickViewOpocs(opocs) {
            $modal.open({
                templateUrl: 'app/components/dashboard/opocDetails.view.html',
                controller: 'OpocDetailsController',
                controllerAs: 'vm',
                backdrop: 'static',
                keyboard: false,
                resolve: {
                    opocs: function () {
                        return opocs;
                    }
                }
            });
        }

        function getTroubledOrganizationsSuccess(response, index, num) {
            if (index === 0) {
                vm.loadStatusHoursApps.currentIndex = 0;
                vm.troubledOrganizations = [];
            }

            // Either set current index to max if all users loaded or increment by rows loaded
            vm.loadStatusHoursApps.currentIndex = (vm.loadStatusHoursApps.currentIndex + num > response.count) ? response.count : (vm.loadStatusHoursApps.currentIndex + num);
            // Track total number of users not loaded for "Load All" button
            vm.loadStatusHoursApps.numResultsNotLoaded = response.count - vm.loadStatusHoursApps.currentIndex;
            // Set text for "Load More" button
            vm.loadStatusHoursApps.nextResultLoadNum = (response.count === vm.loadStatusHoursApps.currentIndex) ? 0 :
                (vm.loadStatusHoursApps.numResultsNotLoaded > num) ? num : vm.loadStatusHoursApps.numResultsNotLoaded;

            vm.troubledOrganizations = vm.troubledOrganizations.concat(response.organizations);
            angular.forEach(vm.troubledOrganizations, function (organization) {
                organization.totalOverdueHours = 0;
                organization.totalOverdueApplications = 0;
                organization.totalSubmitted = 0;

                angular.forEach(organization.organizationOpportunity, function (position) {
                    organization.totalOverdueHours += position.overdueHours.length;
                    organization.totalOverdueApplications += position.overdueApplications.length;
                    organization.totalSubmitted = (organization.totalOverdueHours + organization.totalOverdueApplications);
                });
            });
        }

        function getTroubledOrganizationsError(error) {
            if (angular.isDefined(error)) {
                var errorStr = error.error ? error.error : error;
                $scope.$emit('troubledOrganizations:alert', errorStr);
            }
            else
                $scope.$emit('troubledOrganizations:alert', "Failed to load list! Please try again.");
        }


        function onLoadMore() {
            getTroubledOrganizations(vm.loadStatusHoursApps.currentIndex, vm.loadStatusHoursApps.nextResultLoadNum);
        }

        function onLoadAll() {
            getTroubledOrganizations(vm.loadStatusHoursApps.currentIndex, vm.loadStatusHoursApps.numResultsNotLoaded);
        }

    }
})();
(function () {
    'use strict';

    angular
        .module('app.vmis')
        .controller('OpocAvccAssistantDashboardController', OpocAvccAssistantDashboardController);

    OpocAvccAssistantDashboardController.$inject = ['$q', '$modal', 'moment', 'authentication', 'utilsServices', '_'];

    function OpocAvccAssistantDashboardController($q, $modal, moment, authentication, utilsServices, _) {
        var vm = this;

        vm.isLoading = true;
        vm.sortColumn = 'date';
        vm.sortReverse = true;
        vm.startDate = moment().date() <= 15 ? moment().subtract(1, 'months').startOf('month').toISOString() : moment().startOf('month').toISOString();
        vm.endDate = moment().toISOString();
        vm.hoursChart = {
            options: {
                legend: {
                    display: true,
                    labels: {
                        boxWidth: 12
                    },
                    onClick: function () {
                    }
                },
                tooltips: {
                    callbacks: {
                        label: function (tooltipItem, data) {
                            if (data.labels[tooltipItem.index] === undefined) {
                                return 'There are no hours';
                            }
                            var hours = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
                            var type = data.labels[tooltipItem.index].toLowerCase();
                            return hours + ' ' + type + ' hour' + (hours === 1 ? '' : 's');
                        },
                        afterLabel: function (tooltipItem, data) {
                            return (data.labels[tooltipItem.index] === undefined) ? '' : 'for the current open period';
                        }
                    },
                    displayColors: false
                }
            },
            data: [0, 0, 0, 1],
            labels: ['Certified', 'Rejected', 'Submitted'],
            colors: ['#3c763d', '#a94442', '#337ab7', '#dcdcdc']

        };
        vm.positionsChart = {
            options: {
                legend: {
                    display: true,
                    labels: {
                        boxWidth: 12
                    },
                    onClick: function () {
                    }
                },
                tooltips: {
                    callbacks: {
                        label: function (tooltipItem, data) {
                            if (data.labels[tooltipItem.index] === undefined) {
                                return 'There are no open positions';
                            }
                            var positionCount = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
                            var text;
                            switch (data.labels[tooltipItem.index]) {
                                case 'Filled':
                                    text = positionCount + ((positionCount > 1) ? ' positions have' : ' position has');
                                    break;
                                case 'Unfilled':
                                    text = positionCount + ((positionCount > 1) ? ' positions do' : ' position does') + ' not have';
                                    break;
                                default:
                                    text = '';
                                    break;
                            }
                            return text;
                        },
                        afterLabel: function (tooltipItem, data) {
                            if (data.labels[tooltipItem.index] === undefined) {
                                return 'for the selected organization.';
                            }
                            var text;
                            switch (data.labels[tooltipItem.index]) {
                                case 'Filled':
                                    text = 'active volunteers';
                                    break;
                                case 'Unfilled':
                                    text = 'any active volunteers';
                                    break;
                                default:
                                    text = '';
                                    break;
                            }
                            return text;
                        }
                    },
                    displayColors: false
                }
            },
            data: [0, 0, 1],
            labels: ['Filled', 'Unfilled'],
            colors: ['#3c763d', '#337ab7', '#dcdcdc']
        };

        vm.onRejectHoursClick = onRejectHoursClick;
        vm.onClickCertify = onClickCertify;
        vm.onChangeCommunity = onChangeCommunity;
        vm.onChangeOrganization = onChangeOrganization;

        activate();

        function activate() {
            isUserOPOC();
            getSubmittedHours();
        }

        function getHoursDistribution(community, organization) {
            var params = {
                startingRowIndex: 0,
                numberOfRows: 1,
                startDate: vm.startDate,
                endDate: vm.endDate,
                communityAffiliationId: community ? community.id : undefined,
                volunteerOrganizationId: organization ? organization.id : undefined
            };
            return authentication.getHoursAdmin(params).then(function (response) {
                params.numberOfRows = response.count || 1;
                return authentication.getHoursAdmin(params);
            }).then(function (response) {
                var hours = {
                    certified: 0,
                    rejected: 0,
                    submitted: 0
                };
                _.forEach(response.hours, function (activity) {
                    switch (activity.volunteerHoursStatus) {
                        case 'Submitted':
                            hours.submitted += activity.hours;
                            return true;
                        case 'Certified':
                            hours.certified += activity.hours;
                            break;
                        case 'Rejected':
                            hours.rejected += activity.hours;
                            break;
                    }
                });

                if (hours.certified > 0 || hours.rejected > 0 || hours.submitted > 0) {
                    vm.hoursChart.data = [
                        hours.certified,
                        hours.rejected,
                        hours.submitted
                    ];
                } else {
                    vm.hoursChart.data = [0, 0, 0, 1];
                }
            });
        }

        function getSubmittedHours() {
            vm.isLoading = true;
            var params = {
                startingRowIndex: 0,
                numberOfRows: 1,
                startDate: vm.startDate,
                endDate: vm.endDate,
                volunteerHoursStatus: 'Submitted'
            };
            return authentication.getHoursAdmin(params).then(function (response) {
                params.numberOfRows = response.count || 1;
                return authentication.getHoursAdmin(params);
            }).then(function (response) {
                vm.hours = _.map(response.hours, function (activity) {
                    return {
                        id: activity.volunteerHoursId,
                        position: activity.volunteerOpportunity,
                        organization: activity.volunteerOrganization,
                        community: activity.communityAffiliation,
                        volunteer: {
                            firstName: activity.firstName,
                            lastName: activity.lastName
                        },
                        documents: activity.documents,
                        hours: activity.hours,
                        status: activity.volunteerHoursStatus,
                        type: activity.dayOfService ? 'Daily' : 'Period',
                        date: activity.dayOfService || activity.periodOfService,
                        volunteerNote: activity.userNotes || '',
                        reviewerNote: activity.reviewerNotes || ''
                    };
                });
            }).finally(function () {
                vm.isLoading = false;
            });
        }

        function getPositionsFilled(community, organization) {
            var params = {
                numberOfRows: 1,
                volunteerPositionStatus: ['Open, searchable', 'Open, not searchable'],
                communityAffiliationId: community ? community.id : undefined,
                volunteerOrganizationId: organization ? organization.id : undefined
            };
            return authentication.getOpportunitiesAdmin(params).then(function (response) {
                params.numberOfRows = response.count || 1;
                return authentication.getOpportunitiesAdmin(params);
            }).then(function (response) {
                var filledPositions = response.opportunities.reduce(function (filled, currentPosition) {
                    return currentPosition.applicationCount > 0 ? filled + 1 : filled;
                }, 0);
                if (response.opportunities.length > 0) {
                    vm.positionsChart.data = [
                        filledPositions,
                        response.opportunities.length - filledPositions
                    ];
                } else {
                    vm.positionsChart.data = [0, 0, 1];
                }
            });
        }

        function isUserOPOC() {
            authentication.getUserRoles()
                .then(function (response) {
                    vm.isOpoc = false;
                    if (response.vmisUserRoles !== null) {
                        for (var i = 0; i < response.vmisUserRoles.length; i++) {
                            if (response.vmisUserRoles[i] === "AVC OPOC") {
                                vm.isOpoc = true;
                                break;
                            }
                        }
                    }
                    if (vm.isOpoc) {
                        return getCommunities();
                    }
                })
                .catch(function () {
                    $state.go('vmis', null, {reload: true});
                });
        }

        function getCommunities() {
            return authentication.getUserProfile().then(function (response) {
                return utilsServices.combineCommunityResponsibilities(response, 'AVC OPOC');
            }).then(function (communities) {
                vm.communities = communities;
                vm.hoursCommunity = communities[0];
                vm.positionsCommunity = communities[0];
            }).then(function () {
                return onChangeCommunity(vm.hoursCommunity, 'hours');
            }).then(function () {
                return onChangeCommunity(vm.positionsCommunity, 'positions');
            });
        }

        function onRejectHoursClick(activity) {
            $modal.open({
                templateUrl: 'app/components/administrator/hours/manageActivity.view.html',
                controller: 'ManageActivityController',
                controllerAs: 'vm',
                backdrop: 'static',
                keyboard: false,
                resolve: {
                    activity: function () {
                        return angular.copy(activity);
                    },
                    rejectOnly: function () {
                        return true;
                    }
                }
            }).result.then(function () {
                activity.isFading = true;
                return getSubmittedHours();
            });
        }

        function onClickCertify(activity) {
            authentication.manageVolunteerHours({
                hoursIds: [activity.id],
                volunteerHoursStatus: 'Certified'
            }).then(getSubmittedHours);
        }

        function onChangeCommunity(community, type) {
            var promise;
            if (community.organizations) {
                promise = $q.when();
            } else {
                promise = authentication.getOrganizations({
                    communityAffiliationId: community.id
                }).then(function (response) {
                    community.organizations = _.map(response.organizations, function (organization) {
                        return {
                            id: organization.volunteerOrganizationId,
                            name: organization.organizationName
                        };
                    });
                    if (community.organizations.length > 1) {
                        community.organizations.unshift({
                            name: 'All'
                        });
                    }
                });
            }

            return promise.then(function () {
                switch (type) {
                    case 'hours':
                        vm.hoursOrganization = community.organizations[0];
                        return getHoursDistribution(community, vm.hoursOrganization);
                    case 'positions':
                        vm.positionsOrganization = community.organizations[0];
                        return getPositionsFilled(community, vm.positionsOrganization);
                }
            });
        }

        function onChangeOrganization(organization, type) {
            switch (type) {
                case 'hours':
                    return getHoursDistribution(null, organization);
                case 'positions':
                    return getPositionsFilled(null, organization);
            }
        }
    }
})();
/**
 * Created by scuzzort3 on 6/7/16.
 */
(function () {
    'use strict';

    angular
        .module('app.vmis')
        .controller('VolunteerDashboardController', VolunteerDashboardController);

    VolunteerDashboardController.$inject = ['lite', 'usersServices', 'moment', 'isAdmin'];

    function VolunteerDashboardController(lite, usersServices, moment, isAdmin) {
        var vm = this;

        vm.isLiteMode = lite.isLiteMode();

        vm.date = new Date();
        vm.startDate = moment().startOf('week').toDate();
        vm.endDate = moment().endOf('week').toDate();
        vm.isAdmin = isAdmin;

        vm.onHoursEntered = onHoursEntered;
        vm.onPreviousWeek = onPreviousWeek;
        vm.onNextWeek = onNextWeek;

        vm.hoursChart = {
            options: {
                tooltips: {
                    displayColors: false,
                    custom: function (tooltip) {
                        if (!tooltip) {
                            return;
                        }

                        if (tooltip.body && vm.hoursReport.certifiedHours === 0 && vm.hoursReport.submittedHours === 0 && vm.hoursReport.rejectedHours === 0) {
                            tooltip.body[0].lines[0] = 'Hours: 0';
                            tooltip.width = 58;
                        }
                    }
                }
            },
            data: [],
            labels: ['Certified', 'Submitted', 'Rejected'],
            colors: ['#3c763d', '#337ab7', '#a94442', '#dcdcdc']
        };

        activate();

        function activate() {
            updateTotalHoursForVolunteer();
        }

        function updateTotalHoursForVolunteer() {
            usersServices.getTotalHoursForUserForMonth(vm.date)
                .then(function (hoursReport) {
                    hoursReport.submittedAndCertified = hoursReport.submittedHours + hoursReport.certifiedHours;
                    vm.hoursReport = hoursReport;

                    if (hoursReport.submittedHours > 0 || hoursReport.certifiedHours > 0 || hoursReport.rejectedHours > 0) {
                        vm.hoursChart.data = [
                            hoursReport.certifiedHours,
                            hoursReport.submittedHours,
                            hoursReport.rejectedHours
                        ];
                    } else {
                        vm.hoursChart.data = [0, 0, 0, 1];
                    }
                });
        }

        function onHoursEntered() {
            updateTotalHoursForVolunteer();
        }

        function onPreviousWeek() {
            vm.date = moment(vm.date).subtract(1, 'weeks').toDate();
            updateDateRange();
        }

        function onNextWeek() {
            vm.date = moment(vm.date).add(1, 'weeks').toDate();
            updateDateRange();
        }

        function updateDateRange() {
            vm.startDate = moment(vm.date).startOf('week').toDate();
            vm.endDate = moment(vm.date).endOf('week').toDate();
            updateTotalHoursForVolunteer();
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.vmis')
        .controller('IdleController', IdleController);

    IdleController.$inject = ['$scope', '$modalStack', 'config'];

    function IdleController($scope, $modalStack, config) {
        var vm = this;
        vm.countdown = null;

        $scope.$on('IdleWarn', function (e, countdown) {
            // follows after the IdleStart event, but includes a countdown until the user is considered timed out
            // the countdown arg is the number of seconds remaining until then.
            // you can change the title or display a warning dialog from here.
            // you can let them resume their session by calling Idle.watch()

            $scope.$apply(function () {
                vm.countdown = countdown;
            });
        });

        $scope.$on('IdleTimeout', function () {
            // the user has timed out (meaning idleDuration + timeout has passed without any activity)
            // this is where you'd log them

            return $modalStack.dismissAll();
        });

        activate();

        function activate() {
            config.get().then(function (configData) {
                vm.countdown = configData.idleConfig.timeout;
            });
        }
    }
}());
(function () {
    'use strict';

    angular
        .module('app.vmis')
        .config(routes);

    routes.$inject = ['$stateProvider'];

    function routes($stateProvider) {
        $stateProvider
            .state('landing', {
                url: '/',
                templateUrl: 'app/components/landingPage/landingPage.view.html',
                controller: 'LandingController',
                controllerAs: 'vm'
            });
    }
})();

(function () {
    'use strict';

    angular
        .module('app.vmis')
        .controller('LandingController', LandingController);

    LandingController.$inject = ['$scope', '$state', 'config'];

    function LandingController($scope, $state, config) {
        var vm = this;
        vm.websiteFamilyList = null;
        vm.showMenu = false;
        vm.logIn = logIn;
        vm.classList = [
            'afwp-home',
            'efmp-blue',
            'acs-green',
            'vmis-teal',
            'ims-red',
            'olms-orange',
            'vfrg-blue'];

        for (var website in vm.websiteFamilyList) {
            vm.websiteFamilyList[website].color = vm.classList[website];
        }

        // Close the dropdown menu if the user clicks outside of it
        window.onclick = function (event) {
            if (!$(event.target).hasClass("header-icon-menu")) {
                vm.showMenu = false;
                $scope.$apply();
            }
        };

        activate();

        function activate() {
            config.get().then(function (configData) {
                vm.websiteFamilyList = configData.afwpWebsiteFamilyList;
            });
        }

        function logIn() {
            $state.go('vmis.logIn');
        }
    }

})();
(function () {
    'use strict';

    angular
        .module('app.vmis')
        .config(routes);

    routes.$inject = ['$stateProvider'];

    function routes($stateProvider) {
        $stateProvider
            .state('vmis.loggedOut', {
                url: '/logged-out',
                templateUrl: 'app/components/loggedOut/loggedOut.view.html',
                controller: 'LoggedOutController',
                controllerAs: 'vm',
                title: 'Logged Out'
            });
    }
})();

(function () {
    'use strict';

    angular
        .module('app.vmis')
        .controller('LoggedOutController', LoggedOutController);

    LoggedOutController.$inject = ['$cookies','config','authentication'];

    function LoggedOutController($cookies,config,authentication) {
        var vm = this;

        // Show reason for being logged out if any
        vm.formError = $cookies.get('logged-out-reason');

        activate();

        function activate() {
            if(authentication.isLoggedIn()){
                vm.isLoading=true;
                var ticketErrorStr = "";

                return config.get().then(function (configData) {
                    ticketErrorStr = configData.loggedOutReasons.ticketError;
                }).then(authentication.logOut)
                .catch(function (error) {
                    console.error(error);
                    $cookies.put('logged-out-reason', ticketErrorStr);
                }).finally(vm.isLoading=false);
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.vmis')
        .config(routes);

    routes.$inject = ['$stateProvider', '$urlRouterProvider'];

    function routes($stateProvider, $urlRouterProvider) {
        $urlRouterProvider
            .when('/log-in', logInRedirect);

        $stateProvider
            .state('vmis.logIn', {
                url: '/log-in',
                template: '<h1 class="center-horizontal">Redirecting to SSO Log-In...</h1>',
                title: 'Login'
            });

        logInRedirect.$inject = ['$window', 'config'];

        function logInRedirect($window, config) {
            return config.get().then(function (configData) {
                $window.location.href = configData.casServer + 'login?service=' +
                    encodeURIComponent($window.location.protocol + "//" + $window.location.host);
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.vmis')
        .controller('PasswordExpirationModalController', PasswordExpirationModalController);

    PasswordExpirationModalController.$inject = ['daysRemaining', 'config'];

    function PasswordExpirationModalController(daysRemaining, config) {
        var vm = this;

        vm.daysRemaining = daysRemaining;
        vm.accountSettingsURL = null;

        activate();

        function activate() {
            config.get().then(function (configData) {
                vm.accountSettingsURL = configData.accountSettingsURL;
            });
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.vmis')
        .config(routes);

    routes.$inject = ['$stateProvider'];

    function routes($stateProvider) {
        $stateProvider
            .state('vmis.profile', {
                url: '/profile',
                templateUrl: 'app/components/profile/profile.view.html',
                controller: 'ProfileController',
                controllerAs: 'vm',
                title: 'Profile'
            })
            .state('vmis.profileEdit', {
                url: '/profile/{id:int}',
                templateUrl: 'app/components/profile/profile.view.html',
                controller: 'ProfileController',
                controllerAs: 'vm',
                title: 'Profile'
            })
            .state('vmis.profileNonUser', {
                url: '/profile/{email}',
                templateUrl: 'app/components/profile/profile.view.html',
                controller: 'ProfileController',
                controllerAs: 'vm',
                title: 'Profile'
            });
    }
})();

(function () {
    'use strict';

    angular
        .module('app')
        .controller('ProfileController', ProfileController);

    ProfileController.$inject = ['$anchorScroll', '$q', '$state', '$stateParams', '$modal', '$window', '$scope',
        'authentication', 'moment', '_', 'config'];

    function ProfileController($anchorScroll, $q, $state, $stateParams, $modal, $window, $scope,
        authentication, moment, _, config) {
        var vm = this;
        var oldCommunity = {
            communityAffiliationId: null,
            communityAffiliationName: null
        };
        var testString = "";

        vm.isUatWebsite = null;
        vm.isTrainingWebsite = null;
        vm.isLoading = true;

        vm.dispositions = {};
        vm.dispositionsSelected = 0;
        vm.masterUserId = parseInt($stateParams.id) || null; // If exists, using page as admin
        vm.nonUserEmail = $stateParams.email || null; // If exists, using page to create non-user
        vm.fullName = vm.nonUserEmail || "";
        vm.userName = "";

        vm.noProfile = false;

        vm.onSubmit = onSubmit;
        vm.onChangeCountry = onChangeCountry;
        vm.onCancel = onCancel;
        vm.onChangeDisposition = onChangeDisposition;
        vm.onChangeBirthday = onChangeBirthday;

        activate();

        function activate() {
            config.get().then(function (configData) {
                vm.isUatWebsite = configData.isUatWebsite;
                vm.isTrainingWebsite = configData.isTrainingWebsite;
            });
            fillDropDowns().then(function () {
                if (vm.masterUserId) {
                    getUserProfile(vm.masterUserId);
                }
                else if (vm.nonUserEmail) {
                    vm.adminEditing = true;
                    vm.noProfile = true;

                    // For non-users, the volunteer email should match the master email
                    // Pre-fill that field out
                    vm.volunteerProfile = {
                        volunteerEmail: vm.nonUserEmail
                    };

                    // Only allow assigning of a non-user to a community the admin is responsible for (and is active)
                    // Slightly inefficient since the admin's profile is obtained elsewhere on page load
                    authentication.getUserProfile()
                        .then(function (response) {
                            if (response.aosUser.vmisUser.adminProfile && response.aosUser.vmisUser.adminProfile.responsibilities) {
                                var responsibilities = response.aosUser.vmisUser.adminProfile.responsibilities;
                                var workingCommIdsList = [];
                                // Note: according to people.routes.js:112, only AVCC and OPOC can access this functionality
                                // (In combination with the exclusion of AVCC Assistants in volunteers.controller.js.)
                                if (responsibilities.avcc) {
                                    responsibilities.avcc.forEach(function (comm) {
                                        workingCommIdsList.push(comm.communityAffiliationId);
                                    });
                                }
                                if (responsibilities.opoc) {
                                    responsibilities.opoc.forEach(function (comm) {
                                        workingCommIdsList.push(comm.communityAffiliationId);
                                    });
                                }

                                var newCommsList = [];
                                workingCommIdsList.forEach(function (respCommId) {
                                    var match = _.find(vm.dropDowns.communities, { 'communityAffiliationId': respCommId });
                                    if (match !== undefined) {
                                        newCommsList.push(match);
                                    }
                                });
                                vm.dropDowns.communities = newCommsList;
                            }
                            else {
                                vm.formSuccess = '';
                                vm.formError = "Error: insufficient admin responsibilities to create a non-user";
                            }
                            vm.isLoading = false;
                        })
                        .catch(function (error) {
                            vm.formSuccess = '';
                            vm.formError = "Error: " + error;
                            vm.isLoading = false;
                        });
                }
                else {
                    vm.adminEditing = false;
                    getUserProfile();
                }
            });
        }

        function fillDropDowns() {
            var promiseArray = [];

            var elements = [
                'usstate',
                'stateabbrev',
                'country',
                'branchofservice',
                'component',
                'disposition',
                'paygrade',
                'civilianpaygrade',
                'preferredcontactmethod'
            ];

            vm.dropDowns = {};

            promiseArray.push(authentication.getUiData(elements).then(function (response) {
                vm.dropDowns.states = authentication.createStateList(response.usstate,response.stateabbrev);
                vm.dropDowns.countries = response.country;
                vm.dropDowns.branches = response.branchofservice;
                vm.dropDowns.components = response.component;
                vm.dropDowns.ranks = response.paygrade;
                vm.dropDowns.civilianRanks = response.civilianpaygrade;
                vm.dropDowns.preferredContactMethods = response.preferredcontactmethod;

                response.disposition.forEach(function (disposition) {
                    vm.dispositions[disposition] = {
                        name: disposition,
                        selected: false,
                        disabled: false
                    };
                });
            }));

            promiseArray.push(authentication.getCommunities({
                getAll: true,
                isArchived: false
            }).then(function (response) {
                vm.dropDowns.communities = response.communityAffiliations;
            }));

            return $q.all(promiseArray).catch(function (error) {
                vm.formSuccess = '';
                vm.formError = "Error: " + error;
            });
        }

        function getUserProfile(id) {
            var getUserProfilePromiseArray = [];
            var commCheckPromiseArray = [];
            vm.isLoading = true;

            var params = null;
            if (angular.isNumber(id)) {
                params = {
                    masterUserId: id
                };

                getUserProfilePromiseArray.push(authentication.getUsernameFromMasterUserId(params).then(function(response){
                    vm.username = response.username;
                }));
            }



            getUserProfilePromiseArray.push(authentication.getUserProfile(params)
                .then(function (response) {
                    // If editing own profile and a part is incomplete (not checking admin profile)
                    if (!id && (!authentication.isAosProfileValid(response.aosUser) ||
                        (response.aosUser.vmisUser && !authentication.isVmisProfileValid(response.aosUser.vmisUser.volunteerProfile)))) {
                        vm.noProfile = true;
                        vm.formSuccess = '';
                        vm.formError = "You must fill out your User profile before proceeding.";

                        vm.initialDate = moment().format('MM/DD/YYYY');
                    }

                    vm.email = response.masterUserEmail || response.aosUser.email;

                    var aosProfile = response.aosUser;

                    vm.fullName = aosProfile.firstName + " " + aosProfile.lastName;

                    vm.aosProfile = {};
                    vm.aosProfile.firstName = aosProfile.firstName || '';
                    vm.aosProfile.middleInitial = aosProfile.middleInitial ? aosProfile.middleInitial : '';
                    vm.aosProfile.lastName = aosProfile.lastName || '';
                    vm.aosProfile.dateOfBirth = aosProfile.dateOfBirth ? moment(aosProfile.dateOfBirth, 'YYYY-MM-DD').toDate() : undefined;
                    if (vm.aosProfile.dateOfBirth !== undefined) {
                        var birthday = new Date(vm.aosProfile.dateOfBirth).toISOString();
                        var age = moment().startOf('day').diff(birthday, 'years');
                        vm.isMinor = (age < 18);
                    }
                    else {
                        vm.isMinor = false;
                    }

                    if (aosProfile.communityAffiliationId) {
                        commCheckPromiseArray.push(authentication.isCommunityArchived(aosProfile.communityAffiliationId)
                            .then(function (isArchived) {
                                if (isArchived) {
                                    vm.formSuccess = '';
                                    vm.formError = "The Military Community you were a part of has been inactivated. Please select a new one.";
                                }
                            })
                        );

                        oldCommunity = vm.aosProfile.militaryCommunity = vm.dropDowns.communities.filter(function (comm) {
                            return comm.communityAffiliationId === aosProfile.communityAffiliationId;
                        })[0];
                    }
                    else {
                        vm.aosProfile.militaryCommunity = oldCommunity = undefined;
                    }

                    vm.aosProfile.branch = aosProfile.branchOfService || '';
                    vm.aosProfile.component = aosProfile.armyComponent || '';

                    // Minor fields
                    vm.aosProfile.isMarried = aosProfile.isMarried || false;
                    if (!aosProfile.isMarried) {
                        vm.aosProfile.parentGuardian = {
                            firstName: aosProfile.parentGuardianFirstName,
                            lastName: aosProfile.parentGuardianLastName,
                            phone: aosProfile.parentGuardianPhone,
                            email: aosProfile.parentGuardianEmail,
                            address: {
                                country: aosProfile.parentGuardianCountry,
                                line1: aosProfile.parentGuardianAddress1,
                                line2: aosProfile.parentGuardianAddress2 || '',
                                city: aosProfile.parentGuardianCity,
                                state: aosProfile.parentGuardianUsState,
                                zipCode: aosProfile.parentGuardianZipCode
                            }
                        };
                        onChangeCountry(vm.aosProfile.parentGuardian.address);
                    }

                    if (aosProfile.dispositions) {
                        aosProfile.dispositions.forEach(function (disposition) {
                            vm.dispositions[disposition].selected = true;
                            onChangeDisposition(vm.dispositions[disposition]);
                        });

                        if (vm.dispositions['Service Member'].selected) {
                            vm.aosProfile.rank = aosProfile.payGrade;
                        }
                        if (vm.dispositions['Family Member'].selected) {
                            vm.aosProfile.sponsorRank = aosProfile.sponsorPayGrade;
                        }
                        if (vm.dispositions['DoD Civilian'].selected) {
                            vm.aosProfile.civilianRank = aosProfile.civilianPayGrade;
                        }
                    }

                    if ('vmisUser' in response.aosUser && response.aosUser.vmisUser !== null) {
                        var vmisUser = response.aosUser.vmisUser;

                        // Edge case that should not happen in normal usage
                        // Can occur if, for example, in Postman only part of the profile is set
                        if (vmisUser === null)
                            vm.noProfile = true;

                        if ('adminProfile' in vmisUser && vmisUser.adminProfile !== null) {
                            var adminProfile = vmisUser.adminProfile;

                            if (!id && !authentication.isAdminProfileValid(adminProfile)) {
                                vm.formSuccess = '';
                                vm.formError = "You have been granted a higher level of access within VMIS. Please update your administrator profile before continuing.";
                            }

                            var isAfwpAdmin = false;
                            var isProgramManager = false;

                            // Find out if AFWP admin or PM
                            response.roles.vmisUserRoles.forEach(function (role) {
                                switch (role) {
                                    case "AFWP Administrator":
                                        isAfwpAdmin = true;
                                        break;
                                    case "AVC Program Manager":
                                        isProgramManager = true;
                                        break;
                                }
                            });

                            vm.adminProfile = {
                                additionalRoles: {
                                    afwpAdmin: isAfwpAdmin,
                                    programManager: isProgramManager
                                },
                                responsibilities: {
                                    opoc: _.map(adminProfile.responsibilities.opoc, function (community) {
                                        return {
                                            name: community.communityAffiliationName,
                                            organizations: _.map(community.organizations, function (organization) {
                                                return organization.volunteerOrganizationName;
                                            })
                                        };
                                    }),
                                    avccAssistant: _.map(adminProfile.responsibilities.avccAssistant, function (community) {
                                        return community.communityAffiliationName;
                                    }),
                                    coordinator: _.map(adminProfile.responsibilities.avcc, function (community) {
                                        return community.communityAffiliationName;
                                    }),
                                    rm: _.map(adminProfile.responsibilities.rm, function (community) {
                                        return community.communityAffiliationName;
                                    })
                                },
                                note: adminProfile.note || '',
                                workEmail: adminProfile.workEmail,
                                commercialWorkPhone: adminProfile.commercialWorkPhone,
                                dsnPhone: adminProfile.dsnPhone || '',
                                address: {
                                    country: adminProfile.country,
                                    line1: adminProfile.address1,
                                    line2: adminProfile.address2 || '',
                                    city: adminProfile.city,
                                    state: adminProfile.usState,
                                    zipCode: adminProfile.zipCode
                                }
                            };
                            onChangeCountry(vm.adminProfile.address);
                        }

                        if ('volunteerProfile' in vmisUser && vmisUser.volunteerProfile !== null) {
                            var volunteerProfile = vmisUser.volunteerProfile;
                            vm.volunteerProfile = {};
                            vm.volunteerProfile.volunteerEmail = volunteerProfile.volunteerEmail;
                            vm.volunteerProfile.preferredContactMethod = volunteerProfile.preferredContactMethod;
                            vm.volunteerProfile.workExperience = volunteerProfile.workExperience ? volunteerProfile.workExperience : '';
                            vm.volunteerProfile.volunteerExperience = volunteerProfile.volunteerExperience ? volunteerProfile.volunteerExperience : '';
                            vm.volunteerProfile.specialSkillsInterestsAndHobbies = volunteerProfile.specialSIH ? volunteerProfile.specialSIH : '';
                            vm.volunteerProfile.primaryPhone = volunteerProfile.primaryPhone;
                            vm.volunteerProfile.secondaryPhone = volunteerProfile.secondaryPhone ? volunteerProfile.secondaryPhone : '';
                        }
                    }
                })
                .catch(function (error) {
                    vm.formSuccess = '';
                    vm.formError = "Error: " + error;
                    vm.isLoading = false;
                }));

            if(vm.masterUserId) {
                getUserProfilePromiseArray.push(authentication.getUserNotificationEmailSettings({masterUserId: vm.masterUserId})
                    .then(function (response) {
                        vm.gettingNotificationEmails = response.currentNotificationEmails.count > 0;
                        vm.initalNotificationEmails = vm.gettingNotificationEmails;
                        vm.isLoading = false;
                    })
                    .catch(function (error) {
                        vm.formSuccess = '';
                        vm.formError = "Error: " + error;
                        vm.isLoading = false;
                    }));
            }
            else {
                getUserProfilePromiseArray.push(authentication.getUserNotificationEmailSettings()
                    .then(function (response) {
                        vm.gettingNotificationEmails = response.currentNotificationEmails.count > 0;
                        vm.initalNotificationEmails = vm.gettingNotificationEmails;
                        vm.isLoading = false;
                    })
                    .catch(function (error) {
                        vm.formSuccess = '';
                        vm.formError = "Error: " + error;
                        vm.isLoading = false;
                    }));
            }

            // Check if "adminEditing" own account, otherwise set flag to true
            if (angular.isNumber(id)) {
                getUserProfilePromiseArray.push(authentication.getUserProfile()
                    .then(function (response) {
                        vm.adminEditing = id !== response.masterUserId;
                    })
                    .catch(function (error) {
                        vm.formSuccess = '';
                        vm.formError = "Error: " + error;
                        vm.isLoading = false;
                    }));
            }

            return $q.all(getUserProfilePromiseArray)
                .then(function () {
                    return $q.all(commCheckPromiseArray)
                        .then(function () {
                            vm.isLoading = false;
                        });

                });
        }

        function onSubmit() {
            // If editing another user but not creating non-user
            if (vm.adminEditing && !vm.nonUserEmail)
                setUserProfile(vm.masterUserId);
            else
                setUserProfile();
        }

        function setUserProfile(id) {
            var aosUser = {
                firstName: vm.aosProfile.firstName,
                middleInitial: vm.aosProfile.middleInitial,
                lastName: vm.aosProfile.lastName,
                dateOfBirth: moment(vm.aosProfile.dateOfBirth).format('YYYY-MM-DD'),
                communityAffiliationId: vm.aosProfile.militaryCommunity.communityAffiliationId,
                branchOfService: vm.aosProfile.branch,
                armyComponent: vm.aosProfile.component,
                dispositions: []
            };

            // TODO: Should we check the time again or just follow what the checkbox indicates?
            if (moment().diff(vm.aosProfile.dateOfBirth, 'years') < 18) {
                aosUser.isMarried = vm.aosProfile.isMarried;
                if (!aosUser.isMarried) {
                    aosUser.parentGuardianFirstName = vm.aosProfile.parentGuardian.firstName;
                    aosUser.parentGuardianLastName = vm.aosProfile.parentGuardian.lastName;
                    aosUser.parentGuardianPhone = vm.aosProfile.parentGuardian.phone;
                    aosUser.parentGuardianEmail = vm.aosProfile.parentGuardian.email;
                    aosUser.parentGuardianAddress1 = vm.aosProfile.parentGuardian.address.line1;
                    aosUser.parentGuardianAddress2 = vm.aosProfile.parentGuardian.address.line2;
                    aosUser.parentGuardianCity = vm.aosProfile.parentGuardian.address.city;
                    aosUser.parentGuardianCountry = vm.aosProfile.parentGuardian.address.country;
                    aosUser.parentGuardianZipCode = vm.aosProfile.parentGuardian.address.zipCode;
                    if(angular.isDefined(vm.aosProfile.parentGuardian.address.state) && vm.aosProfile.parentGuardian.address.state !== null){
                        testString = vm.aosProfile.parentGuardian.address.state.substring(vm.aosProfile.parentGuardian.address.state.length-5);

                        if(testString.substring(0,2) === ' (' && testString.substring(testString.length-1) === ')'){
                            vm.aosProfile.parentGuardian.address.state = vm.aosProfile.parentGuardian.address.state.substring(0,vm.aosProfile.parentGuardian.address.state.length-5);
                        }
                    }
                    aosUser.parentGuardianUsState = vm.aosProfile.parentGuardian.address.isStateRequired ? vm.aosProfile.parentGuardian.address.state : undefined;
                }
            }

            angular.forEach(vm.dispositions, function (disposition) {
                if (disposition.selected) aosUser.dispositions.push(disposition.name);
            });

            if (vm.dispositions['Service Member'].selected) {
                aosUser.payGrade = vm.aosProfile.rank;
            }
            if (vm.dispositions['Family Member'].selected) {
                aosUser.sponsorPayGrade = vm.aosProfile.sponsorRank;
            }
            if (vm.dispositions['DoD Civilian'].selected) {
                aosUser.civilianPayGrade = vm.aosProfile.civilianRank;
            }
            
            if (vm.adminProfile || vm.volunteerProfile) {
                aosUser.vmisUser = {};
            }

            if (vm.adminProfile) {

                if(angular.isDefined(vm.adminProfile.address.state) && vm.adminProfile.address.state !== null){
                    testString = vm.adminProfile.address.state.substring(vm.adminProfile.address.state.length-5);

                    if(testString.substring(0,2) === ' (' && testString.substring(testString.length-1) === ')'){
                        vm.adminProfile.address.state = vm.adminProfile.address.state.substring(0,vm.adminProfile.address.state.length-5);
                    }
                }

                aosUser.vmisUser.adminProfile = {
                    note: vm.adminProfile.note,
                    workEmail: vm.adminProfile.workEmail,
                    commercialWorkPhone: vm.adminProfile.commercialWorkPhone,
                    dsnPhone: vm.adminProfile.dsnPhone,
                    country: vm.adminProfile.address.country,
                    address1: vm.adminProfile.address.line1,
                    address2: vm.adminProfile.address.line2,
                    city: vm.adminProfile.address.city,
                    usState: vm.adminProfile.address.isStateRequired ? vm.adminProfile.address.state : undefined,
                    zipCode: vm.adminProfile.address.zipCode
                };
            }

            if (vm.volunteerProfile) {
                aosUser.vmisUser.volunteerProfile = {
                    volunteerEmail: vm.volunteerProfile.volunteerEmail,
                    preferredContactMethod: vm.volunteerProfile.preferredContactMethod,
                    workExperience: vm.volunteerProfile.workExperience,
                    volunteerExperience: vm.volunteerProfile.volunteerExperience,
                    specialSIH: vm.volunteerProfile.specialSkillsInterestsAndHobbies,
                    primaryPhone: vm.volunteerProfile.primaryPhone,
                    secondaryPhone: vm.volunteerProfile.secondaryPhone
                };
            }

            if (vm.nonUserEmail)
                completeNonUserCreation(aosUser);
            else {
                var promise = $q.resolve();
                if (oldCommunity && oldCommunity.communityAffiliationId && oldCommunity.communityAffiliationId !== aosUser.communityAffiliationId) {
                    promise = $modal.open({
                        templateUrl: 'app/components/profile/changeCommunity.view.html',
                        controller: 'ChangeCommunityController',
                        controllerAs: 'vm',
                        size: 'tiny',
                        backdrop: 'static',
                        keyboard: false,
                        resolve: {
                            params: function () {
                                return {
                                    community: oldCommunity.communityAffiliationName,
                                    name: vm.adminEditing ? aosUser.firstName : null
                                };
                            }
                        }
                    }).result.then(function () {
                        return authentication.finishOpportunityStatusForUser({
                            communityAffiliationId: oldCommunity.communityAffiliationId,
                            userId: vm.adminEditing ? id : undefined
                        });
                    }, function () {
                    });
                }

                promise.then(function () {
                    return authentication.setUserProfile(aosUser, vm.adminEditing ? id : undefined);
                }).then(function () {
                    oldCommunity = vm.aosProfile.militaryCommunity;
                    var fullName = aosUser.firstName + " " + aosUser.lastName;
                    if(vm.gettingNotificationEmails !== vm.initalNotificationEmails){
                        var params = vm.gettingNotificationEmails ? {} : {isRemoving: true};
                        return authentication.setUserNotificationEmailSettings(params).then(function () {
                            profileUpdatedSuccessfully(fullName);
                            activate();
                        });
                    }
                    else {
                        profileUpdatedSuccessfully(fullName);
                    }

                }).catch(function (error) {
                    vm.formSuccess = '';
                    vm.formError = "Error: " + error;
                }).finally(function () {
                    $anchorScroll('anchor-top');
                });
            }
        }

        function profileUpdatedSuccessfully(fullName) {
            vm.formError = '';
            vm.formSuccess = 'Profile updated successfully!';
            // Alert header and side nav to update for any possible changes if not admin editing
            if (!vm.masterUserId)
                $scope.$emit('profile:update');
            // Just update profile page header if admin editing
            else
                vm.fullName = fullName;
        }

        function onChangeCountry(profileAddress) {
            profileAddress.isStateRequired = profileAddress.country === 'United States';
            if (!profileAddress.isStateRequired) {
                profileAddress.state = undefined;
            }
        }

        function onChangeBirthday(date) {
            if (!date) return;
            var birthday = new Date(date).toISOString();
            var age = moment().startOf('day').diff(birthday, 'years');
            vm.isMinor = (age < 18);
            vm.aosProfile.isMarried = 0;
        }

        function onCancel() {
            $state.go('vmis', null, { reload: true });
        }

        function onChangeDisposition(disposition) {
            vm.dispositionsSelected += disposition.selected ? 1 : -1;
        }

        function completeNonUserCreation(aosUser) {
            // Non-user-specific check
            if (vm.nonUserEmail && (vm.nonUserEmail !== aosUser.vmisUser.volunteerProfile.volunteerEmail)) {
                vm.formError = "Volunteer email must match master user email for non-users.";
                vm.isLoading = false;
                return;
            }

            var params = {
                aosUser: aosUser,
                email: vm.nonUserEmail
            };

            authentication.setNonUser(params)
                .then(function () {
                    // Inform user of success with modal
                    var options = {
                        templateUrl: 'app/components/profile/infoModal.view.html',
                        controller: 'InfoModalController',
                        controllerAs: 'vm',
                        size: 'tiny',
                        backdrop: 'static',
                        keyboard: false,
                        resolve: {
                            title: function () {
                                return "User Successfully Created";
                            },
                            firstName: function () {
                                return params.aosUser.firstName;
                            },
                            lastName: function () {
                                return params.aosUser.lastName;
                            },
                            email: function () {
                                return params.email;
                            },
                            error: function () {
                                return null;
                            }
                        }
                    };

                    $modal.open(options)
                        .result.finally(function () {
                            infoModalResponse();
                        });
                })
                .catch(function (error) {
                    // Inform user of failure with modal
                    var options = {
                        templateUrl: 'app/components/profile/infoModal.view.html',
                        controller: 'InfoModalController',
                        controllerAs: 'vm',
                        size: 'tiny',
                        backdrop: 'static',
                        keyboard: false,
                        resolve: {
                            title: function () {
                                return "User Creation Failed";
                            },
                            firstName: function () {
                                return params.aosUser.firstName;
                            },
                            lastName: function () {
                                return params.aosUser.lastName;
                            },
                            email: function () {
                                return params.email;
                            },
                            error: function () {
                                return error;
                            }
                        }
                    };

                    $modal.open(options)
                        .result.finally(function () {
                            vm.formError = error;
                            vm.isLoading = false;
                        });
                });

            function infoModalResponse() {
                // Go to another page
                if ($stateParams['return-to'])
                    redirect.returnTo($stateParams['return-to']);
                else
                    $window.history.back();

                vm.isLoading = false;
            }
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app')
        .controller('ChangeCommunityController', ChangeCommunityController);

    ChangeCommunityController.$inject = ['params'];

    function ChangeCommunityController(params) {
        var vm = this;

        vm.community = params.community;
        vm.name = params.name;
    }
})();
(function () {
    'use strict';

    angular
        .module('app.vmis')
        .controller('InfoModalController', InfoModalController);

    InfoModalController.$inject = ['$modalInstance', 'title', 'firstName', 'lastName', 'email', 'error'];

    function InfoModalController($modalInstance, title, firstName, lastName, email, error) {
        var vm = this;

        vm.title = title;
        vm.fullName = firstName + " " + lastName;
        vm.email = email;

        vm.error = error;

        vm.onOk = onOk;

        activate();

        function activate() {
            $modalInstance.close();
        }

        function onOk() {
            $modalInstance.close();
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.vmis')
        .config(routes);

    routes.$inject = ['$stateProvider', '$urlRouterProvider'];

    function routes($stateProvider, $urlRouterProvider) {
        $urlRouterProvider
            .when('/register', registerRedirect);

        $stateProvider
            .state('vmis.register', {
                url: '/register?{return-to}',
                template: '<h1 class="center-horizontal">Redirecting to Account Management registration...</h1>'
            })
            .state('vmis.migrateUser', {
                url: '/migrate-user',
                templateUrl: 'app/components/register/migrateUser.view.html',
                controller: 'MigrateUserController',
                controllerAs: 'vm',
                title: 'Transition User Account'
            })
            .state('vmis.claimUser', {
                url: '/claim-user?{key}',
                templateUrl: 'app/components/register/claimUser.view.html',
                controller: 'ClaimUserController',
                controllerAs: 'vm',
                title: 'Claim User'
            });

        registerRedirect.$inject = ['$window', 'config'];

        function registerRedirect($window, config) {
            return config.get().then(function (configData) {
                // Removing return URL functionality because Account Management needs updates to use it properly.
                // User is required to verify and fill out profile there, so holding on to the link is difficult.
                // Having it visible on transfer gives false impression user will be sent back to their application.
                /*
                var returnUrl = $window.location.search !== "" ?
                    $window.location.search : $window.location.protocol + "//" + $window.location.host;
                $window.location.href = configData.accountSettingsUrl + 'register?service=' +
                    encodeURIComponent(returnUrl);
                */
                $window.location.href = configData.accountSettingsUrl + 'register';
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.vmis')
        .controller('MigrateUserController', MigrateUserController);

    MigrateUserController.$inject = ['$state', '$modal', 'authentication'];

    function MigrateUserController($state, $modal, authentication) {
        var vm = this;

        vm.isLoading = false;
        vm.emailSent = false;
        vm.onSubmit = onSubmit;
        vm.emailStatusMessage = "";

        function onSubmit(username) {
            vm.isLoading = true;

            vm.formError = "";

            authentication.findByUsername(vm.username)
                .then(function (response) {
                    vm.formError = "";
                    if (response.emailCount === 0) {
                        vm.formError = "Cannot find an account with this username.";
                    }
                    else{
                        return authentication.sendMigrationEmailByUsername(vm.username)
                            .then(function(){
                                vm.emailStatusMessage = "Please check the email(s) associated with your account for login instructions. Redirecting you to home page.";
                                vm.emailSent = true;

                                var options = {
                                    templateUrl: 'app/components/register/beginMigration.view.html',
                                    controller: 'BeginMigrationController',
                                    controllerAs: 'vm',
                                    size:"tiny",
                                    backdrop: 'static',
                                    keyboard: false
                                };
                                $modal.open(options).result
                                    .then(function(){
                                        $state.go('vmis', null, {reload: true});
                                    })
                                    .catch(function(){
                                        $state.go('vmis', null, {reload: true});
                                    });
                            });
                    }

                    vm.isLoading = false;

                    return response;
                })
                .then(function(response){
                })
                .catch(function (error) {
                    vm.formError = error;
                    vm.isLoading = false;
                });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.vmis')
        .controller('ClaimUserController', ClaimUserController);

    ClaimUserController.$inject = ['$cookies', '$stateParams', '$timeout', '$window', 'authentication', 'config'];

    function ClaimUserController($cookies, $stateParams, $timeout, $window, authentication, config) {
        var vm = this;

        vm.isLoading = false;
        vm.email = "";
        vm.confirmEmail = "";
        vm.password = "";
        vm.confirmPassword = "";
        vm.onSubmit = onSubmit;
        vm.username = "";
        vm.userFound = false;
        vm.formError = "";
        vm.passwordRequirements = null;

        activate();

        function activate() {
            vm.formError = "";

            config.get().then(function (configData) {
                vm.passwordRequirements = configData.passwordRequirements;
            });

            authentication.findUsernameByKey($stateParams.key)
                .then(function (response) {
                    vm.formError = "";
                    vm.isLoading = false;
                    vm.userFound = true;
                    vm.username = response.username;
                })
                .catch(function (error) {
                    vm.formError = error;
                    vm.isLoading = false;
                });

        }

        function onSubmit() {
            vm.isLoading = true;
            vm.formError = "";
            authentication.completeUserMigration($stateParams.key, vm.username, vm.email, vm.password)
                .then(function () {
                    config.get().then(function (configData) {
                        $window.location.href = configData.accountSettingsUrl + "registration-landing";
                    });
                })
                .catch(function (error) {
                    vm.formError = error ? (error.error ? error.error : error) : 'Unknown error';
                    vm.isLoading = false;
                });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.vmis')
        .controller('BeginMigrationController', BeginMigrationController);

    BeginMigrationController.$inject = ['$modalInstance'];

    function BeginMigrationController($modalInstance) {
        var vm = this;

        vm.onClickOk = onClickOk;

        function onClickOk() {
            $modalInstance.dismiss({});
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.vmis')
        .config(routes);

    routes.$inject = ['$stateProvider'];

    function routes($stateProvider) {
        $stateProvider
            .state('underConstruction', {
                url: '/',
                templateUrl: 'app/components/underConstructionPage/underConstructionPage.view.html',
                controller: 'UnderConstructionController',
                controllerAs: 'vm',
                title: 'Under Construction'
            });
    }
})();
(function () {
    'use strict';

    angular
        .module('app.vmis')
        .controller('UnderConstructionController', UnderConstructionController);

    UnderConstructionController.$inject = ['$scope', '$window', 'config'];

    function UnderConstructionController($scope, $window, config) {
        var vm = this;
        vm.websiteFamilyList = null;

        // Close the drop down menu if the user clicks outside of it
        window.onclick = function (event) {
            if (!$(event.target).hasClass("header-icon-menu")) {
                vm.showMenu = false;
                $scope.$apply();
            }
        };

        activate();

        function activate() {
            config.get().then(function (configData) {
                vm.websiteFamilyList = configData.afwpWebsiteFamilyList;
            });
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('vmis.volunteer', [
            'ui.router',
            'app.auth',
            'app.vmisHoursEntry'
        ]);
})();
(function () {
    'use strict';

    angular
        .module('vmis.volunteer')
        .config(routes);

    routes.$inject = ['$stateProvider'];

    function routes($stateProvider) {
        $stateProvider
            .state('vmis.volunteer', {
                url: '/volunteer',
                abstract: true,
                templateUrl: 'app/components/volunteer/volunteer.view.html'
            })
            .state('vmis.volunteer.serviceLog', {
                url: '/service-log',
                templateUrl: 'app/components/volunteer/serviceLog/serviceLog.view.html',
                controller: 'ServiceLogController',
                controllerAs: 'vm',
                title: 'Service Log'
            })
            .state('vmis.volunteer.serviceLogEdit', {
                url: '/service-log/{id}',
                templateUrl: 'app/components/volunteer/serviceLog/serviceLog.view.html',
                controller: 'ServiceLogController',
                controllerAs: 'vm',
                title: 'Service Log'
            })
            .state('vmis.volunteer.applications', {
                url: '/applications',
                templateUrl: 'app/components/volunteer/applications/applications.view.html',
                controller: 'VolunteerApplicationsController',
                controllerAs: 'vm',
                title: 'Applications'
            })
            .state('vmis.volunteer.applications.details', {
                url: '/details?opportunityId&applicationId&communityVolunteerOrganizationApplicationId',
                templateUrl: 'app/components/volunteer/applications/applicationDetails.view.html',
                controller: 'VolunteerApplicationDetailsController',
                controllerAs: 'vm',
                title: 'Application Details'
            })
            .state('vmis.volunteer.applications.createNonAvcPosition', {
                url: '/create-non-avc-position',
                templateUrl: 'app/components/volunteer/createNonAvcPosition/createNonAvcPosition.view.html',
                controller: 'CreateNonAvcPositionController',
                controllerAs: 'vm',
                title: 'Create Position'
            })
            .state('vmis.volunteer.opportunities', {
                url: '/opportunities',
                templateUrl: 'app/components/volunteer/opportunities/opportunities.view.html',
                controller: 'OpportunitiesController',
                controllerAs: 'vm',
                title: 'Opportunities'
            })
            .state('vmis.volunteer.opportunities.apply', {
                url: '/apply/{opportunityId:int}',
                templateUrl: 'app/components/volunteer/opportunities/apply.view.html',
                controller: 'ApplyController',
                controllerAs: 'vm',
                title: 'Volunteer Application'
            });
    }
})();
(function () {
    'use strict';

    angular
        .module('vmis.activityCalendar', [
            'angularMoment',
            'ngFileUpload'
        ]);
})();
(function () {
    'use strict';

    angular
        .module('vmis.activityCalendar')
        .directive('calendar', ActivityCalendar);

    ActivityCalendar.$inject = [];

    function ActivityCalendar() {
        return {
            restrict: 'E',
            templateUrl: 'app/components/volunteer/activityCalendar/activityCalendar.view.html',
            scope: {
                date: '=?',
                position: '=',
                reload: '=?'
            },
            controller: 'ActivityCalendarController',
            controllerAs: 'vm',
            backdrop: 'static',
            keyboard: false,
            bindToController: {
                onLoadActivities: '&?',
                disabled: '=?',
                targetUser: '=',
                adminEditing: '='
            },
            link: link
        };

        function link(scope) {
            scope.$watch('date', dateListener);
            scope.$watch('position', positionListener);
            scope.$watch('reload', reloadListener);

            function dateListener() {
            }

            function positionListener(newValue, oldValue, scope) {
                if (angular.isDefined(newValue) && (newValue !== oldValue)) {
                    scope.vm.onSetPosition(newValue);
                }
            }

            function reloadListener(newValue, oldValue, scope) {
                if(angular.isDefined(newValue) && (newValue !== oldValue) && newValue === true) {
                    scope.reload = false;
                    scope.vm.onReload();
                }
            }
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('vmis.activityCalendar')
        .controller('ActivityCalendarController', ActivityCalendarController);

    ActivityCalendarController.$inject = ['$scope', '$modal', 'moment', 'authentication', '_'];

    function ActivityCalendarController($scope, $modal, moment, authentication, _) {
        var vm = this;

        vm.isCalendarLoading = true;

        var periodStart = new Date();
        var position;
        var dailyActivities = [];
        var periodActivities = [];

        vm.current = new Date();
        vm.calendarView = buildMonth(moment(vm.current).year(), moment(vm.current).month());

        vm.isToday = isToday;
        vm.isCurrentMonth = isCurrentMonth;
        vm.isCurrentPeriod = isCurrentPeriod;
        vm.isBeforePeriod = isBeforePeriod;
        //vm.isAfterPeriod = isAfterPeriod;
        vm.onNextMonth = onNextMonth;
        vm.onPreviousMonth = onPreviousMonth;
        vm.onSelect = onSelect;
        vm.onSetPosition = onSetPosition;
        vm.onReload = onReload;

        activate();

        function activate() {
            if (moment().date() < 15) {
                periodStart = moment().subtract(1, 'months');
            }
            periodStart = moment(periodStart).startOf('month').toDate();

            if ((angular.isUndefined(position)) || (position === null)) {
                vm.isCalendarLoading = false;
            }
        }

        function buildCalendar(year, month) {
            // "!= undefined" catches null and undefined but allows for 0
            if ((year != undefined && !parseInt(year)) || (month != undefined && !parseInt(month))) {
                console.warn("Warning: attempted to build calendar with invalid year, month: " +
                    year + ", " + month);
                return;
            }

            if (year && month) {
                vm.current = new Date(year, month);
                vm.calendarView = buildMonth(year, month);
            } else {
                vm.calendarView = buildMonth(moment(vm.current).year(), moment(vm.current).month());
            }
            loadActivities();
        }

        function buildMonth(year, month) {
            var week = moment().year(year).month(month).startOf('month').week();
            var weeks = [];
            for (var i = 0; i < 6; i++) {
                weeks.push(buildWeek(year, week++));
            }
            return weeks;
        }

        function buildWeek(year, week) {
            // Set time to avoid timezone differences changing the selected date
            var date = moment().year(year).startOf('month').week(week).day(0).startOf('day');
            var days = [];
            for (var i = 0; i < 7; i++) {
                days.push({
                    date: date.toDate(), // Convert to native JS date object
                    activity: null
                });
                date.add(1, 'days');
            }
            return days;
        }

        function getFirstCalendarDate() {
            return vm.calendarView[0][0].date;
        }

        function getLastCalendarDate() {
            var lastWeek = vm.calendarView[vm.calendarView.length - 1];
            return lastWeek[lastWeek.length - 1].date;
        }

        function isToday(date) {
            return moment().isSame(date, 'day');
        }

        function isCurrentMonth(date) {
            return moment(vm.current).isSame(date, 'month');
        }

        function isCurrentPeriod(date) {
            return moment(date).isSameOrAfter(periodStart, 'day') && moment(date).isSameOrBefore(new Date(), 'day');
        }

        function isBeforePeriod(date) {
            return moment(date).isBefore(periodStart, 'day');
        }

        /*
        function isAfterPeriod(date) {
            return moment(date).isAfter(new Date(), 'day');
        }
        */

        function onNextMonth() {
            vm.current = moment(vm.current).add(1, 'months').toDate();
            buildCalendar();
        }

        function onPreviousMonth() {
            vm.current = moment(vm.current).subtract(1, 'months').toDate();
            buildCalendar();
        }

        function onSelect(day) {
            if (((!isCurrentPeriod(day.date) || vm.disabled) && day.activity === null) || angular.isUndefined(position))
                if (!vm.adminEditing)
                    return;

            var options = {};
            if (vm.adminEditing) {
                options = {
                    templateUrl: 'app/components/administrator/hours/manageActivity.view.html',
                    controller: 'ManageActivityController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    keyboard: false,
                    resolve: {
                        activity: function () {
                            // On creating new daily hours as admin, provide field
                            // to indicate that type as well as additional needed data
                            var activity = {};
                            if (day.activity) {
                                activity = angular.copy(day.activity);
                                activity.position = position;
                                activity.volunteer = {
                                    firstName: vm.targetUser.firstName,
                                    lastName: vm.targetUser.lastName,
                                    masterUserId: vm.targetUser.masterUserId
                                };
                                activity.organization = position.organization;
                            }
                            else {
                                activity = {
                                    type: 'Daily',
                                    date: day.date,
                                    position: position,
                                    volunteer: {
                                        firstName: vm.targetUser.firstName,
                                        lastName: vm.targetUser.lastName,
                                        masterUserId: vm.targetUser.masterUserId
                                    },
                                    organization: position.organization
                                };
                            }
                            return activity;
                        },
                        rejectOnly: function () {
                            return false;
                        }
                    }
                };
            }
            else {
                options = {
                    templateUrl: 'app/components/volunteer/activityCalendar/enterHours.view.html',
                    controller: 'EnterHoursController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    keyboard: false,
                    resolve: {
                        activity: function () {
                            var newActivity = {
                                type: 'Daily',
                                date: day.date
                            };
                            return day.activity !== null ? angular.copy(day.activity) : newActivity;
                        },
                        positionId: function () {
                            return position.id;
                        },
                        volunteerId: function () {
                            return vm.targetUser.masterUserId;
                        },
                        readOnly: function () {
                            return (vm.disabled || !isCurrentPeriod(day.date));
                        }
                    }
                };
            }

            $modal.open(options).result
                .catch(function (error) {
                    $scope.$emit('activity:alert', error);
                // Even if user does not submit, could have deleted documents
                })
                .finally(loadActivities);
        }

        function onSetPosition(pos) {
            position = pos;
            // Only go back in the calendar if the position is not "Active" (where hours can be entered)
            if (position && (position.serviceStatus === "Active")) {
                loadActivities();
            } else {
                loadRecentActivities();
            }
        }

        function loadRecentActivities() {
            if ((angular.isUndefined(position)) || (position === null)) {
                return;
            }

            // Similar setup to loadActivities()
            var getHours = vm.adminEditing ? authentication.getHoursAdmin : authentication.getHoursVol;
            var params = {
                volunteerOpportunityId: position.id,
            };
            if (vm.adminEditing) {
                params.onlyShowNonDeletedHours = true;
                params.masterUserId = vm.targetUser.masterUserId;
            }

            // Note: this assumes all hours are returned in this single call (and in chronological order)
            return getHours(params).then(function (response) {
                if (response.hours.length > 0) {
                    var mostRecentDate = moment(response.hours[0].dayOfService || response.hours[0].periodOfService);

                    // Removed because of "onlyShowNonDeletedHours" and that API returns most recent first
                    /*
                    var testIndex = 0;
                    // Find most recent entry that isn't deleted
                    while (response.hours[testIndex].volunteerHoursStatus === "Deleted") {
                        testIndex++;
                    }
                    var mostRecentDate = moment(response.hours[testIndex].dayOfService || response.hours[testIndex].periodOfService);

                    _.forEach(response.hours, function (hour) {
                        var curDate = moment(hour.dayOfService || hour.periodOfService);
                        if (curDate.isAfter(mostRecentDate, 'day')) {
                            mostRecentDate = curDate;
                        }
                    });
                    */

                    buildCalendar(mostRecentDate.year(), mostRecentDate.month());
                } else {
                    buildCalendar();
                }
            });
        }

        function loadActivities() {
            if ((angular.isUndefined(position)) || (position === null)) {
                return;
            }

            vm.isCalendarLoading = true;

            // Removed because it was clearing errors before they appeared
            //$scope.$emit('activity:alert', "");

            var params = {
                volunteerOpportunityId: position.id,
                startDate: getFirstCalendarDate().toISOString(),
                endDate: getLastCalendarDate().toISOString()
            };
            var getHours = authentication.getHoursVol;

            // If admin editing, get activities for others
            if (vm.adminEditing) {
                params.onlyShowNonDeletedHours = true;
                params.masterUserId = vm.targetUser.masterUserId;
                getHours = authentication.getHoursAdmin;
            }

            return getHours(params).then(function (response) {
                var activities = _.map(_.reject(response.hours, function (activity) {
                    return activity.volunteerHoursStatus === 'Deleted';
                }), function (activity) {
                    return {
                        type: activity.dayOfService ? 'Daily' : 'Period',
                        date: activity.dayOfService ? new moment(activity.dayOfService) : new moment(activity.periodOfService),
                        hours: activity.hours,
                        status: activity.volunteerHoursStatus,
                        reviewerNote: activity.reviewerNotes || "", // Make empty strings for compatibility in modals
                        volunteerNote: activity.userNotes || "",
                        id: activity.volunteerHoursId,
                        documents: activity.documents ? activity.documents : null,
                        createdByMasterUserId: activity.createdByMasterUserId
                    };
                });

                dailyActivities = _.sortBy(_.filter(activities, function (activity) {
                    return activity.type === 'Daily';
                }), ['date']);
                periodActivities = _.sortBy(_.filter(activities, function (activity) {
                    return activity.type === 'Period';
                }), ['date']);

                if (angular.isFunction(vm.onLoadActivities)) {
                    onLoadActivities();
                }
            }).then(function () {
                vm.calendarView.forEach(function (week) {
                    week.forEach(function (day) {
                        day.activity = _.find(dailyActivities, function (activity) {
                                return moment(activity.date).isSame(day.date, 'day');
                            }) || null;
                    });
                });
                vm.isCalendarLoading = false;
            }).catch(function (error) {
                $scope.$emit('activity:alert', error);
            });
        }

        function onReload() {
            buildCalendar();
            loadActivities();
        }

        function onLoadActivities() {
            var dailyActivitiesCopy = angular.copy(dailyActivities)
                .filter(function (activity) {
                    return moment(activity.date).month() === moment(vm.current).month();
                });
            var periodActivitiesCopy = angular.copy(periodActivities)
                .filter(function (activity) {
                    return moment(activity.date).month() === moment(vm.current).month();
                });
            vm.onLoadActivities({
                year: moment(vm.current).year(),
                month: moment(vm.current).month(),
                dailyActivities: dailyActivitiesCopy,
                periodActivities: periodActivitiesCopy
            });
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('vmis.activityCalendar')
        .controller('EnterHoursController', EnterHoursController);

    EnterHoursController.$inject = ['$modalInstance', '$timeout', '$modal', 'authentication', 'moment', 'activity', 'positionId', 'volunteerId', 'readOnly', 'config', 'utilsServices'];

    // This controller should only be accessed by volunteers, not admins
    function EnterHoursController($modalInstance, $timeout, $modal, authentication, moment, activity, positionId, volunteerId, readOnly, config, utilsServices) {
        var vm = this;

        vm.isModalLoading = true;
        vm.allowedFileTypesForUpload = null;
        vm.maxFileSizeInMegabytes = null;

        vm.activity = activity;
        // This modal is used for both daily and period hours
        vm.isDaily = vm.activity.type === 'Daily';
        vm.isDocumentUploading = false;
        vm.disableButton = true;
        vm.maxHours = vm.isDaily ? 24 : (moment(vm.activity.date).daysInMonth() * 8);
        vm.hrLabel = [];

        vm.title = "Enter ";
        if (vm.isDaily)
            vm.title += "Daily Hours - " + moment(vm.activity.date).format("D MMMM YYYY");
        else
            vm.title += "Period Hours - " + moment(vm.activity.date).format("MMMM YYYY");

        vm.hours = Math.floor(vm.activity.hours) || 0;
        vm.minutes = (vm.activity.hours - vm.hours) * 60 || 0;

        if (vm.hours === 0)
            vm.minLabel = [15, 30, 45];
        else if (vm.hours === 24)
            vm.minLabel = [0];
        else
            vm.minLabel = [0, 15, 30, 45];

        vm.status = vm.activity.status;
        vm.note = vm.activity.volunteerNote || '';
        vm.reviewerNote = vm.activity.reviewerNote || '';
        vm.certified = (vm.activity.status === 'Certified');
        vm.readOnly = readOnly || vm.certified;
        vm.positionId = positionId;
        vm.volunteerId = volunteerId;
        vm.hoursId = vm.activity.id || null; // Existence of hoursId is flag for editing existing activity
        vm.newUpload = false;

        vm.uploadedDocuments = vm.activity.documents ? vm.activity.documents : [];
        vm.maxDocumentsUploaded = vm.uploadedDocuments.length === 3;
        vm.selectedDocuments = [];

        // Only matters if activity is not new
        vm.submitterText = "";
        if (vm.hoursId) {
            if (vm.activity.createdByMasterUserId === vm.volunteerId)
                vm.submitterText += "Volunteer";
            else
                vm.submitterText += "Administrator";
        }

        vm.onChangeHours = onChangeHours;
        vm.onSelectDoc = onSelectDoc;
        vm.onDeleteUploadedDoc = onDeleteUploadedDoc;
        vm.onDeleteSelectedDoc = onDeleteSelectedDoc;
        vm.onSubmit = onSubmit;
        vm.isDeletable = isDeletable;
        vm.onClickDelete = onClickDelete;

        activate();

        function activate() {
            config.get().then(function (configData) {
                vm.allowedFileTypesForUpload = configData.allowedFileTypesForUpload;
                vm.maxFileSizeInMegabytes = configData.maxFileSizeInMegabytes;
            });
            for (var i = 0; i <= vm.maxHours; i++)
                vm.hrLabel.push(i);

            vm.isModalLoading = false;
        }

        function onChangeHours() {
            // If selected min hours in dropdown,
            // remove 0 and set minutes to something
            // because 0 hours, 0 minutes is not allowed
            if (vm.hours === 0) {
                vm.minLabel = [15, 30, 45];
                if (vm.minutes === 0)
                    vm.minutes = vm.minLabel[0];
            }
            else if (vm.hours === 24) {
                vm.minLabel = [0];
                if (vm.minutes !== 0)
                    vm.minutes = vm.minLabel[0];
            }
            // If left previous state,
            // fill back in that dropdown
            else if (vm.minLabel.length < 4) {
                vm.minLabel = [0, 15, 30, 45];
            }
        }

        function onSubmit() {
            vm.isModalLoading = true;

            var params = {
                volunteerOpportunityId: vm.positionId,
                hours: {
                    dateEntered: new Date().toISOString(),
                    hours: (vm.hours + (vm.minutes / 60)),
                    userNotes: vm.note
                }
            };

            var activityDate = moment(vm.activity.date).format("YYYY-MM-DD");
            if (vm.isDaily)
                params.hours.dayOfService = activityDate;
            else
                params.hours.periodOfService = activityDate;

            return authentication.setVolunteerHoursForOpportunity(params)
                .then(function (response) {
                    // If document to upload, do so!
                    if (vm.newUpload) {
                        vm.isDocumentUploading = true;
                        uploadDocuments(response.volunteerHoursId);
                    }
                    else {
                        $modalInstance.close("Activity submitted!");
                    }
                })
                .catch(function (error) {
                    $modalInstance.dismiss(utilsServices.parseErrorString(error));
                });
        }

        // Occurs after user clicks "Submit", so close when completed
        function uploadDocuments(hoursId) {
            var numUploadsDone = 0;
            angular.forEach(vm.selectedDocuments, function (document) {
                var uploadDocumentParams = {
                    theFile: document,
                    fileSuffix: document.name.split(".").pop(),
                    documentName: document.name, // TODO: Allow user to title the upload
                    volunteerHoursId: hoursId
                };

                // TODO: Ideally would like to not create function in a loop,
                // but no known way to pass in "document" and the response
                authentication.uploadHoursDocument(uploadDocumentParams)
                    .then(function (response) {
                        uploadHoursSuccess(response, document);
                    })
                    .catch(function (error) {
                        uploadHoursFailure(error, document);
                    });
            });

            function uploadHoursSuccess(response, document) {
                document.uploaded = true; // Show check mark

                if (++numUploadsDone === vm.selectedDocuments.length) {
                    // Delay slightly to show final check mark
                    $timeout(function () {
                        $modalInstance.close("Document successfully uploaded!");
                    }, 1000);
                }
            }

            function uploadHoursFailure(error, document) {
                if (++numUploadsDone === vm.selectedDocuments.length) {
                    $timeout(function () {
                        $modalInstance.dismiss("Document upload failed: " + utilsServices.parseErrorString(error));
                    }, 1000);
                }
            }
        }

        function onDeleteUploadedDoc(document) {
        
            $modal.open({
                templateUrl: 'app/components/volunteer/activityCalendar/deleteHoursDocument.view.html',
                controller: 'DeleteHoursDocumentController',
                controllerAs: 'vm',
                size: 'tiny',
                backdrop: 'static',
                keyboard: false,
                resolve: {
                    document: function () {
                        return document ? angular.copy(document) : {};
                    }
                }
            })
            .result
                .then(function(response) {
                    vm.uploadedDocuments.splice(vm.uploadedDocuments.indexOf(document), 1);
                    updateMaxDocumentsUploaded();
                })
                .catch(function (error) {
                $modalInstance.dismiss("Document delete failed: " + utilsServices.parseErrorString(error));
                });
                
        }

        function onDeleteSelectedDoc(document) {
            vm.selectedDocuments.splice(vm.selectedDocuments.indexOf(document), 1);
            updateMaxDocumentsUploaded();
        }

        // This function ensures that only 3 total documents are uploaded or selected to be uploaded at once
        function onSelectDoc(documents, errDocuments) {
            var numDocuments = documents.length + vm.selectedDocuments.length + vm.uploadedDocuments.length;
            if (errDocuments.length > 0) {
                vm.formError = "File size is larger than " + vm.maxFileSizeInMegabytes + ".";
                $('#hoursModal')[0].scrollIntoView();
                updateNewUpload();
                return;
            } else {
                vm.formError = "";
            }
            if (documents.length === 0) {
                // Update flag for whether new documents to upload were selected
                updateNewUpload();
                return;
            }
            else if (numDocuments > 3) {
                updateNewUpload();
                return;
            }
            else if (numDocuments === 3) {
                vm.maxDocumentsUploaded = true;
            }

            vm.selectedDocuments = vm.selectedDocuments.concat(documents);
            //vm.errDocuments = errDocuments && errDocuments[0];

            updateNewUpload();
        }

        function isDeletable() {
            return !vm.activity.flaggedForDelete &&
                (vm.activity.status === 'Submitted' ||
                    vm.activity.status === 'Rejected' ||
                    vm.activity.status === 'Resubmitted');
        }

        function onClickDelete() {
            $modal.open({
                templateUrl: 'app/components/volunteer/activityCalendar/deleteHours.view.html',
                controller: 'DeleteHoursController',
                controllerAs: 'vm',
                size: 'tiny',
                backdrop: 'static',
                keyboard: false,
                resolve: {
                    activity: function () {
                        return vm.activity;
                    },
                    adminEditing: function () {
                        return false;
                    }
                }
            }).result
                .then($modalInstance.close);
        }

        function updateMaxDocumentsUploaded() {
            vm.maxDocumentsUploaded = ((vm.selectedDocuments.length + vm.uploadedDocuments.length) === 3);
        }

        function updateNewUpload() {
            vm.newUpload = (vm.selectedDocuments.length > 0);
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('vmis.activityCalendar')
        .controller('DeleteHoursController', DeleteHoursController);

    DeleteHoursController.$inject = ['$modalInstance', 'authentication', 'activity', 'adminEditing'];

    function DeleteHoursController($modalInstance, authentication, activity, adminEditing) {
        var vm = this;

        vm.activity = activity;
        vm.adminEditing = adminEditing;

        vm.title = "Delete ";

        if (vm.activity.type === 'Daily')
            vm.title += "Daily Hours - " + moment(vm.activity.date).format("MMMM DD, YYYY");
        else
            vm.title += "Period Hours - " + moment(vm.activity.date).format("MMMM YYYY");

        vm.onClickDelete = onClickDelete;

        function onClickDelete() {
            vm.isWaiting = true;
            return authentication.deleteHours({
                hoursIds: [vm.activity.id],
                reviewerNotes: vm.adminEditing ? vm.activity.reviewerNote : undefined
            }).then($modalInstance.close).catch(function(error) {
                vm.formError = error;
            });
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('vmis.activityCalendar')
        .controller('DeleteHoursDocumentController', DeleteHoursDocumentController);

        DeleteHoursDocumentController.$inject = ['$modalInstance', 'authentication', 'document'];

    function DeleteHoursDocumentController($modalInstance, authentication, document) {
        var vm = this;

        vm.document = document;

        vm.onDeleteUploadedDoc = onClickDelete;

        function onClickDelete() {
            vm.processing = true;

            var params = {
                hoursDocumentId: vm.document.hoursDocumentId,
            };

            return authentication.deleteHoursDocument(params)
                .then($modalInstance.close)
                .catch($modalInstance.dismiss);

        }
    }
})();
(function () {
    'use strict';

    angular
        .module('vmis.volunteer')
        .controller('VolunteerApplicationsController', VolunteerApplicationsController);

    VolunteerApplicationsController.$inject = ['$state', 'authentication', 'loadStatus', '$scope'];

    function VolunteerApplicationsController($state, authentication, loadStatus, $scope) {
        var vm = this;

        vm.isLoading = true;

        vm.activities = [];
        vm.applicationId = -1;
        vm.sortReverse = true;
        vm.sortColumn = 'submittedDate';
        vm.statusTypes = [
            'All',
            'Submitted',
            'Approved',
            'Declined'
        ];
        vm.status = vm.statusTypes[0];
        vm.applications = [];
        vm.loadStatus = loadStatus.init();

        vm.onClickApplication = onClickApplication;
        vm.onChangeStatus = onChangeStatus;
        vm.onLoadMore = onLoadMore;
        vm.onLoadAll = onLoadAll;

        activate();

        function activate() {
            loadStatus.setup(vm.loadStatus, "applications")
                .then(function () {
                    loadApplications(vm.loadStatus.currentIndex, vm.loadStatus.defaultNumRows, vm.status);
                });
        }

        function loadApplications(index, num, status) {
            vm.isLoading = true;

            var params = {
                startingRowIndex: index,
                numberOfRows: num
            };
            if (status !== "All")
                params.volunteerApplicationStatus = status;

            authentication.getOpportunitiesAppliedFor(params)
                .then(function (response) {
                    getApplicationsSuccess(response, index, num);
                }).catch(function (error) {
                    getApplicationsError(error);
                });
        }

        function onClickApplication(application) {
            var params = {
                opportunityId: application.opportunityId,
                applicationId: application.applicationId,
                communityVolunteerOrganizationApplicationId: application.communityVolunteerOrganizationApplicationId
            };
            $state.go('vmis.volunteer.applications.details', params);
        }

        function onChangeStatus(status) {
            loadApplications(0, vm.loadStatus.defaultNumRows, status);
        }

        function getApplicationsSuccess(response, index, num) {
            if (index === 0) {
                vm.loadStatus.currentIndex = 0;
                vm.applications = [];
            }

            // Either set current index to max if all users loaded or increment by rows loaded
            vm.loadStatus.currentIndex = (vm.loadStatus.currentIndex + num > response.count) ? response.count : (vm.loadStatus.currentIndex + num);
            // Track total number of users not loaded for "Load All" button
            vm.loadStatus.numResultsNotLoaded = response.count - vm.loadStatus.currentIndex;
            // Set text for "Load More" button
            vm.loadStatus.nextResultLoadNum = (response.count === vm.loadStatus.currentIndex) ? 0 :
                (vm.loadStatus.numResultsNotLoaded > num) ? num : vm.loadStatus.numResultsNotLoaded;

            vm.applications = vm.applications.concat(response.opportunities);
            vm.isLoading = false;
        }

        function getApplicationsError(error) {
            if (angular.isDefined(error)) {
                var errorStr = error.error ? error.error : error;
                $scope.$emit('applications:alert', errorStr);
            }
            else
                $scope.$emit('applications:alert', "Failed to load list! Please try again.");

            vm.isLoading = false;
        }

        function onLoadMore() {
            loadApplications(vm.loadStatus.currentIndex, vm.loadStatus.nextResultLoadNum, vm.volunteerApplicationStatus);
        }

        function onLoadAll() {
            loadApplications(vm.loadStatus.currentIndex, vm.loadStatus.numResultsNotLoaded, vm.volunteerApplicationStatus);
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('vmis.volunteer')
        .controller('VolunteerApplicationDetailsController', VolunteerApplicationDetailsController);

    VolunteerApplicationDetailsController.$inject = ['$q', '$state', '$stateParams', '$modal', 'authentication'];

    function VolunteerApplicationDetailsController($q, $state, $stateParams, $modal, authentication) {
        var vm = this;

        vm.onDelete = onDelete;

        activate();

        function activate() {
            getApplicationDetails();
        }

        function getApplicationDetails() {
            var opportunityPromise;
            var applicationPromise;
            var params;
            var volunteerApplicationId;
            if ($stateParams.opportunityId) {
                volunteerApplicationId = parseInt($stateParams.applicationId);
                params = {
                    volunteerOpportunityId: parseInt($stateParams.opportunityId)
                };
                opportunityPromise = authentication.getOpportunityDetails(params);
                applicationPromise = authentication.getApplicationDetails({volunteerApplicationId: volunteerApplicationId});
            } else if ($stateParams.communityVolunteerOrganizationApplicationId) {
                params = {
                    startingRowIndex: 0,
                    numberOfRows: 1,
                    communityVolunteerOrganizationApplicationId: parseInt($stateParams.communityVolunteerOrganizationApplicationId)
                };
                opportunityPromise = authentication.getOpportunitiesAppliedFor(params);
                applicationPromise = authentication.getCommunityApplicationDetails({communityVolunteerOrganizationApplicationId: params.communityVolunteerOrganizationApplicationId});
            }

            return $q.all({
                positionDetails: opportunityPromise,
                userProfile: authentication.getUserProfile(),
                applicationDetails: applicationPromise
            })
                .then(function (result) {
                    if ($stateParams.opportunityId) {
                        vm.position = result.positionDetails;
                        vm.application = {
                            statusReason: result.applicationDetails.application.statusReason
                        };
                        vm.application.status = result.applicationDetails.application.status;
                        vm.isVolunteerSubmitted = vm.position.volunteerOrganization === 'Volunteer Submitted';
                    } else if ($stateParams.communityVolunteerOrganizationApplicationId) {
                        vm.position = result.positionDetails.opportunities[0];
                        vm.application = {
                            status: result.positionDetails.opportunities[0].status,
                            statusReason: result.positionDetails.opportunities[0].statusReason
                        };
                        vm.isVolunteerSubmitted = true;
                    }
                    vm.position.isBackgroundCheckRequired = vm.position.isBackgroundCheckRequired ? 'Yes' : 'No';
                    vm.position.supervisionConditionFlag = vm.position.supervisionConditionFlag ? 'Yes' : 'No';
                    vm.profile = result.userProfile;
                    vm.showRank = vm.profile.aosUser.dispositions.some(function (disposition) {
                        return disposition === 'Service Member';
                    });
                    vm.showCivilianRank = vm.profile.aosUser.dispositions.some(function (disposition) {
                        return disposition === 'DoD Civilian';
                    });
                });
        }

        function onDelete() {
            $modal.open({
                templateUrl: 'app/components/volunteer/applications/deleteApplicationConfirmation.view.html',
                controller: 'DeleteApplicationConfirmationController',
                controllerAs: 'vm',
                backdrop: 'static',
                keyboard: false,
                resolve: {
                    title: function () {
                        return vm.position.title;
                    }
                },
                size: 'tiny'
            }).result.then(function () {
                var params = {};

                if ($stateParams.applicationId) {
                    params.volunteerApplicationId = parseInt($stateParams.applicationId);
                } else if ($stateParams.communityVolunteerOrganizationApplicationId) {
                    params.communityVolunteerOrganizationApplicationId = parseInt($stateParams.communityVolunteerOrganizationApplicationId);
                }

                return authentication.deleteApplication(params);
            }).then(function () {
                $state.go('vmis.volunteer.applications', null, {reload: true});
            });
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('vmis.volunteer')
        .controller('DeleteApplicationConfirmationController', DeleteApplicationConfirmationController);

    DeleteApplicationConfirmationController.$inject = ['title'];

    function DeleteApplicationConfirmationController(title) {
        var vm = this;

        vm.title = title;
    }
})();
(function () {
    'use strict';

    angular
        .module('vmis.volunteer')
        .config(routes);

    routes.$inject = ['$stateProvider'];

    function routes($stateProvider) {
        $stateProvider
            .state('vmis.volunteer.avccLocator', {
                url: '/avcc-locator',
                title: 'AVCC Locator',
                views: {
                    "@vmis.volunteer": {
                        templateUrl: 'app/components/volunteer/avccLocator/avccLocator.view.html',
                        controller: 'AvccLocatorController',
                        controllerAs: 'vm'
                    },
                    "avccList@vmis.volunteer.avccLocator": {
                        templateUrl: 'app/components/volunteer/avccLocator/avccList/avccList.view.html',
                        controller: 'AvccListController',
                        controllerAs: 'vm'
                    }
                }
            });
    }
})();
(function () {
    'use strict';

    angular
        .module('vmis.volunteer')
        .controller('AvccLocatorController', AvccLocatorController);

    AvccLocatorController.$inject = ['_', '$q', '$scope', 'authentication'];

    function AvccLocatorController(_, $q, $scope, authentication) {
        var vm = this;

        vm.isLoading = true;

        vm.communities = [];
        vm.communityId = null;

        vm.onChangeCommunityId = onChangeCommunityId;

        $scope.$on('avccLocatorList:update', onListUpdate);

        activate();

        function activate() {
            $q.all({
                communities: getCommunities(),
                communityId: getDefaultCommunityId()
            }).then(function (responses) {
                vm.communities = responses.communities;
                if (responses.communityId) {
                    vm.communityId = responses.communityId;
                    onChangeCommunityId(vm.communityId);
                }
                else
                    vm.isLoading = false;
            });
        }

        function getDefaultCommunityId() {
            if (authentication.isLoggedIn()) {
                return authentication.getUserProfile()
                    .then(function (response) {
                        return response.aosUser.communityAffiliationId;
                    });
            } else {
                return null;
            }
        }

        function getCommunities() {
            return authentication.getCommunities({
                numberOfRows: 1,
                isArchived: false
            }).then(function (response) {
                return authentication.getCommunities({
                    numberOfRows: response.total,
                    isArchived: false
                });
            }).then(function (response) {
                return _.map(response.communityAffiliations, function (community) {
                    return {
                        id: community.communityAffiliationId,
                        name: community.communityAffiliationName
                    };
                });
            });
        }

        function onChangeCommunityId(communityId) {
            vm.isLoading = true;
            $scope.$broadcast('avccLocatorFilters:update', {
                communityId: communityId
            });
        }

        function onListUpdate(event) {
            event.stopPropagation();
            vm.isLoading = false;
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('vmis.volunteer')
        .controller('AvccListController', AvccListController);

    AvccListController.$inject = ['$q', '$scope', 'authentication', 'loadStatus'];

    function AvccListController($q, $scope, authentication, loadStatus) {
        var vm = this;

        vm.isLoading = true;

        vm.coordinators = [];
        vm.loadStatus = loadStatus.init();

        vm.onLoadMore = onLoadMore;
        vm.onLoadAll = onLoadAll;
        vm.sortColumn = "lastName";
        vm.sortReverse = false;

        // If not logged in, there will be no
        // filter update event to do this at start.
        if (!authentication.isLoggedIn())
            vm.isLoading = false;

        $scope.$on('avccLocatorFilters:update', onFiltersUpdate);

        activate();

        function activate() {
            loadStatus.setup(vm.loadStatus, "users");
        }

        function onFiltersUpdate(event, filters) {
            vm.coordinators = [];
            vm.isLoading = true;
            vm.currentCommunity = filters.communityId;

            // Reset load status object
            vm.loadStatus.currentIndex = 0;
            vm.loadStatus.nextResultLoadNum = vm.loadStatus.defaultNumRows;
            return getCoordinators(filters.communityId, vm.loadStatus.currentIndex, vm.loadStatus.nextResultLoadNum)
                .then(function (coordinators) {
                    vm.isLoading = false;
                    vm.coordinators = coordinators;
                    $scope.$emit('avccLocatorList:update');
                });
        }

        function getCoordinators(communityId, index, num) {
            return communityId ? authentication.getAvccsForCommunity({
                communityAffiliationId: communityId,
                startingRowIndex: index,
                numberOfRows: num
            }).then(function (response) {
                return getCoordinatorsSuccess(response, index, num);
            }).catch(function (error) {
                getCoordinatorsError(error);
            }) : $q.resolve([]);

        }

        function getCoordinatorsSuccess(response, index, num) {
            if (index === 0) {
                vm.loadStatus.currentIndex = 0;
            }

            for (var i = 0; i < response.avccs.length; i++) {
                // Create secret field for filtering on first and last name simultaneously
                response.avccs[i].fullName = response.avccs[i].firstName + " " + response.avccs[i].lastName;
                // Add user to full list
                vm.coordinators.push(response.avccs[i]);
            }

            // Either set current index to max if all users loaded or increment by rows loaded
            vm.loadStatus.currentIndex = (vm.loadStatus.currentIndex + num > response.count) ? response.count : (vm.loadStatus.currentIndex + num);
            // Track total number of users not loaded for "Load All" button
            vm.loadStatus.numResultsNotLoaded = response.count - vm.loadStatus.currentIndex;
            // Set text for "Load More" button
            vm.loadStatus.nextResultLoadNum = (response.count === vm.loadStatus.currentIndex) ? 0 :
                (vm.loadStatus.numResultsNotLoaded > num) ? num : vm.loadStatus.numResultsNotLoaded;

            vm.isLoading = false;
            return response.avccs;
        }

        function getCoordinatorsError(error) {
            if (angular.isDefined(error)) {
                var errorStr = error.error ? error.error : error;
                $scope.$emit('avccLocator:alert', errorStr);
            }
            else
                $scope.$emit('avccLocator:alert', "Failed to load list! Please try again.");

            vm.isLoading = false;
        }

        function onLoadMore() {
            getCoordinators(vm.currentCommunity, vm.loadStatus.currentIndex, vm.loadStatus.nextResultLoadNum);
        }

        function onLoadAll() {
            getCoordinators(vm.currentCommunity, vm.loadStatus.currentIndex, vm.loadStatus.numResultsNotLoaded);
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('vmis.volunteer')
        .controller('CreateNonAvcPositionController', CreateNonAvcPositionController);

    CreateNonAvcPositionController.$inject = ['$state', '$modal', '$q', '$anchorScroll', 'authentication'];

    function CreateNonAvcPositionController($state, $modal, $q, $anchorScroll, authentication) {
        var vm = this;

        vm.isLoading = true;

        var firstName;

        vm.dropDowns = {
            booleanOptions: [{
                label: 'No',
                value: false
            }, {
                label: 'Yes',
                value: true
            }]
        };
        vm.position = {
            backgroundCheckRequired: false
        };

        vm.onSubmit = onSubmit;
        vm.onChangeCountry = onChangeCountry;

        activate();

        function activate() {
            var promiseArray = [];
            promiseArray.push(authentication.getUserProfile()
                .then(function (response) {
                    vm.position.communityId = response.aosUser.communityAffiliationId;
                    firstName = response.aosUser.firstName;
                }));
            promiseArray.push(getDropDownData());

            return $q.all(promiseArray)
                .then(function (responses) {
                    vm.isLoading = false;
                })
                .catch(function (error) {
                    if (error)
                        vm.formError = "Error: " + error.error ? error.error : error;
                    vm.isLoading = false;
                });
        }

        function getDropDownData() {
            var elements = [
                'usstate',
                'stateabbrev',
                'country'
            ];

            return authentication.getUiData(elements).then(function (response) {
                vm.dropDowns.states = authentication.createStateList(response.usstate,response.stateabbrev);
                vm.dropDowns.countries = response.country;
            });
        }

        function confirm() {
            var options = {
                templateUrl: 'app/components/volunteer/opportunities/applicationConfirmation.template.html',
                controller: 'ApplicationConfirmationController',
                controllerAs: 'vm',
                backdrop: 'static',
                keyboard: false,
                resolve: {
                    name: function () {
                        return firstName;
                    },
                    positionTitle: function () {
                        return vm.position.title;
                    }
                },
                size: 'tiny'
            };

            return $modal.open(options).result.then(function () {
                $state.go('vmis.volunteer.applications', null, { reload: true });
                vm.isLoading = false;
            }, function () {
                $state.go('vmis.volunteer.applications', null, { reload: true });
                vm.isLoading = false;
            });
        }

        function setPosition() {
            if(angular.isDefined(vm.position.address.state) && vm.position.address.state !== null){
                var testString = vm.position.address.state.substring(vm.position.address.state.length-5);

                if(testString.substring(0,2) === ' (' && testString.substring(testString.length-1) === ')'){
                    vm.position.address.state = vm.position.address.state.substring(0,vm.position.address.state.length-5);
                }
            }

            var params = {
                communityAffiliationId: vm.position.communityId,
                title: vm.position.title,
                summary: vm.position.organizationName,
                isBackgroundCheckRequired: vm.position.backgroundCheckRequired,
                duties: vm.position.duties,
                qualifications: vm.position.qualifications,
                training: vm.position.training,
                orientation: vm.position.orientation,
                timeRequired: vm.position.timeRequired,
                opportunityApplicationComment: vm.position.comment,
                country: vm.position.address.country,
                address1: vm.position.address.line1,
                address2: vm.position.address.line2,
                city: vm.position.address.city,
                usState: vm.position.address.state,
                zipCode: vm.position.address.zipCode,
                firstLineSupervisorName: vm.position.supervisor.name,
                firstLineSupervisorEmail: vm.position.supervisor.email,
                firstLineSupervisorPhone: vm.position.supervisor.phone,
                role: 'AVC Volunteer'
            };
            return authentication.setOpportunity(params);
        }

        function onSubmit() {
            vm.isLoading = true;
            setPosition()
                .then(confirm)
                .catch(function (error) {
                    if (error)
                        vm.formError = "Error: " + error.error ? error.error : error;
                    vm.isLoading = false;
                })
                .finally(function () {
                    $anchorScroll('anchor-top');
                });
        }

        function onChangeCountry(country) {
            vm.isStateRequired = country === 'United States';
            if (!vm.isStateRequired)
                vm.position.address.state = undefined;
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('vmis.volunteer')
        .factory('opportunitiesService', opportunitiesService);

    opportunitiesService.$inject = ['$q', 'authentication'];

    function opportunitiesService($q, authentication) {
        return {
            isLoggedIn: isLoggedIn,
            getOpportunities: getOpportunities,
            getOpportunityDetails: getOpportunityDetails,
            applyForOpportunity: applyForOpportunity,
            getDropDownData: getDropDownData,
            getUserProfile: getUserProfile,
            setVolunteerProfile: setVolunteerProfile,
            getCurrentUser: getCurrentUser
        };

        function isLoggedIn() {
            return authentication.isLoggedIn();
        }

        function getOpportunities(startIndex, length, postalCode, state, country, community, organizationGroup, organization, title) {
            var request = {
                startingRowIndex: startIndex,
                numberOfRows: length
            };

            var isAdmin = false;
            var promiseArray = [];

            if (isLoggedIn()) {
                promiseArray.push(authentication.getUserProfile()
                    .then(function (response) {
                        if (response.aosUser && response.aosUser.vmisUser && response.aosUser.vmisUser.adminProfile)
                            isAdmin = !!response.aosUser.vmisUser.adminProfile;
                    })
                    .catch(function (error) {
                        return $q.reject(error);
                    }));
            }

            return $q.all(promiseArray)
                .then(function () {
                    if (isAdmin) request.volunteerPositionStatus = "Open, searchable";
                    if (postalCode) request.postalCode = postalCode;
                    if (title) request.title = title;
                    if (state) request.usstate = state;
                    if (country) request.country = country;
                    if (community) request.communityAffiliation = community;
                    if (organization) request.volunteerOrganizationId = organization;
                    if (organizationGroup) request.volunteerOrganizationGroup = organizationGroup;

                    return authentication
                        .getOpportunities(request)
                        .then(function (response) {
                            for (var i in response.opportunities) {
                                var opp = response.opportunities[i];
                                if (opp.usState !== undefined) {
                                    opp.region = opp.usState + ", " + opp.country;
                                }
                                else {
                                    opp.region = opp.country;
                                }
                                if(!opp.userHasApplied){
                                    opp.applicationStatus = "None";
                                }
                                else {
                                    opp.applicationStatus = opp.volunteerApplications[0].volunteerApplicationStatus;
                                }
                            }
                            return {
                                opportunities: response.opportunities,
                                count: response.count
                            };
                        })
                        .catch(function (error) {
                            return $q.reject(error);
                        });
                })
                .catch(function (error) {
                    return $q.reject(error);
                });
        }

        function getOpportunityDetails(id) {
            var request = {
                volunteerOpportunityId: id
            };

            return authentication
                .getOpportunityDetails(request)
                .then(function (response) {
                    return response;
                })
                .catch(function (error) {
                    return $q.reject(error);
                });
        }

        function applyForOpportunity(id) {
            var request = {
                volunteerOpportunityId: id
            };

            return authentication
                .applyForOpportunity(request)
                .then(function (response) {
                    return response;
                });
        }

        function getDropDownData(dropDowns) {
            return authentication
                .getUiData(dropDowns)
                .then(function (response) {
                    return response;
                })
                .catch(function (error) {
                    return $q.reject(error);
                });
        }
        
        function getCommunities() {
            return authentication.
            getCommunities({getAll:true})
                .then(function (response){
                    return response;
                })
                .catch(function(error){
                    return $q.reject(error);
                });
        }

        function getUserProfile() {
            return authentication
                .getUserProfile()
                .then(function (response) {
                    return response;
                })
                .catch(function (error) {
                    return $q.reject(error);
                });
        }

        function setVolunteerProfile(profile) {
            var request = {
                vmisUser: {
                    volunteerProfile: profile
                }
            };

            return authentication
                .setUserProfile(request)
                .then(function (response) {
                    return response;
                })
                .catch(function (error) {
                    return $q.reject(error);
                });
        }
        
        function getCurrentUser() {
            return authentication.currentUser().email;
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('vmis.volunteer')
        .controller('ApplicationConfirmationController', ApplicationConfirmationController);

    ApplicationConfirmationController.$inject = ['$modalInstance', 'name', 'positionTitle'];

    function ApplicationConfirmationController($modalInstance, name, positionTitle) {
        var vm = this;

        vm.name = name;
        vm.positionTitle = positionTitle;

        vm.onOk = onOk;
        vm.onDismiss = onDismiss;

        activate();

        function activate() {
        }

        function onOk() {
            $modalInstance.close();
        }

        function onDismiss() {
            $modalInstance.dismiss();
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('vmis.volunteer')
        .controller('OpportunitiesController', OpportunitiesController);

    OpportunitiesController.$inject = ['$modal', 'opportunitiesService', 'loadStatus', 'config', '$scope', '$timeout'];

    function OpportunitiesController($modal, opportunitiesService, loadStatus, config, $scope, $timeout) {
        var vm = this;

        vm.isLoading = true;

        vm.opportunities = [];
        vm.sortReverse = true;
        vm.sortColumn = 'postedDate';
        vm.title = '';
        vm.filters = {};
        vm.alerts = [];

        vm.loadStatus = loadStatus.init();

        vm.onFiltersClick = onFiltersClick;
        vm.onClickSearch = onClickSearch;
        vm.onSelect = onSelect;
        vm.onLoadMore = onLoadMore;
        vm.onLoadAll = onLoadAll;
        vm.onCloseAlert = onCloseAlert;

        $scope.$on('opportunities:alert', alertHandler);

        activate();

        function activate() {
            vm.isLoggedIn = opportunitiesService.isLoggedIn();

            loadStatus.setup(vm.loadStatus, "opportunities")
                .then(function () {
                    // If user is logged in, filter the Opportunities page based on their home community.
                    // (This was recommended by Gary Ducharme of Three Wire Systems.)
                    if (vm.isLoggedIn) {
                        opportunitiesService.getUserProfile().then(function (response) {
                            // Note: when filter is selected from modal, more data is present than these fields.
                            // Filter modal setup fills in remaining information if opened.
                            // See opportunitiesFilter.controller.js:99
                            vm.filters.community = {
                                "communityAffiliationId": response.aosUser.communityAffiliationId,
                                "communityAffiliationName": response.aosUser.communityAffiliation
                            };
                            // Matches line ~129
                            vm.selectedCommunity = vm.filters.community.communityAffiliationName;

                            loadOpportunities(vm.loadStatus.currentIndex, vm.loadStatus.defaultNumRows,
                                undefined, undefined, undefined, vm.selectedCommunity,
                                undefined, undefined, undefined);
                        }).catch(function (error) {
                            console.error(error);
                        });
                    } else {
                        // Otherwise, load opportunities normally
                        loadOpportunities(vm.loadStatus.currentIndex, vm.loadStatus.defaultNumRows);
                    }
                });
        }

        function loadOpportunities(index, num, postalCode, state, country, community, organizationGroup, organization, title) {
            vm.isLoading = true;

            opportunitiesService
                .getOpportunities(index, num, postalCode, state, country, community, organizationGroup, organization, title)
                .then(function (result) {
                    // TODO: communityAffiliationId, usStateId, countryId replace
                    // communityAffiliation, usState, country - table columns empty
                    getOpportunitiesSuccess(result, index, num);
                }).catch(function (error) {
                    getOpportunitiesError(error);
                });
        }

        function onSelect(opportunity) {
            openModal(opportunity.volunteerOpportunityId);
        }

        function openModal(id) {
            $modal.open({
                templateUrl: 'app/components/volunteer/opportunities/opportunityDetails.template.html',
                controller: 'OpportunityDetailsController',
                controllerAs: 'vm',
                backdrop: 'static',
                keyboard: false,
                resolve: {
                    params: function () {
                        return {
                            opportunityId: id
                        };
                    }
                }
            });

            // modalInstance.result
            // To Do: add error catching

        }

        function onClickSearch() {
            vm.loadStatus.currentIndex = 0;
            return loadOpportunities(vm.loadStatus.currentIndex, vm.loadStatus.defaultNumRows,
                vm.filters.postalCode, vm.filters.state, vm.filters.country,
                vm.selectedCommunity, vm.filters.organizationGroup, vm.selectedOrganization, vm.title);
        }

        function onFiltersClick() {
            var modalInstance = $modal.open({
                templateUrl: 'app/components/volunteer/opportunities/opportunitiesFilter.template.html',
                controller: 'OpportunitiesFilterController',
                controllerAs: 'vm',
                backdrop: 'static',
                keyboard: false,
                resolve: {
                    filters: function () {
                        return vm.filters;
                    }
                }
            });

            modalInstance.result
                .then(function (filters) {
                    vm.filters = filters;

                    // These set to undefined in opportunities filter if not selected,
                    // which is copied out into the vm.filters object above.
                    // (The vm.filters fields for comm and org are not used?)
                    if (angular.isDefined(filters.community) &&
                        angular.isDefined(filters.community.communityAffiliationName)) {
                        vm.selectedCommunity = filters.community.communityAffiliationName;
                    }
                    else {
                        vm.selectedCommunity = undefined;
                    }
                    if (angular.isDefined(filters.organization) &&
                        angular.isDefined(filters.organization.volunteerOrganizationId)) {
                        vm.selectedOrganization = filters.organization.volunteerOrganizationId;
                    }
                    else {
                        vm.selectedOrganization = undefined;
                    }

                    if(angular.isDefined(filters.state)){
                        filters.state = filters.state.substring(0,filters.state.length-5);
                    }
                    else {
                        filters.state = undefined;
                    }

                    vm.loadStatus.currentIndex = 0;
                    loadOpportunities(vm.loadStatus.currentIndex, vm.loadStatus.defaultNumRows,
                        filters.postalCode, filters.state, filters.country,
                        vm.selectedCommunity, filters.organizationGroup, vm.selectedOrganization, vm.title);
                }, function (error) {
                    if (angular.isDefined(error)) {
                        var errorStr = error.error ? error.error : error;
                        $scope.$emit('opportunities:alert', errorStr);
                    }

                    vm.isLoading = false;
                });
        }

        function getOpportunitiesSuccess(response, index, num) {
            if (index === 0) {
                vm.loadStatus.currentIndex = 0;
                vm.opportunities = [];
            }

            // Either set current index to max if all users loaded or increment by rows loaded
            vm.loadStatus.currentIndex = (vm.loadStatus.currentIndex + num > response.count) ? response.count : (vm.loadStatus.currentIndex + num);
            // Track total number of users not loaded for "Load All" button
            vm.loadStatus.numResultsNotLoaded = response.count - vm.loadStatus.currentIndex;
            // Set text for "Load More" button
            vm.loadStatus.nextResultLoadNum = (response.count === vm.loadStatus.currentIndex) ? 0 :
                (vm.loadStatus.numResultsNotLoaded > num) ? num : vm.loadStatus.numResultsNotLoaded;

            vm.opportunities = vm.opportunities.concat(response.opportunities);
            $timeout(function () {
                vm.isLoading = false;
            }, 100);
        }

        function getOpportunitiesError(error) {
            if (angular.isDefined(error)) {
                var errorStr = error.error ? error.error : error;
                $scope.$emit('opportunities:alert', errorStr);
            }
            else
                $scope.$emit('opportunities:alert', "Failed to load list! Please try again.");

            $timeout(function () {
                vm.isLoading = false;
            }, 100);
        }

        function onLoadMore() {
            loadOpportunities(vm.loadStatus.currentIndex, vm.loadStatus.nextResultLoadNum,
                vm.filters.postalCode, vm.filters.state, vm.filters.country,
                vm.selectedCommunity, vm.filters.organizationGroup, vm.selectedOrganization, vm.title);
        }
        function onLoadAll() {
            loadOpportunities(vm.loadStatus.currentIndex, vm.loadStatus.numResultsNotLoaded,
                vm.filters.postalCode, vm.filters.state, vm.filters.country,
                vm.selectedCommunity, vm.filters.organizationGroup, vm.selectedOrganization, vm.title);
        }

        function alertHandler(event, message) {
            event.stopPropagation();

            displayError(message);
        }

        function onCloseAlert(index) {
            vm.alerts.splice(index, 1);
        }

        function displayAlert(type, message) {
            vm.alerts.push({
                type: type,
                message: message
            });
        }

        function displayError(error) {
            if (error === 'cancel' || error === 'backdrop click')
                return;
            if (error)
                displayAlert('alert', error);
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('vmis.volunteer')
        .controller('ApplyController', ApplyController);

    ApplyController.$inject = ['$state', '$stateParams', '$modal', '$timeout', 'opportunitiesService'];

    function ApplyController($state, $stateParams, $modal, $timeout, opportunitiesService) {
        var vm = this;
        vm.isLoading = true;

        var dropDowns = [
            'preferredcontactmethod'
        ];

        vm.opportunityId = $stateParams.opportunityId;
        vm.alerts = [];

        // Variables for tracking the loading of the page's data
        // for setting vm.isLoading to false.
        var numSetupPromises = 3; // For the 3 activate() functions
        var curNumPromises = 0;

        vm.onSubmit = onSubmit;
        vm.onCloseAlert = onCloseAlert;

        activate();

        function activate() {
            fillDropDowns();
            getOpportunityDetails();
            getProfileInformation();
        }

        function tallyPromise() {
            if (++curNumPromises === numSetupPromises)
                vm.isLoading = false;
        }

        function fillDropDowns() {
            opportunitiesService
                .getDropDownData(dropDowns)
                .then(function (result) {
                    dropDowns.forEach(function (element) {
                        vm[element] = result[element];
                    });
                    tallyPromise();
                });
        }

        function getOpportunityDetails() {
            opportunitiesService
                .getOpportunityDetails(vm.opportunityId)
                .then(function (result) {
                    vm.position = {
                        title: result.title,
                        organization: result.volunteerOrganization,
                        community: result.communityAffiliation,
                        backgroundCheckRequired: result.isBackgroundCheckRequired ? 'Yes' : 'No'
                    };
                    tallyPromise();
                });

        }

        function getProfileInformation() {
            opportunitiesService
                .getUserProfile()
                .then(function (response) {
                    var aosUser = response.aosUser;
                    if (aosUser !== null) {
                        vm.aosProfile = {
                            firstName: aosUser.firstName,
                            lastName: aosUser.lastName,
                            community: aosUser.communityAffiliation
                        };
                        if (aosUser.vmisUser !== null) {
                            var volunteerProfile = aosUser.vmisUser.volunteerProfile;
                            vm.volunteerProfile = {
                                preferredContactMethod: volunteerProfile.preferredContactMethod,
                                volunteerEmail: volunteerProfile.volunteerEmail,
                                primaryPhone: volunteerProfile.primaryPhone,
                                secondaryPhone: volunteerProfile.secondaryPhone || '',
                                workExperience: volunteerProfile.workExperience || '',
                                volunteerExperience: volunteerProfile.volunteerExperience || '',
                                specialSIH: volunteerProfile.specialSIH || ''
                            };
                        } else {
                            vm.volunteerProfile = {
                                volunteerEmail: response.masterUserEmail,
                                secondaryPhone: '',
                                workExperience: '',
                                volunteerExperience: '',
                                specialSIH: ''
                            };
                        }
                    }
                    tallyPromise();
                });
        }

        function onSubmit() {
            vm.isLoading = true;
            return setVolunteerProfile()
                .then(applyForOpportunity)
                .catch(function (error) {
                    displayError(error);
                    vm.isLoading = false;
                })
                .then(confirmApplication)
                .catch(function (error) {
                    displayError(error);
                    vm.isLoading = false;
                });
        }

        function setVolunteerProfile() {
            return opportunitiesService.setVolunteerProfile(vm.volunteerProfile);
        }

        function applyForOpportunity() {
            return opportunitiesService.applyForOpportunity(vm.opportunityId);
        }

        function confirmApplication() {
            if (vm.isLoading) {
                var modalInstance = $modal.open({
                    templateUrl: 'app/components/volunteer/opportunities/applicationConfirmation.template.html',
                    controller: 'ApplicationConfirmationController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    keyboard: false,
                    
                    resolve: {
                        name: function () {
                            return vm.aosProfile.firstName;
                        },
                        positionTitle: function () {
                            return vm.position.title;
                        }
                    },
                    size: 'tiny'
                });

                modalInstance.result
                    .then(function () {
                        redirectAfterApply();
                    }, function () {
                        redirectAfterApply();
                    });
            }

            // Whether the resulting modal after applying is exited with "OK", "X", or Escape,
            // redirect back to the opportunities page. Delay that process slightly to prevent console errors.
            function redirectAfterApply()
            {
                return $timeout(function () {
                    $state.go('^', null, {reload: true});
                    vm.isLoading = false;
                }, 100);
            }
        }

        function successHandler(event, message) {
            event.stopPropagation();

            displayAlert('success', message);
        }

        function onCloseAlert(index) {
            vm.alerts.splice(index, 1);
        }

        function displayAlert(type, message) {
            vm.alerts.push({
                type: type,
                message: message
            });
        }

        function displayError(error) {
            if (error === 'cancel' || error === 'ok' || error === 'backdrop click')
                return;
            if (error)
                displayAlert('alert', error);
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('vmis.volunteer')
        .controller('OpportunityDetailsController', OpportunityDetailsController);

    OpportunityDetailsController.$inject = ['$q', 'params', '$modalInstance', '$state', '$window', 'opportunitiesService', 'authentication'];

    function OpportunityDetailsController($q, params, $modalInstance, $state, $window, opportunitiesService, authentication) {
        var vm = this;

        vm.opportunityId = params.opportunityId;
        vm.onSubmit = onSubmit;
        vm.closeModal = closeModal;
        vm.onPrint = onPrint;

        activate();

        function activate() {
            getOpportunityDetails();
        }

        function getOpportunityDetails() {
            return $q.all({
                details: opportunitiesService.getOpportunityDetails(vm.opportunityId),
                opocs: authentication.getOpocsForOpportunity({volunteerOpportunityId: vm.opportunityId})
            })
                .then(function (results) {
                    vm.details = results.details;
                    vm.details.isBackgroundCheckRequired = vm.details.isBackgroundCheckRequired ? 'Yes' : 'No';
                    vm.details.supervisionConditionFlag = vm.details.supervisionConditionFlag ? 'Yes' : 'No';

                    vm.opocs = results.opocs.opocs;
                });
        }

        function onSubmit() {
            //$modalInstance.close(); // This was causing a console error: "TypeError: Cannot read property 'value' of undefined"
            if (opportunitiesService.isLoggedIn()) {
                $state.go('vmis.volunteer.opportunities.apply', {opportunityId: vm.opportunityId});
            }
            else {
                authentication.setRedirect('vmis.volunteer.opportunities.apply', {opportunityId: vm.opportunityId});
                $state.go('vmis.logIn');
            }
        }

        function onPrint() {
            var printHref = $state.href("print.position", { id: vm.opportunityId }, {absolute: true});
            $window.open(printHref.replace("#", "print.html#"), "Print");
        }
        
        function closeModal() {
            $modalInstance.close();
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('vmis.volunteer')
        .controller('OpportunitiesFilterController', OpportunitiesFilterController);

    OpportunitiesFilterController.$inject = ['$modalInstance', 'authentication', 'filters'];

    function OpportunitiesFilterController($modalInstance, authentication, filters) {
        var vm = this;

        vm.isLoading = true;

        var dropDowns = [
            'volunteerorganizationgroup',
            'usstate',
            'stateabbrev',
            'country'
        ];

        vm.filters = angular.copy(filters);

        vm.communities = [];
        vm.dropDowns = {
            organizationGroups: [
                "All"
            ],
            states: [
                "All"
            ],
            countries: [
                "All"
            ]
        };

        vm.onSubmit = onSubmit;
        vm.onCancel = onCancel;
        vm.disableOrgDropDown = disableOrgDropDown;
        vm.onSelectCommunity = onSelectCommunity;
        vm.onSelectCountry = onSelectCountry;
        
        activate();
        
        function activate() {
            fillDropDowns(dropDowns);
            onSelectCountry(vm.filters.country);
        }

        function fillDropDowns(dropDowns) {
            vm.isLoading = true;
            authentication
                .getUiData(dropDowns)
                .then(function (response) {
                    response.volunteerorganizationgroup.forEach(function (orgGroup) {
                        vm.dropDowns.organizationGroups.push(orgGroup);
                    });
                    vm.dropDowns.states = vm.dropDowns.states.concat(authentication.createStateList(response.usstate,response.stateabbrev));
                    response.country.forEach(function (country) {
                        vm.dropDowns.countries.push(country);
                    });
                    if (!angular.isDefined(vm.filters.organizationGroup))
                        vm.filters.organizationGroup = vm.dropDowns.organizationGroups[0];
                    if (!angular.isDefined(vm.filters.state))
                        vm.filters.state = vm.dropDowns.states[0];
                    if (!angular.isDefined(vm.filters.country))
                        vm.filters.country = vm.dropDowns.countries[0];

                    authentication.getCommunities(
                        {
                            getAll: true,
                            isArchived: false
                        })
                        .then(function(comms) {
                            comms.communityAffiliations.forEach(function (comm) {
                                comm.organizations = [{
                                    organizationName: "All"
                                    //volunteerOrganizationId: -1
                                }];
                                vm.communities.push(comm);
                            });
                            // Use lack of ID as cue for this entry
                            vm.communities.unshift({
                                communityAffiliationName: "All",
                                //communityAffiliationId: -1
                                organizations: [{
                                    organizationName: "All"
                                    //volunteerOrganizationId: -1
                                }]
                            });

                            // If existing filter, set to those selections
                            if (angular.isDefined(vm.filters.community) &&
                                angular.isDefined(vm.filters.community.communityAffiliationId)) {
                                var foundComm = false;
                                for (var i = 0; i < vm.communities.length; i++) {
                                    if (vm.communities[i].communityAffiliationName === vm.filters.community.communityAffiliationName) {
                                        vm.filters.community = vm.communities[i];
                                        foundComm = true;
                                        break;
                                    }
                                }

                                if (!foundComm) {
                                    vm.formError = "Could not find selected filter community: " + vm.filters.community.communityAffiliationName;
                                    vm.isLoading = false;
                                }
                                else {
                                    if (angular.isDefined(vm.filters.organization) &&
                                        angular.isDefined(vm.filters.organization.volunteerOrganizationId)) {
                                        getOrgs(vm.filters.community.communityAffiliationId).then(function (orgs) {
                                            orgs.organizations.forEach(function (org) {
                                                // Populate organization list
                                                vm.filters.community.organizations.push(org);

                                                // Check if selected org
                                                if (org.organizationName === vm.filters.organization.organizationName) {
                                                    vm.filters.organization = org;
                                                }
                                            });

                                            vm.isLoading = false;
                                        }).catch(function (error) {
                                            vm.formError = error;
                                            vm.filters.organization = vm.filters.community.organizations[0];

                                            vm.isLoading = false;
                                        });
                                    }
                                    else {
                                        onSelectCommunity(); // Fill in organizations and select first one ("All")
                                        vm.isLoading = false;
                                    }
                                }
                            }
                            else {
                                vm.filters.community = vm.communities[0];
                                vm.filters.organization = vm.filters.community.organizations[0];

                                vm.isLoading = false;
                            }
                        });
                })
                .catch(function (error) {
                    vm.formError = error;
                });
        }

        function disableOrgDropDown() {
            return vm.isLoading || !angular.isDefined(vm.filters.community) || !angular.isDefined(vm.filters.community.communityAffiliationId);
        }
        
        function onSelectCountry(country) {
            vm.isStateDisabled = country !== 'United States';
            if (vm.isStateDisabled)
                vm.filters.state = vm.dropDowns.states[0];
        }
        
        function onSubmit() {
            if (!angular.isDefined(vm.filters.community.communityAffiliationId))
                vm.filters.community = undefined;
            if (vm.filters.organizationGroup === "All")
                vm.filters.organizationGroup = undefined;
            if (!angular.isDefined(vm.filters.organization.volunteerOrganizationId))
                vm.filters.organization = undefined;
            if (vm.filters.country === "All")
                vm.filters.country = undefined;
            if (vm.filters.state === "All")
                vm.filters.state = undefined;

            $modalInstance.close(vm.filters);
        }

        function onCancel() {
            $modalInstance.dismiss('cancel');
        }

        function onSelectCommunity() {
            if (angular.isDefined(vm.filters.community.communityAffiliationId)) {
                if (vm.filters.community.organizations.length === 1) {
                    getOrgs(vm.filters.community.communityAffiliationId)
                        .then(function (orgs) {
                            orgs.organizations.forEach(function (org) {
                                vm.filters.community.organizations.push(org);
                            });
                            vm.filters.organization = vm.filters.community.organizations[0];
                        });
                }
                else
                    vm.filters.organization = vm.filters.community.organizations[0];
            }
            else
                vm.filters.organization = vm.filters.community.organizations[0];
        }

        function getOrgs(commId) {
            return authentication.getOrganizations({
                communityAffiliationId: commId,
                getAll: true
            });
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('vmis.volunteer')
        .config(routes);

    routes.$inject = ['$stateProvider'];

    function routes($stateProvider) {
        $stateProvider
            .state('vmis.volunteer.records', {
                url: '/records',
                title: 'Records',
                views: {
                    "@vmis.volunteer": {
                        templateUrl: 'app/components/volunteer/records/records.view.html',
                        controller: 'RecordsController',
                        controllerAs: 'vm'
                    },
                    "awards@vmis.volunteer.records": {
                        templateUrl: 'app/components/volunteer/records/awards/view.html',
                        controller: 'AwardsController',
                        controllerAs: 'vm'
                    },
                    "trainings@vmis.volunteer.records": {
                        templateUrl: 'app/components/volunteer/records/trainings/view.html',
                        controller: 'TrainingsController',
                        controllerAs: 'vm'
                    },
                    "orientations@vmis.volunteer.records": {
                        templateUrl: 'app/components/volunteer/records/orientations/view.html',
                        controller: 'OrientationsController',
                        controllerAs: 'vm'
                    },
                    "backgroundChecks@vmis.volunteer.records": {
                        templateUrl: 'app/components/volunteer/records/backgroundChecks/view.html',
                        controller: 'BackgroundChecksController',
                        controllerAs: 'vm'
                    },
                    "documents@vmis.volunteer.records": {
                        templateUrl: 'app/components/volunteer/records/documents/view.html',
                        controller: 'DocumentsController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    adminInfo: function () {
                        return {};
                    }
                }
            })
            .state('vmis.volunteer.recordsEdit', {
                url: '/records/{id}',
                title: 'Records',
                views: {
                    "@vmis.volunteer": {
                        templateUrl: 'app/components/volunteer/records/records.view.html',
                        controller: 'RecordsController',
                        controllerAs: 'vm'
                    },
                    "awards@vmis.volunteer.recordsEdit": {
                        templateUrl: 'app/components/volunteer/records/awards/view.html',
                        controller: 'AwardsController',
                        controllerAs: 'vm'
                    },
                    "trainings@vmis.volunteer.recordsEdit": {
                        templateUrl: 'app/components/volunteer/records/trainings/view.html',
                        controller: 'TrainingsController',
                        controllerAs: 'vm'
                    },
                    "orientations@vmis.volunteer.recordsEdit": {
                        templateUrl: 'app/components/volunteer/records/orientations/view.html',
                        controller: 'OrientationsController',
                        controllerAs: 'vm'
                    },
                    "notes@vmis.volunteer.recordsEdit": {
                        templateUrl: 'app/components/volunteer/records/notes/view.html',
                        controller: 'NotesController',
                        controllerAs: 'vm'
                    },
                    "backgroundChecks@vmis.volunteer.recordsEdit": {
                        templateUrl: 'app/components/volunteer/records/backgroundChecks/view.html',
                        controller: 'BackgroundChecksController',
                        controllerAs: 'vm'
                    },
                    "documents@vmis.volunteer.recordsEdit": {
                        templateUrl: 'app/components/volunteer/records/documents/view.html',
                        controller: 'DocumentsController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    adminInfo: ['$stateParams', 'authentication', function ($stateParams, authentication) {
                        // If URL has an ID in it, admin editing
                        var masterUserId = parseInt($stateParams.id) || null;
                        if (angular.isNumber(masterUserId)) {
                            // ...Unless editing own profile
                            return authentication.getUserProfile()
                                .then(function (response) {
                                    // Return current user's info for some sections of this page
                                    if (masterUserId !== response.masterUserId)
                                        return {
                                            adminMasterUserId: response.masterUserId,
                                            adminFullName: response.aosUser.firstName + " " + response.aosUser.lastName,
                                            adminEmail: response.masterUserEmail,
                                            adminRoles: response.aosUser.vmisRoles
                                        };
                                    else
                                        return {};
                                })
                                .catch(function () {
                                    return {};
                                });
                        }
                        // Otherwise not admin editing
                        else
                            return {};
                    }]
                }
            });
    }
})();
(function () {
    'use strict';

    angular
        .module('vmis.volunteer')
        .controller('RecordsController', RecordsController);

    RecordsController.$inject = ['$scope', '$stateParams', 'authentication', 'adminInfo'];

    function RecordsController($scope, $stateParams, authentication, adminInfo) {
        var vm = this;

        vm.isLoading = true;

        vm.masterUserId = parseInt($stateParams.id) || null;
        // Use existence of adminMasterUserId (not undefined) as the official check
        // of whether admin is editing another user
        vm.adminEditing = angular.isNumber(adminInfo.adminMasterUserId);

        vm.alerts = [];

        vm.onCloseAlert = onCloseAlert;

        $scope.$on('records:success', successHandler);
        $scope.$on('records:alert', alertHandler);

        activate();

        function activate() {
            if (vm.adminEditing)
                getUserProfile(vm.masterUserId);
            else
                vm.isLoading = false;
        }

        function getUserProfile(id) {
            var params = null;
            if (angular.isNumber(id)) {
                params = {
                    masterUserId: id
                };
            }

            return authentication.getUserProfile(params)
                .then(function (response) {
                    if (!response.masterUserId) {
                        displayError("Could not retrieve user!");
                        vm.isLoading = false;
                        return;
                    }
                    if (!response.aosUser) {
                        vm.fullName = "Unknown User";
                    } else {
                        vm.fullName = response.aosUser.firstName + " " + response.aosUser.lastName;
                    }
                    vm.isLoading = false;
                })
                .catch(function (error) {
                    displayError(error);
                    vm.isLoading = false;
                });
        }

        function successHandler(event, message) {
            event.stopPropagation();

            displayAlert('success', message);
        }

        function alertHandler(event, message) {
            event.stopPropagation();

            displayError(message);
        }

        function onCloseAlert(index) {
            vm.alerts.splice(index, 1);
        }

        function displayAlert(type, message) {
            vm.alerts.push({
                type: type,
                message: message
            });
        }

        function displayError(error) {
            if (error === 'cancel' || error === 'ok' || error === 'backdrop click')
                return;
            if (error)
                displayAlert('alert', error);
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('vmis.volunteer')
        .controller('AwardsController', AwardsController);

    AwardsController.$inject = ['$scope', '$modal', '$stateParams', 'authentication', 'adminInfo', 'moment'];

    function AwardsController($scope, $modal, $stateParams, authentication, adminInfo, moment) {
        var vm = this;

        vm.isLoading = true;
        vm.sortColumn = 'date';
        vm.sortReverse = true;

        var index = 0;
        var limit = 100;

        vm.awards = [];
        vm.masterUserId = parseInt($stateParams.id) || null;
        // Use existence of adminMasterUserId (not undefined) as the official check
        // of whether admin is editing another user
        vm.adminEditing = angular.isNumber(adminInfo.adminMasterUserId);

        vm.onClickDetails = onClickDetails;
        vm.onClickAddAward = onClickAddAward;
        vm.canUserEditAward = canUserEditAward;

        activate();

        function activate() {
            refreshAwards();
        }

        function getAwards(id) {
            vm.isLoading = true;

            var params = {
                startingRowIndex: index,
                numberOfRows: limit
            };

            if (angular.isNumber(id)) {
                params.masterUserId = id;
            }

            return authentication.getVolunteerAwards(params)
                .then(function (response) {
                    vm.awards = response.result.map(function (award) {
                        return {
                            id: award.volunteerAwardId,
                            date: moment(award.awardDate, 'YYYY-MM-DD').toDate(),
                            name: award.awardName,
                            certified: award.isCertified,
                            description: award.awardDetails,
                            // Note: API currently designed for 1 attachment
                            attachments: award.atoAttachmentId ?
                                [{
                                    id: award.atoAttachmentId,
                                    url: award.fileUrl,
                                    name: award.documentName,
                                    description: award.documentDescription
                                }] : []
                        };
                    });

                    vm.isLoading = false;
                })
                .catch(function (error) {
                    error = error.error ? error.error : error;
                    $scope.$emit('records:alert', error);
                    vm.isLoading = false;
                });
        }

        function openDetailsModal(award, id) {
            var options = {
                templateUrl: 'app/components/volunteer/records/awards/details/view.html',
                controller: 'AwardDetailsController',
                controllerAs: 'vm',
                backdrop: 'static',
                keyboard: false,
                resolve: {
                    award: function () {
                        return award ? angular.copy(award) : {};
                    },
                    id: function () {
                        return id ? angular.copy(id) : null;
                    },
                    // If award exists, editing and must check further;
                    // if not, adding and not view only
                    viewOnly: function () {
                        return award ? !canUserEditAward(award) : false;
                    }
                }
            };
            $modal.open(options)
                .result
                .then(function (result) {
                    vm.isLoading = true;

                    var verb = "";
                    switch (result.action) {
                        case 'add':
                            verb = "added";
                            break;
                        case 'edit':
                            verb = "updated";
                            break;
                        case 'delete':
                            verb = "deleted";
                            break;
                        default:
                            break;
                    }

                    var msg = "";
                    if (verb)
                        msg = "Award successfully " + verb + "!";
                    else
                        msg = "Unrecognized action!";
                    $scope.$emit('records:success', msg);
                })
                .catch(function (error) {
                    // If modal is left by pressing "Escape", error is undefined.
                    if (error) {
                        error = error.error ? error.error : error;
                        $scope.$emit('records:alert', error);
                    }
                })
                .finally(function () {
                    refreshAwards();
                });
        }

        function onClickDetails(award) {
            if (vm.adminEditing)
                openDetailsModal(award, vm.masterUserId);
            else
                openDetailsModal(award);
        }

        function onClickAddAward() {
            if (vm.adminEditing)
                openDetailsModal(null, vm.masterUserId);
            else
                openDetailsModal();
        }

        function refreshAwards() {
            if (vm.adminEditing)
                getAwards(vm.masterUserId);
            else
                getAwards();
        }

        // If award is uncertified, it can be edited by user themselves
        function canUserEditAward(award) {
            return vm.adminEditing || !award.certified;
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('vmis.volunteer')
        .controller('AwardDetailsController', AwardDetailsController);

    AwardDetailsController.$inject = ['$modalInstance', '$modal', '$timeout', '$q', 'moment', 'authentication',
        'utilsServices', 'records', 'award', 'id', 'viewOnly', 'config'];

    function AwardDetailsController($modalInstance, $modal, $timeout, $q, moment, authentication,
                                    utilsServices, records, award, id, viewOnly, config) {
        var vm = this;

        vm.isLoading = true;
        vm.isAttachmentUploading = false;

        vm.newUpload = false;

        vm.award = award;

        // This Boolean checks whether the modal was opened
        // to view/delete an existing attachment or to upload new ones.
        if (vm.award.attachments && vm.award.attachments.length > 0) {
            vm.attachmentPresent = true;
            vm.attachments = vm.award.attachments;
        } else {
            vm.attachmentPresent = false;
            vm.attachments = [];
        }

        vm.masterUserId = parseInt(id) || null;
        // Existence of master user ID indicates whether user is editing another user
        vm.adminEditing = angular.isNumber(vm.masterUserId);
        vm.viewOnly = viewOnly;
        vm.title = vm.award.id ? 'Award Details' : 'Add Award';

        vm.allowedFileTypesForUpload = null;
        vm.maxFileSizeInMegabytes = null;
        vm.formError = "";

        vm.onSelectAttachments = onSelectAttachments;
        vm.onDeleteSelectedAttachment = onDeleteSelectedAttachment;
        vm.onClickSave = onClickSave;
        vm.onClickDelete = onClickDelete;

        activate();

        function activate() {
            config.get().then(function (configData) {
                vm.allowedFileTypesForUpload = configData.allowedFileTypesForUpload;
                vm.maxFileSizeInMegabytes = configData.maxFileSizeInMegabytes;
            });

            vm.award.date = vm.award.date ? vm.award.date : null;
            // If new award, set Certified to true if admin or false if self
            if (!vm.award.id)
                vm.award.certified = vm.adminEditing;
            // If existing award, convert 0/1 API return to true/false for checkbox
            else
                vm.award.certified = vm.award.certified === 1;

            vm.isLoading = false;
        }

        function onSelectAttachments(attachments, errAttachments) {
            if (errAttachments.length > 0) {
                utilsServices.displayError("Wrong file type or file size is larger than " + vm.maxFileSizeInMegabytes + ".", vm);
                updateAttachmentPresent();
                return;
            } else {
                vm.formError = "";
            }

            if (attachments.length > 0) {
                angular.forEach(attachments, function (a) {
                    vm.attachments.push({
                        theFile: a,
                        name: a.name,
                        isSelected: true
                    });
                });
            }

            // Update flag for whether new attachments to upload were selected
            updateAttachmentPresent();
        }

        function onDeleteSelectedAttachment(attachment) {
            var index = vm.attachments.indexOf(attachment);
            if (index > -1) {
                if (attachment.isSelected) {
                    vm.attachments.splice(index, 1);
                    updateAttachmentPresent();
                } else {
                    var params = {
                        volunteerAwardIds: [vm.award.id],
                        atoAttachmentId: attachment.id
                    };
                    authentication.deleteVolunteerAwards(params)
                        .then(function (response) {
                            vm.attachments.splice(index, 1);
                            updateAttachmentPresent();
                        })
                        .catch(function (error) {
                            utilsServices.displayError(error, vm);
                        });
                }
            }
        }

        function onClickSave() {
            vm.isLoading = true;

            var params = {
                volunteerAwardId: vm.award.id || undefined,
                masterUserId: (vm.adminEditing && !vm.award.id) ? vm.masterUserId : undefined, // Only do this on admin create, not admin edit
                awardName: vm.award.name,
                awardDetails: vm.award.description || '',
                awardDate: moment(vm.award.date).format('YYYY-MM-DD[T00:00:00Z]'),
                isCertified: vm.adminEditing ? vm.award.certified : undefined
            };

            return authentication.setVolunteerAwards(params)
                .then(function (response) {
                    response.action = vm.award.id ? 'edit' : 'add';

                    var selectedAttachments = [];
                    vm.attachments.forEach(function (a) {
                        if (a.isSelected) {
                            selectedAttachments.push(a);
                        }
                    });

                    if (selectedAttachments.length > 0) {
                        uploadAttachments(selectedAttachments,
                            vm.award.id ? vm.award.id : response.volunteerAwardId);
                    } else {
                        return $modalInstance.close(response);
                    }
                })
                .catch(function (error) {
                    var params = {
                        error: error,
                        success: false,
                        action: vm.award.id ? 'edit' : 'add'
                    };
                    return $modalInstance.dismiss(params);
                });
        }

        function onClickDelete() {
            vm.isLoading = true;

            var options = {
                templateUrl: 'app/components/volunteer/records/awards/delete/view.html',
                controller: 'AwardDeleteController',
                controllerAs: 'vm',
                size: 'tiny',
                backdrop: 'static',
                keyboard: false,
                resolve: {
                    award: function () {
                        return vm.award;
                    }
                }
            };

            return $modal.open(options)
                .result
                .then(function (response) {
                    response.action = 'delete';
                    return $modalInstance.close(response);
                })
                .catch(function (error) {
                    var params = {
                        error: error,
                        success: false,
                        action: 'delete'
                    };
                    return $modalInstance.dismiss(params);
                });
        }

        function uploadAttachments(attachments, awardId) {
            vm.isAttachmentUploading = true;

            var promiseArray = [];

            attachments.forEach(function (a) {
                var suffix = a.name.split(".").pop();
                // If user-created attachment name does not have a suffix
                if (suffix === a.name)
                    suffix = "";

                var uploadAttachmentParams = {
                    masterUserId: vm.adminEditing ? vm.masterUserId : records.getMyMasterUserId(),
                    documentName: a.name,
                    fileSuffix: suffix,
                    volunteerAwardId: awardId,
                    documentDescription: a.name,
                    theFile: a.theFile
                };

                promiseArray.push(authentication.uploadVolunteerDocument(uploadAttachmentParams)
                    .then(function (response) {
                        a.uploaded = true;
                    }));
            });

            $q.all(promiseArray)
                .then(function (response) {
                    return $timeout(function () {
                        vm.isAttachmentUploading = false;
                        response.action = 'add';
                        return $modalInstance.close(response);
                    }, 1000);
                })
                .catch(function (error) {
                    return $timeout(function () {
                        vm.isAttachmentUploading = false;
                        var params = {
                            error: error,
                            success: false,
                            action: 'add'
                        };
                        return $modalInstance.dismiss(params);
                    }, 1000);
                });
        }

        function updateAttachmentPresent() {
            vm.attachmentPresent = (vm.attachments.length > 0);
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('vmis.volunteer')
        .controller('AwardDeleteController', AwardDeleteController);

    AwardDeleteController.$inject = ['$modalInstance', 'authentication', 'award'];

    function AwardDeleteController($modalInstance, authentication, award) {
        var vm = this;

        vm.award = award;

        vm.onClickDelete = onClickDelete;

        function onClickDelete() {
            vm.processing = true;

            var params = {
                volunteerAwardIds: [vm.award.id]
            };

            return authentication.deleteVolunteerAwards(params)
                .then($modalInstance.close)
                .catch($modalInstance.dismiss);
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('vmis.volunteer')
        .controller('TrainingsController', TrainingsController);

    TrainingsController.$inject = ['$scope', '$modal', '$stateParams', 'authentication', 'adminInfo', 'moment'];

    function TrainingsController($scope, $modal, $stateParams, authentication, adminInfo, moment) {
        var vm = this;

        vm.isLoading = true;
        vm.sortColumn = 'endDate';
        vm.sortReverse = true;

        var index = 0;
        var limit = 100;

        vm.trainings = [];
        vm.masterUserId = parseInt($stateParams.id) || null;
        // Use existence of adminMasterUserId (not undefined) as the official check
        // of whether admin is editing another user
        vm.adminEditing = angular.isNumber(adminInfo.adminMasterUserId);

        vm.onClickDetails = onClickDetails;
        vm.onClickAddTraining = onClickAddTraining;
        vm.canUserEditTraining = canUserEditTraining;

        activate();

        function activate() {
           refreshTrainings();
        }

        function getTrainings(id) {
            vm.isLoading = true;

            var params = {
                startingRowIndex: index,
                numberOfRows: limit
            };

            if (angular.isNumber(id)) {
                params.masterUserId = id;
            }

            return authentication.getVolunteerTrainings(params)
                .then(function (response) {
                    vm.trainings = response.result.map(function (training) {
                        return {
                            id: training.volunteerTrainingId,
                            startDate: moment(training.trainingStartDate, 'YYYY-MM-DD').toDate(),
                            endDate: moment(training.trainingEndDate, 'YYYY-MM-DD').toDate(),
                            name: training.trainingName,
                            hours: training.hours,
                            certified: training.isCertified,
                            pursuit: training.pursuit,
                            description: training.trainingDetails,
                            // Note: API currently designed for 1 attachment
                            attachments: training.atoAttachmentId ?
                                [{
                                    id: training.atoAttachmentId,
                                    url: training.fileUrl,
                                    name: training.documentName,
                                    description: training.documentDescription
                                }] : []
                        };
                    });

                    vm.isLoading = false;
                })
                .catch(function (error) {
                    error = error.error ? error.error : error;
                    $scope.$emit('records:alert', error);
                    vm.isLoading = false;
                });
        }

        function openDetailsModal(training, id) {
            var options = {
                templateUrl: 'app/components/volunteer/records/trainings/details/view.html',
                controller: 'TrainingDetailsController',
                controllerAs: 'vm',
                backdrop: 'static',
                keyboard: false,
                resolve: {
                    training: function () {
                        return training ? angular.copy(training) : {};
                    },
                    id: function () {
                        return id ? angular.copy(id) : null;
                    },
                    // If training exists, editing and must check further;
                    // if not, adding and not view only
                    viewOnly: function () {
                        return training ? !canUserEditTraining(training) : false;
                    }
                }
            };
            $modal.open(options)
                .result
                .then(function (result) {
                    vm.isLoading = true;

                    var verb = "";
                    switch (result.action) {
                        case 'add':
                            verb = "added";
                            break;
                        case 'edit':
                            verb = "updated";
                            break;
                        case 'delete':
                            verb = "deleted";
                            break;
                        default:
                            break;
                    }

                    var msg = "";
                    if (verb)
                        msg = "Training successfully " + verb + "!";
                    else
                        msg = "Unrecognized action!";
                    $scope.$emit('records:success', msg);
                })
                .catch(function (error) {
                    // If modal is left by pressing "Escape", error is undefined.
                    if (error) {
                        error = error.error ? error.error : error;
                        $scope.$emit('records:alert', error);
                    }
                })
                .finally(function () {
                    refreshTrainings();
                });
        }

        function onClickDetails(training) {
            if (vm.adminEditing)
                openDetailsModal(training, vm.masterUserId);
            else
                openDetailsModal(training);
        }

        function onClickAddTraining() {
            if (vm.adminEditing)
                openDetailsModal(null, vm.masterUserId);
            else
                openDetailsModal();
        }

        function refreshTrainings() {
            if (vm.adminEditing)
                getTrainings(vm.masterUserId);
            else
                getTrainings();
        }

        // If training is uncertified, it can be edited by user themselves
        function canUserEditTraining(training) {
            return vm.adminEditing || !training.certified;
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('vmis.volunteer')
        .controller('TrainingDetailsController', TrainingDetailsController);

    TrainingDetailsController.$inject = ['$modalInstance', '$modal', '$timeout', '$q', 'moment', 'authentication',
        'utilsServices', 'records', 'training', 'id', 'viewOnly', 'config'];

    function TrainingDetailsController($modalInstance, $modal, $timeout, $q, moment, authentication,
                                       utilsServices, records, training, id, viewOnly, config) {
        var vm = this;

        vm.isLoading = true;
        vm.isAttachmentUploading = false;

        vm.newUpload = false;

        vm.training = training;

        // This Boolean checks whether the modal was opened
        // to view/delete an existing attachment or to upload new ones.
        if (vm.training.attachments && vm.training.attachments.length > 0) {
            vm.attachmentPresent = true;
            vm.attachments = vm.training.attachments;
        } else {
            vm.attachmentPresent = false;
            vm.attachments = [];
        }

        vm.masterUserId = parseInt(id) || null;
        // Existence of master user ID indicates whether user is editing another user
        vm.adminEditing = angular.isNumber(vm.masterUserId);
        vm.viewOnly = viewOnly;
        vm.title = vm.training.id ? 'Training Details' : 'Add Training';
        vm.currentDate = new Date();

        vm.allowedFileTypesForUpload = null;
        vm.maxFileSizeInMegabytes = null;
        vm.formError = "";

        vm.onSelectAttachments = onSelectAttachments;
        vm.onDeleteSelectedAttachment = onDeleteSelectedAttachment;
        vm.onClickSave = onClickSave;
        vm.onClickDelete = onClickDelete;

        activate();

        function activate() {
            config.get().then(function (configData) {
                vm.allowedFileTypesForUpload = configData.allowedFileTypesForUpload;
                vm.maxFileSizeInMegabytes = configData.maxFileSizeInMegabytes;
            });

            vm.training.startDate = isNaN(vm.training.startDate) ? null : vm.training.startDate;
            vm.training.endDate = isNaN(vm.training.endDate) ? null : vm.training.endDate;
            // If new training, set Certified to true if admin or false if self
            if (!vm.training.id)
                vm.training.certified = vm.adminEditing;
            // If existing training, convert 0/1 API return to true/false for checkbox
            else
                vm.training.certified = vm.training.certified === 1;

            vm.isLoading = false;
        }

        function onSelectAttachments(attachments, errAttachments) {
            if (errAttachments.length > 0) {
                utilsServices.displayError("Wrong file type or file size is larger than " + vm.maxFileSizeInMegabytes + ".", vm);
                updateAttachmentPresent();
                return;
            } else {
                vm.formError = "";
            }

            if (attachments.length > 0) {
                angular.forEach(attachments, function (a) {
                    vm.attachments.push({
                        theFile: a,
                        name: a.name,
                        isSelected: true
                    });
                });
            }

            // Update flag for whether new attachments to upload were selected
            updateAttachmentPresent();
        }

        function onDeleteSelectedAttachment(attachment) {
            var index = vm.attachments.indexOf(attachment);
            if (index > -1) {
                if (attachment.isSelected) {
                    vm.attachments.splice(index, 1);
                    updateAttachmentPresent();
                } else {
                    var params = {
                        volunteerTrainingIds: [vm.training.id],
                        atoAttachmentId: attachment.id
                    };
                    authentication.deleteVolunteerTrainings(params)
                        .then(function (response) {
                            vm.attachments.splice(index, 1);
                            updateAttachmentPresent();
                        })
                        .catch(function (error) {
                            utilsServices.displayError(error, vm);
                        });
                }
            }
        }

        function onClickSave() {
            vm.isLoading = true;

            var params = {
                volunteerTrainingId: vm.training.id || undefined,
                masterUserId: (vm.adminEditing && !vm.training.id) ? vm.masterUserId : undefined, // Only do this on admin create, not admin edit
                trainingName: vm.training.name,
                trainingDetails: vm.training.description || '',
                trainingStartDate: vm.training.startDate ? moment(vm.training.startDate).format('YYYY-MM-DD[T00:00:00Z]') : undefined,
                trainingEndDate: moment(vm.training.endDate).format('YYYY-MM-DD[T00:00:00Z]'),
                pursuit: vm.training.pursuit || '',
                hours: vm.training.hours,
                isCertified: vm.adminEditing ? vm.training.certified : undefined
            };

            return authentication.setVolunteerTrainings(params)
                .then(function (response) {
                    response.action = vm.training.id ? 'edit' : 'add';

                    var selectedAttachments = [];
                    vm.attachments.forEach(function (a) {
                        if (a.isSelected) {
                            selectedAttachments.push(a);
                        }
                    });

                    if (selectedAttachments.length > 0) {
                        uploadAttachments(selectedAttachments,
                            vm.training.id ? vm.training.id : response.volunteerTrainingId);
                    } else {
                        return $modalInstance.close(response);
                    }
                })
                .catch(function (error) {
                    var params = {
                        error: error,
                        success: false,
                        action: vm.training.id ? 'edit' : 'add'
                    };
                    return $modalInstance.dismiss(params);
                });
        }

        function onClickDelete() {
            vm.isLoading = true;

            var options = {
                templateUrl: 'app/components/volunteer/records/trainings/delete/view.html',
                controller: 'TrainingDeleteController',
                controllerAs: 'vm',
                size: 'tiny',
                backdrop: 'static',
                keyboard: false,
                resolve: {
                    training: function () {
                        return vm.training;
                    }
                }
            };

            return $modal.open(options)
                .result
                .then(function (response) {
                    response.action = 'delete';
                    return $modalInstance.close(response);
                })
                .catch(function (error) {
                    var params = {
                        error: error,
                        success: false,
                        action: 'delete'
                    };
                    return $modalInstance.dismiss(params);
                });
        }

        function uploadAttachments(attachments, trainingId) {
            vm.isAttachmentUploading = true;

            var promiseArray = [];

            attachments.forEach(function (a) {
                var suffix = a.name.split(".").pop();
                // If user-created attachment name does not have a suffix
                if (suffix === a.name)
                    suffix = "";

                var uploadAttachmentParams = {
                    masterUserId: vm.adminEditing ? vm.masterUserId : records.getMyMasterUserId(),
                    documentName: a.name,
                    fileSuffix: suffix,
                    volunteerTrainingId: trainingId,
                    documentDescription: a.name,
                    theFile: a.theFile
                };

                promiseArray.push(authentication.uploadVolunteerDocument(uploadAttachmentParams)
                    .then(function (response) {
                        a.uploaded = true;
                    }));
            });

            $q.all(promiseArray)
                .then(function (response) {
                    return $timeout(function () {
                        vm.isAttachmentUploading = false;
                        response.action = 'add';
                        return $modalInstance.close(response);
                    }, 1000);
                })
                .catch(function (error) {
                    return $timeout(function () {
                        vm.isAttachmentUploading = false;
                        var params = {
                            error: error,
                            success: false,
                            action: 'add'
                        };
                        return $modalInstance.dismiss(params);
                    }, 1000);
                });
        }

        function updateAttachmentPresent() {
            vm.attachmentPresent = (vm.attachments.length > 0);
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('vmis.volunteer')
        .controller('TrainingDeleteController', TrainingDeleteController);

    TrainingDeleteController.$inject = ['$modalInstance', 'authentication', 'training'];

    function TrainingDeleteController($modalInstance, authentication, training) {
        var vm = this;

        vm.training = training;

        vm.onClickDelete = onClickDelete;

        function onClickDelete() {
            vm.processing = true;

            var params = {
                volunteerTrainingIds: [vm.training.id]
            };

            return authentication.deleteVolunteerTrainings(params)
                .then($modalInstance.close)
                .catch($modalInstance.dismiss);
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('vmis.volunteer')
        .controller('OrientationsController', OrientationsController);

    OrientationsController.$inject = ['$scope', '$modal', '$stateParams', 'authentication', 'adminInfo', 'moment'];

    function OrientationsController($scope, $modal, $stateParams, authentication, adminInfo, moment) {
        var vm = this;

        vm.isLoading = true;
        vm.sortColumn = 'date';
        vm.sortReverse = true;

        var index = 0;
        var limit = 100;

        vm.orientations = [];
        vm.masterUserId = parseInt($stateParams.id) || null;
        // Use existence of adminMasterUserId (not undefined) as the official check
        // of whether admin is editing another user
        vm.adminEditing = angular.isNumber(adminInfo.adminMasterUserId);

        vm.onClickDetails = onClickDetails;
        vm.onClickAddOrientation = onClickAddOrientation;
        vm.canUserEditOrientation = canUserEditOrientation;

        activate();

        function activate() {
            refreshOrientations();
        }

        function getOrientations(id) {
            vm.isLoading = true;

            var params = {
                startingRowIndex: index,
                numberOfRows: limit
            };

            if (angular.isNumber(id)) {
                params.masterUserId = id;
            }

            return authentication.getVolunteerOrientations(params)
                .then(function (response) {
                    vm.orientations = response.result.map(function (orientation) {
                        return {
                            id: orientation.volunteerOrientationId,
                            date: moment(orientation.orientationDate, 'YYYY-MM-DD').toDate(),
                            name: orientation.orientationName,
                            certified: orientation.isCertified,
                            // Note: API currently designed for 1 attachment
                            attachments: orientation.atoAttachmentId ?
                                [{
                                    id: orientation.atoAttachmentId,
                                    url: orientation.fileUrl,
                                    name: orientation.documentName,
                                    description: orientation.documentDescription
                                }] : []
                        };
                    });

                    vm.isLoading = false;
                })
                .catch(function (error) {
                    error = error.error ? error.error : error;
                    $scope.$emit('records:alert', error);
                    vm.isLoading = false;
                });
        }

        function openDetailsModal(orientation, id) {
            var options = {
                templateUrl: 'app/components/volunteer/records/orientations/details/view.html',
                controller: 'OrientationDetailsController',
                controllerAs: 'vm',
                backdrop: 'static',
                keyboard: false,
                resolve: {
                    orientation: function () {
                        return orientation ? angular.copy(orientation) : {};
                    },
                    id: function () {
                        return id ? angular.copy(id) : null;
                    },
                    // If orientation exists, editing and must check further;
                    // if not, adding and not view only
                    viewOnly: function () {
                        return orientation ? !canUserEditOrientation(orientation) : false;
                    }
                }
            };
            $modal.open(options)
                .result
                .then(function (result) {
                    vm.isLoading = true;

                    var verb = "";
                    switch (result.action) {
                        case 'add':
                            verb = "added";
                            break;
                        case 'edit':
                            verb = "updated";
                            break;
                        case 'delete':
                            verb = "deleted";
                            break;
                        default:
                            break;
                    }

                    var msg = "";
                    if (verb)
                        msg = "Orientation successfully " + verb + "!";
                    else
                        msg = "Unrecognized action!";
                    $scope.$emit('records:success', msg);
                })
                .catch(function (error) {
                    // If modal is left by pressing "Escape", error is undefined.
                    if (error) {
                        error = error.error ? error.error : error;
                        $scope.$emit('records:alert', error);
                    }
                })
                .finally(function () {
                    refreshOrientations();
                });
        }

        function onClickDetails(orientation) {
            if (vm.adminEditing)
                openDetailsModal(orientation, vm.masterUserId);
            else
                openDetailsModal(orientation);
        }

        function onClickAddOrientation() {
            if (vm.adminEditing)
                openDetailsModal(null, vm.masterUserId);
            else
                openDetailsModal();
        }

        function refreshOrientations() {
            if (vm.adminEditing)
                getOrientations(vm.masterUserId);
            else
                getOrientations();
        }

        // If orientation is uncertified, it can be edited by user themselves
        function canUserEditOrientation(orientation) {
            return vm.adminEditing || !orientation.certified;
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('vmis.volunteer')
        .controller('OrientationDetailsController', OrientationDetailsController);

    OrientationDetailsController.$inject = ['$modalInstance', '$modal', '$timeout', '$q', 'moment', 'authentication',
        'utilsServices', 'records', 'orientation', 'id', 'viewOnly', 'config'];

    function OrientationDetailsController($modalInstance, $modal, $timeout, $q, moment, authentication,
                                          utilsServices, records, orientation, id, viewOnly, config) {
        var vm = this;

        vm.isLoading = true;
        vm.isAttachmentUploading = false;

        vm.newUpload = false;

        vm.orientation = orientation;

        // This Boolean checks whether the modal was opened
        // to view/delete an existing attachment or to upload new ones.
        if (vm.orientation.attachments && vm.orientation.attachments.length > 0) {
            vm.attachmentPresent = true;
            vm.attachments = vm.orientation.attachments;
        } else {
            vm.attachmentPresent = false;
            vm.attachments = [];
        }

        vm.masterUserId = parseInt(id) || null;
        // Existence of master user ID indicates whether user is editing another user
        vm.adminEditing = angular.isNumber(vm.masterUserId);
        vm.viewOnly = viewOnly;
        vm.title = vm.orientation.id ? 'Orientation Details' : 'Add Orientation';

        vm.allowedFileTypesForUpload = null;
        vm.maxFileSizeInMegabytes = null;
        vm.formError = "";

        vm.onSelectAttachments = onSelectAttachments;
        vm.onDeleteSelectedAttachment = onDeleteSelectedAttachment;
        vm.onClickSave = onClickSave;
        vm.onClickDelete = onClickDelete;

        activate();

        function activate() {
            config.get().then(function (configData) {
                vm.allowedFileTypesForUpload = configData.allowedFileTypesForUpload;
                vm.maxFileSizeInMegabytes = configData.maxFileSizeInMegabytes;
            });

            vm.orientation.date = vm.orientation.date ? vm.orientation.date : null;
            // If new orientation, set Certified to true if admin or false if self
            if (!vm.orientation.id)
                vm.orientation.certified = vm.adminEditing;
            // If existing orientation, convert 0/1 API return to true/false for checkbox
            else
                vm.orientation.certified = vm.orientation.certified === 1;

            vm.isLoading = false;
        }

        function onSelectAttachments(attachments, errAttachments) {
            if (errAttachments.length > 0) {
                utilsServices.displayError("Wrong file type or file size is larger than " + vm.maxFileSizeInMegabytes + ".", vm);
                updateAttachmentPresent();
                return;
            } else {
                vm.formError = "";
            }

            if (attachments.length > 0) {
                angular.forEach(attachments, function (a) {
                    vm.attachments.push({
                        theFile: a,
                        name: a.name,
                        isSelected: true
                    });
                });
            }

            // Update flag for whether new attachments to upload were selected
            updateAttachmentPresent();
        }

        function onDeleteSelectedAttachment(attachment) {
            var index = vm.attachments.indexOf(attachment);
            if (index > -1) {
                if (attachment.isSelected) {
                    vm.attachments.splice(index, 1);
                    updateAttachmentPresent();
                } else {
                    var params = {
                        volunteerOrientationIds: [vm.orientation.id],
                        atoAttachmentId: attachment.id
                    };
                    authentication.deleteVolunteerOrientations(params)
                        .then(function (response) {
                            vm.attachments.splice(index, 1);
                            updateAttachmentPresent();
                        })
                        .catch(function (error) {
                            utilsServices.displayError(error, vm);
                        });
                }
            }
        }

        function onClickSave() {
            vm.isLoading = true;

            var params = {
                volunteerOrientationId: vm.orientation.id || undefined,
                masterUserId: vm.adminEditing && !vm.orientation.id ? vm.masterUserId : undefined, // Only do this on admin create, not admin edit
                orientationName: vm.orientation.name,
                orientationDate: moment(vm.orientation.date).format('YYYY-MM-DD[T00:00:00Z]'),
                isCertified: vm.adminEditing ? vm.orientation.certified : undefined
            };

            return authentication.setVolunteerOrientations(params)
                .then(function (response) {
                    response.action = vm.orientation.id ? 'edit' : 'add';

                    var selectedAttachments = [];
                    vm.attachments.forEach(function (a) {
                        if (a.isSelected) {
                            selectedAttachments.push(a);
                        }
                    });

                    if (selectedAttachments.length > 0) {
                        uploadAttachments(selectedAttachments,
                            vm.orientation.id ? vm.orientation.id : response.volunteerOrientationId);
                    } else {
                        return $modalInstance.close(response);
                    }
                })
                .catch(function (error) {
                    var params = {
                        error: error,
                        success: false,
                        action: vm.orientation.id ? 'edit' : 'add'
                    };
                    return $modalInstance.dismiss(params);
                });
        }

        function onClickDelete() {
            vm.isLoading = true;

            var options = {
                templateUrl: 'app/components/volunteer/records/orientations/delete/view.html',
                controller: 'OrientationDeleteController',
                controllerAs: 'vm',
                size: 'tiny',
                backdrop: 'static',
                keyboard: false,
                resolve: {
                    orientation: function () {
                        return vm.orientation;
                    }
                }
            };

            return $modal.open(options)
                .result
                .then(function (response) {
                    response.action = 'delete';
                    return $modalInstance.close(response);
                })
                .catch(function (error) {
                    var params = {
                        error: error,
                        success: false,
                        action: 'delete'
                    };
                    return $modalInstance.dismiss(params);
                });
        }

        function uploadAttachments(attachments, orientationId) {
            vm.isAttachmentUploading = true;

            var promiseArray = [];

            attachments.forEach(function (a) {
                var suffix = a.name.split(".").pop();
                // If user-created attachment name does not have a suffix
                if (suffix === a.name)
                    suffix = "";

                var uploadAttachmentParams = {
                    masterUserId: vm.adminEditing ? vm.masterUserId : records.getMyMasterUserId(),
                    documentName: a.name,
                    fileSuffix: suffix,
                    volunteerOrientationId: orientationId,
                    documentDescription: a.name,
                    theFile: a.theFile
                };

                promiseArray.push(authentication.uploadVolunteerDocument(uploadAttachmentParams)
                    .then(function (response) {
                        a.uploaded = true;
                    }));
            });

            $q.all(promiseArray)
                .then(function (response) {
                    return $timeout(function () {
                        vm.isAttachmentUploading = false;
                        response.action = 'add';
                        return $modalInstance.close(response);
                    }, 1000);
                })
                .catch(function (error) {
                    return $timeout(function () {
                        vm.isAttachmentUploading = false;
                        var params = {
                            error: error,
                            success: false,
                            action: 'add'
                        };
                        return $modalInstance.dismiss(params);
                    }, 1000);
                });
        }

        function updateAttachmentPresent() {
            vm.attachmentPresent = (vm.attachments.length > 0);
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('vmis.volunteer')
        .controller('OrientationDeleteController', OrientationDeleteController);

    OrientationDeleteController.$inject = ['$modalInstance', 'authentication', 'orientation'];

    function OrientationDeleteController($modalInstance, authentication, orientation) {
        var vm = this;

        vm.orientation = orientation;

        vm.onClickDelete = onClickDelete;

        function onClickDelete() {
            vm.processing = true;

            var params = {
                volunteerOrientationIds: [vm.orientation.id]
            };

            return authentication.deleteVolunteerOrientations(params)
                .then($modalInstance.close)
                .catch($modalInstance.dismiss);
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('vmis.volunteer')
        .controller('NotesController', NotesController);

    NotesController.$inject = ['$scope', '$modal', '$stateParams', 'authentication', 'adminInfo'];

    function NotesController($scope, $modal, $stateParams, authentication, adminInfo) {
        var vm = this;

        vm.isLoading = true;
        vm.sortColumn = 'date';
        vm.sortReverse = true;

        var index = 0;
        var limit = 100;

        vm.notes = [];
        vm.masterUserId = parseInt($stateParams.id) || null;
        // Admin master user ID is used to check whether user can edit individual notes that are theirs
        vm.adminMasterUserId = parseInt(adminInfo.adminMasterUserId) || null;
        // Use existence of adminMasterUserId (not undefined) as the official check
        // of whether admin is editing another user
        vm.adminEditing = angular.isNumber(vm.adminMasterUserId);
        vm.isOnlyAVCCAssistant = (adminInfo.adminRoles.length === 1) &&
            (adminInfo.adminRoles[0].name === "AVC Coordinator Assistant");

        vm.onClickDetails = onClickDetails;
        vm.onClickAddNote = onClickAddNote;
        vm.canUserEditNote = canUserEditNote;

        activate();

        function activate() {
            // If AVCC Assistant, do not show or set up this section
            if (vm.isOnlyAVCCAssistant)
                return;

            if (vm.adminEditing)
                getNotes(vm.masterUserId);
            else
                getNotes();
        }

        function getNotes(id) {
            vm.isLoading = true;

            var params = {
                startingRowIndex: index,
                numberOfRows: limit
            };

            if (angular.isNumber(id)) {
                params.masterUserId = id;
            }

            return authentication.getVolunteerNotes(params)
                .then(function (response) {
                    vm.notes = response.volunteerNotes.map(function (note) {
                        return {
                            id: note.volunteerNoteId,
                            note: note.volunteerNotes,
                            date: new Date(note.modifiedDate),
                            author: note.lastName + ', ' + note.firstName,
                            createdByUserId: note.createdByUserId,
                            adminMasterUserId: vm.adminMasterUserId
                        };
                    });

                    vm.isLoading = false;
                })
                .catch(function (error) {
                    error = error.error ? error.error : error;
                    $scope.$emit('records:alert', error);
                    vm.isLoading = false;
                });
        }

        function openDetailsModal(note, id) {
            var options = {
                templateUrl: 'app/components/volunteer/records/notes/details/view.html',
                controller: 'NoteDetailsController',
                controllerAs: 'vm',
                backdrop: 'static',
                keyboard: false,
                resolve: {
                    note: function () {
                        return note ? angular.copy(note) : {};
                    },
                    id: function () {
                        return id ? angular.copy(id) : null;
                    },
                    // If note already exists, check if it can be edited. If not, making new one.
                    viewOnly: function () {
                        return note ? !canUserEditNote(note) : false;
                    }
                }
            };
            $modal.open(options)
                .result
                .then(function (result) {
                    vm.isLoading = true;

                    var msg = "";
                    if (result) {
                        var verb = "";
                        switch (result.action) {
                            case 'add':
                                verb = "added";
                                break;
                            case 'edit':
                                verb = "updated";
                                break;
                            case 'delete':
                                verb = "deleted";
                                break;
                            default:
                                msg = "Unrecognized action!";
                                break;
                        }

                        if (verb)
                            msg = "Note successfully " + verb + "!";

                    }
                    else
                        msg = "Unrecognized action!";

                    $scope.$emit('records:success', msg);

                    if (vm.adminEditing)
                        getNotes(id);
                    else
                        getNotes();
                })
                .catch(function (error) {
                    // If modal is left by pressing "Escape", error is undefined.
                    if (error) {
                        error = error.error ? error.error : error;
                        $scope.$emit('records:alert', error);
                    }
                });
        }

        function onClickDetails(note) {
            if (vm.adminEditing)
                openDetailsModal(note, vm.masterUserId);
            else
                openDetailsModal(note);
        }

        function onClickAddNote() {
            if (vm.adminEditing)
                openDetailsModal(null, vm.masterUserId);
            else
                openDetailsModal();
        }

        function canUserEditNote(note) {
            return vm.adminEditing;
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('vmis.volunteer')
        .controller('NoteDetailsController', NoteDetailsController);

    NoteDetailsController.$inject = ['$modalInstance', '$modal', 'authentication', 'note', 'id', 'viewOnly'];

    function NoteDetailsController($modalInstance, $modal, authentication, note, id, viewOnly) {
        var vm = this;

        vm.isLoading = true;

        vm.note = note;
        // Existence of master user ID indicates whether user is editing another user
        vm.masterUserId = parseInt(id) || null;
        vm.viewOnly = viewOnly;
        vm.title = vm.note.id ? 'Note Details' : 'Add Note';

        vm.isSavedDisabled = (vm.note.adminMasterUserId !== null && (vm.note.createdByUserId !== vm.note.adminMasterUserId));

        vm.onClickSave = onClickSave;
        vm.onClickDelete = onClickDelete;

        activate();

        function activate() {
            vm.note.date = vm.note.date ? vm.note.date : null;

            vm.isLoading = false;
        }

        function onClickSave() {
            vm.isLoading = true;

            var params = {
                volunteerNoteId: vm.note.id,
                masterUserId: vm.masterUserId,
                volunteerNotes: vm.note.note
            };

            return authentication.manageVolunteerNotes(params)
                .then(function (response) {
                    response.action = vm.note.id ? 'edit' : 'add';
                    return $modalInstance.close(response);
                })
                .catch(function (error) {
                    var params = {
                        error: error,
                        success: false,
                        action: vm.note.id ? 'edit' : 'add'
                    };
                    return $modalInstance.dismiss(params);
                });
        }

        // Notes may only be deleted by their creator
        function onClickDelete() {
            vm.isLoading = true;

            var options = {
                templateUrl: 'app/components/volunteer/records/notes/delete/view.html',
                controller: 'NoteDeleteController',
                controllerAs: 'vm',
                size: 'tiny',
                backdrop: 'static',
                keyboard: false,
                resolve: {
                    note: function () {
                        return vm.note;
                    }
                }
            };

            return $modal.open(options)
                .result
                .then(function (response) {
                    response.action = 'delete';
                    return $modalInstance.close(response);
                })
                .catch(function (error) {
                    var params = {
                        error: error,
                        success: false,
                        action: 'delete'
                    };
                    return $modalInstance.dismiss(params);
                });
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('vmis.volunteer')
        .controller('NoteDeleteController', NoteDeleteController);

    NoteDeleteController.$inject = ['$modalInstance', 'authentication', 'note'];

    function NoteDeleteController($modalInstance, authentication, note) {
        var vm = this;

        vm.note = note;

        vm.onClickDelete = onClickDelete;

        function onClickDelete() {
            vm.processing = true;

            var params = {
                volunteerNoteId: vm.note.id,
                isDelete: true
            };

            return authentication.manageVolunteerNotes(params)
                .then($modalInstance.close)
                .catch($modalInstance.dismiss);
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('vmis.volunteer')
        .controller('BackgroundChecksController', BackgroundChecksController);

    BackgroundChecksController.$inject = ['$scope', '$modal', '$stateParams', 'authentication', 'adminInfo', 'moment'];

    function BackgroundChecksController($scope, $modal, $stateParams, authentication, adminInfo, moment) {
        var vm = this;

        vm.isLoading = true;
        vm.sortColumn = 'date';
        vm.sortReverse = true;

        var index = 0;
        var limit = 100;

        vm.backgroundChecks = [];
        vm.masterUserId = parseInt($stateParams.id) || null;
        // Admin master user ID is used to check whether user can edit individual background checks that are theirs
        vm.adminMasterUserId = parseInt(adminInfo.adminMasterUserId) || null;
        // Use existence of adminMasterUserId (not undefined) as the official check
        // of whether admin is editing another user
        vm.adminEditing = angular.isNumber(vm.adminMasterUserId);
        // Additional information for modals
        vm.adminFullName = adminInfo.adminFullName || "";
        vm.adminEmail = adminInfo.adminEmail || "";

        vm.onClickDetails = onClickDetails;
        vm.onClickAddBackgroundCheck = onClickAddBackgroundCheck;
        vm.canUserEditBackgroundCheck = canUserEditBackgroundCheck;

        activate();

        function activate() {
            if (vm.adminEditing)
                getBackgroundChecks(vm.masterUserId);
            else
                getBackgroundChecks();
        }

        function getBackgroundChecks(id) {
            vm.isLoading = true;

            var params = {
                startingRowIndex: index,
                numberOfRows: limit
            };

            if (angular.isNumber(id)) {
                params.masterUserId = id;
            }

            return authentication.getVolunteerBackgroundChecks(params)
                .then(function (response) {
                    vm.backgroundChecks = response.volunteerBackgroundChecks.map(function (backgroundCheck) {
                        var bgc = backgroundCheck.backgroundCheck;
                        var checker = backgroundCheck.checkerInfo;
                        return {
                            id: bgc.volunteerBackgroundCheckId,
                            checkerMasterUserId: bgc.checkerMasterUserId,
                            date: moment(bgc.date, 'YYYY-MM-DD').toDate(),
                            validUntil: moment(bgc.dateValidUntil, 'YYYY-MM-DD').toDate(),
                            comment: bgc.note,
                            checker: {
                                firstName: checker.firstName,
                                lastName: checker.lastName,
                                // Sometimes (migrated data) BGCs don't have the adminProfile
                                // Leave row blank so it doesn't make a broken link, but details page will do this.
                                workEmail: checker.adminProfile ? checker.adminProfile.workEmail : ""
                            }
                        };
                    });

                    vm.isLoading = false;
                })
                .catch(function (error) {
                    error = error.error ? error.error : error;
                    $scope.$emit('records:alert', error);
                    vm.isLoading = false;
                });
        }

        function openDetailsModal(backgroundCheck, id) {
            var options = {
                templateUrl: 'app/components/volunteer/records/backgroundChecks/details/view.html',
                controller: 'BackgroundCheckDetailsController',
                controllerAs: 'vm',
                backdrop: 'static',
                keyboard: false,
                resolve: {
                    backgroundCheck: function () {
                        return backgroundCheck ? angular.copy(backgroundCheck) : {};
                    },
                    id: function () {
                        return id ? angular.copy(id) : null;
                    },
                    // If background check already exists, check if it can be edited. If not, making new one.
                    viewOnly: function () {
                        return backgroundCheck ? !canUserEditBackgroundCheck(backgroundCheck) : false;
                    },
                    adminInfo: function () {
                        return {
                            checkerFullName: vm.adminFullName,
                            checkerEmail: vm.adminEmail
                        };
                    }
                }
            };
            $modal.open(options)
                .result
                .then(function (result) {
                    vm.isLoading = true;

                    var msg = "";
                    if (result) {
                        var verb = "";
                        switch (result.action) {
                            case 'add':
                                verb = "added";
                                break;
                            case 'edit':
                                verb = "updated";
                                break;
                            case 'delete':
                                verb = "deleted";
                                break;
                            default:
                                msg = "Unrecognized action!";
                                break;
                        }

                        if (verb)
                            msg = "Background check successfully " + verb + "!";
                    }
                    else
                        msg = "Unrecognized action!";

                    $scope.$emit('records:success', msg);

                    if (vm.adminEditing)
                        getBackgroundChecks(id);
                    else
                        getBackgroundChecks();
                })
                .catch(function (error) {
                    // If modal is left by pressing "Escape", error is undefined.
                    if (error) {
                        error = error.error ? error.error : error;
                        $scope.$emit('records:alert', error);
                    }
                });
        }

        function onClickDetails(backgroundCheck) {
            if (vm.adminEditing){
                backgroundCheck.adminMasterUserId = vm.adminMasterUserId;
                openDetailsModal(backgroundCheck, vm.masterUserId);
            }
            else
                openDetailsModal(backgroundCheck);
        }

        function onClickAddBackgroundCheck() {
            if (vm.adminEditing)
                openDetailsModal(null, vm.masterUserId);
            //else
            //openDetailsModal();
        }

        function canUserEditBackgroundCheck(backgroundCheck) {
            return vm.adminEditing;
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('vmis.volunteer')
        .controller('BackgroundCheckDetailsController', BackgroundCheckDetailsController);

    BackgroundCheckDetailsController.$inject = ['$modalInstance', '$modal', 'moment', 'authentication',
        'backgroundCheck', 'id', 'viewOnly', 'adminInfo'];

    function BackgroundCheckDetailsController($modalInstance, $modal, moment, authentication,
                                              backgroundCheck, id, viewOnly, adminInfo) {
        var vm = this;

        vm.isLoading = true;

        vm.backgroundCheck = backgroundCheck;
        // Existence of master user ID indicates whether user is editing another user
        vm.masterUserId = parseInt(id) || null;
        vm.viewOnly = viewOnly;
        vm.title = vm.backgroundCheck.id ? 'Background Check Details' : 'Add Background Check';
        vm.currentDate = new Date();

        vm.isSavedDisabled = (!vm.viewOnly && vm.backgroundCheck.adminMasterUserId !== null && (vm.backgroundCheck.adminMasterUserId !== vm.backgroundCheck.checkerMasterUserId));

        vm.onClickSave = onClickSave;
        vm.onClickDelete = onClickDelete;
        vm.dateCheckedEndDate = dateCheckedEndDate;
        vm.formatDate = formatDate;

        activate();

        function activate() {
            // If viewing existing background check
            if (vm.backgroundCheck.checker) {
                vm.checkerFullName = vm.backgroundCheck.checker.lastName + ", " + vm.backgroundCheck.checker.firstName || "Checker name not found";
                vm.checkerEmail = vm.backgroundCheck.checker.workEmail || "Checker email not found";
            }
            // If new background check, the checker will be the current user
            else {
                vm.checkerFullName = adminInfo.checkerFullName || "Checker name not found";
                vm.checkerEmail = adminInfo.checkerEmail || "Checker email not found";
            }

            vm.backgroundCheck.date = vm.backgroundCheck.date ? vm.backgroundCheck.date : null;
            vm.backgroundCheck.validUntil = vm.backgroundCheck.validUntil ? vm.backgroundCheck.validUntil : null;

            vm.isLoading = false;
        }

        function onClickSave() {
            vm.isLoading = true;

            var params = {
                masterUserId: vm.masterUserId,
                volunteerBackgroundCheckId: vm.backgroundCheck.id,
                date: vm.backgroundCheck.date.toISOString(),
                dateValidUntil: vm.backgroundCheck.validUntil.toISOString(),
                note: vm.backgroundCheck.comment || ''
            };

            return authentication.manageVolunteerBackgroundChecks(params)
                .then(function (response) {
                    response.action = vm.backgroundCheck.id ? 'edit' : 'add';
                    return $modalInstance.close(response);
                })
                .catch(function (error) {
                    var params = {
                        error: error,
                        success: false,
                        action: vm.backgroundCheck.id ? 'edit' : 'add'
                    };
                    return $modalInstance.dismiss(params);
                });
        }

        // Deleting another user's trainings is not currently allowed
        function formatDate(theDateInMoment) {
            return theDateInMoment.format("M/D/YYYY");
        }

        // Deleting another user's trainings is not currently allowed
        function onClickDelete() {
            vm.isLoading = true;

            var options = {
                templateUrl: 'app/components/volunteer/records/backgroundChecks/delete/view.html',
                controller: 'BackgroundCheckDeleteController',
                controllerAs: 'vm',
                size: 'tiny',
                backdrop: 'static',
                keyboard: false,
                resolve: {
                    backgroundCheck: function () {
                        return vm.backgroundCheck;
                    }
                }
            };

            return $modal.open(options)
                .result
                .then(function (response) {
                    response.action = 'delete';
                    return $modalInstance.close(response);
                })
                .catch(function (error) {
                    var params = {
                        error: error,
                        success: false,
                        action: 'delete'
                    };
                    return $modalInstance.dismiss(params);
                });
        }

        function dateCheckedEndDate() {
            return moment(vm.currentDate).isAfter(vm.backgroundCheck.validUntil, 'day') ? vm.backgroundCheck.validUntil : vm.currentDate;
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('vmis.volunteer')
        .controller('BackgroundCheckDeleteController', BackgroundCheckDeleteController);

    BackgroundCheckDeleteController.$inject = ['$modalInstance', 'authentication', 'backgroundCheck'];

    function BackgroundCheckDeleteController($modalInstance, authentication, backgroundCheck) {
        var vm = this;

        vm.backgroundCheck = backgroundCheck;

        vm.onClickDelete = onClickDelete;

        function onClickDelete() {
            vm.processing = true;

            var params = {
                volunteerBackgroundCheckId: vm.backgroundCheck.id,
                isDelete: true
            };

            return authentication.manageVolunteerBackgroundChecks(params)
                .then($modalInstance.close)
                .catch($modalInstance.dismiss);
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('vmis.volunteer')
        .controller('DocumentsController', DocumentsController);

    DocumentsController.$inject = ['$scope', '$modal', '$stateParams', 'authentication', 'adminInfo'];

    function DocumentsController($scope, $modal, $stateParams, authentication, adminInfo) {
        var vm = this;

        vm.isLoading = true;
        vm.sortColumn = 'date';
        vm.sortReverse = true;

        vm.maxDocumentsUploaded = false;

        var index = 0;
        var limit = 100;

        vm.documents = [];
        vm.masterUserId = parseInt($stateParams.id) || null;
        // Admin master user ID is used to check whether user can delete individual documents they uploaded
        vm.adminMasterUserId = parseInt(adminInfo.adminMasterUserId) || null;
        // Use existence of adminMasterUserId (not undefined) as the official check
        // of whether admin is editing another user
        vm.adminEditing = angular.isNumber(vm.adminMasterUserId);

        vm.onClickDetails = onClickDetails;
        vm.onClickAddDoc = onClickAddDoc;
        vm.canUserDeleteDoc = canUserDeleteDoc;

        activate();

        function activate() {
            getDocuments(vm.masterUserId);
        }

        function getDocuments(id) {
            vm.isLoading = true;

            var params = {
                startingRowIndex: index,
                numberOfRows: limit
            };

            // Only add this field if valid parameter is passed in
            if (angular.isNumber(id))
                params.masterUserId = id;

            return authentication.getVolunteerDocuments(params)
                .then(function (response) {
                    vm.documents = response.documents.map(function (doc) {
                        return {
                            id: doc.userFileId,
                            name: doc.documentName,
                            url: doc.fileUrl,
                            date: new Date(doc.modifiedDate),
                            description: doc.documentDescription,
                            uploaderFullName: doc.uploaderLastName + ', ' + doc.uploaderFirstName,
                            uploadersId: doc.uploadersId,
                            masterUserId: doc.masterUserId
                        };
                    });

                    vm.isLoading = false;
                })
                .catch(function (error) {
                    if (error) {
                        error = error.error ? error.error : error;
                        $scope.$emit('records:alert', error);
                    }
                    vm.isLoading = false;
                });
        }

        function openDetailsModal(document, id) {
            var options = {
                templateUrl: 'app/components/volunteer/records/documents/details/view.html',
                controller: 'DocumentDetailsController',
                controllerAs: 'vm',
                backdrop: 'static',
                keyboard: false,
                resolve: {
                    document: function () {
                        return document ? angular.copy(document) : {};
                    },
                    id: function () {
                        return id ? angular.copy(id) : null;
                    },
                    // If document already exists, it cannot be edited. If not, making new one.
                    viewOnly: function () {
                        return document ? !canUserDeleteDoc(document) : false;
                    }
                }
            };
            $modal.open(options)
                .result
                .then(function (result) {
                    vm.isLoading = true;

                    var verb = "";
                    switch (result.action) {
                        case 'add':
                            verb = "added";
                            break;
                        case 'edit':
                            verb = "updated";
                            break;
                        case 'delete':
                            verb = "deleted";
                            break;
                        default:
                            break;
                    }

                    var msg = "";
                    if (verb)
                        msg = "Document(s) successfully " + verb + "!";
                    else
                        msg = "Unrecognized action!";
                    $scope.$emit('records:success', msg);

                    if (vm.adminEditing)
                        getDocuments(id);
                    else
                        getDocuments();
                })
                .catch(function (error) {
                    // If modal is left by pressing "Escape", error is undefined.
                    if (error) {
                        error = error.error ? error.error : error;
                        $scope.$emit('records:alert', error);
                    }
                });
        }

        function onClickDetails(document) {
            if (vm.adminEditing)
                openDetailsModal(document, vm.masterUserId);
            else
                openDetailsModal(document);
        }

        function onClickAddDoc() {
            if (vm.adminEditing)
                openDetailsModal(null, vm.masterUserId);
        }

        // Documents can only be deleted by their uploader
        function canUserDeleteDoc(document) {
            return (document.uploadersId === vm.adminMasterUserId) && vm.adminEditing;
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('vmis.volunteer')
        .controller('DocumentDetailsController', DocumentDetailsController);

    DocumentDetailsController.$inject = ['$modalInstance', '$modal', '$q', '$timeout', 'authentication', 'document', 'id', 'viewOnly', 'config'];

    function DocumentDetailsController($modalInstance, $modal, $q, $timeout, authentication, document, id, viewOnly, config) {
        var vm = this;

        vm.isLoading = true;
        vm.isDocumentUploading = false;

        vm.newUpload = false;
        vm.maxDocumentsUploaded = false;

        // This Boolean checks whether the modal was opened
        // to view/delete an existing document or to upload new ones.
        vm.existingDocument = angular.isNumber(document.id);

        vm.documents = vm.existingDocument ? [document] : [];
        // Existence of master user ID indicates whether user is editing another user
        vm.masterUserId = parseInt(id) || null;
        // This Boolean determines what buttons are available at the bottom of the modal
        vm.viewOnly = viewOnly;
        vm.title = vm.existingDocument ? 'Document Details' : 'Add Documents'; // Update

        vm.allowedFileTypesForUpload = null;
        vm.maxFileSizeInMegabytes = null;
        vm.formError = "";

        vm.onSelectDocs = onSelectDocs;
        vm.onDeleteSelectedDoc = onDeleteSelectedDoc;
        vm.onClickSave = onClickSave;
        vm.onClickDelete = onClickDelete;

        activate();

        function activate() {
            config.get().then(function (configData) {
                vm.allowedFileTypesForUpload = configData.allowedFileTypesForUpload;
                vm.maxFileSizeInMegabytes = configData.maxFileSizeInMegabytes;
            });
            vm.isLoading = false;
        }

        function displayError(error) {
            if (_.isUndefined(error)) return;
            var errorStr = utilsServices.parseErrorString(error);

            vm.isLoading = false;

            if (errorStr === 'cancel' || errorStr === 'backdrop click' || errorStr === 'ok')
                return;
            if (errorStr)
                vm.formError = errorStr;
        }

        function onSelectDocs(documents, errDocuments) {
            if (errDocuments.length > 0) {
                vm.formError = "Wrong file type or file size is larger than " + vm.maxFileSizeInMegabytes + ".";
                displayError(vm.formError);
                updateNewUpload();
                return;
            } else {
                vm.formError = "";
            }

            if (documents.length > 0) {
                angular.forEach(documents, function (doc) {
                    vm.documents.push({
                        theFile: doc,
                        id: doc.id,
                        name: doc.name,
                        description: "",
                        isSelected: true,
                        originalName: doc.name
                    });
                });
            }

            // Update flag for whether new documents to upload were selected
            updateNewUpload();
        }

        function onDeleteSelectedDoc(document) {
            var index = vm.documents.indexOf(document);
            if (index > -1)
                vm.documents.splice(index, 1);
            vm.newUpload = false;
        }

        // Only for adding, not editing or deleting
        function onClickSave() {
            if (vm.masterUserId)
                uploadDocuments(vm.documents, vm.masterUserId);
            else
                uploadDocuments(vm.documents);
        }

        // Deleting another user's documents is not currently allowed
        function onClickDelete(document) {
            var options = {
                templateUrl: 'app/components/volunteer/records/documents/delete/view.html',
                controller: 'DocumentDeleteController',
                controllerAs: 'vm',
                size: 'tiny',
                backdrop: 'static',
                keyboard: false,
                resolve: {
                    document: function () {
                        return document ? angular.copy(document) : {};
                    },
                    id: function () {
                        return id ? angular.copy(id) : null;
                    }
                }
            };

            return $modal.open(options)
                .result
                .then(function (response) {
                    vm.isLoading = true;
                    response.action = 'delete';
                    return $modalInstance.close(response);
                })
                .catch(function (error) {
                    var params = {
                        error: error,
                        success: false,
                        action: 'delete'
                    };
                    return $modalInstance.dismiss(params);
                });
        }


        function uploadDocuments(documents, id) {
            vm.isDocumentUploading = true;

            var promiseArray = [];

            angular.forEach(documents, function (document) {
                var suffix = document.name.split(".").pop();
                // If user-created document name does not have a suffix
                if (suffix === document.name)
                    suffix = document.originalName.split(".").pop();

                var uploadDocumentParams = {
                    theFile: document.theFile,
                    fileSuffix: suffix,
                    documentName: document.name,
                    masterUserId: angular.isNumber(id) ? id : null,
                    documentDescription: document.description
                };

                promiseArray.push(authentication.uploadVolunteerDocument(uploadDocumentParams)
                    .then(function (response) {
                        document.uploaded = true;
                    }));
                //.catch(function (error) {
                //
                //}));
            });

            $q.all(promiseArray)
                .then(function (response) {
                    return $timeout(function () {
                        vm.isDocumentUploading = false;
                        response.action = 'add';
                        return $modalInstance.close(response);
                    }, 1000);
                })
                .catch(function (error) {
                    return $timeout(function () {
                        vm.isDocumentUploading = false;
                        var params = {
                            error: error,
                            success: false,
                            action: 'add'
                        };
                        return $modalInstance.dismiss(params);
                    }, 1000);
                });
        }

        function updateNewUpload() {
            vm.newUpload = (vm.documents.length > 0);
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('vmis.volunteer')
        .controller('DocumentDeleteController', DocumentDeleteController);

    DocumentDeleteController.$inject = ['$modalInstance', 'authentication', 'document', 'id'];

    function DocumentDeleteController($modalInstance, authentication, document, id) {
        var vm = this;

        vm.document = document;
        vm.id = id;

        vm.onClickDelete = onClickDelete;

        function onClickDelete() {
            vm.processing = true;

            var params = {
                userFileId: vm.document.id,
                masterUserId: vm.id
            };

            return authentication.deleteVolunteerDocument(params)
                .then($modalInstance.close)
                .catch($modalInstance.dismiss);
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('vmis.volunteer')
        .config(routes);

    routes.$inject = ['$stateProvider'];

    function routes($stateProvider) {
        var states = {
            volunteer: 'vmis.volunteer.serviceHistory',
            admin: 'vmis.volunteer.serviceHistoryEdit'
        };
        var views = function (state) {
            var views = {};
            views['@vmis.volunteer'] = {
                templateUrl: 'app/components/volunteer/serviceHistory/view.html',
                controller: 'ServiceHistoryController',
                controllerAs: 'vm',
                resolve: {
                    defaultFilters: ['filters', function (filters) {
                        return filters;
                    }]
                }
            };
            views['avcPositions@' + state] = {
                templateUrl: 'app/components/volunteer/serviceHistory/avcPositions/view.html',
                controller: 'PositionListController',
                controllerAs: 'vm',
                resolve: {
                    defaultFilters: ['filters', function (filters) {
                        var defaultFilters = angular.copy(filters);
                        defaultFilters.organizationTypes = ['AVC', 'Private Organization'];
                        defaultFilters.onlyAVCInfo = 1;
                        return defaultFilters;
                    }]
                }
            };
            views['nonAVCPositions@' + state] = {
                templateUrl: 'app/components/volunteer/serviceHistory/nonAVCPositions/view.html',
                controller: 'PositionListController',
                controllerAs: 'vm',
                resolve: {
                    defaultFilters: ['filters', function (filters) {
                        var defaultFilters = angular.copy(filters);
                        defaultFilters.organizationTypes = ['Non-AVC'];
                        defaultFilters.onlyAVCInfo = 0;
                        return defaultFilters;
                    }]
                }
            };
            views['annualHoursRecord@' + state] = {
                templateUrl: 'app/components/volunteer/serviceHistory/annualHoursRecord/view.html',
                controller: 'ServiceHistoryAnnualHoursRecordController',
                controllerAs: 'vm'
            };
            return views;
        };
        var resolve = {
            filters: function () {
                return {
                    startDate: moment().date() < 15 ? moment().subtract(1, 'months').startOf('month').toDate() : moment().startOf('month').toDate(),
                    endDate: moment().toDate(),
                    statuses: ['Approved']
                };
            },
            volunteer: ['$stateParams', 'authentication', function ($stateParams, authentication) {
                return $stateParams.id ? authentication.getUserProfile({masterUserId: $stateParams.id}).then(function (response) {
                        return {
                            firstName: response.aosUser.firstName,
                            lastName: response.aosUser.lastName
                        };
                    }) : null;
            }]
        };

        $stateProvider.state(states.volunteer, {
            url: '/service-history',
            views: views(states.volunteer),
            resolve: resolve,
            title: 'Service History'
        }).state(states.admin, {
            url: '/service-history/{id:int}',
            views: views(states.admin),
            resolve: resolve,
            title: 'Service History'
        });
    }
})();
(function () {
    'use strict';

    angular
        .module('vmis.volunteer')
        .controller('ServiceHistoryController', ServiceHistoryController);

    ServiceHistoryController.$inject = ['$scope', 'defaultFilters', 'volunteer', '$modal', '$stateParams', 'authentication'];

    function ServiceHistoryController($scope, defaultFilters, volunteer, $modal, $stateParams, authentication) {
        var vm = this;

        vm.years=[];
        vm.alerts=[];
        vm.isLoading = true;

        var year = moment().year();
        vm.years.push(year.toString());
        vm.selectedYear = year.toString();
        for(var i=0; i<9; i++){
            vm.years.push((year-(i+1)).toString());
        }

        vm.volunteer = volunteer;
        vm.startDate = moment(defaultFilters.startDate).format('MM/DD/YYYY');
        vm.endDate = moment(defaultFilters.endDate).format('MM/DD/YYYY');

        $scope.$on('serviceHistory:alert', alertHandler);
        vm.onCloseAlert = onCloseAlert;

        activate();
        vm.generateDA4713 = generateDA4713;
        vm.generateDA4162 = generateDA4162;

        vm.isLoading = false;

        function activate() {
        }

        function updateFilters() {
            $scope.$broadcast('filters', {
                startDate: moment(vm.startDate, 'MM/DD/YYYY').toDate(),
                endDate: moment(vm.endDate, 'MM/DD/YYYY').toDate()
            });
        }
        
        function generateDA4713() {
            $modal.open({
                templateUrl: 'app/components/volunteer/serviceHistory/da4713YearSelector/view.html',
                controller: 'DA4713YearSelector',
                controllerAs: 'vm',
                backdrop: 'static',
                keyboard: false,
                resolve: {
                    masterUserId: function () {
                        return $stateParams.id || undefined;
                    }
                }
            });
        }

        function generateDA4162() {
            vm.isLoading = true;
            return authentication.getDA4162({
                masterUserId: $stateParams.id || undefined
            })
                .then(function(){
                    vm.isLoading = false;
                })
                .catch(function(err){
                    vm.isLoading = false;
                    generateDAFormError(err);
                });
        }

        function generateDAFormError(error) {
            if (angular.isDefined(error)) {
                var errorStr = error.error ? error.error : error;
                $scope.$emit('serviceHistory:alert', errorStr);
            }
            else
                $scope.$emit('serviceHistory:alert', "Failed to generate form, please try again");

            vm.isLoading = false;
        }

        function alertHandler(event, message) {
            event.stopPropagation();

            displayError(message);
        }

        function onCloseAlert(index) {
            vm.alerts.splice(index, 1);
        }

        function displayAlert(type, message) {
            vm.alerts.push({
                type: type,
                message: message
            });
        }

        function displayError(error) {
            if (error === 'cancel' || error === 'backdrop click')
                return;
            if (error)
                displayAlert('alert', error);
        }
    }
})();
/**
 * Created by nbhadsavle3 on 10/18/2017.
 */
(function () {
    'use strict';

    angular
        .module('app')
        .controller('DA4713YearSelector', DA4713YearSelector);

    DA4713YearSelector.$inject = ['$scope', 'masterUserId','$modalInstance', 'authentication'];

    function DA4713YearSelector($scope, masterUserId, $modalInstance, authentication) {
        var vm = this;
        vm.isLoading = true;

        vm.years=[];
        vm.alerts=[];

        var year = moment().year();
        vm.years.push(year.toString());
        vm.selectedYear = year.toString();
        for(var i=0; i<9; i++){
            vm.years.push((year-(i+1)).toString());
        }

        $scope.$on('da4713YearSelector:alert', alertHandler);
        vm.onCloseAlert = onCloseAlert;

        activate();
        vm.generateDA4713Form = generateDA4713Form;

        vm.isLoading = false;
        function activate() {
        }

        function generateDA4713Form() {
            vm.isLoading = true;
            return authentication.getDA4713({
                year: vm.selectedYear,
                masterUserId: masterUserId
            })
            .then($modalInstance.close).catch(function (error) {
                vm.isLoading = false;
            })
            .catch(function(error){
                vm.isLoading = false;
               generateDAFormError(error);
            });
        }

        function generateDAFormError(error) {
            if (angular.isDefined(error)) {
                var errorStr = error.error ? error.error : error;
                $scope.$emit('serviceHistory:alert', errorStr);
            }
            else
                $scope.$emit('serviceHistory:alert', "Failed to generate form, please try again");

            vm.isLoading = false;
        }

        function alertHandler(event, message) {
            event.stopPropagation();

            displayError(message);
        }

        function onCloseAlert(index) {
            vm.alerts.splice(index, 1);
        }

        function displayAlert(type, message) {
            vm.alerts.push({
                type: type,
                message: message
            });
        }

        function displayError(error) {
            if (error === 'cancel' || error === 'backdrop click')
                return;
            if (error)
                displayAlert('alert', error);
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('vmis.volunteer')
        .controller('PositionListController', PositionListController);

    PositionListController.$inject = ['$scope', '$stateParams', '$modal', '_', 'authentication', 'defaultFilters'];

    function PositionListController($scope, $stateParams, $modal, _, authentication, defaultFilters) {
        var vm = this;
        var index = 0;
        var limit = 100;
        var filters = defaultFilters;

        vm.positions = null;
        vm.isLoading = true;

        vm.getDetails = getDetails;
        vm.getHours = getHours;

        $scope.$on('filters', onChangeFilters);

        activate();

        function activate() {
            getPositions();
        }

        function getPositions() {
            vm.isLoading = true;
            return authentication.getVolunteerServiceRecord({
                onlyAVCInfo: defaultFilters.onlyAVCInfo,
                masterUserId: $stateParams.id || undefined
            }).then(function (result) {
                vm.positions = result.positions.map(function (position) {
                    return {
                        id: position.id,
                        name: position.name,
                        startDate: (position.startDate === "N/A")?position.startDate:moment.utc(position.startDate).format('MM/DD/YYYY'),
                        endDate: (position.endDate === "N/A")?position.endDate:moment.utc(position.endDate).format('MM/DD/YYYY'),
                        status: position.serviceStatus,
                        organization: position.organization.name,
                        community: position.organization.community,
                        summary: position.summary,
                        hours: position.totalHoursCertified,
                        isReadonly: _.isUndefined($stateParams.id) && position.serviceStatus !== 'Active' && position.serviceStatus !== 'Finished'
                    };
                });
            }).finally(function () {
                vm.isLoading = false;
            });
        }

        function getDetails(position) {
            var options = {
                templateUrl: 'app/components/volunteer/serviceHistory/avcPositions/serviceDetailsModal/view.html',
                controller: 'PositionServiceDetailsModalController',
                controllerAs: 'vm',
                backdrop: 'static',
                keyboard: false,
                resolve: {
                    params: function () {
                        return {
                            positionId: position.id,
                            userId: $stateParams.id,
                            startDate: position.startDate,
                            endDate: position.endDate,
                            status: position.status,
                            hours: position.hours
                        };
                    }
                }
            };
            $modal.open(options).result.then(getPositions);
        }

        function getHours(id) {

        }

        function onChangeFilters(event, newFilters) {
            filters = newFilters;
            getPositions();
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('vmis.volunteer')
        .controller('PositionServiceDetailsModalController', PositionServiceDetailsModalController);

    PositionServiceDetailsModalController.$inject = ['$q', '$modalInstance', 'authentication', 'params', '_'];

    function PositionServiceDetailsModalController($q, $modalInstance, authentication, params, _) {
        var vm = this;
        var originalStatus;

        vm.save = save;
        vm.isReadonly = null;

        activate();

        function activate() {
            vm.isLoading = true;

            $q.all([
                getDropDowns(),
                getDetails(params.positionId, params.userId)
            ]).finally(function () {
                //vm.title = "Service Details - " + vm.position.title;
                vm.title = "Service Details";
                vm.isLoading = false;
            });
        }

        function getDropDowns() {
            return authentication.getUiData(['volunteerservicestatus']).then(function (response) {
                vm.serviceStatuses = params.userId ? response.volunteerservicestatus : _.slice(response.volunteerservicestatus, 0, 2);
            });
        }

        function getDetails(positionId, userId) {
            return $q.all({
                position: authentication.getOpportunityDetails({
                    volunteerOpportunityId: positionId
                })
            }).then(function (results) {
                var position = results.position;

                vm.position = {
                    community: position.communityAffiliation,
                    organization: position.volunteerOrganization,
                    title: position.title,
                    supervisors: [],
                    address: {
                        line1: position.address1,
                        line2: position.address2,
                        city: position.city,
                        state: position.usState,
                        postalCode: position.zipCode,
                        country: position.country
                    },
                    hours: params.hours
                };

                if (position.firstLineSupervisorName) {
                    vm.position.supervisors.push({
                        name: position.firstLineSupervisorName,
                        email: position.firstLineSupervisorEmail,
                        phone: position.firstLineSupervisorPhone
                    });
                }

                if (position.secondLineSupervisorName) {
                    vm.position.supervisors.push({
                        name: position.secondLineSupervisorName,
                        email: position.secondLineSupervisorEmail,
                        phone: position.secondLineSupervisorPhone
                    });
                }

                vm.service = {
                    status: params.status,
                    startDate: params.startDate,
                    endDate: params.endDate,
                    notes: null,
                    include: null
                };
                originalStatus = vm.service.status;
                vm.isReadonly = !userId && (vm.service.status !== 'Active');
            });
        }

        function save() {
            if (vm.service.status !== originalStatus) {
                return authentication.setOpportunityStatusForUser({
                    opportunityId: params.positionId,
                    volunteerServiceStatus: vm.service.status,
                    role: params.userId ? undefined : 'AVC Volunteer',
                    userId: params.userId || undefined
                }).then($modalInstance.close);
            } else {
                return $modalInstance.close();
            }
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('vmis.volunteer')
        .controller('ServiceHistoryAnnualHoursRecordController', ServiceHistoryAnnualHoursRecordController);

    ServiceHistoryAnnualHoursRecordController.$inject = ['$stateParams', 'authentication'];

    function ServiceHistoryAnnualHoursRecordController($stateParams, authentication) {
        var vm = this;

        vm.annualHoursRecords = null;
        vm.isLoading = true;

        activate();

        function activate() {
            getAnnualHoursRecord();
        }

        function getAnnualHoursRecord() {
            vm.isLoading = true;
            return authentication.getVolunteerServiceRecord({
                masterUserId: $stateParams.id || undefined
            }).then(function (result) {
                vm.annualHoursRecords = result.annualHoursRecord;
            }).finally(function () {
                vm.isLoading = false;
            });
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('vmis.volunteer')
        .controller('ServiceLogController', ServiceLogController);

    ServiceLogController.$inject = ['$scope', '$modal', '$q', '$stateParams', 'authentication', 'moment'];

    function ServiceLogController($scope, $modal, $q, $stateParams, authentication, moment) {
        var vm = this;

        vm.isLoading = true;
        vm.serviceStatus = 'Active';

        var calendarMonth = moment().month();
        var calendarYear = moment().year();

        vm.positions = [];
        vm.position = null;
        vm.periodActivity = null;
        vm.certifiedHours = 0;
        vm.submittedHours = 0;
        vm.rejectedHours = 0;
        vm.posClosed = "";

        vm.targetUser = {
            masterUserId: parseInt($stateParams.id) || null,
            firstName: "",
            lastName: ""
        };

        vm.adminEditing = angular.isNumber(vm.targetUser.masterUserId);
        vm.isOnlyAVCCAssistant = false;

        // List of communities and organizations an AVCC/OPOC has control over
        var adminResponsibilities = {};
        // List of organizations an OPOC user on this page can see
        // Remains empty if user is AVCC+
        var opocResponsibilities = [];

        vm.onShowPeriodHoursModal = onShowPeriodHoursModal;
        vm.onClickAddPosition = onClickAddPosition;
        vm.onLoadActivities = onLoadActivities;
        vm.isInFiscalYear = isInFiscalYear;
        vm.onChangePosition = onChangePosition;
        vm.reloadPositions = reloadPositions;
        vm.checkClosedPosition = checkClosedPositions;

        $scope.$on('activity:success', successHandler);
        $scope.$on('activity:alert', alertHandler);

        activate();

        function activate() {
            var promiseArray = [];

            promiseArray.push(authentication.getUiData(['volunteerservicestatus']).then(function (response) {
                vm.serviceStatuses = [];
                for (var status in response.volunteerservicestatus) {
                    var newStatus = {
                        name: response.volunteerservicestatus[status],
                        value: response.volunteerservicestatus[status]
                    };
                    vm.serviceStatuses.push(newStatus);
                }
                var allStatus = {
                    name: 'All',
                    value: undefined
                };
                vm.serviceStatuses.splice(0, 0, allStatus);
            }));

            // If volunteer, get own master user ID
            // Also check if "adminEditing" own account, in which case turn off admin mode
            promiseArray.push(authentication.getUserProfile()
                .then(function (response) {
                    if (!response.masterUserEmail) {
                        filterError("Could not retrieve user!");
                        return;
                    }

                    if (vm.adminEditing) {
                        if (vm.targetUser.masterUserId === response.masterUserId)
                            vm.adminEditing = false;

                        adminResponsibilities = response.aosUser.vmisUser.adminProfile.responsibilities;

                        // Determine if admin is only OPOC, and if so, get list of responsible organizations
                        var isOPOC = false;
                        var isAVCC = false;
                        var isAVCCAssistant = false;

                        // Instead of looking at vmisRoles, could ensure user actually has responsibilities for the role
                        //var isOPOC = angular.isDefined(adminResponsibilities.opoc);
                        //var isAVCC = angular.isDefined(adminResponsibilities.avcc);
                        //var isAVCCAssistant = angular.isDefined(adminResponsibilities.avccAssistant);

                        response.roles.vmisUserRoles.forEach(function (role) {
                            if (role === "AVC Coordinator Assistant")
                                isAVCCAssistant = true;
                            else if (role === "AVC OPOC")
                                isOPOC = true;
                            else if (role === "AVC Coordinator")
                                isAVCC = true;
                        });

                        if (isOPOC && !isAVCC && !isAVCCAssistant)
                            response.aosUser.vmisUser.adminProfile.responsibilities.opoc.forEach(function (comm) {
                                comm.organizations.forEach(function (org) {
                                    opocResponsibilities.push(org);
                                });
                            });
                        // If AVCC Assistant, do not show "Add To Position" button
                        if (isAVCCAssistant && !isOPOC && !isAVCC)
                            vm.isOnlyAVCCAssistant = true;
                    }
                    else {
                        vm.targetUser.masterUserId = response.masterUserId;
                        vm.targetUser.firstName = response.aosUser.firstName;
                        vm.targetUser.lastName = response.aosUser.lastName;
                    }
                })
                .catch(function (error) {
                    filterError(error);
                    vm.isLoading = false;
                }));

            // If admin editing, get target user profile info
            if (vm.adminEditing) {
                var params = {
                    masterUserId: vm.targetUser.masterUserId
                };
                promiseArray.push(authentication.getUserProfile(params)
                    .then(function (response) {
                        if (!response.masterUserId) {
                            filterError("Could not retrieve user!");
                            return;
                        }

                        // For calendar
                        if (!response.aosUser){
                            vm.targetUser.firstName = "Unknown";
                            vm.targetUser.firstName = "User";
                        }
                        else {
                            vm.targetUser.firstName = response.aosUser.firstName;
                            vm.targetUser.lastName = response.aosUser.lastName;
                        }
                    })
                    .catch(function (error) {
                        filterError(error);
                        vm.isLoading = false;
                    }));
            }

            // Wait until getting one or two profiles complete
            // Setting of vm.position here triggers loading of calendar activities
            $q.all(promiseArray)
                .then(function () {
                    loadPositions()
                        .then(function () {
                            vm.position = vm.positions[0];
                            onChangePosition(vm.position);
                        });
                });
        }

        function checkClosedPositions() {
            if (vm.serviceStatus === 'Active' && vm.position.status === 'Closed') {
                vm.posClosed = "This position is closed. Contact your OPOC if you believe this is in error. If you are done with this position, go to your Service History to Finish it.";
            }
            else {
                vm.posClosed = "";
            }
        }

        function reloadPositions() {
            if (vm.adminEditing) {
                loadPositions(vm.targetUser.masterUserId)
                    .then(function () {
                        vm.position = vm.positions.length >= 1 ? vm.positions[0] : null;
                        onChangePosition(vm.position);
                    });
            }
            else {
                loadPositions()
                    .then(function () {
                        vm.position = vm.positions.length >= 1 ? vm.positions[0] : null;
                        onChangePosition(vm.position);
                    });
            }
        }

        function loadPositions() {
            var params = {};

            // If admin editing, get opportunities for target user
            if (vm.adminEditing) {
                // TODO: Hard-coded numerical value should be replaced
                params = {
                    startingRowIndex: 0,
                    numberOfRows: 1000,
                    masterUserId: vm.targetUser.masterUserId,
                    volunteerApplicationStatus: 'Approved',
                    volunteerServiceStatus: vm.serviceStatus ? vm.serviceStatus : undefined
                };
                return authentication.getApplicationsAdmin(params)
                    .then(function (response) {
                        // If specifically OPOC, filter this list of volunteer positions further
                        // to only show positions within organizations OPOC is responsible for
                        //opocResponsibilities[i].volunteerOrganizationName === app.volunteerOrganization
                        vm.positions = response.applications.map(function (app) {
                            return {
                                id: app.volunteerOrganizationOpportunityId,
                                title: app.volunteerOrganization + ": " + app.volunteerOpportunity,
                                organization: app.volunteerOrganization,
                                closedDate: app.closedDate,
                                status: app.opportunityStatus, // TODO: not present
                                serviceStatus: app.volunteerServiceStatus
                            };
                        });
                    })
                    .catch(function (error) {
                        filterError(error);
                        vm.isLoading = false;
                    });
            }
            // If volunteer, get own opportunities
            else {
                // TODO: Hard-coded numerical value should be replaced
                params = {
                    startingRowIndex: 0,
                    numberOfRows: 1000,
                    volunteerApplicationStatus: 'Approved',
                    volunteerServiceStatus: vm.serviceStatus ? vm.serviceStatus : undefined
                };
                return authentication.getOpportunitiesAppliedFor(params)
                    .then(function (response) {
                        vm.positions = response.opportunities.map(function (opportunity) {
                            return {
                                id: opportunity.opportunityId,
                                title: opportunity.opportunityStatus === "Closed" ?
                                    opportunity.organizationName + ": " + opportunity.title + " (Closed)" : 
                                    opportunity.organizationName + ": " + opportunity.title,
                                organization: opportunity.organizationName,
                                closedDate: opportunity.closedDate,
                                status: opportunity.opportunityStatus,
                                serviceStatus: opportunity.serviceStatus
                            };
                        });
                    })
                    .catch(function (error) {
                        filterError(error);
                        vm.isLoading = false;
                    });
            }
        }

        function onShowPeriodHoursModal() {
            var options = {};
            if (vm.adminEditing) {
                options = {
                    templateUrl: 'app/components/administrator/hours/manageActivity.view.html',
                    controller: 'ManageActivityController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    keyboard: false,
                    resolve: {
                        activity: function () {
                            // On creating new period hours as admin, provide field
                            // to indicate that type as well as additional needed data
                            var activity = {};
                            if (vm.periodActivity) {
                                activity = angular.copy(vm.periodActivity);
                                activity.position = vm.position;
                                activity.volunteer = {
                                    firstName: vm.targetUser.firstName,
                                    lastName: vm.targetUser.lastName,
                                    masterUserId: vm.targetUser.masterUserId
                                };
                                activity.organization = vm.position.organization;
                            }
                            else {
                                activity = {
                                    type: 'Period',
                                    date: moment().year(calendarYear).month(calendarMonth).startOf('month').toDate(),
                                    position: vm.position,
                                    volunteer: {
                                        firstName: vm.targetUser.firstName,
                                        lastName: vm.targetUser.lastName,
                                        masterUserId: vm.targetUser.masterUserId
                                    },
                                    organization: vm.position.organization
                                };
                            }
                            return activity;
                        },
                        rejectOnly: function () {
                            return false;
                        }
                    }
                };
            }
            else {
                options = {
                    templateUrl: 'app/components/volunteer/activityCalendar/enterHours.view.html',
                    controller: 'EnterHoursController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    keyboard: false,
                    resolve: {
                        activity: function () {
                            var newActivity = {
                                type: 'Period',
                                date: moment().year(calendarYear).month(calendarMonth).startOf('month').toDate()
                            };
                            return vm.periodActivity !== null ? angular.copy(vm.periodActivity) : newActivity;
                        },
                        positionId: function () {
                            return vm.position.id;
                        },
                        volunteerId: function () {
                            return vm.targetUser.masterUserId;
                        },
                        readOnly: function () {
                            return (vm.disabled || !isInFiscalYear(calendarYear, calendarMonth));
                        }
                    }
                };
            }

            $modal.open(options).result
                .catch(function (error) {
                    filterError(error);
                })
                // Even if user does not submit, could have deleted documents
                .finally(reloadCalendar);
        }

        function onClickAddPosition() {
            var options = {
                templateUrl: 'app/components/volunteer/serviceLog/addToPosition.view.html',
                controller: 'AddToPositionController',
                controllerAs: 'vm',
                backdrop: 'static',
                keyboard: false,
                resolve: {
                    params: function () {
                        return {
                            occupiedPositions: vm.positions,
                            targetUser: vm.targetUser,
                            responsibilities: adminResponsibilities
                        };
                    }
                }
            };

            $modal.open(options)
                .result
                .then(function (result) {
                    vm.isLoading = true;
                    if (result.action === "success") {
                        loadPositions().then(function () {
                            vm.position = vm.positions[0];
                            for (var i = 0; i < vm.positions.length; i++) {
                                if (vm.positions[i].id === result.position.volunteerOpportunityId) {
                                    vm.position = vm.positions[i];
                                    break;
                                }
                            }
                            onChangePosition(vm.position);
                        });
                        displayAlert('success', result.message);
                    }
                    else {
                        filterError(result.message);
                        vm.isLoading = false;
                    }
                })
                .catch(function (error) {
                    filterError(error);
                });
        }

        function isInFiscalYear(year, month) {
            if (angular.isUndefined(year) || year === null) {
                year = calendarYear;
            }
            if (angular.isUndefined(month) || month === null) {
                month = calendarMonth;
            }
            var start = moment().month('October').subtract(1, 'years').startOf('month');
            var end = moment();
            if (moment().month() >= 9) {
                if (moment().month() === 9 && moment().date() < 15) {
                    start = moment().month('September').startOf('month');
                } else {
                    start = moment().month('October').startOf('month');
                }
            }
            var date = {
                year: year,
                month: month
            };
            return moment(date).isSameOrAfter(start, 'month') && moment(date).isSameOrBefore(end, 'month');
        }

        function onLoadActivities(year, month, dailyActivities, periodActivities) {
            calendarYear = year;
            calendarMonth = month;
            vm.periodActivity = periodActivities[0] || null;

            vm.certifiedHours = 0;
            vm.submittedHours = 0;
            vm.rejectedHours = 0;
            dailyActivities.forEach(updateHours);
            periodActivities.forEach(updateHours);

            function updateHours (activity) {
                switch (activity.status) {
                    case 'Certified':
                        vm.certifiedHours += activity.hours;
                        break;
                    case 'Submitted':
                        vm.submittedHours += activity.hours;
                        break;
                    case 'Rejected':
                        vm.rejectedHours += activity.hours;
                        break;
                    default:
                        break;
                }
            }
        }

        function reloadCalendar() {
            vm.reloadCalendar = true;
        }

        function onChangePosition(position) {
            if ((angular.isUndefined(position)) || (position === null)){
                vm.disabled = true;
                vm.isLoading = false;
                vm.reloadCalendar = true;
                return;
            }

            var onChangePromise = {
                application: authentication.getOpportunitiesAppliedFor({
                    volunteerOpportunityId: position.id
                }),
                position: authentication.getOpportunityDetails({
                    volunteerOpportunityId: position.id
                })
            };

            if(vm.adminEditing) {
                onChangePromise = {
                    application: authentication.getApplicationsAdmin({
                        volunteerOpportunityId: position.id,
                        masterUserId: parseInt($stateParams.id)
                    }),
                    position: authentication.getOpportunityDetails({
                        volunteerOpportunityId: position.id
                    })
                };
            }

            // TODO: Could be simplified with different/previous API calls?
            $q.all(onChangePromise)
                .then(function (responses) {
                vm.disabled = vm.adminEditing ? false : (responses.position.volunteerPositionStatus === 'Closed' ||
                    ((responses.application.opportunities.length >= 1)) &&
                    (responses.application.opportunities[0].serviceStatus !== 'Active'));
                vm.isLoading = false;
                checkClosedPositions();
            }).catch(function (error) {
                filterError(error);
                vm.isLoading = false;
            });
        }

        function successHandler(event, message) {
            event.stopPropagation();

            displayAlert('success', message);
        }

        function alertHandler(event, message) {
            event.stopPropagation();

            filterError(message);
        }

        function filterError(error) {
            if (angular.isDefined(error)) {
                var errorStr = error.error ? error.error : error;
                if (errorStr === 'ok' || errorStr === 'cancel' || errorStr === 'backdrop click')
                    displayAlert('clear');
                else
                    displayAlert('error', errorStr);
            }
        }

        function displayAlert(type, message) {
            switch (type) {
                case 'success':
                    vm.formSuccess = message;
                    vm.formError = "";
                    break;
                case 'error':
                    vm.formError = message;
                    vm.formSuccess = "";
                    break;
                case 'clear':
                    vm.formError = "";
                    vm.formSuccess = "";
                    break;
                default:
                    vm.formError = message;
                    vm.formSuccess = "";
                    break;
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('vmis.volunteer')
        .controller('AddToPositionController', AddToPositionController);

    AddToPositionController.$inject = ['$modalInstance', 'authentication', 'params'];

    function AddToPositionController($modalInstance, authentication, params) {
        var vm = this;

        var occupiedPositions = params.occupiedPositions;
        vm.targetUser = params.targetUser;
        var responsibilities = params.responsibilities;

        vm.title = "Add To Position - ";

        vm.title += vm.targetUser.firstName + " " + vm.targetUser.lastName;

        vm.selectedCommunity = null;
        vm.selectedOrganization = null;
        vm.selectedPosition = null;
        vm.isLoading = true;

        var isAVCC = angular.isDefined(responsibilities.avcc);
        var isOPOC = angular.isDefined(responsibilities.opoc);

        if (isAVCC)
        {
            vm.communities = responsibilities.avcc;

            // If AVCC, communities specified but need organizations arrays
            vm.communities.forEach(function (comm) {
                comm.organizations = [];
            });

            if (isOPOC)
            {
                for (var i = 0, len = responsibilities.opoc.length; i < len; i++) {
                    var comm = responsibilities.opoc[i];
                    var duplicateComm = (responsibilities.avcc.indexOf(comm) !== -1);
                    if (!duplicateComm)
                    {
                        comm.organizations.forEach(function (org) {
                            org.positions = [];
                        });
                        vm.communities.push(comm);
                    }
                }
            }
        }
        else
        {
            vm.communities = responsibilities.opoc;

            // If OPOC, organizations specified but need positions arrays
            vm.communities.forEach(function (comm) {
                comm.organizations.forEach(function (org) {
                    org.positions = [];
                });
            });
        }

        vm.onSelectCommunity = onSelectCommunity;
        vm.onSelectOrganization = onSelectOrganization;
        vm.onSubmit = onSubmit;

        activate();

        function activate() {
            if(!angular.isDefined(vm.communities) || vm.communities === null || vm.communities.length === 0){
                vm.formError = "This user is not allowed to add other users to positions";
                vm.isLoading = false;
                close('error', "This user is not allowed to add other users to positions");
            }
            vm.selectedCommunity = vm.communities[0];
            var params = {
                community: vm.communities[0]
            };

            selectFirstOrgFromCommunity(params).then(function(selectedVolOrg) {
                getOpportunities(selectedVolOrg);
            });
        }

        function getOpportunities(selectedVolOrg){

        // Volunteers can be added to positions in other communities or organizations
        // regardless of what their affiliated community is
        authentication.getOpportunitiesAdmin({volunteerOrganizationId: selectedVolOrg, getAll: true})
            .then(function (response) {
                // For each opportunity, place in hierarchical list
                response.opportunities.forEach(function (opp) {
                    var opportunityPlacementFound = false;
                    // Find existing community to place opportunity in
                    for (var i = 0; i < vm.communities.length; i++) {
                        if (opp.communityAffiliation === vm.communities[i].communityAffiliationName) {
                            // Find existing organization to place opportunity in
                            for (var j = 0; j < vm.communities[i].organizations.length; j++) {
                                if (opp.volunteerOrganizationId === vm.communities[i].organizations[j].volunteerOrganizationId) {
                                    addNewPosition(opp, j, i);
                                    opportunityPlacementFound = true;
                                    break; // Stop searching through organizations
                                }
                            }
                            // If new or first organization
                            if (!opportunityPlacementFound) {
                                addNewPosition(opp, opp.organization, i);
                                opportunityPlacementFound = true;
                            }
                            break; // Stop searching through communities
                        }
                    }
                    // If new or first community
                    if (!opportunityPlacementFound) {
                        addNewPosition(opp, opp.organization, opp.communityAffiliation);
                    }
                });

                if(vm.selectedOrganization.positions.length > 0){
                    vm.selectedPosition = vm.selectedOrganization.positions[0];
                }

                vm.isLoading = false;

            })
            .catch(function (error) {
                vm.formError = error;
                vm.isLoading = false;
            });

        }

        // "position" is new object to add
        // "org" and "comm" are objects if they are new or indices if already exist
        function addNewPosition(position, org, comm) {
            // If volunteer has an application for this position,
            // this modal will return an error

            // Check if user is already accepted into position
            var positionAvailable = position.volunteerPositionStatus !== "Closed";
            if (positionAvailable) {
                occupiedPositions.forEach(function (occPos) {
                    if (occPos.id === position.volunteerOrganizationOpportunityId)
                        positionAvailable = false;
                });
            }

            var commIndex = null;
            var orgIndex = null;

            if (angular.isNumber(comm))
                commIndex = comm;
            // If community object passed in, it is new
            else {
                var newComm = {
                    communityAffiliationId: 0,
                    communityAffiliationName: "",
                    organizations: []
                };
                vm.communities.push(newComm);
                commIndex = vm.communities.length - 1;
            }

            if (angular.isNumber(org))
                orgIndex = org;
            // If organization object passed in, it is new
            else {
                // Use format from OPOC responsibilities object (Name, not FullName)
                var newOrg = {
                    volunteerOrganizationId: position.volunteerOrganizationId,
                    volunteerOrganizationName: position.volunteerOrganization,
                    positions: []
                };
                vm.communities[commIndex].organizations.push(newOrg);
                orgIndex = vm.communities[commIndex].organizations.length - 1;
            }

            if (positionAvailable)
                vm.communities[commIndex].organizations[orgIndex].positions.push(position);

            return true;
        }

        function onSelectCommunity() {
            vm.selectedPosition = null;
            selectFirstOrgFromCommunity({community: vm.selectedCommunity})
                .then(function(selectedVolOrg){
                    getOpportunities(selectedVolOrg);
                });
        }

        function onSelectOrganization() {
            vm.selectedOrganization.positions = [];
            vm.selectedPosition = null;
            getOpportunities(vm.selectedOrganization.volunteerOrganizationId);

        }

        function selectFirstOrgFromCommunity(params) {
            var selectedVolOrgPromise = Promise.resolve(null);

            // return the first organization of the community otherwise get a list of orgs and then return the first one
            if(params.community.organizations.length > 0){
                vm.selectedOrganization = params.community.organizations[0];
                vm.selectedOrganization.positions = [];
                selectedVolOrgPromise = Promise.resolve(params.community.organizations[0].volunteerOrganizationId);
            }

            else {
                selectedVolOrgPromise = authentication.getOrganizations({communityAffiliationId: params.community.communityAffiliationId, isActive: true, getAll: true})
                    .then(function(orgs){
                        orgs.organizations.forEach(function(org){
                            if(org.organizationName != "Volunteer Submitted") {
                                var newOrg = {
                                    volunteerOrganizationId: org.volunteerOrganizationId,
                                    volunteerOrganizationName: org.organizationName,
                                    positions: []
                                };
                                params.community.organizations.push(newOrg);
                            }
                        });
                        if(params.community.organizations.length > 0) {
                            vm.selectedOrganization = params.community.organizations[0];
                            return params.community.organizations[0].volunteerOrganizationId;
                        }
                        else {
                            return null;
                        }
                    });
            }

            return selectedVolOrgPromise;
        }

        function onSubmit() {
            vm.isLoading = true;

            var params = {
                volunteerOpportunityId: vm.selectedPosition.volunteerOrganizationOpportunityId,
                masterUserId: vm.targetUser.masterUserId
            };

            authentication.setVolunteerForOpportunity(params)
                .then(function (response) {
                    close('success', "Volunteer successfully added to position!", vm.selectedPosition);
                })
                .catch(function (error) {
                    close('error', "Failed to add volunteer to position: " + error);
                });
        }

        function close(action, msg, position) {
            $modalInstance.close({
                action: action,
                message: msg,
                position: position ? position : null
            });
        }
    }
})();
// This file is regenerated each time the app is run using the version value in package.json.var APP_VERSION = '1.6.0';



(function(){'use strict';angular.module('templates').run(['$templateCache', function($templateCache) {$templateCache.put('app/components/vmis.view.html','<header role="banner" class="site-header"> <icon id="hamburger-button" name="fa-bars" class="header-icon-menu clickable register-header" ng-click="vm.showMenu = !vm.showMenu;" alt="Select this icon to open the list of AFWP sites"></icon> <div id="hamburger-dropdown" class="main-menu" ng-show="vm.showMenu" style="padding: 0; background: transparent; border: none;"> <ul> <li style="border: 0 solid black;" ng-repeat="website in vm.websiteFamilyList"> <a class="main-menu-links" href="{{website.url}}" target="_blank"> <icon name="fa-circle" class="{{website.color}}"></icon> {{website.name}} </a> </li> </ul> </div> <div id="header-logo-title-section" ng-class="{title: vm.isLoggedIn}" ng-click="vm.goHome()"> <img class="site-icon" src="../../assets/img/US-Army-logo-small.png" alt="Select this US Army logo to go to the dashboard"> <h1 class="show-for-large">Volunteer Management Information System</h1> <h1 class="hide-for-large">VMIS</h1> </div> <div class="header-right float-right"> <div id="header-notifications-section" tooltip="{{notificationObject.unreadNotifications}} Unread Notifications" ng-click="vm.redirectToDashboard()" tooltip-placement="bottom" tooltip-popup-delay="200" class="clickable" style="position: relative; yPadding: 250px;"> <div ng-if="vm.isLoggedIn === true" class="notification-header"> <icon name="fa-bell" ng-click="vm.redirectToDashboard()"></icon> <span style="color: black; background-color: white;\n                             border-radius: 25px; position: relative; bottom: 3px;"> &nbsp;{{notificationObject.unreadNotifications}}&nbsp; </span> </div> </div> <div ng-if="vm.isLoggedIn"> <vmis-dropdown id="header-user-section" is-open="vm.isDropdownOpen"> <vmis-dropdown-toggle class="user-button"> <icon name="fa-user-circle-o" alt="User Icon"></icon> <div class="profile-badge"> <span class="header-right-text">{{vm.firstName}}</span> <span ng-if="!!vm.lastLoginDate" class="last-login">Last Login: {{vm.lastLoginDate}} </span> </div> <icon name="fa-caret-down" alt="Select this caret to view profile, change account settings, or log out"></icon> </vmis-dropdown-toggle> <vmis-dropdown-pane> <ul class="menu vertical"> <li id="user-dropdown-profile" ng-click="vm.onClickViewProfile()">View Profile</li> <li id="user-dropdown-account-management" ng-click="vm.onClickViewAccountSettings()">Account Management</li> <li class="separator"></li> <li id="user-dropdown-logout" ng-click="vm.onClickLogOut()">Log Out</li> </ul> </vmis-dropdown-pane> </vmis-dropdown> </div> <div id="header-register" class="clickable" ng-if="!vm.isLoggedIn"> <a ui-sref="vmis.register" class="register-header"><span class="header-right-text no-hover">Register</span></a> </div> <div id="header-login" class="clickable login-button" ng-click="vm.logIn()" ng-if="!vm.isLoggedIn"> <icon name="fa-user-circle" class="no-hover" alt=""></icon> <span class="header-right-text no-hover">Log In</span> </div> </div> </header> <button class="nav-button button" ng-class="{\'is-shown\': vm.navClosed}" ng-click="vm.toggleNav()" aria-label="Side navigation bar toggle"> <icon name="fa-caret-right" class="icon-big clickable" alt="Select this icon to toggle the side navigation bar"></icon> </button> <nav role="navigation" id="vmis-sidebar-nav" class="nav-bar" data-sticky-container ng-class="{\'is-closed\': vm.navClosed}"> <div id="nav-dashboard" class="nav-entry" ui-sref-active="active" ng-if="vm.isLoggedIn"> <h4 class="nav-title" ui-sref="vmis.dashboard">Dashboard</h4> </div> <div ng-show="vm.hasAdditionalRole()"> <h4 id="nav-admin-header" class="nav-title nav-static-title">Administrator</h4> <ul class="vertical menu"> <li id="nav-merge-accounts" class="nav-entry" ui-sref-active="active" ng-show="vm.isRole.afwpAdmin"> <a ui-sref="vmis.administrator.mergeAccounts"> Merge Accounts </a> </li> <li id="nav-organizations" class="nav-entry" ui-sref-active="active" ng-show="vm.isRole.coordinator"> <a ui-sref="vmis.administrator.organizations"> Organizations </a> </li> <li id="nav-organization-groups" class="nav-entry" ui-sref-active="active" ng-show="vm.isRole.programManager"> <a ui-sref="vmis.administrator.organizationGroups"> Organization Groups </a> </li> <li id="nav-standard-organizations" class="nav-entry" ui-sref-active="active" ng-show="vm.isRole.programManager"> <a ui-sref="vmis.administrator.standardOrganizations"> Standard Organizations </a> </li> <li id="nav-standard-positions" class="nav-entry" ui-sref-active="active" ng-show="vm.isRole.programManager"> <a ui-sref="vmis.administrator.standardPositions"> Standard Positions </a> </li> <li id="nav-invitations" class="nav-entry" ui-sref-active="active" ng-show="vm.isRole.coordinator"> <a ui-sref="vmis.administrator.invitations"> Invitations </a> </li> <li class="nav-entry" ui-sref-active="active" ng-show="vm.isRole.opoc || vm.isRole.coorAssistant ||\n                vm.isRole.coordinator || vm.isRole.regionManager ||\n                vm.isRole.programManager"> <a ui-sref="vmis.administrator.people"> People </a> </li> <li id="nav-applications-admin" class="nav-entry" ui-sref-active="active" ng-show="vm.isRole.opoc || vm.isRole.coordinator"> <a ui-sref="vmis.administrator.applications"> Applications </a> </li> <li id="nav-positions" class="nav-entry" ui-sref-active="active" ng-show="vm.isRole.opoc || vm.isRole.coordinator"> <a ui-sref="vmis.administrator.positions"> Positions </a> </li> <li id="nav-hours" class="nav-entry" ui-sref-active="active" ng-show="vm.isRole.opoc || vm.isRole.coorAssistant || vm.isRole.coordinator"> <a ui-sref="vmis.administrator.hours"> Hours </a> </li> <li id="nav-reports" class="nav-entry" ui-sref-active="active" ng-show="vm.isRole.opoc || vm.isRole.coordinator || vm.isRole.regionManager || vm.isRole.programManager"> <a ng-href="{{vm.reportsUrl}}" target="_blank"> Reports </a> </li> </ul> </div> <h4 id="nav-volunteer-header" class="nav-title nav-static-title">Volunteer</h4> <ul class="vertical menu"> <li id="nav-service-log" class="nav-entry" ui-sref-active="active" ng-show="vm.isRole.volunteer"> <a ui-sref="vmis.volunteer.serviceLog"> Service Log </a> </li> <li id="nav-applications-volunteer" class="nav-entry" ui-sref-active="active" ng-show="vm.isRole.volunteer"> <a ui-sref="vmis.volunteer.applications"> Applications </a> </li> <li id="nav-opportunities" class="nav-entry" ui-sref-active="active"> <a ui-sref="vmis.volunteer.opportunities"> Opportunities </a> </li> <li id="nav-records" class="nav-entry" ui-sref-active="active" ng-show="vm.isRole.volunteer"> <a ui-sref="vmis.volunteer.records"> Records </a> </li> <li id="nav-service-history" class="nav-entry" ui-sref-active="active" ng-show="vm.isRole.volunteer"> <a ui-sref="vmis.volunteer.serviceHistory"> Service History </a> </li> <li id="nav-avcc-locator" class="nav-entry" ui-sref-active="active"> <a ui-sref="vmis.volunteer.avccLocator"> AVCC Locator </a> </li> <li id="nav-close" class="nav-entry hide-for-large"> <a ng-click="vm.toggleNav()">Close Side Nav</a> </li> </ul> </nav> <main role="main" class="main-view" ng-class="{\'nav-closed\': vm.navClosed}"> <div ui-view style="position:relative;"></div> </main> <footer role="contentinfo" class="site-footer expanded row"> <span id="faq-section"> <a id="faq-link" target="_blank" ng-href="{{vm.faqUrl}}">FAQ</a> <span class="link-divider">|</span> <span id="contact-helpdesk"> <a id="contact-helpdesk-link" target="_blank" ng-href="{{vm.contactHelpDeskUrl}}">Contact Help Desk</a> </span> <span class="link-divider">|</span> <span class="lite-mode-text" ng-click="vm.toggleLiteMode()" tooltip="VMIS Lite is for slower connections" tooltip-popup-delay="200">{{vm.vmisLiteText}}</span> </span> <span class="link-divider">|</span> <span> <img class="footer-logos" src="../../../assets/img/AMC-IMCOM-MWR-ACS-Color.png"> </span> <span ng-if="vm.footerMessage.length"> <span class="link-divider">|</span> <span id="footer-info-section"> {{vm.footerMessage}} </span> </span> <span class="link-divider">|</span> <span id="about-section" ng-class="{\'small-2-offset\': vm.showMyLiveChat}"> <a id="about-link" ng-click="vm.openAboutModal()">About</a> </span> </footer> <live-chat ng-if="vm.showMyLiveChat"></live-chat> ');
$templateCache.put('app/components/vmisPrint.view.html','<h1>{{vm.details.title}}</h1> <table class="table print-table"> <tbody> <tr> <td class="print-label-column"> Posted Date </td> <td class="print-value-column"> <div>{{vm.details.postedDate | date:\'d MMMM yyyy\'}}</div> </td> </tr> <tr ng-if="!vm.isVolunteerSubmitted"> <td class="print-label-column"> Closed Date </td> <td class="print-value-column"> <div>{{vm.details.closedDate | date:\'d MMMM yyyy\'}}</div> </td> </tr> <tr> <td class="print-label-column"> Community </td> <td class="print-value-column"> <div>{{vm.details.communityAffiliation}}</div> </td> </tr> <tr> <td class="print-label-column"> Organization </td> <td class="print-value-column"> <div>{{vm.details.volunteerOrganization}}</div> </td> </tr> <div ng-if="vm.isVolunteerSubmitted"> <td class="print-label-column"> Summary </td> <td class="print-value-column"> <div>{{vm.details.summary}}</div> </td> </div> <tr ng-if="!vm.isVolunteerSubmitted"> <td class="print-label-column"> Position Type </td> <td class="print-value-column"> <div>{{vm.details.volunteerPositionType}}</div> </td> </tr> <tr ng-if="!vm.isVolunteerSubmitted"> <td class="print-label-column"> Opportunity Type </td> <td class="print-value-column"> <div>{{vm.details.volunteerOpportunityType}}</div> </td> </tr> <tr> <td class="print-label-column"> Background Check Required </td> <td class="print-value-column"> <div>{{vm.details.isBackgroundCheckRequired}}</div> </td> </tr> <tr ng-if="!vm.isVolunteerSubmitted"> <td class="print-label-column"> Supervision Required </td> <td class="print-value-column"> <div>{{vm.details.supervisionConditionFlag}}</div> </td> </tr> <tr> <td class="print-label-column"> Duties </td> <td class="print-value-column"> <div class="angular-with-newlines">{{vm.details.duties}}</div> </td> </tr> <tr> <td class="print-label-column"> Qualifications </td> <td class="print-value-column"> <div>{{vm.details.qualifications}}</div> </td> </tr> <tr> <td class="print-label-column"> Training </td> <td class="print-value-column"> <div>{{vm.details.training}}</div> </td> </tr> <tr> <td class="print-label-column"> Orientation </td> <td class="print-value-column"> <div>{{vm.details.orientation}}</div> </td> </tr> <tr> <td class="print-label-column"> Time Required </td> <td class="print-value-column"> <div>{{vm.details.timeRequired}}</div> </td> </tr> <tr ng-if="!vm.isVolunteerSubmitted"> <td class="print-label-column"> Evaluation </td> <td class="print-value-column"> <div>{{vm.details.evaluation}}</div> </td> </tr> <tr ng-if="!vm.isVolunteerSubmitted"> <td class="print-label-column"> Benefits </td> <td class="print-value-column"> <div>{{vm.details.benefits}}</div> </td> </tr> <tr> <td class="print-label-column"> Address </td> <td class="print-value-column"> {{vm.details.address1}}<br ng-show="vm.details.address2"> {{vm.details.address2}}<br> {{vm.details.city}}<span ng-show="vm.details.city">,</span> {{vm.details.usState}} {{vm.details.zipCode}}<br> {{vm.details.country}} </td> </tr> <tr> <td class="print-label-column"> Supervisor 1 </td> <td class="print-value-column"> <div>{{vm.details.firstLineSupervisorName}}</div> <div>{{vm.details.firstLineSupervisorPhone}}</div> <div>{{vm.details.firstLineSupervisorEmail}}</div> </td> </tr> <tr ng-if="!vm.isVolunteerSubmitted"> <td class="print-label-column"> Supervisor 2 </td> <td class="print-value-column"> <div>{{vm.details.secondLineSupervisorName}}</div> <div>{{vm.details.secondLineSupervisorPhone}}</div> <div>{{vm.details.secondLineSupervisorEmail}}</div> </td> </tr> <tr> <td class="print-label-column" style="vertical-align: top;"> OPOCs </td> <td class="print-value-column"> <div ng-repeat="opoc in vm.opocs"> <br ng-if="!$first"> <div>{{opoc.firstName}} {{opoc.lastName}}</div> <div> <a ng-href="mailto:{{opoc.email}}" target="_self"> {{opoc.email}} </a> </div> <div>{{opoc.phone}}</div> </div> </td> </tr> </tbody> </table> ');
$templateCache.put('app/components/about/about.modal.view.html','<modal close="aboutModal.stayOpen ? null : $dismiss" modal-title="About VMIS"> <modal-body> <loading-icon show="aboutModal.isLoading"></loading-icon> <div class="row" ng-hide="aboutModal.isLoading"> <div class="small-12 columns"> <h4 id="acronym-definition">Volunteer Management Information System</h4> <p id="explanation">See the <a id="landing-page-link" ui-sref="landing">landing page</a> for general information about this system. Use "Learn about this page" links at the top-right of pages for feature details. The below table lists version and status information about the system:</p> </div> <div class="small-12 columns"> <table class="information-table table"> <thead> <tr> <th>Component</th> <th>Version</th> <th>Additional Info</th> </tr> </thead> <tbody> <tr ng-show="aboutModal.vmisUi.display" ng-class-even="\'even\'" ng-class-odd="\'odd\'"> <td id="vmis-ui-title">VMIS User Interface</td> <td id="vmis-ui-version">{{aboutModal.vmisUi.numericalVersion}}</td> <td id="vmis-ui-info"> Deployed: <span id="vmis-ui-date">{{aboutModal.vmisUi.date}}</span> <span ng-if="aboutModal.vmisUi.url"> <br> Hash: (<a id="vmis-ui-commit-url" target="_blank" ng-href="{{aboutModal.vmisUi.url}}">{{aboutModal.vmisUi.version}}</a><span id="vmis-ui-commit" ng-if="!aboutModal.vmisUi.url">{{aboutModal.vmisUi.version}}</span>) </span> </td> </tr> <tr ng-show="aboutModal.vmisUi.display" ng-class-even="\'even\'" ng-class-odd="\'odd\'"> <td id="vmis-api-title">VMIS API</td> <td id="vmis-api-version">{{aboutModal.vmisApi.version}}</td> <td id="vmis-api-info">{{aboutModal.vmisApi.online ? "Online" : "Offline"}}</td> </tr> <tr ng-show="aboutModal.vmisUi.display" ng-class-even="\'even\'" ng-class-odd="\'odd\'"> <td id="core-api-title">Core API</td> <td id="core-api-version">{{aboutModal.coreApi.version}}</td> <td id="core-api-info">{{aboutModal.coreApi.online ? "Online": "Offline"}}</td> </tr> <tr ng-hide="aboutModal.vmisUi.display"> <td id="no-data-row" colspan="3"> System version information unavailable </td> </tr> </tbody> </table> </div> </div> </modal-body> <modal-footer> <button type="submit" class="dflt button pull-right" ng-click="$close()" ng-hide="aboutModal.stayOpen">OK</button> </modal-footer> </modal> ');
$templateCache.put('app/components/dashboard/acceptOPOCInviteDetails.modal.html','<form name="form" ng-submit="modal.AcceptInvite()"> <modal close="$dismiss" modal-title="OPOC Invitation"> <modal-body> <div ng-show="modal.formError" class="callout alert">{{modal.formError}}</div> <p> You have been invited through the Army Volunteer Corps (AVC) to register as an Army Volunteer Corps Organization Point of Contact (AVC OPOC) in the following communit(y/ies):</p> <ul> <li ng-repeat="community in modal.communities">{{community.name}}</li> </ul> <p>for the following organization(s):</p> <ul> <li ng-repeat="organization in modal.organizations">{{organization.name}}</li> </ul> <i ng-if="modal.isAccepted">You have already accepted this invitation.</i> </modal-body> <modal-footer> <div class="float-right"> <button type="submit" class="dflt button" ng-disabled="modal.formError || modal.isAccepted">Accept</button> <button type="button" class="dflt button" ng-click="$dismiss()">Cancel</button> </div> </modal-footer> </modal> </form>');
$templateCache.put('app/components/dashboard/dashboard.view.html','<learn-about-this-page learn-title="About Dashboard Page" text-body="Welcome to the Volunteer Management Information System (VMIS). VMIS is a web application that allows volunteers within the military community to find and apply for volunteer opportunities, record and track their volunteer hours, and manage their volunteer service record. VMIS also assists the Army Volunteer Corps in managing these dedicated volunteers.\nThis page is known as the Dashboard. The Dashboard provides several resources that are useful on a daily basis to both volunteers and administrators. These common resources include a Notifications area, Log Hours area, and hour chart representing the volunteer\u2019s current number of submitted, approved, and rejected hours for the month.\nThe Dashboard can be accessed from any page on VMIS while logged in \u2013 simply select Dashboard from the left-hand navigation menu."></learn-about-this-page> <div class="dashboard"> <div class="row"> <alert ng-repeat="alert in vm.alerts" type="alert.type" close="vm.onCloseAlert($index)">{{alert.message}}</alert> </div> <h1 class="row section-header">Notifications</h1> <div class="row"> <div class="tile"> <div class="tile-fill small-12 columns"> <div ng-hide="vm.isLoading"> <div class="lead" style="float: left; margin-bottom: 10px;"> <span class="notification-badge">Unread:</span> <span class="badge notification-badge" ng-if="vm.unreadNotifications">{{vm.unreadNotifications}} </span> <span class="badge notification-badge" ng-if="!vm.unreadNotifications">0</span> </div> <a id="notification-delete-all" style="cursor: pointer;float: right; margin-left: 10px" ng-click="vm.onDeleteAllClick()"> Delete All </a> <a id="notification-mark-all-read" style="cursor: pointer;float: right;" ng-click="vm.onMarkAllReadClick()"> Mark All Read </a> </div> <div style="width: 100%; max-height: 30vh; margin-bottom: 10px; overflow: auto;" ng-hide="vm.isLoading" tabindex="0"> <table class="table information-table"> <tr ng-repeat="row in vm.notifications | orderBy:postedDate"> <td id="dashboard-notification-{{$index}}" ng-click="vm.onNotificationClick(row)" class="clickable table-icon-column-entry"> <icon name="fa-circle" aria-hidden="true" class="icon-notifications" ng-class="{\'icon-notif-unread\': !row.read, \'icon-notif-read\': row.read}"></icon> </td> <td ng-click="vm.onNotificationClick(row)" class="clickable"> {{row.subject}} </td> <td ng-click="vm.onNotificationClick(row)" class="clickable"> {{row.postedDate | date:\'d MMM yyyy\'}} </td> <td class="table-icon-column-entry"> <icon id="notification-delete-badge-{{$index}}" name="fa-trash-o" class="icon-lg clickable" aria-hidden="true" ng-click="vm.onDeleteNotificationClick(row)"></icon> </td> </tr> <tr ng-if="vm.notifications.length == 0"> <td> You have no notifications. </td> </tr> </table> <load-more is-loading="vm.isLoading" load-status="vm.loadStatus" on-load-more="vm.onLoadMore()" on-load-all="vm.onLoadAll()" class="load-more-narrow"></load-more> </div> <loading-icon show="vm.isLoading"></loading-icon> </div> </div> </div> <div ui-view="coordinator" ng-if="!vm.isLiteMode && vm.isCoordinator"></div> <div ui-view="opocAvccAssistant" ng-if="!vm.isLiteMode && (vm.isOpoc || vm.isAvccAssistant)"></div> <div ui-view="volunteer" ng-if="vm.isVolunteer"></div> </div> ');
$templateCache.put('app/components/dashboard/deleteAllNotifications.modal.view.html','<form name="form"> <modal close="$dismiss" modal-title="Delete all"> <modal-body> <p>Are you sure you want to delete all of your notifications?</p> </modal-body> <modal-footer> <div class="pull-right"> <button type="submit" class="dflt button" ng-click="$close()">Yes</button> <button type="button" class="dflt button" ng-click="$dismiss()">No</button> </div> </modal-footer> </modal> </form>');
$templateCache.put('app/components/dashboard/notificationDetails.modal.view.html','<form name="form"> <modal close="$dismiss" modal-title="{{modal.notification.subject}}"> <modal-body> <div class="row"> <div class="small-12 columns"> <div class="form-control-static" ng-bind-html="modal.notification.body"> </div> </div> </div> </modal-body> <modal-footer> <button type="submit" class="dflt button pull-right" ng-click="$close()">OK</button> </modal-footer> </modal> </form>');
$templateCache.put('app/components/dashboard/opocDetails.view.html','<form ng-submit="$close()" name="form"> <modal close="$dismiss" modal-title="OPOC Details"> <modal-body> <div ng-repeat="opoc in vm.opocs"> <label><b>Name:</b> {{opoc.name}}</label> <label><b>Phone:</b> {{opoc.phone}}</label> <label><b>DSN Phone:</b> {{opoc.dsnPhone}}</label> <label><b>Email:</b> {{opoc.email}}</label> <br> </div> </modal-body> <modal-footer> <button type="submit" class="dflt button pull-right" ng-click="$close()">OK</button> </modal-footer> </modal> </form>');
$templateCache.put('app/components/dashboard/showOPOCInviteDetails.modal.html','<form ng-submit="$close()" name="form"> <modal close="$dismiss" modal-title="OPOC Invite Deleted"> <modal-body> <div class="row"> <p class="form-control-static"> {{modal.details.body}} </p> </div> </modal-body> <modal-footer> <button type="submit" class="dflt button pull-right" ng-click="$close()">OK</button> </modal-footer> </modal> </form>');
$templateCache.put('app/components/idle/idle.view.html','<form ng-submit="$close()" name="form"> <modal modal-title="Stay Logged In?"> <modal-body> You will be logged out of VMIS in {{vm.countdown}} second(s) due to inactivity. </modal-body> <modal-footer> <div class="float-right"> <div> <button type="button" class="dflt button" ng-click="$close()">Stay Logged In</button> </div> </div> </modal-footer> </modal> </form>');
$templateCache.put('app/components/landingPage/landingPage.view.html','<div class="landing-page-header"> <icon name="fa-bars" class="header-icon-menu clickable register-header" ng-click="vm.showMenu = !vm.showMenu;"></icon> <div ng-show="vm.showMenu" class="main-menu" style="padding: 0; background: transparent; border: none"> <ul id="landing-list"> <li style="border: 0 solid black" ng-repeat="website in vm.websiteFamilyList"> <a class="main-menu-links" href="{{website.url}}" target="_blank"> <icon name="fa-circle" class="{{website.color}}"></icon> {{website.name}} </a> </li> </ul> </div> <div ng-class="{title: vm.isLoggedIn}" ng-click="vm.goHome()"> <img class="site-icon" src="../../assets/img/US-Army-logo-small.png" alt="US Army logo"> <h1 class="show-for-large">Volunteer Management Information System</h1> <h1 class="hide-for-large">VMIS</h1> </div> </div> <div id="home-page-main-image" class="expanded row"> <div id="home-page-inner-content"> <div id="main-box" class="home-page-box"> <div class="row"> <div class="small-12 columns"> <div id="site-icon"> <p><img id="home-page-logo" src="/assets/img/avc_logo.png" alt="AVC Logo"></p> </div> <h2>Volunteer Management Information System</h2> </div> </div> <div id="home-page-lower-inner-text" class="row small-12 columns"> <div class="small-7 columns"> <p id="vmis-description"> Volunteer Management Information System (VMIS) provides tools to manage volunteerism in your military community. </p> </div> <div id="home-buttons" class="small-4 columns end"> <button id="landing-page-login" class="button" ng-click="vm.logIn()">Log In</button> <p>OR</p> <button id="landing-page-guest" ui-sref="vmis" class="button">Use Site as Guest</button> <p> Not a member? <a ui-sref="vmis.register">Register</a> or <a ui-sref="vmis.migrateUser">transition your account</a>. </p> </div> </div> </div> <div id="browser-box" class="home-page-box"> <div class="row"> <div class="small-12 large-9 small-centered columns"> <p id="home-page-browser-info"> Supported browsers for AFWP Applications are Edge, Chrome, and Firefox. You may experience functionality and appearance differences when using the application depending on your browser version. </p> </div> </div> </div> </div> <div id="home-page-scroll-button" data-magellan> <a href="#about" aria-label="About"><icon id="home-page-scroll-icon" name="fa-angle-down"></icon></a> </div> </div> <div class="expanded row" id="about"> <div id="about-section"> <div class="large-3 columns first-home-box"> <img src="/assets/img/avc_logo.png" alt="AVC Logo"> </div> <div class="large-3 columns home-box left-center-home-box"> <h4>What is VMIS?</h4> <br> <br> <br> <p> Volunteers play an integral role in the life of soldiers and their families, and are found throughout the military community. The Volunteer Management Information System (VMIS) assists the Army Volunteer Corps in managing these dedicated volunteers and allows volunteers a way track their hours, awards, trainings and certificates. </p> </div> <div class="large-3 columns home-box right-center-home-box"> <h4>What can volunteers do in VMIS?</h4> <br> <p> Volunteers can apply for volunteer opportunities, record and track volunteer hours, and manage their volunteer service record. </p> </div> <div class="large-3 columns end home-box last-home-box"> <h4>What can administrators do in VMIS?</h4> <br> <p> Administrators can engage in online volunteer recruitment, manage military community volunteerism (hours, positions, awards, and trainings), and produce simple reports on program statistics. </p> </div> </div> </div> ');
$templateCache.put('app/components/loggedOut/loggedOut.view.html','<div id="logged-out-page"> <h1 id="logout-text">Logged Out</h1> <alert id="logout-alert" type="\'warning\'" ng-show="vm.formError">{{vm.formError}}</alert> <p>You\'ve been logged out of Single Sign On (SSO) for VMIS.</p> <p>You may still be logged in to other AFWP systems. Close your browser to completely log out from them.</p> <p>Click <a id="log-back-in-text" ui-sref="vmis.logIn">here</a> to log back in.</p> </div> ');
$templateCache.put('app/components/profile/aosProfile.view.html','<table class="information-table table"> <thead> <tr> <th>Personal Information</th> </tr> </thead> </table> <div class="row" ng-if="vm.masterUserId"> <div class="small-3 columns"> <label class="bold text-right middle"> Log-In Email </label> </div> <div class="small-9 columns profile-label"> {{vm.email}} </div> </div> <div class="row" ng-if="vm.masterUserId"> <div class="small-3 columns"> <label class="bold text-right middle"> Legacy Username<br>(Migrated, Legacy Email) </label> </div> <div class="small-9 columns profile-label"> {{vm.username}} </div> </div> <div class="row"> <div class="small-3 columns"> <label for="first-name" class="bold text-right middle"> First Name<span class="required text">*</span> </label> </div> <div class="small-9 columns"> <input id="first-name" ng-maxlength="250" type="text" ng-model="vm.aosProfile.firstName" required autocomplete="given-name"> </div> </div> <div class="row"> <div class="small-3 columns"> <label for="middle-initial" class="bold text-right middle"> Middle Initial </label> </div> <div class="small-9 columns"> <input id="middle-initial" ng-maxlength="1" type="text" ng-model="vm.aosProfile.middleInitial"> </div> </div> <div class="row"> <div class="small-3 columns"> <label for="last-name" class="bold text-right middle"> Last Name<span class="required text">*</span> </label> </div> <div class="small-9 columns"> <input id="last-name" ng-maxlength="250" type="text" ng-model="vm.aosProfile.lastName" required autocomplete="family-name"> </div> </div> <div class="row"> <div class="small-3 columns"> <label class="bold text-right middle" for="birthDay"> Date of Birth<span class="required text">*</span> </label> </div> <div class="small-9 columns"> <span class="input-group"> <input type="text" id="birthDay" class="input-group-field" ng-model="vm.aosProfile.dateOfBirth" data-ng-change="vm.onChangeBirthday(vm.aosProfile.dateOfBirth)" placeholder="MM/DD/YYYY" vmis-datepicker target="date-of-birth" format="M/D/YYYY" end-date required> <span class="input-group-button"> <button id="date-of-birth" type="button" class="dflt button icon-button" aria-label="Date of Birth"> <icon name="fa-calendar" class="icon-big"></icon> </button> </span> </span> </div> </div> <div class="row"> <div class="small-3 columns"> <label for="military-community" class="bold text-right middle"> Military Community<span class="required text">*</span> </label> </div> <div class="small-9 columns" id="military-community"> <ui-select required data-ng-model="vm.aosProfile.militaryCommunity"> <ui-select-match placeholder="Select a community or search..."> {{$select.selected.communityAffiliationName}} </ui-select-match> <ui-select-choices repeat="comm in vm.dropDowns.communities | propsFilter: {communityAffiliationName: $select.search}"> <span ng-bind-html="comm.communityAffiliationName | highlight: $select.search"></span> </ui-select-choices> </ui-select> </div> </div> <table class="information-table table"> <thead> <tr> <th>Demographic Information</th> </tr> </thead> </table> <div class="row"> <div class="small-3 columns"> <label for="branch" class="bold text-right middle"> Branch<span class="required text">*</span> </label> </div> <div class="small-9 columns" id="branch"> <ui-select required data-ng-model="vm.aosProfile.branch"> <ui-select-match placeholder="Select a branch or search..."> {{$select.selected}} </ui-select-match> <ui-select-choices repeat="branch in vm.dropDowns.branches | filter:$select.search"> <span ng-bind-html="branch | highlight: $select.search"></span> </ui-select-choices> </ui-select> </div> </div> <div class="row"> <div class="small-3 columns"> <label for="component" class="bold text-right middle"> Component<span class="required text">*</span> </label> </div> <div class="small-9 columns" id="component"> <ui-select required data-ng-model="vm.aosProfile.component"> <ui-select-match placeholder="Select a component or search..."> {{$select.selected}} </ui-select-match> <ui-select-choices repeat="comp in vm.dropDowns.components | filter:$select.search"> <span ng-bind-html="comp | highlight: $select.search"></span> </ui-select-choices> </ui-select> </div> </div> <div class="row"> <div class="small-3 columns"> <label class="bold text-right"> Disposition(s)<span class="required text">*</span> </label> </div> <fieldset class="small-9 columns"> <div ng-repeat="(name, disposition) in vm.dispositions"> <input id="disposition-{{$index}}" type="checkbox" ng-model="disposition.selected" ng-model-options="{allowInvalid: true}" ng-change="vm.onChangeDisposition(disposition)" ng-required="!vm.dispositionsSelected"> <label for="disposition-{{$index}}" ng-class="{\'simple-tip\': (name === \'Non-DoD Civilian\')}" tooltip="{{(name === \'Non-DoD Civilian\') ? \'Non-DoD Civilian includes friends, significant others, and other designations not captured in the other Disposition options.\' : \'\'}}" tooltip-popup-delay="1000"> {{name}} </label> <div ng-switch="name" ng-show="disposition.selected" class="columns"> <label ng-switch-when="Service Member">Rank<span class="required text">*</span> <ui-select data-ng-required="disposition.selected" data-ng-model="vm.aosProfile.rank"> <ui-select-match placeholder="Select a rank or search..."> {{$select.selected}} </ui-select-match> <ui-select-choices repeat="rank in vm.dropDowns.ranks | filter:$select.search"> <span ng-bind-html="rank | highlight: $select.search"></span> </ui-select-choices> </ui-select> </label> <label ng-switch-when="Family Member">Sponsor\'s Rank<span class="required text">*</span> <ui-select data-ng-required="disposition.selected" data-ng-model="vm.aosProfile.sponsorRank"> <ui-select-match placeholder="Select a rank or search..."> {{$select.selected}} </ui-select-match> <ui-select-choices repeat="rank in vm.dropDowns.ranks | filter:$select.search"> <span ng-bind-html="rank | highlight: $select.search"></span> </ui-select-choices> </ui-select> </label> <label ng-switch-when="DoD Civilian">Civilian Rank<span class="required text">*</span> <ui-select data-ng-required="disposition.selected" data-ng-model="vm.aosProfile.civilianRank"> <ui-select-match placeholder="Select a rank or search..."> {{$select.selected}} </ui-select-match> <ui-select-choices repeat="rank in vm.dropDowns.civilianRanks | filter:$select.search"> <span ng-bind-html="rank | highlight: $select.search"></span> </ui-select-choices> </ui-select> </label> </div> </div> </fieldset> </div>');
$templateCache.put('app/components/profile/changeCommunity.view.html','<modal close="$dismiss" modal-title="{{vm.name ? \'Has \'+vm.name : \'Have you\'}} moved?"> <modal-body> <p>Would you like to finish {{vm.name ? vm.name+\'\\\'s\' : \'your\'}} position(s) at {{vm.community}}?</p> </modal-body> <modal-footer> <div class="pull-right"> <button type="button" class="dflt button" ng-click="$close()">Yes</button> <button type="button" class="dflt button" ng-click="$dismiss()">No</button> </div> </modal-footer> </modal> ');
$templateCache.put('app/components/profile/infoModal.view.html','<form ng-submit="$close()" name="form"> <modal close="$dismiss" modal-title="{{vm.title}}"> <modal-body> <p class="text-center"><span class="bold">{{vm.fullName}}</span> ({{vm.email}})</p> <p class="text-center" ng-if="vm.error">{{vm.error}}</p> </modal-body> <modal-footer> <button type="button" class="dflt button pull-right" ng-click="vm.onOk()">OK</button> </modal-footer> </modal> </form> ');
$templateCache.put('app/components/profile/minorParentProfile.view.html','<table class="information-table table"> <thead> <tr> <th>Minors</th> </tr> </thead> </table> <div class="row"> <div class="small-3 columns"> <label for="is-married" class="bold text-right middle"> Minor<span class="required text">*</span> </label> </div> <div class="small-9 columns"> <input id="is-married" type="checkbox" ng-model="vm.aosProfile.isMarried" ng-true-value="0" ng-false-value="1"> <span> Check this if you are under 18 years of age and not married. If that is the case, you will require parental permission to volunteer, and must provide contact information for your parent or guardian.</span> </div> </div> <br> <div ng-if="!vm.aosProfile.isMarried"> <div class="row"> <div class="small-offset-3 small-9 columns"> <h4>Parent/Guardian Contact Information</h4> </div> </div> <br> <div class="row"> <div class="small-3 columns"> <label for="parent-first-name" class="bold text-right middle"> First Name<span class="required text">*</span> </label> </div> <div class="small-9 columns"> <input id="parent-first-name" type="text" ng-model="vm.aosProfile.parentGuardian.firstName" required> </div> </div> <div class="row"> <div class="small-3 columns"> <label for="parent-last-name" class="bold text-right middle"> Last Name<span class="required text">*</span> </label> </div> <div class="small-9 columns"> <input id="parent-last-name" type="text" ng-model="vm.aosProfile.parentGuardian.lastName" required> </div> </div> <div class="row"> <div class="small-3 columns"> <label for="parent-phone" class="bold text-right middle"> Phone<span class="required text">*</span> </label> </div> <div class="small-9 columns"> <input type="text" id="parent-phone" ng-model="vm.aosProfile.parentGuardian.phone" required> </div> </div> <div class="row"> <div class="small-3 columns"> <label for="parent-email" class="bold text-right middle"> Email<span class="required text">*</span> </label> </div> <div class="small-9 columns"> <input id="parent-email" type="email" ng-model="vm.aosProfile.parentGuardian.email" required> </div> </div> <div class="row"> <div class="small-3 columns"> <label for="parent-country" class="bold text-right middle"> Country<span class="required text">*</span> </label> </div> <div class="small-9 columns" id="parent-country"> <ui-select required data-ng-change="vm.onChangeCountry(vm.aosProfile.parentGuardian.address)" data-ng-model="vm.aosProfile.parentGuardian.address.country"> <ui-select-match placeholder="Select a country or search..."> {{$select.selected}} </ui-select-match> <ui-select-choices repeat="country in vm.dropDowns.countries | filter:$select.search"> <span ng-bind-html="country | highlight: $select.search"></span> </ui-select-choices> </ui-select> </div> </div> <div class="row"> <div class="small-3 columns"> <label for="parent-address-1" class="bold text-right middle"> Address Line 1<span class="required text">*</span> </label> </div> <div class="small-9 columns"> <input id="parent-address-1" type="text" ng-model="vm.aosProfile.parentGuardian.address.line1" required> </div> </div> <div class="row"> <div class="small-3 columns"> <label for="parent-address-2" class="bold text-right middle"> Address Line 2 </label> </div> <div class="small-9 columns"> <input id="parent-address-2" type="text" ng-model="vm.aosProfile.parentGuardian.address.line2"> </div> </div> <div class="row"> <div class="small-3 columns"> <label for="parent-city" class="bold text-right middle"> City<span class="required text">*</span> </label> </div> <div class="small-9 columns"> <input id="parent-city" type="text" ng-model="vm.aosProfile.parentGuardian.address.city" required> </div> </div> <div class="row" ng-show="vm.aosProfile.parentGuardian.address.isStateRequired"> <div class="small-3 columns"> <label for="parent-state" class="bold text-right middle"> State<span class="required text">*</span> </label> </div> <div class="small-9 columns" id="parent-state"> <ui-select data-ng-required="vm.aosProfile.parentGuardian.address.isStateRequired" data-ng-disabled="!vm.aosProfile.parentGuardian.address.isStateRequired" data-ng-change="vm.onChangeCountry(vm.aosProfile.parentGuardian.address)" data-ng-model="vm.aosProfile.parentGuardian.address.state"> <ui-select-match placeholder="Select a state or search..."> {{$select.selected}} </ui-select-match> <ui-select-choices repeat="state in vm.dropDowns.states | filter:$select.search"> <span ng-bind-html="state | highlight: $select.search"></span> </ui-select-choices> </ui-select> </div> </div> <div class="row"> <div class="small-3 columns"> <label for="parent-zip" class="bold text-right middle"> ZIP/Postal Code<span class="required text">*</span> </label> </div> <div class="small-9 columns"> <input id="parent-zip" type="text" ng-model="vm.aosProfile.parentGuardian.address.zipCode" required> </div> </div> </div>');
$templateCache.put('app/components/profile/preferences.view.html','<h1>Preferences</h1> <table class="information-table table"> <thead> <tr> <th>Notifications</th> </tr> </thead> </table> <div class="row"> <div class="small-3 columns"> <label class="bold text-right" for="notification-email"> <span class="has-tip" tooltip-placement="right" tooltip-html-unsafe="You will always receive in-app notifications.<br> Check this box if you would like to also receive email notifications." tooltip-popup-delay="1000">Receive Email Notifications</span> </label> </div> <div ng-if="!vm.adminEditing" class="small-9 columns"> <input id="notification-email" type="checkbox" class="checkbox-top" ng-model="vm.gettingNotificationEmails">  </div> <div ng-if="vm.adminEditing" class="small-9 columns"> <p>{{vm.gettingNotificationEmails}}</p> </div> </div>');
$templateCache.put('app/components/profile/profile.view.html','<h1 id="anchor-top">AFWP Profile<span ng-if="vm.adminEditing"> - {{vm.fullName}}</span></h1> <div role="alert" ng-show="vm.formError" class="callout warning">{{vm.formError}}</div> <div role="alert" ng-show="vm.formSuccess" class="callout success">{{vm.formSuccess}}</div> <div ng-if="vm.isUatWebsite" role="alert" class="callout alert">This is a UAT site. Do not input real data.</div> <div ng-if="vm.isTrainingWebsite" role="alert" class="callout alert">This is a Training site. Do not input real data.</div> <label class="help-text" ng-hide="vm.isLoading"> <span class="required text">*</span>Indicates a required field. </label> <form name="form" class="form" data-ng-submit="vm.onSubmit(); form.$setPristine()"> <div ng-hide="vm.isLoading"> <div ng-include="\'app/components/profile/aosProfile.view.html\'"></div> <div ng-if="vm.isMinor" ng-include="\'app/components/profile/minorParentProfile.view.html\'"></div> <div ng-if="vm.adminProfile" ng-include="\'app/components/profile/vmisAdminProfile.view.html\'"></div> <div ng-include="\'app/components/profile/vmisVolunteerProfile.view.html\'"></div> <div ng-include="\'app/components/profile/preferences.view.html\'"></div> <div class="pull-right"> <button type="submit" class="dflt button" data-ng-disabled="form.$invalid || form.$pristine || vm.isLoading"> Save </button> <button type="button" class="dflt button" ng-click="vm.onCancel()" data-ng-disabled="vm.isLoading" ng-if="!vm.adminEditing"> Cancel </button> </div> </div> <loading-icon show="vm.isLoading" push-down="true"></loading-icon> </form> ');
$templateCache.put('app/components/profile/vmisAdminProfile.view.html','<h1>Administrator Profile<span ng-if="vm.adminEditing"> - {{vm.fullName}}</span></h1> <table class="table information-table"> <thead> <tr> <th>Administrator Information</th> </tr> </thead> </table> <div class="row" ng-if="vm.adminProfile && (vm.adminProfile.additionalRoles.afwpAdmin || vm.adminProfile.additionalRoles.programManager)"> <div class="small-3 columns"> <label class="bold text-right"> Additional Roles </label> </div> <div class="small-9 columns"> <ul class="admin-profile-communities-list"> <li id="afwp-admin-role" ng-show="vm.adminProfile.additionalRoles.afwpAdmin">AFWP Administrator</li> <li id="pm-role" ng-show="vm.adminProfile.additionalRoles.programManager">Program Manager</li> </ul> </div> </div> <div class="row" ng-if="vm.adminProfile.responsibilities.rm.length"> <div class="small-3 columns"> <label class="bold text-right"> RM Regions </label> </div> <div class="small-9 columns"> <ul class="admin-profile-communities-list"> <li ng-repeat="community in vm.adminProfile.responsibilities.rm"><span>{{community}}</span></li> </ul> </div> </div> <div class="row" ng-if="vm.adminProfile.responsibilities.coordinator.length"> <div class="small-3 columns"> <label class="bold text-right"> AVCC Communities </label> </div> <div class="small-9 columns"> <ul class="admin-profile-communities-list"> <li ng-repeat="community in vm.adminProfile.responsibilities.coordinator">{{community}}</li> </ul> </div> </div> <div class="row" ng-if="vm.adminProfile.responsibilities.avccAssistant.length"> <div class="small-3 columns"> <label class="bold text-right"> AVCC Assistant Communities </label> </div> <div class="small-9 columns"> <ul class="admin-profile-communities-list"> <li ng-repeat="community in vm.adminProfile.responsibilities.avccAssistant">{{community}}</li> </ul> </div> </div> <div class="row" ng-if="vm.adminProfile.responsibilities.opoc.length"> <div class="small-3 columns"> <label id="opoc-orgs-label" class="bold text-right"> OPOC Organizations </label> </div> <div class="small-9 columns"> <ul class="admin-profile-communities-list"> <li ng-repeat="community in vm.adminProfile.responsibilities.opoc"> <span>{{community.name}}</span> <ul> <li ng-repeat="organization in community.organizations">{{organization}}</li> </ul> </li> </ul> </div> </div> <div class="row"> <div class="small-3 columns"> <label for="note" class="bold text-right middle simple-tip" id="label-note" data-tooltip-placement="right" tooltip-popup-delay="1000" tooltip-html-unsafe="This note is visible to other AVC administrators."> Note </label> </div> <div class="small-9 columns"> <textarea id="note" rows="3" data-ng-model="vm.adminProfile.note" ng-maxlength="1100" name="profileNote" class="vertical-resize-only"></textarea> <label ng-hide="vm.adminEditing" class="character-countdown">{{1100 - form.profileNote.$viewValue.length}}</label> </div> </div> <table class="table information-table"> <thead> <tr> <th>Contact Information</th> </tr> </thead> </table> <div class="row"> <div class="small-3 columns"> <label for="work-email" class="bold text-right middle"> Work Email<span class="required text">*</span> </label> </div> <div class="small-9 columns"> <input id="work-email" type="email" ng-model="vm.adminProfile.workEmail" ng-required="!vm.adminEditing"> </div> </div> <div class="row"> <div class="small-3 columns"> <label for="commercial-work-phone" class="bold text-right middle"> Commercial Work Phone<span class="required text">*</span> </label> </div> <div class="small-9 columns"> <input id="commercial-work-phone" type="text" ng-model="vm.adminProfile.commercialWorkPhone" ng-required="!vm.adminEditing"> </div> </div> <div class="row"> <div class="small-3 columns"> <label for="dsn-phone" class="bold text-right middle"> DSN Phone </label> </div> <div class="small-9 columns"> <input id="dsn-phone" type="text" ng-model="vm.adminProfile.dsnPhone"> </div> </div> <table class="table information-table"> <thead> <tr> <th>Work Address</th> </tr> </thead> </table> <div class="row"> <div class="small-3 columns"> <label for="country" class="bold text-right middle"> Country<span class="required text">*</span> </label> </div> <div class="small-9 columns" id="country"> <ui-select data-ng-required="!vm.adminEditing" data-ng-change="vm.onChangeCountry(vm.adminProfile.address)" data-ng-model="vm.adminProfile.address.country" autocomplete="country-name"> <ui-select-match placeholder="Select a country or search..."> {{$select.selected}} </ui-select-match> <ui-select-choices repeat="country in vm.dropDowns.countries | filter:$select.search"> <span ng-bind-html="country | highlight: $select.search"></span> </ui-select-choices> </ui-select> </div> </div> <div class="row"> <div class="small-3 columns"> <label for="address-line-1" class="bold text-right middle"> Line 1<span class="required text">*</span> </label> </div> <div class="small-9 columns"> <input id="address-line-1" type="text" ng-model="vm.adminProfile.address.line1" autocomplete="address-level1" ng-required="!vm.adminEditing"> </div> </div> <div class="row"> <div class="small-3 columns"> <label for="address-line-2" class="bold text-right middle"> Line 2 </label> </div> <div class="small-9 columns"> <input id="address-line-2" type="text" ng-model="vm.adminProfile.address.line2" autocomplete="address-level2"> </div> </div> <div class="row"> <div class="small-3 columns"> <label for="city" class="bold text-right middle"> City<span class="required text">*</span> </label> </div> <div class="small-9 columns"> <input id="city" type="text" ng-model="vm.adminProfile.address.city" ng-required="!vm.adminEditing"> </div> </div> <div class="row"> <div class="small-3 columns"> <label for="state" class="bold text-right middle"> State<span class="required text" ng-show="vm.adminProfile.address.isStateRequired">*</span> </label> </div> <div class="small-9 columns" id="state"> <ui-select data-ng-required="vm.adminProfile.address.isStateRequired && !vm.adminEditing" data-ng-disabled="!vm.adminProfile.address.isStateRequired" data-ng-model="vm.adminProfile.address.state"> <ui-select-match placeholder="Select a state or search..."> {{$select.selected}} </ui-select-match> <ui-select-choices repeat="state in vm.dropDowns.states | filter:$select.search"> <span ng-bind-html="state | highlight: $select.search"></span> </ui-select-choices> </ui-select> </div> </div> <div class="row"> <div class="small-3 columns"> <label for="zip-code" class="bold text-right middle"> ZIP/Postal Code<span class="required text">*</span> </label> </div> <div class="small-9 columns"> <input id="zip-code" type="text" ng-model="vm.adminProfile.address.zipCode" autocomplete="postal-code" ng-required="!vm.adminEditing"> </div> </div> ');
$templateCache.put('app/components/profile/vmisVolunteerProfile.view.html','<h1>Volunteer Profile<span ng-if="vm.adminEditing"> - {{vm.fullName}}</span></h1> <table class="information-table table"> <thead> <tr> <th>Contact Information</th> </tr> </thead> </table> <div class="row"> <div class="small-3 columns"> <label for="preferred-contact-method" class="bold text-right middle"> Preferred Contact Method<span class="required text">*</span> </label> </div> <div class="small-9 columns" id="preferred-contact-method"> <ui-select required data-ng-model="vm.volunteerProfile.preferredContactMethod"> <ui-select-match placeholder="Select a contact method or search..."> {{$select.selected}} </ui-select-match> <ui-select-choices repeat="pcm in vm.dropDowns.preferredContactMethods | filter:$select.search"> <span ng-bind-html="pcm | highlight: $select.search"></span> </ui-select-choices> </ui-select> </div> </div> <div class="row"> <div class="small-3 columns"> <label for="volunteer-email" class="bold text-right middle"> Volunteer Email<span class="required text">*</span> </label> </div> <div class="small-9 columns"> <label tooltip="{{vm.nonUserEmail ? \'Volunteer email is encouraged to match master user email for non-users.\' : null}}" tooltip-popup-delay="200"> <input id="volunteer-email" type="email" ng-model="vm.volunteerProfile.volunteerEmail" required autocomplete="email"> </label> </div> </div> <div class="row"> <div class="small-3 columns"> <label for="primary-phone" class="bold text-right middle"> Primary Phone<span class="required text">*</span> </label> </div> <div class="small-9 columns"> <input id="primary-phone" type="text" ng-model="vm.volunteerProfile.primaryPhone" required autocomplete="tel"> </div> </div> <div class="row"> <div class="small-3 columns"> <label for="secondary-phone" class="bold text-right middle">Secondary Phone</label> </div> <div class="small-9 columns"> <input id="secondary-phone" type="text" ng-model="vm.volunteerProfile.secondaryPhone" ng-required="vm.volunteerProfile.secondaryPhone"> </div> </div> <table class="table information-table"> <thead> <tr> <th>Background</th> </tr> </thead> </table> <div class="row"> <div class="small-3 columns"> <label for="work-experience" class="bold text-right middle"> Work Experience </label> </div> <div class="small-9 columns"> <textarea rows="3" ng-maxlength="1000" id="work-experience" data-ng-model="vm.volunteerProfile.workExperience" name="workExperience" class="vertical-resize-only"></textarea> <label class="character-countdown">{{1000 - form.workExperience.$viewValue.length}}</label> </div> </div> <div class="row"> <div class="small-3 columns"> <label for="volunteer-experience" class="bold text-right middle"> Volunteer Experience </label> </div> <div class="small-9 columns"> <textarea rows="3" ng-maxlength="1000" id="volunteer-experience" data-ng-model="vm.volunteerProfile.volunteerExperience" name="volunteerExperience" class="vertical-resize-only"></textarea> <label class="character-countdown">{{1000 - form.volunteerExperience.$viewValue.length}}</label> </div> </div> <div class="row"> <div class="small-3 columns"> <label for="special-skills-interests-hobbies" class="bold text-right middle"> Special Skills, Interests, and Hobbies </label> </div> <div class="small-9 columns"> <textarea rows="3" ng-maxlength="1000" id="special-skills-interests-hobbies" data-ng-model="vm.volunteerProfile.specialSkillsInterestsAndHobbies" name="specialSkillsInterestsHobbies" class="vertical-resize-only"></textarea> <label class="character-countdown">{{1000 - form.specialSkillsInterestsHobbies.$viewValue.length}}</label> </div> </div>');
$templateCache.put('app/components/register/beginMigration.view.html','<form name="form"> <modal modal-title="Transition Account"> <modal-body> <p>To complete the transition process, please check the email address(es) associated with your AOS account and click the link.</p> </modal-body> <modal-footer> <div class="pull-right"> <button type="button" class="dflt button" ng-click="vm.onClickOk()"> OK </button> </div> </modal-footer> </modal> </form>');
$templateCache.put('app/components/register/claimUser.view.html','<h1>Transition User Account from AOS to AFWP</h1> <br> <form name="form" data-ng-submit="vm.onSubmit(vm.email)" novalidate class="container"> <div role="alert" ng-show="vm.formError" class="callout warning">{{vm.formError}}</div> <div class="row"> <div class="small-12 medium-8 large-4 small-centered columns"> <div class="row"> <div class="columns"> <p> To finish transitioning your AOS account, please select an email and password. From now on, you will use your email address to log in to any AFWP system. </p> </div> </div> <div class="row"> <div class="columns"> <p><b>AOS Account Username: {{vm.username}}</b></p> </div> </div> <div class="row"> <div class="columns"> <label>Email<span class="required text">*</span> <input name="email" type="email" placeholder="Enter Email" ng-maxlength="100" ng-model="vm.email" ng-disabled="!vm.userFound" autocomplete="username" required> </label> </div> </div> <div class="row"> <div class="columns"> <label>Confirm Email<span class="required text">*</span> <input name="confirmEmail" type="email" placeholder="Confirm Email" ng-maxlength="100" ng-model="vm.confirmEmail" ng-disabled="!vm.userFound" confirm-data-error="vm.confirmEmail != vm.email" autocomplete="username" required> </label> </div> </div> <div class="row"> <div class="columns"> <label>Password<span class="required text">*</span> <input name="password" type="password" placeholder="Enter Password" ng-model="vm.password" pattern="{{vm.passwordRequirements.regex}}" tooltip="{{vm.passwordRequirements.description}}" tooltip-placement="top" tooltip-trigger="focus" required autocomplete="new-password" password-validator ng-disabled="!vm.userFound"> </label> </div> <div class="columns" ng-show="form.$submitted || form.password.$touched"> <span>Requirements:</span> <ul> <li ng-class="form.password.$error.passwordLength ? \'invalid\' : \'valid\'">At least 15 characters long</li> <li ng-class="form.password.$error.passwordUpper ? \'invalid\' : \'valid\'">At least 2 uppercase letters</li> <li ng-class="form.password.$error.passwordLower ? \'invalid\' : \'valid\'">At least 2 lowercase letters</li> <li ng-class="form.password.$error.passwordNum ? \'invalid\' : \'valid\'">At least 2 numbers</li> <li ng-class="form.password.$error.passwordSpecial ? \'invalid\' : \'valid\'">At least 2 special characters</li> <li ng-class="form.password.$error.passwordSpace || form.password.length() == 0 ? \'invalid\' : \'valid\'">No spaces</li> </ul> </div> </div> <div class="row"> <div class="columns"> <label>Confirm Password<span class="required text">*</span> <input name="confirmPassword" type="password" placeholder="Confirm Password" ng-model="vm.confirmPassword" ng-disabled="!vm.userFound" confirm-data-error="vm.confirmPassword != vm.password" autocomplete="new-password" required> </label> </div> </div> <div class="row"> <div class="columns"> <label class="help-text" style="margin-bottom: 1rem;"> <span class="required text">*</span> Indicates a required field. </label> </div> </div> <div class="row"> <div class="columns"> <button type="submit" class="dflt button expanded" data-ng-disabled="form.$invalid || vm.isLoading || !vm.userFound"> Complete Account Transition </button> </div> </div> </div> </div> </form>');
$templateCache.put('app/components/register/migrateUser.view.html','<h1>Transition User Account from AOS to AFWP</h1> <form name="form" data-ng-submit="vm.onSubmit(vm.email)" novalidate> <div role="alert" ng-show="vm.formError" class="callout warning">{{vm.formError}}</div> <div class="row"> <div class="small-4 small-centered columns"> <label for="username">Username from www.myarmyonesource.com: <input id="username" type="text" placeholder="Enter Username" ng-model="vm.username" required> </label> </div> </div> <div class="row"> <div class="small-4 small-centered columns"> <button type="submit" class="dflt button expanded" data-ng-disabled="form.$invalid || vm.isLoading || vm.emailSent">Transition Account</button> </div> </div> <div class="row"> <div class="small-4 small-centered columns"> <p>{{vm.emailStatusMessage}}</p> </div> </div> </form> ');
$templateCache.put('app/components/underConstructionPage/underConstructionPage.view.html','<header role="banner" class="site-header"> <icon name="fa-bars" class="header-icon-menu clickable register-header" ng-click="vm.showMenu = !vm.showMenu;" alt="Select this icon to open the list of AFWP sites"></icon> <div class="dropdown-pane" ng-show="vm.showMenu" style="background-color: white; width: 450px; padding: 0; visibility: visible; position: absolute; top: 50px;"> <ul style="list-style: none; text-align: left; width: 500px; height: 100%"> <li style="border: 0px solid black;" ng-repeat="website in vm.websiteFamilyList"> <a href="{{website.url}}">{{website.name}}</a> </li> </ul> </div> <div ng-class="{title: vm.isLoggedIn}" ng-click="vm.goHome()"> <img class="site-icon" src="../../assets/img/US-Army-logo-small.png" alt="Select this US Army logo to go to the dashboard"> <h1 class="show-for-large">Volunteer Management Information System</h1> <h1 class="hide-for-large">VMIS</h1> </div> </header> <main role="main" class="main-view"> <h1>Under Construction</h1> <span>Our website is currently undergoing scheduled maintenance. We should be back shortly. Thank you for your patience.</span> </main> <footer role="contentinfo" class="site-footer"></footer> ');
$templateCache.put('app/components/volunteer/volunteer.view.html','<div ui-view></div>');
$templateCache.put('app/common/directives/dropdown/dropdown.view.html','<span class="vmis-dropdown-button" ng-class="{\'is-open\': vm.active}" ng-click="vm.toggle()"></span> <div ng-class="{\'is-open\': vm.active}"></div>');
$templateCache.put('app/common/directives/icon/icon.template.html','<svg class="icon icon-{{icon.name}}" ng-class="{\'icon-spin\': icon.spin}"> <use xlink:href="" data-ng-href="#icon-{{icon.name}}"></use> </svg>');
$templateCache.put('app/common/directives/learnAboutThisPage/learnAboutModal.template.html','<form name="form" ng-submit="$dismiss()"> <modal close="$dismiss" modal-title="{{vmWidgetModal.learnTitle}}"> <modal-body> <p ng-repeat="item in vmWidgetModal.textBodyParagraphs">{{item}}</p> </modal-body> <modal-footer> <div class="text-right"> <button type="submit" class="dflt button">OK</button> </div> </modal-footer> </modal> </form>');
$templateCache.put('app/common/directives/learnAboutThisPage/learnAboutThisPage.view.html','<div class="text-right" style="position:absolute; top: 0; right: 20px;"> <a ng-click="vmWidget.openModal()">Learn about this page</a> </div>');
$templateCache.put('app/common/directives/loadMore/loadMore.template.html','<div class="row" ng-hide="vm.isLoading || (vm.loadStatus.nextResultLoadNum === 0) || (vm.loadStatus.currentIndex === 0)"> <div class="small-9 small-centered columns"> <button type="button" class="dflt button expanded" ng-click="vm.onLoadMore()"> Load {{(vm.loadStatus.nextResultLoadNum === vm.loadStatus.numResultsNotLoaded) ? \'Remaining\' : \'More\'}} Result<span ng-hide="vm.loadStatus.nextResultLoadNum === 1">s</span> </button> </div> <div class="small-3 small-centered columns" ng-hide="(vm.loadStatus.nextResultLoadNum === vm.loadStatus.numResultsNotLoaded) || (vm.loadStatus.numResultsNotLoaded > vm.loadStatus.maxLoadAll)"> <p class="text-center" tooltip="May create significant loading times" tooltip-popup-delay="200"> <a ng-click="vm.onLoadAll()">Load All Results</a> </p> </div> </div>');
$templateCache.put('app/common/directives/loadingIcon/loadingIcon.template.html','<div ng-if="loadingIcon.show" ng-class="{\'push-down\': loadingIcon.pushDown}"> <icon name="fa-spinner" class="icon-smallest" aria-hidden="true" ng-show="loadingIcon.littlest" spin="true"></icon> <icon name="fa-spinner" class="icon-big" aria-hidden="true" ng-show="loadingIcon.little" spin="true"></icon> <icon name="fa-spinner" class="icon-bigger" aria-hidden="true" ng-hide="loadingIcon.little||loadingIcon.littlest" spin="true"></icon> </div>');
$templateCache.put('app/common/directives/massAction/massAction.template.html','<div class="row"> <div style="padding:0" class="small-6 columns"> <ui-select id="mass-action" data-ng-model="vm.selectedMassAction" data-ng-disabled="vm.disabled()"> <ui-select-match placeholder="Select action"> {{$select.selected.name}} </ui-select-match> <ui-select-choices repeat="ma in vm.massActions | propsFilter: {name: $select.search}"> <span ng-bind-html="ma.name | highlight: $select.search"></span> </ui-select-choices> </ui-select> </div> <div style="padding:0" class="small-6 columns right-align-contents"> <button type="button" class="dflt button" data-ng-disabled="vm.disabled() || !vm.selectedMassAction" ng-click="vm.selectedMassAction.action()"> <span>Submit</span> </button> </div> </div> ');
$templateCache.put('app/common/directives/modal/modal.template.html','<div class="modal-header"> <h3>{{vm.modalTitle}}</h3> <button type="button" class="close-button" ng-click="vm.close()" ng-if="vm.close" aria-label="Close"> <span aria-hidden="true">&times;</span> </button> <hr> </div> <div class="inner-form" ng-transclude="body"></div> <div class="row button-row" ng-transclude="footer"></div>');
$templateCache.put('app/common/directives/retrievedResults/retrievedResults.template.html','<div class="center-horizontal" ng-hide="vm.isLoading"> <p class="remove-bottom-margin"> Retrieved {{vm.loadStatus.currentIndex}} <span ng-if="(vm.loadStatus.nextResultLoadNum !== 0)">out of {{vm.loadStatus.currentIndex + vm.loadStatus.numResultsNotLoaded}}</span> result<span ng-if="(vm.loadStatus.currentIndex !== 1) || (vm.loadStatus.nextResultLoadNum !== 0)">s</span> </p> </div>');
$templateCache.put('app/common/directives/textAreaWithCount/textAreaWithCount.template.html','<div ng-form="noteForm"> <textarea class="vertical-resize-only" rows="{{vm.numberRows}}" ng-model="vm.modelName" placeholder="{{vm.defaultShownText}}" ng-disabled="vm.isDisabled" maxlength="vm.maxGivenLength" name="noteItem" ng-maxlength="vm.maxGivenLength" ng-trim="false" ng-required="vm.isRequired" ng-hide="vm.isHidden">\n        </textarea> <label ng-hide="vm.isHidden || vm.isDisabled" class="character-countdown">{{vm.maxGivenLength - noteForm.noteItem.$viewValue.length}}</label> </div> ');
$templateCache.put('app/common/directives/uploadDocumentList/uploadDocumentList.template.html','<div class="row small-bottom-margin" ng-repeat="uploadedDocument in uploadDocumentList.uploadedDocuments"> <div class="small-10 columns overflow-ellipsis center-horizontal"> <span tooltip="This document link for {{uploadedDocument.documentName}} is not permanent. Download this document if you wish to share it." tooltip-popup-delay="1000"> <a ng-href="{{uploadedDocument.urlPath | uploadedFileFilter}}" target="_blank"> {{uploadedDocument.documentName}} </a> </span> </div> <div class="small-2 columns upload-list-icon-height text-center" ng-if="uploadDocumentList.showDelete && !uploadDocumentList.disableDelete"> <div ng-click="uploadDocumentList.onDeleteUploadedDoc(uploadedDocument)" tooltip="Deleting documents does not require resubmitting." tooltip-popup-delay="200"> <icon name="fa-trash-o" class="icon-lg clickable" aria-hidden="true"></icon> </div> </div> </div> <div class="row small-bottom-margin" ng-repeat="selectedDocument in uploadDocumentList.selectedDocuments"> <div class="small-10 columns overflow-ellipsis center-horizontal" tooltip="{{selectedDocument.name}}" tooltip-popup-delay="1000"> {{selectedDocument.name}} </div> <div class="small-2 columns upload-list-icon-height text-center"> <div ng-click="uploadDocumentList.onDeleteSelectedDoc(selectedDocument)" ng-if="uploadDocumentList.showDelete && !uploadDocumentList.disableDelete" tooltip="Deleting this document removes it immediately." tooltip-popup-delay="200"> <icon name="fa-trash-o" class="icon-lg clickable" aria-hidden="true"></icon> </div> <icon name="fa-check" class="icon-lg green" aria-hidden="true" ng-if="selectedDocument.uploaded"></icon> </div> </div> <div class="row small-bottom-margin"> <div class="small-10 columns italic center-horizontal" ng-if="uploadDocumentList.showUploadInstructions"> <span ng-if="(uploadDocumentList.uploadedDocuments.length + uploadDocumentList.selectedDocuments.length) === 0"> Attach up to 3 documents. </span> <span ng-if="(uploadDocumentList.uploadedDocuments.length + uploadDocumentList.selectedDocuments.length) === 1"> Attach up to 2 more documents. </span> <span ng-if="(uploadDocumentList.uploadedDocuments.length + uploadDocumentList.selectedDocuments.length) === 2"> Attach up to 1 more document. </span> <span ng-if="(uploadDocumentList.uploadedDocuments.length + uploadDocumentList.selectedDocuments.length) === 3"> You have reached your maximum of 3 attachments. </span> </div> </div>');
$templateCache.put('app/common/directives/vmisCalendar/vmisCalendar.view.html','<div class="week names" ng-if="showDayOfWeek"> <div class="day">Sunday</div> <div class="day">Monday</div> <div class="day">Tuesday</div> <div class="day">Wednesday</div> <div class="day">Thursday</div> <div class="day">Friday</div> <div class="day">Saturday</div> </div> <div class="week" ng-repeat="week in weeks" ng-if="showDays"> <div class="day" ng-repeat="day in week"> <div> 1 </div> </div> </div>');
$templateCache.put('app/common/directives/vmisHoursEntry/error.html','<form name="form"> <modal close="$dismiss" modal-title="Log Hours Error"> <modal-body> <p>{{modal.error}}</p> </modal-body> <modal-footer> <div class="pull-right"> <button type="button" class="dflt button" ng-click="$dismiss()"> Close </button> </div> </modal-footer> </modal> </form>');
$templateCache.put('app/common/directives/vmisHoursEntry/vmisHoursEntry.view.html','<table class="table information-table"> <thead uib-tooltip="Saved" data-tooltip-class="customClass" data-tooltip-placement="top-right" data-tooltip-trigger="none" data-tooltip-is-open="vmWidget.tooltipIsOpen"> <tr> <td class="unsorted"> Position </td> <td class="unsorted vmis-hours-entry-col">S</td> <td class="unsorted vmis-hours-entry-col">M</td> <td class="unsorted vmis-hours-entry-col">T</td> <td class="unsorted vmis-hours-entry-col">W</td> <td class="unsorted vmis-hours-entry-col">T</td> <td class="unsorted vmis-hours-entry-col">F</td> <td class="unsorted vmis-hours-entry-col">S</td> </tr> </thead> <tbody> <tr ng-if="vmWidget.positions.length == 0 || !vmWidget.positions"> <td colspan="8">You have no active positions.</td> </tr> <tr ng-repeat="position in vmWidget.positions"> <td> {{position.title}} </td> <td ng-repeat="activity in position.activities track by $index" style="padding: 0;"> <div tooltip-popup-delay="200" tooltip="{{activity.date > vmWidget.dateRange.end ?\r\n            \'This date is in the future\' : activity.date < vmWidget.dateRange.start ?\r\n            \'This date is outside the open period\' : activity.status === \'Certified\'?\r\n            \'These hours have already been certified\' : null}}"> <label hidden for="{{activity.id}}">Enter Hours</label> <input type="text" id="{{activity.id}}" class="form-control" aria-label="{{ \'enter-hours-\' + activity.date }}" style="padding: 0; text-align: center;" ng-model="activity.hours" ng-keyup="vmWidget.autoSubmitHours(position, activity)" ng-disabled="activity.date > vmWidget.dateRange.end || activity.date < vmWidget.dateRange.start || activity.status === \'Certified\'" hours-entry-formatter> </div> </td> </tr> </tbody> </table>');
$templateCache.put('app/common/directives/vmisHoursStatus/vmisHoursStatus.template.html','<div ng-switch="vm.status.toLowerCase()"> <icon ng-switch-when="certified" name="fa-check" class="icon-lg icon-hours certified"></icon> <icon ng-switch-when="rejected" name="fa-times" class="icon-lg icon-hours rejected"></icon> <icon ng-switch-when="submitted" name="fa-circle" class="icon-hours submitted"></icon> <icon ng-switch-when="deleted" name="fa-trash-o" class="icon-lg icon-hours"></icon> </div>');
$templateCache.put('app/components/administrator/applications/applicationDetails.view.html','<form name="form"> <modal close="$dismiss" modal-title="{{vm.title}}"> <modal-body> <div ng-hide="vm.isLoading"> <p ng-if="vm.profile.aosUser.isMinor" class="text-center"> <b>{{vm.profile.aosUser.firstName}} {{vm.profile.aosUser.lastName}} is a minor.</b> </p> <table class="table information-table" tabindex="0"> <thead></thead> <tbody> <tr> <td class="row-title"> <label class="control-label"> Status </label> </td> <td> {{vm.application.status}} </td> </tr> <tr ng-if="vm.application.statusReason"> <td class="row-title"> <label class="control-label"> Reason </label> </td> <td> {{vm.application.statusReason}} </td> </tr> </tbody> <thead> <tr> <th colspan="2">Position</th> </tr> </thead> <tbody> <tr> <td class="row-title"> <label class="control-label"> Posted Date </label> </td> <td> {{(vm.position.postedDate || vm.position.submittedDate) | date:\'MM/dd/yyyy\'}} </td> </tr> <tr ng-if="!vm.isVolunteerSubmitted"> <td class="row-title"> <label class="control-label"> Closed Date </label> </td> <td> {{vm.position.closedDate | date:\'MM/dd/yyyy\'}} </td> </tr> <tr> <td class="row-title"> <label class="control-label"> Title </label> </td> <td> {{vm.position.title}} </td> </tr> <tr> <td class="row-title"> <label class="control-label"> Organization </label> </td> <td> {{vm.position.volunteerOrganization || vm.position.organizationName}} </td> </tr> <tr ng-if="vm.isVolunteerSubmitted"> <td class="row-title"> <label class="control-label"> Organization Name </label> </td> <td> {{vm.position.summary}} </td> </tr> <tr> <td class="row-title"> <label class="control-label"> Community </label> </td> <td> {{vm.position.communityAffiliation}} </td> </tr> <tr ng-if="!vm.isVolunteerSubmitted"> <td class="row-title"> <label class="control-label"> Position Type </label> </td> <td> {{vm.position.volunteerPositionType}} </td> </tr> <tr ng-if="!vm.isVolunteerSubmitted"> <td class="row-title"> <label class="control-label"> Opportunity Type </label> </td> <td> {{vm.position.volunteerOpportunityType}} </td> </tr> <tr> <td class="row-title"> <label class="control-label"> Background Check Required </label> </td> <td> {{vm.position.isBackgroundCheckRequired}} </td> </tr> <tr ng-if="!vm.isVolunteerSubmitted"> <td class="row-title"> <label class="control-label"> Supervision Required </label> </td> <td> {{vm.position.supervisionConditionFlag}} </td> </tr> <tr ng-if="!vm.isVolunteerSubmitted"> <td class="row-title"> <label class="control-label"> Summary </label> </td> <td> {{vm.position.summary}} </td> </tr> <tr> <td class="row-title"> <label class="control-label"> Duties </label> </td> <td> {{vm.position.duties}} </td> </tr> <tr> <td class="row-title"> <label class="control-label"> Qualifications </label> </td> <td> {{vm.position.qualifications}} </td> </tr> <tr> <td class="row-title"> <label class="control-label"> Training </label> </td> <td> {{vm.position.training}} </td> </tr> <tr> <td class="row-title"> <label class="control-label"> Orientation </label> </td> <td> {{vm.position.orientation}} </td> </tr> <tr> <td class="row-title"> <label class="control-label"> Time Required </label> </td> <td> {{vm.position.timeRequired}} </td> </tr> <tr ng-if="!vm.isVolunteerSubmitted"> <td class="row-title"> <label class="control-label"> Evaluation </label> </td> <td> {{vm.position.evaluation}} </td> </tr> <tr ng-if="!vm.isVolunteerSubmitted"> <td class="row-title"> <label class="control-label"> Benefits </label> </td> <td> {{vm.position.benefits}} </td> </tr> <tr ng-if="vm.isVolunteerSubmitted"> <td class="row-title"> <label class="control-label"> Comment </label> </td> <td> {{vm.application.opportunityApplicationComment || vm.application.volunteerApplicationComment}} </td> </tr> <tr> <td class="row-title"> <label class="control-label"> Address </label> </td> <td> <div>{{vm.position.address1}}</div> <div>{{vm.position.address2}}</div> <div>{{vm.position.city}}<span ng-if="vm.position.country === \'United States\'">, {{vm.position.usState}}</span> {{vm.position.zipCode}} </div> <div>{{vm.position.country}}</div> </td> </tr> <tr> <td class="row-title"> <label class="control-label"> Supervisor{{vm.isVolunteerSubmitted ? \'\' : \' 1\'}} </label> </td> <td> <div>{{vm.position.firstLineSupervisorName}}</div> <div>{{vm.position.firstLineSupervisorPhone}}</div> <div>{{vm.position.firstLineSupervisorEmail}}</div> </td> </tr> <tr ng-if="!vm.isVolunteerSubmitted"> <td class="row-title"> <label class="control-label"> Supervisor 2 </label> </td> <td> <div>{{vm.position.secondLineSupervisorName}}</div> <div>{{vm.position.secondLineSupervisorPhone}}</div> <div>{{vm.position.secondLineSupervisorEmail}}</div> </td> </tr> </tbody> <thead> <tr> <th colspan="2">User Profile</th> </tr> </thead> <tbody> <tr> <td class="row-title"> <label class="control-label"> Name </label> </td> <td> {{vm.profile.aosUser.firstName}} {{vm.profile.aosUser.lastName}} </td> </tr> <tr> <td class="row-title"> <label class="control-label"> Email </label> </td> <td> {{vm.profile.masterUserEmail}} </td> </tr> <tr> <td class="row-title"> <label class="control-label"> Minor </label> </td> <td> {{vm.profile.aosUser.isMinor ? \'Yes\' : \'No\'}} </td> </tr> <tr> <td class="row-title"> <label class="control-label"> Community </label> </td> <td> {{vm.profile.aosUser.communityAffiliation}} </td> </tr> <tr> <td class="row-title"> <label class="control-label"> Branch </label> </td> <td> {{vm.profile.aosUser.branchOfService}} </td> </tr> <tr> <td class="row-title"> <label class="control-label"> Component </label> </td> <td> {{vm.profile.aosUser.armyComponent}} </td> </tr> <tr class="vertical-align-top"> <td class="row-title"> <label class="control-label"> Disposition(s) </label> </td> <td> <label ng-repeat="disposition in vm.profile.aosUser.dispositions" ng-switch="disposition"> <span ng-switch-when="Service Member">{{disposition}}, Rank: {{vm.profile.aosUser.payGrade}}</span> <span ng-switch-when="Family Member">{{disposition}}, Sponsor\'s Rank: {{vm.profile.aosUser.sponsorPayGrade}}</span> <span ng-switch-when="DoD Civilian">{{disposition}}, Civilian Rank: {{vm.profile.aosUser.civilianPayGrade}}</span> <span ng-switch-default>{{disposition}}</span> </label> </td> </tr> </tbody> <thead> <tr> <th colspan="2">Volunteer Profile</th> </tr> </thead> <tbody> <tr> <td class="row-title"> <label class="control-label"> Preferred Contact Method </label> </td> <td> {{vm.profile.aosUser.vmisUser.volunteerProfile.preferredContactMethod}} </td> </tr> <tr> <td class="row-title"> <label class="control-label"> Volunteer Email </label> </td> <td> {{vm.profile.aosUser.vmisUser.volunteerProfile.volunteerEmail}} </td> </tr> <tr> <td class="row-title"> <label class="control-label"> Primary Phone </label> </td> <td> {{vm.profile.aosUser.vmisUser.volunteerProfile.primaryPhone}} </td> </tr> <tr> <td class="row-title"> <label class="control-label"> Secondary Phone </label> </td> <td> {{vm.profile.aosUser.vmisUser.volunteerProfile.secondaryPhone}} </td> </tr> <tr> <td class="row-title"> <label class="control-label"> Work Experience </label> </td> <td> {{vm.profile.aosUser.vmisUser.volunteerProfile.workExperience}} </td> </tr> <tr> <td class="row-title"> <label class="control-label"> Volunteer Experience </label> </td> <td> {{vm.profile.aosUser.vmisUser.volunteerProfile.volunteerExperience}} </td> </tr> <tr> <td class="row-title"> <label class="control-label"> Special Skills, Interests, and Hobbies </label> </td> <td> {{vm.profile.aosUser.vmisUser.volunteerProfile.specialSIH}} </td> </tr> </tbody> </table> </div> <div ng-if="vm.isLoading" style="margin-top: 50px; overflow:hidden"> <loading-icon show="true"></loading-icon> </div> </modal-body> <modal-footer> <div class="pull-right"> <button type="button" class="dflt button" data-ng-disabled="!vm.canDelete || vm.isLoading" ng-click="vm.onSetStatus(\'Delete\')"> Delete </button> <button type="button" class="dflt button" data-ng-disabled="vm.application.status == \'Declined\' || (vm.canReject == false && vm.application.status == \'Approved\') || !vm.isOrgActive || vm.isLoading" ng-click="vm.onSetStatus(\'Declined\')"> Decline </button> <button type="button" class="dflt button" data-ng-disabled="vm.application.status == \'Approved\' || !vm.isOrgActive || vm.isLoading" ng-click="vm.onSetStatus(\'Approved\')"> Approve </button> <button type="button" class="dflt button" ng-click="$dismiss()">Cancel</button> </div> </modal-footer> </modal> </form>');
$templateCache.put('app/components/administrator/applications/applications.view.html','<div ui-view> <ul class="breadcrumbs"> <li><a ui-sref="vmis" ui-sref-opts="{reload:true}">VMIS</a></li> <li> <span class="show-for-sr">Current: </span>Applications </li> </ul> <learn-about-this-page learn-title="About Applications Page" text-body="The Applications page displays the applications that are managed by the OPOC or AVCC. Applications can be approved or declined from this view, and specific volunteers and applications can be managed using the Applications page\u2019s filter and search tools.\nNote: AVCCs are the only individuals who can see applications for non-AVC Positions that have been submitted by volunteers. No OPOC will be able to see these applications. To filter for these specifically, change the Organization drop-down to \u201CVolunteer Submitted\u201D.\nFor information on how to use this page, please see section 4.0 in the VMIS OPOC User Guide or section 6.0 in the VMIS AVCC User Guide."></learn-about-this-page> <h1>Applications</h1> <form> <alert ng-repeat="alert in vm.alerts" type="alert.type" close="vm.onCloseAlert($index)">{{alert.message}}</alert> <div class="expanded row"> <div class="small-8 columns"> <label> Position <ui-select data-ng-model="vm.filter.volunteerOpportunity" data-ng-change="vm.getApplications(0, vm.loadStatus.defaultNumRows)" data-ng-disabled="vm.isLoading"> <ui-select-match placeholder="Select a position or search..."> {{$select.selected.title}} </ui-select-match> <ui-select-choices repeat="positionTitle.value as positionTitle in vm.positionTitles | propsFilter: {title: $select.search}"> <span ng-bind-html="positionTitle.title | highlight: $select.search"></span> </ui-select-choices> </ui-select> </label> </div> <div class="small-4 columns"> <label> Status <ui-select data-ng-model="vm.filter.volunteerApplicationStatus" data-ng-change="vm.getApplications(0, vm.loadStatus.defaultNumRows)" data-ng-disabled="vm.isLoading"> <ui-select-match placeholder="Select a status or search..."> {{$select.selected.status}} </ui-select-match> <ui-select-choices repeat="statusType.value as statusType in vm.statusTypes | propsFilter: {status: $select.search}"> <span ng-bind-html="statusType.status | highlight: $select.search"></span> </ui-select-choices> </ui-select> </label> </div> </div> <div class="expanded row"> <div class="small-3 columns"> <label id="community">Community</label> </div> <div class="small-3 columns"> <label id="organization">Organization</label> </div> <div class="small-6 columns"> <label id="searchApplication" hidden>Search for Application</label> </div> </div> <div class="expanded row"> <div class="small-3 columns"> <ui-select data-ng-model="vm.filter.selectedCommunity" data-ng-change="vm.onSelectCommunity()" data-ng-disabled="vm.isLoading"> <ui-select-match placeholder="Select a community or search..."> {{$select.selected.name}} </ui-select-match> <ui-select-choices repeat="comm in vm.communities | propsFilter: {name: $select.search}"> <span ng-bind-html="comm.name | highlight: $select.search"></span> </ui-select-choices> </ui-select> </div> <div class="small-3 columns"> <ui-select data-ng-model="vm.filter.selectedOrganization" data-ng-change="vm.onSelectOrganization()" data-ng-disabled="vm.disableOrgDropDown()"> <ui-select-match placeholder="Select an organization or search..."> {{$select.selected.name}} </ui-select-match> <ui-select-choices repeat="org in vm.filter.selectedCommunity.organizations | propsFilter: {name: $select.search}"> <span ng-bind-html="org.name | highlight: $select.search"></span> </ui-select-choices> </ui-select> </div> <form> <div class="small-6 columns"> <div class="input-group"> <div class="input-group-label icon-label"><icon name="fa-search" class="icon-lg"></icon></div> <input type="text" id="input-last-name" aria-label="Last name" class="input-group-field" placeholder="Last name" ng-model="vm.filter.lastName"> <span class="input-group-glue"></span> <input type="text" id="input-first-name" aria-label="First name" class="input-group-field" placeholder="First name" ng-model="vm.filter.firstName"> <div class="input-group-button"> <button type="submit" class="dflt button" ng-disabled="vm.isLoading" ng-click="vm.onClickSearch()">Search</button> </div> </div> </div> </form> </div> </form> <retrieved-results is-loading="vm.isLoading" load-status="vm.loadStatus"></retrieved-results> <table class="table information-table table-hover"> <thead> <tr> <th ng-click="vm.sortColumn = \'volunteerOpportunity\'; vm.sortReverse = !vm.sortReverse"> <span ng-class="{unsorted: vm.sortColumn !== \'volunteerOpportunity\'}"> Position Title <icon ng-show="vm.sortColumn === \'volunteerOpportunity\'" name="{{vm.sortReverse ? \'fa-caret-down\' : \'fa-caret-up\'}}" class="icon-table-header" alt="Sorted by Position Title"></icon> </span> </th> <th ng-click="vm.sortColumn = \'volunteerOrganization\'; vm.sortReverse = !vm.sortReverse"> <span ng-class="{unsorted: vm.sortColumn !== \'volunteerOrganization\'}"> Organization <icon ng-show="vm.sortColumn === \'volunteerOrganization\'" name="{{vm.sortReverse ? \'fa-caret-down\' : \'fa-caret-up\'}}" class="icon-table-header" alt="Sorted by Organization"></icon> </span> </th> <th ng-click="vm.sortColumn = \'lastName\'; vm.sortReverse = !vm.sortReverse"> <span ng-class="{unsorted: vm.sortColumn !== \'lastName\'}"> Last Name <icon ng-show="vm.sortColumn === \'lastName\'" name="{{vm.sortReverse ? \'fa-caret-down\' : \'fa-caret-up\'}}" class="icon-table-header" alt="Sorted by Last Name"></icon> </span> </th> <th ng-click="vm.sortColumn = \'firstName\'; vm.sortReverse = !vm.sortReverse"> <span ng-class="{unsorted: vm.sortColumn !== \'firstName\'}"> First Name <icon ng-show="vm.sortColumn === \'firstName\'" name="{{vm.sortReverse ? \'fa-caret-down\' : \'fa-caret-up\'}}" class="icon-table-header" alt="Sorted by First Name"></icon> </span> </th> <th ng-click="vm.sortColumn = \'submittedDate\'; vm.sortReverse = !vm.sortReverse"> <span ng-class="{unsorted: vm.sortColumn !== \'submittedDate\'}"> Submitted Date <icon ng-show="vm.sortColumn === \'submittedDate\'" name="{{vm.sortReverse ? \'fa-caret-down\' : \'fa-caret-up\'}}" class="icon-table-header" alt="Sorted by Submitted Date"></icon> </span> </th> <th ng-click="vm.sortColumn = \'volunteerApplicationStatus\'; vm.sortReverse = !vm.sortReverse"> <span ng-class="{unsorted: vm.sortColumn !== \'volunteerApplicationStatus\'}"> Status <icon ng-show="vm.sortColumn === \'volunteerApplicationStatus\'" name="{{vm.sortReverse ? \'fa-caret-down\' : \'fa-caret-up\'}}" class="icon-table-header" alt="Sorted by Status"></icon> </span> </th> </tr> </thead> <tbody ng-hide="vm.isLoading"> <tr ng-repeat="application in (vm.filteredApplications = (vm.applications | orderBy:vm.sortColumn:vm.sortReverse | filter:vm.search))" ng-click="vm.onClickApplication(application)"> <td>{{application.volunteerOpportunity}}</td> <td>{{application.volunteerOrganization}}</td> <td>{{application.lastName}}</td> <td>{{application.firstName}}</td> <td>{{application.submittedDate | date:\'MM/dd/yyyy\'}}</td> <td>{{application.volunteerApplicationStatus}}</td> </tr> <tr ng-if="vm.filteredApplications.length === 0"> <td colspan="7"> No data to display </td> </tr> </tbody> </table> <loading-icon show="vm.isLoading"></loading-icon> <load-more is-loading="vm.isLoading" load-status="vm.loadStatus" on-load-more="vm.onLoadMore()" on-load-all="vm.onLoadAll()"></load-more> </div> ');
$templateCache.put('app/components/administrator/applications/approveConfirmation.template.html','<form ng-submit="$close()" name="form"> <modal close="$dismiss" modal-title="Approve Application"> <modal-body> <p>Are you sure you want to approve <span class="bold">{{vm.firstName}} {{vm.lastName}}</span> to volunteer for the following position?</p> <p class="text-center bold">{{vm.positionTitle}}</p> </modal-body> <modal-footer> <div class="pull-right"> <button type="button" class="dflt button" ng-click="vm.onApprove()">Approve</button> <button type="button" class="dflt button" ng-click="vm.onCancel()">Cancel</button> </div> </modal-footer> </modal> </form>');
$templateCache.put('app/components/administrator/applications/deleteConfirmation.template.html','<form ng-submit="$close()" name="form"> <modal close="$dismiss" modal-title="Delete Application"> <modal-body> <p>Are you sure you want to delete <span class="bold">{{vm.firstName}} {{vm.lastName}}</span> to volunteer for the following position?</p> <p class="text-center bold">{{vm.positionTitle}}</p> </modal-body> <modal-footer> <div class="pull-right"> <button type="button" class="dflt button" ng-click="vm.onDelete()">Delete</button> <button type="button" class="dflt button" ng-click="vm.onCancel()">Cancel</button> </div> </modal-footer> </modal> </form>');
$templateCache.put('app/components/administrator/applications/nameFilter.view.html','<form name="form"> <modal close="$dismiss" modal-title="Filter People"> <modal-body> <div class="row"> <div class="small-11 small-centered columns"> <p class="help-text"> Note: Table will reload when a new filter is applied. </p> <label for="firstName"> <span tooltip-html-unsafe="Find all users with a specific first name" tooltip-popup-delay="1000" class="bold has-tip"> First Name </span> <span class="input-group"> <input type="text" id="firstName" class="input-group-field" ng-model="vm.filter.firstName" placeholder="First Name" data-ng-disabled="vm.isLoading"> </span> </label> <label for="lastName"> <span tooltip-html-unsafe="Find all users with a specific last name" tooltip-popup-delay="1000" class="bold has-tip"> Last Name </span> <span class="input-group"> <input type="text" id="lastName" class="input-group-field" ng-model="vm.filter.lastName" placeholder="Last Name" data-ng-disabled="vm.isLoading"> </span> </label> </div> </div> </modal-body> <modal-footer> <div class="pull-right"> <button type="submit" class="dflt button" ng-click="vm.onFilter()" data-ng-disabled="form.$invalid || vm.isLoading"> Filter </button> <button type="button" class="dflt button" ng-click="$dismiss(\'cancel\')" ng-disabled="vm.isLoading"> Cancel </button> </div> </modal-footer> </modal> </form>');
$templateCache.put('app/components/administrator/applications/rejectConfirmation.template.html','<form name="form"> <modal close="$dismiss" modal-title="Decline Application"> <modal-body> <p>Please provide a reason for declining the application of <span class="bold">{{vm.firstName}} {{vm.lastName}}</span> for the following position:</p> <p class="text-center bold">{{vm.positionTitle}}</p> <div class="row"> <label for="reason" class="text-left"> <span class="bold">Reason</span><span class="required text">*</span> <textarea id="reason" placeholder="Reason for declining" rows="3" ng-model="vm.reason" ng-maxlength="1100" name="declineReason" class="vertical-resize-only"></textarea> <label class="character-countdown">{{1100 - form.declineReason.$viewValue.length}}</label> </label> </div> <div class="row"> <label class="help-text"> <span class="pull-left"><span class="required text">*</span> Indicates a required field.</span> <span class="pull-right">Note: {{vm.firstName}} will be able to view this message.</span> </label> </div> </modal-body> <modal-footer> <div class="pull-right"> <button type="button" class="dflt button" ng-click="$close(vm.reason)" data-ng-disabled="!vm.reason">Decline</button> <button type="button" class="dflt button" ng-click="$dismiss()">Cancel</button> </div> </modal-footer> </modal> </form>');
$templateCache.put('app/components/administrator/hours/batchConfirmation.view.html','<form name="form"> <modal close="$dismiss" modal-title="{{vm.status}} Hours"> <modal-body> <p>Are you sure you want to <span class="bold">{{vm.status}}</span> all of the selected hours?</p> <div class="row"> <div ng-switch="vm.status"> <label ng-switch-when="Certify"> <span class="bold">Reviewer Note</span> <text-area-with-count is-required="" number-rows="3" model-name="vm.reviewerNote" max-given-length="350" default-shown-text="Note" is-disabled=""></text-area-with-count> </label> <label ng-switch-when="Reject"> <span class="bold">Reviewer Note</span><span class="required text">*</span> <text-area-with-count is-required="true" number-rows="3" model-name="vm.reviewerNote" max-given-length="350" default-shown-text="Note (required for rejection)" is-disabled=""></text-area-with-count> </label> </div> <p class="help-text pull-right">Note: Volunteers will be able to view this message.</p> <p class="help-text pull-left" ng-if="vm.status === \'Reject\'"><span class="required text">*</span>Indicates a required field.</p> </div> </modal-body> <modal-footer> <div class="float-right"> <button type="button" class="dflt button" ng-click="$close(vm.reviewerNote)" ng-disabled="form.$invalid"> {{vm.status}} </button> <button type="button" class="dflt button" ng-click="$dismiss()"> Cancel </button> </div> </modal-footer> </modal> </form>');
$templateCache.put('app/components/administrator/hours/hours.view.html','<ul class="breadcrumbs"> <li><a ui-sref="vmis" ui-sref-opts="{reload:true}">VMIS</a></li> <li> <span class="show-for-sr">Current: </span>Hours </li> </ul> <learn-about-this-page learn-title="About Hours Page" text-body="The Hours page displays all of the hours recorded by volunteers within a particular community and organization. Volunteer hours can be rejected or certified on this page, either individually or in bulk, as well as edited or deleted.\nAdditionally, more information related to hour entries can be viewed here, such as submitter notes and any attached documentation.\nFor more information on how to use this page, please see section 6.0 in the VMIS OPOC User Guide or section 8.0 in the VMIS AVCC User Guide."></learn-about-this-page> <h1>Hours</h1> <div ng-show="vm.formError" class="callout alert">{{vm.formError}}</div> <div class="row"> <div class="small-6 columns"> <label for="from">From <span class="input-group"> <input id="from" type="text" class="input-group-field" ng-model="vm.filter.startDate" ng-model-options="{updateOn: \'default programmatic\', debounce: {default: 500, programmatic: 0}}" placeholder="MM/DD/YYYY" vmis-datepicker target="start-date" format="M/D/YYYY" end-date="vm.filter.endDate || vm.currentDate" ng-change="vm.onChangeDates(vm.filter.startDate, vm.filter.endDate)" required> <span class="input-group-button"> <button id="start-date" type="button" class="dflt button icon-button" aria-label="Starting date" data-ng-disabled="vm.isLoading"> <icon name="fa-calendar" class="icon-big" alt="Select this calendar icon to choose the starting date"></icon> </button> </span> </span> </label> </div> <div class="small-6 columns"> <label for="to">To <span class="input-group"> <input id="to" type="text" class="input-group-field" ng-model="vm.filter.endDate" ng-model-options="{updateOn: \'default programmatic\', debounce: {default: 500, programmatic: 0}}" placeholder="MM/DD/YYYY" vmis-datepicker target="end-date" format="M/D/YYYY" start-date="vm.filter.startDate" end-date ng-change="vm.onChangeDates(vm.filter.startDate, vm.filter.endDate)" required> <span class="input-group-button"> <button id="end-date" type="button" class="dflt button icon-button" aria-label="Ending date" data-ng-disabled="vm.isLoading"> <icon name="fa-calendar" class="icon-big" alt="Select this calendar icon to choose the ending date"></icon> </button> </span> </span> </label> </div> </div> <div class="row"> <div class="small-4 columns"> <label>Community <ui-select data-ng-change="vm.onSelectCommunity()" data-ng-model="vm.filter.selectedCommunity" data-ng-disabled="vm.isLoading"> <ui-select-match placeholder="Select a community or search..."> {{$select.selected.name}} </ui-select-match> <ui-select-choices repeat="community in vm.communities | propsFilter: {name: $select.search}"> <span ng-bind-html="community.name | highlight: $select.search"></span> </ui-select-choices> </ui-select> </label> </div> <div class="small-4 columns"> <label>Organization <ui-select data-ng-change="vm.onSelectOrganization()" data-ng-model="vm.filter.selectedOrganization" data-ng-disabled="vm.disableOrgDropDown()"> <ui-select-match placeholder="Select an organization or search..."> {{$select.selected.name}} </ui-select-match> <ui-select-choices repeat="organization in vm.filter.selectedCommunity.organizations | propsFilter: {name: $select.search}"> <span ng-bind-html="organization.name | highlight: $select.search"></span> </ui-select-choices> </ui-select> </label> </div> <div class="small-4 columns"> <label>Status <ui-select data-ng-change="vm.onStatusChange()" data-ng-model="vm.filter.status" data-ng-disabled="vm.isLoading"> <ui-select-match placeholder="Select a status or search..."> {{$select.selected}} </ui-select-match> <ui-select-choices repeat="status in vm.statusTypes | filter:$select.search"> <span ng-bind-html="status | highlight: $select.search"></span> </ui-select-choices> </ui-select> </label> </div> </div> <div id="button-row-spacing" class="row"> <form> <div class="small-8 columns"> <div class="input-group"> <div class="input-group-label icon-label"> <icon name="fa-search" class="icon-lg"></icon> </div> <label for="lastName" class="offscreen">Last Name</label> <input type="text" id="lastName" class="input-group-field" placeholder="Last name" ng-model="vm.filter.lastName"> <span class="input-group-glue"></span> <label for="firstName" class="offscreen">First Name</label> <input type="text" id="firstName" class="input-group-field" placeholder="First name" ng-model="vm.filter.firstName"> <div class="input-group-button"> <button type="submit" class="dflt button" ng-disabled="vm.isLoading" ng-click="vm.onClickSearch()" disabled="disabled">Search</button> </div> </div> </div> </form> <div id="certify-reject-hours-btns" class="small-4 columns"> <button type="button" class="dflt button" data-ng-disabled="!vm.activityChecked" ng-click="vm.onClickBatch(\'Reject\')">Reject </button> <button type="button" class="dflt button" data-ng-disabled="!vm.activityChecked" ng-click="vm.onClickBatch(\'Certify\')">Certify </button> </div> </div> <retrieved-results is-loading="vm.isLoading" load-status="vm.loadStatus"></retrieved-results> <table class="information-table table"> <thead> <tr> <th class="tiny"> <input type="checkbox" class="checkbox" id="checkbox-all" aria-label="Check all" ng-model="vm.checkAll" ng-click="vm.onCheckAll()" ng-disabled="vm.filter.status === \'Deleted\'"> </th> <th class="ten" ng-click="vm.sortColumn = \'volunteer.lastName\'; vm.sortReverse = !vm.sortReverse"> <span ng-class="{unsorted: vm.sortColumn !== \'volunteer.lastName\'}"> Last Name <icon ng-show="vm.sortColumn === \'volunteer.lastName\'" class="icon-table-header" name="{{vm.sortReverse ? \'fa-caret-down\' : \'fa-caret-up\'}}" alt="Sorted by Last Name"></icon> </span> </th> <th class="ten" ng-click="vm.sortColumn = \'volunteer.firstName\'; vm.sortReverse = !vm.sortReverse"> <span ng-class="{unsorted: vm.sortColumn !== \'volunteer.firstName\'}"> First Name <icon ng-show="vm.sortColumn === \'volunteer.firstName\'" class="icon-table-header" name="{{vm.sortReverse ? \'fa-caret-down\' : \'fa-caret-up\'}}" alt="Sorted by First Name"></icon> </span> </th> <th class="twenty-five" ng-click="vm.sortColumn = \'position.title\'; vm.sortReverse = !vm.sortReverse"> <span ng-class="{unsorted: vm.sortColumn !== \'position.title\'}"> Position <icon ng-show="vm.sortColumn == \'position.title\'" class="icon-table-header" name="{{vm.sortReverse ? \'fa-caret-down\' : \'fa-caret-up\'}}" alt="Sorted by Position"></icon> </span> </th> <th class="twenty" ng-click="vm.sortColumn = \'organization\'; vm.sortReverse = !vm.sortReverse"> <span ng-class="{unsorted: vm.sortColumn !== \'organization\'}"> Organization <icon ng-show="vm.sortColumn == \'organization\'" class="icon-table-header" name="{{vm.sortReverse ? \'fa-caret-down\' : \'fa-caret-up\'}}" alt="Sorted by Organization"></icon> </span> </th> <th class="ten" ng-click="vm.sortColumn = \'type\'; vm.sortReverse = !vm.sortReverse"> <span ng-class="{unsorted: vm.sortColumn !== \'type\'}"> Type <icon ng-show="vm.sortColumn == \'type\'" class="icon-table-header" name="{{vm.sortReverse ? \'fa-caret-down\' : \'fa-caret-up\'}}" alt="Sorted by Type"></icon> </span> </th> <th class="twenty" ng-click="vm.sortColumn = \'date\'; vm.sortReverse = !vm.sortReverse"> <span ng-class="{unsorted: vm.sortColumn !== \'date\'}"> Date <icon ng-show="vm.sortColumn == \'date\'" class="icon-table-header" name="{{vm.sortReverse ? \'fa-caret-down\' : \'fa-caret-up\'}}" alt="Sorted by Date"></icon> </span> </th> <th class="five" ng-click="vm.sortColumn = \'hours\'; vm.sortReverse = !vm.sortReverse"> <span ng-class="{unsorted: vm.sortColumn !== \'hours\'}"> Hours <icon ng-show="vm.sortColumn == \'hours\'" class="icon-table-header" name="{{vm.sortReverse ? \'fa-caret-down\' : \'fa-caret-up\'}}" alt="Sorted by Hours"></icon> </span> </th> <th class="five" ng-click="vm.sortColumn = \'status\'; vm.sortReverse = !vm.sortReverse"> <span ng-class="{unsorted: vm.sortColumn !== \'status\'}"> Status <icon ng-show="vm.sortColumn == \'status\'" class="icon-table-header" name="{{vm.sortReverse ? \'fa-caret-down\' : \'fa-caret-up\'}}" alt="Sorted by Status"></icon> </span> </th> <th class="tiny"></th> </tr> </thead> <tbody ng-hide="vm.isLoading"> <tr ng-repeat="activity in vm.activities | orderBy:vm.sortColumn:vm.sortReverse" ng-class-even="\'even\'" ng-class-odd="\'odd\'"> <td> <input type="checkbox" class="checkbox" aria-label="{{\'Select entry\' + ($index + 1) }}" id="{{ \'checkbox-\' + ($index + 1) }}" ng-model="activity.isChecked" ng-click="vm.onCheckActivity()" ng-disabled="activity.status === \'Deleted\'"> </td> <td>{{activity.volunteer.lastName}}</td> <td>{{activity.volunteer.firstName}}</td> <td>{{activity.position.title}}</td> <td>{{activity.organization}}</td> <td>{{activity.type}}</td> <td>{{activity.date | date:activity.type === \'Daily\' ? \'MMMM dd, yyyy\' : \'MMMM yyyy\'}}</td> <td>{{activity.hours | number:2}}</td> <td class="table-icon-column-entry"> <div tooltip="{{activity.status}}" class="text-center"> <vmis-hours-status status="activity.status"></vmis-hours-status> </div> </td> <td class="table-icon-column-entry clickable" ng-click="vm.onActivityClick(activity)"> <icon name="fa-pencil" class="icon-lg" alt="Select this pencil icon to edit this hour entry"></icon> </td> </tr> <tr ng-if="vm.activities.length === 0"> <td colspan="10"> No data to display </td> </tr> </tbody> </table> <loading-icon show="vm.isLoading"></loading-icon> <load-more is-loading="vm.isLoading" load-status="vm.loadStatus" on-load-more="vm.onLoadMore()" on-load-all="vm.onLoadAll()"></load-more> <div class="reveal fade" id="myModal" data-reveal> <div id=""></div> </div> ');
$templateCache.put('app/components/administrator/hours/manageActivity.view.html','<form name="form"> <modal close="$dismiss" modal-title="{{vm.title}}"> <modal-body id="activityModal"> <div ng-show="vm.formError" class="callout alert">{{vm.formError}}</div> <div ng-if="!vm.isNew"> <div class="row"> <div class="small-6 columns"> <label class="control-label">Volunteer</label> <p class="form-control-static"> {{vm.activity.volunteer.firstName}} {{vm.activity.volunteer.lastName}} </p> </div> <div class="small-3 columns"> <label class="control-label">Submitted By</label> <p class="form-control-static">{{vm.submitterText}}</p> </div> <div class="small-3 columns"> <label class="control-label">Status</label> <p class="form-control-static">{{vm.activity.status}}</p> </div> </div> <div class="row"> <div class="small-6 columns"> <label class="control-label">Position</label> <p class="form-control-static">{{vm.activity.position.title}}</p> </div> <div class="small-6 columns"> <label class="control-label">Organization</label> <p class="form-control-static">{{vm.activity.organization}}</p> </div> </div> </div> <div ng-if="vm.isNew"> <div class="row"> <div class="small-4 columns"> <label class="control-label">Volunteer</label> <p class="form-control-static"> {{vm.activity.volunteer.firstName}} {{vm.activity.volunteer.lastName}} </p> </div> <div class="small-4 columns"> <label class="control-label">Position</label> <p class="form-control-static">{{vm.activity.position.title}}</p> </div> <div class="small-4 columns"> <label class="control-label">Organization</label> <p class="form-control-static">{{vm.activity.organization}}</p> </div> </div> </div> <hr> <div class="row"> <div ng-if="!vm.rejectOnly"> <div class="small-6 columns"> <label class="control-label">Hours</label> <ui-select class="form-control-static" data-ng-change="vm.onChangeHours()" data-ng-model="vm.numHours" data-ng-disabled="vm.isLoading || vm.isDeleted"> <ui-select-match placeholder=""> {{$select.selected}} </ui-select-match> <ui-select-choices repeat="hour in vm.hrLabel | filter:$select.search"> <span ng-bind-html="hour | highlight: $select.search"></span> </ui-select-choices> </ui-select> </div> <div class="small-6 columns"> <label class="control-label">Minutes</label> <ui-select class="form-control-static" data-ng-change="vm.onChangeHours()" data-ng-model="vm.numMinutes" data-ng-disabled="vm.isLoading || vm.isDeleted"> <ui-select-match placeholder=""> {{$select.selected}} </ui-select-match> <ui-select-choices repeat="min in vm.minLabel | filter:$select.search"> <span ng-bind-html="min | highlight: $select.search"></span> </ui-select-choices> </ui-select> </div> </div> <div ng-if="vm.rejectOnly" class="small-12 columns"> <label class="control-label">Hours</label> <p>{{vm.numHours + vm.numMinutes / 60 | number:2}}</p> </div> </div> <div class="row" ng-if="!vm.isNew && vm.hoursEdited"> <div class="small-11 small-centered columns small-warning text-center"> <span> <icon name="fa-exclamation-circle" class="icon-small-exclamation" aria-hidden="true" alt="Edited"></icon> <span>(Edited from {{vm.originalHours | number:2}})</span> </span> </div> </div> <div class="row" ng-if="!vm.rejectOnly || vm.activity.volunteerNote"> <div class="small-12 columns"> <label><span class="control-label">Submitter Note</span> <div ng-if="!vm.rejectOnly"> <text-area-with-count is-required="false" number-rows="3" model-name="vm.activity.volunteerNote" max-given-length="350" default-shown-text="Note (required for period hours)" is-disabled="vm.isLoading || !vm.isNew || vm.isDeleted"></text-area-with-count> <p class="help-text pull-right" ng-if="vm.isNew"> Note: {{vm.activity.volunteer.firstName}} will be able to view this message. </p> </div> <div ng-if="vm.rejectOnly"> <p>{{vm.activity.volunteerNote}}</p> </div> </label> </div> </div> <hr> <div class="row"> <div class="small-12 columns"> <label class="control-label">Documentation</label> <p ng-if="vm.rejectOnly"> Documents, if attached, are not viewable from this page. Go to the full-featured Hours page to review. </p> </div> <div ng-if="!vm.rejectOnly"> <div class="small-9 columns"> <upload-document-list uploaded-documents="vm.uploadedDocuments" selected-documents="vm.selectedDocuments" on-delete-uploaded-doc="vm.onDeleteUploadedDoc" on-delete-selected-doc="vm.onDeleteSelectedDoc" show-upload-instructions="true" show-delete="true" disable-delete="vm.isLoading || vm.isDeleted"> </upload-document-list> </div> <div class="small-3 columns"> <button type="button" aria-label="Attach a document" class="dflt button expanded icon-button" multiple="multiple" ngf-max-size="{{vm.maxFileSizeInMegabytes}}" ngf-select="vm.onSelectDoc($files, $invalidFiles); form.$setDirty()" ngf-pattern="{{vm.allowedFileTypesForUpload}}" accept="{{vm.allowedFileTypesForUpload}}" ng-disabled="vm.isLoading || vm.maxDocumentsUploaded || vm.isDeleted"> <icon name="fa-paperclip" class="icon-big" aria-hidden="true" ng-hide="vm.isDocumentUploading" alt="Select this paperclip to attach a document"></icon> <loading-icon show="vm.isDocumentUploading" little="true"></loading-icon> </button> </div> </div> </div> <hr ng-if="!vm.isNew"> <div class="row" ng-if="!vm.isNew"> <div class="small-12 small-centered columns"> <label><span class="control-label">Reviewer Note</span> <text-area-with-count is-required="false" number-rows="3" model-name="vm.activity.reviewerNote" max-given-length="350" default-shown-text="Note (required for changing hours, rejecting, and deleting)" is-disabled="vm.isDeleted"></text-area-with-count> </label> <p class="help-text pull-right"> Note: {{vm.activity.volunteer.firstName}} will be able to view this message. </p> </div> </div> </modal-body> <modal-footer> <div class="row"> <div ng-switch="vm.isNew" class="small-12 columns"> <div ng-switch-when="true" class="float-right"> <button type="submit" class="dflt button" ng-click="vm.onClickCertify()" data-ng-disabled="vm.isLoading || !vm.hoursEdited || !(vm.isDaily || vm.activity.volunteerNote)"> Certify </button> <button type="button" class="dflt button" ng-click="$dismiss(\'cancel\')" data-ng-disabled="vm.isLoading"> Cancel </button> </div> <div ng-switch-default class="float-right"> <div ng-if="!vm.rejectOnly && !vm.isDeleted"> <button type="button" class="dflt button" ng-click="vm.onClickDelete()" ng-disabled="vm.isLoading || !vm.activity.reviewerNote || vm.hoursEdited"> Delete </button> <button type="submit" class="dflt button" ng-click="vm.onClickReject()" data-ng-disabled="vm.isLoading || !vm.activity.reviewerNote || vm.hoursEdited"> Reject </button> <button type="submit" class="dflt button" ng-click="vm.onClickCertify()" data-ng-disabled="vm.isLoading || (!vm.activity.reviewerNote && vm.hoursEdited)"> Certify </button> <button type="button" class="dflt button" ng-click="$dismiss(\'cancel\')" data-ng-disabled="vm.isLoading"> Cancel </button> </div> <div ng-if="vm.rejectOnly && !vm.isDeleted"> <button type="submit" class="dflt button" ng-click="vm.onClickReject()" data-ng-disabled="vm.isLoading || !vm.activity.reviewerNote || vm.hoursEdited"> Reject </button> <button type="button" class="dflt button" ng-click="$dismiss(\'cancel\')"> Cancel </button> </div> <div ng-if="vm.isDeleted"> <button type="button" class="dflt button" ng-click="$dismiss(\'ok\')"> OK </button> </div> </div> </div> </div> </modal-footer> </modal> </form>');
$templateCache.put('app/components/administrator/invitations/acceptInvite.view.html','<ui-view> <h1>Accept {{vm.role}} Invitation</h1> <div ng-show="vm.formError" class="callout alert">{{vm.formError}}</div> <form ng-submit="vm.onSubmit()" ng-show="vm.showInvite"> <p>{{vm.firstName}} {{vm.lastName}},</p> <div ng-switch="vm.role"> <div ng-switch-when="AVC Coordinator"> <div ng-include="\'app/components/administrator/invitations/acceptInviteTemplates/coordinator.view.html\'"></div> </div> <div ng-switch-when="AVC Region Manager"> <div ng-include="\'app/components/administrator/invitations/acceptInviteTemplates/regionManager.view.html\'"></div> </div> <div ng-switch-when="AVC OPOC"> <div ng-include="\'app/components/administrator/invitations/acceptInviteTemplates/opoc.view.html\'"></div> </div> </div> <div class="pull-right"> <button type="submit" class="dflt button" ng-disabled="vm.expired">Accept</button> </div> </form> <div ng-show="vm.expired"> <p>This invitation has expired.</p> </div> <div ng-show="vm.accepted"> <p>This invitation has already been accepted.</p> </div> </ui-view>');
$templateCache.put('app/components/administrator/invitations/deleteInvite.view.html','<form ng-submit="$close()" name="form"> <modal close="$dismiss" modal-title="{{vm.title}}"> <modal-body> Are you sure you want to delete the {{vm.role}} invite for {{vm.fullName}} ({{vm.email}})? </modal-body> <modal-footer> <div class="float-right"> <div> <button type="button" class="dflt button" ng-click="$close()">Yes</button> <button type="button" class="dflt button" ng-click="$dismiss()">No</button> </div> </div> </modal-footer> </modal> </form>');
$templateCache.put('app/components/administrator/invitations/invitations.view.html','<div ui-view> <ul class="breadcrumbs"> <li><a ui-sref="vmis" ui-sref-opts="{reload:true}">VMIS</a></li> <li> <span class="show-for-sr">Current: </span>{{vm.title}} </li> </ul> <learn-about-this-page learn-title="About Invitations Page" text-body="The Invitations page is where invitations are sent to individuals who have been designated as OPOCs. Invitations can be resent or deleted from this page, and detailed information about new OPOCs invitations is also available.\nWhen an individual is invited to become an OPOC, they are expected to assume all OPOC responsibilities of one or more organizations. The invited person will receive an email with instructions on how to accept the invitation and proceed to the system, but an invitation will expire if the recipient does not accept it within 30 days.\nFor more information on how to use this page, please see section 4.0 in the VMIS AVCC User Guide."></learn-about-this-page> <h1>{{vm.title}}</h1> <alert ng-repeat="alert in vm.alerts" type="alert.type" close="vm.onCloseAlert($index)">{{alert.message}}</alert> <div class="expanded row"> <div ng-if="vm.roles" class="small-3 columns"> <label id="role">Role</label> </div> <div class="small-3 columns end"> <label id="status">Status</label> </div> </div> <div class="expanded row"> <div class="small-3 columns" ng-if="vm.roles"> <ui-select data-ng-model="vm.role" data-ng-change="vm.getInvites(0, vm.loadStatus.defaultNumRows)" data-ng-disabled="vm.isLoading"> <ui-select-match placeholder="Select a role or search..."> {{$select.selected.name}} </ui-select-match> <ui-select-choices repeat="role.role as role in vm.roles | propsFilter: {name: $select.search}"> <span ng-bind-html="role.name | highlight: $select.search"></span> </ui-select-choices> </ui-select> </div> <div class="small-3 columns"> <ui-select data-ng-model="vm.currentStatus" data-ng-change="vm.getInvites(0, vm.loadStatus.defaultNumRows)" data-ng-disabled="vm.isLoading"> <ui-select-match placeholder="Select a status or search..."> {{$select.selected}} </ui-select-match> <ui-select-choices repeat="status in vm.status | filter:$select.search"> <span ng-bind-html="status | highlight: $select.search"></span> </ui-select-choices> </ui-select> </div> <div class="small-4 columns"> <button type="button" class="dflt button float-right remove-bottom-margin" data-ng-disabled="vm.isLoading" ng-click="vm.sendInvite()" ng-switch="vm.role"> <span ng-switch-when="AVC OPOC">Invite New OPOC</span> <span ng-switch-when="AVC Coordinator">Invite New AVCC</span> <span ng-switch-default>Send Invite</span> </button> </div> </div> <retrieved-results is-loading="vm.isLoading" load-status="vm.loadStatus"></retrieved-results> <table class="information-table table"> <thead> <tr> <th ng-click="vm.sortColumn = \'invitationDate\'; vm.sortReverse = !vm.sortReverse"> <span ng-class="{unsorted: vm.sortColumn !== \'invitationDate\'}"> Date Sent <icon ng-show="vm.sortColumn === \'invitationDate\'" name="{{vm.sortReverse ? \'fa-caret-down\' : \'fa-caret-up\'}}" class="icon-table-header" alt="Sorted by Date Sent"></icon> </span> </th> <th ng-click="vm.sortColumn = \'lastName\'; vm.sortReverse = !vm.sortReverse"> <span ng-class="{unsorted: vm.sortColumn !== \'lastName\'}"> Last Name <icon ng-show="vm.sortColumn === \'lastName\'" name="{{vm.sortReverse ? \'fa-caret-down\' : \'fa-caret-up\'}}" class="icon-table-header" alt="Sorted by Last Name"></icon> </span> </th> <th ng-click="vm.sortColumn = \'firstName\'; vm.sortReverse = !vm.sortReverse"> <span ng-class="{unsorted: vm.sortColumn !== \'firstName\'}"> First Name <icon ng-show="vm.sortColumn === \'firstName\'" name="{{vm.sortReverse ? \'fa-caret-down\' : \'fa-caret-up\'}}" class="icon-table-header" alt="Sorted by First Name"></icon> </span> </th> <th ng-click="vm.sortColumn = \'emailAddress\'; vm.sortReverse = !vm.sortReverse"> <span ng-class="{unsorted: vm.sortColumn !== \'emailAddress\'}"> Email <icon ng-show="vm.sortColumn === \'emailAddress\'" name="{{vm.sortReverse ? \'fa-caret-down\' : \'fa-caret-up\'}}" class="icon-table-header" alt="Sorted by Email Address"></icon> </span> </th> <th ng-click="vm.sortColumn = \'status\'; vm.sortReverse = !vm.sortReverse"> <span ng-class="{unsorted: vm.sortColumn !== \'status\'}"> Status <icon ng-show="vm.sortColumn === \'status\'" name="{{vm.sortReverse ? \'fa-caret-down\' : \'fa-caret-up\'}}" class="icon-table-header" alt="Sorted by Status"></icon> </span> </th> <th width="1"></th> </tr> </thead> <tbody ng-hide="vm.isLoading"> <tr ng-repeat="invite in (vm.sortedInvites = (vm.invites | orderBy:vm.sortColumn:vm.sortReverse))" ng-class-even="\'even\'" ng-class-odd="\'odd\'"> <td>{{invite.invitationDate | date:\'MM/dd/yyyy\'}}</td> <td>{{invite.lastName}}</td> <td>{{invite.firstName}}</td> <td>{{invite.emailAddress}}</td> <td>{{invite.status}}</td> <td class="table-icon-column-entry"> <icon ng-click="vm.sendInvite(invite)" ng-if="invite.status !== \'Accepted\'" name="fa-pencil" class="icon-lg clickable" alt="Select this pencil icon to edit this Invitation"></icon> </td> </tr> <tr ng-if="vm.sortedInvites.length === 0"> <td colspan="6"> No data to display </td> </tr> </tbody> </table> <loading-icon show="vm.isLoading"></loading-icon> <load-more is-loading="vm.isLoading" load-status="vm.loadStatus" on-load-more="vm.onLoadMore()" on-load-all="vm.onLoadAll()"></load-more> </div> ');
$templateCache.put('app/components/administrator/invitations/inviteAccepted.view.html','<h1 align="center">Invitation Accepted</h1> <p align="center">Click <a ui-sref="vmis.profile">here</a> to fill out your administrator profile </p> ');
$templateCache.put('app/components/administrator/invitations/inviteNotFound.view.html','<h1 align="center">Invitation Not Found</h1> <p align="center">Click <a ui-sref="vmis.dashboard">here</a> to return to your dashboard</p>');
$templateCache.put('app/components/administrator/invitations/sendInvite.view.html','<form ng-submit="vm.onSubmit()" name="form"> <modal close="$dismiss" modal-title="{{vm.title}}"> <modal-body> <label class="help-text"> <span class="required text">*</span>Indicates a required field. </label> <label class="help-text"> This invitation will be valid for 30 days from the send date, after which point it will be expired. </label> <div data-alert class="row alert-box alert" ng-show="vm.errorText"> {{vm.errorText}} </div> <div ng-switch="vm.role"> <div ng-switch-when="AVC OPOC"> <label> <span class="bold has-tip" tooltip-popup-delay="200" tooltip-placement="right" tooltip="Select a Community to filter the Organizations that appear as options below"> Community </span> <ui-select required data-ng-model="vm.selectedCommunity" data-ng-change="vm.onChangeCommunity()" data-ng-disabled="vm.isLoading"> <ui-select-match placeholder="Select a community or search..."> {{$select.selected.communityAffiliationName}} </ui-select-match> <ui-select-choices repeat="comm in vm.communities"> <span ng-bind-html="comm.communityAffiliationName | highlight: $select.search"></span> </ui-select-choices> </ui-select> </label> <label> <span class="bold has-tip" tooltip-popup-delay="200" tooltip-placement="right" tooltip="Click within the text box below to view and search for Organizations"> Organizations </span><span class="required text">*</span> <ui-select multiple="multiple" role="listbox" ng-model="vm.invitedResponsibilities" on-select="vm.onSelectOrg($item, $model)" close-on-select="false" data-ng-disabled="vm.isLoading"> <ui-select-match placeholder="Select an organization or search..."> {{$item.organizationName}} <span ng-if="($item.communityAffiliationId !== vm.selectedCommunity.communityAffiliationId)"><br>[{{$item.communityAffiliationName}}]</span> </ui-select-match> <ui-select-choices repeat="org in vm.selectedCommunity.organizations | propsFilter: {organizationName: $select.search}" position="down"> <div ng-bind-html="org.organizationName | highlight: $select.search"></div> </ui-select-choices> </ui-select> </label> </div> </div> <label> <span class="bold">Email</span><span class="required text">*</span> <input type="email" placeholder="Enter Email" ng-model="vm.email" required ng-disabled="vm.isLoading"> </label> <label for="fName"> <span class="bold">First Name</span><span class="required text">*</span> <input type="text" id="fName" placeholder="Enter First Name" ng-model="vm.firstName" required ng-disabled="vm.isLoading"> </label> <label for="lName"> <span class="bold">Last Name</span><span class="required text">*</span> <input type="text" id="lName" placeholder="Enter Last Name" ng-model="vm.lastName" required ng-disabled="vm.isLoading"> </label> <div class="row"> <div class="columns small-7 center-horizontal"> <input id="checkbox-2" type="checkbox" ng-model="vm.requestReadReceipt" ng-disabled="vm.isLoading"> <label for="checkbox-2">Request Read Receipt</label> </div> <div class="columns small-5 center-horizontal"> <input id="checkbox-3" type="checkbox" ng-model="vm.bcc" ng-disabled="vm.isLoading"> <label for="checkbox-3">BCC</label> </div> </div> <label for="bccEmail" ng-show="vm.bcc"> <span class="bold">BCC Email</span><span class="required text">*</span> <input type="email" id="bccEmail" placeholder="Enter BCC Email" ng-model="vm.bccEmailAddress" ng-required="vm.bcc" ng-disabled="vm.isLoading"> </label> </modal-body> <modal-footer> <div ng-if="!vm.isEditing" class="float-right"> <button type="submit" class="dflt button" ng-switch="vm.role" data-ng-disabled="form.$invalid || vm.invitedResponsibilities.length === 0 || vm.isLoading"> <span ng-switch-when="AVC OPOC">Invite New OPOC</span> </button> <button type="button" class="dflt button" ng-click="$dismiss()" ng-disabled="vm.isLoading">Cancel </button> </div> <div ng-if="vm.isEditing" class="float-right"> <button type="submit" class="dflt button" data-ng-disabled="form.$invalid || vm.invitedResponsibilities.length === 0 || vm.isLoading"> Resend </button> <button type="button" class="dflt button" ng-click="vm.onClickDelete()" ng-disabled="vm.isLoading"> Delete </button> <button type="button" class="dflt button" ng-click="$dismiss()" ng-disabled="vm.isLoading"> Cancel </button> </div> </modal-footer> </modal> </form> ');
$templateCache.put('app/components/administrator/mergeAccounts/addEmailUsername.view.html','<form name="form" ng-submit="vm.onConfirm()"> <modal close="$dismiss" modal-title="{{vm.title}}"> <modal-body> <div class="row" ng-if="vm.title === \'Add Email\'"> <label for="emailAddress">Email</label> <input id="emailAddress" type="email" data-ng-model="vm.item" autofocus> </div> <div class="row" ng-if="vm.title === \'Add Non-User\'"> <label for="nonuser">Non User</label> <input id="nonuser" type="text" data-ng-model="vm.item" autofocus> </div> <div class="row" ng-if="vm.title === \'Add Username\'"> <label for="username">Username</label> <input id="username" type="text" data-ng-model="vm.item" autofocus> </div> </modal-body> <modal-footer> <div class="float-right"> <button type="submit" class="dflt button" ng-disabled="form.$invalid || form.$pristine">Add</button> <button type="button" class="dflt button" ng-click="vm.onCancel()">Cancel</button> </div> </modal-footer> </modal> </form>');
$templateCache.put('app/components/administrator/mergeAccounts/confirmMerge.view.html','<form name="form"> <modal close="$dismiss" modal-title="Merge Confirmation"> <modal-body> <loading-icon show="vm.isLoading"></loading-icon> <div ng-if="!vm.isLoading"> <p>Note: After completion of the merge, all data pertaining to the Merge From user(s) will be deleted from the VMIS system.</p> <p>Their user account will still exist in AFWP SSO, except non-user accounts which will be deleted.</p> <p>You should be signed out of all Merge From accounts in order to continue.</p> <p>Are you sure you want to merge?</p> <p><b>To Email:</b> {{vm.toEmail}}</p> <div ng-if="vm.fromUsernames.length !== 0"> <span> <b>From Username(s):</b> </span> <ul> <li ng-repeat="username in vm.fromUsernames">{{username}}</li> </ul> </div> <div ng-if="vm.fromEmails.length !== 0"> <span> <b>From Email(s):</b> </span> <ul> <li ng-repeat="email in vm.fromEmails">{{email}}</li> </ul> </div> <div ng-if="vm.fromNonUsers.length !== 0"> <span> <b>From Non-User(s):</b> </span> <ul> <li ng-repeat="nonUser in vm.fromNonUsers">{{nonUser}}</li> </ul> </div> </div> </modal-body> <modal-footer> <div class="float-right"> <button type="button" class="dflt button" ng-click="vm.onConfirm()" ng-disabled="vm.isLoading" autofocus>Merge</button> <button type="button" class="dflt button" ng-click="vm.onCancel()" ng-disabled="vm.isLoading">Cancel</button> </div> </modal-footer> </modal> </form>');
$templateCache.put('app/components/administrator/mergeAccounts/hoursAppsDetails.view.html','<form name="form" ng-submit="vm.onConfirm()"> <modal close="$dismiss" modal-title="{{vm.title}}"> <modal-body> <div ng-if="vm.title === \'Hours Details\'"> <div ng-repeat="hour in vm.hours"> <label><b>HoursId:</b> {{hour.volunteerHoursId}}</label> <label><b>Hours Status:</b> {{hour.volunteerHoursStatus}}</label> <label><b>Day of Service:</b> {{hour.dayOfService}}</label> <label><b>Period of Service:</b> {{hour.periodOfService}}</label> <label><b>Opportunity Name:</b> {{hour.volunteerOrganizationOpportunity}}</label> <label><b>OpportunityId:</b> {{hour.volunteerOrganizationOpportunityId}}</label> <br> </div> </div> <div ng-if="vm.title === \'Applications Details\'"> <div ng-repeat="app in vm.applications"> <label><b>ApplicationId:</b> {{app.volunteerApplicationId}}</label> <label><b>Application Status:</b> {{app.volunteerApplicationStatus}}</label> <label><b>Opportunity Name:</b> {{app.volunteerOrganizationOpportunity}}</label> <label><b>OpportunityId:</b> {{app.volunteerOrganizationOpportunityId}}</label> <br> </div> </div> </modal-body> <modal-footer> <div class="float-right"> <button type="submit" class="dflt button" autofocus>OK</button> </div> </modal-footer> </modal> </form>');
$templateCache.put('app/components/administrator/mergeAccounts/mergeAccounts.view.html','<form ng-submit="vm.onSave()" name="form"> <ul class="breadcrumbs"> <li><a ui-sref="vmis" ui-sref-opts="{reload:true}">VMIS</a></li> <li> <span class="show-for-sr">Current: </span>Merge Accounts </li> </ul> <h1>Merge Accounts</h1> <alert ng-repeat="alert in vm.alerts" type="alert.type" close="vm.onCloseAlert($index)">{{alert.message}}</alert> <div> <div class="row"> <div class="small-3 columns help-text" style="text-align: left"> <span> You will merge the following data: </span> <ul> <li>Hours</li> <li>Applications</li> <li>Awards</li> <li>Trainings</li> <li>Orientations</li> <li>Background Checks</li> <li>Notes</li> <li>Documents</li> <li>VMIS Roles</li> </ul> </div> <div class="small-9 columns help-text" style="text-align: left"> <p> If there are hours on the same day within the same opportunity in the Merge To user and Merge From user(s), then the hours entries from the Merge From user(s) will be deleted. </p> <p> If there are accepted applications within the same opportunity in the Merge To user and Merge From user(s), then the application from the Merge From user(s) will be deleted. </p> <p> If there is a submitted/rejected application in the Merge To user and (an) approved application(s) in the Merge From user(s) within the same opportunity, then the application in the Merge To user will be approved, hours from the Merge From user(s) application(s) will be moved to the Merge To user application, and the Merge from user(s) application(s) will be deleted. </p> <p> Note: After completion of the merge, all data pertaining to the Merge From user(s) will be deleted from the VMIS system. Their user account(s) will still exist in AFWP SSO, and their AOS Profile(s) will be retained, however. You should be signed out of all Merge From accounts in order to continue. </p> <p> You cannot merge from a user who is an AFWP Admin or Program Manager. All other VMIS roles in the Merge From user(s) will be transferred to the Merge To user. The responsibilities for those roles will be combined into a single set with no duplicates. </p> </div> </div> </div> <div> <div class="row"> <div class="small-3 columns"> <label for="mergeToUser" class="bold text-right middle"> Merge To Email Address </label> </div> <div class="small-9 columns"> <input id="mergeToUser" type="email" data-ng-model="vm.mergeToUser" ng-disabled="vm.isLoading"> </div> </div> </div> <div> <div class="row"> <div class="small-3 columns"> <label for="email" class="bold text-right middle"> <span id="merge-from-email-label-text" class="has-tip" tooltip="If entering a legacy AOS account to merge from, you must use the username, not any associated email." tooltip-placement="right" tooltip-popup-delay="1000"> Merge From Email Addresses </span> </label> </div> <div class="small-9 columns"> <textarea readonly="readonly" id="email" rows="3" data-ng-model="vm.selectedEmailList"></textarea> <button id="add-email-button" type="button" style="margin-left: 5px" class="dflt button float-right" ng-click="vm.onClickEmail()" ng-disabled="vm.isLoading"> Add Email Address </button> <button id="clear-email-button" type="button" class="dflt button float-right" ng-click="vm.onClearData(\'email\')" ng-disabled="vm.isLoading"> Clear Email Addresses </button> </div> </div> <div class="row"> <div class="small-3 columns"> <label for="username" class="bold text-right middle"> Merge From Usernames </label> </div> <div class="small-9 columns"> <textarea readonly="readonly" id="username" rows="3" data-ng-model="vm.selectedUsernameList"></textarea> <button id="add-username-button" type="button" style="margin-left: 5px" class="dflt button float-right" ng-click="vm.onClickUsername()" ng-disabled="vm.isLoading"> Add Username </button> <button id="clear-username-button" type="button" class="dflt button float-right" ng-click="vm.onClearData(\'username\')" ng-disabled="vm.isLoading"> Clear Usernames </button> </div> </div> </div> <div class="row"> <div class="small-3 columns"> <label for="nonuser" class="bold text-right middle"> Merge From Non-Users </label> </div> <div class="small-9 columns"> <textarea readonly="readonly" id="nonuser" rows="3" data-ng-model="vm.selectedNonUserList"></textarea> <button id="add-nonuser-button" type="button" style="margin-left: 5px" class="dflt button float-right" ng-click="vm.onClickNonUser()" ng-disabled="vm.isLoading"> Add Non-User </button> <button id="clear-nonuser-button" type="button" class="dflt button float-right" ng-click="vm.onClearData(\'nonuser\')" ng-disabled="vm.isLoading"> Clear Non-Users </button> </div> </div>  <div> <br> <br> <div class="row"> <div class="float-right"> <button id="clear-all-data-button" type="button" class="dflt button" ng-click="vm.onClearData(\'all\')" ng-disabled="vm.isLoading"> Clear All Data </button> <button id="get-merge-info-button" type="button" class="dflt button" ng-click="vm.onClickMergeStats()" ng-class="{\'icon-button\': vm.isLoading}" ng-disabled="vm.isLoading || vm.mergeToUser === \'\' || form.$invalid || form.$pristine ||\n                        (vm.selectedEmails.length === 0 && vm.selectedUsernames.length === 0 && vm.selectedNonUsers.length === 0)"> <span ng-hide="vm.isLoading">Get Merge Info</span> <loading-icon show="vm.isLoading" little="true"></loading-icon> </button> <button id="merge-account-data-button" type="button" class="dflt button" ng-click="vm.onClickMerge()" ng-disabled="vm.isLoading || vm.mergeToUser === \'\' || form.$invalid || form.$pristine ||\n                        (vm.selectedEmails.length === 0 && vm.selectedUsernames.length === 0 && vm.selectedNonUsers.length === 0)"> Merge Account Data </button> </div> </div> </div> </form>');
$templateCache.put('app/components/administrator/mergeAccounts/mergeCompleted.view.html','<form name="form" ng-submit="vm.onConfirm()"> <modal modal-title="{{vm.title}}"> <modal-body> <table class="table information-table"> <thead> <tr ng-if="vm.title === \'Merge Information\'"> <th>Item</th> <th>Merge Conflicts (discard from user)</th> <th>Merge Conflicts (update to user)</th> <th>Total Merging Successfully</th> </tr> <tr ng-if="vm.title === \'Merge Results\'"> <th>Item merged</th> <th>Total</th> </tr> </thead> <tr ng-if="vm.title === \'Merge Information\'"> <td>Applications</td> <td> <a ng-if="vm.applicationsLost !== 0" class="clickable" ng-click="vm.onClickHoursApps(\'apps\',\'appLost\')">{{vm.applicationsLost}}</a> <span ng-if="vm.applicationsLost === 0">0</span> </td> <td> <a ng-if="vm.applicationsUpdated !== 0" class="clickable" ng-click="vm.onClickHoursApps(\'apps\',\'appUpdated\')">{{vm.applicationsUpdated}}</a> <span ng-if="vm.applicationsUpdated === 0">0</span> </td> <td><a ng-if="vm.applications !== 0" class="clickable" ng-click="vm.onClickHoursApps(\'apps\',\'totalApps\')">{{vm.applications}}</a> <span ng-if="vm.applications === 0">0</span></td> </tr> <tr ng-if="vm.title === \'Merge Information\'"> <td>Hours</td> <td><a ng-if="vm.hoursLost !== 0" class="clickable" ng-click="vm.onClickHoursApps(\'hours\',\'hoursLost\')">{{vm.hoursLost}}</a> <span ng-if="vm.hoursLost === 0">0</span></td> <td>0</td> <td><a ng-if="vm.hours !== 0" class="clickable" ng-click="vm.onClickHoursApps(\'hours\',\'totalHours\')">{{vm.hours}}</a> <span ng-if="vm.hours === 0">0</span></td> </tr> <tr ng-if="vm.title === \'Merge Results\'"> <td>Applications</td> <td>{{vm.applications}}</td> </tr> <tr ng-if="vm.title === \'Merge Results\'"> <td>Hours</td> <td>{{vm.hours}}</td> </tr> <tr ng-if="vm.title === \'Merge Results\'"> <td>Awards</td> <td>{{vm.awards}}</td> </tr> <tr ng-if="vm.title === \'Merge Results\'"> <td>Trainings</td> <td>{{vm.trainings}}</td> </tr> <tr ng-if="vm.title === \'Merge Results\'"> <td>Orientations</td> <td>{{vm.orientations}}</td> </tr> <tr ng-if="vm.title === \'Merge Results\'"> <td>Background Checks</td> <td>{{vm.backgroundChecks}}</td> </tr> <tr ng-if="vm.title === \'Merge Results\'"> <td>Notes</td> <td>{{vm.notes}}</td> </tr> <tr ng-if="vm.title === \'Merge Results\'"> <td>Documents</td> <td>{{vm.documents}}</td> </tr> </table> </modal-body> <modal-footer> <div class="float-right"> <button type="submit" class="dflt button" autofocus>OK</button> </div> </modal-footer> </modal> </form>');
$templateCache.put('app/components/administrator/organizationGroups/organizationGroupDelete.view.html','<form ng-submit="$close()" name="form"> <modal close="$dismiss" modal-title="Delete Organization Group"> <modal-body> <p>Are you sure you want to delete <b>{{vm.organizationGroupName}}</b> organization group?</p> </modal-body> <modal-footer> <div class="float-right"> <button type="submit" class="dflt button" ng-disabled="form.$invalid">Yes</button> <button type="button" class="dflt button" ng-click="$dismiss()">No</button> </div> </modal-footer> </modal> </form>');
$templateCache.put('app/components/administrator/organizationGroups/organizationGroupDetails.view.html','<form ng-submit="vm.onSave()" name="form"> <modal close="$dismiss" modal-title="{{vm.title}}"> <modal-body> <div ng-if="vm.isProductionWebsite" role="alert" class="callout alert">{{vm.bannerMessage}}</div> <div ng-show="vm.formError" class="callout alert">{{vm.formError}}</div> <label class="help-text"> <span class="required text">*</span>Indicates a required field. </label> <label for="name"> <b>Name</b><span class="required text">*</span> <input type="text" id="name" ng-model="vm.organizationGroup.name" required ng-disabled="vm.isLoading"> </label> </modal-body> <modal-footer> <div class="float-right"> <button type="submit" class="dflt button" ng-disabled="form.$invalid || vm.isLoading">Save</button> <button type="button" class="dflt button" ng-click="vm.onClickDelete()" ng-if="vm.organizationGroup.id" ng-disabled="vm.isLoading"> Delete </button> <button type="button" class="dflt button" ng-click="$dismiss(\'cancel\')">Cancel</button> </div> </modal-footer> </modal> </form>');
$templateCache.put('app/components/administrator/organizationGroups/organizationGroups.view.html','<ul class="breadcrumbs"> <li><a ui-sref="vmis" ui-sref-opts="{reload:true}">VMIS</a></li> <li> <span class="show-for-sr">Current: </span>Organization Groups </li> </ul> <learn-about-this-page learn-title="About Organization Groups Page" text-body="The Organization Groups page provides a list of all organization groups created, including those created by other AVC PMs. From this page, you can edit, add, and delete organization groups.\nOrganization groups allow similar organizations to be grouped under a common name, mainly for reporting purposes. An organization group can contain both standard and regular organizations.\nFor more information on how to use this page, please see section 3.0 of the VMIS AVC PM User Guide."></learn-about-this-page> <h1>Organization Groups</h1> <div role="alert" ng-show="vm.formError" class="callout warning">{{vm.formError}}</div> <div class="row"> <button type="button" class="dflt button float-right" data-ng-disabled="vm.isLoading" ng-click="vm.onClickOrganizationGroup()"> Add New Organization Group </button> </div> <retrieved-results is-loading="vm.isLoading" load-status="vm.loadStatus"></retrieved-results> <table class="information-table table table-hover"> <thead> <tr> <th ng-click="vm.sortColumn = \'name\'; vm.sortReverse = !vm.sortReverse"> <span ng-class="{unsorted: vm.sortColumn !== \'name\'}"> Name <icon ng-show="vm.sortColumn === \'name\'" class="icon-table-header" name="{{vm.sortReverse ? \'fa-caret-down\' : \'fa-caret-up\'}}"></icon> </span> </th> </tr> </thead> <tbody> <tr ng-hide="vm.isLoading" ng-repeat="organizationGroup in (vm.filteredOrganizationGroups = (vm.organizationGroups | orderBy:vm.sortColumn:vm.sortReverse))" ng-click="((organizationGroup.name === vm.defaultCategoryName) ? null : vm.onClickOrganizationGroup(organizationGroup))"> <td tooltip="{{(organizationGroup.name === vm.defaultCategoryName) ? \'This group is not editable because it is the default category\' : \'\'}}" tooltip-popup-delay="1000" ng-class="(organizationGroup.name === vm.defaultCategoryName) ? \'default-cursor\' : \'\'"> {{organizationGroup.name}} </td> </tr> <tr ng-if="vm.filteredOrganizationGroups.length === 0"> <td colspan="2"> No data to display </td> </tr> </tbody> </table> <loading-icon show="vm.isLoading"></loading-icon> <load-more is-loading="vm.isLoading" load-status="vm.loadStatus" on-load-more="vm.onLoadMore()" on-load-all="vm.onLoadAll()"></load-more>');
$templateCache.put('app/components/administrator/organizations/confirmOrganizationDelete.template.html','<form ng-submit="vm.onAccept()" name="form"> <modal close="$dismiss" modal-title="{{vm.title}}"> <modal-body> <div class="small-8 small-centered columns"> Are you sure you want to delete {{vm.name}}? </div> </modal-body> <modal-footer> <div class="float-right"> <button type="submit" class="dflt button"> Delete </button> <button type="button" class="dflt button" ng-click="$dismiss()"> Cancel </button> </div> </modal-footer> </modal> </form>');
$templateCache.put('app/components/administrator/organizations/confirmOrganizationInactive.template.html','<form ng-submit="$close()" name="form"> <modal close="$dismiss" modal-title="{{vm.title}}"> <modal-body> <div ng-if="vm.title === \'Inactivate Organization\'"> <p>Are you sure you want to inactivate {{vm.name}}?</p> <p>This will close all positions and set the service status to finished for all volunteers.</p> </div> <div ng-if="vm.title === \'Archive Community\'"> <p>Are you sure you want to archive {{vm.name}}?</p> <p>This will inactivate all the organizations in this community, close all positions and set the service status to finished for all volunteers.</p> </div> </modal-body> <modal-footer> <div class="pull-right"> <button type="button" class="dflt button" ng-click="vm.onAccept()">Yes</button> <button type="button" class="dflt button" ng-click="$dismiss()">No</button> </div> </modal-footer> </modal> </form>');
$templateCache.put('app/components/administrator/organizations/editOrganizationForm.template.html','<form ng-submit="vm.onSubmit()" name="form"> <modal close="$dismiss" modal-title="{{vm.title}}"> <modal-body> <div ng-if="vm.isProductionWebsite" role="alert" class="callout alert">{{vm.bannerMessage}}</div> <div ng-show="vm.formError" class="callout alert">{{vm.formError}}</div> <div class="row"> <div class="small-11 small-centered columns"> <label class="help-text"> <span class="required text">*</span> Indicates a required field. </label> <div> <label> <span class="bold">Community</span> <ui-select required ng-if="!vm.organization.id" ng-model="vm.organization.communityId" ng-disabled="vm.isLoading"> <ui-select-match placeholder="Select a community or search..."> {{$select.selected.name}} </ui-select-match> <ui-select-choices repeat="comm.id as comm in vm.dropDowns.communities | propsFilter: {name: $select.search}"> <span ng-bind-html="comm.name | highlight: $select.search"></span> </ui-select-choices> </ui-select> </label> <p ng-if="vm.organization.id">{{vm.organization.community.name}}</p> </div> <div ng-if="!vm.organization.id"> <label> <span class="bold">Standard Organization</span> <ui-select ng-model="vm.standardOrganization" ng-disabled="vm.isLoading" ng-change="vm.onChangeStandardOrganization()"> <ui-select-match placeholder="Select a standard organization or search..."> {{$select.selected.name}} </ui-select-match> <ui-select-choices repeat="s in vm.dropDowns.standardOrganizations | propsFilter: {name: $select.search}"> <span ng-bind-html="s.name | highlight: $select.search"></span> </ui-select-choices> </ui-select> </label> </div> <div> <label> <span class="bold">Type<span ng-if="!vm.organization.id" class="required text">*</span></span> <ui-select required ng-if="!vm.organization.id" data-ng-model="vm.organization.type" data-ng-disabled="vm.isLoading || (!vm.organization.id && vm.standardOrganization.id)"> <ui-select-match placeholder="Select a type or search..."> {{$select.selected}} </ui-select-match> <ui-select-choices repeat="type in vm.dropDowns.types | filter:$select.search"> <span ng-bind-html="type | highlight: $select.search"></span> </ui-select-choices> </ui-select> </label> <p ng-if="vm.organization.id">{{vm.organization.type}}</p> </div> <label> <span class="bold">Group</span> <ui-select ng-if="!vm.isDerivedFromStandardOrganization" data-ng-model="vm.organization.group" data-ng-disabled="vm.isLoading || (!vm.organization.id && vm.standardOrganization.id)"> <ui-select-match placeholder="Select a group or search..."> {{$select.selected.name}} </ui-select-match> <ui-select-choices repeat="group in vm.dropDowns.groups | propsFilter: {name: $select.search}"> <span ng-bind-html="group.name | highlight: $select.search"></span> </ui-select-choices> </ui-select> </label> <p ng-if="vm.isDerivedFromStandardOrganization">{{vm.organization.group.name}}</p> <label ng-if="vm.organization.id" tooltip="{{vm.commArchived ? \'You cannot change the status of an organization in an archived community\' : \'\'}}" tooltip-popup-delay="200"> <span class="bold">Status</span> <ui-select required data-ng-model="vm.organization.status" data-ng-disabled="vm.isLoading||vm.commArchived"> <ui-select-match placeholder="Select a status or search..."> {{$select.selected.name}} </ui-select-match> <ui-select-choices repeat="status.value as status in vm.dropDowns.statuses | propsFilter: {name: $select.search}"> <span ng-bind-html="status.name | highlight: $select.search"></span> </ui-select-choices> </ui-select> </label> <div> <label for="name"> <span class="bold">Name</span><span ng-if="!vm.isDerivedFromStandardOrganization" class="required text">*</span> <input ng-if="!vm.isDerivedFromStandardOrganization" id="name" type="text" ng-model="vm.organization.name" placeholder="Name" required ng-disabled="vm.isLoading || (!vm.organization.id && vm.standardOrganization.id)"> </label> <p ng-if="vm.isDerivedFromStandardOrganization">{{vm.organization.name}}</p> </div> <label> <span class="bold">Description</span><span class="required text">*</span> <text-area-with-count is-required="true" number-rows="3" model-name="vm.organization.description" max-given-length="1100" default-shown-text="Description" is-disabled="vm.isLoading"></text-area-with-count> </label> </div> </div> </modal-body> <modal-footer> <div> <div> <button type="button" class="dflt button float-right margin-left-5" ng-click="$dismiss(\'cancel\')" ng-disabled="vm.isLoading">Cancel </button> </div> <div ng-if="vm.showDelete"> <button type="button" class="dflt button float-right margin-left-5" ng-click="vm.onClickDelete()" ng-disabled="vm.isLoading">Delete </button> </div> <div> <button type="submit" class="dflt button float-right margin-left-5" ng-disabled="form.$invalid || form.$pristine || vm.isLoading">Save </button> </div> </div> </modal-footer> </modal> </form>');
$templateCache.put('app/components/administrator/organizations/organizations.view.html','<div ui-view> <ul class="breadcrumbs"> <li><a ui-sref="vmis" ui-sref-opts="{reload:true}">VMIS</a></li> <li> <span class="show-for-sr">Current: </span>Organizations </li> </ul> <learn-about-this-page learn-title="About Organizations Page" text-body="The Organizations page provides information about a community\u2019s organizations. Limited information about these organizations can be edited from this page, and new organizations can also be added. For more information on how to use this page, please see section 3.0 in the VMIS AVCC User Guide."></learn-about-this-page> <h1>Organizations</h1> <alert ng-repeat="alert in vm.alerts" type="alert.type" close="vm.onCloseAlert($index)">{{alert.message}}</alert> <div class="row"> <div class="small-6 columns"> <label for="select-communities">Communities</label> <ui-select id="select-communities" data-ng-model="vm.selectedCommunityId" data-ng-change="vm.onChangeCommunity(vm.selectedCommunityId)" data-ng-disabled="vm.isLoading"> <ui-select-match placeholder="Select a community or search..."> {{$select.selected.name}} </ui-select-match> <ui-select-choices repeat="comm.id as comm in vm.communities | propsFilter: {name: $select.search}"> <span ng-bind-html="comm.name | highlight: $select.search"></span> </ui-select-choices> </ui-select> </div> <div class="small-3 columns"> <label for="select-status">Status</label> <ui-select id="select-status" data-ng-model="vm.status" data-ng-change="vm.onChangeStatus(vm.status)" data-ng-disabled="vm.isLoading"> <ui-select-match placeholder="Select a status or search..."> {{$select.selected.name}} </ui-select-match> <ui-select-choices repeat="status.value as status in vm.statuses | propsFilter: {name: $select.search}"> <span ng-bind-html="status.name | highlight: $select.search"></span> </ui-select-choices> </ui-select> </div> <div class="small-3 columns"> <label for="select-type">Type</label> <ui-select id="select-type" data-ng-model="vm.organizationType" data-ng-change="vm.onChangeType()" data-ng-disabled="vm.isLoading"> <ui-select-match placeholder="Select a type or search..."> {{$select.selected.name}} </ui-select-match> <ui-select-choices repeat="type in vm.dropDowns.types | filter:$select.search"> <span ng-bind-html="type.name | highlight: $select.search"></span> </ui-select-choices> </ui-select> </div> </div> <div class="row columns"> <div class="float-right"> <button type="button" class="dflt button" data-ng-disabled="vm.isLoading" ng-click="vm.onClickAddNewOrganization()">Add New Organization </button> </div> </div> <retrieved-results is-loading="vm.isLoading" load-status="vm.loadStatus"></retrieved-results> <table class="information-table table"> <thead> <tr> <th ng-click="vm.sortColumn = \'name\'; vm.sortReverse = !vm.sortReverse"> <span ng-class="{unsorted: vm.sortColumn !== \'name\'}"> Name <icon ng-show="vm.sortColumn === \'name\'" name="{{vm.sortReverse ? \'fa-caret-down\' : \'fa-caret-up\'}}" class="icon-table-header" alt="Sorted by Name"></icon> </span> </th> <th ng-click="vm.sortColumn = \'community.name\'; vm.sortReverse = !vm.sortReverse"> <span ng-class="{unsorted: vm.sortColumn !== \'community.name\'}"> Community <icon ng-show="vm.sortColumn === \'community.name\'" name="{{vm.sortReverse ? \'fa-caret-down\' : \'fa-caret-up\'}}" class="icon-table-header" alt="Sorted by Community"></icon> </span> </th> <th ng-click="vm.sortColumn = \'group.name\'; vm.sortReverse = !vm.sortReverse"> <span ng-class="{unsorted: vm.sortColumn !== \'group.name\'}"> Group <icon ng-show="vm.sortColumn === \'group\'" name="{{vm.sortReverse ? \'fa-caret-down\' : \'fa-caret-up\'}}" class="icon-table-header" alt="Sorted by Group"></icon> </span> </th> <th ng-click="vm.sortColumn = \'type\'; vm.sortReverse = !vm.sortReverse"> <span ng-class="{unsorted: vm.sortColumn !== \'type\'}"> Type <icon ng-show="vm.sortColumn === \'type\'" name="{{vm.sortReverse ? \'fa-caret-down\' : \'fa-caret-up\'}}" class="icon-table-header" alt="Sorted by Type"></icon> </span> </th> <th ng-click="vm.sortColumn = \'status\'; vm.sortReverse = !vm.sortReverse"> <span ng-class="{unsorted: vm.sortColumn !== \'status\'}"> Status <icon ng-show="vm.sortColumn === \'status\'" name="{{vm.sortReverse ? \'fa-caret-down\' : \'fa-caret-up\'}}" class="icon-table-header" alt="Sorted by Status"></icon> </span> </th> <th width="1"></th> </tr> </thead> <tbody ng-hide="vm.isLoading"> <tr ng-repeat="organization in (vm.filteredOrganizations = (vm.organizations | orderBy:vm.sortColumn:vm.sortReverse))" ng-class-even="\'even\'" ng-class-odd="\'odd\'"> <td>{{organization.name}}</td> <td>{{organization.community.name}}</td> <td>{{organization.group.name}}</td> <td>{{organization.type}}</td> <td>{{organization.status ? \'Active\' : \'Inactive\'}}</td> <td ng-if="organization.name !== vm.volunteerSubmitted" class="table-icon-column-entry clickable" ng-click="vm.onClickEditOrganization(organization)"> <icon name="fa-pencil" class="icon-lg" alt="Select this pencil icon to edit this Organization"></icon> </td> <td ng-if="organization.name === vm.volunteerSubmitted" class="table-icon-column-entry"> <span tooltip="Volunteer Submitted organizations can not be edited/deleted." tooltip-placement="left" tooltip-popup-delay="200"> <icon name="fa-info-circle" class="icon-lg" alt="Volunteer Submitted organizations can not be edited or deleted."></icon> </span> </td> </tr> <tr ng-if="vm.filteredOrganizations.length === 0"> <td colspan="6"> No data to display </td> </tr> </tbody> </table> <loading-icon show="vm.isLoading"></loading-icon> <load-more is-loading="vm.isLoading" load-status="vm.loadStatus" on-load-more="vm.onLoadMore()" on-load-all="vm.onLoadAll()"></load-more> </div> ');
$templateCache.put('app/components/administrator/people/people.view.html','<div ui-view> <ul class="breadcrumbs"> <li><a ui-sref="vmis" ui-sref-opts="{reload:true}">VMIS</a></li> <li> <span class="show-for-sr">Current:</span> People </li> </ul> <learn-about-this-page learn-title="About People Page" text-body="The People page provides tools for those in administrator roles such as AVCCs and OPOCs to manage and contact people within their community and/or organization. These tools include the ability to view the profiles, service logs, records, and service histories of volunteers, export volunteer lists, and contact volunteers through email.\nThis page also allows actions to be taken on behalf of volunteers within the community or organization, such as adding them to positions or logging their volunteer hours. Additionally, this page allows OPOCs and AVCCs to add Non-Users to the community.\nWhen filtering by the Volunteer role, the \u201CInclude volunteers from outside my AVC communities\u201D checkbox will appear. If you are an OPOC or you are filtering further by Organization, this box will always be checked. If you are an AVCC and not filtering further by Organization, you will have the option to check or uncheck it. If the box is checked, the list of volunteers that appear in the table will include those who have approved applications within the selected Community or Organization, regardless of the Community that is associated with their profile.\nIn addition, when first loading the page on the Volunteer role, the returned results will be automatically filtered to show the first community or organization of responsibility for your role. You can update your filter as normal with the Filter People button.\nFor more information on how to use this page, please see section 3.0 in the VMIS OPOC User Guide or section 5.0 in the VMIS AVCC User Guide."></learn-about-this-page> <h1>People</h1> <alert ng-repeat="alert in vm.alerts" type="alert.type" close="vm.onCloseAlert($index)">{{alert.message}}</alert> <div ng-switch="vm.selectedRoleObject.name"> <div ng-switch-when="Global Lookup"> <div ui-view="global"></div> </div> <div ng-switch-when="Volunteer"> <div ui-view="volunteers"></div> </div> <div ng-switch-when="OPOC"> <div ui-view="opocs"></div> </div> <div ng-switch-when="AVCC Assistant"> <div ui-view="coordinatorAssistants"></div> </div> <div ng-switch-when="AVCC"> <div ui-view="coordinators"></div> </div> <div ng-switch-when="Region Manager"> <div ui-view="regionManagers"></div> </div> <div ng-switch-when="Program Manager"> <div ui-view="programManagers"></div> </div> <div ng-switch-default> <div ui-view="volunteers"></div> </div> </div> <loading-icon show="vm.isLoading"></loading-icon> </div> ');
$templateCache.put('app/components/administrator/positions/confirmation.template.html','<form name="form"> <modal close="$dismiss" modal-title="{{vm.title}}"> <modal-body> {{vm.body}} </modal-body> <modal-footer> <div class="float-right"> <button type="button" class="dflt button" ng-click="vm.onConfirm()">Confirm</button> <button type="button" class="dflt button" ng-click="vm.onCancel()">Cancel</button> </div> </modal-footer> </modal> </form>');
$templateCache.put('app/components/administrator/positions/positionDetails.view.html','<form ng-submit="vm.onSave()" name="form"> <modal close="$dismiss" modal-title="{{vm.title}}"> <modal-body> <div ng-if="vm.isProductionWebsite" role="alert" class="callout alert">{{vm.bannerMessage}}</div> <div ng-show="vm.formError" class="callout alert">{{vm.formError}}</div> <label class="help-text"> <span class="required text">*</span>Indicates a required field. </label> <div class="row" ng-if="vm.position.id"> <div class="small-6 columns"> <label class="bold">Community</label> <p>{{vm.position.organization.community.name}}</p> </div> <div class="small-6 columns"> <label class="bold">Organization</label> <p>{{vm.position.organization.name}}</p> <div ng-if="vm.isVolunteerSubmitted"> <label class="bold">Summary</label> <p>{{vm.position.summary}}</p> </div> </div> </div> <div ng-if="!vm.position.id"> <label> <span class="bold">Community</span><span class="required text">*</span> <ui-select required data-ng-change="vm.onChangeCommunity(vm.position.community)" data-ng-model="vm.position.community" data-ng-disabled="vm.isLoading"> <ui-select-match placeholder="Select a community or search..."> {{$select.selected.name}} </ui-select-match> <ui-select-choices repeat="comm in vm.dropDowns.communities | propsFilter: {name: $select.search}"> <span ng-bind-html="comm.name | highlight: $select.search"></span> </ui-select-choices> </ui-select> </label> <label> <span class="bold">Organization</span><span class="required text">*</span> <ui-select required data-ng-change="vm.onChangeOrganization(vm.position.organization)" data-ng-model="vm.position.organization" data-ng-disabled="vm.disableOrgDropDown()"> <ui-select-match placeholder="Select an organization or search..."> {{$select.selected.name}} </ui-select-match> <ui-select-choices repeat="org in vm.position.community.organizations | propsFilter: {name: $select.search}"> <span ng-bind-html="org.name | highlight: $select.search"></span> </ui-select-choices> </ui-select> </label> </div> <div class="row" ng-if="vm.position.hasApplications"> <label class="help-text bold"> Disabled fields cannot be changed because hours are associated with this position. </label> </div> <div class="row" ng-if="vm.isVolunteerSubmitted"> <label class="help-text bold"> Positions in Volunteer Submitted Organization cannot be edited. </label> </div> <label for="title"> <span class="bold">Title</span><span class="required text">*</span> <input id="title" type="text" ng-maxlength="75" ng-model="vm.position.title" required ng-disabled="vm.isLoading || (vm.position.hasApplications && !vm.ignoreInvalid) || vm.isVolunteerSubmitted"> </label> <div ng-if="!vm.isVolunteerSubmitted" tooltip="Use commas to separate keywords" tooltip-popup-delay="200"> <label for="keywords"> <span class="bold">Keywords</span> <input id="keywords" ng-maxlength="200" type="text" ng-model="vm.position.keywords" ng-disabled="vm.isLoading"> </label> </div> <label ng-if="!vm.isVolunteerSubmitted"> <span class="bold">Position Type</span><span class="required text">*</span> <ui-select required data-ng-model="vm.position.positionType" data-ng-disabled="vm.isLoading || vm.position.hasApplications || !vm.position.organization"> <ui-select-match placeholder="{{ vm.position.organization == null ? \'Organization selection is required...\' : \'Select a position type or search...\'}}"> {{$select.selected}} </ui-select-match> <ui-select-choices repeat="pos in vm.dropDowns.positionTypes | filter:$select.search"> <span ng-bind-html="pos | highlight: $select.search"></span> </ui-select-choices> </ui-select> </label> <label ng-if="!vm.isVolunteerSubmitted"> <span class="bold">Opportunity Type</span><span class="required text">*</span> <ui-select required data-ng-model="vm.position.opportunityType" data-ng-disabled="vm.isLoading"> <ui-select-match placeholder="Select an opportunity type or search..."> {{$select.selected}} </ui-select-match> <ui-select-choices repeat="opp in vm.dropDowns.opportunityTypes | filter:$select.search"> <span ng-bind-html="opp | highlight: $select.search"></span> </ui-select-choices> </ui-select> </label> <label tooltip="{{!vm.isOrgActive ? \'You cannot change the status of a position in an inactive organization.\' : \'\'}}"> <span class="bold">Status</span><span class="required text">*</span> <ui-select required data-ng-model="vm.position.status" data-ng-disabled="vm.isLoading || vm.isVolunteerSubmitted || !vm.isOrgActive"> <ui-select-match placeholder="Select a status or search..."> {{$select.selected}} </ui-select-match> <ui-select-choices repeat="status in vm.dropDowns.statuses | filter:$select.search"> <span ng-bind-html="status | highlight: $select.search"></span> </ui-select-choices> </ui-select> </label> <label> <span class="bold">Background Check Required</span><span class="required text">*</span> <ui-select required data-ng-model="vm.position.backgroundCheckRequired" data-ng-disabled="vm.isLoading || vm.position.hasApplications|| vm.isVolunteerSubmitted"> <ui-select-match placeholder="Select an option or search..."> {{$select.selected.label}} </ui-select-match> <ui-select-choices repeat="bcr.value as bcr in vm.dropDowns.booleanOptions | propsFilter: {label: $select.search}"> <span ng-bind-html="bcr.label | highlight: $select.search"></span> </ui-select-choices> </ui-select> </label> <label ng-if="!vm.isVolunteerSubmitted"> <span class="bold">Supervision Required</span><span class="required text">*</span> <ui-select required data-ng-model="vm.position.supervisionRequired" data-ng-disabled="vm.isLoading || vm.position.hasApplications"> <ui-select-match placeholder="Select an option or search..."> {{$select.selected.label}} </ui-select-match> <ui-select-choices repeat="sr.value as sr in vm.dropDowns.booleanOptions | propsFilter: {label: $select.search}"> <span ng-bind-html="sr.label | highlight: $select.search"></span> </ui-select-choices> </ui-select> </label> <div ng-show="!vm.isVolunteerSubmitted" tooltip-html-unsafe="Setting a Closed Date (not required) will automatically set the service status of volunteers in this position to Finished once the Closed Date has passed.<br>This also means that volunteers will no longer be able to enter hours once the Closed Date has passed." tooltip-popup-delay="200"> <label for="closed"> <span class="bold">Closed Date</span> <span class="input-group"> <input id="closed" name="closedDate" type="text" class="input-group-field" ng-model="vm.position.closedDate" placeholder="MM/DD/YYYY" ng-disabled="vm.isLoading || vm.ignoreInvalid" vmis-datepicker target="closed-date" start-date="vm.startDate" format="M/D/YYYY"> <span class="input-group-button"> <button id="closed-date" type="button" aria-label="Closed date" class="dflt button icon-button" ng-disabled="vm.isLoading"> <icon name="fa-calendar" class="icon-big" alt="Select this calendar icon to choose the date which the position closes"></icon> </button> </span> </span> </label> </div> <label ng-if="!vm.isVolunteerSubmitted"> <span class="bold">Summary</span> <text-area-with-count is-required="false" number-rows="3" model-name="vm.position.summary" max-given-length="1100" is-disabled="vm.isLoading"></text-area-with-count> </label> <label> <span class="bold">Duties</span><span class="required text">*</span> <text-area-with-count is-required="true" number-rows="3" model-name="vm.position.duties" max-given-length="4200" is-disabled="vm.isLoading || vm.isVolunteerSubmitted"></text-area-with-count> </label> <label> <span class="bold">Qualifications</span><span class="required text">*</span> <text-area-with-count is-required="true" number-rows="3" model-name="vm.position.qualifications" max-given-length="2200" is-disabled="vm.isLoading || vm.isVolunteerSubmitted"></text-area-with-count> </label> <label> <span class="bold">Training</span><span class="required text">*</span> <text-area-with-count is-required="true" number-rows="3" model-name="vm.position.training" max-given-length="1100" is-disabled="vm.isLoading || vm.isVolunteerSubmitted"></text-area-with-count> </label> <label> <span class="bold">Orientation</span><span class="required text">*</span> <text-area-with-count is-required="true" number-rows="3" model-name="vm.position.orientation" max-given-length="1100" is-disabled="vm.isLoading || vm.isVolunteerSubmitted"></text-area-with-count> </label> <label> <span class="bold">Time Required</span><span class="required text">*</span> <text-area-with-count is-required="true" number-rows="3" model-name="vm.position.timeRequired" max-given-length="1100" is-disabled="vm.isLoading || vm.isVolunteerSubmitted"></text-area-with-count> </label> <label ng-if="!vm.isVolunteerSubmitted"> <span class="bold">Evaluation</span> <text-area-with-count is-required="false" number-rows="3" model-name="vm.position.evaluation" max-given-length="1100" is-disabled="vm.isLoading"></text-area-with-count> </label> <label ng-if="!vm.isVolunteerSubmitted"> <span class="bold">Benefits</span> <text-area-with-count is-required="false" number-rows="3" model-name="vm.position.benefits" max-given-length="1100" is-disabled="vm.isLoading"></text-area-with-count> </label> <table class="table information-table"> <thead> <tr> <td>Address</td> </tr> </thead> </table> <label> <span class="bold">Country</span><span class="required text">*</span> <ui-select required data-ng-change="vm.onChangeCountry(vm.position.address.country)" data-ng-model="vm.position.address.country" data-ng-disabled="vm.isLoading || vm.isVolunteerSubmitted"> <ui-select-match placeholder="Select a country or search..."> {{$select.selected}} </ui-select-match> <ui-select-choices repeat="country in vm.dropDowns.countries | filter:$select.search"> <span ng-bind-html="country | highlight: $select.search"></span> </ui-select-choices> </ui-select> </label> <label for="line1"> <span class="bold">Line 1</span><span class="required text">*</span> <input id="line1" type="text" ng-model="vm.position.address.line1" required ng-disabled="vm.isLoading || vm.isVolunteerSubmitted"> </label> <label for="line2"> <span class="bold">Line 2</span> <input id="line2" type="text" ng-model="vm.position.address.line2" ng-disabled="vm.isLoading || vm.isVolunteerSubmitted"> </label> <label for="city"> <span class="bold">City</span><span class="required text">*</span> <input id="city" type="text" ng-model="vm.position.address.city" required ng-disabled="vm.isLoading || vm.isVolunteerSubmitted"> </label> <label> <span class="bold">State</span><span ng-show="vm.isStateRequired" class="required text">*</span> <ui-select required data-ng-model="vm.position.address.state" data-ng-required="vm.isStateRequired" data-ng-disabled="vm.isLoading || !vm.isStateRequired || vm.isVolunteerSubmitted"> <ui-select-match placeholder="Select a state or search..."> {{$select.selected}} </ui-select-match> <ui-select-choices repeat="state in vm.dropDowns.states | filter:$select.search"> <span ng-bind-html="state | highlight: $select.search"></span> </ui-select-choices> </ui-select> </label> <label for="zip"> <span class="bold">Zip/Postal Code</span><span class="required text">*</span> <input id="zip" type="text" ng-model="vm.position.address.zipCode" required ng-disabled="vm.isLoading || vm.isVolunteerSubmitted"> </label> <table class="table information-table" ng-repeat-start="supervisor in vm.position.supervisors | limitTo:(vm.isVolunteerSubmitted ? 1 : undefined)"> <thead> <tr> <td>Supervisor {{vm.isVolunteerSubmitted ? \'\' : $index + 1}}</td> </tr> </thead> </table> <label for="{{ \'name-\' + ($index + 1) }}"> <span class="bold">Name</span> <input id="{{ \'name-\' + ($index + 1) }}" ng-maxlength="250" type="text" ng-model="supervisor.name" ng-disabled="vm.isLoading || vm.isVolunteerSubmitted"> </label> <label for="{{ \'email-\' + ($index + 1) }}"> <span class="bold">Email</span> <input id="{{ \'email-\' + ($index + 1) }}" type="email" ng-model="supervisor.email" ng-disabled="vm.isLoading || vm.isVolunteerSubmitted"> </label> <label ng-repeat-end for="{{ \'phone-\' + ($index + 1) }}"> <span class="bold">Phone</span> <input id="{{ \'phone-\' + ($index + 1) }}" type="text" ng-model="supervisor.phone" ng-disabled="vm.isLoading || vm.isVolunteerSubmitted"> </label> </modal-body> <modal-footer> <div ng-if="vm.position.id" class="float-left hyperlink-button-div"> <a ng-if="!vm.isVolunteerSubmitted" class="bold" ng-click="vm.onClickClone()">Clone</a> <a class="bold" ng-click="vm.onPrint()">Print</a> </div> <div class="float-right"> <div ng-if="vm.position.id && vm.position.hasApplications === false"> <button type="submit" class="dflt button" ng-disabled="vm.isLoading || (form.$invalid && !vm.ignoreInvalid) || form.$pristine"> Save </button> <button type="button" class="dflt button" ng-click="vm.onDelete()">Delete</button> <button type="button" class="dflt button" ng-click="$dismiss(\'cancel\')">Cancel</button> </div> <div ng-if="!vm.position.id || vm.position.hasApplications === true"> <button type="submit" class="dflt button" ng-disabled="vm.isLoading || (form.$invalid && !vm.ignoreInvalid) || form.$pristine || vm.isVolunteerSubmitted"> Save </button> <button type="button" class="dflt button" ng-click="$dismiss(\'cancel\')">Cancel</button> </div> </div> </modal-footer> </modal> </form> ');
$templateCache.put('app/components/administrator/positions/positions.view.html','<div ui-view> <ul class="breadcrumbs"> <li><a ui-sref="vmis" ui-sref-opts="{reload:true}">VMIS</a></li> <li> <span class="show-for-sr">Current: </span>Positions </li> </ul> <learn-about-this-page learn-title="About Positions Page" text-body="The Positions page provides details about each of the positions managed by the OPOC or AVCC. From this page, managed positions can be created, edited, filtered, and deleted. For more information on how to use this page, please see section 5.0 in the VMIS OPOC User Guide and section 7.0 in the VMIS AVCC User Guide."></learn-about-this-page> <h1>Positions</h1> <div class="expanded row"> <div class="small-2 columns"> <label id="status">Status</label> </div> <div class="small-2 columns"> <label id="community">Community</label> </div> <div class="small-2 columns"> <label id="organization">Organization</label> </div> <div class="small-2 columns"> <label id="searchPosition" hidden>Search for Position</label> </div> </div> <div class="expanded row"> <div class="small-2 columns"> <ui-select data-ng-change="vm.onStatusChange()" data-ng-model="vm.status" data-ng-disabled="vm.isLoading"> <ui-select-match placeholder="Select a status or search..."> {{$select.selected}} </ui-select-match> <ui-select-choices repeat="s in vm.statuses | filter:$select.search"> <span ng-bind-html="s | highlight: $select.search"></span> </ui-select-choices> </ui-select> </div> <div class="small-2 columns"> <ui-select data-ng-change="vm.onCommunityChange()" data-ng-model="vm.selectedCommunity" data-ng-disabled="vm.isLoading"> <ui-select-match placeholder="Select a community or search..."> {{$select.selected.name}} </ui-select-match> <ui-select-choices repeat="c in vm.communities | propsFilter: {name: $select.search}"> <span ng-bind-html="c.name | highlight: $select.search"></span> </ui-select-choices> </ui-select> </div> <div class="small-2 columns"> <ui-select data-ng-change="vm.onOrganizationChange()" data-ng-model="vm.selectedOrganization" data-ng-disabled="vm.disableOrgDropDown()"> <ui-select-match placeholder="Select an organization or search..."> {{$select.selected.name}} </ui-select-match> <ui-select-choices repeat="o in vm.selectedCommunity.organizations | propsFilter: {name: $select.search}"> <span ng-bind-html="o.name | highlight: $select.search"></span> </ui-select-choices> </ui-select> </div> <form> <div class="small-4 columns"> <div class="input-group"> <div class="input-group-label icon-label"><icon name="fa-search" class="icon-lg"></icon></div> <input type="text" id="input-search" aria-label="Search" class="input-group-field" placeholder="Search by title" ng-model="vm.filterName"> <div class="input-group-button"> <button type="submit" class="dflt button" ng-disabled="vm.isLoading" ng-click="vm.onClickSearch()">Search</button> </div> </div> </div> </form> <div class="small-2 columns"> <button type="button" class="dflt button float-right" data-ng-disabled="vm.isLoading" ng-click="vm.onPositionClick()"> Add New Position </button> </div> </div> <retrieved-results is-loading="vm.isLoading" load-status="vm.loadStatus"></retrieved-results> <table class="information-table table table-hover"> <thead> <tr> <th ng-click="vm.sortColumn = \'title\'; vm.sortReverse = !vm.sortReverse"> <span ng-class="{unsorted: vm.sortColumn !== \'title\'}"> Title <icon ng-show="vm.sortColumn === \'title\'" class="icon-table-header" name="{{vm.sortReverse ? \'fa-caret-down\' : \'fa-caret-up\'}}" alt="Sorted by Title"></icon> </span> </th> <th ng-click="vm.sortColumn = \'organization.name\'; vm.sortReverse = !vm.sortReverse"> <span ng-class="{unsorted: vm.sortColumn !== \'organization.name\'}"> Organization <icon ng-show="vm.sortColumn === \'organization.name\'" class="icon-table-header" name="{{vm.sortReverse ? \'fa-caret-down\' : \'fa-caret-up\'}}" alt="Sorted by Organization"></icon> </span> </th> <th ng-click="vm.sortColumn = \'postedDate\'; vm.sortReverse = !vm.sortReverse"> <span ng-class="{unsorted: vm.sortColumn !== \'postedDate\'}"> Posted Date <icon ng-show="vm.sortColumn === \'postedDate\'" class="icon-table-header" name="{{vm.sortReverse ? \'fa-caret-down\' : \'fa-caret-up\'}}" alt="Sorted by Posted Date"></icon> </span> </th> <th ng-click="vm.sortColumn = \'closedDate\'; vm.sortReverse = !vm.sortReverse"> <span ng-class="{unsorted: vm.sortColumn !== \'closedDate\'}"> Closed Date <icon ng-show="vm.sortColumn === \'closedDate\'" class="icon-table-header" name="{{vm.sortReverse ? \'fa-caret-down\' : \'fa-caret-up\'}}" alt="Sorted by Closed Date"></icon> </span> </th> <th ng-click="vm.sortColumn = \'status\'; vm.sortReverse = !vm.sortReverse"> <span ng-class="{unsorted: vm.sortColumn !== \'status\'}"> Status <icon ng-show="vm.sortColumn === \'status\'" class="icon-table-header" name="{{vm.sortReverse ? \'fa-caret-down\' : \'fa-caret-up\'}}" alt="Sorted by Status"></icon> </span> </th> <th ng-click="vm.sortColumn = \'totalApplicants\'; vm.sortReverse = !vm.sortReverse"> <span ng-class="{unsorted: vm.sortColumn !== \'totalApplicants\'}"> Total Applicants <icon ng-show="vm.sortColumn === \'totalApplicants\'" class="icon-table-header" name="{{vm.sortReverse ? \'fa-caret-down\' : \'fa-caret-up\'}}" alt="Sorted by Total Applicants"></icon> </span> </th> </tr> </thead> <tbody> <tr ng-class-even="\'even\'" ng-class-odd="\'odd\'" ng-hide="vm.isLoading" ng-repeat="position in (vm.filteredPositions = (vm.positions | orderBy:vm.sortColumn:vm.sortReverse))" ng-click="vm.onPositionClick(position.id)"> <td>{{position.title}}</td> <td>{{position.organization.name}}</td> <td>{{position.postedDate | date:\'MM/dd/yyyy\':\'+0\'}}</td> <td>{{(position.closedDate || \'None\') | date:\'MM/dd/yyyy\':\'+0\'}}</td> <td>{{position.status}}</td> <td class="center-horizontal">{{position.totalApplicants}}</td> </tr> <tr ng-if="vm.filteredPositions.length === 0"> <td colspan="7"> No data to display </td> </tr> </tbody> </table> <loading-icon show="vm.isLoading"></loading-icon> <load-more is-loading="vm.isLoading" load-status="vm.loadStatus" on-load-more="vm.onLoadMore()" on-load-all="vm.onLoadAll()"></load-more> </div> ');
$templateCache.put('app/components/administrator/standardOrganizations/standardOrganizationDelete.view.html','<form ng-submit="$close()" name="form"> <modal close="$dismiss" modal-title="Delete Standard Organization"> <modal-body> <p>Are you sure you want to delete the standard organization <b>{{vm.standardOrganizationName}}</b>?</p> </modal-body> <modal-footer> <div class="float-right"> <button type="submit" class="dflt button" ng-disabled="form.$invalid">Yes</button> <button type="button" class="dflt button" ng-click="$dismiss()">No</button> </div> </modal-footer> </modal> </form>');
$templateCache.put('app/components/administrator/standardOrganizations/standardOrganizationDetails.view.html','<form ng-submit="vm.onSave(vm.standardOrganization)" name="form"> <modal close="$dismiss" modal-title="{{vm.title}}"> <modal-body> <div ng-if="vm.isProductionWebsite" role="alert" class="callout alert">{{vm.bannerMessage}}</div> <div ng-show="vm.formError" class="callout alert">{{vm.formError}}</div> <label class="help-text"> <span class="required text">*</span>Indicates a required field. </label> <label for="name"> <b>Name</b><span class="required text">*</span> <input type="text" id="name" ng-model="vm.standardOrganization.name" required ng-disabled="vm.isLoading"> </label> <label> <b>Organization Group</b><span class="required text">*</span> <ui-select data-ng-model="vm.standardOrganization.group.id" data-ng-disabled="vm.isLoading" required> <ui-select-match placeholder="Select a group or search..."> {{$select.selected.label}} </ui-select-match> <ui-select-choices repeat="group.value as group in vm.dropDowns.groups | propsFilter: {label: $select.search}"> <span ng-bind-html="group.label | highlight: $select.search"></span> </ui-select-choices> </ui-select> </label> <label> <b>Type</b><span class="required text">*</span> <ui-select data-ng-model="vm.standardOrganization.type" data-ng-disabled="vm.isLoading" required> <ui-select-match placeholder="Select a type or search..."> {{$select.selected.label}} </ui-select-match> <ui-select-choices repeat="type.value as type in vm.dropDowns.types | propsFilter: {label: $select.search}"> <span ng-bind-html="type.label | highlight: $select.search"></span> </ui-select-choices> </ui-select> </label> <label> <b>Status</b><span class="required text">*</span> <ui-select data-ng-model="vm.standardOrganization.status" data-ng-disabled="vm.isLoading" required> <ui-select-match placeholder="Select a status or search..."> {{$select.selected.label}} </ui-select-match> <ui-select-choices repeat="status.value as status in vm.dropDowns.statuses | propsFilter: {label: $select.search}"> <span ng-bind-html="status.label | highlight: $select.search"></span> </ui-select-choices> </ui-select> </label> <label> <b>Description</b><span class="required text">*</span> <text-area-with-count is-required="true" number-rows="3" model-name="vm.standardOrganization.description" max-given-length="1100" is-disabled="vm.isLoading"></text-area-with-count> </label> </modal-body> <modal-footer> <div class="float-right"> <button type="submit" class="dflt button" ng-disabled="form.$invalid || vm.isLoading">Save</button> <button type="button" class="dflt button" ng-click="vm.onClickDelete()" ng-if="vm.standardOrganization.id" ng-disabled="vm.isLoading"> Delete </button> <button type="button" class="dflt button" ng-click="$dismiss()">Cancel</button> </div> </modal-footer> </modal> </form>');
$templateCache.put('app/components/administrator/standardOrganizations/standardOrganizations.view.html','<ul class="breadcrumbs"> <li><a ui-sref="vmis" ui-sref-opts="{reload:true}">VMIS</a></li> <li> <span class="show-for-sr">Current: </span>Standard Organizations </li> </ul> <learn-about-this-page learn-title="About Standard Organizations Page" text-body="The Standard Organizations page provides a list of all standard organizations created, including those created by other AVC PMs. From this page, you can filter, edit, add, and delete standard organizations.\nA standard organization contains one or more standard positions, and it can be used as a template to easily create similar or identical organizations at multiple installations.\nFor more information on how to use this page, please see section 4.0 in the VMIS AVC PM User Guide."></learn-about-this-page> <h1>Standard Organizations</h1> <div role="alert" ng-show="vm.formError" class="callout warning">{{vm.formError}}</div> <div class="row"> <div class="columns small-4"> <label> Organization Group <ui-select data-ng-change="vm.onChangeFilter()" data-ng-model="vm.filters.group" data-ng-disabled="vm.isLoading"> <ui-select-match placeholder="Select a group or search..."> {{$select.selected.label}} </ui-select-match> <ui-select-choices repeat="group in vm.dropDowns.groups | propsFilter: {label: $select.search}"> <span ng-bind-html="group.label | highlight: $select.search"></span> </ui-select-choices> </ui-select> </label> </div> <div class="columns small-4"> <label> Type <ui-select data-ng-change="vm.onChangeFilter()" data-ng-model="vm.filters.type" data-ng-disabled="vm.isLoading"> <ui-select-match placeholder="Select a type or search..."> {{$select.selected.label}} </ui-select-match> <ui-select-choices repeat="type in vm.dropDowns.types | propsFilter: {label: $select.search}"> <span ng-bind-html="type.label | highlight: $select.search"></span> </ui-select-choices> </ui-select> </label> </div> <div class="columns small-4"> <label> Status <ui-select data-ng-change="vm.onChangeFilter()" data-ng-model="vm.filters.status" data-ng-disabled="vm.isLoading"> <ui-select-match placeholder="Select a status or search..."> {{$select.selected.label}} </ui-select-match> <ui-select-choices repeat="status in vm.dropDowns.statuses | propsFilter: {label: $select.search}"> <span ng-bind-html="status.label | highlight: $select.search"></span> </ui-select-choices> </ui-select> </label> </div> </div> <div class="row columns"> <button type="button" class="dflt button float-right" data-ng-disabled="vm.isLoading" ng-click="vm.onClickStandardOrganization()"> Add New Standard Organization </button> </div> <retrieved-results is-loading="vm.isLoading" load-status="vm.loadStatus"></retrieved-results> <table class="information-table table table-hover"> <thead> <tr> <th ng-click="vm.sortColumn = \'name\'; vm.sortReverse = !vm.sortReverse"> <span ng-class="{unsorted: vm.sortColumn !== \'name\'}"> Name <icon ng-show="vm.sortColumn === \'name\'" class="icon-table-header" name="{{vm.sortReverse ? \'fa-caret-down\' : \'fa-caret-up\'}}"></icon> </span> </th> <th ng-click="vm.sortColumn = \'group.name\'; vm.sortReverse = !vm.sortReverse"> <span ng-class="{unsorted: vm.sortColumn !== \'group.name\'}"> Organization Group <icon ng-show="vm.sortColumn === \'group.name\'" class="icon-table-header" name="{{vm.sortReverse ? \'fa-caret-down\' : \'fa-caret-up\'}}"></icon> </span> </th> <th ng-click="vm.sortColumn = \'type\'; vm.sortReverse = !vm.sortReverse"> <span ng-class="{unsorted: vm.sortColumn !== \'type\'}"> Type <icon ng-show="vm.sortColumn === \'type\'" class="icon-table-header" name="{{vm.sortReverse ? \'fa-caret-down\' : \'fa-caret-up\'}}"></icon> </span> </th> <th ng-click="vm.sortColumn = \'status\'; vm.sortReverse = !vm.sortReverse"> <span ng-class="{unsorted: vm.sortColumn !== \'status\'}"> Status <icon ng-show="vm.sortColumn === \'status\'" class="icon-table-header" name="{{vm.sortReverse ? \'fa-caret-down\' : \'fa-caret-up\'}}"></icon> </span> </th> <th ng-click="vm.sortColumn = \'standardPositionCount\'; vm.sortReverse = !vm.sortReverse" class="tiny"> <span ng-class="{unsorted: vm.sortColumn !== \'standardPositionCount\'}"> Total Standard Positions <icon ng-show="vm.sortColumn === \'standardPositionCount\'" class="icon-table-header" name="{{vm.sortReverse ? \'fa-caret-down\' : \'fa-caret-up\'}}"></icon> </span> </th> </tr> </thead> <tbody> <tr ng-hide="vm.isLoading" ng-repeat="standardOrganization in (vm.filteredStandardOrganizations = (vm.standardOrganizations | orderBy:vm.sortColumn:vm.sortReverse))" ng-click="vm.onClickStandardOrganization(standardOrganization)"> <td>{{standardOrganization.name}}</td> <td>{{standardOrganization.group.name}}</td> <td>{{standardOrganization.type}}</td> <td>{{standardOrganization.status ? \'Active\' : \'Inactive\'}}</td> <td>{{standardOrganization.standardPositionCount}}</td> </tr> <tr ng-if="vm.filteredStandardOrganizations.length === 0"> <td colspan="5"> No data to display </td> </tr> </tbody> </table> <loading-icon show="vm.isLoading"></loading-icon> <load-more is-loading="vm.isLoading" load-status="vm.loadStatus" on-load-more="vm.onLoadMore()" on-load-all="vm.onLoadAll()"></load-more>');
$templateCache.put('app/components/administrator/standardPositions/standardPositionDelete.view.html','<form ng-submit="$close()" name="form"> <modal close="$dismiss" modal-title="Delete Standard Position"> <modal-body> <p>Are you sure you want to delete the standard position <b>{{vm.standardPositionName}}</b>?</p> </modal-body> <modal-footer> <div class="float-right"> <button type="submit" class="dflt button" ng-disabled="form.$invalid">Yes</button> <button type="button" class="dflt button" ng-click="$dismiss()">No</button> </div> </modal-footer> </modal> </form>');
$templateCache.put('app/components/administrator/standardPositions/standardPositionDetails.view.html','<form ng-submit="vm.onSave()" name="form"> <modal close="$dismiss" modal-title="{{vm.title}}"> <modal-body> <div ng-if="vm.isProductionWebsite" role="alert" class="callout alert">{{vm.bannerMessage}}</div> <div ng-show="vm.formError" class="callout alert">{{vm.formError}}</div> <label class="help-text"> <span class="required text">*</span>Indicates a required field. </label> <label> <b>Standard Organization</b><span class="required text">*</span> <ui-select required data-ng-model="vm.standardPosition.standardOrganization" data-ng-disabled="vm.isLoading"> <ui-select-match placeholder="Select a standard organization or search..."> {{$select.selected.name}} </ui-select-match> <ui-select-choices repeat="standardOrganization in vm.standardOrganizations | propsFilter: {name: $select.search}"> <span ng-bind-html="standardOrganization.name | highlight: $select.search"></span> </ui-select-choices> </ui-select> </label> <label for="title"> <b>Title</b><span class="required text">*</span> <input type="text" id="title" ng-model="vm.standardPosition.title" required ng-disabled="vm.isLoading"> </label> <label> <b>Duties</b> <text-area-with-count is-required="false" number-rows="3" model-name="vm.standardPosition.duties" max-given-length="3100" is-disabled="vm.isLoading"></text-area-with-count> </label> <label> <b>Qualifications</b> <text-area-with-count is-required="false" number-rows="3" model-name="vm.standardPosition.qualifications" max-given-length="2200" is-disabled="vm.isLoading"></text-area-with-count> </label> <label> <b>Training</b> <text-area-with-count is-required="false" number-rows="3" model-name="vm.standardPosition.training" max-given-length="2200" is-disabled="vm.isLoading"></text-area-with-count> </label> </modal-body> <modal-footer> <div class="float-right"> <button type="submit" class="dflt button" ng-disabled="form.$invalid || vm.isLoading">Save</button> <button type="button" class="dflt button" ng-click="vm.onClickDelete()" ng-if="vm.standardPosition.id" ng-disabled="vm.isLoading"> Delete </button> <button type="button" class="dflt button" ng-click="$dismiss()">Cancel</button> </div> </modal-footer> </modal> </form> ');
$templateCache.put('app/components/administrator/standardPositions/standardPositions.view.html','<ul class="breadcrumbs"> <li><a ui-sref="vmis" ui-sref-opts="{reload:true}">VMIS</a></li> <li> <span class="show-for-sr">Current: </span>Standard Positions </li> </ul> <learn-about-this-page learn-title="About Standard Positions Page" text-body="The Standard Positions page provides a list of all standard positions created, including those created by other AVC PMs. From this page, you can filter, edit, add, and delete standard positions.\nA standard position belongs to a standard organization, and it can be used as a template to easily create similar or identical positions at multiple installations.\nFor more information on how to use this page, please see section 5.0 in the VMIS AVC PM User Guide."></learn-about-this-page> <h1>Standard Positions</h1> <div role="alert" ng-show="vm.formError" class="callout warning">{{vm.formError}}</div> <div class="row"> <div class="columns small-6"> <label>Standard Organization</label> </div> </div> <div class="row"> <div class="columns small-6"> <ui-select data-ng-change="vm.onChangeStandardOrganization(vm.standardOrganization)" data-ng-model="vm.standardOrganization" data-ng-disabled="vm.isLoading"> <ui-select-match placeholder="Select a standard organization or search..."> {{$select.selected.name}} </ui-select-match> <ui-select-choices repeat="standardOrganization in vm.standardOrganizations | propsFilter: {name: $select.search}"> <span ng-bind-html="standardOrganization.name | highlight: $select.search"></span> </ui-select-choices> </ui-select> </div> <div class="columns small-6"> <button type="button" class="dflt button pull-right" data-ng-disabled="vm.isLoading" ng-click="vm.onClickStandardPosition()"> Add New Standard Position </button> </div> </div> <retrieved-results is-loading="vm.isLoading" load-status="vm.loadStatus"></retrieved-results> <table class="information-table table table-hover"> <thead> <tr> <th ng-click="vm.sortColumn = \'title\'; vm.sortReverse = !vm.sortReverse"> <span ng-class="{unsorted: vm.sortColumn !== \'title\'}"> Title <icon ng-show="vm.sortColumn === \'title\'" class="icon-table-header" name="{{vm.sortReverse ? \'fa-caret-down\' : \'fa-caret-up\'}}"></icon> </span> </th> <th ng-click="vm.sortColumn = \'standardOrganization.name\'; vm.sortReverse = !vm.sortReverse"> <span ng-class="{unsorted: vm.sortColumn !== \'standardOrganization.name\'}"> Standard Organization <icon ng-show="vm.sortColumn === \'standardOrganization.name\'" class="icon-table-header" name="{{vm.sortReverse ? \'fa-caret-down\' : \'fa-caret-up\'}}"></icon> </span> </th> </tr> </thead> <tbody> <tr ng-hide="vm.isLoading" ng-repeat="standardPosition in (vm.filteredStandardPositions = (vm.standardPositions | orderBy:vm.sortColumn:vm.sortReverse))" ng-click="vm.onClickStandardPosition(standardPosition)"> <td>{{standardPosition.title}}</td> <td>{{standardPosition.standardOrganization.name}}</td> </tr> <tr ng-if="vm.filteredStandardPositions.length === 0"> <td colspan="2"> No data to display </td> </tr> </tbody> </table> <loading-icon show="vm.isLoading"></loading-icon> <load-more is-loading="vm.isLoading" load-status="vm.loadStatus" on-load-more="vm.onLoadMore()" on-load-all="vm.onLoadAll()"></load-more>');
$templateCache.put('app/components/dashboard/coordinator/coordinatorDashboard.view.html','<h1 class="row section-header">Recent Hours and Applications</h1> <div class="row"> <div class="tile"> <div class="tile-fill small-12-columns"> <div class="lead dashHeader"> <span id="avcc-hours-select"> Days Since Submission <ui-select class="float-left narrow" data-ng-change="vm.onChangeOverdueThreshold()" data-ng-model="vm.overdueThreshold" data-ng-disabled="vm.overdueLoading"> <ui-select-match placeholder="##"> {{$select.selected}} </ui-select-match> <ui-select-choices repeat="ot in vm.overdueThresholds | filter:$select.search"> <span ng-bind-html="ot | highlight: $select.search"></span> </ui-select-choices> </ui-select> </span> </div> <retrieved-results is-loading="vm.overdueLoading" load-status="vm.loadStatusHoursApps"></retrieved-results> <table class="table information-table"> <thead> <tr> <th ng-click="vm.sortColumn = \'organizationName\'; vm.sortReverse = !vm.sortReverse"> <span ng-class="{unsorted: vm.sortColumn !== \'organizationName\'}"> Organization <icon ng-show="vm.sortColumn === \'organizationName\'" name="{{vm.sortReverse ? \'fa-caret-down\' : \'fa-caret-up\'}}" class="icon-table-header"></icon> </span> </th> <th> <span class="no-pointer" ng-class="{unsorted: true}"> OPOC(s) </span> </th> <th width="130px" ng-click="vm.sortColumn = \'totalOverdueHours\'; vm.sortReverse = !vm.sortReverse"> <span tooltip-html-unsafe="Number of hours submissions within the past {{vm.overdueThreshold}} days<br>that have\n                                not been certified, rejected, or deleted." data-tooltip-popup-delay="1000" ng-class="{unsorted: vm.sortColumn !== \'totalOverdueHours\'}"> <span class="table-header-tooltip">Hours Submissions</span> <icon ng-show="vm.sortColumn === \'totalOverdueHours\'" name="{{vm.sortReverse ? \'fa-caret-down\' : \'fa-caret-up\'}}" class="icon-table-header"></icon> </span> </th> <th width="176px" ng-click="vm.sortColumn = \'totalOverdueApplications\'; vm.sortReverse = !vm.sortReverse"> <span tooltip-html-unsafe="Number of submitted applications within the past {{vm.overdueThreshold}} days<br>that have not been accepted, rejected, or deleted." data-tooltip-popup-delay="1000" ng-class="{unsorted: vm.sortColumn !== \'totalOverdueApplications\'}"> <span class="table-header-tooltip">Applications Submissions</span> <icon ng-show="vm.sortColumn === \'totalOverdueApplications\'" name="{{vm.sortReverse ? \'fa-caret-down\' : \'fa-caret-up\'}}" class="icon-table-header"></icon> </span> </th> <th width="176px" ng-click="vm.sortColumn = \'totalSubmitted\'; vm.sortReverse = !vm.sortReverse"> <span tooltip-html-unsafe="Total number of submitted hours and applications within the past {{vm.overdueThreshold}} days<br>that have not been accepted, rejected, or deleted." data-tooltip-popup-delay="1000" data-tooltip-placement="left" ng-class="{unsorted: vm.sortColumn !== \'totalSubmitted\'}"> <span class="table-header-tooltip">Total Submissions</span> <icon ng-show="vm.sortColumn === \'totalSubmitted\'" name="{{vm.sortReverse ? \'fa-caret-down\' : \'fa-caret-up\'}}" class="icon-table-header"></icon> </span> </th> </tr> </thead> <tbody ng-show="!vm.overdueLoading"> <tr ng-repeat="organization in (vm.troubledOrganizations | orderBy:vm.sortColumn:vm.sortReverse)"> <td>{{organization.organizationName}}</td> <td> <span ng-if="organization.opocs.length === 0">No Assigned OPOCs</span> <a ng-if="organization.opocs.length" class="clickable" ng-click="vm.onClickViewOpocs(organization.opocs)">View {{organization.opocs.length > 1 ? organization.opocs.length + \' OPOCs\' : \'OPOC\'}}</a> </td> <td class="text-left"> <span ng-if="organization.totalOverdueHours > 0">{{organization.totalOverdueHours}}</span> <span ng-if="organization.totalOverdueHours === 0">0</span> </td> <td class="text-left"> <span ng-if="organization.totalOverdueApplications > 0">{{organization.totalOverdueApplications}}</span> <span ng-if="organization.totalOverdueApplications === 0">0</span> </td> <td class="text-left"> <span ng-if="organization.totalSubmitted > 0">{{organization.totalSubmitted}}</span> <span ng-if="organization.totalSubmitted === 0">0</span> </td> </tr> <tr ng-show="vm.troubledOrganizations.length === 0"> <td colspan="5"> There are no overdue hours/applications. </td> </tr> </tbody> </table> <loading-icon show="vm.overdueLoading"></loading-icon> <load-more is-loading="vm.overdueLoading" load-status="vm.loadStatusHoursApps" on-load-more="vm.onLoadMore()" on-load-all="vm.onLoadAll()"></load-more> </div> </div> </div> <div class="row"> <div class="tile"> <div class="tile-fill"> <div class="row"> <div class="small-6 column"> <label>Community</label> <ui-select data-ng-model="vm.community" data-ng-change="vm.onSelectCommunity()" data-ng-disabled="vm.chartLoading"> <ui-select-match placeholder="Select a community or search..."> {{$select.selected.name}} </ui-select-match> <ui-select-choices repeat="comm in vm.communities | propsFilter: {name: $select.search}"> <span ng-bind-html="comm.name | highlight: $select.search"></span> </ui-select-choices> </ui-select> </div> <div class="small-6 column"> <label>Organization</label> <ui-select data-ng-disabled="vm.chartLoading" data-ng-change="vm.onChangeChart()" data-ng-model="vm.organization"> <ui-select-match placeholder="Select an organization or search..."> {{$select.selected.name}} </ui-select-match> <ui-select-choices repeat="org in vm.organizations | propsFilter: {name: $select.search}"> <span ng-bind-html="org.name | highlight: $select.search"></span> </ui-select-choices> </ui-select> </div> </div> <div class="row"> <div class="small-4 column"> <label>Type</label> <ui-select data-ng-disabled="vm.chartLoading" data-ng-change="vm.onChangeChart()" data-ng-model="vm.chartType"> <ui-select-match placeholder="Select a chart type or search..."> {{$select.selected}} </ui-select-match> <ui-select-choices repeat="chart in vm.chartTypes | filter:$select.search"> <span ng-bind-html="chart | highlight: $select.search"></span> </ui-select-choices> </ui-select> </div> <div class="small-4 column"> <label for="startDate">Start Date</label> <div class="input-group"> <input type="text" id="startDate" class="input-group-field" ng-model="vm.startDate" ng-model-options="{updateOn: \'default programmatic\', debounce: {default: 500, programmatic: 0}}" placeholder="MM/DD/YYYY" ng-change="vm.onChangeDate()" data-ng-disabled="vm.chartLoading" vmis-datepicker target="start-date" format="M/D/YYYY" end-date="vm.endDate || vm.currentDate" required> <div class="input-group-button"> <button id="start-date" type="button" class="dflt button icon-button" data-ng-disabled="vm.chartLoading" aria-label="Start Date"> <icon name="fa-calendar" class="icon-big"></icon> </button> </div> </div> </div> <div class="small-4 column"> <label for="endDate">End Date</label> <div class="input-group"> <input type="text" id="endDate" class="input-group-field" ng-model="vm.endDate" ng-model-options="{updateOn: \'default programmatic\', debounce: {default: 500, programmatic: 0}}" placeholder="MM/DD/YYYY" ng-change="vm.onChangeDate()" data-ng-disabled="vm.chartLoading" vmis-datepicker target="end-date" format="M/D/YYYY" start-date="vm.startDate" end-date required> <div class="input-group-button"> <button id="end-date" type="button" class="dflt button icon-button" data-ng-disabled="vm.chartLoading" aria-label="End Date"> <icon name="fa-calendar" class="icon-big"></icon> </button> </div> </div> </div> </div> <div ng-class="{\'loading-background\': vm.chartLoading}"> <icon name="fa-spinner" class="icon-huge loading-center" spin="true" aria-hidden="true" ng-show="vm.chartLoading"></icon> <p class="notice-text" ng-show="!vm.chartLoading && vm.showChartIncompleteDataWarning"> More data exists for this range than is being displayed. Use the Reports feature for complete data. </p> <canvas class="chart chart-line" data-chart-data="vm.chart.data" data-chart-labels="vm.chart.labels" data-chart-options="vm.chart.options" data-chart-series="vm.chart.series" data-chart-colors="vm.chart.colors" data-chart-dataset-override="vm.chart.datasetOverride"></canvas> <p class="help-text" ng-hide="vm.chartLoading"> The data displayed on the chart only represents data from within the selected date range. </p> </div> </div> </div> </div> ');
$templateCache.put('app/components/dashboard/opocAvccAssistant/opocAvccAssistantDashboard.view.html','<h1 class="row section-header">Newly Submitted Hours</h1> <div class="row"> <div class="small-12 columns tile" style="height: inherit;"> <div class="tile-fill" style="height: inherit; overflow: auto;" ng-class="{\'loading-background\': vm.isLoading}"> <div style="width: 100%; max-height: 300px; overflow: auto;"> <table class="table information-table"> <thead> <tr> <th ng-click="vm.sortColumn = \'volunteer.lastName\'; vm.sortReverse = !vm.sortReverse"> <span ng-class="{unsorted: vm.sortColumn !== \'volunteer.lastName\'}"> Last Name <icon ng-show="vm.sortColumn === \'volunteer.lastName\'" name="{{vm.sortReverse ? \'fa-caret-down\' : \'fa-caret-up\'}}" class="icon-table-header"></icon> </span> </th> <th ng-click="vm.sortColumn = \'volunteer.firstName\'; vm.sortReverse = !vm.sortReverse"> <span ng-class="{unsorted: vm.sortColumn !== \'volunteer.firstName\'}"> First Name <icon ng-show="vm.sortColumn === \'volunteer.firstName\'" name="{{vm.sortReverse ? \'fa-caret-down\' : \'fa-caret-up\'}}" class="icon-table-header"></icon> </span> </th> <th ng-click="vm.sortColumn = \'position\'; vm.sortReverse = !vm.sortReverse"> <span ng-class="{unsorted: vm.sortColumn !== \'position\'}"> Position <icon ng-show="vm.sortColumn === \'position\'" name="{{vm.sortReverse ? \'fa-caret-down\' : \'fa-caret-up\'}}" class="icon-table-header"></icon> </span> </th> <th ng-click="vm.sortColumn = \'type\'; vm.sortReverse = !vm.sortReverse"> <span ng-class="{unsorted: vm.sortColumn !== \'type\'}"> Type <icon ng-show="vm.sortColumn === \'type\'" name="{{vm.sortReverse ? \'fa-caret-down\' : \'fa-caret-up\'}}" class="icon-table-header"></icon> </span> </th> <th ng-click="vm.sortColumn = \'date\'; vm.sortReverse = !vm.sortReverse"> <span ng-class="{unsorted: vm.sortColumn !== \'date\'}"> Date <icon ng-show="vm.sortColumn === \'date\'" name="{{vm.sortReverse ? \'fa-caret-down\' : \'fa-caret-up\'}}" class="icon-table-header"></icon> </span> </th> <th ng-click="vm.sortColumn = \'hours\'; vm.sortReverse = !vm.sortReverse"> <span ng-class="{unsorted: vm.sortColumn !== \'hours\'}"> Hours <icon ng-show="vm.sortColumn === \'hours\'" name="{{vm.sortReverse ? \'fa-caret-down\' : \'fa-caret-up\'}}" class="icon-table-header"></icon> </span> </th> <th></th> <th></th> </tr> </thead> <tbody> <tr ng-repeat="row in vm.hours | orderBy:vm.sortColumn:vm.sortReverse" ng-class-even="\'even\'" ng-class-odd="\'odd\'" ng-class="{\'fade\':row.isFading, \'loading-background\': vm.isLoading}"> <td>{{row.volunteer.lastName}}</td> <td>{{row.volunteer.firstName}}</td> <td>{{row.position}}</td> <td>{{row.type}}</td> <td>{{row.date | date:row.type === \'Daily\' ? \'d MMM yyyy\' : \'MMM yyyy\'}}</td> <td>{{row.hours | number:2}}</td> <td class="table-icon-column-entry"> <icon name="fa-times" class="icon-lg icon-hours rejected" ng-class="{\'clickable\': !vm.isLoading}" aria-hidden="true" ng-click="!vm.isLoading && vm.onRejectHoursClick(row)"></icon> </td> <td class="table-icon-column-entry"> <icon name="fa-check" class="icon-lg icon-hours certified" ng-class="{\'clickable\': !vm.isLoading}" aria-hidden="true" ng-click="!vm.isLoading && vm.onClickCertify(row)"></icon> </td> </tr> <tr ng-if="vm.hours.length === 0"> <td colspan="8">No data to display</td> </tr> </tbody> </table> </div> <icon name="fa-spinner" class="icon-huge loading-center" spin="true" aria-hidden="true" ng-show="vm.isLoading && vm.hours.length"></icon> </div> </div> </div> <div ng-if="vm.isOpoc"> <h1 class="row section-header">My Organization Charts</h1> <div class="row"> <div class="small-6 columns tile"> <div class="lead tile-fill" style="text-align: center;"> <span tooltip="This chart displays hours for the current open period, which is {{vm.startDate | date:\'d MMM yyyy\'}} to {{vm.endDate | date:\'d MMM yyyy\'}}" tooltip-append-to-body="true">Hours Status Distribution</span> </div> <div class="tile-fill"> <label> Community <ui-select data-ng-change="vm.onChangeCommunity(vm.hoursCommunity, \'hours\')" data-ng-model="vm.hoursCommunity" data-ng-disabled="vm.hoursChartLoading"> <ui-select-match placeholder="Select a community or search..."> {{$select.selected.name}} </ui-select-match> <ui-select-choices repeat="comm in vm.communities | propsFilter: {name: $select.search}"> <span ng-bind-html="comm.name | highlight: $select.search"></span> </ui-select-choices> </ui-select> </label> <label> Organization <ui-select data-ng-change="vm.onChangeOrganization(vm.hoursOrganization, \'hours\')" data-ng-model="vm.hoursOrganization" data-ng-disabled="vm.hoursChartLoading"> <ui-select-match placeholder="Select an organization or search..."> {{$select.selected.name}} </ui-select-match> <ui-select-choices repeat="org in vm.hoursCommunity.organizations | propsFilter: {name: $select.search}"> <span ng-bind-html="org.name | highlight: $select.search"></span> </ui-select-choices> </ui-select> </label> <div class="columns small-8 small-centered"> <canvas class="chart chart-doughnut" data-chart-data="vm.hoursChart.data" data-chart-labels="vm.hoursChart.labels" data-chart-colors="vm.hoursChart.colors" data-chart-options="vm.hoursChart.options"></canvas> </div> </div> </div> <div class="small-6 columns tile"> <div class="lead tile-fill" style="text-align: center;"> <span tooltip="This chart displays the proportion of your positions that have at least 1 active volunteer." tooltip-append-to-body="true">Positions Filled</span> </div> <div class="tile-fill"> <label> Community <ui-select data-ng-change="vm.onChangeCommunity(vm.positionsCommunity, \'positions\')" data-ng-model="vm.positionsCommunity" data-ng-disabled="vm.positionsChartLoading"> <ui-select-match placeholder="Select a community or search..."> {{$select.selected.name}} </ui-select-match> <ui-select-choices repeat="comm in vm.communities | propsFilter: {name: $select.search}"> <span ng-bind-html="comm.name | highlight: $select.search"></span> </ui-select-choices> </ui-select> </label> <label> Organization <ui-select data-ng-change="vm.onChangeOrganization(vm.positionsOrganization, \'positions\')" data-ng-model="vm.positionsOrganization" data-ng-disabled="vm.positionsChartLoading"> <ui-select-match placeholder="Select an organization or search..."> {{$select.selected.name}} </ui-select-match> <ui-select-choices repeat="org in vm.positionsCommunity.organizations | propsFilter: {name: $select.search}"> <span ng-bind-html="org.name | highlight: $select.search"></span> </ui-select-choices> </ui-select> </label> <div class="columns small-8 small-centered"> <canvas class="chart chart-doughnut" data-chart-data="vm.positionsChart.data" data-chart-labels="vm.positionsChart.labels" data-chart-colors="vm.positionsChart.colors" data-chart-options="vm.positionsChart.options"></canvas> </div> </div> </div> </div> </div> ');
$templateCache.put('app/components/dashboard/volunteer/volunteerDashboard.view.html','<h1 class="row section-header"> <span ng-if="!vm.isAdmin">My Volunteering</span> <span ng-if="vm.isAdmin" class="simple-tip" tooltip="This section refers only to your personal volunteering" tooltip-popup-delay="200" tooltip-append-to-body="true" tooltip-placement="right"> My Volunteering </span> </h1> <div class="row"> <div class="columns small-12 tile" ng-class="{\'medium-6\': !vm.isLiteMode, \'medium-12\': vm.isLiteMode}"> <div class="tile-fill" style="min-height: 255px;"> <div> <div class="lead pull-left remove-bottom-margin simple-tip" style="height: 25px" tooltip-html-unsafe="Hours are only recorded in 15-minute increments (.00, .25, .50, .75).\n                     <br>Hours are automatically submitted when you stop typing in an entry (after 2 seconds).\n                     <br>Avoid clicking outside of the entry box until your activity is logged.\n                     <br>Logging hours on the Volunteer Dashboard does not allow you to add a note,\n                     attach documentation, or delete hours.\n                     <br>Please go to the Service Log page to complete these actions." tooltip-popup-delay="200" tooltip-placement="right"> Log Hours </div> <div class="pull-right"> <div class="pull-left"> <icon name="fa-caret-left" class="icon-big clickable" ng-click="vm.onPreviousWeek()"></icon> </div> <div class="pull-right"> <icon name="fa-caret-right" class="icon-big clickable" ng-click="vm.onNextWeek()"></icon> </div> <label class="pull-right" style="width: 138px; text-align: center"> {{vm.startDate | date:\'d MMM\'}} to {{vm.endDate | date:\'d MMM\'}} </label> </div> </div> <div style="width: 100%; max-height: 200px; overflow: auto;"> <vmis-hours-entry date="vm.date" set-hour-callback="vm.onHoursEntered"></vmis-hours-entry> </div> </div> </div> <div class="columns small-12 medium-6 tile" ng-if="!vm.isLiteMode"> <div class="tile-fill" style="min-height: 255px;"> <div> <div class="lead remove-bottom-margin"> Hours for {{vm.date | date:\'MMMM yyyy\'}} </div> </div> <div> <div class="small-4 columns" style="height: inherit; overflow: auto; padding-top: 30px;"> <label style="color: #3c763d;">Certified: {{vm.hoursReport.certifiedHours | number:2}}</label> <label style="color: #337ab7;">Submitted: {{vm.hoursReport.submittedHours | number:2}}</label> <label style="color: #a94442;">Rejected: {{vm.hoursReport.rejectedHours | number:2}}</label> </div> <div class="small-8 columns" style="height: inherit; overflow: hidden;"> <canvas class="chart volunteer chart-doughnut" data-chart-options="vm.hoursChart.options" data-chart-data="vm.hoursChart.data" data-chart-labels="vm.hoursChart.labels" data-chart-colors="vm.hoursChart.colors" width="12" height="6" style="float: left;"></canvas> </div> </div> </div> </div> </div>');
$templateCache.put('app/components/logIn/passwordExpirationModal/passwordExpirationModal.view.html','<modal modal-title="Password Expiration Warning"> <modal-body> Your password will expire in {{vm.daysRemaining}} days. Please go to your <a href="{{vm.accountSettingsURL}}">Account Management</a> to update your password. </modal-body> <modal-footer> <div class="pull-right"> <button type="button" class="dflt button" ng-click="$close()">OK</button> </div> </modal-footer> </modal>');
$templateCache.put('app/components/volunteer/activityCalendar/activityCalendar.view.html','<div class="header" data-ng-disabled="vm.isCalendarLoading"> <icon name="fa-caret-left" class="icon-calendar-arrows left-arrow" ng-click="vm.onPreviousMonth()"></icon> <span>{{vm.current | date:\'MMMM yyyy\'}}</span> <icon name="fa-caret-right" class="icon-calendar-arrows right-arrow" ng-click="vm.onNextMonth()"></icon> </div> <div class="week names" data-ng-disabled="vm.isCalendarLoading"> <div class="day">Sunday</div> <div class="day">Monday</div> <div class="day">Tuesday</div> <div class="day">Wednesday</div> <div class="day">Thursday</div> <div class="day">Friday</div> <div class="day">Saturday</div> </div> <div class="week" ng-repeat="week in vm.calendarView" data-ng-disabled="vm.isCalendarLoading"> <div class="day" ng-click="vm.onSelect(day)" ng-repeat="day in week" ng-class="{\n             disabled: vm.disabled,\n             today: vm.isToday(day.date),\n             \'different-month\': !vm.isCurrentMonth(day.date),\n             \'outside-date-range\': !vm.isCurrentPeriod(day.date),\n             \'has-activity\': day.activity\n         }" tooltip="{{(!vm.disabled && !vm.isCurrentPeriod(day.date)) ?\n                    (vm.isBeforePeriod(day.date) ?\n                    \'This date is outside the open period.\' : \'This date is in the future.\') : null}}" tooltip-popup-delay="1000"> <div class="triangle"></div> <div class="number"> {{day.date | date:\'d\'}} </div> <div class="hours" ng-if="day.activity.hours"> {{ day.activity.hours | number:2 }} </div> <div class="attachments" ng-if="day.activity.documents.length > 0"> <icon name="fa-paperclip" class="icon-lg" alt="This entry contains a document"></icon> </div> <div class="note" ng-if="day.activity.volunteerNote || day.activity.reviewerNote"> <icon name="fa-file-text-o" class="icon-lg" alt="This entry contains a note"></icon> </div> <vmis-hours-status status="day.activity.status" class="hours-status"></vmis-hours-status> </div> </div> ');
$templateCache.put('app/components/volunteer/activityCalendar/deleteHours.view.html','<form name="form" ng-submit="vm.onClickDelete()"> <modal close="$dismiss" modal-title="{{vm.title}}"> <modal-body> <div role="alert" ng-show="vm.formError" class="callout alert">{{vm.formError}}</div> <p>Are you sure you want to delete <span ng-if="!vm.adminEditing">your</span> <span class="bold">{{vm.activity.hours}}</span> hour<span ng-if="vm.activity.hours !== 1">s</span> <span ng-if="vm.adminEditing"> for <span class="bold">{{vm.activity.volunteer.firstName}} {{vm.activity.volunteer.lastName}}</span></span>? </p> <div ng-if="vm.adminEditing"> <label class="bold">Reviewer Note</label> <p>{{vm.activity.reviewerNote}}</p> </div> </modal-body> <modal-footer> <div class="float-right"> <button type="submit" class="dflt button" ng-disabled="form.$invalid || vm.isWaiting"> Delete </button> <button type="button" class="dflt button" ng-click="$dismiss(\'cancel\')" ng-disabled="vm.isWaiting"> Cancel </button> </div> </modal-footer> </modal> </form>');
$templateCache.put('app/components/volunteer/activityCalendar/deleteHoursDocument.view.html','<form ng-submit="$close()" name="form"> <modal close="$dismiss" modal-title="Delete Service Log Document"> <modal-body> <p>Are you sure you want to delete this Service Log document, <span class="bold">{{vm.document.documentName}}</span>?</p> <loading-icon show="vm.processing"></loading-icon> </modal-body> <modal-footer> <div class="pull-right"> <button type="button" class="dflt button" ng-click="vm.onDeleteUploadedDoc()" data-ng-disabled="vm.processing"> Delete </button> <button type="button" class="dflt button" ng-click="$dismiss()" data-ng-disabled="vm.processing"> Cancel </button> </div> </modal-footer> </modal> </form>');
$templateCache.put('app/components/volunteer/activityCalendar/enterHours.view.html','<form ng-submit="vm.onSubmit()" name="form"> <modal close="$dismiss" modal-title="{{vm.title}}"> <modal-body id="hoursModal"> <div ng-show="vm.formError" class="callout alert">{{vm.formError}}</div> <div class="row" ng-if="vm.hoursId"> <div class="small-6 columns"> <label class="control-label">Status</label> <p class="form-control-static">{{vm.status}}</p> </div> <div class="small-6 columns"> <label class="control-label">Submitted By</label> <p class="form-control-static">{{vm.submitterText}}</p> </div> </div> <div class="row"> <div class="small-6 columns"> <label class="control-label"> Hours<span ng-if="!vm.readOnly" class="required text">*</span> </label> <ui-select class="form-control-static" required data-ng-change="vm.onChangeHours()" data-ng-model="vm.hours" data-ng-disabled="vm.readOnly || vm.isModalLoading"> <ui-select-match placeholder=""> {{$select.selected}} </ui-select-match> <ui-select-choices repeat="hour in vm.hrLabel | filter:$select.search"> <span ng-bind-html="hour | highlight: $select.search"></span> </ui-select-choices> </ui-select> </div> <div class="small-6 columns"> <label class="control-label"> Minutes<span ng-if="!vm.readOnly" class="required text">*</span> </label> <ui-select class="form-control-static" required data-ng-change="vm.onChangeHours()" data-ng-model="vm.minutes" data-ng-disabled="vm.readOnly || vm.isModalLoading"> <ui-select-match placeholder=""> {{$select.selected}} </ui-select-match> <ui-select-choices repeat="min in vm.minLabel | filter:$select.search"> <span ng-bind-html="min | highlight: $select.search"></span> </ui-select-choices> </ui-select> </div> </div> <div class="row"> <div class="small-12 columns"> <label><span class="control-label">Submitter Note<span ng-if="!vm.readOnly && !vm.isDaily" class="required text">*</span></span> <text-area-with-count is-required="!vm.isDaily" number-rows="3" model-name="vm.note" max-given-length="350" default-shown-text="Note" is-disabled="vm.readOnly || vm.isModalLoading"></text-area-with-count> <label class="help-text text-center" ng-if="!vm.readOnly"> <span class="required text">*</span> Indicates a required field. </label> </label> </div> </div> <hr ng-if="!(vm.readOnly && vm.uploadedDocuments.length === 0)"> <div class="row" ng-if="!(vm.readOnly && vm.uploadedDocuments.length === 0)"> <div class="small-12 columns"> <label class="control-label">Documentation</label> </div> <div class="small-9 columns"> <upload-document-list uploaded-documents="vm.uploadedDocuments" selected-documents="vm.selectedDocuments" on-delete-uploaded-doc="vm.onDeleteUploadedDoc" on-delete-selected-doc="vm.onDeleteSelectedDoc" show-upload-instructions="!vm.readOnly" show-delete="true" disable-delete="vm.isModalLoading || vm.readOnly"> </upload-document-list> </div> <div class="small-3 columns"> <button type="button" aria-label="Attach a document" class="dflt button expanded icon-button" multiple="multiple" ngf-max-size="{{vm.maxFileSizeInMegabytes}}" ngf-select="vm.onSelectDoc($files, $invalidFiles); form.$setDirty()" ngf-pattern="{{vm.allowedFileTypesForUpload}}" accept="{{vm.allowedFileTypesForUpload}}" ng-disabled="vm.isModalLoading || vm.maxDocumentsUploaded || vm.readOnly"> <icon name="fa-paperclip" class="icon-big" aria-hidden="true" ng-hide="vm.isDocumentUploading" alt="Select this paperclip to attach a document"></icon> <loading-icon show="vm.isDocumentUploading" little="true"></loading-icon> </button> </div> </div> <p class="documents-help-text" id="enter-hours-documents" ng-if="!vm.readOnly"> These documents will be deleted once an administrator has reviewed them.<br> Please keep copies of these documents for your personal record keeping.</p> <hr ng-if="vm.reviewerNote"> <div class="row" ng-if="vm.reviewerNote"> <div class="small-12 small-centered columns"> <span class="control-label">Reviewer Note</span> <p class="form-control-static small-bottom-margin">{{vm.reviewerNote}}</p> </div> </div> </modal-body> <modal-footer> <div class="row" ng-switch="vm.readOnly"> <div ng-switch-when="true" class="small-12 columns"> <div class="small-3 columns small-offset-9"> <button type="button" class="dflt button expanded" ng-click="$dismiss(\'ok\')"> OK </button> </div> </div> <div ng-switch-default class="small-12 columns"> <div class="small-3 columns" ng-class="{\'small-offset-6\': !vm.isDeletable(), \'small-offset-3\': vm.isDeletable()}"> <button type="submit" class="dflt button expanded" ng-disabled="form.$invalid || form.$pristine || vm.isModalLoading || (vm.hours === 0 && vm.minutes === 0)"> Submit </button> </div> <div class="small-3 columns" ng-if="vm.isDeletable()"> <button type="button" class="dflt button expanded" ng-click="vm.onClickDelete()" ng-disabled="vm.isModalLoading"> Delete </button> </div> <div class="small-3 columns"> <button type="button" class="dflt button expanded" ng-click="$dismiss(\'cancel\')" ng-disabled="vm.isModalLoading"> Cancel </button> </div> </div> </div> </modal-footer> </modal> </form>');
$templateCache.put('app/components/volunteer/applications/applicationDetails.view.html','<ul class="breadcrumbs"> <li><a ui-sref="vmis" ui-sref-opts="{reload:true}">VMIS</a></li> <li><a ui-sref="vmis.volunteer.applications">Applications</a></li> <li> <span class="show-for-sr">Current: </span> Application Details </li> </ul> <h1>Application Details</h1> <table class="table information-table"> <thead></thead> <tbody> <tr> <td class="row-title"> <label class="control-label"> Status </label> </td> <td> {{vm.application.status}} </td> </tr> <tr ng-if="vm.application.statusReason"> <td class="row-title"> <label class="control-label"> Reason </label> </td> <td> {{vm.application.statusReason}} </td> </tr> </tbody> <thead> <tr> <th colspan="2">Position</th> </tr> </thead> <tbody> <tr> <td class="row-title"> <label class="control-label"> Posted Date </label> </td> <td> {{(vm.position.postedDate || vm.position.submittedDate) | date:\'MM/dd/yyyy\'}} </td> </tr> <tr ng-if="!vm.isVolunteerSubmitted"> <td class="row-title"> <label class="control-label"> Closed Date </label> </td> <td> {{vm.position.closedDate | date:\'MM/dd/yyyy\'}} </td> </tr> <tr> <td class="row-title"> <label class="control-label"> Title </label> </td> <td> {{vm.position.title}} </td> </tr> <tr> <td class="row-title"> <label class="control-label"> Organization </label> </td> <td> {{vm.position.volunteerOrganization || vm.position.organizationName}} </td> </tr> <tr ng-if="vm.isVolunteerSubmitted"> <td class="row-title"> <label class="control-label"> Organization Name </label> </td> <td> {{vm.position.summary}} </td> </tr> <tr> <td class="row-title"> <label class="control-label"> Community </label> </td> <td> {{vm.position.communityAffiliation}} </td> </tr> <tr ng-if="!vm.isVolunteerSubmitted"> <td class="row-title"> <label class="control-label"> Position Type </label> </td> <td> {{vm.position.volunteerPositionType}} </td> </tr> <tr ng-if="!vm.isVolunteerSubmitted"> <td class="row-title"> <label class="control-label"> Opportunity Type </label> </td> <td> {{vm.position.volunteerOpportunityType}} </td> </tr> <tr> <td class="row-title"> <label class="control-label"> Background Check Required </label> </td> <td> {{vm.position.isBackgroundCheckRequired}} </td> </tr> <tr ng-if="!vm.isVolunteerSubmitted"> <td class="row-title"> <label class="control-label"> Supervision Required </label> </td> <td> {{vm.position.supervisionConditionFlag}} </td> </tr> <tr ng-if="!vm.isVolunteerSubmitted"> <td class="row-title"> <label class="control-label"> Summary </label> </td> <td> {{vm.position.summary}} </td> </tr> <tr> <td class="row-title"> <label class="control-label"> Duties </label> </td> <td> {{vm.position.duties}} </td> </tr> <tr> <td class="row-title"> <label class="control-label"> Qualifications </label> </td> <td> {{vm.position.qualifications}} </td> </tr> <tr> <td class="row-title"> <label class="control-label"> Training </label> </td> <td> {{vm.position.training}} </td> </tr> <tr> <td class="row-title"> <label class="control-label"> Orientation </label> </td> <td> {{vm.position.orientation}} </td> </tr> <tr> <td class="row-title"> <label class="control-label"> Time Required </label> </td> <td> {{vm.position.timeRequired}} </td> </tr> <tr ng-if="!vm.isVolunteerSubmitted"> <td class="row-title"> <label class="control-label"> Evaluation </label> </td> <td> {{vm.position.evaluation}} </td> </tr> <tr ng-if="!vm.isVolunteerSubmitted"> <td class="row-title"> <label class="control-label"> Benefits </label> </td> <td> {{vm.position.benefits}} </td> </tr> <tr ng-if="vm.isVolunteerSubmitted"> <td class="row-title"> <label class="control-label"> Comment </label> </td> <td> {{vm.position.opportunityApplicationComment}} </td> </tr> <tr> <td class="row-title"> <label class="control-label"> Address </label> </td> <td> <div>{{vm.position.address1}}</div> <div>{{vm.position.address2}}</div> <div>{{vm.position.city}}<span ng-if="vm.position.country === \'United States\'">, {{vm.position.usState}}</span> {{vm.position.zipCode}} </div> <div>{{vm.position.country}}</div> </td> </tr> <tr> <td class="row-title"> <label class="control-label"> Supervisor{{vm.isVolunteerSubmitted ? \'\' : \' 1\'}} </label> </td> <td> <div>{{vm.position.firstLineSupervisorName}}</div> <div>{{vm.position.firstLineSupervisorPhone}}</div> <div>{{vm.position.firstLineSupervisorEmail}}</div> </td> </tr> <tr ng-if="!vm.isVolunteerSubmitted"> <td class="row-title"> <label class="control-label"> Supervisor 2 </label> </td> <td> <div>{{vm.position.secondLineSupervisorName}}</div> <div>{{vm.position.secondLineSupervisorPhone}}</div> <div>{{vm.position.secondLineSupervisorEmail}}</div> </td> </tr> </tbody> <thead> <tr> <th colspan="2">User Profile</th> </tr> </thead> <tbody> <tr> <td class="row-title"> <label class="control-label"> Name </label> </td> <td> {{vm.profile.aosUser.firstName}} {{vm.profile.aosUser.lastName}} </td> </tr> <tr> <td class="row-title"> <label class="control-label"> Email </label> </td> <td> {{vm.profile.masterUserEmail}} </td> </tr> <tr> <td class="row-title"> <label class="control-label"> Community </label> </td> <td> {{vm.profile.aosUser.communityAffiliation}} </td> </tr> <tr> <td class="row-title"> <label class="control-label"> Branch </label> </td> <td> {{vm.profile.aosUser.branchOfService}} </td> </tr> <tr> <td class="row-title"> <label class="control-label"> Component </label> </td> <td> {{vm.profile.aosUser.armyComponent}} </td> </tr> <tr class="vertical-align-top"> <td class="row-title"> <label class="control-label"> Disposition(s) </label> </td> <td> <label ng-repeat="disposition in vm.profile.aosUser.dispositions" ng-switch="disposition"> <span ng-switch-when="Service Member">{{disposition}}, Rank: {{vm.profile.aosUser.payGrade}}</span> <span ng-switch-when="Family Member">{{disposition}}, Sponsor\'s Rank: {{vm.profile.aosUser.sponsorPayGrade}}</span> <span ng-switch-when="DoD Civilian">{{disposition}}, Civilian Rank: {{vm.profile.aosUser.civilianPayGrade}}</span> <span ng-switch-default>{{disposition}}</span> </label> </td> </tr> </tbody> <thead> <tr> <th colspan="2">Volunteer Profile</th> </tr> </thead> <tbody> <tr> <td class="row-title"> <label class="control-label"> Preferred Contact Method </label> </td> <td> {{vm.profile.aosUser.vmisUser.volunteerProfile.preferredContactMethod}} </td> </tr> <tr> <td class="row-title"> <label class="control-label"> Volunteer Email </label> </td> <td> {{vm.profile.aosUser.vmisUser.volunteerProfile.volunteerEmail}} </td> </tr> <tr> <td class="row-title"> <label class="control-label"> Primary Phone </label> </td> <td> {{vm.profile.aosUser.vmisUser.volunteerProfile.primaryPhone}} </td> </tr> <tr> <td class="row-title"> <label class="control-label"> Secondary Phone </label> </td> <td> {{vm.profile.aosUser.vmisUser.volunteerProfile.secondaryPhone}} </td> </tr> <tr> <td class="row-title"> <label class="control-label"> Work Experience </label> </td> <td> {{vm.profile.aosUser.vmisUser.volunteerProfile.workExperience}} </td> </tr> <tr> <td class="row-title"> <label class="control-label"> Volunteer Experience </label> </td> <td> {{vm.profile.aosUser.vmisUser.volunteerProfile.volunteerExperience}} </td> </tr> <tr> <td class="row-title"> <label class="control-label"> Special Skills, Interests, and Hobbies </label> </td> <td> {{vm.profile.aosUser.vmisUser.volunteerProfile.specialSIH}} </td> </tr> </tbody> </table> <div class="pull-right"> <button type="button" class="dflt button" ng-click="vm.onDelete()" ng-if="vm.application.status === \'Submitted\'"> Delete </button> <button type="button" class="dflt button" ui-sref="^"> Back </button> </div> ');
$templateCache.put('app/components/volunteer/applications/applications.view.html','<div ui-view> <ul class="breadcrumbs"> <li><a ui-sref="vmis" ui-sref-opts="{reload:true}">VMIS</a></li> <li> <span class="show-for-sr">Current: </span>Applications </li> </ul> <learn-about-this-page learn-title="About Applications Page" text-body="The Applications page gives detailed information about the volunteer opportunities you have already applied for, including an application\u2019s status, submission date, and organization. This page can also be used to submit non-AVC volunteer positions.\nIf no opportunity applications or non-AVC positions have been submitted, the table will be left blank. For more information on how to use this page, please see section 4.0 of the VMIS Volunteer User Guide."></learn-about-this-page> <h1>Applications</h1> <div class="row"> <div class="small-3 columns"> <label>Status</label> </div> </div> <div class="row"> <div class="small-3 columns"> <ui-select data-ng-change="vm.onChangeStatus(vm.status)" data-ng-model="vm.status" data-ng-disabled="vm.isLoading"> <ui-select-match placeholder="Select a status or search..."> {{$select.selected}} </ui-select-match> <ui-select-choices repeat="status in vm.statusTypes | filter:$select.search"> <span ng-bind-html="status | highlight: $select.search"></span> </ui-select-choices> </ui-select> </div> <div class="small-9 columns"> <button type="button" class="dflt button float-right" ui-sref="vmis.volunteer.applications.createNonAvcPosition"> Submit Non-AVC Position </button> </div> </div> <retrieved-results is-loading="vm.isLoading" load-status="vm.loadStatus"></retrieved-results> <table class="information-table table table-hover"> <thead> <tr> <th ng-click="vm.sortColumn = \'title\'; vm.sortReverse = !vm.sortReverse"> <span ng-class="{unsorted: vm.sortColumn !== \'title\'}"> Position Title <icon ng-show="vm.sortColumn === \'title\'" name="{{vm.sortReverse ? \'fa-caret-down\' : \'fa-caret-up\'}}" class="icon-table-header" alt="Sorted by Position Title"></icon> </span> </th> <th ng-click="vm.sortColumn = \'organizationName\'; vm.sortReverse = !vm.sortReverse"> <span ng-class="{unsorted: vm.sortColumn !== \'organizationName\'}"> Organization <icon ng-show="vm.sortColumn === \'organizationName\'" name="{{vm.sortReverse ? \'fa-caret-down\' : \'fa-caret-up\'}}" class="icon-table-header" alt="Sorted by Organization"></icon> </span> </th> <th ng-click="vm.sortColumn = \'submittedDate\'; vm.sortReverse = !vm.sortReverse"> <span ng-class="{unsorted: vm.sortColumn !== \'submittedDate\'}"> Submitted Date <icon ng-show="vm.sortColumn === \'submittedDate\'" name="{{vm.sortReverse ? \'fa-caret-down\' : \'fa-caret-up\'}}" class="icon-table-header" alt="Sorted by Submitted Date"></icon> </span> </th> <th ng-click="vm.sortColumn = \'status\'; vm.sortReverse = !vm.sortReverse"> <span ng-class="{unsorted: vm.sortColumn !== \'status\'}"> Status <icon ng-show="vm.sortColumn === \'status\'" name="{{vm.sortReverse ? \'fa-caret-down\' : \'fa-caret-up\'}}" class="icon-table-header" alt="Sorted by Status"></icon> </span> </th> </tr> </thead> <tbody ng-hide="vm.isLoading"> <tr ng-repeat="application in vm.applications | orderBy:vm.sortColumn:vm.sortReverse" ng-click="vm.onClickApplication(application)" ng-class-even="\'even\'" ng-class-odd="\'odd\'"> <td>{{application.title}}</td> <td>{{application.organizationName}}</td> <td>{{application.submittedDate | date:\'d MMM yyyy\'}}</td> <td>{{application.status}}</td> </tr> <tr ng-if="vm.applications.length === 0"> <td colspan="4"> No data to display </td> </tr> </tbody> </table> <loading-icon show="vm.isLoading"></loading-icon> <load-more is-loading="vm.isLoading" load-status="vm.loadStatus" on-load-more="vm.onLoadMore()" on-load-all="vm.onLoadAll()"></load-more> </div> ');
$templateCache.put('app/components/volunteer/applications/deleteApplicationConfirmation.view.html','<form ng-submit="$close()" name="form"> <modal close="$dismiss" modal-title="Delete Application"> <modal-body> Are you sure you want to delete your application for <span class="bold">{{vm.title}}</span>? </modal-body> <modal-footer> <div class="float-right"> <button type="button" class="dflt button" ng-click="$close()">Delete</button> <button type="button" class="dflt button" ng-click="$dismiss()">Cancel</button> </div> </modal-footer> </modal> </form>');
$templateCache.put('app/components/volunteer/avccLocator/avccLocator.view.html','<ul class="breadcrumbs"> <li><a ui-sref="vmis" ui-sref-opts="{reload:true}">VMIS</a></li> <li> <span class="show-for-sr">Current: </span>AVCC Locator </li> </ul> <learn-about-this-page learn-title="About AVCC Locator Page" text-body="The AVCC Locator page allows you to search by community for specific AVCCs and their contact information. This information includes the AVCCs\u2019 first and last names, email addresses, and phone numbers. For more information on how to use this page, please see section 8.0 in the VMIS Volunteer User Guide."></learn-about-this-page> <h1>AVCC Locator</h1> <div class="row"> <div class="small-4 columns"> <label>Community <ui-select data-ng-change="vm.onChangeCommunityId(vm.communityId)" data-ng-model="vm.communityId" data-ng-disabled="vm.isLoading"> <ui-select-match placeholder="Select a community or search..."> {{$select.selected.name}} </ui-select-match> <ui-select-choices repeat="comm.id as comm in vm.communities | propsFilter: {name: $select.search}"> <span ng-bind-html="comm.name | highlight: $select.search"></span> </ui-select-choices> </ui-select> </label> </div> </div> <div ui-view="avccList"></div>');
$templateCache.put('app/components/volunteer/createNonAvcPosition/createNonAvcPosition.view.html','<ul class="breadcrumbs"> <li><a ui-sref="vmis" ui-sref-opts="{reload:true}">VMIS</a></li> <li><a ui-sref="vmis.volunteer.applications">Applications</a></li> <li><span class="show-for-sr">Current: </span>Create Non-AVC Position</li> </ul> <h1 id="anchor-top">Create Non-AVC Position</h1> <div role="alert" ng-show="vm.formError" class="callout warning">{{vm.formError}}</div> <div role="alert" ng-show="vm.formSuccess" class="callout success">{{vm.formSuccess}}</div> <div class="help-text middle"> <p><span class="alert-text">Before submitting your Non-AVC Position, please ensure that there is not already an AVC position for this volunteering opportunity. Use the Opportunities page to conduct this kind of search.</span></p> <p><span class="required text">*</span>Indicates a required field.</p> </div> <form name="form" ng-submit="vm.onSubmit()" class="form"> <table class="table information-table"> <thead> <tr> <td colspan="2"> Details </td> </tr> </thead> <tbody> <tr> <td> <label for="title" class="text-right middle"> <span class="bold">Title</span><span class="required text">*</span> </label> </td> <td> <input id="title" type="text" ng-model="vm.position.title" required data-ng-disabled="vm.isLoading"> </td> </tr> <tr> <td> <label for="summary" class="text-right middle"> <span class="bold">Organization Name</span><span class="required text">*</span> </label> </td> <td> <input id="summary" type="text" ng-model="vm.position.organizationName" required data-ng-disabled="vm.isLoading"> </td> </tr> <tr> <td> <label for="background-check" class="text-right middle"> <span class="bold">Background Check Required</span><span class="required text">*</span> </label> </td> <td id="background-check"> <ui-select required data-ng-model="vm.position.backgroundCheckRequired" data-ng-disabled="vm.isLoading"> <ui-select-match placeholder="Select an option or search..."> {{$select.selected.label}} </ui-select-match> <ui-select-choices repeat="bcr.value as bcr in vm.dropDowns.booleanOptions | propsFilter: {label: $select.search}"> <span ng-bind-html="bcr.label | highlight: $select.search"></span> </ui-select-choices> </ui-select> </td> </tr> <tr> <td> <label for="duties" class="text-right middle"> <span class="bold">Duties</span><span class="required text">*</span> </label> </td> <td> <textarea id="duties" rows="3" ng-model="vm.position.duties" required data-ng-disabled="vm.isLoading" ng-maxlength="3100" name="positionDuties" class="vertical-resize-only"></textarea> <label ng-hide="vm.isLoading" class="character-countdown">{{3100 - form.positionDuties.$viewValue.length}}</label> </td> </tr> <tr> <td> <label for="qualifications" class="text-right middle"> <span class="bold">Qualifications</span><span class="required text">*</span> </label> </td> <td> <textarea id="qualifications" rows="3" ng-model="vm.position.qualifications" required data-ng-disabled="vm.isLoading" ng-maxlength="2200" name="positionQualifications" class="vertical-resize-only"></textarea> <label ng-hide="vm.isLoading" class="character-countdown">{{2200 - form.positionQualifications.$viewValue.length}}</label> </td> </tr> <tr> <td> <label for="training" class="text-right middle"> <span class="bold">Training</span><span class="required text">*</span> </label> </td> <td> <textarea id="training" rows="3" ng-model="vm.position.training" required data-ng-disabled="vm.isLoading" ng-maxlength="2200" name="positionTraining" class="vertical-resize-only"></textarea> <label ng-hide="vm.isLoading" class="character-countdown">{{2200 - form.positionTraining.$viewValue.length}}</label> </td> </tr> <tr> <td> <label for="orientation" class="text-right middle"> <span class="bold">Orientation</span><span class="required text">*</span> </label> </td> <td> <textarea id="orientation" rows="3" ng-model="vm.position.orientation" required data-ng-disabled="vm.isLoading" ng-maxlength="2200" name="positionOrientation" class="vertical-resize-only"></textarea> <label ng-hide="vm.isLoading" class="character-countdown">{{2200 - form.positionOrientation.$viewValue.length}}</label> </td> </tr> <tr> <td> <label for="time-required" class="text-right middle"> <span class="bold">Time Required</span><span class="required text">*</span> </label> </td> <td> <textarea id="time-required" rows="3" ng-model="vm.position.timeRequired" required data-ng-disabled="vm.isLoading" ng-maxlength="2200" name="positionTimeRequired" class="vertical-resize-only"></textarea> <label ng-hide="vm.isLoading" class="character-countdown">{{2200 - form.positionTimeRequired.$viewValue.length}}</label> </td> </tr> <tr> <td> <label for="comment" class="text-right middle"> <span class="bold">Comment</span> </label> </td> <td> <textarea id="comment" rows="3" ng-model="vm.position.comment" data-ng-disabled="vm.isLoading" ng-maxlength="1100" name="positionComment" class="vertical-resize-only"></textarea> <label ng-hide="vm.isLoading" class="character-countdown">{{1100 - form.positionComment.$viewValue.length}}</label> </td> </tr> </tbody> <thead> <tr> <td colspan="2"> Address </td> </tr> </thead> <tbody> <tr> <td> <label for="address-country" class="text-right middle"> <span class="bold">Country</span><span class="required text">*</span> </label> </td> <td id="address-country"> <ui-select required data-ng-change="vm.onChangeCountry(vm.position.address.country)" data-ng-model="vm.position.address.country" data-ng-disabled="vm.isLoading"> <ui-select-match placeholder="Select a country or search..."> {{$select.selected}} </ui-select-match> <ui-select-choices repeat="country in vm.dropDowns.countries | filter:$select.search"> <span ng-bind-html="country | highlight: $select.search"></span> </ui-select-choices> </ui-select> </td> </tr> <tr> <td> <label for="address-line-1" class="text-right middle"> <span class="bold">Line 1</span><span class="required text">*</span> </label> </td> <td> <input id="address-line-1" type="text" ng-model="vm.position.address.line1" required data-ng-disabled="vm.isLoading"> </td> </tr> <tr> <td> <label for="address-line-2" class="text-right middle"> <span class="bold">Line 2</span> </label> </td> <td> <input id="address-line-2" type="text" ng-model="vm.position.address.line2" data-ng-disabled="vm.isLoading"> </td> </tr> <tr> <td> <label for="address-city" class="text-right middle"> <span class="bold">City</span><span class="required text">*</span> </label> </td> <td> <input id="address-city" type="text" ng-model="vm.position.address.city" required data-ng-disabled="vm.isLoading"> </td> </tr> <tr> <td> <label for="address-state" class="text-right middle"> <span class="bold">State</span><span ng-show="vm.isStateRequired" class="required text">*</span> </label> </td> <td id="address-state"> <ui-select data-ng-required="vm.isStateRequired" data-ng-model="vm.position.address.state" data-ng-disabled="!vm.isStateRequired || vm.isLoading"> <ui-select-match placeholder="Select a state or search..."> {{$select.selected}} </ui-select-match> <ui-select-choices repeat="state in vm.dropDowns.states | filter:$select.search"> <span ng-bind-html="state | highlight: $select.search"></span> </ui-select-choices> </ui-select> </td> </tr> <tr> <td> <label for="address-zip-code" class="text-right middle"> <span class="bold">Zip/Postal Code</span><span class="required text">*</span> </label> </td> <td> <input id="address-zip-code" type="text" ng-model="vm.position.address.zipCode" required data-ng-disabled="vm.isLoading"> </td> </tr> </tbody> <thead> <tr> <td colspan="2"> Supervisor </td> </tr> </thead> <tbody> <tr> <td> <label for="supervisor-1-name" class="text-right middle"> <span class="bold">Name</span><span class="required text">*</span> </label> </td> <td> <input id="supervisor-1-name" type="text" ng-model="vm.position.supervisor.name" required data-ng-disabled="vm.isLoading"> </td> </tr> <tr> <td> <label for="supervisor-1-email" class="text-right middle"> <span class="bold">Email</span> </label> </td> <td> <input id="supervisor-1-email" type="email" ng-model="vm.position.supervisor.email" data-ng-disabled="vm.isLoading"> </td> </tr> <tr> <td> <label for="supervisor-1-phone" class="text-right middle"> <span class="bold">Phone</span> </label> </td> <td> <input id="supervisor-1-phone" type="text" ng-model="vm.position.supervisor.phone" data-ng-disabled="vm.isLoading"> </td> </tr> </tbody> </table> <div class="row"> <div class="pull-right"> <button type="submit" class="dflt button" data-ng-disabled="form.$invalid || vm.isLoading"> Save </button> <button type="button" class="dflt button" ui-sref="vmis.volunteer.applications" data-ng-disabled="vm.isLoading"> Cancel </button> </div> </div> </form> ');
$templateCache.put('app/components/volunteer/opportunities/applicationConfirmation.template.html','<form name="form"> <modal close="vm.onDismiss" modal-title="Application Received"> <modal-body> Thank you, {{vm.name}}, for submitting an application for {{vm.positionTitle}}. </modal-body> <modal-footer> <button type="button" class="dflt button pull-right" ng-click="vm.onOk()">OK</button> </modal-footer> </modal> </form> ');
$templateCache.put('app/components/volunteer/opportunities/apply.view.html','<ul class="breadcrumbs"> <li><a ui-sref="vmis" ui-sref-opts="{reload:true}">VMIS</a></li> <li><a ui-sref="vmis.volunteer.opportunities">Volunteer Opportunities</a></li> <li> <span class="show-for-sr">Current: </span> Volunteer Application </li> </ul> <h1>Volunteer Application</h1> <alert ng-repeat="alert in vm.alerts" type="alert.type" close="vm.onCloseAlert($index)">{{alert.message}}</alert> <form name="form" class="form" ng-submit="vm.onSubmit()"> <table class="table information-table"> <thead> <tr> <th colspan="2">Position</th> </tr> </thead> <tbody> <tr> <td class="row-title"> <label class="control-label"> Title </label> </td> <td>{{vm.position.title}}</td> </tr> <tr> <td class="row-title"> <label class="control-label"> Organization </label> </td> <td>{{vm.position.organization}}</td> </tr> <tr> <td class="row-title"> <label class="control-label"> Community </label> </td> <td>{{vm.position.community}}</td> </tr> <tr> <td class="row-title"> <label class="control-label"> Background Check Required </label> </td> <td>{{vm.position.backgroundCheckRequired}}</td> </tr> </tbody> <thead> <tr> <th colspan="2">User Profile</th> </tr> </thead> <tbody> <tr> <td class="row-title"> <label class="control-label"> Name </label> </td> <td>{{vm.aosProfile.firstName}} {{vm.aosProfile.lastName}}</td> </tr> <tr> <td class="row-title"> <label class="control-label"> Community </label> </td> <td>{{vm.aosProfile.community}}</td> </tr> </tbody> <thead> <tr> <th colspan="2">Contact Information</th> </tr> </thead> <tbody> <tr> <td class="row-title"> <div class="input-group"> <label for="preferred-contact-method" class="text-right middle input-group-field"> <span class="bold">Preferred Contact Method</span><span class="required text">*</span> </label> </div> </td> <td id="preferred-contact-method"> <ui-select required ng-disabled="vm.isLoading" data-ng-model="vm.volunteerProfile.preferredContactMethod"> <ui-select-match placeholder="Select a contact method or search..."> {{$select.selected}} </ui-select-match> <ui-select-choices repeat="pcm in vm.preferredcontactmethod | filter:$select.search"> <span ng-bind-html="pcm | highlight: $select.search"></span> </ui-select-choices> </ui-select> </td> </tr> <tr> <td class="row-title"> <div class="input-group"> <label for="volunteer-email" class="text-right middle input-group-field"> <span class="bold">Volunteer Email</span><span class="required text">*</span> </label> </div> </td> <td> <input id="volunteer-email" type="email" ng-model="vm.volunteerProfile.volunteerEmail" required ng-disabled="vm.isLoading"> </td> </tr> <tr> <td class="row-title"> <div class="input-group"> <label for="primary-phone" class="text-right middle input-group-field"> <span class="bold">Primary Phone</span><span class="required text">*</span> </label> </div> </td> <td> <input id="primary-phone" type="text" ng-model="vm.volunteerProfile.primaryPhone" required ng-disabled="vm.isLoading"> </td> </tr> <tr> <td class="row-title"> <div class="input-group"> <label for="secondary-phone" class="bold text-right middle input-group-field"> Secondary Phone </label> </div> </td> <td> <input id="secondary-phone" type="text" ng-model="vm.volunteerProfile.secondaryPhone" ng-disabled="vm.isLoading"> </td> </tr> </tbody> <thead> <tr> <th colspan="2">Background</th> </tr> </thead> <tbody> <tr> <td class="row-title"> <label for="work-experience" class="control-label"> Work Experience </label> </td> <td> <textarea id="work-experience" rows="3" ng-model="vm.volunteerProfile.workExperience" ng-disabled="vm.isLoading" ng-maxlength="1000" name="workExperience" class="vertical-resize-only"></textarea> <label ng-hide="vm.isLoading" class="character-countdown">{{1000 - form.workExperience.$viewValue.length}}</label> </td> </tr> <tr> <td class="row-title"> <label for="volunteer-experience" class="control-label"> Volunteer Experience </label> </td> <td> <textarea id="volunteer-experience" rows="3" ng-model="vm.volunteerProfile.volunteerExperience" ng-disabled="vm.isLoading" ng-maxlength="1000" name="volunteerExperience" class="vertical-resize-only"></textarea> <label ng-hide="vm.isLoading" class="character-countdown">{{1000 - form.volunteerExperience.$viewValue.length}}</label> </td> </tr> <tr> <td class="row-title"> <label for="special-skills-interests-and-hobbies" class="control-label"> Special Skills, Interests, <br>and Hobbies </label> </td> <td> <textarea id="special-skills-interests-and-hobbies" rows="3" ng-model="vm.volunteerProfile.specialSIH" ng-disabled="vm.isLoading" ng-maxlength="1000" name="specialSkillsInterestsAndHobbies" class="vertical-resize-only"></textarea> <label ng-hide="vm.isLoading" class="character-countdown">{{1000 - form.specialSkillsInterestsAndHobbies.$viewValue.length}}</label> </td> </tr> </tbody> </table> <div class="row"> <div class="small-3 columns"> <label class="help-text text-right middle"> <span class="required text">*</span> Indicates a required field. </label> </div> <div class="small-9 columns"> <div class="pull-right"> <button type="submit" class="dflt button" data-ng-disabled="form.$invalid || vm.isLoading"> Apply </button> <button type="button" class="dflt button" ui-sref="vmis.volunteer.opportunities" data-ng-disabled="vm.isLoading"> Cancel </button> </div> </div> </div> </form>');
$templateCache.put('app/components/volunteer/opportunities/opportunities.view.html','<div ui-view> <ul class="breadcrumbs"> <li><a ui-sref="vmis" ui-sref-opts="{reload:true}">VMIS</a></li> <li> <span class="show-for-sr">Current: </span>Opportunities </li> </ul> <learn-about-this-page learn-title="About Opportunities Page" text-body="The Opportunities page allows you to search for and apply to many different volunteer opportunities within various communities and organizations. You can sort and filter opportunities, and you can browse opportunities without creating a VMIS account. For more information on how to use this page, please see section 5.0 in the VMIS Volunteer User Guide."></learn-about-this-page> <h1>Opportunities</h1> <alert ng-repeat="alert in vm.alerts" type="alert.type" close="vm.onCloseAlert($index)">{{alert.message}}</alert> <form> <div class="expanded row"> <form> <div class="small-11 columns"> <div class="input-group"> <div class="input-group-label icon-label"> <icon name="fa-search" class="icon-lg"></icon> </div> <label for="search" class="offscreen">Search by title</label> <input type="text" id="search" class="input-group-field" placeholder="Search by title" ng-model="vm.title"> <div class="input-group-button"> <button type="submit" class="dflt button" ng-disabled="vm.isLoading" ng-click="vm.onClickSearch()">Search</button> </div> </div> </div> </form> <div class="small-1 columns"> <button type="button" class="dflt button" ng-disabled="vm.isLoading" ng-click="vm.onFiltersClick()">Filters</button> </div> </div> </form> <retrieved-results is-loading="vm.isLoading" load-status="vm.loadStatus"></retrieved-results> <table class="table information-table table-hover"> <thead> <tr> <th ng-click="vm.sortColumn = \'title\'; vm.sortReverse = !vm.sortReverse"> <span ng-class="{unsorted: vm.sortColumn !== \'title\'}"> Title <icon ng-show="vm.sortColumn === \'title\'" name="{{vm.sortReverse ? \'fa-caret-down\' : \'fa-caret-up\'}}" class="icon-table-header" alt="Sorted by Title"></icon> </span> </th> <th ng-if="vm.isLoggedIn" ng-click="vm.sortColumn = \'applicationStatus\'; vm.sortReverse = !vm.sortReverse"> <span ng-class="{unsorted: vm.sortColumn !== \'applicationStatus\'}"> Application Status <icon ng-show="vm.sortColumn === \'applicationStatus\'" name="{{vm.sortReverse ? \'fa-caret-down\' : \'fa-caret-up\'}}" class="icon-table-header" alt="Sorted by Application Status"></icon> </span> </th> <th ng-click="vm.sortColumn = \'communityAffiliation\'; vm.sortReverse = !vm.sortReverse"> <span ng-class="{unsorted: vm.sortColumn !== \'communityAffiliation\'}"> Community <icon ng-show="vm.sortColumn === \'communityAffiliation\'" name="{{vm.sortReverse ? \'fa-caret-down\' : \'fa-caret-up\'}}" class="icon-table-header" alt="Sorted by Community"></icon> </span> </th> <th ng-click="vm.sortColumn = \'volunteerOrganization\'; vm.sortReverse = !vm.sortReverse"> <span ng-class="{unsorted: vm.sortColumn !== \'volunteerOrganization\'}"> Organization <icon ng-show="vm.sortColumn === \'volunteerOrganization\'" name="{{vm.sortReverse ? \'fa-caret-down\' : \'fa-caret-up\'}}" class="icon-table-header" alt="Sorted by Organization"></icon> </span> </th> <th ng-click="vm.sortColumn = \'city\'; vm.sortReverse = !vm.sortReverse"> <span ng-class="{unsorted: vm.sortColumn !== \'city\'}"> City <icon ng-show="vm.sortColumn === \'city\'" name="{{vm.sortReverse ? \'fa-caret-down\' : \'fa-caret-up\'}}" class="icon-table-header" alt="Sorted by City"></icon> </span> </th> <th ng-click="vm.sortColumn = \'region\'; vm.sortReverse = !vm.sortReverse"> <span ng-class="{unsorted: vm.sortColumn !== \'region\'}"> Region <icon ng-show="vm.sortColumn === \'region\'" name="{{vm.sortReverse ? \'fa-caret-down\' : \'fa-caret-up\'}}" class="icon-table-header" alt="Sorted by Region"></icon> </span> </th> <th ng-click="vm.sortColumn = \'postedDate\'; vm.sortReverse = !vm.sortReverse"> <span ng-class="{unsorted: vm.sortColumn !== \'postedDate\'}"> Date Posted <icon ng-show="vm.sortColumn === \'postedDate\'" name="{{vm.sortReverse ? \'fa-caret-down\' : \'fa-caret-up\'}}" class="icon-table-header" alt="Sorted by Date Posted"></icon> </span> </th> </tr> </thead> <tbody ng-hide="vm.isLoading"> <tr ng-repeat="row in (vm.filteredOpportunities = (vm.opportunities | orderBy:vm.sortColumn:vm.sortReverse))" ng-click="vm.onSelect(row)" ng-class-even="\'even\'" ng-class-odd="\'odd\'"> <td>{{ row.title }}</td> <td ng-if="vm.isLoggedIn">{{ row.applicationStatus }}</td> <td>{{ row.communityAffiliation }}</td> <td>{{ row.volunteerOrganization }}</td> <td>{{ row.city }}</td> <td>{{ row.region }}</td> <td>{{ row.postedDate | date: \'d MMM yyyy\' }}</td> </tr> <tr ng-if="vm.filteredOpportunities.length === 0"> <td colspan="7"> No data to display </td> </tr> </tbody> </table> <loading-icon show="vm.isLoading"></loading-icon> <load-more is-loading="vm.isLoading" load-status="vm.loadStatus" on-load-more="vm.onLoadMore()" on-load-all="vm.onLoadAll()"></load-more> </div> ');
$templateCache.put('app/components/volunteer/opportunities/opportunitiesFilter.template.html','<form ng-submit="vm.onSubmit()" name="form"> <modal close="$dismiss" modal-title="Filters"> <modal-body ng-hide="vm.isLoading"> <div ng-show="vm.formError" class="callout alert">{{vm.formError}}</div> <label for="community" class="control-label col-sm-2">Community</label> <ui-select required id="community" data-ng-change="vm.onSelectCommunity()" data-ng-model="vm.filters.community" data-ng-disabled="vm.isLoading"> <ui-select-match placeholder="Select a community or search..."> {{$select.selected.communityAffiliationName}} </ui-select-match> <ui-select-choices repeat="comm in vm.communities | propsFilter: {communityAffiliationName: $select.search}"> <span ng-bind-html="comm.communityAffiliationName | highlight: $select.search"></span> </ui-select-choices> </ui-select> <label for="organization-group" class="control-label col-sm-2">Organization Group</label> <ui-select required id="organization-group" data-ng-model="vm.filters.organizationGroup" data-ng-disabled="vm.isLoading"> <ui-select-match placeholder="Select an organization group or search..."> {{$select.selected}} </ui-select-match> <ui-select-choices repeat="orgGroup in vm.dropDowns.organizationGroups | filter:$select.search"> <span ng-bind-html="orgGroup | highlight: $select.search"></span> </ui-select-choices> </ui-select> <label for="organization" class="control-label col-sm-2">Organization</label> <ui-select required id="organization" data-ng-model="vm.filters.organization" data-ng-disabled="vm.disableOrgDropDown()"> <ui-select-match placeholder="Select an organization or search..."> {{$select.selected.organizationName}} </ui-select-match> <ui-select-choices repeat="org in vm.filters.community.organizations | propsFilter: {organizationName: $select.search}"> <span ng-bind-html="org.organizationName | highlight: $select.search"></span> </ui-select-choices> </ui-select> <label for="country" class="control-label col-sm-2">Country</label> <ui-select required id="country" data-ng-model="vm.filters.country" data-ng-change="vm.onSelectCountry(vm.filters.country)"> <ui-select-match placeholder="Select a country or search..."> {{$select.selected}} </ui-select-match> <ui-select-choices repeat="country in vm.dropDowns.countries | filter:$select.search"> <span ng-bind-html="country | highlight: $select.search"></span> </ui-select-choices> </ui-select> <label for="state-region" class="control-label col-sm-2">State</label> <ui-select required id="state-region" data-ng-model="vm.filters.state" data-ng-disabled="vm.isStateDisabled || vm.isLoading"> <ui-select-match placeholder="Select a state or search..."> {{$select.selected}} </ui-select-match> <ui-select-choices repeat="state in vm.dropDowns.states | filter:$select.search"> <span ng-bind-html="state | highlight: $select.search"></span> </ui-select-choices> </ui-select> <label for="postal-code" class="control-label col-sm-2">ZIP/Postal Code</label> <div class="col-sm-10"> <input type="text" id="postal-code" ng-model="vm.filters.postalCode"> </div> </modal-body> <modal-body ng-show="vm.isLoading"> <loading-icon show="vm.isLoading"></loading-icon> </modal-body> <modal-footer> <div class="float-right"> <button class="dflt button" type="submit">OK</button> <button class="dflt button" type="button" ng-click="vm.onCancel()">Cancel</button> </div> </modal-footer> </modal> </form>');
$templateCache.put('app/components/volunteer/opportunities/opportunityDetails.template.html','<form name="form" ng-submit="vm.onSubmit()"> <modal close="$dismiss" modal-title="{{vm.details.title}} - Details"> <modal-body> <table class="table information-table"> <tbody> <tr> <td class="row-title"> <label class="bold text-right"> Posted Date </label> </td> <td> <div>{{vm.details.postedDate | date:\'d MMMM yyyy\'}}</div> </td> </tr> <tr> <td> <label class="bold text-right"> Closed Date </label> </td> <td> <div>{{vm.details.closedDate | date:\'d MMMM yyyy\'}}</div> </td> </tr> <tr> <td> <label class="bold text-right"> Community </label> </td> <td> <div>{{vm.details.communityAffiliation}}</div> </td> </tr> <tr> <td> <label class="bold text-right"> Organization </label> </td> <td> <div>{{vm.details.volunteerOrganization}}</div> </td> </tr> <tr> <td> <label class="bold text-right"> Position Type </label> </td> <td> <div>{{vm.details.volunteerPositionType}}</div> </td> </tr> <tr> <td> <label class="bold text-right"> Opportunity Type </label> </td> <td> <div>{{vm.details.volunteerOpportunityType}}</div> </td> </tr> <tr> <td> <label class="bold text-right"> Background Check Required </label> </td> <td> <div>{{vm.details.isBackgroundCheckRequired}}</div> </td> </tr> <tr> <td> <label class="bold text-right"> Supervision Required </label> </td> <td> <div>{{vm.details.supervisionConditionFlag}}</div> </td> </tr> <tr> <td> <label class="bold text-right"> Duties </label> </td> <td> <div class="angular-with-newlines">{{vm.details.duties}}</div> </td> </tr> <tr> <td> <label class="bold text-right"> Qualifications </label> </td> <td> <div>{{vm.details.qualifications}}</div> </td> </tr> <tr> <td> <label class="bold text-right"> Training </label> </td> <td> <div>{{vm.details.training}}</div> </td> </tr> <tr> <td> <label class="bold text-right"> Orientation </label> </td> <td> <div>{{vm.details.orientation}}</div> </td> </tr> <tr> <td> <label class="bold text-right"> Time Required </label> </td> <td> <div>{{vm.details.timeRequired}}</div> </td> </tr> <tr> <td> <label class="bold text-right"> Evaluation </label> </td> <td> <div>{{vm.details.evaluation}}</div> </td> </tr> <tr> <td> <label class="bold text-right"> Benefits </label> </td> <td> <div>{{vm.details.benefits}}</div> </td> </tr> <tr> <td> <label class="bold text-right"> Address </label> </td> <td> {{vm.details.address1}}<br ng-show="vm.details.address2"> {{vm.details.address2}}<br> {{vm.details.city}}<span ng-show="vm.details.city">,</span> {{vm.details.usState}} {{vm.details.zipCode}}<br> {{vm.details.country}} </td> </tr> <tr> <td> <label class="bold text-right"> Supervisor 1 </label> </td> <td> <div>{{vm.details.firstLineSupervisorName}}</div> <div>{{vm.details.firstLineSupervisorPhone}}</div> <div>{{vm.details.firstLineSupervisorEmail}}</div> </td> </tr> <tr> <td> <label class="bold text-right"> Supervisor 2 </label> </td> <td> <div>{{vm.details.secondLineSupervisorName}}</div> <div>{{vm.details.secondLineSupervisorPhone}}</div> <div>{{vm.details.secondLineSupervisorEmail}}</div> </td> </tr> <tr style="vertical-align: text-top"> <td> <label class="bold text-right"> OPOCs </label> </td> <td> <div ng-repeat="opoc in vm.opocs"> <br ng-if="!$first"> <div>{{opoc.firstName}} {{opoc.lastName}}</div> <div> <a ng-href="mailto:{{opoc.email}}" target="_self"> {{opoc.email}} </a> </div> <div>{{opoc.phone}}</div> </div> </td> </tr> </tbody> </table> </modal-body> <modal-footer> <div class="float-left hyperlink-button-div"> <a class="bold" ng-click="vm.onPrint()">Print</a> </div> <button type="button" class="dflt button float-right margin-left-5" ng-click="vm.closeModal()"> Cancel </button> <div ng-if="vm.details.opportunityStatus !== \'Closed\'" class="float-right"> <label ng-if="vm.details.userHasApplied" class="middle" style="margin-bottom: 0;"> Already Applied </label> <button ng-if="!vm.details.userHasApplied" class="dflt button" style="margin-bottom: 0;"> Apply </button> </div> </modal-footer> </modal> </form>');
$templateCache.put('app/components/volunteer/records/records.view.html','<ul class="breadcrumbs"> <li><a ui-sref="vmis" ui-sref-opts="{reload:true}">VMIS</a></li> <li> <span class="show-for-sr">Current: </span> Records </li> </ul> <learn-about-this-page learn-title="About Records Page" text-body="The Records page allows volunteers to document any awards, trainings, or orientations they have completed, as well as the certification status for any of these items. This page also stores any background checks and documents about the volunteer . Only an OPOC or AVCC can add background checks and documents. You can view these records, but you cannot edit or delete them. If you want to add documentation to these sections, contact your OPOC or AVCC.\nNote that awards, trainings, and certifications can only be deleted or modified if they have not yet been certified.\nFor more information on how to use this page, please see section 6.0 of the VMIS Volunteer User Guide."></learn-about-this-page> <div ng-hide="vm.isLoading"> <h1>Records<span ng-if="vm.adminEditing"> - {{vm.fullName}}</span></h1> <alert ng-repeat="alert in vm.alerts" type="alert.type" close="vm.onCloseAlert($index)">{{alert.message}}</alert> <div ui-view="awards"></div> <div ui-view="trainings"></div> <div ui-view="orientations"></div> <div ui-view="notes"></div> <div ui-view="backgroundChecks"></div> <div ui-view="documents"></div> </div> <loading-icon show="vm.isLoading" push-down="true"></loading-icon>');
$templateCache.put('app/components/volunteer/serviceHistory/view.html','<ul class="breadcrumbs"> <li><a ui-sref="vmis" ui-sref-opts="{reload:true}">VMIS</a></li> <li> <span class="show-for-sr">Current: </span>Service History </li> </ul> <learn-about-this-page learn-title="About Service History Page" text-body="The Service History page provides a high-level summary of volunteer hours broken down by position and a total number of your certified hours for the current year. Information found on this page is based on certified volunteer hours only. For more information on how to use this page, please see section 7.0 of the VMIS Volunteer User Guide.\nFor the DA 4162 Form, the following data is included for only AVC and Private Organization positions:\n- the 7 most recent certified awards,\n- the 7 most recent certified trainings,\n- the 7 most recent positions, which are determined by the most recent date of certified hours.\nFor the DA 4713 Form, only certified daily hours from AVC and Private Organization positions are included."></learn-about-this-page> <alert ng-repeat="alert in vm.alerts" type="alert.type" close="vm.onCloseAlert($index)">{{alert.message}}</alert> <h1>Service History<span ng-if="vm.volunteer"> - {{vm.volunteer.firstName}} {{vm.volunteer.lastName}}</span></h1> <div ui-view="avcPositions"></div> <div ui-view="nonAVCPositions"></div> <div ui-view="annualHoursRecord"></div> <div class="expanded row"> <div class="float-right"> <button type="button" class="dflt button" ng-click="vm.generateDA4713()" ng-disabled="vm.isLoading">Download DA 4713</button> <button type="button" class="dflt button" ng-click="vm.generateDA4162()" ng-disabled="vm.isLoading">Download DA 4162</button> </div> </div> <loading-icon show="vm.isLoading"></loading-icon> ');
$templateCache.put('app/components/volunteer/serviceLog/addToPosition.view.html','<form name="form" ng-submit="vm.onSubmit()"> <modal close="$dismiss" modal-title="{{vm.title}}"> <modal-body> <loading-icon show="vm.isLoading"></loading-icon> <div ng-show="vm.formError" class="callout alert">{{vm.formError}}</div> <div class="row" ng-hide="vm.isLoading"> <div class="small-11 small-centered columns"> <label> <span class="bold">Community</span><span class="required text">*</span> <ui-select id="select-community-position" required data-ng-change="vm.onSelectCommunity()" data-ng-model="vm.selectedCommunity"> <ui-select-match placeholder="Select a community or search..."> {{$select.selected.communityAffiliationName}} </ui-select-match> <ui-select-choices repeat="comm in vm.communities | propsFilter: {communityAffiliationName: $select.search}"> <span ng-bind-html="comm.communityAffiliationName | highlight: $select.search"></span> </ui-select-choices> </ui-select> </label> <label> <span class="bold">Organization</span><span class="required text">*</span> <ui-select id="select-organization-position" required data-ng-change="vm.onSelectOrganization()" data-ng-model="vm.selectedOrganization"> <ui-select-match placeholder="Select an organization or search..."> {{$select.selected.volunteerOrganizationName}} </ui-select-match> <ui-select-choices repeat="org in vm.selectedCommunity.organizations | propsFilter: {volunteerOrganizationName: $select.search}"> <span ng-bind-html="org.volunteerOrganizationName | highlight: $select.search"></span> </ui-select-choices> </ui-select> </label> <label> <span class="bold">Position</span><span class="required text">*</span> <ui-select id="select-position" required data-ng-model="vm.selectedPosition"> <ui-select-match placeholder="Select a position or search..."> {{$select.selected.title}} </ui-select-match> <ui-select-choices repeat="pos in vm.selectedOrganization.positions | propsFilter: {title: $select.search}"> <span ng-bind-html="pos.title | highlight: $select.search"></span> </ui-select-choices> </ui-select> </label> <label class="help-text"> <span class="required text">*</span> Indicates a required field. </label> </div> </div> </modal-body> <modal-footer> <div class="float-right"> <button id="confirm-add-to-position" type="submit" class="dflt button" data-ng-disabled="form.$invalid || vm.isLoading"> Add To Position </button> <button type="button" class="dflt button" ng-click="$dismiss(\'cancel\')" ng-disabled="vm.isLoading"> Cancel </button> </div> </modal-footer> </modal> </form>');
$templateCache.put('app/components/volunteer/serviceLog/serviceLog.view.html','<ul class="breadcrumbs"> <li><a ui-sref="vmis" ui-sref-opts="{reload:true}">VMIS</a></li> <li> <span class="show-for-sr">Current: </span>Service Log </li> </ul> <learn-about-this-page learn-title="About Service Log Page" text-body="The Service Log provides a way to log volunteer hours and a calendar view for each volunteer position. Hours can be logged by the day (daily hours) or in bulk for the month (period hours), and you can add notes or attachments related to those hours.\nThe Service Log can also be used to view volunteer hours for positions with Active, Finished, Blocked, No Background Check, or Inactive statuses. For more information on how to use this page, please see section 3.0 of the VMIS Volunteer User Guide."></learn-about-this-page> <div ng-hide="vm.isLoading"> <h1>Service Log<span ng-if="vm.adminEditing"> - {{vm.targetUser.firstName}} {{vm.targetUser.lastName}}</span></h1> <div role="alert" ng-show="vm.posClosed" class="callout alert">{{vm.posClosed}}</div> <div role="alert" ng-show="vm.formError" class="callout alert">{{vm.formError}}</div> <div role="alert" ng-show="vm.formSuccess" class="callout success">{{vm.formSuccess}}</div> <div class="expanded row"> <div style="padding-left:0;" class="small-3 columns"> <label>Service Status</label> </div> <div style="padding-right:0;" class="small-9 columns"> <div class="small-12 columns"> <label>Position</label> </div> </div> </div> <div class="expanded row"> <div style="padding-left: 0;" class="small-3 columns"> <ui-select required data-ng-change="vm.reloadPositions()" data-ng-model="vm.serviceStatus"> <ui-select-match placeholder="Select a status or search..."> {{$select.selected.name}} </ui-select-match> <ui-select-choices repeat="s.value as s in vm.serviceStatuses | filter:$select.search"> <span ng-bind-html="s.name | highlight: $select.search"></span> </ui-select-choices> </ui-select> </div> <div style="padding-right:0;" class="small-9 columns"> <div class="columns" style="padding-right:0;" ng-class="{\'small-9\': (vm.adminEditing && !vm.isOnlyAVCCAssistant),\n                            \'small-12\': (!vm.adminEditing || vm.isOnlyAVCCAssistant)}"> <ui-select data-ng-change="vm.onChangePosition(vm.position)" data-ng-model="vm.position" data-ng-disabled="vm.isLoading || vm.positions.length < 1"> <ui-select-match placeholder="Select a position or search..."> {{$select.selected.title}} </ui-select-match> <ui-select-choices repeat="position in vm.positions | propsFilter: {title: $select.search}"> <span ng-bind-html="position.title | highlight: $select.search"></span> </ui-select-choices> </ui-select> </div> <div class="small-3 columns" ng-if="(vm.adminEditing && !vm.isOnlyAVCCAssistant)"> <button id="add-to-position" type="button" class="dflt button expanded" ng-click="vm.onClickAddPosition()"> Add To Position </button> </div> </div> </div> <div class="row service-log-calendar-spacing"> <div class="small-3 columns text-center"> <label ng-if="vm.position"> Period Hours: <span data-ng-disabled="vm.isLoading"> <a ng-if="vm.periodActivity || vm.isInFiscalYear() || !vm.disabled" ng-click="vm.onShowPeriodHoursModal()">{{(vm.periodActivity.hours || 0) | number:2}}</a> <span ng-if="!(vm.periodActivity || vm.isInFiscalYear() || !vm.disabled)">0.00</span> </span> <span class="clickable" data-ng-disabled="vm.isLoading" ng-click="vm.onShowPeriodHoursModal()" ng-if="vm.periodActivity"> <vmis-hours-status status="vm.periodActivity.status" class="period-hours-status"></vmis-hours-status> </span> <span class="clickable" data-ng-disabled="vm.isLoading" ng-click="vm.onShowPeriodHoursModal()" ng-if="(vm.periodActivity.status === \'Submitted\') || (!vm.periodActivity && vm.isInFiscalYear())"> <icon name="fa-pencil" class="icon-service-log-period" ng-if="(vm.periodActivity.status === \'Submitted\') && (!vm.disabled && vm.isInFiscalYear())" alt="Select this pencil to edit the period hours"></icon> <icon name="fa-info-circle" class="icon-service-log-period" ng-if="(vm.periodActivity.status === \'Submitted\') && !vm.isInFiscalYear()" alt="Period hours submitted"></icon> <icon name="fa-plus" class="icon-service-log-period" ng-if="!vm.periodActivity && vm.isInFiscalYear()" alt="Select this icon to add period hours"></icon> </span> </label> <label ng-if="!vm.position">Period Hours: 0.00</label> </div> <div class="small-3 columns text-center"> <label>Certified Hours: {{vm.certifiedHours | number:2}}</label> </div> <div class="small-3 columns text-center"> <label>Submitted Hours: {{vm.submittedHours | number:2}}</label> </div> <div class="small-3 columns text-center"> <label>Rejected Hours: {{vm.rejectedHours | number:2}}</label> </div> </div> <calendar position="vm.position" reload="vm.reloadCalendar" disabled="vm.disabled" target-user="vm.targetUser" admin-editing="vm.adminEditing" on-load-activities="vm.onLoadActivities(year, month, dailyActivities, periodActivities)"></calendar> </div> <loading-icon show="vm.isLoading" push-down="true"></loading-icon> ');
$templateCache.put('app/components/administrator/invitations/acceptInviteTemplates/coordinator.view.html','<p>You have been invited through the Army Volunteer Corps (AVC) to register as a Coordinator for the following communities:</p> <ul> <li ng-repeat="community in vm.communities">{{community}}</li> </ul>');
$templateCache.put('app/components/administrator/invitations/acceptInviteTemplates/opoc.view.html','<p>You have been invited through the Army Volunteer Corps (AVC) to register as an Organization Point-of-Contact(OPOC) at {{vm.community}} for the following organization(s):</p> <ul> <li ng-repeat="organization in vm.organizations">{{organization}}</li> </ul> ');
$templateCache.put('app/components/administrator/invitations/acceptInviteTemplates/regionManager.view.html','<p>You have been invited through the Army Volunteer Corps (AVC) to register as a Region Manager for the following communities:</p> <ul> <li ng-repeat="community in vm.communities">{{community}}</li> </ul>');
$templateCache.put('app/components/administrator/people/actionDirectives/commFilter.view.html','<form name="form"> <modal close="$dismiss" modal-title="Filter People"> <modal-body> <div class="row"> <div class="small-11 small-centered columns"> <p class="help-text"> Note: Table will reload when a new filter is applied. </p> <label> <span class="bold">Communities of Responsibility</span> <ui-select id="select-community-vol" multiple="multiple" role="listbox" on-select="vm.onSelectCommunity($item, $model)" data-ng-model="vm.filter.selectedCommunities" data-ng-disabled="vm.isLoading"> <ui-select-match placeholder="Select a community or search..." ui-lock-choice="$item.readOnly"> <span ng-class="{\'italic\': $item.readOnly}">{{$item.communityAffiliationName}}</span> </ui-select-match> <ui-select-choices repeat="comm in vm.filter.communities | propsFilter: {communityAffiliationName: $select.search}"> <span ng-bind-html="comm.communityAffiliationName | highlight: $select.search"></span> </ui-select-choices> </ui-select> </label> <label> <span class="input-group"> <span tooltip-html-unsafe="Work Email must be an exact match." tooltip-popup-delay="1000" class="bold has-tip">Work Email</span> <input type="email" id="workEmail" class="input-group-field" placeholder="Work Email" ng-model="vm.filter.workEmail"> </span> </label> <label for="loggedInSince"> <span tooltip-html-unsafe="Find all users who have logged in since a particular date.<br>For example, find all users who have logged in since January 1, 2016." tooltip-popup-delay="1000" class="bold has-tip"> Have logged in since </span> <span class="input-group"> <input type="text" id="loggedInSince" class="input-group-field" ng-model="vm.filter.startDate" placeholder="MM/DD/YYYY" data-ng-disabled="vm.isLoading" vmis-datepicker target="start-date" format="M/D/YYYY" end-date="vm.filter.endDate || vm.currentDate"> <span class="input-group-button"> <button id="start-date" type="button" class="dflt button icon-button" aria-label="Have logged in since" data-ng-disabled="vm.isLoading"> <icon name="fa-calendar" class="icon-big"></icon> </button> </span> </span> </label> <label for="notLoggedIn"> <span tooltip-html-unsafe="Find all users who have not logged in since a particular date.<br>For example, find all users who have not logged in since January 1, 2016." tooltip-popup-delay="1000" class="bold has-tip"> Have not logged in since </span> <span class="input-group"> <input type="text" id="notLoggedIn" class="input-group-field" ng-model="vm.filter.endDate" placeholder="MM/DD/YYYY" data-ng-disabled="vm.isLoading" vmis-datepicker target="end-date" format="M/D/YYYY" start-date="vm.filter.startDate" end-date="vm.currentDate"> <span class="input-group-button"> <button id="end-date" type="button" class="dflt button icon-button" aria-label="Have not logged in since" data-ng-disabled="vm.isLoading"> <icon name="fa-calendar" class="icon-big"></icon> </button> </span> </span> </label> </div> </div> <div class="empty-space-small"></div> </modal-body> <modal-footer> <div class="pull-right"> <button type="submit" class="dflt button" ng-click="vm.onFilter()" data-ng-disabled="form.$invalid || vm.isLoading"> Filter </button> <button type="button" class="dflt button" aria-label="Clear" ng-click="vm.onClear()" ng-disabled="vm.isLoading"> Clear </button> <button type="button" class="dflt button" ng-click="$dismiss(\'cancel\')" ng-disabled="vm.isLoading"> Cancel </button> </div> </modal-footer> </modal> </form>');
$templateCache.put('app/components/administrator/people/actionDirectives/confirmAvccAssistReplace.view.html','<form name="form" ng-submit="$close()"> <modal close="$dismiss" modal-title="{{vm.title}}"> <modal-body> <div class="row"> <div class="small-11 small-centered columns"> {{vm.name}} is an AVCC Assistant. To make them an AVCC of <span class="bold">{{vm.avccResponsibilities}}</span>, their Assistant role in <span class="bold">{{vm.avccAssistantResponsibilities}}</span> will be removed. Are you sure? </div> </div> </modal-body> <modal-footer> <div class="pull-right"> <button type="button" class="dflt button" ng-click="vm.onAccept()">Replace</button> <button type="button" class="dflt button" ng-click="$dismiss()">Cancel</button> </div> </modal-footer> </modal> </form> ');
$templateCache.put('app/components/administrator/people/actionDirectives/confirmRoleRemove.view.html','<form name="form" ng-submit="$close()"> <modal close="$dismiss" modal-title="{{vm.title}}"> <modal-body> <div class="row"> <div class="small-11 small-centered columns"> Are you sure you want to remove the {{vm.role}} role from {{vm.name}}? </div> </div> </modal-body> <modal-footer> <div class="pull-right"> <button type="button" class="dflt button" ng-click="vm.onAccept()">Remove</button> <button type="button" class="dflt button" ng-click="$dismiss()">Cancel</button> </div> </modal-footer> </modal> </form> ');
$templateCache.put('app/components/administrator/people/actionDirectives/dateFilter.view.html','<form name="form"> <modal close="$dismiss" modal-title="Filter People"> <modal-body> <div class="row"> <div class="small-11 small-centered columns"> <p class="help-text"> Note: Table will reload when a new filter is applied. </p> <label> <span class="input-group"> <span tooltip-html-unsafe="Work Email must be an exact match." tooltip-popup-delay="1000" class="bold has-tip">Work Email</span> <input type="email" id="workEmail" class="input-group-field" placeholder="Work Email" ng-model="vm.filter.workEmail"> </span> </label> <label for="haveLoggedIn"> <span tooltip-html-unsafe="Find all users who have logged in since a particular date.<br>For example, find all users who have logged in since January 1, 2016." tooltip-popup-delay="1000" class="bold has-tip"> Have logged in since </span> <span class="input-group"> <input type="text" id="haveLoggedIn" class="input-group-field" ng-model="vm.filter.startDate" placeholder="MM/DD/YYYY" data-ng-disabled="vm.isLoading" vmis-datepicker target="start-date" format="M/D/YYYY" end-date="vm.filter.endDate || vm.currentDate"> <span class="input-group-button"> <button id="start-date" type="button" class="dflt button icon-button" aria-label="Have logged in since" data-ng-disabled="vm.isLoading"> <icon name="fa-calendar" class="icon-big"></icon> </button> </span> </span> </label> <label for="haveNotLoggedIn"> <span tooltip-html-unsafe="Find all users who have not logged in since a particular date.<br>For example, find all users who have not logged in since January 1, 2016." tooltip-popup-delay="1000" class="bold has-tip"> Have not logged in since </span> <span class="input-group"> <input type="text" id="haveNotLoggedIn" class="input-group-field" ng-model="vm.filter.endDate" placeholder="MM/DD/YYYY" data-ng-disabled="vm.isLoading" vmis-datepicker target="end-date" format="M/D/YYYY" start-date="vm.filter.startDate" end-date="vm.currentDate"> <span class="input-group-button"> <button id="end-date" type="button" class="dflt button icon-button" aria-label="Have not logged in since" data-ng-disabled="vm.isLoading"> <icon name="fa-calendar" class="icon-big"></icon> </button> </span> </span> </label> </div> </div> </modal-body> <modal-footer> <div class="pull-right"> <button type="submit" class="dflt button" ng-click="vm.onFilter()" data-ng-disabled="form.$invalid || vm.isLoading"> Filter </button> <button type="button" class="dflt button" aria-label="Clear" ng-click="vm.onClear()" ng-disabled="vm.isLoading"> Clear </button> <button type="button" class="dflt button" ng-click="$dismiss(\'cancel\')" ng-disabled="vm.isLoading"> Cancel </button> </div> </modal-footer> </modal> </form>');
$templateCache.put('app/components/administrator/people/actionDirectives/massEmail.view.html','<form name="form"> <modal close="$dismiss" modal-title="Compose Mass Email"> <modal-body> <div ng-show="vm.formError" class="callout alert">{{vm.formError}}</div> <div class="row"> <div class="small-11 small-centered columns"> <label for="subject"> <span class="bold">Subject</span><span class="required text">*</span> <input type="text" id="subject" data-ng-model="vm.subject" data-ng-disabled="vm.isLoading" required> </label> <label> <span class="bold">Message</span><span class="required text">*</span> <textarea rows="3" data-ng-model="vm.body" data-ng-disabled="vm.isLoading" required></textarea> </label> <p class="help-text"> <span class="required text">*</span> Indicates a required field. </p> <hr> <label for="modal-attachments" class="bold">Attachments</label> <div class="small-9 columns"> <upload-document-list id="modal-attachments" selected-documents="vm.selectedFiles" on-delete-selected-doc="vm.onDeleteSelectedDoc" show-upload-instructions="true" show-delete="true" disable-delete="vm.isLoading"> </upload-document-list> </div> <div class="small-3 columns"> <button type="button" id="upload-attachment-btn" class="dflt button expanded icon-button" multiple="multiple" ngf-select="vm.onSelectFile($files, $invalidFiles); form.$setDirty()" ngf-max-size="{{vm.maxFileSizeInMegabytes}}" accept="{{vm.allowedFileTypesForUpload}}" ngf-pattern="{{vm.allowedFileTypesForUpload}}" ng-disabled="vm.isLoading || vm.maxFilesUploaded" tooltip-popup-delay="1000" tooltip-html-unsafe="Only files with the extensions {{vm.allowedFileTypesForUpload}}<br>with total combined size under {{vm.maxFileSizeInMegabytes}} will be accepted."> <icon name="fa-paperclip" class="icon-big" aria-hidden="true" ng-hide="vm.isFileUploading" alt="Select this paperclip to attach a document"></icon> <loading-icon show="vm.isFileUploading" little="true"></loading-icon> </button> </div> <hr> <span class="bold">Sending To</span> </div> </div> <div class="row"> <div class="item-list small-11 small-centered columns"> <div class="row" ng-repeat="email in vm.emails" ng-if="$even"> <div class="small-6 columns"> <label class="overflow-ellipsis"> {{email}} </label> </div> <div class="small-6 columns" ng-if="vm.emails[$index+1]"> <label class="overflow-ellipsis"> {{vm.emails[$index+1]}} </label> </div> </div> </div> </div> </modal-body> <modal-footer> <div class="pull-right"> <button type="submit" class="dflt button" ng-click="vm.onSend()" data-ng-disabled="form.$invalid || vm.isLoading"> Send </button> <button type="button" class="dflt button" ng-click="$dismiss(\'cancel\')" data-ng-disabled="vm.isLoading"> Cancel </button> </div> </modal-footer> </modal> </form>');
$templateCache.put('app/components/administrator/people/actionDirectives/orgCommFilter.view.html','<form name="form"> <modal close="$dismiss" modal-title="Filter People"> <modal-body> <div class="row"> <div class="small-11 small-centered columns"> <p class="help-text"> Note: Table will reload when a new filter is applied. </p> <label> <span tooltip="{{vm.disableCommunity() ? \'Community cannot be changed when selecting organizations.\' : \'\'}}" tooltip-popup-delay="1000" class="bold" ng-class="{\'has-tip\': vm.disableCommunity()}">Community</span> <ui-select id="select-community-vol-for-org" data-ng-change="vm.onSelectCommunity()" data-ng-model="vm.filter.selectedCommunity" data-ng-disabled="vm.isLoading || vm.filter.selectedOrganizations.length>0"> <ui-select-match placeholder="Select a community or search..."> {{$select.selected.communityAffiliationName}} </ui-select-match> <ui-select-choices repeat="comm in vm.filter.communities | propsFilter: {communityAffiliationName: $select.search}"> <span ng-bind-html="comm.communityAffiliationName | highlight: $select.search"></span> </ui-select-choices> </ui-select> </label> <label> <span tooltip="{{vm.disableOrgDropDown() ? \'You must select a Community in order to select an Organization.\' : \'\'}}" tooltip-popup-delay="1000" class="bold" ng-class="{\'has-tip\': vm.disableOrgDropDown()}">{{vm.organizationText}}</span> <ui-select id="select-organization-vol" multiple="multiple" role="listbox" data-ng-model="vm.filter.selectedOrganizations" on-select="vm.onSelectOrg($item, $model)" close-on-select="false" data-ng-disabled="vm.disableOrgDropDown()"> <ui-select-match placeholder="Select an organization or search..." ui-lock-choice="$item.readOnly"> <span ng-class="{\'italic\': $item.readOnly}">{{$item.organizationName}}</span> </ui-select-match> <ui-select-choices repeat="org in vm.filter.selectedCommunity.organizations | propsFilter: {organizationName: $select.search}" position="down"> <span ng-bind-html="org.organizationName | highlight: $select.search"></span> </ui-select-choices> </ui-select> </label> <label> <span class="input-group"> <span tooltip-html-unsafe="{{vm.searchEmailText}} must be an exact match." tooltip-popup-delay="1000" class="bold has-tip">{{vm.searchEmailText}}</span> <input ng-if="!vm.filteringVol" type="email" id="workEmail" class="input-group-field" placeholder="Work Email" ng-model="vm.filter.workEmail"> <input ng-if="vm.filteringVol" type="email" id="volunteerEmail" class="input-group-field" placeholder="Volunteer Email" ng-model="vm.filter.volunteerEmail"> </span> </label> <label ng-if="vm.filteringVol"> <span class="bold">Activity</span> <ui-select id="select-activity-vol" data-ng-model="vm.filter.isActive" data-ng-disabled="vm.isLoading"> <ui-select-match placeholder="Select an activity or search..."> {{$select.selected.name}} </ui-select-match> <ui-select-choices repeat="activity in vm.filter.activities | propsFilter: {name: $select.search}"> <span ng-bind-html="activity.name | highlight: $select.search"></span> </ui-select-choices> </ui-select> </label> <label for="haveLoggedIn"> <span tooltip-html-unsafe="Find all users who have logged in since a particular date.<br>For example, find all users who have logged in since January 1, 2016." tooltip-popup-delay="1000" class="bold has-tip"> Have logged in since </span> <span class="input-group"> <input type="text" id="haveLoggedIn" class="input-group-field" ng-model="vm.filter.startDate" placeholder="MM/DD/YYYY" data-ng-disabled="vm.isLoading" vmis-datepicker target="start-date" format="M/D/YYYY" end-date="vm.filter.endDate || vm.currentDate"> <span class="input-group-button"> <button id="start-date" type="button" class="dflt button icon-button" aria-label="Have logged in since" data-ng-disabled="vm.isLoading"> <icon name="fa-calendar" class="icon-big"></icon> </button> </span> </span> </label> <label for="haveNotLoggedIn"> <span tooltip-html-unsafe="Find all users who have not logged in since a particular date.<br>For example, find all users who have not logged in since January 1, 2016." tooltip-popup-delay="1000" class="bold has-tip"> Have not logged in since </span> <span class="input-group"> <input type="text" id="haveNotLoggedIn" class="input-group-field" ng-model="vm.filter.endDate" placeholder="MM/DD/YYYY" data-ng-disabled="vm.isLoading" vmis-datepicker target="end-date" format="M/D/YYYY" start-date="vm.filter.startDate" end-date="vm.currentDate"> <span class="input-group-button"> <button id="end-date" type="button" class="dflt button icon-button" aria-label="Have not logged in since" data-ng-disabled="vm.isLoading"> <icon name="fa-calendar" class="icon-big"></icon> </button> </span> </span> </label> <label ng-if="vm.filteringVol"> <span class="input-group"> <span tooltip-html-unsafe="Selecting the user number you want to start looking from, if you returned 1000 results and want to see the 900th user return then enter 900, if a value is entered here and no Number of Rows is entered a default is used for Number of Rows ({{vm.defaultNumRows}}). Entering a value here will disable the load more/load all features" tooltip-popup-delay="1000" class="bold has-tip">Starting Row Index</span> <input type="number" id="startingRowIndex" class="input-group-field" placeholder="Starting Row Index" min="{{vm.defaultStartingIndex}}" ng-model="vm.filter.startingRowIndex"> </span> </label> <label ng-if="vm.filteringVol"> <span class="input-group"> <span tooltip-html-unsafe="Entering the total number of users you want to see up to the maximum allowed of ({{vm.maxNumRows}}), if a value is entered here and no starting row index is entered a default is used for Starting Row Index: ({{vm.defaultStartingIndex}}). Entering a value here will disable the load more/load all features" tooltip-popup-delay="1000" class="bold has-tip">Number of Rows</span> <input type="number" id="numberOfRows" class="input-group-field" placeholder="Number of Rows" min="1" max="{{vm.maxNumRows}}" ng-model="vm.filter.numberOfRows"> </span> </label> </div> </div> </modal-body> <modal-footer> <div class="pull-right"> <button type="submit" class="dflt button" ng-click="vm.onFilter()" data-ng-disabled="form.$invalid || vm.isLoading"> Filter </button> <button type="button" class="dflt button" aria-label="Clear" ng-click="vm.onClear()" ng-disabled="vm.isLoading"> Clear </button> <button type="button" class="dflt button" ng-click="$dismiss(\'cancel\')" ng-disabled="vm.isLoading"> Cancel </button> </div> </modal-footer> </modal> </form>');
$templateCache.put('app/components/administrator/people/coordinatorAssistants/coordinatorAssistants.view.html','<div class="expanded row"> <div class="small-offset-6 small-6 columns right-align-contents"> <button type="button" class="dflt button" data-ng-disabled="vm.isLoading" ng-click="vm.onClickFilterUsers()" disabled="disabled"> Filter People </button> <button type="button" class="dflt button" ng-if="!vm.isPMAndNotAVCC" data-ng-disabled="vm.isLoading" ng-click="vm.onClickAddNewAVCCAssistant()" disabled="disabled"> Add New AVCC Assistant </button> </div> </div> <div class="expanded row"> <div class="small-3 columns"> <label for="select-role"> Filter by Role </label> </div> <div class="small-6 columns"> <label id="searchPeople" hidden>Search for person</label> </div> <div class="small-3 columns"> <div class="row"> <label for="bulk-action"> Bulk Action ({{vm.numUsersSelected}}) </label> </div> </div> </div> <div class="expanded row"> <div class="small-3 columns"> <ui-select id="select-role" data-ng-change="vm.onSelectRole()" data-ng-model="vm.selectedRoleObject" data-ng-disabled="vm.isLoading"> <ui-select-match placeholder="Select a role or search..."> {{$select.selected.name}} </ui-select-match> <ui-select-choices repeat="role in vm.roleObjectList | propsFilter: {name: $select.search, shortName: $select.search}"> <span ng-bind-html="role.name | highlight: $select.search"></span> </ui-select-choices> </ui-select> </div> <form> <div class="small-6 columns"> <div class="input-group"> <div class="input-group-label icon-label"> <icon name="fa-search" class="icon-lg"></icon> </div> <label for="lastName" class="offscreen">Last Name</label> <input type="text" id="lastName" aria-label="Last name" class="input-group-field" placeholder="Last name" ng-model="vm.filter.lastName"> <span class="input-group-glue"></span> <label for="firstName" class="offscreen">First Name</label> <input type="text" id="firstName" aria-label="First name" class="input-group-field" placeholder="First name" ng-model="vm.filter.firstName"> <div class="input-group-button"> <button type="submit" class="dflt button" ng-disabled="vm.isLoading" ng-click="vm.onClickSearch()" disabled="disabled">Search</button> </div> </div> </div> </form> <div class="small-3 columns"> <mass-action id="bulk-action" mass-actions="vm.massActions" selected-mass-action="vm.selectedMassAction" num-selected="vm.numUsersSelected" disabled="vm.massActionDisabled"> </mass-action> </div> </div> <retrieved-results is-loading="vm.isLoading" load-status="vm.loadStatus"></retrieved-results> <table class="information-table table" ng-hide="vm.isLoading"> <thead> <tr> <th width="1"> <label for="checkAll" class="offscreen">Check All</label> <input type="checkbox" id="checkAll" class="checkbox" aria-label="Check all" ng-model="vm.checkAll" ng-click="vm.onCheckAll()"> </th> <th ng-click="vm.sortColumn = \'aosUser.lastName\'; vm.sortReverse = !vm.sortReverse"> <span ng-class="{unsorted: vm.sortColumn !== \'aosUser.lastName\'}"> Last Name <icon ng-show="vm.sortColumn === \'aosUser.lastName\'" class="icon-table-header" name="{{vm.sortReverse ? \'fa-caret-down\' : \'fa-caret-up\'}}" alt="Sorted by Last Name"></icon> </span> </th> <th ng-click="vm.sortColumn = \'aosUser.firstName\'; vm.sortReverse = !vm.sortReverse"> <span ng-class="{unsorted: vm.sortColumn !== \'aosUser.firstName\'}"> First Name <icon ng-show="vm.sortColumn === \'aosUser.firstName\'" class="icon-table-header" name="{{vm.sortReverse ? \'fa-caret-down\' : \'fa-caret-up\'}}" alt="Sorted by First Name"></icon> </span> </th> <th ng-click="vm.sortColumn = \'lastSignedIn\'; vm.sortReverse = !vm.sortReverse"> <span ng-class="{unsorted: vm.sortColumn !== \'lastSignedIn\'}"> Last Login Date <icon ng-show="vm.sortColumn === \'lastSignedIn\'" class="icon-table-header" name="{{vm.sortReverse ? \'fa-caret-down\' : \'fa-caret-up\'}}" alt="Sorted by Last Login Date"></icon> </span> </th> <th ng-click="vm.sortColumn = \'responsibilities\'; vm.sortReverse = !vm.sortReverse"> <span ng-class="{unsorted: vm.sortColumn !== \'responsibilities\'}"> Responsibilities <icon ng-show="vm.sortColumn === \'responsibilities\'" class="icon-table-header" name="{{vm.sortReverse ? \'fa-caret-down\' : \'fa-caret-up\'}}" alt="Sorted by Responsibilities"></icon> </span> </th> <th ng-click="vm.sortColumn = \'aosUser.vmisUser.adminProfile.workEmail\'; vm.sortReverse = !vm.sortReverse"> <span ng-class="{unsorted: vm.sortColumn !== \'aosUser.vmisUser.adminProfile.workEmail\'}"> Work Email <icon ng-show="vm.sortColumn === \'aosUser.vmisUser.adminProfile.workEmail\'" class="icon-table-header" name="{{vm.sortReverse ? \'fa-caret-down\' : \'fa-caret-up\'}}" alt="Sorted by Work Email"></icon> </span> </th> <th class="unsorted">Actions</th> </tr> </thead> <tbody ng-hide="vm.isLoading"> <tr ng-repeat="avccAssistant in (vm.filteredUsers = (vm.usersWithRole | orderBy:vm.sortColumn:vm.sortReverse))" ng-class-even="\'even\'" ng-class-odd="\'odd\'"> <td> <label for="{{avccAssistant.checkboxId}}" class="offscreen">Check User</label> <input type="checkbox" id="{{avccAssistant.checkboxId}}" class="checkbox" ng-model="avccAssistant.isChecked" ng-click="vm.onCheckUser()"> </td> <td>{{avccAssistant.aosUser.lastName}}</td> <td>{{avccAssistant.aosUser.firstName}}</td> <td>{{avccAssistant.lastSignedIn ? (avccAssistant.lastSignedIn | date:\'MM/dd/yyyy\') : \'Never logged in\'}}</td> <td> <div class="middle" ng-repeat="community in avccAssistant.aosUser.vmisUser.adminProfile.responsibilities.avccAssistant track by $index"> <span>{{community.communityAffiliationName}}</span> </div> </td> <td> <a ng-if="avccAssistant.aosUser.vmisUser.adminProfile.workEmail" ng-href="{{\'mailto:\' + avccAssistant.aosUser.vmisUser.adminProfile.workEmail}}"> {{avccAssistant.aosUser.vmisUser.adminProfile.workEmail}} </a> </td> <td class="table-icon-column-entry"> <vmis-dropdown class="float-right"> <vmis-dropdown-toggle> <icon name="fa-pencil" class="icon-lg clickable" alt="Select this pencil icon to view or edit the user\'s profile"></icon> </vmis-dropdown-toggle> <vmis-dropdown-pane class="table-vmis-dropdown"> <ul class="menu vertical"> <li ng-click="vm.onClickOpenAVCCAssistant(avccAssistant)"> Profile </li> <li ng-click="vm.onClickEditAVCCAssistant(avccAssistant)"> Edit </li> </ul> </vmis-dropdown-pane> </vmis-dropdown> </td> </tr> <tr ng-if="vm.filteredUsers.length === 0"> <td colspan="7"> No data to display </td> </tr> </tbody> </table> <loading-icon show="vm.isLoading"></loading-icon> <load-more is-loading="vm.isLoading" load-status="vm.loadStatus" on-load-more="vm.onLoadMore()" on-load-all="vm.onLoadAll()"></load-more>');
$templateCache.put('app/components/administrator/people/coordinatorAssistants/editCoordinatorAssistant.view.html','<form name="form" ng-submit="vm.onSubmit()"> <modal close="$dismiss" modal-title="{{vm.title}}"> <modal-body> <div class="row"> <div class="small-11 small-centered columns"> <p class="help-text" ng-if="vm.isNewAVCCAssistant"> This user must already have an VMIS account. </p> <label> <span class="bold has-tip" tooltip-popup-delay="200" tooltip-placement="right" tooltip="Click within the text box below to view and search for Communities"> Communities </span> <ui-select multiple="multiple" role="listbox" ng-model="vm.avccAssistantResponsibilities" close-on-select="false" data-ng-disabled="!vm.canEdit || vm.isLoading"> <ui-select-match placeholder="Select a community or search..." ui-lock-choice="$item.readOnly"> <span ng-class="{\'italic\': $item.readOnly}">{{$item.communityAffiliationName}}</span> </ui-select-match> <ui-select-choices repeat="community in vm.communities | propsFilter: {communityAffiliationName: $select.search}" position="down"> <div ng-bind-html="community.communityAffiliationName | highlight: $select.search"></div> </ui-select-choices> </ui-select> </label> <label ng-if="vm.isNewAVCCAssistant"> <span class="bold has-tip" tooltip="This email must match the user\'s AFWP log in email address" tooltip-popup-delay="200" tooltip-placement="right">Log In Email</span> <input type="email" ng-model="vm.avccAssistant.masterUserEmail" placeholder="Email" required data-ng-disabled="vm.isLoading"> </label> </div> </div> <div data-alert class="row alert-box alert" ng-show="vm.errorText"> {{vm.errorText}} </div> <div class="empty-space"></div> </modal-body> <modal-footer> <div class="pull-right"> <button type="button" class="dflt button" ng-if="vm.canRemove" ng-click="vm.onClickRemove()" data-ng-disabled="vm.isLoading"> Remove Role </button> <button type="submit" class="dflt button" ng-if="vm.canEdit" data-ng-disabled="form.$invalid || (vm.avccAssistantResponsibilities.length === 0 && vm.isNewAVCCAssistant) || vm.isLoading"> Save </button> <button type="button" class="dflt button" ng-click="$dismiss(\'cancel\')" data-ng-disabled="vm.isLoading"> Cancel </button> </div> </modal-footer> </modal> </form>');
$templateCache.put('app/components/administrator/people/coordinators/coordinators.view.html','<div class="expanded row"> <div class="small-offset-6 small-6 columns right-align-contents"> <button type="button" class="dflt button" data-ng-disabled="vm.isLoading" ng-click="vm.onClickFilterUsers()" disabled="disabled"> Filter People </button> <button type="button" class="dflt button" data-ng-disabled="vm.isLoading" ng-click="vm.onClickAddNewCoordinator()" disabled="disabled"> Add New AVCC </button> </div> </div> <div class="expanded row"> <div class="small-3 columns"> <label for="select-role"> Filter by Role </label> </div> <div class="small-6 columns"> <label id="searchPeople" hidden>Search for person</label> </div> <div class="small-3 columns"> <div class="row"> <label for="bulk-action"> Bulk Action ({{vm.numUsersSelected}}) </label> </div> </div> </div> <div class="expanded row"> <div class="small-3 columns"> <ui-select id="select-role" data-ng-change="vm.onSelectRole()" data-ng-model="vm.selectedRoleObject" data-ng-disabled="vm.isLoading"> <ui-select-match placeholder="Select a role or search..."> {{$select.selected.name}} </ui-select-match> <ui-select-choices repeat="role in vm.roleObjectList | propsFilter: {name: $select.search, shortName: $select.search}"> <span ng-bind-html="role.name | highlight: $select.search"></span> </ui-select-choices> </ui-select> </div> <form> <div class="small-6 columns"> <div class="input-group"> <div class="input-group-label icon-label"> <icon name="fa-search" class="icon-lg"></icon> </div> <label for="lastName" class="offscreen">Last Name</label> <input type="text" id="lastName" aria-label="Last name" class="input-group-field" placeholder="Last name" ng-model="vm.filter.lastName"> <span class="input-group-glue"></span> <label for="firstName" class="offscreen">First Name</label> <input type="text" id="firstName" aria-label="First name" class="input-group-field" placeholder="First name" ng-model="vm.filter.firstName"> <div class="input-group-button"> <button type="submit" class="dflt button" ng-disabled="vm.isLoading" ng-click="vm.onClickSearch()" disabled="disabled">Search</button> </div> </div> </div> </form> <div class="small-3 columns"> <mass-action id="bulk-action" mass-actions="vm.massActions" selected-mass-action="vm.selectedMassAction" num-selected="vm.numUsersSelected" disabled="vm.massActionDisabled"> </mass-action> </div> </div> <retrieved-results is-loading="vm.isLoading" load-status="vm.loadStatus"></retrieved-results> <table class="information-table table" ng-hide="vm.isLoading"> <thead> <tr> <th width="1"> <label for="checkAll" class="offscreen">Check All</label> <input type="checkbox" id="checkAll" class="checkbox" aria-label="Check all" ng-model="vm.checkAll" ng-click="vm.onCheckAll()"> </th> <th ng-click="vm.sortColumn = \'aosUser.lastName\'; vm.sortReverse = !vm.sortReverse"> <span ng-class="{unsorted: vm.sortColumn !== \'aosUser.lastName\'}"> Last Name <icon ng-show="vm.sortColumn === \'aosUser.lastName\'" class="icon-table-header" name="{{vm.sortReverse ? \'fa-caret-down\' : \'fa-caret-up\'}}" alt="Sorted by Last Name"></icon> </span> </th> <th ng-click="vm.sortColumn = \'aosUser.firstName\'; vm.sortReverse = !vm.sortReverse"> <span ng-class="{unsorted: vm.sortColumn !== \'aosUser.firstName\'}"> First Name <icon ng-show="vm.sortColumn === \'aosUser.firstName\'" class="icon-table-header" name="{{vm.sortReverse ? \'fa-caret-down\' : \'fa-caret-up\'}}" alt="Sorted by First Name"></icon> </span> </th> <th ng-click="vm.sortColumn = \'lastSignedIn\'; vm.sortReverse = !vm.sortReverse"> <span ng-class="{unsorted: vm.sortColumn !== \'lastSignedIn\'}"> Last Login Date <icon ng-show="vm.sortColumn === \'lastSignedIn\'" class="icon-table-header" name="{{vm.sortReverse ? \'fa-caret-down\' : \'fa-caret-up\'}}" alt="Sorted by Last Login Date"></icon> </span> </th> <th ng-click="vm.sortColumn = \'responsibilities\'; vm.sortReverse = !vm.sortReverse"> <span ng-class="{unsorted: vm.sortColumn !== \'responsibilities\'}"> Responsibilities <icon ng-show="vm.sortColumn === \'responsibilities\'" class="icon-table-header" name="{{vm.sortReverse ? \'fa-caret-down\' : \'fa-caret-up\'}}" alt="Sorted by Responsibilities"></icon> </span> </th> <th ng-click="vm.sortColumn = \'aosUser.vmisUser.adminProfile.workEmail\'; vm.sortReverse = !vm.sortReverse"> <span ng-class="{unsorted: vm.sortColumn !== \'aosUser.vmisUser.adminProfile.workEmail\'}"> Work Email <icon ng-show="vm.sortColumn === \'aosUser.vmisUser.adminProfile.workEmail\'" class="icon-table-header" name="{{vm.sortReverse ? \'fa-caret-down\' : \'fa-caret-up\'}}" alt="Sorted by Work Email"></icon> </span> </th> <th class="unsorted">Actions</th> </tr> </thead> <tbody ng-hide="vm.isLoading"> <tr ng-repeat="coordinator in (vm.filteredUsers = (vm.usersWithRole | orderBy:vm.sortColumn:vm.sortReverse))" ng-class-even="\'even\'" ng-class-odd="\'odd\'"> <td> <label for="{{coordinator.checkboxId}}" class="offscreen">Check User</label> <input type="checkbox" id="{{coordinator.checkboxId}}" class="checkbox" ng-model="coordinator.isChecked" ng-click="vm.onCheckUser()"> </td> <td>{{coordinator.aosUser.lastName}}</td> <td>{{coordinator.aosUser.firstName}}</td> <td>{{coordinator.lastSignedIn ? (coordinator.lastSignedIn | date:\'MM/dd/yyyy\') : \'Never logged in\'}}</td> <td> <div class="middle" ng-repeat="community in coordinator.aosUser.vmisUser.adminProfile.responsibilities.avcc track by $index"> <span>{{community.communityAffiliationName}}</span> </div> </td> <td> <a ng-if="coordinator.aosUser.vmisUser.adminProfile.workEmail" ng-href="{{\'mailto:\' + coordinator.aosUser.vmisUser.adminProfile.workEmail}}"> {{coordinator.aosUser.vmisUser.adminProfile.workEmail}} </a> </td> <td class="table-icon-column-entry"> <vmis-dropdown class="float-right"> <vmis-dropdown-toggle> <icon name="fa-pencil" class="icon-lg clickable" alt="Select this pencil icon to view or edit the user\'s profile"></icon> </vmis-dropdown-toggle> <vmis-dropdown-pane class="table-vmis-dropdown"> <ul class="menu vertical"> <li ng-click="vm.onClickOpenCoordinator(coordinator)"> Profile </li> <li ng-click="vm.onClickEditCoordinator(coordinator)"> Edit </li> </ul> </vmis-dropdown-pane> </vmis-dropdown> </td> </tr> <tr ng-if="vm.filteredUsers.length === 0"> <td colspan="7"> No data to display </td> </tr> </tbody> </table> <loading-icon show="vm.isLoading"></loading-icon> <load-more is-loading="vm.isLoading" load-status="vm.loadStatus" on-load-more="vm.onLoadMore()" on-load-all="vm.onLoadAll()"></load-more>');
$templateCache.put('app/components/administrator/people/coordinators/editCoordinator.view.html','<form name="form" ng-submit="vm.onSubmit()"> <modal close="$dismiss" modal-title="{{vm.title}}"> <modal-body> <div class="row"> <div class="small-11 small-centered columns"> <p class="help-text" ng-if="vm.isNewAVCC"> This user must already have an VMIS account. </p> <label> <span class="bold has-tip" tooltip-popup-delay="200" tooltip-placement="right" tooltip="Click within the text box below to view and search for Communities"> Communities </span> <ui-select multiple="multiple" role="listbox" ng-model="vm.avccResponsibilities" aria-label="Communities" close-on-select="false" data-ng-disabled="vm.isLoading"> <ui-select-match placeholder="Select a community or search..." ui-lock-choice="$item.readOnly"> <span ng-class="{\'italic\': $item.readOnly}">{{$item.communityAffiliationName}}</span> </ui-select-match> <ui-select-choices repeat="community in vm.communities | propsFilter: {communityAffiliationName: $select.search}" position="down"> <div ng-bind-html="community.communityAffiliationName | highlight: $select.search"></div> </ui-select-choices> </ui-select> </label> <label ng-if="vm.isNewAVCC"> <span class="bold has-tip" tooltip="This email must match the user\'s AFWP log in email address" tooltip-popup-delay="200" tooltip-placement="right">Log In Email</span> <input type="email" ng-model="vm.coordinator.masterUserEmail" placeholder="Email" required data-ng-disabled="vm.isLoading"> </label> </div> </div> <div data-alert class="row alert-box alert" ng-show="vm.errorText"> {{vm.errorText}} </div> <div class="empty-space"></div> </modal-body> <modal-footer> <div class="pull-right"> <button type="button" class="dflt button" ng-if="vm.canRemove" ng-click="vm.onClickRemove()" data-ng-disabled="vm.isLoading"> Remove Role </button> <button type="submit" class="dflt button" data-ng-disabled="form.$invalid || (vm.avccResponsibilities.length === 0 && vm.isNewAVCC) || vm.isLoading"> Save </button> <button type="button" class="dflt button" ng-click="$dismiss(\'cancel\')" data-ng-disabled="vm.isLoading"> Cancel </button> </div> </modal-footer> </modal> </form>');
$templateCache.put('app/components/administrator/people/global/global.view.html','<div class="expanded row"> <div class="small-3 columns"> <ui-select id="select-role" data-ng-change="vm.onSelectRole()" data-ng-model="vm.selectedRoleObject" data-ng-disabled="vm.isLoading"> <ui-select-match placeholder="Select a role or search..."> {{$select.selected.name}} </ui-select-match> <ui-select-choices repeat="role in vm.roleObjectList | propsFilter: {name: $select.search, shortName: $select.search}"> <span ng-bind-html="role.name | highlight: $select.search"></span> </ui-select-choices> </ui-select> </div> </div> <div class="expanded row"> <form> <div class="small-9 columns"> <div class="input-group"> <div class="input-group-label icon-label"> <icon name="fa-search" class="icon-lg"></icon> </div> <label for="lastName" class="offscreen">Last Name</label> <input type="text" id="lastName" aria-label="Last name" class="input-group-field" placeholder="Last name" ng-model="vm.filter.lastName"> <span class="input-group-glue"></span> <label for="firstName" class="offscreen">First Name</label> <input type="text" id="firstName" aria-label="First name" class="input-group-field" placeholder="First name" ng-model="vm.filter.firstName"> <span class="input-group-glue"></span> <label for="email" class="offscreen">Email</label> <input type="email" id="email" aria-label="Email" class="input-group-field" placeholder="Email" ng-model="vm.filter.email"> <div class="input-group-button"> <button type="submit" class="dflt button" ng-disabled="vm.isLoading||(!vm.filter.firstName && !vm.filter.lastName && !vm.filter.email)" ng-click="vm.onClickSearch()" disabled="disabled">Search</button> </div> </div> </div> </form> <div class="small-3 columns"> <span tooltip="When checked will do an exact search for first and last name if filled out, otherwise will do a like search on item passed" tooltip-popup-delay="1000" tooltip-append-to-body="true" class="has-tip" style="font-weight: normal;"> <input type="checkbox" class="checkbox" aria-label="Exact match for first and last name" ng-model="vm.isExactNameSearch" ng-disabled="vm.isLoading" ng-click="vm.onToggleExactNameSearch()"> Exact match for first and last name </span> </div> </div> <retrieved-results is-loading="vm.isLoading" load-status="vm.loadStatus"></retrieved-results> <table class="information-table table" ng-hide="vm.isLoading"> <thead> <tr> <th width="1"> </th><th ng-click="vm.sortColumn = \'aosUser.lastName\'; vm.sortReverse = !vm.sortReverse"> <span ng-class="{unsorted: vm.sortColumn !== \'aosUser.lastName\'}"> Last Name <icon ng-show="vm.sortColumn === \'aosUser.lastName\'" class="icon-table-header" name="{{vm.sortReverse ? \'fa-caret-down\' : \'fa-caret-up\'}}" alt="Sorted by Last Name"></icon> </span> </th> <th ng-click="vm.sortColumn = \'aosUser.firstName\'; vm.sortReverse = !vm.sortReverse"> <span ng-class="{unsorted: vm.sortColumn !== \'aosUser.firstName\'}"> First Name <icon ng-show="vm.sortColumn === \'aosUser.firstName\'" class="icon-table-header" name="{{vm.sortReverse ? \'fa-caret-down\' : \'fa-caret-up\'}}" alt="Sorted by First Name"></icon> </span> </th> <th ng-click="vm.sortColumn = \'aosUser.communityAffiliation\'; vm.sortReverse = !vm.sortReverse"> <span ng-class="{unsorted: vm.sortColumn !== \'aosUser.communityAffiliation\'}"> Community Affiliation <icon ng-show="vm.sortColumn === \'aosUser.communityAffiliation\'" class="icon-table-header" name="{{vm.sortReverse ? \'fa-caret-down\' : \'fa-caret-up\'}}" alt="Sorted by Community Affiliation"></icon> </span> </th> <th ng-click="vm.sortColumn = \'lastSignedIn\'; vm.sortReverse = !vm.sortReverse"> <span ng-class="{unsorted: vm.sortColumn !== \'lastSignedIn\'}"> Last Login Date <icon ng-show="vm.sortColumn === \'lastSignedIn\'" class="icon-table-header" name="{{vm.sortReverse ? \'fa-caret-down\' : \'fa-caret-up\'}}" alt="Sorted by Last Login Date"></icon> </span> </th> <th ng-click="vm.sortColumn = \'masterUserEmail\'; vm.sortReverse = !vm.sortReverse"> <span ng-class="{unsorted: vm.sortColumn !== \'masterUserEmail\'}"> Login Email <icon ng-show="vm.sortColumn === \'masterUserEmail\'" class="icon-table-header" name="{{vm.sortReverse ? \'fa-caret-down\' : \'fa-caret-up\'}}" alt="Sorted by Login Email"></icon> </span> </th> <th ng-click="vm.sortColumn = \'aosUser.vmisUser.volunteerProfile.volunteerEmail\'; vm.sortReverse = !vm.sortReverse"> <span ng-class="{unsorted: vm.sortColumn !== \'aosUser.vmisUser.volunteerProfile.volunteerEmail\'}"> Volunteer Email <icon ng-show="vm.sortColumn === \'aosUser.vmisUser.volunteerProfile.volunteerEmail\'" class="icon-table-header" name="{{vm.sortReverse ? \'fa-caret-down\' : \'fa-caret-up\'}}" alt="Sorted by Volunteer Email"></icon> </span> </th> <th ng-click="vm.sortColumn = \'aosUser.vmisUser.adminProfile.workEmail\'; vm.sortReverse = !vm.sortReverse"> <span ng-class="{unsorted: vm.sortColumn !== \'aosUser.vmisUser.adminProfile.workEmail\'}"> Admin Email <icon ng-show="vm.sortColumn === \'aosUser.vmisUser.adminProfile.workEmail\'" class="icon-table-header" name="{{vm.sortReverse ? \'fa-caret-down\' : \'fa-caret-up\'}}" alt="Sorted by Admin Email"></icon> </span> </th> </tr> </thead> <tbody ng-hide="vm.isLoading"> <tr ng-repeat="vol in (vm.filteredUsers = (vm.usersWithRole | orderBy:vm.sortColumn:vm.sortReverse))" ng-class-even="\'even\'" ng-class-odd="\'odd\'"> <td class="icon-column table-icon-column-entry"> <div tooltip="{{vol.isNonUser ? \'Non-User\' : \'Normal User\'}}" tooltip-popup-delay="200" class="icon-teal"> <icon name="fa-user-circle-o" ng-if="!vol.isNonUser" alt="This account is a user"></icon> <icon name="fa-user-circle" ng-if="vol.isNonUser" alt="This account is a non-user"></icon> </div> </td> <td>{{vol.aosUser.lastName}}</td> <td>{{vol.aosUser.firstName}}</td> <td>{{vol.aosUser.communityAffiliation}}</td> <td>{{vol.lastSignedIn ? (vol.lastSignedIn | date:\'MM/dd/yyyy\') : \'Never logged in\'}}</td> <td>{{vol.masterUserEmail}}</td> <td> <a ng-if="vol.aosUser.vmisUser.volunteerProfile.volunteerEmail" ng-href="{{\'mailto:\' + vol.aosUser.vmisUser.volunteerProfile.volunteerEmail}}"> {{vol.aosUser.vmisUser.volunteerProfile.volunteerEmail}} </a> </td> <td>{{vol.aosUser.vmisUser.adminProfile?vol.aosUser.vmisUser.adminProfile.workEmail:\'\'}}</td> </tr> <tr ng-if="vm.filteredUsers.length === 0"> <td colspan="8"> No data to display </td> </tr> </tbody> </table> <loading-icon show="vm.isLoading"></loading-icon> <load-more is-loading="vm.isLoading" load-status="vm.loadStatus" on-load-more="vm.onLoadMore()" on-load-all="vm.onLoadAll()"></load-more>');
$templateCache.put('app/components/administrator/people/opocs/editOpoc.view.html','<form name="form" ng-submit="vm.onSubmit()"> <modal close="$dismiss" modal-title="{{vm.title}}"> <modal-body> <div class="row"> <div class="small-11 small-centered columns"> <p class="help-text" ng-if="vm.canEdit"> This is not an OPOC invitation.<span ng-if="vm.isNewOPOC"> This user must already have an VMIS account.</span> </p> <div> <label ng-if="vm.canEdit"> <span class="bold has-tip" tooltip-popup-delay="200" tooltip-placement="right" tooltip="Select a Community to filter the Organizations that appear as options below"> Community </span> <ui-select required data-ng-change="vm.onCommunityChange()" data-ng-model="vm.selectedCommunity" data-ng-disabled="vm.isLoading"> <ui-select-match placeholder="Select a community or search..."> {{$select.selected.communityAffiliationName}} </ui-select-match> <ui-select-choices repeat="comm in vm.communities | propsFilter: {communityAffiliationName: $select.search}" position="down"> <span ng-bind-html="comm.communityAffiliationName | highlight: $select.search"></span> </ui-select-choices> </ui-select> </label> <label> <span class="bold has-tip" tooltip-popup-delay="200" tooltip-placement="right" tooltip="Click within the text box below to view and search for Organizations"> Organizations </span> <ui-select multiple="multiple" role="listbox" ng-model="vm.opocResponsibilities" on-select="vm.onSelectOrg($item, $model)" close-on-select="false" data-ng-disabled="!vm.canEdit || vm.isLoading"> <ui-select-match placeholder="Select an organization or search..." ui-lock-choice="$item.readOnly"> <span ng-class="{\'italic\': $item.readOnly}">{{$item.organizationName}} <span ng-if="($item.communityAffiliationId !== vm.selectedCommunity.communityAffiliationId)"> <br>[{{$item.communityAffiliationName}}] </span> </span> </ui-select-match> <ui-select-choices repeat="org in vm.selectedCommunity.organizations | propsFilter: {organizationName: $select.search}" position="down"> <div ng-bind-html="org.organizationName | highlight: $select.search"></div> </ui-select-choices> </ui-select> </label> </div> <label ng-if="vm.isNewOPOC"> <span class="bold has-tip" tooltip="This email must match the user\'s AFWP log in email address" tooltip-popup-delay="200" tooltip-placement="right">Log In Email</span> <input type="email" ng-model="vm.opoc.masterUserEmail" placeholder="Email" required data-ng-disabled="vm.isLoading"> </label> </div> </div> <div data-alert class="row alert-box alert" ng-show="vm.errorText"> {{vm.errorText}} </div> <div class="empty-space"></div> </modal-body> <modal-footer> <div class="pull-right"> <button type="button" class="dflt button" ng-if="vm.canRemove" ng-click="vm.onClickRemove()" data-ng-disabled="vm.isLoading"> Remove Role </button> <button type="submit" class="dflt button" ng-if="vm.canEdit" data-ng-disabled="form.$invalid || (vm.opocResponsibilities.length === 0 && vm.isNewOPOC) || vm.isLoading"> Save </button> <button type="button" class="dflt button" ng-click="$dismiss(\'cancel\')" data-ng-disabled="vm.isLoading"> Cancel </button> </div> </modal-footer> </modal> </form>');
$templateCache.put('app/components/administrator/people/opocs/opocs.view.html','<div class="expanded row"> <div class="small-offset-6 small-6 columns right-align-contents"> <button type="button" class="dflt button" data-ng-disabled="vm.isLoading" ng-click="vm.onClickFilterUsers()" disabled="disabled"> Filter People </button> <button type="button" class="dflt button" ng-if="!vm.isPMAndNotAVCC" data-ng-disabled="vm.isLoading" ng-click="vm.onClickAddNewOPOC()" disabled="disabled"> Add New OPOC </button> </div> </div> <div class="expanded row"> <div class="small-3 columns"> <label for="select-role"> Filter by Role </label> </div> <div class="small-6 columns"> <label id="searchPeople" hidden>Search for person</label> </div> <div class="small-3 columns"> <div class="row"> <label for="bulk-action"> Bulk Action ({{vm.numUsersSelected}}) </label> </div> </div> </div> <div class="expanded row"> <div class="small-3 columns"> <ui-select id="select-role" data-ng-change="vm.onSelectRole()" data-ng-model="vm.selectedRoleObject" data-ng-disabled="vm.isLoading"> <ui-select-match placeholder="Select a role or search..."> {{$select.selected.name}} </ui-select-match> <ui-select-choices repeat="role in vm.roleObjectList | propsFilter: {name: $select.search, shortName: $select.search}"> <span ng-bind-html="role.name | highlight: $select.search"></span> </ui-select-choices> </ui-select> </div> <form> <div class="small-6 columns"> <div class="input-group"> <div class="input-group-label icon-label"> <icon name="fa-search" class="icon-lg"></icon> </div> <label for="lastName" class="offscreen">Last Name</label> <input type="text" id="lastName" aria-label="Last name" class="input-group-field" placeholder="Last name" ng-model="vm.filter.lastName"> <span class="input-group-glue"></span> <label for="firstName" class="offscreen">First Name</label> <input type="text" id="firstName" aria-label="First name" class="input-group-field" placeholder="First name" ng-model="vm.filter.firstName"> <div class="input-group-button"> <button type="submit" class="dflt button" ng-disabled="vm.isLoading" ng-click="vm.onClickSearch()" disabled="disabled">Search</button> </div> </div> </div> </form> <div class="small-3 columns"> <mass-action id="bulk-action" mass-actions="vm.massActions" selected-mass-action="vm.selectedMassAction" num-selected="vm.numUsersSelected" disabled="vm.massActionDisabled"> </mass-action> </div> </div> <retrieved-results is-loading="vm.isLoading" load-status="vm.loadStatus"></retrieved-results> <table class="information-table table" ng-hide="vm.isLoading"> <thead> <tr> <th width="1"> <label for="checkAll" class="offscreen">Check All</label> <input type="checkbox" id="checkAll" class="checkbox" aria-label="Check all" ng-model="vm.checkAll" ng-click="vm.onCheckAll()"> </th> <th ng-click="vm.sortColumn = \'aosUser.lastName\'; vm.sortReverse = !vm.sortReverse"> <span ng-class="{unsorted: vm.sortColumn !== \'aosUser.lastName\'}"> Last Name <icon ng-show="vm.sortColumn === \'aosUser.lastName\'" class="icon-table-header" name="{{vm.sortReverse ? \'fa-caret-down\' : \'fa-caret-up\'}}" alt="Sorted by Last Name"></icon> </span> </th> <th ng-click="vm.sortColumn = \'aosUser.firstName\'; vm.sortReverse = !vm.sortReverse"> <span ng-class="{unsorted: vm.sortColumn !== \'aosUser.firstName\'}"> First Name <icon ng-show="vm.sortColumn === \'aosUser.firstName\'" class="icon-table-header" name="{{vm.sortReverse ? \'fa-caret-down\' : \'fa-caret-up\'}}" alt="Sorted by First Name"></icon> </span> </th> <th ng-click="vm.sortColumn = \'lastSignedIn\'; vm.sortReverse = !vm.sortReverse"> <span ng-class="{unsorted: vm.sortColumn !== \'lastSignedIn\'}"> Last Login Date <icon ng-show="vm.sortColumn === \'lastSignedIn\'" class="icon-table-header" name="{{vm.sortReverse ? \'fa-caret-down\' : \'fa-caret-up\'}}" alt="Sorted by Last Login Date"></icon> </span> </th> <th ng-click="vm.sortColumn = \'responsibilities\'; vm.sortReverse = !vm.sortReverse"> <span ng-class="{unsorted: vm.sortColumn !== \'responsibilities\'}"> Responsibilities <icon ng-show="vm.sortColumn === \'responsibilities\'" class="icon-table-header" name="{{vm.sortReverse ? \'fa-caret-down\' : \'fa-caret-up\'}}" alt="Sorted by Responsibilities"></icon> </span> </th> <th ng-click="vm.sortColumn = \'aosUser.vmisUser.adminProfile.workEmail\'; vm.sortReverse = !vm.sortReverse"> <span ng-class="{unsorted: vm.sortColumn !== \'aosUser.vmisUser.adminProfile.workEmail\'}"> Work Email <icon ng-show="vm.sortColumn === \'aosUser.vmisUser.adminProfile.workEmail\'" class="icon-table-header" name="{{vm.sortReverse ? \'fa-caret-down\' : \'fa-caret-up\'}}" alt="Sorted by Work Email"></icon> </span> </th> <th class="unsorted">Actions</th> </tr> </thead> <tbody ng-hide="vm.isLoading"> <tr ng-repeat="opoc in (vm.filteredUsers = (vm.usersWithRole | orderBy:vm.sortColumn:vm.sortReverse))" ng-class-even="\'even\'" ng-class-odd="\'odd\'"> <td> <label for="{{opoc.checkboxId}}" class="offscreen">Check User</label> <input type="checkbox" id="{{opoc.checkboxId}}" class="checkbox" ng-model="opoc.isChecked" ng-click="vm.onCheckUser()"> </td> <td>{{opoc.aosUser.lastName}}</td> <td>{{opoc.aosUser.firstName}}</td> <td>{{opoc.lastSignedIn ? (opoc.lastSignedIn | date:\'MM/dd/yyyy\') : \'Never logged in\'}}</td> <td> <div class="middle" ng-repeat="community in opoc.aosUser.vmisUser.adminProfile.responsibilities.opoc track by $index"> <span>{{community.communityAffiliationName}}</span> <ul class="remove-bottom-margin"> <li ng-repeat="organization in community.organizations track by $index"> {{organization.volunteerOrganizationName}} </li> </ul> </div> </td> <td> <a ng-if="opoc.aosUser.vmisUser.adminProfile.workEmail" ng-href="{{\'mailto:\' + opoc.aosUser.vmisUser.adminProfile.workEmail}}"> {{opoc.aosUser.vmisUser.adminProfile.workEmail}} </a> </td> <td class="table-icon-column-entry"> <vmis-dropdown class="float-right"> <vmis-dropdown-toggle> <icon name="fa-pencil" class="icon-lg clickable" alt="Select this pencil icon to view or edit the user\'s profile"></icon> </vmis-dropdown-toggle> <vmis-dropdown-pane class="table-vmis-dropdown"> <ul class="menu vertical"> <li ng-click="vm.onClickOpenOPOC(opoc)"> Profile </li> <li ng-click="vm.onClickEditOPOC(opoc)"> Edit </li> </ul> </vmis-dropdown-pane> </vmis-dropdown> </td> </tr> <tr ng-if="vm.filteredUsers.length === 0"> <td colspan="7"> No data to display </td> </tr> </tbody> </table> <loading-icon show="vm.isLoading"></loading-icon> <load-more is-loading="vm.isLoading" load-status="vm.loadStatus" on-load-more="vm.onLoadMore()" on-load-all="vm.onLoadAll()"></load-more>');
$templateCache.put('app/components/administrator/people/programManagers/editProgramManager.view.html','<form name="form" ng-submit="vm.onSubmit()"> <modal close="$dismiss" modal-title="{{vm.title}}"> <modal-body> <div class="row"> <div class="small-11 small-centered columns"> <p class="help-text" ng-if="vm.isNewProgramManager"> This user must already have an VMIS account. </p> <label ng-if="vm.isNewProgramManager"> <span class="bold has-tip" tooltip="This email must match the user\'s AFWP log in email address" tooltip-popup-delay="200" tooltip-placement="right">Log In Email</span> <input type="email" ng-model="vm.programManager.masterUserEmail" placeholder="Email" required data-ng-disabled="vm.isLoading"> </label> </div> </div> <div data-alert class="row alert-box alert" ng-show="vm.errorText"> {{vm.errorText}} </div> </modal-body> <modal-footer> <div class="pull-right"> <button type="button" class="dflt button" ng-if="vm.canRemove" ng-click="vm.onClickRemove()" data-ng-disabled="vm.isLoading"> Remove Role </button> <button type="submit" class="dflt button" data-ng-disabled="form.$invalid || vm.isLoading"> Save </button> <button type="button" class="dflt button" ng-click="$dismiss(\'cancel\')" data-ng-disabled="vm.isLoading"> Cancel </button> </div> </modal-footer> </modal> </form>');
$templateCache.put('app/components/administrator/people/programManagers/programManagers.view.html','<div class="expanded row"> <div class="small-offset-6 small-6 columns right-align-contents"> <button type="button" class="dflt button" data-ng-disabled="vm.isLoading" ng-click="vm.onClickFilterUsers()" disabled="disabled"> Filter People </button> <button type="button" class="dflt button" data-ng-disabled="vm.isLoading" ng-click="vm.onClickAddNewProgramManager()" disabled="disabled"> Add New Program Manager </button> </div> </div> <div class="expanded row"> <div class="small-3 columns people-label"> <label for="select-role"> Filter by Role </label> </div> <div class="small-6 columns"> <label id="searchPeople" hidden>Search for person</label> </div> <div class="small-3 columns"> <div class="row"> <label for="bulk-action"> Bulk Action ({{vm.numUsersSelected}}) </label> </div> </div> </div> <div class="expanded row"> <div class="small-3 columns"> <ui-select id="select-role" data-ng-change="vm.onSelectRole()" data-ng-model="vm.selectedRoleObject" data-ng-disabled="vm.isLoading"> <ui-select-match placeholder="Select a role or search..."> {{$select.selected.name}} </ui-select-match> <ui-select-choices repeat="role in vm.roleObjectList | propsFilter: {name: $select.search, shortName: $select.search}"> <span ng-bind-html="role.name | highlight: $select.search"></span> </ui-select-choices> </ui-select> </div> <form> <div class="small-6 columns"> <div class="input-group"> <div class="input-group-label icon-label"> <icon name="fa-search" class="icon-lg"></icon> </div> <label for="lastName" class="offscreen">Last Name</label> <input type="text" id="lastName" aria-label="Last name" class="input-group-field" placeholder="Last name" ng-model="vm.filter.lastName"> <span class="input-group-glue"></span> <label for="firstName" class="offscreen">First Name</label> <input type="text" id="firstName" aria-label="First name" class="input-group-field" placeholder="First name" ng-model="vm.filter.firstName"> <div class="input-group-button"> <button type="submit" class="dflt button" ng-disabled="vm.isLoading" ng-click="vm.onClickSearch()" disabled="disabled">Search</button> </div> </div> </div> </form> <div class="small-3 columns"> <mass-action id="bulk-action" mass-actions="vm.massActions" selected-mass-action="vm.selectedMassAction" num-selected="vm.numUsersSelected" disabled="vm.massActionDisabled"> </mass-action> </div> </div> <retrieved-results is-loading="vm.isLoading" load-status="vm.loadStatus"></retrieved-results> <table class="information-table table" ng-hide="vm.isLoading"> <thead> <tr> <th width="1"> <label for="checkAll" class="offscreen">Check All</label> <input type="checkbox" id="checkAll" class="checkbox" aria-label="Check all" ng-model="vm.checkAll" ng-click="vm.onCheckAll()"> </th> <th ng-click="vm.sortColumn = \'aosUser.lastName\'; vm.sortReverse = !vm.sortReverse"> <span ng-class="{unsorted: vm.sortColumn !== \'aosUser.lastName\'}"> Last Name <icon ng-show="vm.sortColumn === \'aosUser.lastName\'" class="icon-table-header" name="{{vm.sortReverse ? \'fa-caret-down\' : \'fa-caret-up\'}}" alt="Sorted by Last Name"></icon> </span> </th> <th ng-click="vm.sortColumn = \'aosUser.firstName\'; vm.sortReverse = !vm.sortReverse"> <span ng-class="{unsorted: vm.sortColumn !== \'aosUser.firstName\'}"> First Name <icon ng-show="vm.sortColumn === \'aosUser.firstName\'" class="icon-table-header" name="{{vm.sortReverse ? \'fa-caret-down\' : \'fa-caret-up\'}}" alt="Sorted by First Name"></icon> </span> </th> <th ng-click="vm.sortColumn = \'lastSignedIn\'; vm.sortReverse = !vm.sortReverse"> <span ng-class="{unsorted: vm.sortColumn !== \'lastSignedIn\'}"> Last Login Date <icon ng-show="vm.sortColumn === \'lastSignedIn\'" class="icon-table-header" name="{{vm.sortReverse ? \'fa-caret-down\' : \'fa-caret-up\'}}" alt="Sorted by Last Login Date"></icon> </span> </th> <th ng-click="vm.sortColumn = \'aosUser.vmisUser.adminProfile.workEmail\'; vm.sortReverse = !vm.sortReverse"> <span ng-class="{unsorted: vm.sortColumn !== \'aosUser.vmisUser.adminProfile.workEmail\'}"> Work Email <icon ng-show="vm.sortColumn === \'aosUser.vmisUser.adminProfile.workEmail\'" class="icon-table-header" name="{{vm.sortReverse ? \'fa-caret-down\' : \'fa-caret-up\'}}" alt="Sorted by Work Email"></icon> </span> </th> <th class="unsorted">Actions</th> </tr> </thead> <tbody ng-hide="vm.isLoading"> <tr ng-repeat="programManager in (vm.filteredUsers = (vm.usersWithRole | orderBy:vm.sortColumn:vm.sortReverse))" ng-class-even="\'even\'" ng-class-odd="\'odd\'"> <td> <label for="{{programManager.checkboxId}}" class="offscreen">Check User</label> <input type="checkbox" id="{{programManager.checkboxId}}" class="checkbox" ng-model="programManager.isChecked" ng-click="vm.onCheckUser()"> </td> <td>{{programManager.aosUser.lastName}}</td> <td>{{programManager.aosUser.firstName}}</td> <td>{{programManager.lastSignedIn ? (programManager.lastSignedIn | date:\'MM/dd/yyyy\') : \'Never logged in\'}}</td> <td> <a ng-if="programManager.aosUser.vmisUser.adminProfile.workEmail" ng-href="{{\'mailto:\' + programManager.aosUser.vmisUser.adminProfile.workEmail}}"> {{programManager.aosUser.vmisUser.adminProfile.workEmail}} </a> </td> <td class="table-icon-column-entry"> <vmis-dropdown class="float-right"> <vmis-dropdown-toggle> <icon name="fa-pencil" class="icon-lg clickable" alt="Select this pencil icon to view or edit the user\'s profile"></icon> </vmis-dropdown-toggle> <vmis-dropdown-pane class="table-vmis-dropdown"> <ul class="menu vertical"> <li ng-click="vm.onClickOpenProgramManager(programManager)"> Profile </li> <li ng-click="vm.onClickRemoveProgramManager(programManager)"> Delete </li> </ul> </vmis-dropdown-pane> </vmis-dropdown> </td> </tr> <tr ng-if="vm.filteredUsers.length === 0"> <td colspan="6"> No data to display </td> </tr> </tbody> </table> <loading-icon show="vm.isLoading"></loading-icon> <load-more is-loading="vm.isLoading" load-status="vm.loadStatus" on-load-more="vm.onLoadMore()" on-load-all="vm.onLoadAll()"></load-more>');
$templateCache.put('app/components/administrator/people/regionManagers/editRegionManager.view.html','<form name="form" ng-submit="vm.onSubmit()"> <modal close="$dismiss" modal-title="{{vm.title}}"> <modal-body> <div class="row"> <div class="small-11 small-centered columns"> <p class="help-text" ng-if="vm.isNewRegionManager"> This user must already have an VMIS account. </p> <label> <span class="bold has-tip" tooltip-popup-delay="200" tooltip-placement="right" tooltip="Click within the text box below to view and search for Regions"> Regions </span> <ui-select multiple="multiple" role="listbox" ng-model="vm.rmResponsibilities" aria-label="Regions" close-on-select="false" data-ng-disabled="vm.isLoading"> <ui-select-match placeholder="Select a region or search...">{{$item.communityAffiliationName}}</ui-select-match> <ui-select-choices repeat="region in vm.regions | propsFilter: {communityAffiliationName: $select.search}" position="down"> <div ng-bind-html="region.communityAffiliationName | highlight: $select.search"></div> </ui-select-choices> </ui-select> </label> <label ng-if="vm.isNewRegionManager"> <span class="bold has-tip" tooltip="This email must match the user\'s AFWP log in email address" tooltip-popup-delay="200" tooltip-placement="right">Log In Email</span> <input type="email" ng-model="vm.regionManager.masterUserEmail" placeholder="Email" required data-ng-disabled="vm.isLoading"> </label> </div> </div> <div data-alert class="row alert-box alert" ng-show="vm.errorText"> {{vm.errorText}} </div> <div class="empty-space"></div> </modal-body> <modal-footer> <div class="pull-right"> <button type="button" class="dflt button" ng-if="vm.canRemove" ng-click="vm.onClickRemove()" data-ng-disabled="vm.isLoading"> Remove Role </button> <button type="submit" class="dflt button" data-ng-disabled="form.$invalid || (vm.rmResponsibilities.length === 0 && vm.isNewRegionManager) || vm.isLoading"> Save </button> <button type="button" class="dflt button" ng-click="$dismiss(\'cancel\')" data-ng-disabled="vm.isLoading"> Cancel </button> </div> </modal-footer> </modal> </form>');
$templateCache.put('app/components/administrator/people/regionManagers/regionManagers.view.html','<div class="expanded row"> <div class="small-offset-6 small-6 columns right-align-contents"> <button type="button" class="dflt button" data-ng-disabled="vm.isLoading" ng-click="vm.onClickFilterUsers()" disabled="disabled"> Filter People </button> <button type="button" class="dflt button" data-ng-disabled="vm.isLoading" ng-click="vm.onClickAddNewRegionManager()" disabled="disabled"> Add New Region Manager </button> </div> </div> <div class="expanded row"> <div class="small-3 columns people-label"> <label for="select-role"> Filter by Role </label> </div> <div class="small-6 columns"> <label id="searchPeople" hidden>Search for person</label> </div> <div class="small-3 columns"> <div class="row"> <label for="bulk-action"> Bulk Action ({{vm.numUsersSelected}}) </label> </div> </div> </div> <div class="expanded row"> <div class="small-3 columns"> <ui-select id="select-role" data-ng-change="vm.onSelectRole()" data-ng-model="vm.selectedRoleObject" data-ng-disabled="vm.isLoading"> <ui-select-match placeholder="Select a role or search..."> {{$select.selected.name}} </ui-select-match> <ui-select-choices repeat="role in vm.roleObjectList | propsFilter: {name: $select.search, shortName: $select.search}"> <span ng-bind-html="role.name | highlight: $select.search"></span> </ui-select-choices> </ui-select> </div> <form> <div class="small-6 columns"> <div class="input-group"> <div class="input-group-label icon-label"> <icon name="fa-search" class="icon-lg"></icon> </div> <label for="lastName" class="offscreen">Last Name</label> <input type="text" id="lastName" aria-label="Last name" class="input-group-field" placeholder="Last name" ng-model="vm.filter.lastName"> <span class="input-group-glue"></span> <label for="firstName" class="offscreen">First Name</label> <input type="text" id="firstName" aria-label="First name" class="input-group-field" placeholder="First name" ng-model="vm.filter.firstName"> <div class="input-group-button"> <button type="submit" class="dflt button" ng-disabled="vm.isLoading" ng-click="vm.onClickSearch()" disabled="disabled">Search</button> </div> </div> </div> </form> <div class="small-3 columns"> <mass-action id="bulk-action" mass-actions="vm.massActions" selected-mass-action="vm.selectedMassAction" num-selected="vm.numUsersSelected" disabled="vm.massActionDisabled"> </mass-action> </div> </div> <retrieved-results is-loading="vm.isLoading" load-status="vm.loadStatus"></retrieved-results> <table class="information-table table" ng-hide="vm.isLoading"> <thead> <tr> <th width="1"> <label for="checkAll" class="offscreen">Check All</label> <input type="checkbox" id="checkAll" class="checkbox" aria-label="Check all" ng-model="vm.checkAll" ng-click="vm.onCheckAll()"> </th> <th ng-click="vm.sortColumn = \'aosUser.lastName\'; vm.sortReverse = !vm.sortReverse"> <span ng-class="{unsorted: vm.sortColumn !== \'aosUser.lastName\'}"> Last Name <icon ng-show="vm.sortColumn === \'aosUser.lastName\'" class="icon-table-header" name="{{vm.sortReverse ? \'fa-caret-down\' : \'fa-caret-up\'}}" alt="Sorted by Last Name"></icon> </span> </th> <th ng-click="vm.sortColumn = \'aosUser.firstName\'; vm.sortReverse = !vm.sortReverse"> <span ng-class="{unsorted: vm.sortColumn !== \'aosUser.firstName\'}"> First Name <icon ng-show="vm.sortColumn === \'aosUser.firstName\'" class="icon-table-header" name="{{vm.sortReverse ? \'fa-caret-down\' : \'fa-caret-up\'}}" alt="Sorted by First Name"></icon> </span> </th> <th ng-click="vm.sortColumn = \'lastSignedIn\'; vm.sortReverse = !vm.sortReverse"> <span ng-class="{unsorted: vm.sortColumn !== \'lastSignedIn\'}"> Last Login Date <icon ng-show="vm.sortColumn === \'lastSignedIn\'" class="icon-table-header" name="{{vm.sortReverse ? \'fa-caret-down\' : \'fa-caret-up\'}}" alt="Sorted by Last Login Date"></icon> </span> </th> <th ng-click="vm.sortColumn = \'responsibilities\'; vm.sortReverse = !vm.sortReverse"> <span ng-class="{unsorted: vm.sortColumn !== \'responsibilities\'}"> Responsibilities <icon ng-show="vm.sortColumn === \'responsibilities\'" class="icon-table-header" name="{{vm.sortReverse ? \'fa-caret-down\' : \'fa-caret-up\'}}" alt="Sorted by Responsibilities"></icon> </span> </th> <th ng-click="vm.sortColumn = \'aosUser.vmisUser.adminProfile.workEmail\'; vm.sortReverse = !vm.sortReverse"> <span ng-class="{unsorted: vm.sortColumn !== \'aosUser.vmisUser.adminProfile.workEmail\'}"> Work Email <icon ng-show="vm.sortColumn === \'aosUser.vmisUser.adminProfile.workEmail\'" class="icon-table-header" name="{{vm.sortReverse ? \'fa-caret-down\' : \'fa-caret-up\'}}" alt="Sorted by Work Email"></icon> </span> </th> <th class="unsorted">Actions</th> </tr> </thead> <tbody ng-hide="vm.isLoading"> <tr ng-repeat="regionManager in (vm.filteredUsers = (vm.usersWithRole | orderBy:vm.sortColumn:vm.sortReverse))" ng-class-even="\'even\'" ng-class-odd="\'odd\'"> <td> <label for="{{regionManager.checkboxId}}" class="offscreen">Check User</label> <input type="checkbox" id="{{regionManager.checkboxId}}" class="checkbox" ng-model="regionManager.isChecked" ng-click="vm.onCheckUser()"> </td> <td>{{regionManager.aosUser.lastName}}</td> <td>{{regionManager.aosUser.firstName}}</td> <td>{{regionManager.lastSignedIn ? (regionManager.lastSignedIn | date:\'MM/dd/yyyy\') : \'Never logged in\'}}</td> <td> <div class="middle" ng-repeat="community in regionManager.aosUser.vmisUser.adminProfile.responsibilities.rm track by $index"> <span>{{community.communityAffiliationName}}</span> </div> </td> <td> <a ng-if="regionManager.aosUser.vmisUser.adminProfile.workEmail" ng-href="{{\'mailto:\' + regionManager.aosUser.vmisUser.adminProfile.workEmail}}"> {{regionManager.aosUser.vmisUser.adminProfile.workEmail}} </a> </td> <td class="table-icon-column-entry"> <vmis-dropdown class="float-right"> <vmis-dropdown-toggle> <icon name="fa-pencil" class="icon-lg clickable" alt="Select this pencil icon to view or edit the user\'s profile"></icon> </vmis-dropdown-toggle> <vmis-dropdown-pane class="table-vmis-dropdown"> <ul class="menu vertical"> <li ng-click="vm.onClickOpenRegionManager(regionManager)"> Profile </li> <li ng-click="vm.onClickEditRegionManager(regionManager)"> Edit </li> </ul> </vmis-dropdown-pane> </vmis-dropdown> </td> </tr> <tr ng-if="vm.filteredUsers.length === 0"> <td colspan="7"> No data to display </td> </tr> </tbody> </table> <loading-icon show="vm.isLoading"></loading-icon> <load-more is-loading="vm.isLoading" load-status="vm.loadStatus" on-load-more="vm.onLoadMore()" on-load-all="vm.onLoadAll()"></load-more>');
$templateCache.put('app/components/administrator/people/volunteers/addNonUser.view.html','<form name="form" ng-submit="vm.onSubmit()"> <modal close="$dismiss" modal-title="Add New Non-User"> <modal-body> <div role="alert" ng-show="vm.formError" class="callout warning">{{vm.formError}}</div> <div class="row"> <div class="small-11 small-centered columns"> <label>Email <input type="email" ng-maxlength="100" placeholder="Enter Email" ng-model="vm.email" required> </label> </div> </div> </modal-body> <modal-footer> <div class="pull-right"> <button type="submit" class="dflt button" data-ng-disabled="form.$invalid || vm.isLoading"> Continue </button> <button type="button" class="dflt button" ng-click="$dismiss(\'cancel\')"> Cancel </button> </div> </modal-footer> </modal> </form>');
$templateCache.put('app/components/administrator/people/volunteers/confirmConvert.view.html','<form name="form"> <modal close="$dismiss" modal-title="Confirm Conversion to Normal User"> <modal-body> <alert type="\'alert\'" ng-if="vm.formError">{{vm.formError}}</alert> <p> Invitation email will be sent to <span class="bold">{{vm.fullName}}</span> to become a normal user. </p> <label>Email <input type="email" ng-maxlength="100" placeholder="Enter Email" ng-model="vm.email" required> </label> </modal-body> <modal-footer> <div class="pull-left"> <loading-icon show="vm.isLoading" little="true"></loading-icon> </div> <div class="pull-right"> <button type="button" class="dflt button" ng-click="vm.onOk()" ng-disabled="form.$invalid || vm.isLoading"> OK </button> <button type="button" class="dflt button" ng-click="$dismiss()" ng-disabled="vm.isLoading"> Cancel </button> </div> </modal-footer> </modal> </form> ');
$templateCache.put('app/components/administrator/people/volunteers/volunteers.view.html','<div class="expanded row"> <div class="small-offset-6 small-6 columns right-align-contents"> <button type="button" class="dflt button" data-ng-disabled="vm.isLoading" ng-click="vm.onClickFilterUsers()" disabled="disabled"> Filter People </button> <button id="new-non-user-button" type="button" class="dflt button" ng-if="!vm.isOnlyAVCCAssistant" data-ng-disabled="vm.isLoading" ng-click="vm.onClickAddNewNonUser()" disabled="disabled"> Add New Non-User </button> </div> </div> <div class="expanded row"> <div class="small-3 columns"> <label for="select-role"> Filter by Role </label> </div> <div class="small-6 columns"> <label id="searchPeople" hidden>Search for person</label> </div> <div class="small-3 columns"> <div class="row"> <label for="bulk-action"> Bulk Action ({{vm.numUsersSelected}}) </label> </div> </div> </div> <div class="expanded row"> <div class="small-3 columns"> <ui-select id="select-role" data-ng-change="vm.onSelectRole()" data-ng-model="vm.selectedRoleObject" data-ng-disabled="vm.isLoading"> <ui-select-match placeholder="Select a role or search..."> {{$select.selected.name}} </ui-select-match> <ui-select-choices repeat="role in vm.roleObjectList | propsFilter: {name: $select.search, shortName: $select.search}"> <span ng-bind-html="role.name | highlight: $select.search"></span> </ui-select-choices> </ui-select> </div> <form> <div class="small-6 columns"> <div class="input-group"> <div class="input-group-label icon-label"> <icon name="fa-search" class="icon-lg"></icon> </div> <label for="lastName" class="offscreen">Last Name</label> <input type="text" id="lastName" aria-label="Last name" class="input-group-field" placeholder="Last name" ng-model="vm.filter.lastName"> <span class="input-group-glue"></span> <label for="firstName" class="offscreen">First Name</label> <input type="text" id="firstName" aria-label="First name" class="input-group-field" placeholder="First name" ng-model="vm.filter.firstName"> <div class="input-group-button"> <button type="submit" class="dflt button" ng-disabled="vm.isLoading" ng-click="vm.onClickSearch()" disabled="disabled">Search</button> </div> </div> </div> </form> <div class="small-3 columns"> <mass-action id="bulk-action" mass-actions="vm.massActions" selected-mass-action="vm.selectedMassAction" num-selected="vm.numUsersSelected" disabled="vm.massActionDisabled"> </mass-action> </div> </div> <div class="expanded row"> <div class="small-5 columns"> <span tooltip="This will include volunteers who are active within your AVC communities but are registered at other communities." tooltip-popup-delay="1000" tooltip-append-to-body="true" class="has-tip" style="font-weight: normal;"> <input type="checkbox" class="checkbox" aria-label="Include volunteers from outside my AVC communities" ng-model="vm.includeFloatingUsers" ng-disabled="!vm.isFloatingUsersEnabled || vm.isLoading" ng-click="vm.onCheckIncludeFloatingUsers()"> Include volunteers from outside my AVC communities </span> </div> <div class="small-5 columns"> <span tooltip="This will only show volunteers who have ever submitted an application in VMIS, unless it was deleted, regardless of the application\'s community or organization." tooltip-popup-delay="1000" tooltip-append-to-body="true" class="has-tip" style="font-weight: normal;"> <input type="checkbox" class="checkbox" aria-label="Show only volunteers who have submitted an application" ng-model="vm.excludeNonAppliedVolunteers" ng-disabled="vm.isLoading" ng-click="vm.onCheckExcludeNonAppliedVolunteers()"> Show only volunteers who have submitted an application </span> </div> </div> <div ng-if="!vm.isCustomPaging"> <retrieved-results is-loading="vm.isLoading" load-status="vm.loadStatus"></retrieved-results> </div> <div ng-if="vm.isCustomPaging" ng-hide="vm.isLoading" class="center-horizontal"> <p class="remove-bottom-margin"> Showing {{vm.filteredUsers.length}} results starting from index #{{vm.filter.startingRowIndex}} from a result set of {{vm.totalResults}} </p> </div> <table class="information-table table" ng-hide="vm.isLoading"> <thead> <tr> <th width="1"> <label for="checkAll" class="offscreen">Check All</label> <input type="checkbox" id="checkAll" class="checkbox" aria-label="Check all" ng-model="vm.checkAll" ng-click="vm.onCheckAll()"> </th> <th width="1"> </th><th ng-click="vm.sortColumn = \'aosUser.lastName\'; vm.sortReverse = !vm.sortReverse"> <span ng-class="{unsorted: vm.sortColumn !== \'aosUser.lastName\'}"> Last Name <icon ng-show="vm.sortColumn === \'aosUser.lastName\'" class="icon-table-header" name="{{vm.sortReverse ? \'fa-caret-down\' : \'fa-caret-up\'}}" alt="Sorted by Last Name"></icon> </span> </th> <th ng-click="vm.sortColumn = \'aosUser.firstName\'; vm.sortReverse = !vm.sortReverse"> <span ng-class="{unsorted: vm.sortColumn !== \'aosUser.firstName\'}"> First Name <icon ng-show="vm.sortColumn === \'aosUser.firstName\'" class="icon-table-header" name="{{vm.sortReverse ? \'fa-caret-down\' : \'fa-caret-up\'}}" alt="Sorted by First Name"></icon> </span> </th> <th ng-click="vm.sortColumn = \'lastSignedIn\'; vm.sortReverse = !vm.sortReverse"> <span ng-class="{unsorted: vm.sortColumn !== \'lastSignedIn\'}"> Last Login Date <icon ng-show="vm.sortColumn === \'lastSignedIn\'" class="icon-table-header" name="{{vm.sortReverse ? \'fa-caret-down\' : \'fa-caret-up\'}}" alt="Sorted by Last Login Date"></icon> </span> </th> <th ng-click="vm.sortColumn = \'activePositionCount\'; vm.sortReverse = !vm.sortReverse"> <span ng-class="{unsorted: vm.sortColumn !== \'activePositionCount\'}" tooltip="{{(vm.filter.selectedCommunity || vm.filter.selectedOrganization) ?\n                  \'This is the number of positions with an active status for each volunteer, within the selected Community or Organization.\' :\n                  \'This is the number of positions with an active status for each volunteer, regardless of Community or Organization.\'}}" tooltip-popup-delay="200"> <span class="table-header-tooltip">Active Position Count</span> <icon ng-show="vm.sortColumn === \'activePositionCount\'" class="icon-table-header" name="{{vm.sortReverse ? \'fa-caret-down\' : \'fa-caret-up\'}}" alt="Sorted by Last Login Date"></icon> </span> </th> <th ng-click="vm.sortColumn = \'latestHoursActivityDate\'; vm.sortReverse = !vm.sortReverse"> <span ng-class="{unsorted: vm.sortColumn !== \'latestHoursActivityDate\'}" tooltip="{{(vm.filter.selectedCommunity || vm.filter.selectedOrganization) ?\n                  \'These hours are those most recently logged in VMIS by the volunteer, within the selected Community or Organization.\' :\n                  \'These hours are those most recently logged in VMIS by the volunteer, regardless of Community or Organization.\'}}" tooltip-popup-delay="200"> <span class="table-header-tooltip">Most Recent Hours</span> <icon ng-show="vm.sortColumn === \'latestHoursActivityDate\'" class="icon-table-header" name="{{vm.sortReverse ? \'fa-caret-down\' : \'fa-caret-up\'}}" alt="Sorted by Most Recent Hours"></icon> </span> </th> <th ng-click="vm.sortColumn = \'aosUser.vmisUser.volunteerProfile.volunteerEmail\'; vm.sortReverse = !vm.sortReverse"> <span ng-class="{unsorted: vm.sortColumn !== \'aosUser.vmisUser.volunteerProfile.volunteerEmail\'}"> Volunteer Email <icon ng-show="vm.sortColumn === \'aosUser.vmisUser.volunteerProfile.volunteerEmail\'" class="icon-table-header" name="{{vm.sortReverse ? \'fa-caret-down\' : \'fa-caret-up\'}}" alt="Sorted by Volunteer Email"></icon> </span> </th> <th ng-click="vm.sortColumn = \'aosUser.backgroundCheckStatus\'; vm.sortReverse = !vm.sortReverse"> <span ng-class="{unsorted: vm.sortColumn !== \'aosUser.backgroundCheckStatus\'}" tooltip="Background Check" tooltip-popup-delay="200"> <span class="table-header-tooltip">BGC</span> <icon ng-show="vm.sortColumn === \'aosUser.backgroundCheckStatus\'" class="icon-table-header" name="{{vm.sortReverse ? \'fa-caret-down\' : \'fa-caret-up\'}}" alt="Sorted by BGC status"></icon> </span> </th> <th class="unsorted">Actions</th> </tr> </thead> <tbody ng-hide="vm.isLoading"> <tr ng-repeat="vol in (vm.filteredUsers = (vm.usersWithRole | orderBy:vm.sortColumn:vm.sortReverse))" ng-class-even="\'even\'" ng-class-odd="\'odd\'"> <td> <label for="{{vol.checkboxId}}" class="offscreen">Check User</label> <input type="checkbox" id="{{vol.checkboxId}}" class="checkbox" ng-model="vol.isChecked" ng-click="vm.onCheckUser()"> </td> <td class="icon-column table-icon-column-entry"> <div tooltip="{{vol.isNonUser ? \'Non-User\' : \'Normal User\'}}" tooltip-popup-delay="200" class="icon-teal"> <icon name="fa-user-circle-o" ng-if="!vol.isNonUser" alt="This account is a user"></icon> <icon name="fa-user-circle" ng-if="vol.isNonUser" alt="This account is a non-user"></icon> </div> </td> <td>{{vol.aosUser.lastName}}</td> <td>{{vol.aosUser.firstName}}</td> <td>{{vol.lastSignedIn ? (vol.lastSignedIn | date:\'MM/dd/yyyy\') : \'Never logged in\'}}</td> <td>{{vol.activePositionCount}}</td> <td>{{vol.latestHoursActivityDate ? (vol.latestHoursActivityDate | date:\'MM/dd/yyyy\') : \'No activity\'}}</td> <td> <a ng-if="vol.aosUser.vmisUser.volunteerProfile.volunteerEmail" ng-href="{{\'mailto:\' + vol.aosUser.vmisUser.volunteerProfile.volunteerEmail}}"> {{vol.aosUser.vmisUser.volunteerProfile.volunteerEmail}} </a> </td> <td class="icon-column table-icon-column-entry"> <div tooltip="{{vol.aosUser.backgroundCheckStatus}}" tooltip-popup-delay="200"> <icon ng-show="vol.aosUser.backgroundCheckStatus === \'Active\'" class="icon-BGC active" name="fa-check" alt="This user has an active background check"></icon> <icon ng-show="vol.aosUser.backgroundCheckStatus === \'Invalid\'" class="icon-BGC invalid" name="fa-exclamation" alt="This user has an invalid background check"></icon> <icon ng-show="vol.aosUser.backgroundCheckStatus === \'Unknown\'" class="icon-BGC unknown" name="fa-question" alt="This user has a background check with unknown status"></icon> </div> </td> <td class="table-icon-column-entry"> <vmis-dropdown class="float-right"> <vmis-dropdown-toggle> <icon name="fa-pencil" class="icon-lg clickable" alt="Select this pencil icon to edit the user\'s profile, service log, records, or service history"></icon> </vmis-dropdown-toggle> <vmis-dropdown-pane class="table-vmis-dropdown"> <ul class="menu vertical"> <li ng-click="vm.onClickEditVol(vol, \'Profile\')" ng-hide="((vm.isOnlyAVCCAssistant || vol.fromAvccAssistPurview) ||\n                            (!vm.isAVCC && vol.isInactiveNonUser))"> Profile </li> <li ng-click="vm.onClickEditVol(vol, \'Service Log\')"> Service Log </li> <li ng-click="vm.onClickEditVol(vol, \'Records\')" ng-hide="(!vm.isAVCC && vol.isInactiveNonUser)"> Records </li> <li ng-click="vm.onClickEditVol(vol, \'Service History\')" ng-hide="((vm.isOnlyAVCCAssistant || vol.fromAvccAssistPurview) ||\n                            (!vm.isAVCC && vol.isInactiveNonUser))"> Service History </li> <li ng-click="vm.onClickEditVol(vol, \'Convert to Normal User\')" ng-show="vol.isNonUser &&\n                            !(vm.isOnlyAVCCAssistant || vol.fromAvccAssistPurview)"> Convert to Normal User </li> </ul> </vmis-dropdown-pane> </vmis-dropdown> </td> </tr> <tr ng-if="vm.filteredUsers.length === 0"> <td colspan="10"> No data to display </td> </tr> </tbody> </table> <loading-icon show="vm.isLoading"></loading-icon> <div ng-if="!vm.isCustomPaging"> <load-more is-loading="vm.isLoading" load-status="vm.loadStatus" on-load-more="vm.onLoadMore()" on-load-all="vm.onLoadAll()"></load-more> </div>');
$templateCache.put('app/components/volunteer/avccLocator/avccList/avccList.view.html','<retrieved-results is-loading="vm.isLoading" load-status="vm.loadStatus"></retrieved-results> <table class="table information-table table-hover"> <thead> <tr> <th ng-click="vm.sortColumn = \'lastName\'; vm.sortReverse = !vm.sortReverse"> <span ng-class="{unsorted: vm.sortColumn !== \'lastName\'}">Last Name <icon ng-show="vm.sortColumn === \'lastName\'" name="{{vm.sortReverse ? \'fa-caret-down\' : \'fa-caret-up\'}}" class="icon-table-header" alt=""></icon> </span> </th> <th ng-click="vm.sortColumn = \'firstName\'; vm.sortReverse = !vm.sortReverse"> <span ng-class="{unsorted: vm.sortColumn !== \'firstName\'}">First Name <icon ng-show="vm.sortColumn === \'firstName\'" name="{{vm.sortReverse ? \'fa-caret-down\' : \'fa-caret-up\'}}" class="icon-table-header" alt=""></icon> </span> </th> <th ng-click="vm.sortColumn = \'email\'; vm.sortReverse = !vm.sortReverse"> <span ng-class="{unsorted: vm.sortColumn !== \'email\'}">Email <icon ng-show="vm.sortColumn === \'email\'" name="{{vm.sortReverse ? \'fa-caret-down\' : \'fa-caret-up\'}}" class="icon-table-header" alt=""></icon> </span> </th> <th ng-click="vm.sortColumn = \'phone\'; vm.sortReverse = !vm.sortReverse"> <span ng-class="{unsorted: vm.sortColumn !== \'phone\'}">Phone <icon ng-show="vm.sortColumn === \'phone\'" name="{{vm.sortReverse ? \'fa-caret-down\' : \'fa-caret-up\'}}" class="icon-table-header" alt=""></icon> </span> </th> </tr> </thead> <tbody> <tr ng-repeat="coordinator in (vm.filteredCoordinators = (vm.coordinators | orderBy:vm.sortColumn:vm.sortReverse))"> <td>{{coordinator.lastName}}</td> <td>{{coordinator.firstName}}</td> <td><a ng-href="mailto:{{coordinator.email}}" target="_self">{{coordinator.email}}</a></td> <td>{{coordinator.phone}}</td> </tr> <tr ng-if="vm.filteredCoordinators.length === 0"> <td colspan="4"> No data to display </td> </tr> </tbody> </table> <loading-icon show="vm.isLoading"></loading-icon> <load-more is-loading="vm.isLoading" load-status="vm.loadStatus" on-load-more="vm.onLoadMore()" on-load-all="vm.onLoadAll()"></load-more> ');
$templateCache.put('app/components/volunteer/records/awards/view.html','<h5 class="tableTitle">Awards and Special Recognitions</h5> <div ng-hide="vm.isLoading"> <table class="table information-table table-hover"> <thead> <tr> <th class="record-column1" ng-click="vm.sortColumn = \'date\'; vm.sortReverse = !vm.sortReverse"> <span ng-class="{unsorted: vm.sortColumn !== \'date\'}"> Date Received <icon ng-show="vm.sortColumn === \'date\'" name="{{vm.sortReverse ? \'fa-caret-down\' : \'fa-caret-up\'}}" class="icon-table-header" alt="Sorted by Date Received"></icon> </span> </th> <th style="width:80%" ng-click="vm.sortColumn = \'name\'; vm.sortReverse = !vm.sortReverse"> <span ng-class="{unsorted: vm.sortColumn !== \'name\'}"> Award/Special Recognition <icon ng-show="vm.sortColumn === \'name\'" name="{{vm.sortReverse ? \'fa-caret-down\' : \'fa-caret-up\'}}" class="icon-table-header" alt="Sorted by Award or Special Recognition Name"></icon> </span> </th> <th style="align:right" ng-click="vm.sortColumn = \'certified\'; vm.sortReverse = !vm.sortReverse"> <span ng-class="{unsorted: vm.sortColumn !== \'certified\'}"> Certified <icon ng-show="vm.sortColumn === \'certified\'" name="{{vm.sortReverse ? \'fa-caret-down\' : \'fa-caret-up\'}}" class="icon-table-header" alt="Sorted by if the award is certified"></icon> </span> </th> <th class="tiny"></th> </tr> </thead> <tbody> <tr ng-repeat="award in (vm.awards | orderBy:vm.sortColumn:vm.sortReverse)"> <td>{{award.date | date:\'M/d/yyyy\'}}</td> <td> {{award.name}} <span tooltip="This award has an attachment" tooltip-popup-delay="200"> <icon name="fa-paperclip" class="icon-lg" ng-if="award.attachments.length > 0" alt="This award has an attachment"></icon> </span> </td> <td> {{award.certified ? \'Yes\' : \'No\'}} </td> <td class="icon-column table-icon-column-entry clickable tiny" ng-click="vm.onClickDetails(award)"> <icon name="{{vm.canUserEditAward(award) ? \'fa-pencil\' : \'fa-info-circle\'}}" class="icon-lg" alt="Select this icon to view award details or edit if possible"></icon> </td> </tr> <tr ng-if="vm.awards.length === 0"> <td colspan="4"> No data to display </td> </tr> </tbody> </table> </div> <loading-icon show="vm.isLoading"></loading-icon> <div class="overflow-ellipsis"> <div class="float-right"> <button type="button" class="dflt button" ng-click="vm.onClickAddAward()" data-ng-disabled="vm.isLoading"> Add Award </button> </div> </div> ');
$templateCache.put('app/components/volunteer/records/backgroundChecks/view.html','<span class="has-tip table-title-tooltip" tooltip="Only OPOCs and AVCCs can add Background Checks" tooltip-popup-delay="1000" tooltip-placement="right"> <h5 class="tableTitle">Background Checks</h5> </span> <div ng-hide="vm.isLoading"> <table class="table information-table"> <thead> <tr> <th class="record-column1" ng-click="vm.sortColumn = \'date\'; vm.sortReverse = !vm.sortReverse"> <span ng-class="{unsorted: vm.sortColumn !== \'date\'}"> Date Checked <icon ng-show="vm.sortColumn === \'date\'" name="{{vm.sortReverse ? \'fa-caret-down\' : \'fa-caret-up\'}}" class="icon-table-header" alt="Sorted by Date Checked"></icon> </span> </th> <th ng-click="vm.sortColumn = \'validUntil\'; vm.sortReverse = !vm.sortReverse"> <span ng-class="{unsorted: vm.sortColumn !== \'validUntil\'}"> Valid Until <icon ng-show="vm.sortColumn === \'validUntil\'" name="{{vm.sortReverse ? \'fa-caret-down\' : \'fa-caret-up\'}}" class="icon-table-header" alt="Sorted by the date in which the background check is no longer valid"></icon> </span> </th> <th style="width:20%" ng-click="vm.sortColumn = \'lastName\'; vm.sortReverse = !vm.sortReverse"> <span ng-class="{unsorted: vm.sortColumn !== \'lastName\'}"> Checker <icon ng-show="vm.sortColumn === \'lastName\'" name="{{vm.sortReverse ? \'fa-caret-down\' : \'fa-caret-up\'}}" class="icon-table-header" alt="Sorted by the Checker\'s Last Name"></icon> </span> </th> <th style="width:30%" ng-click="vm.sortColumn = \'workEmail\'; vm.sortReverse = !vm.sortReverse"> <span ng-class="{unsorted: vm.sortColumn !== \'workEmail\'}"> Email <icon ng-show="vm.sortColumn === \'workEmail\'" name="{{vm.sortReverse ? \'fa-caret-down\' : \'fa-caret-up\'}}" class="icon-table-header" alt="Sorted by Work Email"></icon> </span> </th> <th class="tiny" style="align:right"></th> </tr> </thead> <tbody> <tr ng-repeat="backgroundCheck in (vm.backgroundChecks | orderBy:vm.sortColumn:vm.sortReverse)"> <td>{{backgroundCheck.date | date:\'M/d/yyyy\'}}</td> <td>{{backgroundCheck.validUntil | date:\'M/d/yyyy\'}}</td> <td>{{backgroundCheck.checker.lastName}}, {{backgroundCheck.checker.firstName}}</td> <td> <a ng-href="mailto:{{backgroundCheck.checker.workEmail}}" target="_self"> {{backgroundCheck.checker.workEmail}} </a> </td> <td class="icon-column table-icon-column-entry clickable" ng-click="vm.onClickDetails(backgroundCheck)"> <icon name="{{vm.canUserEditBackgroundCheck(backgroundCheck) ? \'fa-pencil\' : \'fa-info-circle\'}}" class="icon-lg" alt="Select this icon to view background check details or edit if possible"></icon> </td> </tr> <tr ng-if="vm.backgroundChecks.length === 0"> <td colspan="5"> No data to display </td> </tr> </tbody> </table> </div> <loading-icon show="vm.isLoading"></loading-icon> <div class="overflow-ellipsis" ng-if="vm.adminEditing"> <div class="float-right"> <button type="button" class="dflt button" ng-click="vm.onClickAddBackgroundCheck()" data-ng-disabled="vm.isLoading"> Add Background Check </button> </div> </div> ');
$templateCache.put('app/components/volunteer/records/documents/view.html','<span class="has-tip table-title-tooltip" tooltip="Only OPOCs and AVCCs can add Documents" tooltip-popup-delay="1000" tooltip-placement="right"> <h5 class="tableTitle">Documents</h5> </span> <span class="documents-help-text" id="records-documents"> Documentation stored here is for AVC purposes; please keep copies of these documents for your personal record keeping.</span> <div ng-hide="vm.isLoading"> <table class="table information-table"> <thead> <tr> <th class="record-column1" ng-click="vm.sortColumn = \'date\'; vm.sortReverse = !vm.sortReverse"> <span ng-class="{unsorted: vm.sortColumn !== \'date\'}"> Date <icon ng-show="vm.sortColumn === \'date\'" name="{{vm.sortReverse ? \'fa-caret-down\' : \'fa-caret-up\'}}" class="icon-table-header" alt="Sorted by Date"></icon> </span> </th> <th style="width:30%" ng-click="vm.sortColumn = \'name\'; vm.sortReverse = !vm.sortReverse"> <span ng-class="{unsorted: vm.sortColumn !== \'name\'}"> Document <icon ng-show="vm.sortColumn === \'name\'" name="{{vm.sortReverse ? \'fa-caret-down\' : \'fa-caret-up\'}}" class="icon-table-header" alt="Sorted by Document Name"></icon> </span> </th> <th style="width:20%" ng-click="vm.sortColumn = \'description\'; vm.sortReverse = !vm.sortReverse"> <span ng-class="{unsorted: vm.sortColumn !== \'description\'}"> Description <icon ng-show="vm.sortColumn === \'description\'" name="{{vm.sortReverse ? \'fa-caret-down\' : \'fa-caret-up\'}}" class="icon-table-header" alt="Sorted by Description"></icon> </span> </th> <th ng-click="vm.sortColumn = \'uploaderFullName\'; vm.sortReverse = !vm.sortReverse"> <span ng-class="{unsorted: vm.sortColumn !== \'uploaderFullName\'}"> Uploader <icon ng-show="vm.sortColumn === \'uploaderFullName\'" name="{{vm.sortReverse ? \'fa-caret-down\' : \'fa-caret-up\'}}" class="icon-table-header" alt="Sorted by Uploader Name"></icon> </span> </th> <th class="tiny" style="align:right"></th> </tr> </thead> <tbody> <tr ng-repeat="doc in (vm.documents| orderBy:vm.sortColumn:vm.sortReverse)"> <td>{{doc.date | date:\'M/d/yyyy\'}}</td> <td> <span tooltip="This link for {{doc.name}} is not permanent. Download this document if you wish to share it." tooltip-popup-delay="1000"> <a ng-href="{{doc.url | uploadedFileFilter}}" target="_blank">{{doc.name}}</a> </span> </td> <td> <span tooltip="{{doc.name}}" tooltip-popup-delay="1000">{{doc.description}}</span> </td> <td>{{doc.uploaderFullName}}</td> <td class="icon-column table-icon-column-entry clickable" ng-click="vm.onClickDetails(doc)"> <icon name="{{vm.canUserDeleteDoc(doc) ? \'fa-pencil\' : \'fa-info-circle\'}}" class="icon-lg" alt="Select this icon to view the document details or edit if possible"></icon> </td> </tr> <tr ng-if="vm.documents.length === 0"> <td colspan="5"> No data to display </td> </tr> </tbody> </table> </div> <loading-icon show="vm.isLoading"></loading-icon> <div class="overflow-ellipsis" ng-if="vm.adminEditing"> <div class="float-right"> <button type="button" class="dflt button" ng-click="vm.onClickAddDoc()" data-ng-disabled="vm.isLoading"> Add Documents </button> </div> </div>');
$templateCache.put('app/components/volunteer/records/notes/view.html','<div ng-if="vm.adminEditing && !vm.isOnlyAVCCAssistant"> <h5 class="tableTitle">Notes</h5> <div ng-hide="vm.isLoading"> <table class="table information-table"> <thead> <tr> <th class="record-column1" ng-click="vm.sortColumn = \'date\'; vm.sortReverse = !vm.sortReverse"> <span ng-class="{unsorted: vm.sortColumn !== \'date\'}"> Date <icon ng-show="vm.sortColumn === \'date\'" name="{{vm.sortReverse ? \'fa-caret-down\' : \'fa-caret-up\'}}" class="icon-table-header" alt="Sorted by Date"></icon> </span> </th> <th style="width:30%" ng-click="vm.sortColumn = \'author\'; vm.sortReverse = !vm.sortReverse"> <span ng-class="{unsorted: vm.sortColumn !== \'author\'}"> Author <icon ng-show="vm.sortColumn === \'author\'" name="{{vm.sortReverse ? \'fa-caret-down\' : \'fa-caret-up\'}}" class="icon-table-header" alt="Sorted by Author"></icon> </span> </th> <th ng-click="vm.sortColumn = \'note\'; vm.sortReverse = !vm.sortReverse"> <span ng-class="{unsorted: vm.sortColumn !== \'note\'}"> Note <icon ng-show="vm.sortColumn === \'note\'" name="{{vm.sortReverse ? \'fa-caret-down\' : \'fa-caret-up\'}}" class="icon-table-header" alt="Sorted by Note"></icon> </span> </th> <th class="tiny"></th> </tr> </thead> <tbody> <tr ng-repeat="note in (vm.notes | orderBy:vm.sortColumn:vm.sortReverse)"> <td>{{note.date | date:\'M/d/yyyy\'}}</td> <td>{{note.author}}</td> <td>{{note.note}}</td> <td class="icon-column table-icon-column-entry clickable" ng-click="vm.onClickDetails(note)"> <icon name="{{vm.canUserEditNote(note) ? \'fa-pencil\' : \'fa-info-circle\'}}" class="icon-lg tiny" alt="Select this icon to edit the note if possible"></icon> </td> </tr> <tr ng-if="vm.notes.length === 0"> <td colspan="4"> No data to display </td> </tr> </tbody> </table> </div> <loading-icon show="vm.isLoading"></loading-icon> <div class="overflow-ellipsis"> <div class="float-right"> <button type="button" class="dflt button" ng-click="vm.onClickAddNote()" data-ng-disabled="vm.isLoading"> Add Note </button> </div> </div> </div>');
$templateCache.put('app/components/volunteer/records/orientations/view.html','<h5 class="tableTitle">Orientations</h5> <div ng-hide="vm.isLoading"> <table class="table information-table"> <thead> <tr> <th style="width:15%" ng-click="vm.sortColumn = \'date\'; vm.sortReverse = !vm.sortReverse"> <span ng-class="{unsorted: vm.sortColumn !== \'date\'}"> Date Completed <icon ng-show="vm.sortColumn === \'date\'" name="{{vm.sortReverse ? \'fa-caret-down\' : \'fa-caret-up\'}}" class="icon-table-header" alt="Sorted by Date Completed"></icon> </span> </th> <th style="width:80%" ng-click="vm.sortColumn = \'name\'; vm.sortReverse = !vm.sortReverse"> <span ng-class="{unsorted: vm.sortColumn !== \'name\'}"> Orientation <icon ng-show="vm.sortColumn === \'name\'" name="{{vm.sortReverse ? \'fa-caret-down\' : \'fa-caret-up\'}}" class="icon-table-header" alt="Sorted by Orientation"></icon> </span> </th> <th style="align:right" ng-click="vm.sortColumn = \'certified\'; vm.sortReverse = !vm.sortReverse"> <span ng-class="{unsorted: vm.sortColumn !== \'certified\'}"> Certified <icon ng-show="vm.sortColumn === \'certified\'" name="{{vm.sortReverse ? \'fa-caret-down\' : \'fa-caret-up\'}}" class="icon-table-header" alt="Sorted by if the orientation is cerfified"></icon> </span> </th> <th></th> </tr> </thead> <tbody> <tr ng-repeat="orientation in (vm.orientations| orderBy:vm.sortColumn:vm.sortReverse)"> <td>{{orientation.date | date:\'M/d/yyyy\'}}</td> <td> {{orientation.name}} <span tooltip="This orientation has an attachment" tooltip-popup-delay="200"> <icon name="fa-paperclip" class="icon-lg" ng-if="orientation.attachments.length > 0" alt="This orientation has an attachment"></icon> </span> </td> <td>{{orientation.certified ? \'Yes\' : \'No\'}}</td> <td class="icon-column table-icon-column-entry clickable" ng-click="vm.onClickDetails(orientation)"> <icon name="{{vm.canUserEditOrientation(orientation) ? \'fa-pencil\' : \'fa-info-circle\'}}" class="icon-lg" alt="Select this icon to view orientation details or edit if possible"></icon> </td> </tr> <tr ng-if="vm.orientations.length === 0"> <td colspan="4"> No data to display </td> </tr> </tbody> </table> </div> <div class="overflow-ellipsis"> <div class="float-right"> <button type="button" class="dflt button" ng-click="vm.onClickAddOrientation()" data-ng-disabled="vm.isLoading"> Add Orientation </button> </div> </div> ');
$templateCache.put('app/components/volunteer/records/trainings/view.html','<h5 class="tableTitle">Trainings</h5> <div ng-hide="vm.isLoading"> <table class="table information-table table-hover"> <thead> <tr> <th style="width:15%" ng-click="vm.sortColumn = \'endDate\'; vm.sortReverse = !vm.sortReverse"> <span ng-class="{unsorted: vm.sortColumn !== \'endDate\'}"> Date Completed <icon ng-show="vm.sortColumn === \'endDate\'" name="{{vm.sortReverse ? \'fa-caret-down\' : \'fa-caret-up\'}}" class="icon-table-header" alt="Sorted by Date Completed"></icon> </span> </th> <th style="width:33%" ng-click="vm.sortColumn = \'name\'; vm.sortReverse = !vm.sortReverse"> <span ng-class="{unsorted: vm.sortColumn !== \'name\'}"> Training <icon ng-show="vm.sortColumn === \'name\'" name="{{vm.sortReverse ? \'fa-caret-down\' : \'fa-caret-up\'}}" class="icon-table-header" alt="Sorted by Training"></icon> </span> </th> <th style="width:47%" ng-click="vm.sortColumn = \'hours\'; vm.sortReverse = !vm.sortReverse"> <span ng-class="{unsorted: vm.sortColumn !== \'hours\'}"> Hours <icon ng-show="vm.sortColumn === \'hours\'" name="{{vm.sortReverse ? \'fa-caret-down\' : \'fa-caret-up\'}}" class="icon-table-header" alt="Sorted by Hours"></icon> </span> </th> <th style="align:right;" ng-click="vm.sortColumn = \'certified\'; vm.sortReverse = !vm.sortReverse"> <span ng-class="{unsorted: vm.sortColumn !== \'certified\'}"> Certified <icon ng-show="vm.sortColumn === \'certified\'" name="{{vm.sortReverse ? \'fa-caret-down\' : \'fa-caret-up\'}}" class="icon-table-header" alt="Sorted by if the training is certified"></icon> </span> </th> <th></th> </tr> </thead> <tbody> <tr ng-repeat="training in (vm.trainings | orderBy:vm.sortColumn:vm.sortReverse)"> <td>{{training.endDate | date:\'M/d/yyyy\'}}</td> <td> {{training.name}} <span tooltip="This training has an attachment" tooltip-popup-delay="200"> <icon name="fa-paperclip" class="icon-lg" ng-if="training.attachments.length > 0" alt="This training has an attachment"></icon> </span> </td> <td>{{training.hours}}</td> <td> {{training.certified ? \'Yes\' : \'No\'}} </td> <td class="icon-column table-icon-column-entry clickable" ng-click="vm.onClickDetails(training)"> <icon name="{{vm.canUserEditTraining(training) ? \'fa-pencil\' : \'fa-info-circle\'}}" class="icon-lg" alt="Select this icon to view training details or edit if possible"></icon> </td> </tr> <tr ng-if="vm.trainings.length === 0"> <td colspan="5"> No data to display </td> </tr> </tbody> </table> </div> <loading-icon show="vm.isLoading"></loading-icon> <div class="overflow-ellipsis"> <div class="float-right"> <button type="button" class="dflt button" ng-click="vm.onClickAddTraining()" data-ng-disabled="vm.isLoading"> Add Training </button> </div> </div> ');
$templateCache.put('app/components/volunteer/serviceHistory/annualHoursRecord/view.html','<h5 class="tableTitle">Annual Hours Record</h5> <table class="table information-table"> <thead> <tr> <th class="ten unsorted"><span class="no-pointer">Year</span></th> <th class="thirty unsorted"><span class="no-pointer">Certified AVC Hours</span></th> <th class="thirty unsorted"><span class="no-pointer">Certified Non-AVC Hours</span></th> <th class="thirty unsorted"><span class="no-pointer">Total Certified Hours</span></th> </tr> </thead> <tbody> <tr ng-repeat="record in vm.annualHoursRecords | orderBy : \'-year\'"> <td>{{record.year}}</td> <td>{{record.avcHours | number:2}}</td> <td>{{record.nonAVCHours | number:2}}</td> <td>{{record.hours | number:2}}</td> </tr> <tr ng-if="vm.annualHoursRecords.length === 0"> <td colspan="4"> No data to display </td> </tr> </tbody> </table> <loading-icon show="vm.annualHoursRecords === null && vm.isLoading"></loading-icon> ');
$templateCache.put('app/components/volunteer/serviceHistory/avcPositions/view.html','<h5 class="tableTitle">AVC and Private Organization Positions</h5> <table class="table information-table"> <thead> <tr> <th class="thirty-five unsorted"><span class="no-pointer">Position</span></th> <th class="twenty-five unsorted"><span class="no-pointer">Organization</span></th> <th class="twenty-five unsorted"><span class="no-pointer">Community</span></th> <th class="ten unsorted"><span class="no-pointer">Start Date</span></th> <th class="ten unsorted"><span class="no-pointer">End Date</span></th> <th class="five unsorted"><span class="no-pointer">Status</span></th> <th class="ten unsorted"><span class="no-pointer">Certified Hours</span></th> <th class="five unsorted"></th> </tr> </thead> <tbody ng-class="{\'loading-background\': vm.isLoading}"> <tr ng-repeat="position in vm.positions"> <td>{{position.name}}</td> <td>{{position.organization}}</td> <td>{{position.community}}</td> <td> <div tooltip="Date of your first certified hours." tooltip-popup-delay="200"> {{(position.startDate || \'N/A\') | date:\'MM/dd/yyyy\'}} </div> </td> <td> <div tooltip="Date of your most recent certified hours." tooltip-popup-delay="200"> {{(position.endDate || \'N/A\') | date:\'MM/dd/yyyy\'}} </div> </td> <td>{{position.status}}</td> <td>{{position.hours | number:2}}</td> <td class="icon-column table-icon-column-entry" ng-class="{\'clickable\': !vm.isLoading}" ng-click="vm.isLoading || vm.getDetails(position)"> <icon name="{{position.isReadonly ? \'fa-info-circle\' : \'fa-pencil\'}}" class="icon-lg" alt=""></icon> </td> </tr> <tr ng-if="vm.positions.length === 0"> <td colspan="8"> No data to display </td> </tr> </tbody> </table> <loading-icon show="vm.positions === null && vm.isLoading"></loading-icon> ');
$templateCache.put('app/components/volunteer/serviceHistory/da4713YearSelector/view.html','<form ng-submit="$close()" name="form"> <modal close="$dismiss" modal-title="Select Year - DA 4713"> <modal-body> <loading-icon show="vm.isLoading"></loading-icon> <alert ng-repeat="alert in vm.alerts" type="alert.type" close="vm.onCloseAlert($index)">{{alert.message}}</alert> <div class="row"> <div class="small-offset-1 small-10 columns" ng-hide="vm.isLoading"> <ui-select class="form-control-static short-choices" required data-ng-model="vm.selectedYear" data-ng-disabled="vm.readOnly || vm.isModalLoading"> <ui-select-match placeholder="Select year or search"> {{$select.selected}} </ui-select-match> <ui-select-choices repeat="yr in vm.years | filter:$select.search"> <span ng-bind-html="yr | highlight: $select.search"></span> </ui-select-choices> </ui-select> </div> </div> </modal-body> <modal-footer> <div class="float-right"> <button type="button" class="dflt button" ng-disabled="vm.isLoading" ng-click="vm.generateDA4713Form()">Generate</button> <button type="button" class="dflt button" ng-disabled="vm.isLoading" ng-click="$dismiss()">Cancel</button> </div> </modal-footer> </modal> </form>');
$templateCache.put('app/components/volunteer/serviceHistory/nonAVCPositions/view.html','<h5 class="tableTitle">Non-AVC Positions</h5> <table class="table information-table"> <thead> <tr> <th class="thirty-five unsorted"><span class="no-pointer">Position</span></th> <th class="twenty-five unsorted"><span class="no-pointer">Organization</span></th> <th class="twenty-five unsorted"><span class="no-pointer">Community</span></th> <th class="ten unsorted"><span class="no-pointer">Start Date</span></th> <th class="ten unsorted"><span class="no-pointer">End Date</span></th> <th class="five unsorted"><span class="no-pointer">Status</span></th> <th class="ten unsorted"><span class="no-pointer">Certified Hours</span></th> <th class="five unsorted"></th> </tr> </thead> <tbody ng-class="{\'loading-background\': vm.isLoading}"> <tr ng-repeat="position in vm.positions"> <td>{{position.name}}</td> <td>{{position.organization === \'Volunteer Submitted\' ? position.summary + \' (\' +position.organization+\')\' : position.organization}} </td> <td>{{position.community}}</td> <td> <div tooltip="Date of your first certified hours." tooltip-popup-delay="200"> {{(position.startDate || \'N/A\') | date:\'MM/dd/yyyy\'}} </div> </td> <td> <div tooltip="Date of your most recent certified hours." tooltip-popup-delay="200"> {{(position.endDate || \'N/A\') | date:\'MM/dd/yyyy\'}} </div> </td> <td>{{position.status}}</td> <td>{{position.hours | number:2}}</td> <td class="icon-column table-icon-column-entry" ng-class="{\'clickable\': !vm.isLoading}" ng-click="vm.isLoading || vm.getDetails(position)"> <icon name="{{position.isReadonly ? \'fa-info-circle\' : \'fa-pencil\'}}" class="icon-lg" alt=""></icon> </td> </tr> <tr ng-if="vm.positions.length === 0"> <td colspan="8"> No data to display </td> </tr> </tbody> </table> <loading-icon show="vm.positions === null && vm.isLoading"></loading-icon> ');
$templateCache.put('app/components/volunteer/records/awards/delete/view.html','<form name="form"> <modal close="$dismiss" modal-title="Delete Award"> <modal-body> <p>Are you sure you want to delete this award, <span class="bold">{{vm.award.name}}</span>?</p> <loading-icon show="vm.processing"></loading-icon> </modal-body> <modal-footer> <div class="pull-right"> <button type="button" class="dflt button" ng-click="vm.onClickDelete()" data-ng-disabled="vm.processing"> Delete </button> <button type="button" class="dflt button" ng-click="$dismiss(\'cancel\')" data-ng-disabled="vm.processing"> Cancel </button> </div> </modal-footer> </modal> </form>');
$templateCache.put('app/components/volunteer/records/awards/details/view.html','<form name="form" ng-submit="vm.onClickSave()"> <modal close="$dismiss" modal-title="{{vm.title}}"> <modal-body> <alert id="award-alert" type="\'alert\'" ng-show="vm.formError">{{vm.formError}}</alert> <label for="award"> <span class="bold">Award</span><span class="required text" ng-if="!vm.viewOnly">*</span> </label> <input type="text" id="award" ng-maxlength="100" data-ng-model="vm.award.name" required data-ng-disabled="vm.viewOnly || vm.isLoading"> <label for="dateReceived"> <span class="bold">Date Received</span><span class="required text" ng-if="!vm.viewOnly">*</span> </label> <span class="input-group"> <input type="text" id="dateReceived" class="input-group-field" ng-model="vm.award.date" placeholder="MM/DD/YYYY" data-ng-disabled="vm.viewOnly || vm.isLoading" vmis-datepicker target="date" format="M/D/YYYY" end-date required> <span class="input-group-button"> <button id="date" type="button" class="dflt button icon-button" aria-label="Date received" data-ng-disabled="vm.viewOnly || vm.isLoading"> <icon name="fa-calendar" class="icon-big" alt="Select this calendar to choose the Date Received"></icon> </button> </span> </span> <div> <label for="description"><span class="bold">Description</span></label> <textarea id="description" rows="3" data-ng-model="vm.award.description" name="awardDescription" class="vertical-resize-only" ng-maxlength="1100" data-ng-disabled="vm.viewOnly || vm.isLoading"></textarea> <label ng-hide="vm.viewOnly || vm.isLoading" class="character-countdown"> {{1100 - form.awardDescription.$viewValue.length}} </label> </div> <hr id="attachment-top-bar"> <div class="row" ng-if="!vm.attachmentPresent"> <div class="small-4 small-centered columns"> <button type="button" aria-label="Add an attachment" class="dflt button expanded icon-button" ngf-max-size="{{vm.maxFileSizeInMegabytes}}" ngf-select="vm.onSelectAttachments($files, $invalidFiles); form.$setDirty()" ngf-pattern="{{vm.allowedFileTypesForUpload}}" accept="{{vm.allowedFileTypesForUpload}}" ng-disabled="vm.isLoading || vm.isAttachmentUploading"> <icon name="fa-paperclip" class="icon-big" aria-hidden="true" ng-hide="vm.isAttachmentUploading" alt="Select this paperclip to add an attachment"></icon> <loading-icon show="vm.isAttachmentUploading" little="true"></loading-icon> </button> </div> </div> <div class="row" ng-repeat="a in vm.attachments"> <div ng-if="a.isSelected"> <div class="small-10 columns center-horizontal overflow-ellipsis"> <label for="selected-attachment-name"> <span id="selected-attachment-name">{{a.name}}</span> </label> </div> <div class="small-2 columns center-horizontal center-vertical"> <button type="button" class="dflt button expanded remove-bottom-margin icon-button" ng-click="vm.onDeleteSelectedAttachment(a)" aria-label="add or remove an attachment" tooltip="{{a.uploaded ? \'Deleting this document removes it immediately.\' : \'\'}}" tooltip-popup-delay="200" data-ng-disabled="vm.isLoading || vm.isAttachmentUploading"> <icon name="fa-trash-o" class="icon-big" aria-hidden="true" ng-if="!a.uploaded" alt="Select this trashcan to delete the attachment"></icon> <icon name="fa-check" class="icon-big green" aria-hidden="true" ng-if="a.uploaded" alt="Attachment uploaded"></icon> </button> </div> </div> <div ng-if="!a.isSelected"> <div class="small-10 columns center-horizontal overflow-ellipsis" ng-if="vm.attachmentPresent" tooltip-popup-delay="1000" tooltip="This link for {{a.name}} is not permanent. Download this attachment if you wish to share it."> <label for="attachment-name"> <a id="attachment-name" ng-href="{{a.url | uploadedFileFilter}}" target="_blank">{{a.name}}</a> </label> </div> <div class="small-2 columns center-horizontal center-vertical"> <button type="button" class="dflt button expanded remove-bottom-margin icon-button" ng-click="vm.onDeleteSelectedAttachment(a)" aria-label="remove an attachment" data-ng-disabled="vm.isLoading"> <icon name="fa-trash-o" class="icon-big" aria-hidden="true" ng-if="!a.uploaded" alt="Select this trashcan to delete the attachment"></icon> </button> </div> </div> </div> <hr> <div> <label class="text-left"> <span class="bold has-tip" tooltip="Only an OPOC or an AVCC can certify this award." tooltip-popup-delay="1000">Certified</span><span class="required text" ng-if="!(vm.viewOnly || !vm.adminEditing)">*</span> <input id="certified" type="checkbox" data-ng-model="vm.award.certified" data-ng-disabled="vm.viewOnly || !vm.adminEditing"> </label> </div> <label class="help-text" ng-if="!vm.viewOnly"> <span class="required text">*</span> Indicates a required field. </label> </modal-body> <modal-footer> <div ng-if="vm.viewOnly" class="float-right"> <button type="button" class="dflt button" ng-click="$dismiss(\'ok\')" data-ng-disabled="vm.isLoading">OK </button> </div> <div ng-if="!vm.viewOnly"> <div ng-if="vm.award.id"> <div class="float-right"> <button type="submit" class="dflt button" data-ng-disabled="form.$invalid || form.$pristine || vm.isLoading">Save </button> <button type="button" class="dflt button" ng-click="vm.onClickDelete()" data-ng-disabled="vm.isLoading">Delete </button> <button type="button" class="dflt button" ng-click="$dismiss(\'cancel\')" data-ng-disabled="vm.isLoading">Cancel </button> </div> </div> <div ng-if="!vm.award.id"> <div class="float-right"> <button type="submit" class="dflt button" data-ng-disabled="form.$invalid || vm.isLoading"> Save </button> <button type="button" class="dflt button" ng-click="$dismiss(\'cancel\')" data-ng-disabled="vm.isLoading">Cancel </button> </div> </div> </div> </modal-footer> </modal> </form>');
$templateCache.put('app/components/volunteer/records/backgroundChecks/delete/view.html','<form ng-submit="$close()" name="form"> <modal close="$dismiss" modal-title="Delete Background Check"> <modal-body> <p>Are you sure you want to delete this background check? </p><p>{{vm.backgroundCheck.date | date:\'M/d/yyyy\'}} - {{vm.backgroundCheck.validUntil | date:\'M/d/yyyy\'}}</p> <p>{{vm.backgroundCheck.comment}}</p> <loading-icon show="vm.processing"></loading-icon> </modal-body> <modal-footer> <div class="pull-right"> <button type="button" class="dflt button" ng-click="vm.onClickDelete()" data-ng-disabled="vm.processing"> Delete </button> <button type="button" class="dflt button" ng-click="$dismiss()" data-ng-disabled="vm.processing"> Cancel </button> </div> </modal-footer> </modal> </form>');
$templateCache.put('app/components/volunteer/records/backgroundChecks/details/view.html','<form name="form" ng-submit="vm.onClickSave()"> <modal close="$dismiss" modal-title="{{vm.title}}"> <modal-body> <div class="row"> <label for="dateChecked"> <span class="bold">Date Checked</span><span class="required text">*</span> <span class="input-group"> <input type="text" id="dateChecked" class="input-group-field" ng-model="vm.backgroundCheck.date" ng-hide="vm.viewOnly" placeholder="MM/DD/YYYY" data-ng-disabled="vm.isLoading" vmis-datepicker target="date-checked" format="M/D/YYYY" end-date="vm.dateCheckedEndDate()" required> <span class="input-group-button" ng-hide="vm.viewOnly"> <button id="date-checked" type="button" class="dflt button icon-button" aria-label="Date checked" data-ng-disabled="vm.isLoading"> <icon name="fa-calendar" class="icon-big" alt="Select this calendar to choose when the background check happened"></icon> </button> </span> <span class="input-group" ng-show="vm.viewOnly"> {{vm.backgroundCheck.date | date:\'M/d/yyyy\'}} </span> </span> </label> <label for="validUntil"> <span class="bold">Valid Until</span><span class="required text">*</span> <span class="input-group"> <input type="text" id="validUntil" class="input-group-field" ng-model="vm.backgroundCheck.validUntil" ng-hide="vm.viewOnly" vmis-datepicker target="valid-until" format="M/D/YYYY" start-date="vm.backgroundCheck.date" placeholder="MM/DD/YYYY" data-ng-disabled="vm.isLoading" required> <span class="input-group-button" ng-hide="vm.viewOnly"> <button id="valid-until" type="button" class="dflt button icon-button" aria-label="Valid until date" data-ng-disabled="vm.isLoading"> <icon name="fa-calendar" class="icon-big" alt="Select this calendar to choose the date when the background check will be valid until"></icon> </button> </span> <span class="input-group" ng-show="vm.viewOnly"> {{vm.backgroundCheck.validUntil | date:\'M/d/yyyy\'}} </span> </span> </label> <div class="row small-10"> <div class="small-6 columns"> <span class="bold">Checker</span> <label>{{vm.checkerFullName}}</label> </div> <div class="small-4 columns"> <span class="bold">Email</span> <label> <a ng-href="mailto:{{vm.checkerEmail}}" target="_self"> {{vm.checkerEmail}} </a> </label> </div> </div> <div> <label for="comment"><span class="bold">Comment</span></label> <div ng-hide="vm.viewOnly"> <textarea id="comment" rows="3" data-ng-model="vm.backgroundCheck.comment" ng-maxlength="300" name="checkComment" class="vertical-resize-only" data-ng-disabled="vm.isLoading"></textarea> <label ng-hide="vm.isLoading" class="character-countdown">{{300 - form.checkComment.$viewValue.length}}</label> </div> <div ng-show="vm.viewOnly"> {{vm.backgroundCheck.comment || \'None\'}} </div> </div> <label class="help-text"> <span class="required text">*</span> Indicates a required field. </label> </div> </modal-body> <modal-footer> <div ng-if="!vm.viewOnly"> <div ng-if="vm.backgroundCheck.id"> <div class="float-right"> <button type="submit" class="dflt button" data-ng-disabled="form.$invalid || form.$pristine || vm.isLoading || vm.isSavedDisabled">Save </button> <button type="button" class="dflt button" ng-click="vm.onClickDelete()" data-ng-disabled="vm.isLoading">Delete </button> <button type="button" class="dflt button" ng-click="$dismiss(\'cancel\')" data-ng-disabled="vm.isLoading">Cancel </button> </div> </div> <div ng-if="!vm.backgroundCheck.id"> <div class="float-right"> <button type="submit" class="dflt button" data-ng-disabled="form.$invalid || vm.isLoading">Save </button> <button type="button" class="dflt button" ng-click="$dismiss(\'cancel\')" data-ng-disabled="vm.isLoading">Cancel </button> </div> </div> </div> <div ng-if="vm.viewOnly"> <div class="float-right"> <button type="button" class="dflt button" ng-click="$dismiss(\'cancel\')" data-ng-disabled="vm.isLoading">OK </button> </div> </div> </modal-footer> </modal> </form>');
$templateCache.put('app/components/volunteer/records/documents/delete/view.html','<form ng-submit="$close()" name="form"> <modal close="$dismiss" modal-title="Delete Volunteer Document"> <modal-body> <p>Are you sure you want to delete this volunteer document, <span class="bold">{{vm.document.name}}</span>?</p> <loading-icon show="vm.processing"></loading-icon> </modal-body> <modal-footer> <div class="pull-right"> <button type="button" class="dflt button" ng-click="vm.onClickDelete()" data-ng-disabled="vm.processing"> Delete </button> <button type="button" class="dflt button" ng-click="$dismiss()" data-ng-disabled="vm.processing"> Cancel </button> </div> </modal-footer> </modal> </form>');
$templateCache.put('app/components/volunteer/records/documents/details/view.html','<form name="form" ng-submit="vm.onClickSave()"> <modal close="$dismiss" modal-title="{{vm.title}}"> <modal-body> <div ng-show="vm.formError" class="callout alert">{{vm.formError}}</div> <div class="row" ng-if="!vm.existingDocument"> <div class="small-4 small-centered columns"> <button type="button" aria-label="Attach a document" class="dflt button expanded icon-button" multiple="multiple" ngf-max-size="{{vm.maxFileSizeInMegabytes}}" ngf-select="vm.onSelectDocs($files, $invalidFiles); form.$setDirty()" ngf-pattern="{{vm.allowedFileTypesForUpload}}" accept="{{vm.allowedFileTypesForUpload}}" ng-disabled="vm.isLoading || vm.isDocumentUploading || vm.maxDocumentsUploaded"> <icon name="fa-paperclip" class="icon-big" aria-hidden="true" ng-hide="vm.isDocumentUploading" alt="Select this paperclip to attach a document"></icon> <loading-icon show="vm.isDocumentUploading" little="true"></loading-icon> </button> </div> </div> <div class="row" ng-repeat="doc in vm.documents"> <hr ng-if="!vm.existingDocument"> <div class="row small-11" ng-if="doc.isSelected"> <div class="small-9 columns overflow-ellipsis"> <label> <span class="bold">Original Document Name</span> {{doc.originalName}} </label> </div> <div class="small-2 columns center-horizontal center-vertical"> <button type="button" class="dflt button expanded remove-bottom-margin icon-button" ng-click="vm.onDeleteSelectedDoc(doc)" data-ng-disabled="vm.isLoading || vm.isDocumentUploading"> <icon name="fa-trash-o" class="icon-big" aria-hidden="true" ng-if="!doc.uploaded" alt="Select this trashcan to delete the document"></icon> <icon name="fa-check" class="icon-big green" aria-hidden="true" ng-if="doc.uploaded" alt="Document uploaded"></icon> </button> </div> </div> <label ng-if="!doc.isSelected"> <span class="bold">Date Uploaded</span> <label> {{doc.date | date:\'M/d/yyyy\'}} </label> </label> <label for="documentName"> <span class="bold"><span ng-if="doc.isSelected">VMIS </span>Document Name</span> <span class="required text" ng-if="!vm.existingDocument">*</span> <input type="text" name="documentName" id="documentName" data-ng-model="doc.name" ng-if="!vm.existingDocument" required data-ng-disabled="vm.isLoading || vm.isDocumentUploading"> <label ng-if="vm.existingDocument" tooltip="This link for {{doc.name}} is not permanent. Download this document if you wish to share it." tooltip-popup-delay="1000"> <a ng-href="{{doc.url | uploadedFileFilter}}" target="_blank">{{doc.name}}</a> </label> </label> <div> <label for="description"><span class="bold">Description</span></label> <textarea id="description" rows="2" data-ng-model="doc.description" ng-hide="vm.existingDocument" ng-maxlength="300" data-ng-disabled="vm.isLoading || vm.isDocumentUploading" name="documentDescription" class="vertical-resize-only"></textarea> <label ng-hide="vm.isLoading || vm.existingDocument || vm.isDocumentUploading" class="character-countdown">{{300 - form.documentDescription.$viewValue.length}}</label> <div ng-show="vm.existingDocument"> {{doc.description}} <br> </div> </div> <label ng-if="!doc.isSelected"> <span class="bold">Uploader</span> <label> {{doc.uploaderFullName}} </label> </label> </div> </modal-body> <modal-footer> <div ng-if="vm.viewOnly" class="float-right"> <button type="button" class="dflt button" ng-click="$dismiss(\'ok\')" data-ng-disabled="vm.isLoading">OK </button> </div> <div ng-if="!vm.viewOnly"> <div ng-if="vm.existingDocument"> <div class="float-right"> <button type="button" class="dflt button" ng-click="vm.onClickDelete(vm.documents[0])" data-ng-disabled="vm.isLoading || vm.isDocumentUploading">Delete </button> <button type="button" class="dflt button" ng-click="$dismiss(\'cancel\')" data-ng-disabled="vm.isLoading || vm.isDocumentUploading">Cancel </button> </div> </div> <div ng-if="!vm.existingDocument"> <div class="float-right"> <button type="submit" class="dflt button" data-ng-disabled="form.documentName.$invalid || vm.isLoading || vm.isDocumentUploading || !vm.newUpload"> Save </button> <button type="button" class="dflt button" ng-click="$dismiss(\'cancel\')" data-ng-disabled="vm.isLoading || vm.isDocumentUploading">Cancel </button> </div> </div> </div> </modal-footer> </modal> </form>');
$templateCache.put('app/components/volunteer/records/notes/delete/view.html','<form name="form"> <modal close="$dismiss" modal-title="Delete Note"> <modal-body> <p>Are you sure you want to delete this note? </p><p>{{vm.note.note}}</p> <loading-icon show="vm.processing"></loading-icon> </modal-body> <modal-footer> <div class="pull-right"> <button type="button" class="dflt button" ng-click="vm.onClickDelete()" data-ng-disabled="vm.processing"> Delete </button> <button type="button" class="dflt button" ng-click="$dismiss()" data-ng-disabled="vm.processing"> Cancel </button> </div> </modal-footer> </modal> </form>');
$templateCache.put('app/components/volunteer/records/notes/details/view.html','<form name="form" ng-submit="vm.onClickSave()"> <modal close="$dismiss" modal-title="{{vm.title}}"> <modal-body> <div class="row"> <label> <span class="bold">Note</span><span class="required text" ng-hide="vm.viewOnly">*</span> <text-area-with-count is-required="true" number-rows="5" model-name="vm.note.note" max-given-length="1100" is-hidden="vm.viewOnly" is-disabled="vm.isLoading"></text-area-with-count> <span ng-if="vm.viewOnly">{{vm.note.note}}</span> </label> <label class="help-text" ng-hide="vm.viewOnly"> <span class="required text">*</span> Indicates a required field. </label> </div> </modal-body> <modal-footer> <div ng-if="vm.viewOnly" class="float-right"> <button type="button" class="dflt button" ng-click="$dismiss(\'ok\')" data-ng-disabled="vm.isLoading">OK</button> </div> <div ng-if="!vm.viewOnly"> <div ng-if="vm.note.id"> <div class="float-right"> <button type="submit" class="dflt button" data-ng-disabled="form.$invalid || form.$pristine || vm.isLoading || vm.isSavedDisabled">Save</button> <button type="button" class="dflt button" ng-click="vm.onClickDelete()" data-ng-disabled="vm.isLoading">Delete</button> <button type="button" class="dflt button" ng-click="$dismiss(\'cancel\')" data-ng-disabled="vm.isLoading">Cancel</button> </div> </div> <div ng-if="!vm.note.id"> <div class="float-right"> <button type="submit" class="dflt button" data-ng-disabled="form.$invalid || vm.isLoading">Save</button> <button type="button" class="dflt button" ng-click="$dismiss(\'cancel\')" data-ng-disabled="vm.isLoading">Cancel</button> </div> </div> </div> </modal-footer> </modal> </form>');
$templateCache.put('app/components/volunteer/records/orientations/delete/view.html','<form ng-submit="$close()" name="form"> <modal close="$dismiss" modal-title="Delete Orientation"> <modal-body> <p>Are you sure you want to delete this orientation, <span class="bold">{{vm.orientation.name}}</span>?</p> <loading-icon show="vm.processing"></loading-icon> </modal-body> <modal-footer> <div class="pull-right"> <button type="button" class="dflt button" ng-click="vm.onClickDelete()" data-ng-disabled="vm.processing"> Delete </button> <button type="button" class="dflt button" ng-click="$dismiss(\'cancel\')" data-ng-disabled="vm.processing"> Cancel </button> </div> </modal-footer> </modal> </form>');
$templateCache.put('app/components/volunteer/records/orientations/details/view.html','<form name="form" ng-submit="vm.onClickSave()"> <modal close="$dismiss" modal-title="{{vm.title}}"> <modal-body> <alert id="orientation-alert" type="\'alert\'" ng-show="vm.formError">{{vm.formError}}</alert> <label for="orientation"> <span class="bold">Orientation</span><span class="required text" ng-if="!vm.viewOnly">*</span> <input type="text" id="orientation" ng-maxlength="100" data-ng-model="vm.orientation.name" required data-ng-disabled="vm.viewOnly || vm.isLoading"> </label> <label for="dateCompleted"> <span class="bold">Date Completed</span><span class="required text" ng-if="!vm.viewOnly">*</span> <span class="input-group"> <input type="text" id="dateCompleted" class="input-group-field" ng-model="vm.orientation.date" placeholder="MM/DD/YYYY" data-ng-disabled="vm.viewOnly || vm.isLoading" required vmis-datepicker target="date" format="M/D/YYYY" end-date> <span class="input-group-button"> <button id="date" type="button" class="dflt button icon-button" aria-label="Completed date" data-ng-disabled="vm.viewOnly || vm.isLoading"> <icon name="fa-calendar" class="icon-big" alt="Select this calendar to choose the completed date"></icon> </button> </span> </span> </label> <hr id="attachment-top-bar"> <div class="row" ng-if="!vm.attachmentPresent"> <div class="small-4 small-centered columns"> <button type="button" aria-label="Add an attachment" class="dflt button expanded icon-button" ngf-max-size="{{vm.maxFileSizeInMegabytes}}" ngf-select="vm.onSelectAttachments($files, $invalidFiles); form.$setDirty()" ngf-pattern="{{vm.allowedFileTypesForUpload}}" accept="{{vm.allowedFileTypesForUpload}}" ng-disabled="vm.isLoading || vm.isAttachmentUploading"> <icon name="fa-paperclip" class="icon-big" aria-hidden="true" ng-hide="vm.isAttachmentUploading" alt="Select this paperclip to add an attachment"></icon> <loading-icon show="vm.isAttachmentUploading" little="true"></loading-icon> </button> </div> </div> <div class="row" ng-repeat="a in vm.attachments"> <div ng-if="a.isSelected"> <div class="small-10 columns center-horizontal overflow-ellipsis"> <label for="selected-attachment-name"> <span id="selected-attachment-name">{{a.name}}</span> </label> </div> <div class="small-2 columns center-horizontal center-vertical"> <button type="button" class="dflt button expanded remove-bottom-margin icon-button" ng-click="vm.onDeleteSelectedAttachment(a)" aria-label="add or remove an attachment" tooltip="{{a.uploaded ? \'Deleting this document removes it immediately.\' : \'\'}}" tooltip-popup-delay="200" data-ng-disabled="vm.isLoading || vm.isAttachmentUploading"> <icon name="fa-trash-o" class="icon-big" aria-hidden="true" ng-if="!a.uploaded" alt="Select this trashcan to delete the attachment"></icon> <icon name="fa-check" class="icon-big green" aria-hidden="true" ng-if="a.uploaded" alt="Attachment uploaded"></icon> </button> </div> </div> <div ng-if="!a.isSelected"> <div class="small-10 columns center-horizontal overflow-ellipsis" ng-if="vm.attachmentPresent" tooltip-popup-delay="1000" tooltip="This link for {{a.name}} is not permanent. Download this attachment if you wish to share it."> <label for="attachment-name"> <a id="attachment-name" ng-href="{{a.url | uploadedFileFilter}}" target="_blank">{{a.name}}</a> </label> </div> <div class="small-2 columns center-horizontal center-vertical"> <button type="button" class="dflt button expanded remove-bottom-margin icon-button" ng-click="vm.onDeleteSelectedAttachment(a)" aria-label="remove an attachment" data-ng-disabled="vm.isLoading"> <icon name="fa-trash-o" class="icon-big" aria-hidden="true" ng-if="!a.uploaded" alt="Select this trashcan to delete the attachment"></icon> </button> </div> </div> </div> <hr> <div> <label class="text-left"> <span class="bold has-tip" tooltip="Only an OPOC or an AVCC can certify this orientation." tooltip-popup-delay="1000">Certified</span><span class="required text" ng-if="!(vm.viewOnly || !vm.adminEditing)">*</span> <input id="certified" type="checkbox" data-ng-model="vm.orientation.certified" data-ng-disabled="vm.viewOnly || !vm.adminEditing"> </label> </div> <label class="help-text" ng-if="!vm.viewOnly"> <span class="required text">*</span> Indicates a required field. </label> </modal-body> <modal-footer> <div ng-if="vm.viewOnly" class="float-right"> <button type="button" class="dflt button" ng-click="$dismiss(\'ok\')" data-ng-disabled="vm.isLoading">OK </button> </div> <div ng-if="!vm.viewOnly"> <div ng-if="vm.orientation.id"> <div class="float-right"> <button type="submit" class="dflt button" data-ng-disabled="form.$invalid || form.$pristine || vm.isLoading">Save </button> <button type="button" class="dflt button" ng-click="vm.onClickDelete()" data-ng-disabled="vm.isLoading">Delete </button> <button type="button" class="dflt button" ng-click="$dismiss(\'cancel\')" data-ng-disabled="vm.isLoading">Cancel </button> </div> </div> <div ng-if="!vm.orientation.id"> <div class="float-right"> <button type="submit" class="dflt button" data-ng-disabled="form.$invalid || vm.isLoading"> Save </button> <button type="button" class="dflt button" ng-click="$dismiss(\'cancel\')" data-ng-disabled="vm.isLoading">Cancel </button> </div> </div> </div> </modal-footer> </modal> </form>');
$templateCache.put('app/components/volunteer/records/trainings/delete/view.html','<form name="form"> <modal close="$dismiss" modal-title="Delete Training"> <modal-body> <p>Are you sure you want to delete this training, <span class="bold">{{vm.training.name}}</span>?</p> <loading-icon show="vm.processing"></loading-icon> </modal-body> <modal-footer> <div class="pull-right"> <button type="button" class="dflt button" ng-click="vm.onClickDelete()" data-ng-disabled="vm.processing"> Delete </button> <button type="button" class="dflt button" ng-click="$dismiss(\'cancel\')" data-ng-disabled="vm.processing"> Cancel </button> </div> </modal-footer> </modal> </form>');
$templateCache.put('app/components/volunteer/records/trainings/details/view.html','<form name="form" ng-submit="vm.onClickSave()"> <modal close="$dismiss" modal-title="{{vm.title}}"> <modal-body> <alert id="training-alert" type="\'alert\'" ng-show="vm.formError">{{vm.formError}}</alert> <label for="training"> <span class="bold">Training</span><span class="required text" ng-if="!vm.viewOnly">*</span> <input type="text" id="training" ng-maxlength="100" data-ng-model="vm.training.name" required data-ng-disabled="vm.viewOnly || vm.isLoading"> </label> <label for="dateStarted"> <span class="bold">Date Started</span> <span class="input-group"> <input type="text" id="dateStarted" class="input-group-field" ng-model="vm.training.startDate" placeholder="MM/DD/YYYY" data-ng-disabled="vm.viewOnly || vm.isLoading" vmis-datepicker ng-change="vm.onChangeStartDate()" target="start-date" format="M/D/YYYY" end-date="vm.training.endDate || vm.currentDate"> <span class="input-group-button"> <button id="start-date" type="button" class="dflt button icon-button" aria-label="Start date" data-ng-disabled="vm.viewOnly || vm.isLoading"> <icon name="fa-calendar" class="icon-big" alt="Select this calendar to choose the start date"></icon> </button> </span> </span> </label> <label for="dateCompleted"> <span class="bold">Date Completed</span><span class="required text" ng-if="!vm.viewOnly">*</span> <span class="input-group"> <input type="text" id="dateCompleted" class="input-group-field" ng-model="vm.training.endDate" placeholder="MM/DD/YYYY" data-ng-disabled="vm.viewOnly || vm.isLoading" vmis-datepicker target="end-date" ng-change="vm.onChangeEndDate()" format="M/D/YYYY" start-date="vm.training.startDate" end-date required> <span class="input-group-button"> <button id="end-date" type="button" class="dflt button icon-button" aria-label="Completed date" data-ng-disabled="vm.viewOnly || vm.isLoading"> <icon name="fa-calendar" class="icon-big" alt="Select this calendar to choose the completed date"></icon> </button> </span> </span> </label> <label> <span class="bold">Hours Completed</span><span class="required text" ng-if="!vm.viewOnly">*</span> <input type="number" data-ng-model="vm.training.hours" step="0.1" ng-pattern="/^[0-9]+(\\.([0-9]{1,1})?)?$/" required placeholder="E.g., 3.5" data-ng-disabled="vm.viewOnly || vm.isLoading"> </label> <label> <span class="bold">Description</span> <text-area-with-count is-required="false" number-rows="3" model-name="vm.training.description" max-given-length="1100" is-disabled="vm.viewOnly || vm.isLoading"></text-area-with-count> </label> <label for="reason"> <span class="bold">Reason for Training</span> <input type="text" id="reason" ng-maxlength="100" data-ng-model="vm.training.pursuit" placeholder="E.g., a degree, diploma, certification, or position you were pursuing that required this training." data-ng-disabled="vm.viewOnly || vm.isLoading"> </label> <hr id="attachment-top-bar"> <div class="row" ng-if="!vm.attachmentPresent"> <div class="small-4 small-centered columns"> <button type="button" aria-label="Add an attachment" class="dflt button expanded icon-button" ngf-max-size="{{vm.maxFileSizeInMegabytes}}" ngf-select="vm.onSelectAttachments($files, $invalidFiles); form.$setDirty()" ngf-pattern="{{vm.allowedFileTypesForUpload}}" accept="{{vm.allowedFileTypesForUpload}}" ng-disabled="vm.isLoading || vm.isAttachmentUploading"> <icon name="fa-paperclip" class="icon-big" aria-hidden="true" ng-hide="vm.isAttachmentUploading" alt="Select this paperclip to add an attachment"></icon> <loading-icon show="vm.isAttachmentUploading" little="true"></loading-icon> </button> </div> </div> <div class="row" ng-repeat="a in vm.attachments"> <div ng-if="a.isSelected"> <div class="small-10 columns center-horizontal overflow-ellipsis"> <label for="selected-attachment-name"> <span id="selected-attachment-name">{{a.name}}</span> </label> </div> <div class="small-2 columns center-horizontal center-vertical"> <button type="button" class="dflt button expanded remove-bottom-margin icon-button" ng-click="vm.onDeleteSelectedAttachment(a)" aria-label="add or remove an attachment" tooltip="{{a.uploaded ? \'Deleting this document removes it immediately.\' : \'\'}}" tooltip-popup-delay="200" data-ng-disabled="vm.isLoading || vm.isAttachmentUploading"> <icon name="fa-trash-o" class="icon-big" aria-hidden="true" ng-if="!a.uploaded" alt="Select this trashcan to delete the attachment"></icon> <icon name="fa-check" class="icon-big green" aria-hidden="true" ng-if="a.uploaded" alt="Attachment uploaded"></icon> </button> </div> </div> <div ng-if="!a.isSelected"> <div class="small-10 columns center-horizontal overflow-ellipsis" ng-if="vm.attachmentPresent" tooltip-popup-delay="1000" tooltip="This link for {{a.name}} is not permanent. Download this attachment if you wish to share it."> <label for="attachment-name"> <a id="attachment-name" ng-href="{{a.url | uploadedFileFilter}}" target="_blank">{{a.name}}</a> </label> </div> <div class="small-2 columns center-horizontal center-vertical"> <button type="button" class="dflt button expanded remove-bottom-margin icon-button" ng-click="vm.onDeleteSelectedAttachment(a)" aria-label="remove an attachment" data-ng-disabled="vm.isLoading"> <icon name="fa-trash-o" class="icon-big" aria-hidden="true" ng-if="!a.uploaded" alt="Select this trashcan to delete the attachment"></icon> </button> </div> </div> </div> <hr> <div> <label class="text-left"> <span class="bold has-tip" tooltip="Only an OPOC or an AVCC can certify this training." tooltip-popup-delay="1000">Certified</span><span class="required text" ng-if="!(vm.viewOnly || !vm.adminEditing)">*</span> <input id="certified" type="checkbox" data-ng-model="vm.training.certified" data-ng-disabled="vm.viewOnly || !vm.adminEditing"> </label> </div> <label class="help-text" ng-if="!vm.viewOnly"> <span class="required text">*</span> Indicates a required field. </label> </modal-body> <modal-footer> <div ng-if="vm.viewOnly" class="float-right"> <button type="button" class="dflt button" ng-click="$dismiss(\'ok\')" data-ng-disabled="vm.isLoading">OK </button> </div> <div ng-if="!vm.viewOnly"> <div ng-if="vm.training.id"> <div class="float-right"> <button type="submit" class="dflt button" data-ng-disabled="form.$invalid || form.$pristine || vm.isLoading">Save </button> <button type="button" class="dflt button" ng-click="vm.onClickDelete()" data-ng-disabled="vm.isLoading">Delete </button> <button type="button" class="dflt button" ng-click="$dismiss(\'cancel\')" data-ng-disabled="vm.isLoading">Cancel </button> </div> </div> <div ng-if="!vm.training.id"> <div class="float-right"> <button type="submit" class="dflt button" data-ng-disabled="form.$invalid || vm.isLoading"> Save </button> <button type="button" class="dflt button" ng-click="$dismiss(\'cancel\')" data-ng-disabled="vm.isLoading">Cancel </button> </div> </div> </div> </modal-footer> </modal> </form>');
$templateCache.put('app/components/volunteer/serviceHistory/avcPositions/serviceDetailsModal/view.html','<form ng-submit="vm.save()" name="form"> <modal close="$dismiss" modal-title="{{vm.title}}"> <modal-body> <div class="row"> <label> <span class="bold">Service Status</span> <ui-select ng-if="!vm.isReadonly" data-ng-model="vm.service.status" data-ng-disabled="vm.isLoading"> <ui-select-match placeholder="Select a status or search..."> {{$select.selected}} </ui-select-match> <ui-select-choices repeat="service in vm.serviceStatuses | filter:$select.search"> <span ng-bind-html="service | highlight: $select.search"></span> </ui-select-choices> </ui-select> <label ng-if="vm.isReadonly">{{vm.service.status}}</label> </label> <label> <span class="bold">Community</span> <label>{{vm.position.community}}</label> </label> <label> <span class="bold">Organization</span> <label>{{vm.position.organization}}</label> </label> <label> <span class="bold">Position</span> <label>{{vm.position.title}}</label> </label> <label> <span class="bold">Start Date</span> <label>{{(vm.service.startDate || \'N/A\') | date:\'d MMM yyyy\'}}</label> </label> <label> <span class="bold">End Date</span> <label>{{(vm.service.endDate || \'N/A\') | date:\'d MMM yyyy\'}}</label> </label> <label> <span class="bold">Certified Hours</span> <label>{{vm.position.hours | number:2}}</label> </label> <label ng-if="vm.position.supervisors.length"> <span class="bold">Supervisor(s)</span> </label> <div ng-repeat="supervisor in vm.position.supervisors"> {{supervisor.name}}<span ng-if="supervisor.email">, <a ng-href="mailto:{{supervisor.email}}" target="_self">{{supervisor.email}}</a></span><span ng-if="supervisor.phone">, {{supervisor.phone}}</span> </div> <label> <span class="bold">Address</span> <label>{{vm.position.address.line1}}</label> <label ng-if="vm.position.address.line2">{{vm.position.address.line2}}</label> <label>{{vm.position.address.city}}, {{vm.position.address.state}} {{vm.position.address.postalCode}}</label> <label>{{vm.position.address.country}}</label> </label> </div> </modal-body> <modal-footer> <div ng-if="vm.isReadonly === true"> <div class="pull-right"> <button type="button" class="dflt button" ng-click="$dismiss()" ng-disabled="vm.isLoading"> OK </button> </div> </div> <div ng-if="vm.isReadonly === false"> <div class="pull-right"> <button type="submit" class="dflt button" data-ng-disabled="form.$pristine || vm.isLoading"> Save </button> <button type="button" class="dflt button" ng-click="$dismiss()" data-ng-disabled="vm.isLoading"> Cancel </button> </div> </div> </modal-footer> </modal> </form> ');}]);})();